export const popularStyleIdeas = [
  {
    url: "/styles/sketch/birth-month-flower-bouquet-Tk18ntTg2S7bvjeZwx47eA",
    title: "birth month flower bouquet",
    list_url: "/styles/sketch/birth-month-flower-bouquet"
  },
  {
    url: "/styles/sketch/july-august-november-birth-flower-ETyzWjjneGprSL5HxL2fLv",
    title: "july august november birth flower",
    list_url: "/styles/sketch/july-august-november-birth-flower"
  },
  {
    url: "/styles/minimalist/bbw-xxx-4e2o9VDhC2kdPcYDcjhhW5",
    title: "bbw xxx",
    list_url: "/styles/minimalist/bbw-xxx"
  },
  {
    url: "/styles/sketch/cyber-sigilism-6JoJqi6uPWLqMqrxAgYkS",
    title: "cyber sigilism",
    list_url: "/styles/sketch/cyber-sigilism"
  },
  {
    url: "/styles/minimalist/tamil-font-EM4KC5qkxmdQ2JU43X3cS",
    title: "tamil font",
    list_url: "/styles/minimalist/tamil-font"
  },
  {
    url: "/styles/anime/rape-femboy-Q6LK4LWGT3jSMZJzCNYARY",
    title: "rape femboy",
    list_url: "/styles/anime/rape-femboy"
  },
  {
    url: "/styles/sketch/cybersigilism-PcgbgrQT4zN4XoMcvXebYE",
    title: "cybersigilism",
    list_url: "/styles/sketch/cybersigilism"
  },
  {
    url: "/styles/black-grey/past-life-58BGqJ252irzGzFGtT4m5i",
    title: "past life",
    list_url: "/styles/black-grey/past-life"
  },
  {
    url: "/styles/sketch/infinity-symbol-with-name-4SwLERvCNnkSf7vy3kANd3",
    title: "infinity symbol with name",
    list_url: "/styles/sketch/infinity-symbol-with-name"
  },
  {
    url: "/styles/minimalist/overlapping-letters-tattoo-using-the-UbahjpZqv8UxcTf6aHSv9F",
    title: "overlapping letters tattoo using the",
    list_url: "/styles/minimalist/overlapping-letters-tattoo-using-the"
  },
  {
    url: "/styles/realism/vaginas-7MsYQDCMAhHWwvobw8H7aZ",
    title: "vaginas",
    list_url: "/styles/realism/vaginas"
  },
  {
    url: "/styles/traditional/shemale-X8CgEdXD5V1n4ChaczB3XL",
    title: "shemale",
    list_url: "/styles/traditional/shemale"
  },
  {
    url: "/styles/realism/combination-of-two-names-ashwin-heena-NaMc8id2hsUddZtNmfngQE",
    title: "combination of two names ashwin heena",
    list_url: "/styles/realism/combination-of-two-names-ashwin-heena"
  },
  {
    url: "/styles/realism/vagina-XY4evaT7PbeV95ZTgzab1s",
    title: "vagina",
    list_url: "/styles/realism/vagina"
  },
  {
    url: "/styles/minimalist/combine-letters-e-m-and-i-ARHTPBrupLE31QGoU6uMhF",
    title: "combine letters e m and i",
    list_url: "/styles/minimalist/combine-letters-e-m-and-i"
  },
  {
    url: "/styles/realism/old-man-sucking-young-girl-nipples-G9y9JwQcXXzQAqthY3JC6Z",
    title: "old man sucking young girl nipples",
    list_url: "/styles/realism/old-man-sucking-young-girl-nipples"
  },
  {
    url: "/styles/blackwork/heartbeat-with-name-KQ7r4gENDhabmEyeFQvRpT",
    title: "heartbeat with name",
    list_url: "/styles/blackwork/heartbeat-with-name"
  },
  {
    url: "/styles/minimalist/aham-brahmasmi-in-sanskrit-8bxrfSnTjE3v79m1rLoajV",
    title: "aham brahmasmi in sanskrit",
    list_url: "/styles/minimalist/aham-brahmasmi-in-sanskrit"
  },
  {
    url: "/styles/sketch/bnwo-MFASZYJiHsCrkFv3K6sVmV",
    title: "bnwo",
    list_url: "/styles/sketch/bnwo"
  },
  {
    url: "/styles/minimalist/akash-name-tattoo-2WC3Bx7sb6GEoYevX5afa7",
    title: "akash name tattoo",
    list_url: "/styles/minimalist/akash-name-tattoo"
  },
  {
    url: "/styles/neotraditional/divya-name-tattoo-Dc9YctZkYSCqe6YJFSj6Mh",
    title: "divya name tattoo",
    list_url: "/styles/neotraditional/divya-name-tattoo"
  },
  {
    url: "/styles/geometric/draw-a-sigil-tattoo-from-the-letters-i-WLw4NxFxj7vdsvadFrpYpw",
    title: "draw a sigil tattoo from the letters i",
    list_url: "/styles/geometric/draw-a-sigil-tattoo-from-the-letters-i"
  },
  {
    url: "/styles/minimalist/ankit-name-in-hindi-A86YXpFqHDdzQaX8G7VwhT",
    title: "ankit name in hindi",
    list_url: "/styles/minimalist/ankit-name-in-hindi"
  },
  {
    url: "/styles/dotwork/nsfw-bbc-qos-queen-of-spades-UBeLUmPbBC22GR7pRBhYVM",
    title: "nsfw bbc qos queen of spades",
    list_url: "/styles/dotwork/nsfw-bbc-qos-queen-of-spades"
  },
  {
    url: "/styles/neotraditional/sperm-around-nipple-5o2hqGnBCoUFTb77PP3QoZ",
    title: "sperm around nipple",
    list_url: "/styles/neotraditional/sperm-around-nipple"
  },
  {
    url: "/styles/traditional/sanatan-dharma-Qd1QMkaCETPVmwyTfcGSdG",
    title: "sanatan dharma",
    list_url: "/styles/traditional/sanatan-dharma"
  },
  {
    url: "/styles/neotraditional/shemale-aKqCkMtz8hKpp7JgugScQ",
    title: "shemale",
    list_url: "/styles/neotraditional/shemale"
  },
  {
    url: "/styles/biomechanical/watercolor-WiLnBj1HHGkUSF5YdFmE2a",
    title: "watercolor",
    list_url: "/styles/biomechanical/watercolor"
  },
  {
    url: "/styles/minimalist/butterfly-with-vulva-BcEFFFjzUQXxbsKA58Sm2R",
    title: "butterfly with vulva",
    list_url: "/styles/minimalist/butterfly-with-vulva"
  },
  {
    url: "/styles/minimalist/gay-male-bottom-slave-bondage-3hYzBeeXb1GAGhYadnzKed",
    title: "gay male bottom slave bondage",
    list_url: "/styles/minimalist/gay-male-bottom-slave-bondage"
  },
  {
    url: "/styles/realism/lord-shani-dev-with-mantra-7cN6QZQfrykXGE7gF78fRX",
    title: "lord shani dev with mantra",
    list_url: "/styles/realism/lord-shani-dev-with-mantra"
  },
  {
    url: "/styles/trash-polka",
    title: "trash",
    list_url: "/styles/trash"
  },
  {
    url: "/styles/minimalist/morse-code-HHe393w7F1YLwaFybVEyqP",
    title: "morse code",
    list_url: "/styles/minimalist/morse-code"
  },
  {
    url: "/styles/dotwork/mahabharat-karna-with-arrow-and-sun-YA1rUibF6UxhxhXYMaVaSi",
    title: "mahabharat karna with arrow and sun",
    list_url: "/styles/dotwork/mahabharat-karna-with-arrow-and-sun"
  },
  {
    url: "/styles/minimalist/individually-we-are-whole-but-together-6DZS7UkqsNf1JzM6CN2xxb",
    title: "individually we are whole but together",
    list_url: "/styles/minimalist/individually-we-are-whole-but-together"
  },
  {
    url: "/styles/minimalist/monogram-E1vzHtKLiE7jsTehogwKKV",
    title: "monogram",
    list_url: "/styles/minimalist/monogram"
  },
  {
    url: "/styles/neotraditional/karan-name-TubByUCnJQW4nghhZiVrZb",
    title: "karan name",
    list_url: "/styles/neotraditional/karan-name"
  },
  {
    url: "/styles/neotraditional/tattoo-with-rohit-name-aTMphBGXtd8vJrqKPMjAj",
    title: "tattoo with rohit name",
    list_url: "/styles/neotraditional/tattoo-with-rohit-name"
  },
  {
    url: "/styles/japanese",
    title: "japanese",
    list_url: "/styles/japanese"
  },
  {
    url: "/styles/minimalist/male-submissive-jTG3ajD4wZUaetFNbVShd",
    title: "male submissive",
    list_url: "/styles/minimalist/male-submissive"
  },
  {
    url: "/styles/minimalist/mens-tattoo-above-knee-QXcF59958qwRXQobDKZUsa",
    title: "mens tattoo above knee",
    list_url: "/styles/minimalist/mens-tattoo-above-knee"
  },
  {
    url: "/styles/sketch/ayyappa-8Jte5yarz74U2NDnXyN2Ct",
    title: "ayyappa",
    list_url: "/styles/sketch/ayyappa"
  },
  {
    url: "/styles/woodcut",
    title: "woodcut",
    list_url: "/styles/woodcut"
  },
  {
    url: "/styles/neotraditional/gay-chastity-slave-DWEwCVjAkfjHYo5CqUpgwt",
    title: "gay chastity slave",
    list_url: "/styles/neotraditional/gay-chastity-slave"
  },
  {
    url: "/styles/cyber-sigilism/name-written-G9WG8PKHpfoSPHZUYwDypM",
    title: "name written",
    list_url: "/styles/cyber-sigilism/name-written"
  },
  {
    url: "/styles/sketch/mahabharat-SGVCzvctQzRpA5tUxZWHnU",
    title: "mahabharat",
    list_url: "/styles/sketch/mahabharat"
  },
  {
    url: "/styles/realism/hentai-SK4qRUx2TKv71pkq51o7XX",
    title: "hentai",
    list_url: "/styles/realism/hentai"
  },
  {
    url: "/styles/geometric/stacked-letters-EkGivL3dxs5W2urmr5gvHS",
    title: "stacked letters",
    list_url: "/styles/geometric/stacked-letters"
  },
  {
    url: "/styles/cyber-sigilism/hidden-name-S6BYzxBzVTyuJAbo8xjEe1",
    title: "hidden name",
    list_url: "/styles/cyber-sigilism/hidden-name"
  },
  {
    url: "/styles/sketch/2-names-mixing-in-one-name-UAX9Bw54QpoB85ejnttRGJ",
    title: " names mixing in one name",
    list_url: "/styles/sketch/2-names-mixing-in-one-name"
  },
  {
    url: "/styles/tribal/tribal-6UtjhDahu7b9xGTb2WLDvA",
    title: "tribal",
    list_url: "/styles/tribal/tribal"
  },
  {
    url: "/styles/realism/brahma-vishnu-shiva-BrkhizvsZPsvL72z8UfuCb",
    title: "brahma vishnu shiva",
    list_url: "/styles/realism/brahma-vishnu-shiva"
  },
  {
    url: "/styles/japanese/yk-zn-sksy-ba-jwrab-shlwary-w-ttw-SNAXRefPuRfK51vMcimxXK",
    title: "yk zn sksy ba jwrab shlwary w ttw",
    list_url: "/styles/japanese/yk-zn-sksy-ba-jwrab-shlwary-w-ttw"
  },
  {
    url: "/styles/realism/gardenia-PFFwt5wBCqCQhXwcrVBdak",
    title: "gardenia",
    list_url: "/styles/realism/gardenia"
  },
  {
    url: "/styles/black-grey/orchid-for-men-GrjpzGyxfHLfmhAEuhLxJE",
    title: "orchid for men",
    list_url: "/styles/black-grey/orchid-for-men"
  },
  {
    url: "/styles/blackwork/bdsm-submissive-78oZGsFbiXAoSMiLjGSv9a",
    title: "bdsm submissive",
    list_url: "/styles/blackwork/bdsm-submissive"
  },
  {
    url: "/styles/minimalist/combine-the-names-of-your-three-kids-EMxaRMtiLkGq7BqTcpaz52",
    title: "combine the names of your three kids",
    list_url: "/styles/minimalist/combine-the-names-of-your-three-kids"
  },
  {
    url: "/styles/minimalist/rose-with-stem-name-9PfYR2ZDG7UwJHrXjmhJgT",
    title: "rose with stem name",
    list_url: "/styles/minimalist/rose-with-stem-name"
  },
  {
    url: "/styles/tribal/parshuram-SbWhhLeP6ukvLAR9YYpvNK",
    title: "parshuram",
    list_url: "/styles/tribal/parshuram"
  },
  {
    url: "/styles/black-grey/succubi-having-sex-F1Pac1z2HgoRHz7xrMkBBA",
    title: "succubi having sex",
    list_url: "/styles/black-grey/succubi-having-sex"
  },
  {
    url: "/styles/minimalist/create-your-own-reality-8YWeNPKVtpRNVAnQFZY7Rq",
    title: "create your own reality",
    list_url: "/styles/minimalist/create-your-own-reality"
  },
  {
    url: "/styles/dotwork/kahu-symbol-39cGtXW9fxjwo768PDqrpE",
    title: "kahu symbol",
    list_url: "/styles/dotwork/kahu-symbol"
  },
  {
    url: "/styles/minimalist/heart-and-name-LAa9Wp7dGkYfp2P3yMUxgF",
    title: "heart and name",
    list_url: "/styles/minimalist/heart-and-name"
  },
  {
    url: "/styles/blackwork/hidden-name-aarti-ScWNH1G5XiMWVi8KLsCBrD",
    title: "hidden name aarti",
    list_url: "/styles/blackwork/hidden-name-aarti"
  },
  {
    url: "/styles/anime/anime-girl-with-big-titties-24PaeNR5pcv8HsBhoJD8G8",
    title: "anime girl with big titties",
    list_url: "/styles/anime/anime-girl-with-big-titties"
  },
  {
    url: "/styles/black-grey/superman-logo-HbKbNjZp8vE4i6ivjjwWsH",
    title: "superman logo",
    list_url: "/styles/black-grey/superman-logo"
  },
  {
    url: "/styles/neotraditional/shemale-stripper-3brdzjvMFcFrEahk1ukYhQ",
    title: "shemale stripper",
    list_url: "/styles/neotraditional/shemale-stripper"
  },
  {
    url: "/styles/neotraditional/sumit-name-tattoo-QWDYLmVG4d6fFqBc3qZiXF",
    title: "sumit name tattoo",
    list_url: "/styles/neotraditional/sumit-name-tattoo"
  },
  {
    url: "/styles/traditional/nsfw-pinup-Y7SYcpm7uLCjLaK5ozTf33",
    title: "nsfw pinup",
    list_url: "/styles/traditional/nsfw-pinup"
  },
  {
    url: "/styles/black-grey/karnan-from-mahabharat-boqyGcDLeosXaLvZFP17U",
    title: "karnan from mahabharat",
    list_url: "/styles/black-grey/karnan-from-mahabharat"
  },
  {
    url: "/styles/blackwork/bbc-hentai-tattoo-R8XroAiaRHLgejjLcr15UA",
    title: "bbc hentai tattoo",
    list_url: "/styles/blackwork/bbc-hentai-tattoo"
  },
  {
    url: "/styles/dotwork/qos-xfxjF2YANVp1oG8AYtHTM",
    title: "qos",
    list_url: "/styles/dotwork/qos"
  },
  {
    url: "/styles/neotraditional/female-penis-and-vagina-life-of-freedom-AKRvi8mTKd953avRHGGuAo",
    title: "female penis and vagina life of freedom",
    list_url: "/styles/neotraditional/female-penis-and-vagina-life-of-freedom"
  },
  {
    url: "/styles/blackwork/black-and-white-tattoo-of-open-vagina-YDyHjnMQER2pAagq94Qmhs",
    title: "black and white tattoo of open vagina",
    list_url: "/styles/blackwork/black-and-white-tattoo-of-open-vagina"
  },
  {
    url: "/styles/tribal/cancer-and-pisces-2EWXKdEyUWtaoxNy37zhrM",
    title: "cancer and pisces",
    list_url: "/styles/tribal/cancer-and-pisces"
  },
  {
    url: "/styles/dotwork/kavya-name-7JCKXNP4yqq4jdxVZhdXF1",
    title: "kavya name",
    list_url: "/styles/dotwork/kavya-name"
  },
  {
    url: "/styles/sketch/narasimha-998oSsngAGhDyxdP9ZwWW9",
    title: "narasimha",
    list_url: "/styles/sketch/narasimha"
  },
  {
    url: "/styles/sketch/liverpool-liverbird-C64tkpX8gAxncUA7fDHq9H",
    title: "liverpool liverbird",
    list_url: "/styles/sketch/liverpool-liverbird"
  },
  {
    url: "/styles/black-grey/hot-redhead-naked-woman-full-body-RaaQEg6g5YocxTjcVBpDsF",
    title: "hot redhead naked woman full body",
    list_url: "/styles/black-grey/hot-redhead-naked-woman-full-body"
  },
  {
    url: "/styles/minimalist/50th-birthday-1974-7m25LPQb7sc3gjswBSxc2m",
    title: " th birthday ",
    list_url: "/styles/minimalist/50th-birthday-1974"
  },
  {
    url: "/styles/minimalist/stacked-letters-hednf-6cjM3FiAYUhcpNNryng2QA",
    title: "stacked letters hednf",
    list_url: "/styles/minimalist/stacked-letters-hednf"
  },
  {
    url: "/styles/neotraditional/kaal-bhairav-ThMA4j9kzRWgLF79yANKhv",
    title: "kaal bhairav",
    list_url: "/styles/neotraditional/kaal-bhairav"
  },
  {
    url: "/styles/anime/hentai-EbsJv5GLXBAwbCX29PJc2L",
    title: "hentai",
    list_url: "/styles/anime/hentai"
  },
  {
    url: "/styles/black-grey/bbc-hentai-tattoo-simple-tattoo-K69qaU6zZSaPg8zYxC8LZo",
    title: "bbc hentai tattoo simple tattoo",
    list_url: "/styles/black-grey/bbc-hentai-tattoo-simple-tattoo"
  },
  {
    url: "/styles/dotwork/manisha-BheTpiTfhhuNASFnYJSHgS",
    title: "manisha",
    list_url: "/styles/dotwork/manisha"
  },
  {
    url: "/styles/realism/bnwo-SYekEEcEo6UJD2iHSxo3zF",
    title: "bnwo",
    list_url: "/styles/realism/bnwo"
  },
  {
    url: "/styles/black-grey/forget-me-not-flowers-M2vHecWY6zrGLUo37MfXDf",
    title: "forget me not flowers",
    list_url: "/styles/black-grey/forget-me-not-flowers"
  },
  {
    url: "/styles/minimalist/hidden-letter-a-U6HuKLQDpo5DEwQwVNi7Nf",
    title: "hidden letter a",
    list_url: "/styles/minimalist/hidden-letter-a"
  },
  {
    url: "/styles/neotraditional/xxxxx-PFnsrPCpr6xJTwJnmNXGy6",
    title: "xxxxx",
    list_url: "/styles/neotraditional/xxxxx"
  },
  {
    url: "/styles/blackwork/penis-FgTggopP1yBBAcfQH6FcJE",
    title: "penis",
    list_url: "/styles/blackwork/penis"
  },
  {
    url: "/styles/realism/angela-white-and-lena-paul-K6iS2GYVrKStpdZADexMDg",
    title: "angela white and lena paul",
    list_url: "/styles/realism/angela-white-and-lena-paul"
  },
  {
    url: "/styles/surrealism/free-use-sissy-slut-XjKGaxDks7orfbhY5yHbdt",
    title: "free use sissy slut",
    list_url: "/styles/surrealism/free-use-sissy-slut"
  },
  {
    url: "/styles/japanese/japan-1-girl-1-dragon-and-1-snake-HETcmziLRgGFBd5AkwLJLV",
    title: "japan girl dragon and snake",
    list_url: "/styles/japanese/japan-1-girl-1-dragon-and-1-snake"
  },
  {
    url: "/styles/sketch/madhu-name-with-heart-beat-and-queen-KmdaVGw1X2vtYNPDERdu1N",
    title: "madhu name with heart beat and queen",
    list_url: "/styles/sketch/madhu-name-with-heart-beat-and-queen"
  },
  {
    url: "/styles/tribal/filipino-tribal-HfBYmJnyujqqwj6DjpvgnT",
    title: "filipino tribal",
    list_url: "/styles/tribal/filipino-tribal"
  },
  {
    url: "/styles/minimalist/crossword-with-names-of-my-familyseth-PFesJTMy9CAouXgukPVq8Y",
    title: "crossword with names of my familyseth",
    list_url: "/styles/minimalist/crossword-with-names-of-my-familyseth"
  },
  {
    url: "/styles/minimalist/shivani-name-fxQnGwNuXdrwUodh1ywJQ",
    title: "shivani name",
    list_url: "/styles/minimalist/shivani-name"
  },
  {
    url: "/styles/minimalist/written-name-khushi-CZJdrEfz7rFa6ad1Me7Dzm",
    title: "written name khushi",
    list_url: "/styles/minimalist/written-name-khushi"
  },
  {
    url: "/styles/minimalist/no-fuck-given-A2oMdCABne2bbfcMLZYqFh",
    title: "no fuck given",
    list_url: "/styles/minimalist/no-fuck-given"
  },
  {
    url: "/styles/sketch/kamasutra-3HSxsY1oL9D3oentKzoAWV",
    title: "kamasutra",
    list_url: "/styles/sketch/kamasutra"
  },
  {
    url: "/styles/traditional/crossword-KqfNPApeNedQTZmsMQw1ae",
    title: "crossword",
    list_url: "/styles/traditional/crossword"
  },
  {
    url: "/styles/traditional/sparrow-9L78SnDrqtN7fuYrMrLzt2",
    title: "sparrow",
    list_url: "/styles/traditional/sparrow"
  },
  {
    url: "/styles/minimalist/prasanna-name-W9HAeofPGFxmZPR4zr9utw",
    title: "prasanna name",
    list_url: "/styles/minimalist/prasanna-name"
  },
  {
    url: "/styles/tribal/free-use-slut-M6oWx2EJ1ZBQQyDRdJecA5",
    title: "free use slut",
    list_url: "/styles/tribal/free-use-slut"
  },
  {
    url: "/styles/blackwork/no-one-is-coming-to-save-you-Q5tCBDKn34cKfBZHe4KonL",
    title: "no one is coming to save you",
    list_url: "/styles/blackwork/no-one-is-coming-to-save-you"
  },
  {
    url: "/styles/blackwork/sudarshan-chakra-in-finger-of-lord-NAC8GgvCY2495M1UD36Lwf",
    title: "sudarshan chakra in finger of lord",
    list_url: "/styles/blackwork/sudarshan-chakra-in-finger-of-lord"
  },
  {
    url: "/styles/minimalist/fuck-cancer-VcUcfWV3fk2pFwxZpPWuq1",
    title: "fuck cancer",
    list_url: "/styles/minimalist/fuck-cancer"
  },
  {
    url: "/styles/minimalist/roman-numerals-iixxixmmxx-3KivcvM1dVhQt61AvAYfnp",
    title: "roman numerals iixxixmmxx",
    list_url: "/styles/minimalist/roman-numerals-iixxixmmxx"
  },
  {
    url: "/styles/realism/amirah-adara-winking-T2krqyiwqcMC2rBp1Cif2z",
    title: "amirah adara winking",
    list_url: "/styles/realism/amirah-adara-winking"
  },
  {
    url: "/styles/neotraditional/fuck-the-police-M7U95io2govkfjyhbywfWv",
    title: "fuck the police",
    list_url: "/styles/neotraditional/fuck-the-police"
  },
  {
    url: "/styles/realism/girl-masturbating-TGMt1Hqn2oGAKLVMXJ6CgL",
    title: "girl masturbating",
    list_url: "/styles/realism/girl-masturbating"
  },
  {
    url: "/styles/black-grey/past-life-of-darkness-GWdVUM2NUBRav3pRgNnD2g",
    title: "past life of darkness",
    list_url: "/styles/black-grey/past-life-of-darkness"
  },
  {
    url: "/styles/black-grey/fuck-your-feelings-2r1UhwZsRZqEs1bjBmTLmH",
    title: "fuck your feelings",
    list_url: "/styles/black-grey/fuck-your-feelings"
  },
  {
    url: "/styles/black-grey/what-doesnt-kill-you-makes-you-stronger-VBisBnUrzjuuaE9JsEy484",
    title: "what doesnt kill you makes you stronger",
    list_url: "/styles/black-grey/what-doesnt-kill-you-makes-you-stronger"
  },
  {
    url: "/styles/blackwork/qos-bbc-slut-HwceerwRxq2A1p19k9ksD2",
    title: "qos bbc slut",
    list_url: "/styles/blackwork/qos-bbc-slut"
  },
  {
    url: "/styles/blackwork/spiderweb-around-nipple-xYFKmSApT2joWfYici9Mk",
    title: "spiderweb around nipple",
    list_url: "/styles/blackwork/spiderweb-around-nipple"
  },
  {
    url: "/styles/dotwork/yash-name-tattoo-lord-gadesh-face-N5hSkYKJFTrWHrLc61BxZF",
    title: "yash name tattoo lord gadesh face",
    list_url: "/styles/dotwork/yash-name-tattoo-lord-gadesh-face"
  },
  {
    url: "/styles/minimalist/fourth-man-in-the-fire-religious-QFgQktQF8nQCNcBEyAAND1",
    title: "fourth man in the fire religious",
    list_url: "/styles/minimalist/fourth-man-in-the-fire-religious"
  },
  {
    url: "/styles/neotraditional/fae-valentine-pinup-girl-dressed-8aSKmpZirN8EszHdj9BuMA",
    title: "fae valentine pinup girl dressed",
    list_url: "/styles/neotraditional/fae-valentine-pinup-girl-dressed"
  },
  {
    url: "/styles/realism/prolapsed-anus-Pv4FFNVw2gPbk4rGFXhthi",
    title: "prolapsed anus",
    list_url: "/styles/realism/prolapsed-anus"
  },
  {
    url: "/styles/neotraditional/chastity-sissy-bondage-slave-symbol-Hx2bunmmCTTGvXfWa961y3",
    title: "chastity sissy bondage slave symbol",
    list_url: "/styles/neotraditional/chastity-sissy-bondage-slave-symbol"
  },
  {
    url: "/styles/black-grey/poppy-for-men-HntrV1HR1RQv67Uo6RPQwf",
    title: "poppy for men",
    list_url: "/styles/black-grey/poppy-for-men"
  },
  {
    url: "/styles/minimalist/name-aditya-YofhPLkQbCVNDDSJSiawr",
    title: "name aditya",
    list_url: "/styles/minimalist/name-aditya"
  },
  {
    url: "/styles/neotraditional/vaginal-tattoo-QauUuCCiuHGYQBD4ZGcMHf",
    title: "vaginal tattoo",
    list_url: "/styles/neotraditional/vaginal-tattoo"
  },
  {
    url: "/styles/neotraditional/pink-vulva-with-prominent-clit-design-NZnQQjnnQykEwDQYRPUhUJ",
    title: "pink vulva with prominent clit design",
    list_url: "/styles/neotraditional/pink-vulva-with-prominent-clit-design"
  },
  {
    url: "/styles/realism/suryaputra-karn-EbCLxoJRMwJ2z6QftZGVfS",
    title: "suryaputra karn",
    list_url: "/styles/realism/suryaputra-karn"
  },
  {
    url: "/styles/minimalist/sabr-shukr-SKbM2Lhk3HBxcDsecLQP5o",
    title: "sabr shukr",
    list_url: "/styles/minimalist/sabr-shukr"
  },
  {
    url: "/styles/realism/slave-woman-submissive-and-high-heels-GAA1buckaiAiXoy3THBpWE",
    title: "slave woman submissive and high heels",
    list_url: "/styles/realism/slave-woman-submissive-and-high-heels"
  },
  {
    url: "/styles/sketch/create-me-a-leg-sleeve-that-has-a-LHHkbgR8LGvMDMu8r6SoUJ",
    title: "create me a leg sleeve that has a",
    list_url: "/styles/sketch/create-me-a-leg-sleeve-that-has-a"
  },
  {
    url: "/styles/sketch/words-remember-who-the-fuck-you-are-R8iJz8jP4yhFF1xhBHVi1L",
    title: "words remember who the fuck you are",
    list_url: "/styles/sketch/words-remember-who-the-fuck-you-are"
  },
  {
    url: "/styles/blackwork/muskan-name-Krf6MtJL7ZSK6WfPqTVx9S",
    title: "muskan name",
    list_url: "/styles/blackwork/muskan-name"
  },
  {
    url: "/styles/minimalist/1995-romans-numerals-8bfk6wfvnHJg1BjsZNocwP",
    title: " romans numerals",
    list_url: "/styles/minimalist/1995-romans-numerals"
  },
  {
    url: "/styles/blackwork/52-hoover-gangster-crip-L8C6Uw6JEgPCKGU7Edgbgu",
    title: " hoover gangster crip",
    list_url: "/styles/blackwork/52-hoover-gangster-crip"
  },
  {
    url: "/styles/dotwork/radhika-name-with-feather-in-devnagari-URjgPNNHw1m7soVrKNbrkc",
    title: "radhika name with feather in devnagari",
    list_url: "/styles/dotwork/radhika-name-with-feather-in-devnagari"
  },
  {
    url: "/styles/minimalist/sic-parvis-magna-QwNHcj7yhFthwqkoUMbfoP",
    title: "sic parvis magna",
    list_url: "/styles/minimalist/sic-parvis-magna"
  },
  {
    url: "/styles/neotraditional/sakshi-name-tattoo-desig-GgWfBq9dxtZFmxX21is21z",
    title: "sakshi name tattoo desig",
    list_url: "/styles/neotraditional/sakshi-name-tattoo-desig"
  },
  {
    url: "/styles/realism/lesbian-choking-each-other-EB39eAHV6BwJVz8bM5bQNy",
    title: "lesbian choking each other",
    list_url: "/styles/realism/lesbian-choking-each-other"
  },
  {
    url: "/styles/realism/uday-name-with-feather-2GRZDEieTt4haCPu7hLkCL",
    title: "uday name with feather",
    list_url: "/styles/realism/uday-name-with-feather"
  },
  {
    url: "/styles/sketch/femdom-pegging-EQcnKe4th4GigXfuVynZ14",
    title: "femdom pegging",
    list_url: "/styles/sketch/femdom-pegging"
  },
  {
    url: "/styles/sketch/surya-MVRW2ayKCZN9hAPzm7fDMF",
    title: "surya",
    list_url: "/styles/sketch/surya"
  },
  {
    url: "/styles/blackwork/father-daughter-celtic-knot-with-repeat-7TEZEhnwLoZSEnbFPLZxrF",
    title: "father daughter celtic knot with repeat",
    list_url: "/styles/blackwork/father-daughter-celtic-knot-with-repeat"
  },
  {
    url: "/styles/japanese/neck-tattoo-V5oqKX6jksMWPHmMRf9y1P",
    title: "neck tattoo",
    list_url: "/styles/japanese/neck-tattoo"
  },
  {
    url: "/styles/neotraditional/roshni-name-XmL6arzDLpLybYVr7EBkFh",
    title: "roshni name",
    list_url: "/styles/neotraditional/roshni-name"
  },
  {
    url: "/styles/neotraditional/write-samb-sadashiv-KKYQveu5Uka2LSoiKzWftp",
    title: "write samb sadashiv",
    list_url: "/styles/neotraditional/write-samb-sadashiv"
  },
  {
    url: "/styles/sketch/pavithra-name-with-0625-number-with-Uy2iAYc5pwA34EFQXVzvXA",
    title: "pavithra name with number with",
    list_url: "/styles/sketch/pavithra-name-with-0625-number-with"
  },
  {
    url: "/styles/sketch/vaishno-devi-bhawan-katra-and-mata-rani-4R1s1vbAejz8RRTwHZDMtX",
    title: "vaishno devi bhawan katra and mata rani",
    list_url: "/styles/sketch/vaishno-devi-bhawan-katra-and-mata-rani"
  },
  {
    url: "/styles/blackwork/kill-the-boy-and-let-the-man-be-born-J8oHj4YdoyZsx4RZha1yfq",
    title: "kill the boy and let the man be born",
    list_url: "/styles/blackwork/kill-the-boy-and-let-the-man-be-born"
  },
  {
    url: "/styles/dotwork/ms-dhoni-QKSF7jP4LBB6tRWbqVMrW2",
    title: "ms dhoni",
    list_url: "/styles/dotwork/ms-dhoni"
  },
  {
    url: "/styles/dotwork/rose-with-number-xxvci-KWL6MtXQyiTYHudg3wp7JF",
    title: "rose with number xxvci",
    list_url: "/styles/dotwork/rose-with-number-xxvci"
  },
  {
    url: "/styles/traditional/shaitan-small-tattoo-2aTBoJW2rTYkTtGzjDqHJq",
    title: "shaitan small tattoo",
    list_url: "/styles/traditional/shaitan-small-tattoo"
  },
  {
    url: "/styles/new-school/letter-r-with-priya-name-hidden-in-it-CB3qZii5d82THVYsqM8odC",
    title: "letter r with priya name hidden in it",
    list_url: "/styles/new-school/letter-r-with-priya-name-hidden-in-it"
  },
  {
    url: "/styles/blackwork/sprocket-3u9myYy4Hjh3D4NLR3SS9p",
    title: "sprocket",
    list_url: "/styles/blackwork/sprocket"
  },
  {
    url: "/styles/geometric/suraj-name-in-sanskrit-Qb1Nx88NkWrvUSj2bv24p2",
    title: "suraj name in sanskrit",
    list_url: "/styles/geometric/suraj-name-in-sanskrit"
  },
  {
    url: "/styles/anime/futa-78UTzyYHRAa6YxLy4wqHgK",
    title: "futa",
    list_url: "/styles/anime/futa"
  },
  {
    url: "/styles/blackwork/karna-mahabharat-ATNHsgjYiAz3RU4wXfDTFR",
    title: "karna mahabharat",
    list_url: "/styles/blackwork/karna-mahabharat"
  },
  {
    url: "/styles/blackwork/the-logo-for-the-cyberpunk-edgerunners-Dk5xRkcNVi8cCZoh5MkvN",
    title: "the logo for the cyberpunk edgerunners",
    list_url: "/styles/blackwork/the-logo-for-the-cyberpunk-edgerunners"
  },
  {
    url: "/styles/japanese/archangel-michael-KvyS1ojMPRFHeQYqW6tDMq",
    title: "archangel michael",
    list_url: "/styles/japanese/archangel-michael"
  },
  {
    url: "/styles/anime/slut-KqN8316k5vDP7GcdwZWx31",
    title: "slut",
    list_url: "/styles/anime/slut"
  },
  {
    url: "/styles/black-grey/marijuana-leaf-VuUnKsWr5d9LMuDmcFsxx6",
    title: "marijuana leaf",
    list_url: "/styles/black-grey/marijuana-leaf"
  },
  {
    url: "/styles/black-grey/sandeep-name-written-vertically-i-XTCcPthZs6bGr6HHLBkfyJ",
    title: "sandeep name written vertically i",
    list_url: "/styles/black-grey/sandeep-name-written-vertically-i"
  },
  {
    url: "/styles/black-grey/slutty-whorish-tramp-stamp-TnLQDsAvMNJVsqKdBjA17W",
    title: "slutty whorish tramp stamp",
    list_url: "/styles/black-grey/slutty-whorish-tramp-stamp"
  },
  {
    url: "/styles/minimalist/if-by-rudyard-kipling-Y1vbXPEi83SZBFeCkPK6sf",
    title: "if by rudyard kipling",
    list_url: "/styles/minimalist/if-by-rudyard-kipling"
  },
  {
    url: "/styles/minimalist/panta-rhei-Fu474hfcYKModjneCxd3rF",
    title: "panta rhei",
    list_url: "/styles/minimalist/panta-rhei"
  },
  {
    url: "/styles/blackwork/abi-name-HRiJ8osZq9hPxUiUB5ZSk9",
    title: "abi name",
    list_url: "/styles/blackwork/abi-name"
  },
  {
    url: "/styles/neotraditional/aryan-name-tattoo-Dqe9LLnJJkVrrga1p7A6ZP",
    title: "aryan name tattoo",
    list_url: "/styles/neotraditional/aryan-name-tattoo"
  },
  {
    url: "/styles/realism/slave-NMZqYCSkYkfUAe19XmxeHs",
    title: "slave",
    list_url: "/styles/realism/slave"
  },
  {
    url: "/styles/black-grey/hot-wife-cuckold-VktrBUqVramKLn655uPuGY",
    title: "hot wife cuckold",
    list_url: "/styles/black-grey/hot-wife-cuckold"
  },
  {
    url: "/styles/dotwork/aries-and-virgo-KqkrXnDknkXpvGh11RDVZR",
    title: "aries and virgo",
    list_url: "/styles/dotwork/aries-and-virgo"
  },
  {
    url: "/styles/geometric/the-name-sindhu-in-morse-code-in-N6pgHu7W8BicvMMn7W1cSb",
    title: "the name sindhu in morse code in",
    list_url: "/styles/geometric/the-name-sindhu-in-morse-code-in"
  },
  {
    url: "/styles/minimalist/00-00-9TKMrnkA55iXBZBboJaGbe",
    title: "00-00",
    list_url: "/styles/minimalist/00-00"
  },
  {
    url: "/styles/minimalist/birth-flower-bouquet-fine-line-M8d6ovwrxctKcEWu7RGrBy",
    title: "birth flower bouquet fine line",
    list_url: "/styles/minimalist/birth-flower-bouquet-fine-line"
  },
  {
    url: "/styles/minimalist/detachment-RNyFJy6XhivzdpXJZpFML5",
    title: "detachment",
    list_url: "/styles/minimalist/detachment"
  },
  {
    url: "/styles/minimalist/kamasutra-RZ1h3Td6ox5HMDobnDJeMK",
    title: "kamasutra",
    list_url: "/styles/minimalist/kamasutra"
  },
  {
    url: "/styles/sketch/a-portrait-of-sza-in-a-sketch-style-FBbwSHYfBa4UMEEjL8Dzhn",
    title: "a portrait of sza in a sketch style",
    list_url: "/styles/sketch/a-portrait-of-sza-in-a-sketch-style"
  },
  {
    url: "/styles/sketch/cyber-sigilism-2Hin9fmF2fa4Gh4KkoBF3A",
    title: "cyber sigilism",
    list_url: "/styles/sketch/cyber-sigilism"
  },
  {
    url: "/styles/anime/big-titty-lesbians-8W46CWRSUyUyaenPD5TV6o",
    title: "big titty lesbians",
    list_url: "/styles/anime/big-titty-lesbians"
  },
  {
    url: "/styles/black-grey/naked-black-woman-with-big-butt-RgB17yPTUD4ZzgaR7gdeoA",
    title: "naked black woman with big butt",
    list_url: "/styles/black-grey/naked-black-woman-with-big-butt"
  },
  {
    url: "/styles/minimalist/fc-barcelona-7zfgHkpGaVqH9xo6oS1hXn",
    title: "fc barcelona",
    list_url: "/styles/minimalist/fc-barcelona"
  },
  {
    url: "/styles/neotraditional/suryaputra-karna-JhfNC1CgkgdkDaZuNen6Xp",
    title: "suryaputra karna",
    list_url: "/styles/neotraditional/suryaputra-karna"
  },
  {
    url: "/styles/neotraditional/woman-with-big-butt-UwcfRfpbHkmK8piEQbA1yK",
    title: "woman with big butt",
    list_url: "/styles/neotraditional/woman-with-big-butt"
  },
  {
    url: "/styles/sketch/pisces-and-capricorn-CTq97T6cRFzEsUpVbnKvzD",
    title: "pisces and capricorn",
    list_url: "/styles/sketch/pisces-and-capricorn"
  },
  {
    url: "/styles/surrealism/slut-8uWtQ7m5PmTyyMNhYRHJGz",
    title: "slut",
    list_url: "/styles/surrealism/slut"
  },
  {
    url: "/styles/blackwork/new-chains-same-shackles-gothic-font-Uq1x9hNrhsKN9fb3YNchkD",
    title: "new chains same shackles gothic font",
    list_url: "/styles/blackwork/new-chains-same-shackles-gothic-font"
  },
  {
    url: "/styles/blackwork/textual-prhase-in-latin-non-sine-7ceHJgitXgGEoJnYuqtdU7",
    title: "textual prhase in latin non sine",
    list_url: "/styles/blackwork/textual-prhase-in-latin-non-sine"
  },
  {
    url: "/styles/dotwork/sagittarius-and-aquarius-Di8kFGQLhjqRShpaRvVNtm",
    title: "sagittarius and aquarius",
    list_url: "/styles/dotwork/sagittarius-and-aquarius"
  },
  {
    url: "/styles/dotwork/scrabble-L6vEV2e64upSEaUxJwTSAD",
    title: "scrabble",
    list_url: "/styles/dotwork/scrabble"
  },
  {
    url: "/styles/minimalist/let-it-hurt-let-it-heal-let-it-go-ALWVtJj5A93KvP3D7QM1pt",
    title: "let it hurt let it heal let it go",
    list_url: "/styles/minimalist/let-it-hurt-let-it-heal-let-it-go"
  },
  {
    url: "/styles/neotraditional/kirtimukha-asur-indian-mythology-LvnkP4uTckf8fWjTuaPdrh",
    title: "kirtimukha asur indian mythology",
    list_url: "/styles/neotraditional/kirtimukha-asur-indian-mythology"
  },
  {
    url: "/styles/neotraditional/payal-name-tattoo-design-ACrSmTuZAfi5xUeLc1ouCT",
    title: "payal name tattoo design",
    list_url: "/styles/neotraditional/payal-name-tattoo-design"
  },
  {
    url: "/styles/neotraditional/santosh-name-3DvVFFP4Ld5XD1X1qBec9Z",
    title: "santosh name",
    list_url: "/styles/neotraditional/santosh-name"
  },
  {
    url: "/styles/realism/naked-woman-spreading-her-legs-dcdir5qyn8WfmXYPJ5FC3",
    title: "naked woman spreading her legs",
    list_url: "/styles/realism/naked-woman-spreading-her-legs"
  },
  {
    url: "/styles/realism/preeti-name-tattoo-6MQzsnqcyMAJjn4TdGiv1B",
    title: "preeti name tattoo",
    list_url: "/styles/realism/preeti-name-tattoo"
  },
  {
    url: "/styles/traditional/create-a-tattoo-based-on-my-name-4hgiDBrwu4h9fHNjmhhRVH",
    title: "create a tattoo based on my name",
    list_url: "/styles/traditional/create-a-tattoo-based-on-my-name"
  },
  {
    url: "/styles/black-grey/12-year-old-girl-naked-with-open-vagina-HPvN4iLVKFTHiLjMMEvxca",
    title: " year old girl naked with open vagina",
    list_url: "/styles/black-grey/12-year-old-girl-naked-with-open-vagina"
  },
  {
    url: "/styles/japanese/inner-peace-NBRR1hQmTHGWzxGJrRHbFX",
    title: "inner peace",
    list_url: "/styles/japanese/inner-peace"
  },
  {
    url: "/styles/black-grey/write-name-tattoo-design-of-vicky-and-B4PqRP9JEXR4frpSyXXBkp",
    title: "write name tattoo design of vicky and",
    list_url: "/styles/black-grey/write-name-tattoo-design-of-vicky-and"
  },
  {
    url: "/styles/blackwork/bnwo-ownership-qos-34SQLrQXQYgV3rL4kKToXs",
    title: "bnwo ownership qos",
    list_url: "/styles/blackwork/bnwo-ownership-qos"
  },
  {
    url: "/styles/geometric/isaiah-68-here-i-am-send-me-RZnMKHHQoUAN6D2fyKGvc4",
    title: "isaiah here i am send me",
    list_url: "/styles/geometric/isaiah-68-here-i-am-send-me"
  },
  {
    url: "/styles/minimalist/cheating-death-7puFEmXyqPFGDPNCpWiTNy",
    title: "cheating death",
    list_url: "/styles/minimalist/cheating-death"
  },
  {
    url: "/styles/neotraditional/ashu-name-8fYxrBPkQFMgAbsmPw4PsE",
    title: "ashu name",
    list_url: "/styles/neotraditional/ashu-name"
  },
  {
    url: "/styles/neotraditional/comparison-is-the-thief-of-joy-6PyoFDVuws6cbPNmR3zLve",
    title: "comparison is the thief of joy",
    list_url: "/styles/neotraditional/comparison-is-the-thief-of-joy"
  },
  {
    url: "/styles/realism/three-crosses-on-the-hill-UYXLm3gnauV6sSVCHwcrTU",
    title: "three crosses on the hill",
    list_url: "/styles/realism/three-crosses-on-the-hill"
  },
  {
    url: "/styles/sketch/jack-russell-dog-JJbC4wkBw3M4xc3Dnxf8FD",
    title: "jack russell dog",
    list_url: "/styles/sketch/jack-russell-dog"
  },
  {
    url: "/styles/sketch/taurus-and-scorpio-3AnqHwzSTQwYYjQijGkUYJ",
    title: "taurus and scorpio",
    list_url: "/styles/sketch/taurus-and-scorpio"
  },
  {
    url: "/styles/traditional/surya-dev-F1jSNCkuno6X83bcyAoeBe",
    title: "surya dev",
    list_url: "/styles/traditional/surya-dev"
  },
  {
    url: "/styles/traditional/tanishka-daughter-name-8GbeouFf69gnSa4JCPXRnj",
    title: "tanishka daughter name",
    list_url: "/styles/traditional/tanishka-daughter-name"
  },
  {
    url: "/styles/tribal/thick-goth-girl-large-breasted-fat-WjeZWNeJJfb3e2w4DVFB3Z",
    title: "thick goth girl large breasted fat",
    list_url: "/styles/tribal/thick-goth-girl-large-breasted-fat"
  },
  {
    url: "/styles/black-grey/st-joseph-KBzF1s8pDRtSYV2LR4VpJj",
    title: "st joseph",
    list_url: "/styles/black-grey/st-joseph"
  },
  {
    url: "/styles/blackwork/anti-government-Qp29A85Rdo5Bbu3gsev4EZ",
    title: "anti government",
    list_url: "/styles/blackwork/anti-government"
  },
  {
    url: "/styles/blackwork/sheetal-name-LZzmiYw1kBseN9D1UsnmAv",
    title: "sheetal name",
    list_url: "/styles/blackwork/sheetal-name"
  },
  {
    url: "/styles/japanese/metsuki-sutemi-Nc66qGSdngFR2TZ7o23q1c",
    title: "metsuki sutemi",
    list_url: "/styles/japanese/metsuki-sutemi"
  },
  {
    url: "/styles/minimalist/akash-name-tattoo-LJSz75oAwWcBstHzuke9fB",
    title: "akash name tattoo",
    list_url: "/styles/minimalist/akash-name-tattoo"
  },
  {
    url: "/styles/realism/manisha-name-tatoo-hyper-realistic-5SipwgUTWxqBoQZKzBiUKE",
    title: "manisha name tatoo hyper realistic",
    list_url: "/styles/realism/manisha-name-tatoo-hyper-realistic"
  },
  {
    url: "/styles/realism/patriotic-fuck-trump-SDJ26AJQdtw5crbnxSaDGx",
    title: "patriotic fuck trump",
    list_url: "/styles/realism/patriotic-fuck-trump"
  },
  {
    url: "/styles/traditional/civil-engineering-UmvGAcqEeVKG1Fcvet2Ads",
    title: "civil engineering",
    list_url: "/styles/traditional/civil-engineering"
  },
  {
    url: "/styles/black-grey/fuck-love-PcyJP8ncrc4uyQ5zUqj47Y",
    title: "fuck love",
    list_url: "/styles/black-grey/fuck-love"
  },
  {
    url: "/styles/minimalist/male-submissive-XJ1FdzqrdHFuSA2pwerWn2",
    title: "male submissive",
    list_url: "/styles/minimalist/male-submissive"
  },
  {
    url: "/styles/minimalist/schnauzer-FXPawi71wRN4MuSJGHFTe2",
    title: "schnauzer",
    list_url: "/styles/minimalist/schnauzer"
  },
  {
    url: "/styles/neotraditional/name-kalai-QGGwRU8pARcyAQeQwHt3JJ",
    title: "name kalai",
    list_url: "/styles/neotraditional/name-kalai"
  },
  {
    url: "/styles/neotraditional/tekst-metsuki-sutemi-5RDrWUhzE9YM62f2HYFKML",
    title: "tekst metsuki sutemi",
    list_url: "/styles/neotraditional/tekst-metsuki-sutemi"
  },
  {
    url: "/styles/realism/lion-family-69RHyKspHFSjTCqThrbWei",
    title: "lion family",
    list_url: "/styles/realism/lion-family"
  },
  {
    url: "/styles/realism/tutto-passa-text-AptjgqvhdFT1fji7HyntVr",
    title: "tutto passa text",
    list_url: "/styles/realism/tutto-passa-text"
  },
  {
    url: "/styles/sketch/full-body-10-head-ravanan-GmcGi8Q49SqAGCnbei2i3z",
    title: "full body head ravanan",
    list_url: "/styles/sketch/full-body-10-head-ravanan"
  },
  {
    url: "/styles/traditional/pinup-girl-tied-up-in-bondage-ropes-DQyuKkPqn5gANLZrp88J9a",
    title: "pinup girl tied up in bondage ropes",
    list_url: "/styles/traditional/pinup-girl-tied-up-in-bondage-ropes"
  },
  {
    url: "/styles/blackwork/ashlesha-nakshatra-XnpimLBXTNWVnk8DEHxrwv",
    title: "ashlesha nakshatra",
    list_url: "/styles/blackwork/ashlesha-nakshatra"
  },
  {
    url: "/styles/geometric/sigma-male-mix-with-eagle-UDbaBL1uhWDfeBZgACFs3s",
    title: "sigma male mix with eagle",
    list_url: "/styles/geometric/sigma-male-mix-with-eagle"
  },
  {
    url: "/styles/japanese/demon-back-CwES8V2ARAy6iGw7UugQk6",
    title: "demon back",
    list_url: "/styles/japanese/demon-back"
  },
  {
    url: "/styles/japanese/female-samurai-F24bTUCJEDU4o6srD8aGnh",
    title: "female samurai",
    list_url: "/styles/japanese/female-samurai"
  },
  {
    url: "/styles/minimalist/kartik-name-9WUoVLgE8qsA1HC4oR8eYn",
    title: "kartik name",
    list_url: "/styles/minimalist/kartik-name"
  },
  {
    url: "/styles/neotraditional/ritika-name-tattoo-RvhejEVKcVezbpo9Bx9qn8",
    title: "ritika name tattoo",
    list_url: "/styles/neotraditional/ritika-name-tattoo"
  },
  {
    url: "/styles/realism/slut-bbc-only-8NqtRerSbePdR8aQfGUR5U",
    title: "slut bbc only",
    list_url: "/styles/realism/slut-bbc-only"
  },
  {
    url: "/styles/black-grey/if-i-had-a-gun-noel-gallagher-6fhkE7FURu6zRGDSsUJkQp",
    title: "if i had a gun noel gallagher",
    list_url: "/styles/black-grey/if-i-had-a-gun-noel-gallagher"
  },
  {
    url: "/styles/blackwork/aayush-name-tattoo-GppPwLArTg3PTVmA6FQBmH",
    title: "aayush name tattoo",
    list_url: "/styles/blackwork/aayush-name-tattoo"
  },
  {
    url: "/styles/dotwork/ritu-name-tettoo-FaUKBB61m2sSzV34eEfdEE",
    title: "ritu name tettoo",
    list_url: "/styles/dotwork/ritu-name-tettoo"
  },
  {
    url: "/styles/minimalist/hidden-letter-m-and-p-hidden-3esvyw6fNdFVAGKHJazo1G",
    title: "hidden letter m and p hidden",
    list_url: "/styles/minimalist/hidden-letter-m-and-p-hidden"
  },
  {
    url: "/styles/minimalist/serendipity-EVhwE8tjKt7NTNZJJDtM3Q",
    title: "serendipity",
    list_url: "/styles/minimalist/serendipity"
  },
  {
    url: "/styles/neotraditional/ankita-name-tattoo-design-featuring-MjeETXYZEJBhvJo4AETTuU",
    title: "ankita name tattoo design featuring",
    list_url: "/styles/neotraditional/ankita-name-tattoo-design-featuring"
  },
  {
    url: "/styles/neotraditional/couple-name-written-along-both-sides-by-GVjHnGi9MR43hFRU5bHuMa",
    title: "couple name written along both sides by",
    list_url: "/styles/neotraditional/couple-name-written-along-both-sides-by"
  },
  {
    url: "/styles/realism/yamraj-3nysNqi3XcKBVxVFxCTAR",
    title: "yamraj",
    list_url: "/styles/realism/yamraj"
  },
  {
    url: "/styles/sketch/1988-in-roman-numerals-WwhXQYjKpKwXvnpNT3vpWv",
    title: " in roman numerals",
    list_url: "/styles/sketch/1988-in-roman-numerals"
  },
  {
    url: "/styles/stencil/fuck-cancer-CqUQB1PKiMCdHAuHDT5TzE",
    title: "fuck cancer",
    list_url: "/styles/stencil/fuck-cancer"
  },
  {
    url: "/styles/anime/suryaputra-karna-RGovKUYAEef49bj9bU62Zz",
    title: "suryaputra karna",
    list_url: "/styles/anime/suryaputra-karna"
  },
  {
    url: "/styles/black-grey/bbc-hentai-tattoo-BWU4w4KVdzX98hpViebXiy",
    title: "bbc hentai tattoo",
    list_url: "/styles/black-grey/bbc-hentai-tattoo"
  },
  {
    url: "/styles/blackwork/eagle-neck-tattoo-for-men-R1GCnsUFgrsLaFCh2mBvua",
    title: "eagle neck tattoo for men",
    list_url: "/styles/blackwork/eagle-neck-tattoo-for-men"
  },
  {
    url: "/styles/dotwork/cosmos-flower-6tokwcDWBNkG6ftiJ2xc91",
    title: "cosmos flower",
    list_url: "/styles/dotwork/cosmos-flower"
  },
  {
    url: "/styles/dotwork/female-reaper-topless-nipple-NwmWEGHTUFhwTJ7rCsqmM1",
    title: "female reaper topless nipple",
    list_url: "/styles/dotwork/female-reaper-topless-nipple"
  },
  {
    url: "/styles/dotwork/fuckboy-DwCr7eUdvmchZjARfL9qSH",
    title: "fuckboy",
    list_url: "/styles/dotwork/fuckboy"
  },
  {
    url: "/styles/dotwork/samiksha-name-J2pcwiqS1WPcbaoHz2VC7C",
    title: "samiksha name",
    list_url: "/styles/dotwork/samiksha-name"
  },
  {
    url: "/styles/japanese/madara-uchiha-Y3AW7MNk3STDAXxwB4ofxv",
    title: "madara uchiha",
    list_url: "/styles/japanese/madara-uchiha"
  },
  {
    url: "/styles/minimalist/3-letters-merged-together-into-1-v-p-KFTJXNAa5DhN9g1LMsdxzH",
    title: " letters merged together into v p",
    list_url: "/styles/minimalist/3-letters-merged-together-into-1-v-p"
  },
  {
    url: "/styles/minimalist/ravana-5WitDtUNKrgDJLfP3E2hMv",
    title: "ravana",
    list_url: "/styles/minimalist/ravana"
  },
  {
    url: "/styles/neotraditional/cuckold-Vs52MEHh1chHPWRQo4u3t6",
    title: "cuckold",
    list_url: "/styles/neotraditional/cuckold"
  },
  {
    url: "/styles/neotraditional/naked-viking-women-ENFwTk1EB2Cmmt2RriniRH",
    title: "naked viking women",
    list_url: "/styles/neotraditional/naked-viking-women"
  },
  {
    url: "/styles/realism/akanksha-name-on-hand-6E4BbdKCMPHoAjPhwia1d9",
    title: "akanksha name on hand",
    list_url: "/styles/realism/akanksha-name-on-hand"
  },
  {
    url: "/styles/realism/crazy-bitch-LUG1dcJXaTVKUAUCPEwTes",
    title: "crazy bitch",
    list_url: "/styles/realism/crazy-bitch"
  },
  {
    url: "/styles/realism/sun-tzu-art-of-war-S5AHeNdLfBGK8bdFDLUPXn",
    title: "sun tzu art of war",
    list_url: "/styles/realism/sun-tzu-art-of-war"
  },
  {
    url: "/styles/black-grey/full-sleeve-with-skull-DBCc8hEtmBwPTpPwKKRiCu",
    title: "full sleeve with skull",
    list_url: "/styles/black-grey/full-sleeve-with-skull"
  },
  {
    url: "/styles/black-grey/gay-bdsm-male-tattoo-GEUvDw7YsKSZsnB64t9ZeD",
    title: "gay bdsm male tattoo",
    list_url: "/styles/black-grey/gay-bdsm-male-tattoo"
  },
  {
    url: "/styles/minimalist/name-sukanya-AenscoYkLnorGpNHJUjnij",
    title: "name sukanya",
    list_url: "/styles/minimalist/name-sukanya"
  },
  {
    url: "/styles/neotraditional/neetu-name-hidden-desgin-LeCDrp7buSyuGzpzirLWHQ",
    title: "neetu name hidden desgin",
    list_url: "/styles/neotraditional/neetu-name-hidden-desgin"
  },
  {
    url: "/styles/neotraditional/radha-name-9mRJgVtwZT7Dcop26SfsU1",
    title: "radha name",
    list_url: "/styles/neotraditional/radha-name"
  },
  {
    url: "/styles/realism/aspen-tree-G9Z8NdQcTTnpjaAA6GRDuL",
    title: "aspen tree",
    list_url: "/styles/realism/aspen-tree"
  },
  {
    url: "/styles/realism/bbc-qos-queen-of-spades-Q6gT5TQiZkbqWc5aiPSmoC",
    title: "bbc qos queen of spades",
    list_url: "/styles/realism/bbc-qos-queen-of-spades"
  },
  {
    url: "/styles/realism/octopus-shoulder-6vzQ9jnfh18tFjXEQ4ss5T",
    title: "octopus shoulder",
    list_url: "/styles/realism/octopus-shoulder"
  },
  {
    url: "/styles/stencil/fuck-around-and-find-out-GSQHP54rJkm2Uau6G32yKE",
    title: "fuck around and find out",
    list_url: "/styles/stencil/fuck-around-and-find-out"
  },
  {
    url: "/styles/black-grey/succubus-and-incubus-having-sex-UQz12gRT8LXue46H5QqVm6",
    title: "succubus and incubus having sex",
    list_url: "/styles/black-grey/succubus-and-incubus-having-sex"
  },
  {
    url: "/styles/dotwork/mocro-mafia-A9J8BbvKR7tmJPaqEnNNU1",
    title: "mocro mafia",
    list_url: "/styles/dotwork/mocro-mafia"
  },
  {
    url: "/styles/minimalist/astrology-chart-UKE2vQnzYoV9JdogwQNZes",
    title: "astrology chart",
    list_url: "/styles/minimalist/astrology-chart"
  },
  {
    url: "/styles/minimalist/dont-trust-anyone-9gstGBJKD1QZT7TaqZTPPu",
    title: "dont trust anyone",
    list_url: "/styles/minimalist/dont-trust-anyone"
  },
  {
    url: "/styles/neotraditional/anal-TyJpiHSXgkQF8xtmgV2TeG",
    title: "anal",
    list_url: "/styles/neotraditional/anal"
  },
  {
    url: "/styles/realism/alexander-the-great-6qLELnUTxDKbgBi4ZXuyrF",
    title: "alexander the great",
    list_url: "/styles/realism/alexander-the-great"
  },
  {
    url: "/styles/traditional/trinidad-and-tobago-Y3Ty7x1H2TedvN1FGxBMEK",
    title: "trinidad and tobago",
    list_url: "/styles/traditional/trinidad-and-tobago"
  },
  {
    url: "/styles/black-grey/varahi-amman-KKJaS7uQuWJ8dLKpFtTywS",
    title: "varahi amman",
    list_url: "/styles/black-grey/varahi-amman"
  },
  {
    url: "/styles/blackwork/symbol-of-enforced-male-chastity-and-L8FqC1HXNddmiH41d9gMsm",
    title: "symbol of enforced male chastity and",
    list_url: "/styles/blackwork/symbol-of-enforced-male-chastity-and"
  },
  {
    url: "/styles/minimalist/aut-viam-inveniam-aut-faciam-3xX8a4B1e2K6VnbNmVT946",
    title: "aut viam inveniam aut faciam",
    list_url: "/styles/minimalist/aut-viam-inveniam-aut-faciam"
  },
  {
    url: "/styles/minimalist/bouquet-of-lily-of-the-valley-and-aster-LLto7C1qKbZui7CKpcLXdb",
    title: "bouquet of lily of the valley and aster",
    list_url: "/styles/minimalist/bouquet-of-lily-of-the-valley-and-aster"
  },
  {
    url: "/styles/neotraditional/fuck-love-XtpK6g3ZFNhVuoZh1u2A5T",
    title: "fuck love",
    list_url: "/styles/neotraditional/fuck-love"
  },
  {
    url: "/styles/realism/hitler-Nsex1Egew1hMqd5taezQqU",
    title: "hitler",
    list_url: "/styles/realism/hitler"
  },
  {
    url: "/styles/traditional/green-bay-packers-MqmsnynqfSMidJFzx2PJCQ",
    title: "green bay packers",
    list_url: "/styles/traditional/green-bay-packers"
  },
  {
    url: "/styles/blackwork/audi-vide-tace-NRsvsvnHxN8kDUahcjuJnx",
    title: "audi vide tace",
    list_url: "/styles/blackwork/audi-vide-tace"
  },
  {
    url: "/styles/dotwork/fuck-zamana-text-in-hindi-and-english-R25wTM3pxyTsUQHwzoRvBg",
    title: "fuck zamana text in hindi and english",
    list_url: "/styles/dotwork/fuck-zamana-text-in-hindi-and-english"
  },
  {
    url: "/styles/dotwork/stitch-embroidered-patch-2X5UwPkGsVavT2SupkE4Au",
    title: "stitch embroidered patch",
    list_url: "/styles/dotwork/stitch-embroidered-patch"
  },
  {
    url: "/styles/minimalist/ankita-name-tattoo-design-featuring-ATNX9RmtrHT2veWU9kEWhR",
    title: "ankita name tattoo design featuring",
    list_url: "/styles/minimalist/ankita-name-tattoo-design-featuring"
  },
  {
    url: "/styles/minimalist/date-crossword-puzzle-BTWZMEw3dovQjMAU4Fi9Cj",
    title: "date crossword puzzle",
    list_url: "/styles/minimalist/date-crossword-puzzle"
  },
  {
    url: "/styles/minimalist/tattoo-of-a-latin-phrase-esse-quam-21W4ya6z619DLQyp5YzDDk",
    title: "tattoo of a latin phrase esse quam",
    list_url: "/styles/minimalist/tattoo-of-a-latin-phrase-esse-quam"
  },
  {
    url: "/styles/neotraditional/bbc-hentai-tattoo-JnsJC1VXTytocjteQ6zz4d",
    title: "bbc hentai tattoo",
    list_url: "/styles/neotraditional/bbc-hentai-tattoo"
  },
  {
    url: "/styles/neotraditional/monkey-fucking-a-football-Vs9AnwrbdoySUJczrVkp6S",
    title: "monkey fucking a football",
    list_url: "/styles/neotraditional/monkey-fucking-a-football"
  },
  {
    url: "/styles/sketch/name-manju-6FN2qT6RSQ4tQQhkZmiEpP",
    title: "name manju",
    list_url: "/styles/sketch/name-manju"
  },
  {
    url: "/styles/sketch/neck-tattoo-lightning-BJzzqUQf5A35NicdaW9eVc",
    title: "neck tattoo lightning",
    list_url: "/styles/sketch/neck-tattoo-lightning"
  },
  {
    url: "/styles/surrealism/bdsm-submissive-slave-woman-LyzEhBqf386vAAFoEnxiYp",
    title: "bdsm submissive slave woman",
    list_url: "/styles/surrealism/bdsm-submissive-slave-woman"
  },
  {
    url: "/styles/traditional/tatto-for-name-harsha-CpUmmaJfcZ1azVFDwVXWDL",
    title: "tatto for name harsha",
    list_url: "/styles/traditional/tatto-for-name-harsha"
  },
  {
    url: "/styles/tribal/viking-style-with-kids-names-CddWA1UbT2vcCtp2VvrRuL",
    title: "viking style with kids names",
    list_url: "/styles/tribal/viking-style-with-kids-names"
  },
  {
    url: "/styles/3d/kavita-name-tattoo-D7LiHdCrPvTvYZ5d3wLWBi",
    title: "kavita name tattoo",
    list_url: "/styles/3d/kavita-name-tattoo"
  },
  {
    url: "/styles/dotwork/cross-that-says-in-god-we-trust-4aGRttPvgNnu3q19Z3Qnwg",
    title: "cross that says in god we trust",
    list_url: "/styles/dotwork/cross-that-says-in-god-we-trust"
  },
  {
    url: "/styles/neotraditional/name-riya-2jPMaTGzo6Yuv9KumbDEVv",
    title: "name riya",
    list_url: "/styles/neotraditional/name-riya"
  },
  {
    url: "/styles/realism/sagittarius-and-gemini-JpNZDQQpuA166hx21TN3NB",
    title: "sagittarius and gemini",
    list_url: "/styles/realism/sagittarius-and-gemini"
  },
  {
    url: "/styles/black-grey/ahegao-girl-full-body-UWbHyVLh4dSScKkKmMVYVN",
    title: "ahegao girl full body",
    list_url: "/styles/black-grey/ahegao-girl-full-body"
  },
  {
    url: "/styles/black-grey/david-and-goliath-Rgg2aPUQhcBnjHocSZcURj",
    title: "david and goliath",
    list_url: "/styles/black-grey/david-and-goliath"
  },
  {
    url: "/styles/blackwork/a-tattoo-based-of-the-quote-it-is-what-HBXtgXiVRY242DtadgL6Gf",
    title: "a tattoo based of the quote it is what",
    list_url: "/styles/blackwork/a-tattoo-based-of-the-quote-it-is-what"
  },
  {
    url: "/styles/blackwork/saint-florian-SfoZ2C1qesDAt2WQJ115wV",
    title: "saint florian",
    list_url: "/styles/blackwork/saint-florian"
  },
  {
    url: "/styles/blackwork/skeleton-hand-choking-neck-tattoo-JZp3s2qTCrDbBczhbFqkKM",
    title: "skeleton hand choking neck tattoo",
    list_url: "/styles/blackwork/skeleton-hand-choking-neck-tattoo"
  },
  {
    url: "/styles/blackwork/supriya-name-on-neck-8XRiwm9ht5RaMo2gzpEbLY",
    title: "supriya name on neck",
    list_url: "/styles/blackwork/supriya-name-on-neck"
  },
  {
    url: "/styles/minimalist/calm-in-chaos-Eqs4punE8CS3d37ducbZ1w",
    title: "calm in chaos",
    list_url: "/styles/minimalist/calm-in-chaos"
  },
  {
    url: "/styles/sketch/asian-slut-bbc-only-WbiukAQn6nGnXhJuiYDCFi",
    title: "asian slut bbc only",
    list_url: "/styles/sketch/asian-slut-bbc-only"
  },
  {
    url: "/styles/black-grey/sissy-slut-Xz1L7U1zG2Yd9XxRHfYN8e",
    title: "sissy slut",
    list_url: "/styles/black-grey/sissy-slut"
  },
  {
    url: "/styles/black-grey/suman-name-TVq8kSSK533mjFFzd3jMp1",
    title: "suman name",
    list_url: "/styles/black-grey/suman-name"
  },
  {
    url: "/styles/dotwork/ks-sfyd-L4hAKzUuAX1y2nmXhPg4Sj",
    title: "ks sfyd",
    list_url: "/styles/dotwork/ks-sfyd"
  },
  {
    url: "/styles/japanese/dragon-forearm-9DZpAerg6UseJuFWwHZBto",
    title: "dragon forearm",
    list_url: "/styles/japanese/dragon-forearm"
  },
  {
    url: "/styles/minimalist/be-curious-not-judgemental-KwTtDFuZZZQqg7KVsndXro",
    title: "be curious not judgemental",
    list_url: "/styles/minimalist/be-curious-not-judgemental"
  },
  {
    url: "/styles/minimalist/midwifery-E1J1fGtHHHfKrs2cvp2CKo",
    title: "midwifery",
    list_url: "/styles/minimalist/midwifery"
  },
  {
    url: "/styles/minimalist/unrequited-love-JXmzAANoJF7nhNfbCqA1CA",
    title: "unrequited love",
    list_url: "/styles/minimalist/unrequited-love"
  },
  {
    url: "/styles/sketch/aphrodite-with-brush-dashes-on-the-PjVptMAs584urCF5yEDSxw",
    title: "aphrodite with brush dashes on the",
    list_url: "/styles/sketch/aphrodite-with-brush-dashes-on-the"
  },
  {
    url: "/styles/black-grey/owl-clock-kf98JeGfjcLg6zGsDWGSh",
    title: "owl clock",
    list_url: "/styles/black-grey/owl-clock"
  },
  {
    url: "/styles/dotwork/hanuman-with-krishna-WFBVRSeiJpc6fmTVTzGoWw",
    title: "hanuman with krishna",
    list_url: "/styles/dotwork/hanuman-with-krishna"
  },
  {
    url: "/styles/dotwork/rajput-RvsdLoXCACD9SYXCS9j7Ys",
    title: "rajput",
    list_url: "/styles/dotwork/rajput"
  },
  {
    url: "/styles/minimalist/simple-vine-Fnm5M9JfyUf8ZMpoFccMrX",
    title: "simple vine",
    list_url: "/styles/minimalist/simple-vine"
  },
  {
    url: "/styles/minimalist/tatvamasi-5DbCR56HhoDWBiyevF9egE",
    title: "tatvamasi",
    list_url: "/styles/minimalist/tatvamasi"
  },
  {
    url: "/styles/neotraditional/dominatrix-with-strapon-7GqvUyqPB31nUcX4VDXpw",
    title: "dominatrix with strapon",
    list_url: "/styles/neotraditional/dominatrix-with-strapon"
  },
  {
    url: "/styles/neotraditional/gopika-name-VAV5aeyv8oM3YaMJLKxvAq",
    title: "gopika name",
    list_url: "/styles/neotraditional/gopika-name"
  },
  {
    url: "/styles/neotraditional/isaiah-6-8-TRkLawg1d6rDXFCtLaRMKJ",
    title: "isaiah ",
    list_url: "/styles/neotraditional/isaiah-6-8"
  },
  {
    url: "/styles/neotraditional/the-word-shruti-name-logo-tattoo-B4wVtCASk4xxM15ndyWcwk",
    title: "the word shruti name logo tattoo",
    list_url: "/styles/neotraditional/the-word-shruti-name-logo-tattoo"
  },
  {
    url: "/styles/realism/native-american-medicine-wheel-with-CzbqN6snfCB2fnUVuDKDhg",
    title: "native american medicine wheel with",
    list_url: "/styles/realism/native-american-medicine-wheel-with"
  },
  {
    url: "/styles/sketch/tiger-with-cubs-5MwzzE7B4nid7M3npDM5Xu",
    title: "tiger with cubs",
    list_url: "/styles/sketch/tiger-with-cubs"
  },
  {
    url: "/styles/black-grey/lana-rhoades-MmY3rKZp9b4KNMwRWsTnAZ",
    title: "lana rhoades",
    list_url: "/styles/black-grey/lana-rhoades"
  },
  {
    url: "/styles/blackwork/roman-numerals-of-1976-and-1971-PeTGzPVX75sv9cT4wqxmEz",
    title: "roman numerals of and ",
    list_url: "/styles/blackwork/roman-numerals-of-1976-and-1971"
  },
  {
    url: "/styles/japanese/christian-cross-HYCRXpiw8WSvFnsANVF1YY",
    title: "christian cross",
    list_url: "/styles/japanese/christian-cross"
  },
  {
    url: "/styles/minimalist/combine-letters-j-and-s-JWNEfPTJB5ahTffSA9xEVs",
    title: "combine letters j and s",
    list_url: "/styles/minimalist/combine-letters-j-and-s"
  },
  {
    url: "/styles/neotraditional/madhu-name-with-heart-XrZG8AekNmryuYUQEQhJ72",
    title: "madhu name with heart",
    list_url: "/styles/neotraditional/madhu-name-with-heart"
  },
  {
    url: "/styles/realism/cover-up-over-a-spider-web-NWCD1TnW7NSxWMy6G4B8XK",
    title: "cover up over a spider web",
    list_url: "/styles/realism/cover-up-over-a-spider-web"
  },
  {
    url: "/styles/sketch/karm-sabr-moksh-5FsoWiA7vuJa8x2HD8RHTb",
    title: "karm sabr moksh",
    list_url: "/styles/sketch/karm-sabr-moksh"
  },
  {
    url: "/styles/traditional/futanari-SFJ9sxjR7eQDJGD5kpauBz",
    title: "futanari",
    list_url: "/styles/traditional/futanari"
  },
  {
    url: "/styles/traditional/number-18-8gvtDg8bAna8whdMPdpBxG",
    title: "number ",
    list_url: "/styles/traditional/number-18"
  },
  {
    url: "/styles/black-grey/big-titties-hentai-tattooed-girl-UPP6zaTPs6j5RmGw9P8v2g",
    title: "big titties hentai tattooed girl",
    list_url: "/styles/black-grey/big-titties-hentai-tattooed-girl"
  },
  {
    url: "/styles/blackwork/dhanam-mulam-idam-jagath-ThHnpzYfgxPtibkbyx6YiA",
    title: "dhanam mulam idam jagath",
    list_url: "/styles/blackwork/dhanam-mulam-idam-jagath"
  },
  {
    url: "/styles/blackwork/name-aswathy-5nF7TT56sic2JWmqHA3e8T",
    title: "name aswathy",
    list_url: "/styles/blackwork/name-aswathy"
  },
  {
    url: "/styles/dotwork/name-kanchan-3HdQYPNrvjXCqr6Pc9yJBK",
    title: "name kanchan",
    list_url: "/styles/dotwork/name-kanchan"
  },
  {
    url: "/styles/geometric/bind-rune-with-the-following-runes-DZSFzJroU5NKore5DEpaf3",
    title: "bind rune with the following runes",
    list_url: "/styles/geometric/bind-rune-with-the-following-runes"
  },
  {
    url: "/styles/minimalist/combin-two-name-6TevH1iQaJUFpBzvkpCh7s",
    title: "combin two name",
    list_url: "/styles/minimalist/combin-two-name"
  },
  {
    url: "/styles/minimalist/number-8-4jquSARYxHw1fv3iFUwDUW",
    title: "number ",
    list_url: "/styles/minimalist/number-8"
  },
  {
    url: "/styles/minimalist/the-wizard-of-oz-DPNAcMag6w6UKEedntiCfW",
    title: "the wizard of oz",
    list_url: "/styles/minimalist/the-wizard-of-oz"
  },
  {
    url: "/styles/neotraditional/heavy-is-the-crown-so-i-cede-to-the-FLwB3eA5PDt9BQq1s3mGjm",
    title: "heavy is the crown so i cede to the",
    list_url: "/styles/neotraditional/heavy-is-the-crown-so-i-cede-to-the"
  },
  {
    url: "/styles/realism/magpie-newcastle-united-WQpFwdNax4wRXgidtkH6JN",
    title: "magpie newcastle united",
    list_url: "/styles/realism/magpie-newcastle-united"
  },
  {
    url: "/styles/surrealism/seductive-backshot-of-megan-fox-LNUST2ZmuBEkExwwCG25Ho",
    title: "seductive backshot of megan fox",
    list_url: "/styles/surrealism/seductive-backshot-of-megan-fox"
  },
  {
    url: "/styles/anime/ahegao-XrLiRsefn1hCwatxm6idgL",
    title: "ahegao",
    list_url: "/styles/anime/ahegao"
  },
  {
    url: "/styles/black-grey/ramya-BbdgTvbuw4dE437THBiVo7",
    title: "ramya",
    list_url: "/styles/black-grey/ramya"
  },
  {
    url: "/styles/blackwork/name-tatoo-of-the-name-shreya-SndLKd1gzdy6vtPp4J2U3v",
    title: "name tatoo of the name shreya",
    list_url: "/styles/blackwork/name-tatoo-of-the-name-shreya"
  },
  {
    url: "/styles/blackwork/name-vedika-VHPPY4vyhND8kMTgA8vf4q",
    title: "name vedika",
    list_url: "/styles/blackwork/name-vedika"
  },
  {
    url: "/styles/blackwork/whore-2zG91sxwZqsbNxquvN2hHc",
    title: "whore",
    list_url: "/styles/blackwork/whore"
  },
  {
    url: "/styles/dotwork/yazhini-JGPPxMLBnMPsBJC1thBkLS",
    title: "yazhini",
    list_url: "/styles/dotwork/yazhini"
  },
  {
    url: "/styles/japanese/meghana-name-tattoo-U9zcAj4KLonMbLbxqU338q",
    title: "meghana name tattoo",
    list_url: "/styles/japanese/meghana-name-tattoo"
  },
  {
    url: "/styles/minimalist/a-sunflower-with-a-letter-k-hidden-Er32ZD51jZ9Cu3ZKrNcvug",
    title: "a sunflower with a letter k hidden",
    list_url: "/styles/minimalist/a-sunflower-with-a-letter-k-hidden"
  },
  {
    url: "/styles/minimalist/jesus-the-nazarene-NxNYGmGDK3hhQw8pry7x44",
    title: "jesus the nazarene",
    list_url: "/styles/minimalist/jesus-the-nazarene"
  },
  {
    url: "/styles/minimalist/penicillin-allergy-Py6bUA94tZUqHTu2jGBnD1",
    title: "penicillin allergy",
    list_url: "/styles/minimalist/penicillin-allergy"
  },
  {
    url: "/styles/minimalist/rise-and-rise-again-until-lambs-become-Py8E1irDkkTXkPoGNjkJU3",
    title: "rise and rise again until lambs become",
    list_url: "/styles/minimalist/rise-and-rise-again-until-lambs-become"
  },
  {
    url: "/styles/neotraditional/abhi-name-logo-HQvAGtmfnft7wvhJBUL4x2",
    title: "abhi name logo",
    list_url: "/styles/neotraditional/abhi-name-logo"
  },
  {
    url: "/styles/neotraditional/samrat-ashoka-DSfB7VuHRcUR71N2vnPhxf",
    title: "samrat ashoka",
    list_url: "/styles/neotraditional/samrat-ashoka"
  },
  {
    url: "/styles/realism/dirty-butthole-YPBPEuvUAovcETrBMAfmxE",
    title: "dirty butthole",
    list_url: "/styles/realism/dirty-butthole"
  },
  {
    url: "/styles/realism/mars-roman-god-9P9vRqf2o7jyP92pszbPMF",
    title: "mars roman god",
    list_url: "/styles/realism/mars-roman-god"
  },
  {
    url: "/styles/sketch/birth-flowers-with-names-in-stem-KhjKW9w57owZn4QLVku1No",
    title: "birth flowers with names in stem",
    list_url: "/styles/sketch/birth-flowers-with-names-in-stem"
  },
  {
    url: "/styles/sketch/compass-with-family-initials-LbxzqG54RMhBobwzSN5awD",
    title: "compass with family initials",
    list_url: "/styles/sketch/compass-with-family-initials"
  },
  {
    url: "/styles/black-grey/wife-name-srishti-DmgC9dkwoQLNaPd56osmsG",
    title: "wife name srishti",
    list_url: "/styles/black-grey/wife-name-srishti"
  },
  {
    url: "/styles/black-grey/wrist-tattoo-with-the-name-anna-WmqF1WzYwA4hG6vENqixmd",
    title: "wrist tattoo with the name anna",
    list_url: "/styles/black-grey/wrist-tattoo-with-the-name-anna"
  },
  {
    url: "/styles/dotwork/leo-and-virgo-B5QbzXkamY2AcGBAC3StdK",
    title: "leo and virgo",
    list_url: "/styles/dotwork/leo-and-virgo"
  },
  {
    url: "/styles/dotwork/letter-r-hidden-in-letter-a-X6SfjNfXeM3JSybbVhnn3d",
    title: "letter r hidden in letter a",
    list_url: "/styles/dotwork/letter-r-hidden-in-letter-a"
  },
  {
    url: "/styles/dotwork/sinaloa-cartel-with-scorpions-and-S7AJZVsqhPMEFnjoj5tWGi",
    title: "sinaloa cartel with scorpions and",
    list_url: "/styles/dotwork/sinaloa-cartel-with-scorpions-and"
  },
  {
    url: "/styles/japanese/2004-AwrYtyAdEVmQWqeosW9LyX",
    title: "2004",
    list_url: "/styles/japanese/2004"
  },
  {
    url: "/styles/minimalist/father-with-his-daughter-fishing-E5imKTepddUGPUqjQUhNma",
    title: "father with his daughter fishing",
    list_url: "/styles/minimalist/father-with-his-daughter-fishing"
  },
  {
    url: "/styles/minimalist/gibson-les-paul-guitar-3UJLV1LBSNhLpHcRPdeyLy",
    title: "gibson les paul guitar",
    list_url: "/styles/minimalist/gibson-les-paul-guitar"
  },
  {
    url: "/styles/minimalist/santoshi-mata-HWcCewm7KijwM6G2GHo7gX",
    title: "santoshi mata",
    list_url: "/styles/minimalist/santoshi-mata"
  },
  {
    url: "/styles/minimalist/word-saudade-Di9LW3buz3pbfAZR9LfrUs",
    title: "word saudade",
    list_url: "/styles/minimalist/word-saudade"
  },
  {
    url: "/styles/neotraditional/fuck-em-5Zj1TFMHqNTAJPNxqCD2vB",
    title: "fuck em",
    list_url: "/styles/neotraditional/fuck-em"
  },
  {
    url: "/styles/neotraditional/murugan-vel-with-letter-s-3dD4AxDY82c5HCWeHTbZzY",
    title: "murugan vel with letter s",
    list_url: "/styles/neotraditional/murugan-vel-with-letter-s"
  },
  {
    url: "/styles/neotraditional/nikku-name-with-stylish-font-RSTWxRY22on4479P9ebdW",
    title: "nikku name with stylish font",
    list_url: "/styles/neotraditional/nikku-name-with-stylish-font"
  },
  {
    url: "/styles/sketch/punjabi-BNV6s2xj7VnFTfb2EKzVeX",
    title: "punjabi",
    list_url: "/styles/sketch/punjabi"
  },
  {
    url: "/styles/traditional/bbc-QPYs3ehJLkeCzUcuHZSHpL",
    title: "bbc",
    list_url: "/styles/traditional/bbc"
  },
  {
    url: "/styles/traditional/nepal-ELRBUAB2Csx8dVWJiuHnke",
    title: "nepal",
    list_url: "/styles/traditional/nepal"
  },
  {
    url: "/styles/black-grey/amy-winehouse-topless-girl-QrPNixDmwMWzUEcUEJMDMX",
    title: "amy winehouse topless girl",
    list_url: "/styles/black-grey/amy-winehouse-topless-girl"
  },
  {
    url: "/styles/black-grey/trust-no-bitch-fear-no-man-SASFRyTU8T1zR68z5Dev7H",
    title: "trust no bitch fear no man",
    list_url: "/styles/black-grey/trust-no-bitch-fear-no-man"
  },
  {
    url: "/styles/dotwork/puta-HSjzMxzp31oAwbgQhF8q4P",
    title: "puta",
    list_url: "/styles/dotwork/puta"
  },
  {
    url: "/styles/japanese/wind-bars-and-waves-ME4rDRb72MKD7i9fFNqps",
    title: "wind bars and waves",
    list_url: "/styles/japanese/wind-bars-and-waves"
  },
  {
    url: "/styles/minimalist/camino-de-santiago-UiuZr1515SnbqudqzgU8s3",
    title: "camino de santiago",
    list_url: "/styles/minimalist/camino-de-santiago"
  },
  {
    url: "/styles/neotraditional/black-baby-factory-WeyPW5Afzmfvtg8NxKwVBq",
    title: "black baby factory",
    list_url: "/styles/neotraditional/black-baby-factory"
  },
  {
    url: "/styles/neotraditional/pavithra-name-with-0625-number-with-L6Ai8agLcJupw3haGuvaXK",
    title: "pavithra name with number with",
    list_url: "/styles/neotraditional/pavithra-name-with-0625-number-with"
  },
  {
    url: "/styles/neotraditional/slut-bbc-only-3NCeiaaZix1hohAZMzuAKd",
    title: "slut bbc only",
    list_url: "/styles/neotraditional/slut-bbc-only"
  },
  {
    url: "/styles/neotraditional/theyyam-kerala-yC6WvE4vBEb5hp4dHtZuE",
    title: "theyyam kerala",
    list_url: "/styles/neotraditional/theyyam-kerala"
  },
  {
    url: "/styles/sketch/gemini-and-taurus-zodiac-sign-combined-LCav5WcYN1ACQU9jmHi5RJ",
    title: "gemini and taurus zodiac sign combined",
    list_url: "/styles/sketch/gemini-and-taurus-zodiac-sign-combined"
  },
  {
    url: "/styles/traditional/crazy-white-boy-DZgP1QAKY6dkRUQAn4BYLK",
    title: "crazy white boy",
    list_url: "/styles/traditional/crazy-white-boy"
  },
  {
    url: "/styles/tribal/dont-tread-on-me-fafo-NMQWyP6qtKaJyXqdnx7v8S",
    title: "dont tread on me fafo",
    list_url: "/styles/tribal/dont-tread-on-me-fafo"
  },
  {
    url: "/styles/tribal/polynesian-DCtyuxRotJn1qns4WwNAeu",
    title: "polynesian",
    list_url: "/styles/tribal/polynesian"
  },
  {
    url: "/styles/black-grey/ardra-nakshatra-ECEB96FE7ahVQMLtnWpFeH",
    title: "ardra nakshatra",
    list_url: "/styles/black-grey/ardra-nakshatra"
  },
  {
    url: "/styles/black-grey/femboy-cute-sissy-womb-tattoo-SRna6q9TtmnsDNQ19RS2Ch",
    title: "femboy cute sissy womb tattoo",
    list_url: "/styles/black-grey/femboy-cute-sissy-womb-tattoo"
  },
  {
    url: "/styles/black-grey/indian-one-rupee-coin-8bFVXzKS9NBLAS9LucwNuj",
    title: "indian one rupee coin",
    list_url: "/styles/black-grey/indian-one-rupee-coin"
  },
  {
    url: "/styles/black-grey/tattered-american-flag-Re9Xic3WoauJcpSjnZJC3N",
    title: "tattered american flag",
    list_url: "/styles/black-grey/tattered-american-flag"
  },
  {
    url: "/styles/black-grey/unbreakable-bond-for-brother-and-sister-PP8KR3enhodtZESdjWPVYf",
    title: "unbreakable bond for brother and sister",
    list_url: "/styles/black-grey/unbreakable-bond-for-brother-and-sister"
  },
  {
    url: "/styles/blackwork/heart-attack-stent-96kGGchERLGBzLTN2A2wdC",
    title: "heart attack stent",
    list_url: "/styles/blackwork/heart-attack-stent"
  },
  {
    url: "/styles/blackwork/roman-numerals-1979-HCF6odqSgaQfom6JLWzipk",
    title: "roman numerals ",
    list_url: "/styles/blackwork/roman-numerals-1979"
  },
  {
    url: "/styles/blackwork/srinidhi-name-written-6j41cEU1zPfqizGk981WoD",
    title: "srinidhi name written",
    list_url: "/styles/blackwork/srinidhi-name-written"
  },
  {
    url: "/styles/blackwork/vladimir-makarov-DF9RV9JXBnd5T25zz6A6ta",
    title: "vladimir makarov",
    list_url: "/styles/blackwork/vladimir-makarov"
  },
  {
    url: "/styles/minimalist/curiosity-Rv96WKNdzRUKp1ZsWkw7tu",
    title: "curiosity",
    list_url: "/styles/minimalist/curiosity"
  },
  {
    url: "/styles/minimalist/family-birth-flower-bouquet-Gn7WVb6We3Wdqk8jvERSjJ",
    title: "family birth flower bouquet",
    list_url: "/styles/minimalist/family-birth-flower-bouquet"
  },
  {
    url: "/styles/minimalist/newtons-first-law-of-motion-Gc1YwQmVwjkGiT9NUokKiP",
    title: "newtons first law of motion",
    list_url: "/styles/minimalist/newtons-first-law-of-motion"
  },
  {
    url: "/styles/neotraditional/i-am-not-okay-lyrics-jelly-roll-Ad5fauwXeW89nFwfunFV5H",
    title: "i am not okay lyrics jelly roll",
    list_url: "/styles/neotraditional/i-am-not-okay-lyrics-jelly-roll"
  },
  {
    url: "/styles/neotraditional/karma-dharma-moksha-PKhP6KrDzindaLTzz6L4Qw",
    title: "karma dharma moksha",
    list_url: "/styles/neotraditional/karma-dharma-moksha"
  },
  {
    url: "/styles/neotraditional/n-k-name-letter-tattoo-VPgkZfo1wpbD6i1HVWcSfJ",
    title: "n k name letter tattoo",
    list_url: "/styles/neotraditional/n-k-name-letter-tattoo"
  },
  {
    url: "/styles/neotraditional/saloni-name-tattoo-HtCpR5LELdjiNyKiNTcHWT",
    title: "saloni name tattoo",
    list_url: "/styles/neotraditional/saloni-name-tattoo"
  },
  {
    url: "/styles/realism/man-performing-cunnilingus-on-woman-21nZJLH1HCZSxjTUKR8Y27",
    title: "man performing cunnilingus on woman",
    list_url: "/styles/realism/man-performing-cunnilingus-on-woman"
  },
  {
    url: "/styles/sketch/a-sketch-style-tattoo-of-cody-rhodes-MDPsx3rDfht2WUepwRyrD6",
    title: "a sketch style tattoo of cody rhodes",
    list_url: "/styles/sketch/a-sketch-style-tattoo-of-cody-rhodes"
  },
  {
    url: "/styles/sketch/p-and-c-letter-vWAGbJ3YnhKxZPqVutmdV",
    title: "p and c letter",
    list_url: "/styles/sketch/p-and-c-letter"
  },
  {
    url: "/styles/stencil/joker-XVcCVXQ8DCxGZRhFzNK5FB",
    title: "joker",
    list_url: "/styles/stencil/joker"
  },
  {
    url: "/styles/traditional/paso-corto-vista-larga-LQCr1SPCQPqiZH4vYmc7S1",
    title: "paso corto vista larga",
    list_url: "/styles/traditional/paso-corto-vista-larga"
  },
  {
    url: "/styles/anime/hentai-2KVBKPu8Y8FDjg1svv63h5",
    title: "hentai",
    list_url: "/styles/anime/hentai"
  },
  {
    url: "/styles/black-grey/inner-peace-symbol-UKorgWQYeoEBCjhEPbhwf8",
    title: "inner peace symbol",
    list_url: "/styles/black-grey/inner-peace-symbol"
  },
  {
    url: "/styles/geometric/gemini-and-cancer-symbols-combined-GaGyLwB6eSZzzxc7pX6qhQ",
    title: "gemini and cancer symbols combined",
    list_url: "/styles/geometric/gemini-and-cancer-symbols-combined"
  },
  {
    url: "/styles/japanese/mia-khalifa-VeNeRLyj8zuYuG2E2SXy8v",
    title: "mia khalifa",
    list_url: "/styles/japanese/mia-khalifa"
  },
  {
    url: "/styles/minimalist/antifa-XvQCGimjDBkyzXHuxUW9E6",
    title: "antifa",
    list_url: "/styles/minimalist/antifa"
  },
  {
    url: "/styles/minimalist/athena-8kYSNQe1CgpUhCs2AQWn4Y",
    title: "athena",
    list_url: "/styles/minimalist/athena"
  },
  {
    url: "/styles/minimalist/billie-eilish-lyrics-Hu9ecZu2RsVE1fJ1HbNaJQ",
    title: "billie eilish lyrics",
    list_url: "/styles/minimalist/billie-eilish-lyrics"
  },
  {
    url: "/styles/minimalist/roman-numeral-1111-clock-5M3KVcXonT4okAMcTdvojv",
    title: "roman numeral clock",
    list_url: "/styles/minimalist/roman-numeral-1111-clock"
  },
  {
    url: "/styles/neotraditional/mix-two-names-in-one-tattoo-design-6HxSApUGyg8ghzCW7989gW",
    title: "mix two names in one tattoo design",
    list_url: "/styles/neotraditional/mix-two-names-in-one-tattoo-design"
  },
  {
    url: "/styles/neotraditional/prema-name-7h6J2fyDdpLadytuD5eWPu",
    title: "prema name",
    list_url: "/styles/neotraditional/prema-name"
  },
  {
    url: "/styles/realism/girl-peeing-ArzaxpYSKrgi7boY5CGE4i",
    title: "girl peeing",
    list_url: "/styles/realism/girl-peeing"
  },
  {
    url: "/styles/sketch/flat-earth-A7MoLX7Ynoj59G9nCUJWr8",
    title: "flat earth",
    list_url: "/styles/sketch/flat-earth"
  },
  {
    url: "/styles/sketch/lord-murugan-with-peacock-and-vel-UuTTPRY9e2yKbNvAYaqPE7",
    title: "lord murugan with peacock and vel",
    list_url: "/styles/sketch/lord-murugan-with-peacock-and-vel"
  },
  {
    url: "/styles/trash-polka/a-man-fucks-a-toothless-snake-in-his-KmMrY1SQHzTnS9SLkyzasr",
    title: "a man fucks a toothless snake in his",
    list_url: "/styles/trash-polka/a-man-fucks-a-toothless-snake-in-his"
  },
  {
    url: "/styles/black-grey/name-julie-PyKMUciNtjeE45sVbGEM4B",
    title: "name julie",
    list_url: "/styles/black-grey/name-julie"
  },
  {
    url: "/styles/black-grey/viking-symbol-for-father-and-son-with-MjTXoM2ebphzdChjn5gpc4",
    title: "viking symbol for father and son with",
    list_url: "/styles/black-grey/viking-symbol-for-father-and-son-with"
  },
  {
    url: "/styles/blackwork/bnwo-ownership-qos-9VyjERRjyrvpSGyjmEr6bg",
    title: "bnwo ownership qos",
    list_url: "/styles/blackwork/bnwo-ownership-qos"
  },
  {
    url: "/styles/blackwork/compass-with-kids-names-Tp7VhNUnHe9n8uX5kj3DpV",
    title: "compass with kids names",
    list_url: "/styles/blackwork/compass-with-kids-names"
  },
  {
    url: "/styles/dotwork/2003-rishi-PwnXez58GT6QojD7caaF9g",
    title: " rishi",
    list_url: "/styles/dotwork/2003-rishi"
  },
  {
    url: "/styles/dotwork/archangel-jophiel-MA4UrgyEcvL2W1cYVFAodB",
    title: "archangel jophiel",
    list_url: "/styles/dotwork/archangel-jophiel"
  },
  {
    url: "/styles/dotwork/xavier-rudd-summertime-Rb41Ev6pxgSdZ4YjnXP6DL",
    title: "xavier rudd summertime",
    list_url: "/styles/dotwork/xavier-rudd-summertime"
  },
  {
    url: "/styles/japanese/anth-asti-prarambh-4VabtVuK4XPetY5bacCwCj",
    title: "anth asti prarambh",
    list_url: "/styles/japanese/anth-asti-prarambh"
  },
  {
    url: "/styles/japanese/japanese-style-waves-7-birth-flowers-UorHcoppaK927osVQNCUzw",
    title: "japanese style waves birth flowers",
    list_url: "/styles/japanese/japanese-style-waves-7-birth-flowers"
  },
  {
    url: "/styles/minimalist/1997-roman-numerals-KeKbeX8Rkd8NCVpJygnvcT",
    title: " roman numerals",
    list_url: "/styles/minimalist/1997-roman-numerals"
  },
  {
    url: "/styles/minimalist/daddys-little-slut-XkF8BsayqJ8knb4SiKmVuG",
    title: "daddys little slut",
    list_url: "/styles/minimalist/daddys-little-slut"
  },
  {
    url: "/styles/minimalist/heather-flower-Qh8MobesNFRG82MvXi2t4N",
    title: "heather flower",
    list_url: "/styles/minimalist/heather-flower"
  },
  {
    url: "/styles/minimalist/hidden-letter-k-and-s-h-calligraphy-AV2HZHW1GPa9EXRwRAfaMv",
    title: "hidden letter k and s h calligraphy",
    list_url: "/styles/minimalist/hidden-letter-k-and-s-h-calligraphy"
  },
  {
    url: "/styles/minimalist/marine-engineer-XyC8bfZ9gPUz1QDjdSPNwg",
    title: "marine engineer",
    list_url: "/styles/minimalist/marine-engineer"
  },
  {
    url: "/styles/minimalist/starry-night-wind-by-van-gogh-black-and-9xxHJXHmg8aSQyETVmzEfe",
    title: "starry night wind by van gogh black and",
    list_url: "/styles/minimalist/starry-night-wind-by-van-gogh-black-and"
  },
  {
    url: "/styles/minimalist/tinkerbell-L5Y14nqL9NeV3uwBaf7Hbv",
    title: "tinkerbell",
    list_url: "/styles/minimalist/tinkerbell"
  },
  {
    url: "/styles/neotraditional/gianna-michaels-5zSQK6qZwDRGbxeSwLBAap",
    title: "gianna michaels",
    list_url: "/styles/neotraditional/gianna-michaels"
  },
  {
    url: "/styles/neotraditional/karla-lane-wearing-a-mexican-flag-UF1TgBXV5wdPtW7TUU19cQ",
    title: "karla lane wearing a mexican flag",
    list_url: "/styles/neotraditional/karla-lane-wearing-a-mexican-flag"
  },
  {
    url: "/styles/neotraditional/saint-anthony-3p2XkLHfBwQBGKrkFCGwdT",
    title: "saint anthony",
    list_url: "/styles/neotraditional/saint-anthony"
  },
  {
    url: "/styles/realism/forearm-design-with-names-sonu-JssQcTy2YmMRVntu9kJ3WY",
    title: "forearm design with names sonu",
    list_url: "/styles/realism/forearm-design-with-names-sonu"
  },
  {
    url: "/styles/realism/viking-dad-and-son-DKeEqZpEmKSPFpZoe4BTvJ",
    title: "viking dad and son",
    list_url: "/styles/realism/viking-dad-and-son"
  },
  {
    url: "/styles/traditional/a-seven-of-spades-and-a-two-of-diamonds-N8DeQuReukPDwts1qxoRvX",
    title: "a seven of spades and a two of diamonds",
    list_url: "/styles/traditional/a-seven-of-spades-and-a-two-of-diamonds"
  },
  {
    url: "/styles/black-grey/you-are-my-7-minutes-W2z2PdEXfH8LVGLzDjz6Mi",
    title: "you are my minutes",
    list_url: "/styles/black-grey/you-are-my-7-minutes"
  },
  {
    url: "/styles/blackwork/pisces-with-taurus-BaUzoAk4jzkcCNaPJ5oz2H",
    title: "pisces with taurus",
    list_url: "/styles/blackwork/pisces-with-taurus"
  },
  {
    url: "/styles/blackwork/tbs-13-DRG9NWUHhcLdrtENZg1QLC",
    title: "tbs ",
    list_url: "/styles/blackwork/tbs-13"
  },
  {
    url: "/styles/dotwork/navya-NTnjVo9dCB2BeKKhxZPhoK",
    title: "navya",
    list_url: "/styles/dotwork/navya"
  },
  {
    url: "/styles/dotwork/priya-name-SaqVHYdn43xyvMGod2s2EX",
    title: "priya name",
    list_url: "/styles/dotwork/priya-name"
  },
  {
    url: "/styles/dotwork/shravani-in-kannada-font-A4C4a8pQyqU7ExArz4i1BC",
    title: "shravani in kannada font",
    list_url: "/styles/dotwork/shravani-in-kannada-font"
  },
  {
    url: "/styles/dotwork/the-name-srinivas-with-minimal-design-P9J3MJCvNH2HUdWbNuqRMf",
    title: "the name srinivas with minimal design",
    list_url: "/styles/dotwork/the-name-srinivas-with-minimal-design"
  },
  {
    url: "/styles/japanese/bdsm-CpEagnqhJ9S9x4pur97rEw",
    title: "bdsm",
    list_url: "/styles/japanese/bdsm"
  },
  {
    url: "/styles/minimalist/be-where-your-feet-are-MUNMeFwgB5t6TEsWv2H7cG",
    title: "be where your feet are",
    list_url: "/styles/minimalist/be-where-your-feet-are"
  },
  {
    url: "/styles/minimalist/flowers-growing-in-a-valley-with-a-N3MU7QXmPfzKGmNLT2ZAWX",
    title: "flowers growing in a valley with a",
    list_url: "/styles/minimalist/flowers-growing-in-a-valley-with-a"
  },
  {
    url: "/styles/minimalist/god-is-my-oath-SiX3m9XYvGxsipx69Pa8uH",
    title: "god is my oath",
    list_url: "/styles/minimalist/god-is-my-oath"
  },
  {
    url: "/styles/minimalist/heart-and-letter-c-Lm9Nd4bf5sMFh3QPbxMBu1",
    title: "heart and letter c",
    list_url: "/styles/minimalist/heart-and-letter-c"
  },
  {
    url: "/styles/neotraditional/devil-and-angel-whispering-neck-tattoo-JgqMhZpobLEkiFbDcRLjyq",
    title: "devil and angel whispering neck tattoo",
    list_url: "/styles/neotraditional/devil-and-angel-whispering-neck-tattoo"
  },
  {
    url: "/styles/realism/alexis-texas-in-micro-bikini-Vsd6gqrjMZ1Ja2yTWx6JZ2",
    title: "alexis texas in micro bikini",
    list_url: "/styles/realism/alexis-texas-in-micro-bikini"
  },
  {
    url: "/styles/realism/sayan-name-unique-logo-with-transparent-43VGsS2eLvBSvP1czS1oEU",
    title: "sayan name unique logo with transparent",
    list_url: "/styles/realism/sayan-name-unique-logo-with-transparent"
  },
  {
    url: "/styles/sketch/kaal-bhairav-BH7JrU5oidLqa3wW5wfABV",
    title: "kaal bhairav",
    list_url: "/styles/sketch/kaal-bhairav"
  },
  {
    url: "/styles/sketch/route-66-sign-with-old-time-gas-pump-Na25gFhfBKwKpyUB7oESuT",
    title: "route sign with old time gas pump",
    list_url: "/styles/sketch/route-66-sign-with-old-time-gas-pump"
  },
  {
    url: "/styles/traditional/brahma-vishnu-mahesh-symbol-od6Hq7qayt6v8TJ2ByYB6",
    title: "brahma vishnu mahesh symbol",
    list_url: "/styles/traditional/brahma-vishnu-mahesh-symbol"
  },
  {
    url: "/styles/tribal/charrua-natives-of-uruguay-RrdWaDGVPfvXojyYTZEppa",
    title: "charrua natives of uruguay",
    list_url: "/styles/tribal/charrua-natives-of-uruguay"
  },
  {
    url: "/styles/black-grey/224-in-a-girly-font-and-a-small-design-JQiB1K4WErhd3LosDb3g7q",
    title: " in a girly font and a small design",
    list_url: "/styles/black-grey/224-in-a-girly-font-and-a-small-design"
  },
  {
    url: "/styles/black-grey/a-baseball-son-and-father-XwRapzso4rTeBvAH91RMLR",
    title: "a baseball son and father",
    list_url: "/styles/black-grey/a-baseball-son-and-father"
  },
  {
    url: "/styles/blackwork/the-letter-m-mana-omega-VTSURkxv8deD3J1mYLHvEg",
    title: "the letter m mana omega",
    list_url: "/styles/blackwork/the-letter-m-mana-omega"
  },
  {
    url: "/styles/dotwork/little-singham-lion-KtUt5qyiJ9S6gU1AGW8ERW",
    title: "little singham lion",
    list_url: "/styles/dotwork/little-singham-lion"
  },
  {
    url: "/styles/dotwork/polish-symbol-for-family-DNcAsVxTZnH1ZsuuRMEv9f",
    title: "polish symbol for family",
    list_url: "/styles/dotwork/polish-symbol-for-family"
  },
  {
    url: "/styles/dotwork/quit-smoking-weed-RLb5kNouFsw4qzSQvzgGg4",
    title: "quit smoking weed",
    list_url: "/styles/dotwork/quit-smoking-weed"
  },
  {
    url: "/styles/dotwork/sneha-name-tattoo-UhFk4hddJWokYQs8H34Qj4",
    title: "sneha name tattoo",
    list_url: "/styles/dotwork/sneha-name-tattoo"
  },
  {
    url: "/styles/dotwork/ttw-asm-karn-w-baryyn-tlfyqy-STF59PiRzZHsc2ujwnkCVS",
    title: "ttw asm karn w baryyn tlfyqy",
    list_url: "/styles/dotwork/ttw-asm-karn-w-baryyn-tlfyqy"
  },
  {
    url: "/styles/japanese/father-with-son-BjX96uYkNWTrcSz6tui7bF",
    title: "father with son",
    list_url: "/styles/japanese/father-with-son"
  },
  {
    url: "/styles/japanese/name-vamika-in-sanskrit-UophTPNCcpq6o7mRzemkyK",
    title: "name vamika in sanskrit",
    list_url: "/styles/japanese/name-vamika-in-sanskrit"
  },
  {
    url: "/styles/minimalist/only-3-letters-handwritten-with-a-Fxqzuzt2jEbV9KqjtGPd5d",
    title: "only letters handwritten with a",
    list_url: "/styles/minimalist/only-3-letters-handwritten-with-a"
  },
  {
    url: "/styles/neotraditional/archana-name-hidden-in-tatto-design-of-8m4RoAeki6N75w6fdNpWMx",
    title: "archana name hidden in tatto design of",
    list_url: "/styles/neotraditional/archana-name-hidden-in-tatto-design-of"
  },
  {
    url: "/styles/neotraditional/gopi-name-tattoo-design-PiRRCHy7QfCzFx5LDkGYYQ",
    title: "gopi name tattoo design",
    list_url: "/styles/neotraditional/gopi-name-tattoo-design"
  },
  {
    url: "/styles/neotraditional/queen-of-spades-EiPpJBJJboNJQwEdw9nveS",
    title: "queen of spades",
    list_url: "/styles/neotraditional/queen-of-spades"
  },
  {
    url: "/styles/realism/300-spartans-Dus9AEgWe4AwGNZK9bgzw9",
    title: " spartans",
    list_url: "/styles/realism/300-spartans"
  },
  {
    url: "/styles/realism/shiva-nataraja-ScUuVyeLsGC7qW4cCqZEEB",
    title: "shiva nataraja",
    list_url: "/styles/realism/shiva-nataraja"
  },
  {
    url: "/styles/sketch/mia-khalifa-2tASPJRZycdWhFqFeCyJEg",
    title: "mia khalifa",
    list_url: "/styles/sketch/mia-khalifa"
  },
  {
    url: "/styles/stencil/music-notes-with-flowers-DoQVBaEF4CDPtgkjaRvMr7",
    title: "music notes with flowers",
    list_url: "/styles/stencil/music-notes-with-flowers"
  },
  {
    url: "/styles/traditional/bad-bitch-XUqi5NFRjzxjrD1jo2SdB1",
    title: "bad bitch",
    list_url: "/styles/traditional/bad-bitch"
  },
  {
    url: "/styles/traditional/finnish-3vBgdCyEWQTD8MyyHWuU6n",
    title: "finnish",
    list_url: "/styles/traditional/finnish"
  },
  {
    url: "/styles/traditional/mind-over-matter-text-only-5XmTpyED51RKA9S1viVgbQ",
    title: "mind over matter text only",
    list_url: "/styles/traditional/mind-over-matter-text-only"
  },
  {
    url: "/styles/horror",
    title: "horror",
    list_url: "/styles/horror"
  },
  {
    url: "/styles/japanese/pokemon-6NdjV3fiDS3a8KqPvDWGMS",
    title: "pokemon",
    list_url: "/styles/japanese/pokemon"
  },
  {
    url: "/styles/japanese/the-inscription-metsuki-sutemi-M4q25EUTW7Uj1Z65TthGDM",
    title: "the inscription metsuki sutemi",
    list_url: "/styles/japanese/the-inscription-metsuki-sutemi"
  },
  {
    url: "/styles/minimalist/2010-honda-activa-moped-parked-in-HcBo82KRyEGC7xkgcrwtvt",
    title: " honda activa moped parked in",
    list_url: "/styles/minimalist/2010-honda-activa-moped-parked-in"
  },
  {
    url: "/styles/minimalist/7-days-of-creation-represented-in-MvjAPnL6EtgqxyUvDX6sJ",
    title: " days of creation represented in",
    list_url: "/styles/minimalist/7-days-of-creation-represented-in"
  },
  {
    url: "/styles/minimalist/master-of-the-mind-wolf-face-ASZ8622PnECAMXjR2PuBKT",
    title: "master of the mind wolf face",
    list_url: "/styles/minimalist/master-of-the-mind-wolf-face"
  },
  {
    url: "/styles/minimalist/never-again-7tyqa43KQEEJdMTCYrXQe6",
    title: "never again",
    list_url: "/styles/minimalist/never-again"
  },
  {
    url: "/styles/neotraditional/my-guilt-will-not-purify-me-MYm1Rb4UWj7vxC4LXEpb2q",
    title: "my guilt will not purify me",
    list_url: "/styles/neotraditional/my-guilt-will-not-purify-me"
  },
  {
    url: "/styles/realism/demon-whispering-in-my-ear-A6wEg98UfQ6Ai3SJGWnJJS",
    title: "demon whispering in my ear",
    list_url: "/styles/realism/demon-whispering-in-my-ear"
  },
  {
    url: "/styles/realism/sunflower-with-hummingbird-6LRUEP1B4jGm1jm4NS5vDS",
    title: "sunflower with hummingbird",
    list_url: "/styles/realism/sunflower-with-hummingbird"
  },
  {
    url: "/styles/sketch/lalitha-devi-with-four-hands-with-a-SwuxtNFfat2wKBRAcsKN59",
    title: "lalitha devi with four hands with a",
    list_url: "/styles/sketch/lalitha-devi-with-four-hands-with-a"
  },
  {
    url: "/styles/sketch/letter-a-with-rose-Amkh7BovPMCcoALmdwrqoS",
    title: "letter a with rose",
    list_url: "/styles/sketch/letter-a-with-rose"
  },
  {
    url: "/styles/sketch/xxx-tentacion-poison-tree-with-999-WHm13NS43CLHA3rKDYFiBX",
    title: "xxx tentacion poison tree with ",
    list_url: "/styles/sketch/xxx-tentacion-poison-tree-with-999"
  },
  {
    url: "/styles/surrealism/dad-with-his-two-daughters-holding-PaeWjhgkiN9NyFwoE5JrKx",
    title: "dad with his two daughters holding",
    list_url: "/styles/surrealism/dad-with-his-two-daughters-holding"
  },
  {
    url: "/styles/traditional/gullah-geechee-people-of-south-9Ejci8jhDWE3D3FB62xKgD",
    title: "gullah geechee people of south",
    list_url: "/styles/traditional/gullah-geechee-people-of-south"
  },
  {
    url: "/styles/traditional/jesus-on-a-cross-with-the-words-deus-Dwb76c8grf6ejeW95dBMhj",
    title: "jesus on a cross with the words deus",
    list_url: "/styles/traditional/jesus-on-a-cross-with-the-words-deus"
  },
  {
    url: "/styles/black-grey/dominatrix-pin-up-in-latex-clad-XSR6X6k741MkoMKSQV9je1",
    title: "dominatrix pin up in latex clad",
    list_url: "/styles/black-grey/dominatrix-pin-up-in-latex-clad"
  },
  {
    url: "/styles/black-grey/klu-klux-klan-T9pfBHJbGgv3LefRssHcCS",
    title: "klu klux klan",
    list_url: "/styles/black-grey/klu-klux-klan"
  },
  {
    url: "/styles/black-grey/ocean-theme-leg-sleeve-8JRiph3Adciatmch5haBtB",
    title: "ocean theme leg sleeve",
    list_url: "/styles/black-grey/ocean-theme-leg-sleeve"
  },
  {
    url: "/styles/blackwork/aadi-name-tattoo-design-My83L4e7qCEfAN7SEzU5HB",
    title: "aadi name tattoo design",
    list_url: "/styles/blackwork/aadi-name-tattoo-design"
  },
  {
    url: "/styles/blackwork/male-chastity-and-keyholder-devotion-WXjdED8EPQ7XHJEuJX34Cg",
    title: "male chastity and keyholder devotion",
    list_url: "/styles/blackwork/male-chastity-and-keyholder-devotion"
  },
  {
    url: "/styles/blackwork/rose-with-name-sushmita-ENoMb8cDh11M1CJNy3qrG1",
    title: "rose with name sushmita",
    list_url: "/styles/blackwork/rose-with-name-sushmita"
  },
  {
    url: "/styles/dotwork/god-venkateshwara-swamy-AqXT3XBRPqMueQ7uDPeL7G",
    title: "god venkateshwara swamy",
    list_url: "/styles/dotwork/god-venkateshwara-swamy"
  },
  {
    url: "/styles/dotwork/manthan-name-tattoo-VDay3QC8uXtSXTcPey9xg8",
    title: "manthan name tattoo",
    list_url: "/styles/dotwork/manthan-name-tattoo"
  },
  {
    url: "/styles/japanese/fame-elbow-GaR39CpcvbMsmHFL5ABqZN",
    title: "fame elbow",
    list_url: "/styles/japanese/fame-elbow"
  },
  {
    url: "/styles/minimalist/flowers-with-sun-moon-and-sea-turtle-KpwqugiUUhxD1HooTTboSM",
    title: "flowers with sun moon and sea turtle",
    list_url: "/styles/minimalist/flowers-with-sun-moon-and-sea-turtle"
  },
  {
    url: "/styles/minimalist/guatemala-E82Ai5QZp9xNiajgATv5MF",
    title: "guatemala",
    list_url: "/styles/minimalist/guatemala"
  },
  {
    url: "/styles/minimalist/sonder-JyUALtCFo7EA3tSnDRQY4a",
    title: "sonder",
    list_url: "/styles/minimalist/sonder"
  },
  {
    url: "/styles/minimalist/wifes-name-richa-EghPLTA5Grt7pCiZ75y21D",
    title: "wifes name richa",
    list_url: "/styles/minimalist/wifes-name-richa"
  },
  {
    url: "/styles/neotraditional/australian-native-flowers-birth-month-DHQaFkCpM6NEiUNqukoYS2",
    title: "australian native flowers birth month",
    list_url: "/styles/neotraditional/australian-native-flowers-birth-month"
  },
  {
    url: "/styles/neotraditional/combined-zodiac-signs-FBL3yfkT52pytciwHBqiT4",
    title: "combined zodiac signs",
    list_url: "/styles/neotraditional/combined-zodiac-signs"
  },
  {
    url: "/styles/neotraditional/daddys-whore-TXFs8TdtPXEcCw3n1SGjFX",
    title: "daddys whore",
    list_url: "/styles/neotraditional/daddys-whore"
  },
  {
    url: "/styles/neotraditional/feather-with-name-K9kLEbAwh8d7sryJDyPYVK",
    title: "feather with name",
    list_url: "/styles/neotraditional/feather-with-name"
  },
  {
    url: "/styles/realism/adolf-hitler-VUhuhASmEguTKo8fkpLPeR",
    title: "adolf hitler",
    list_url: "/styles/realism/adolf-hitler"
  },
  {
    url: "/styles/realism/wolf-chest-NGaxzMJYduWFC2yv1F8onZ",
    title: "wolf chest",
    list_url: "/styles/realism/wolf-chest"
  },
  {
    url: "/styles/sketch/roman-numeral-3-GnBcsD4ZQc1rh9oAPWcwkU",
    title: "roman numeral ",
    list_url: "/styles/sketch/roman-numeral-3"
  },
  {
    url: "/styles/sketch/speedometer-XrceoVQuFXWynn28JHCXqx",
    title: "speedometer",
    list_url: "/styles/sketch/speedometer"
  },
  {
    url: "/styles/sketch/st-michael-sword-one-angel-wing-BkVZmjTeieToEzJaN2gkzW",
    title: "st michael sword one angel wing",
    list_url: "/styles/sketch/st-michael-sword-one-angel-wing"
  },
  {
    url: "/styles/stencil/poison-tree-VzDw62yZ6bKynUAGPoUhMA",
    title: "poison tree",
    list_url: "/styles/stencil/poison-tree"
  },
  {
    url: "/styles/stencil/xxxcixc-5FtEz2J4v2DvVoUAq9aSgh",
    title: "xxxcixc",
    list_url: "/styles/stencil/xxxcixc"
  },
  {
    url: "/styles/traditional/comanche-FcoEJkM6nyrw2bSBrAmjie",
    title: "comanche",
    list_url: "/styles/traditional/comanche"
  },
  {
    url: "/styles/tribal/brahma-vishnu-mahesh-symbol-A4P9as8aF9VqVniX2vHB7G",
    title: "brahma vishnu mahesh symbol",
    list_url: "/styles/tribal/brahma-vishnu-mahesh-symbol"
  },
  {
    url: "/styles/tribal/quote-you-only-live-once-4Gmf36A9RQYUUSQp7T3YyY",
    title: "quote you only live once",
    list_url: "/styles/tribal/quote-you-only-live-once"
  },
  {
    url: "/styles/black-grey/daffodil-for-men-UYZFNrgbygTn5pw83vT1p9",
    title: "daffodil for men",
    list_url: "/styles/black-grey/daffodil-for-men"
  },
  {
    url: "/styles/black-grey/hawaiian-flower-for-men-Fe9zuVcXyVqcgZBLZAYjPU",
    title: "hawaiian flower for men",
    list_url: "/styles/black-grey/hawaiian-flower-for-men"
  },
  {
    url: "/styles/blackwork/metro-2033-334ULB2ujHokYbfYGR7uPA",
    title: "metro ",
    list_url: "/styles/blackwork/metro-2033"
  },
  {
    url: "/styles/blackwork/strength-and-honor-5nFJEG9Bfj2vx88NERaqJ7",
    title: "strength and honor",
    list_url: "/styles/blackwork/strength-and-honor"
  },
  {
    url: "/styles/blackwork/tai-lung-AfD61RiZaiZiVUkhg88uGe",
    title: "tai lung",
    list_url: "/styles/blackwork/tai-lung"
  },
  {
    url: "/styles/dotwork/pranay-name-3WbLcUetfpVETu4xPzH1Rb",
    title: "pranay name",
    list_url: "/styles/dotwork/pranay-name"
  },
  {
    url: "/styles/dotwork/puli-for-tiger-28WwjBKTSc4kMn9LrtLdGU",
    title: "puli for tiger",
    list_url: "/styles/dotwork/puli-for-tiger"
  },
  {
    url: "/styles/japanese/ichigo-ichie-in-calligraphy-with-cherry-BCxQd1uye2DJLMKgShCgp1",
    title: "ichigo ichie in calligraphy with cherry",
    list_url: "/styles/japanese/ichigo-ichie-in-calligraphy-with-cherry"
  },
  {
    url: "/styles/japanese/troll-face-meme-8ANg23UQFFzMkvjwyqZCjK",
    title: "troll face meme",
    list_url: "/styles/japanese/troll-face-meme"
  },
  {
    url: "/styles/minimalist/aries-x-sagittarius-Pja4nLZ3GPzn5FbjQedBjb",
    title: "aries x sagittarius",
    list_url: "/styles/minimalist/aries-x-sagittarius"
  },
  {
    url: "/styles/minimalist/birth-month-flowers-fine-line-tattoo-8njDK8br56rhdpUNzvgdn1",
    title: "birth month flowers fine line tattoo",
    list_url: "/styles/minimalist/birth-month-flowers-fine-line-tattoo"
  },
  {
    url: "/styles/minimalist/leo-and-aquarius-zodiac-signs-9WSg3Rgj3Pi29QMwJM6Vsr",
    title: "leo and aquarius zodiac signs",
    list_url: "/styles/minimalist/leo-and-aquarius-zodiac-signs"
  },
  {
    url: "/styles/minimalist/man-performing-cunnilingus-on-a-woman-ETZMsZ844hbjD8HiBJx99i",
    title: "man performing cunnilingus on a woman",
    list_url: "/styles/minimalist/man-performing-cunnilingus-on-a-woman"
  },
  {
    url: "/styles/minimalist/maya-name-in-different-language-VcQU3UFURjH5YEALG9uyBd",
    title: "maya name in different language",
    list_url: "/styles/minimalist/maya-name-in-different-language"
  },
  {
    url: "/styles/minimalist/simple-hidden-tattoo-with-name-kiran-25FupoKrjmqdXtAadAiXnd",
    title: "simple hidden tattoo with name kiran",
    list_url: "/styles/minimalist/simple-hidden-tattoo-with-name-kiran"
  },
  {
    url: "/styles/minimalist/star-wars-RmAh6AsMaRcRzQj6CqFtFw",
    title: "star wars",
    list_url: "/styles/minimalist/star-wars"
  },
  {
    url: "/styles/minimalist/still-waters-run-deep-Lh89DbqiBYxQ2B2zHXsMHP",
    title: "still waters run deep",
    list_url: "/styles/minimalist/still-waters-run-deep"
  },
  {
    url: "/styles/neotraditional/ccxxiv-Q58SFXYVcFw3QJmBatWSTZ",
    title: "ccxxiv",
    list_url: "/styles/neotraditional/ccxxiv"
  },
  {
    url: "/styles/neotraditional/kriti-name-JWNQV2eDXos5dnjPvcDdhy",
    title: "kriti name",
    list_url: "/styles/neotraditional/kriti-name"
  },
  {
    url: "/styles/neotraditional/lokesh-name-B8c2U5VvJtzxDzoY8GYvJA",
    title: "lokesh name",
    list_url: "/styles/neotraditional/lokesh-name"
  },
  {
    url: "/styles/neotraditional/nun-with-a-gun-NQauMTcWaqyKr14qbXKrzR",
    title: "nun with a gun",
    list_url: "/styles/neotraditional/nun-with-a-gun"
  },
  {
    url: "/styles/neotraditional/slut-AA8eMHhaJ5BZeyoPfJsigm",
    title: "slut",
    list_url: "/styles/neotraditional/slut"
  },
  {
    url: "/styles/neotraditional/viraj-name-with-crown-QvchNJD8LVttXPkADMNQtK",
    title: "viraj name with crown",
    list_url: "/styles/neotraditional/viraj-name-with-crown"
  },
  {
    url: "/styles/neotraditional/woman-with-ball-gag-in-her-mouth-6jcX86jiUGms7LxDHUCJpJ",
    title: "woman with ball gag in her mouth",
    list_url: "/styles/neotraditional/woman-with-ball-gag-in-her-mouth"
  },
  {
    url: "/styles/realism/baobab-tree-CfoLFU62QgxEqgdWFao7kd",
    title: "baobab tree",
    list_url: "/styles/realism/baobab-tree"
  },
  {
    url: "/styles/realism/letter-a-with-roses-D9ByySbZLi1sLhmRsKRGaR",
    title: "letter a with roses",
    list_url: "/styles/realism/letter-a-with-roses"
  },
  {
    url: "/styles/realism/saint-michael-patron-saint-of-police-J9gk3pVzTCvKgNTTuxPUdZ",
    title: "saint michael patron saint of police",
    list_url: "/styles/realism/saint-michael-patron-saint-of-police"
  },
  {
    url: "/styles/stencil/qos-bbc-blacked-VRYBrDTBVPJkCENAPoD1wE",
    title: "qos bbc blacked",
    list_url: "/styles/stencil/qos-bbc-blacked"
  },
  {
    url: "/styles/traditional/kidney-BN3opEA2u9v6xdeofxQu3o",
    title: "kidney",
    list_url: "/styles/traditional/kidney"
  },
  {
    url: "/styles/black-grey/bnwo-ownership-qos-51k6dvX3YLVSbWL5H1vgcU",
    title: "bnwo ownership qos",
    list_url: "/styles/black-grey/bnwo-ownership-qos"
  },
  {
    url: "/styles/black-grey/gothic-couple-tattoos-D6L4DwKWsB2M2YmU4ijSkB",
    title: "gothic couple tattoos",
    list_url: "/styles/black-grey/gothic-couple-tattoos"
  },
  {
    url: "/styles/black-grey/imminence-band-lyrics-symbolized-8gd8qX9fCM9ujWvvgJhQ7p",
    title: "imminence band lyrics symbolized",
    list_url: "/styles/black-grey/imminence-band-lyrics-symbolized"
  },
  {
    url: "/styles/black-grey/letter-mk-VgSLSNGnXymWUCyVBfYP6j",
    title: "letter mk",
    list_url: "/styles/black-grey/letter-mk"
  },
  {
    url: "/styles/black-grey/venom-6ymZPSsNpkcJQgpJFC8chX",
    title: "venom",
    list_url: "/styles/black-grey/venom"
  },
  {
    url: "/styles/blackwork/cover-up-for-444-tattoo-XsQ1AeMfhwSG8RvCyYggJh",
    title: "cover up for tattoo",
    list_url: "/styles/blackwork/cover-up-for-444-tattoo"
  },
  {
    url: "/styles/blackwork/pornstar-tattoo-JybjtvHjAK8nxWzyomWUJJ",
    title: "pornstar tattoo",
    list_url: "/styles/blackwork/pornstar-tattoo"
  },
  {
    url: "/styles/blackwork/the-bible-verse-1-corinthians-1313-V5A956ZzE7zTfRendPoTAm",
    title: "the bible verse corinthians ",
    list_url: "/styles/blackwork/the-bible-verse-1-corinthians-1313"
  },
  {
    url: "/styles/blackwork/wolf-couple-tattoos-EELMmKckrVrGHse6HgQMLN",
    title: "wolf couple tattoos",
    list_url: "/styles/blackwork/wolf-couple-tattoos"
  },
  {
    url: "/styles/dotwork/acta-non-verba-HYE2SchHr8eayoXp98LWe5",
    title: "acta non verba",
    list_url: "/styles/dotwork/acta-non-verba"
  },
  {
    url: "/styles/dotwork/paw-prints-butterfly-WczF21uNoG2a3MYiZryDCk",
    title: "paw prints butterfly",
    list_url: "/styles/dotwork/paw-prints-butterfly"
  },
  {
    url: "/styles/dotwork/xiixxxmmiv-3u8sSsZvUhHkGWPXG13NaZ",
    title: "xiixxxmmiv",
    list_url: "/styles/dotwork/xiixxxmmiv"
  },
  {
    url: "/styles/geometric/godsmack-sun-symbol-6sRbpukkAFwroxTKvxVHLY",
    title: "godsmack sun symbol",
    list_url: "/styles/geometric/godsmack-sun-symbol"
  },
  {
    url: "/styles/japanese/asian-style-shoulder-tattoo-men-5BWd9tox98oG3LJPfdibHK",
    title: "asian style shoulder tattoo men",
    list_url: "/styles/japanese/asian-style-shoulder-tattoo-men"
  },
  {
    url: "/styles/japanese/tiger-and-samurai-M6rX2k6G6yxFAxPRbGmr6d",
    title: "tiger and samurai",
    list_url: "/styles/japanese/tiger-and-samurai"
  },
  {
    url: "/styles/minimalist/ad-vitam-aeternam-24stt9T5NZvthr6qvVRMUy",
    title: "ad vitam aeternam",
    list_url: "/styles/minimalist/ad-vitam-aeternam"
  },
  {
    url: "/styles/minimalist/arrow-with-roman-numeral-birthday-date-L6Gt3CSiyT2sRnSPksgXK5",
    title: "arrow with roman numeral birthday date",
    list_url: "/styles/minimalist/arrow-with-roman-numeral-birthday-date"
  },
  {
    url: "/styles/minimalist/bdsm-Ru7ws1oEWGzFQpg3c2mb12",
    title: "bdsm",
    list_url: "/styles/minimalist/bdsm"
  },
  {
    url: "/styles/minimalist/dota-2-4j9wxTwJHCZ2xzzF38siLo",
    title: "dota ",
    list_url: "/styles/minimalist/dota-2"
  },
  {
    url: "/styles/minimalist/drone-SSUeGrbyb8XxCa5aKyQBMt",
    title: "drone",
    list_url: "/styles/minimalist/drone"
  },
  {
    url: "/styles/minimalist/mohan-name-written-in-hindi-in-the-7yVvce5yjsTyPVrvbbatAZ",
    title: "mohan name written in hindi in the",
    list_url: "/styles/minimalist/mohan-name-written-in-hindi-in-the"
  },
  {
    url: "/styles/neotraditional/sissy-bbc-logo-B6b83HVExQbCeKBcbfBZw",
    title: "sissy bbc logo",
    list_url: "/styles/neotraditional/sissy-bbc-logo"
  },
  {
    url: "/styles/neotraditional/text-im-your-whore-92cS54FY951fuAhpUnRwHs",
    title: "text im your whore",
    list_url: "/styles/neotraditional/text-im-your-whore"
  },
  {
    url: "/styles/realism/marines-usmc-AM7ExincWnfbdxgeCx6tkN",
    title: "marines usmc",
    list_url: "/styles/realism/marines-usmc"
  },
  {
    url: "/styles/sketch/lily-of-the-valley-and-hawthorn-flower-nNSvaUzhkwBjvQix9h113",
    title: "lily of the valley and hawthorn flower",
    list_url: "/styles/sketch/lily-of-the-valley-and-hawthorn-flower"
  },
  {
    url: "/styles/traditional/a-lambretta-scooter-with-a-northern-Xvba4FgK8JGckbp62pA65L",
    title: "a lambretta scooter with a northern",
    list_url: "/styles/traditional/a-lambretta-scooter-with-a-northern"
  },
  {
    url: "/styles/tribal/gladiolus-flower-T65CcnCyo3aTNt2R1zothL",
    title: "gladiolus flower",
    list_url: "/styles/tribal/gladiolus-flower"
  },
  {
    url: "/styles/tribal/tattoo-word-milele-meaning-of-eternity-4r8nnjr58cq8cegFYjxDZL",
    title: "tattoo word milele meaning of eternity",
    list_url: "/styles/tribal/tattoo-word-milele-meaning-of-eternity"
  },
  {
    url: "/styles/black-grey/bald-gay-muscle-bear-with-a-belly-Ae223kBtfXkEJizEvSLKWo",
    title: "bald gay muscle bear with a belly",
    list_url: "/styles/black-grey/bald-gay-muscle-bear-with-a-belly"
  },
  {
    url: "/styles/black-grey/sonia-name-tattoo-LXGtRd7Z9ZabHeeNjLKEMN",
    title: "sonia name tattoo",
    list_url: "/styles/black-grey/sonia-name-tattoo"
  },
  {
    url: "/styles/blackwork/airplane-compass-XLaRbHNCvGfuiNndgVu1LJ",
    title: "airplane compass",
    list_url: "/styles/blackwork/airplane-compass"
  },
  {
    url: "/styles/blackwork/boys-anus-FQLWmbatMwihhqkNJZ2t1H",
    title: "boys anus",
    list_url: "/styles/blackwork/boys-anus"
  },
  {
    url: "/styles/dotwork/cancer-and-libra-4GhSyfHw1SAagHhyVZyJSx",
    title: "cancer and libra",
    list_url: "/styles/dotwork/cancer-and-libra"
  },
  {
    url: "/styles/dotwork/chicano-letters-3sitXoGoFjiJnLpWx86Dyy",
    title: "chicano letters",
    list_url: "/styles/dotwork/chicano-letters"
  },
  {
    url: "/styles/dotwork/hidden-r-letter-UMuK42bfuFLA3QzWNYFBCw",
    title: "hidden r letter",
    list_url: "/styles/dotwork/hidden-r-letter"
  },
  {
    url: "/styles/dotwork/i-am-wrath-i-am-a-steel-i-am-the-3SpfoiZsM1n9PwKuB4hpRb",
    title: "i am wrath i am a steel i am the",
    list_url: "/styles/dotwork/i-am-wrath-i-am-a-steel-i-am-the"
  },
  {
    url: "/styles/dotwork/tattoo-with-names-soham-and-asmita-8ZcH8kmy3zpkn9yJja8tu7",
    title: "tattoo with names soham and asmita",
    list_url: "/styles/dotwork/tattoo-with-names-soham-and-asmita"
  },
  {
    url: "/styles/geometric/taurus-QZXNJApHYXJKtkspuKFuQx",
    title: "taurus",
    list_url: "/styles/geometric/taurus"
  },
  {
    url: "/styles/japanese/cherry-blossom-with-a-phoenix-HfENar3kNdBRpM8zx7UfH8",
    title: "cherry blossom with a phoenix",
    list_url: "/styles/japanese/cherry-blossom-with-a-phoenix"
  },
  {
    url: "/styles/minimalist/five-elements-of-nature-inspired-tattoo-MVsP44kJTFKMM6T3NpeHTi",
    title: "five elements of nature inspired tattoo",
    list_url: "/styles/minimalist/five-elements-of-nature-inspired-tattoo"
  },
  {
    url: "/styles/minimalist/hidden-letter-m-and-d-hidden-Jz5NMxhYuHiw4RoVUEDpi1",
    title: "hidden letter m and d hidden",
    list_url: "/styles/minimalist/hidden-letter-m-and-d-hidden"
  },
  {
    url: "/styles/minimalist/preeti-JkFSbvxe7nLUw6N91W2dP3",
    title: "preeti",
    list_url: "/styles/minimalist/preeti"
  },
  {
    url: "/styles/neotraditional/rishi-name-tattoo-KdWVJPTmRmzv4gcCByvSYz",
    title: "rishi name tattoo",
    list_url: "/styles/neotraditional/rishi-name-tattoo"
  },
  {
    url: "/styles/neotraditional/slut-bbc-only-UKMa4Nz2rDk17s2XantPfC",
    title: "slut bbc only",
    list_url: "/styles/neotraditional/slut-bbc-only"
  },
  {
    url: "/styles/realism/name-komal-and-prajyot-Fi5bncrGvVVt9mL7fsyQGr",
    title: "name komal and prajyot",
    list_url: "/styles/realism/name-komal-and-prajyot"
  },
  {
    url: "/styles/sketch/forbidden-love-9vy65JRDgPrhRgZ5WqWu6z",
    title: "forbidden love",
    list_url: "/styles/sketch/forbidden-love"
  },
  {
    url: "/styles/sketch/hibiscus-flower-and-butterflies-HFisATPS52uTkRhrgq2vDT",
    title: "hibiscus flower and butterflies",
    list_url: "/styles/sketch/hibiscus-flower-and-butterflies"
  },
  {
    url: "/styles/traditional/1977-7Jd4QvBWV4gPT37vpsrvYb",
    title: "1997",
    list_url: "/styles/traditional/1977"
  },
  {
    url: "/styles/black-grey/angel-wings-with-the-letter-b-memorial-DW5r41jUeSm3fZfhK3yEFG",
    title: "angel wings with the letter b memorial",
    list_url: "/styles/black-grey/angel-wings-with-the-letter-b-memorial"
  },
  {
    url: "/styles/black-grey/cathedral-window-GCZ5q7r2kLr1jqgiFr31wy",
    title: "cathedral window",
    list_url: "/styles/black-grey/cathedral-window"
  },
  {
    url: "/styles/black-grey/father-with-3-sons-siluet-one-on-dads-2PpfU2P1rNzGhRmfGLGkMJ",
    title: "father with sons siluet one on dads",
    list_url: "/styles/black-grey/father-with-3-sons-siluet-one-on-dads"
  },
  {
    url: "/styles/black-grey/lacrosse-NjKmxqUK5E9TBZCZgXs62A",
    title: "lacrosse",
    list_url: "/styles/black-grey/lacrosse"
  },
  {
    url: "/styles/black-grey/overlapping-letters-d-l-YGZwqjEVn3uTWPA3UuonbZ",
    title: "overlapping letters d l",
    list_url: "/styles/black-grey/overlapping-letters-d-l"
  },
  {
    url: "/styles/blackwork/a-time-for-everything-ecclesiastes-5NQ3aa6NCB1ge69vWBo8Ck",
    title: "a time for everything ecclesiastes",
    list_url: "/styles/blackwork/a-time-for-everything-ecclesiastes"
  },
  {
    url: "/styles/blackwork/boy-fucking-girl-standing-5KNnYcykMSGE6UP2qrviu2",
    title: "boy fucking girl standing",
    list_url: "/styles/blackwork/boy-fucking-girl-standing"
  },
  {
    url: "/styles/blackwork/gothic-tattoo-design-slutty-anime-girl-JRDn1dTWrobPdjtvFPKSQL",
    title: "gothic tattoo design slutty anime girl",
    list_url: "/styles/blackwork/gothic-tattoo-design-slutty-anime-girl"
  },
  {
    url: "/styles/blackwork/roshni-name-RMoN948v7WJumxLmfbztL7",
    title: "roshni name",
    list_url: "/styles/blackwork/roshni-name"
  },
  {
    url: "/styles/blackwork/ruby-name-written-WrB46HyM8wszmzLgT1wMsQ",
    title: "ruby name written",
    list_url: "/styles/blackwork/ruby-name-written"
  },
  {
    url: "/styles/dotwork/artha-dharma-karma-moksha-BZ1yfUz2khSyJi2FGrmWeX",
    title: "artha dharma karma moksha",
    list_url: "/styles/dotwork/artha-dharma-karma-moksha"
  },
  {
    url: "/styles/dotwork/arul-with-king-name-BPj7AfdfEq6KVZby3hjUJW",
    title: "arul with king name",
    list_url: "/styles/dotwork/arul-with-king-name"
  },
  {
    url: "/styles/dotwork/geranium-flower-7ZJZCSQGPLcyjhMkYYMjc1",
    title: "geranium flower",
    list_url: "/styles/dotwork/geranium-flower"
  },
  {
    url: "/styles/dotwork/taurus-and-virgo-9XX5tvQVBnMkvfNPK9pTx",
    title: "taurus and virgo",
    list_url: "/styles/dotwork/taurus-and-virgo"
  },
  {
    url: "/styles/geometric/da-vinci-SLXVwAnmhcCdcMM1coiiTs",
    title: "da vinci",
    list_url: "/styles/geometric/da-vinci"
  },
  {
    url: "/styles/japanese/bear-D7TNQNo9kiVE1J1gXB6pJo",
    title: "bear",
    list_url: "/styles/japanese/bear"
  },
  {
    url: "/styles/japanese/couple-UZ5yocnGp29j2Bv8R5iiX6",
    title: "couple",
    list_url: "/styles/japanese/couple"
  },
  {
    url: "/styles/japanese/leg-sleeve-japanese-style-black-white-RfbC9WGFR97J3REmckTZnL",
    title: "leg sleeve japanese style black white",
    list_url: "/styles/japanese/leg-sleeve-japanese-style-black-white"
  },
  {
    url: "/styles/minimalist/butterfly-k-letter-Qt46qC16KTzWyL8GUp3gXd",
    title: "butterfly k letter",
    list_url: "/styles/minimalist/butterfly-k-letter"
  },
  {
    url: "/styles/minimalist/cristiano-ronaldo-GwNYg9bgYoTZqnRRpGYuVC",
    title: "cristiano ronaldo",
    list_url: "/styles/minimalist/cristiano-ronaldo"
  },
  {
    url: "/styles/minimalist/gandiva-bow-CjoufmSAa2eDhuHcQhhjBH",
    title: "gandiva bow",
    list_url: "/styles/minimalist/gandiva-bow"
  },
  {
    url: "/styles/minimalist/simple-name-tattoo-of-yuva-dyhcizU2FuerkVTbokCXx",
    title: "simple name tattoo of yuva",
    list_url: "/styles/minimalist/simple-name-tattoo-of-yuva"
  },
  {
    url: "/styles/minimalist/stacked-letters-hednf-WbzwXFsNQY3VgyMKdirHfa",
    title: "stacked letters hednf",
    list_url: "/styles/minimalist/stacked-letters-hednf"
  },
  {
    url: "/styles/neotraditional/boner-garage-9oiL3z1Uiuu2iQPEQrnVjy",
    title: "boner garage",
    list_url: "/styles/neotraditional/boner-garage"
  },
  {
    url: "/styles/neotraditional/i-want-nikhil-name-tattoo-design-in-N8BtWkQN7VjV5Ahdm8e9y",
    title: "i want nikhil name tattoo design in",
    list_url: "/styles/neotraditional/i-want-nikhil-name-tattoo-design-in"
  },
  {
    url: "/styles/neotraditional/lord-shiva-murugan-and-vinayagar-6inHoQ64V4GLeXVPzxVuVj",
    title: "lord shiva murugan and vinayagar",
    list_url: "/styles/neotraditional/lord-shiva-murugan-and-vinayagar"
  },
  {
    url: "/styles/neotraditional/shankha-chakra-gada-padma-UNF9S2fk8hqXFuB7EEEQb1",
    title: "shankha chakra gada padma",
    list_url: "/styles/neotraditional/shankha-chakra-gada-padma"
  },
  {
    url: "/styles/neotraditional/vamsi-Hep3vZeiozJPrBw3pYMaEL",
    title: "vamsi",
    list_url: "/styles/neotraditional/vamsi"
  },
  {
    url: "/styles/realism/chicago-bears-JrjGZUdSCSSUJQyJ21XvUg",
    title: "chicago bears",
    list_url: "/styles/realism/chicago-bears"
  },
  {
    url: "/styles/realism/overdose-KdKtMz7PpkFw4tuVRN9xzt",
    title: "overdose",
    list_url: "/styles/realism/overdose"
  },
  {
    url: "/styles/sketch/a-poison-tree-with-no-leaves-with-the-NKfSnJLPJnbnMiJjW9mgtq",
    title: "a poison tree with no leaves with the",
    list_url: "/styles/sketch/a-poison-tree-with-no-leaves-with-the"
  },
  {
    url: "/styles/sketch/branch-with-hidden-letter-m-the-branch-BuqeXekTX31QCLFToFtfrz",
    title: "branch with hidden letter m the branch",
    list_url: "/styles/sketch/branch-with-hidden-letter-m-the-branch"
  },
  {
    url: "/styles/stencil/money-rose-2tjsn4UKpFbhF711EPc72Y",
    title: "money rose",
    list_url: "/styles/stencil/money-rose"
  },
  {
    url: "/styles/traditional/grateful-dead-NEe9M5XPynjifUMTQFSoYQ",
    title: "grateful dead",
    list_url: "/styles/traditional/grateful-dead"
  },
  {
    url: "/styles/trash-polka/text-Kw7mw1SJnwC9CjbCJJJrRC",
    title: "text",
    list_url: "/styles/trash-polka/text"
  },
  {
    url: "/styles/black-grey/black-and-white-tattoo-of-open-vagina-XckHz4kBTHC7xQx3sqnu8i",
    title: "black and white tattoo of open vagina",
    list_url: "/styles/black-grey/black-and-white-tattoo-of-open-vagina"
  },
  {
    url: "/styles/black-grey/cartel-YRNg7xxKqGcUcDsfLpFU7H",
    title: "cartel",
    list_url: "/styles/black-grey/cartel"
  },
  {
    url: "/styles/black-grey/devil-3Wqx8aj4oeMAybtSgu8Rj5",
    title: "devil",
    list_url: "/styles/black-grey/devil"
  },
  {
    url: "/styles/black-grey/harish-name-tattoo-X3TnFNvwHNH1DxKKzE66zG",
    title: "harish name tattoo",
    list_url: "/styles/black-grey/harish-name-tattoo"
  },
  {
    url: "/styles/black-grey/marco-name-tattoo-7nJgufNfUWkMtCuLf5PzpK",
    title: "marco name tattoo",
    list_url: "/styles/black-grey/marco-name-tattoo"
  },
  {
    url: "/styles/black-grey/pawan-E7vjk2k2t5XhJ5PfSNNHw",
    title: "pawan",
    list_url: "/styles/black-grey/pawan"
  },
  {
    url: "/styles/black-grey/tattoed-blonde-milf-4dhnB14QcPYwAo9hNKbKVz",
    title: "tattoed blonde milf",
    list_url: "/styles/black-grey/tattoed-blonde-milf"
  },
  {
    url: "/styles/blackwork/a-k-letter-62mofovNSV27MLLucSnbjP",
    title: "a k letter",
    list_url: "/styles/blackwork/a-k-letter"
  },
  {
    url: "/styles/blackwork/phoenix-with-wings-spreaded-around-neck-HpwgwSU3MKL9xizTzwMpJq",
    title: "phoenix with wings spreaded around neck",
    list_url: "/styles/blackwork/phoenix-with-wings-spreaded-around-neck"
  },
  {
    url: "/styles/blackwork/poison-tree-oz8q3Nav8yUhhaUd9XxXG",
    title: "poison tree",
    list_url: "/styles/blackwork/poison-tree"
  },
  {
    url: "/styles/blackwork/uhr-tod-mors-certa-hora-incerta-JaAV92kfaWQQ7aNzcFFQCm",
    title: "uhr tod mors certa hora incerta",
    list_url: "/styles/blackwork/uhr-tod-mors-certa-hora-incerta"
  },
  {
    url: "/styles/dotwork/john-deere-Vxp7RedfiydUC9g2CaV5yT",
    title: "john deere",
    list_url: "/styles/dotwork/john-deere"
  },
  {
    url: "/styles/geometric/aquarius-and-scorpio-37MRvQQ8HNat8uYAEQ6XkD",
    title: "aquarius and scorpio",
    list_url: "/styles/geometric/aquarius-and-scorpio"
  },
  {
    url: "/styles/geometric/morse-code-LqoJG5CdUgWTQVBVhg8fvj",
    title: "morse code",
    list_url: "/styles/geometric/morse-code"
  },
  {
    url: "/styles/geometric/the-name-tracy-Y7pV528LWyfTGN223uveB2",
    title: "the name tracy",
    list_url: "/styles/geometric/the-name-tracy"
  },
  {
    url: "/styles/minimalist/astronomy-star-map-QKSfgSJh7FRznvtyVAncRq",
    title: "astronomy star map",
    list_url: "/styles/minimalist/astronomy-star-map"
  },
  {
    url: "/styles/minimalist/letter-r-and-a-rose-with-minimalist-PbgKycpXvd3RiqfGFnLvWB",
    title: "letter r and a rose with minimalist",
    list_url: "/styles/minimalist/letter-r-and-a-rose-with-minimalist"
  },
  {
    url: "/styles/minimalist/live-and-let-live-FNNUrxMPKxiRATMHjunbiy",
    title: "live and let live",
    list_url: "/styles/minimalist/live-and-let-live"
  },
  {
    url: "/styles/minimalist/morning-glory-and-lily-of-the-valley-J5vJ4SHMrvZXBpa2RP6z8Y",
    title: "morning glory and lily of the valley",
    list_url: "/styles/minimalist/morning-glory-and-lily-of-the-valley"
  },
  {
    url: "/styles/minimalist/mr-brightside-9J3UHFQ1ngeNcXzgGZCM9h",
    title: "mr brightside",
    list_url: "/styles/minimalist/mr-brightside"
  },
  {
    url: "/styles/minimalist/single-stem-forget-me-not-flower-in-2qhaWYq8pxvWANmNg6KJby",
    title: "single stem forget me not flower in",
    list_url: "/styles/minimalist/single-stem-forget-me-not-flower-in"
  },
  {
    url: "/styles/minimalist/tempus-fugit-with-music-QDzrMTwjdngyHppkpydAAS",
    title: "tempus fugit with music",
    list_url: "/styles/minimalist/tempus-fugit-with-music"
  },
  {
    url: "/styles/minimalist/tool-lyrics-FK9Bz2AyyaCRHaJK2bNmpD",
    title: "tool lyrics",
    list_url: "/styles/minimalist/tool-lyrics"
  },
  {
    url: "/styles/neotraditional/aastha-name-tattoo-VoSShA9hQujqpWuPhCm6MT",
    title: "aastha name tattoo",
    list_url: "/styles/neotraditional/aastha-name-tattoo"
  },
  {
    url: "/styles/neotraditional/bbc-slut-bbc-only-2PRtgKV9oeny3TUNRqZVRj",
    title: "bbc slut bbc only",
    list_url: "/styles/neotraditional/bbc-slut-bbc-only"
  },
  {
    url: "/styles/neotraditional/my-name-yuvi-with-emoji-74WsyQEehmJBacGfVKf8qP",
    title: "my name yuvi with emoji",
    list_url: "/styles/neotraditional/my-name-yuvi-with-emoji"
  },
  {
    url: "/styles/neotraditional/ram-ki-geeta-name-9HoSp7oo5YpoFNBVQ7vjFu",
    title: "ram ki geeta name",
    list_url: "/styles/neotraditional/ram-ki-geeta-name"
  },
  {
    url: "/styles/neotraditional/tree-with-green-man-WoLEUQ14nE2iczxkCnjdz5",
    title: "tree with green man",
    list_url: "/styles/neotraditional/tree-with-green-man"
  },
  {
    url: "/styles/realism/gay-hairy-muscle-male-pinup-beard-8cAiMSGPkNCZ4RjnQnZmFT",
    title: "gay hairy muscle male pinup beard",
    list_url: "/styles/realism/gay-hairy-muscle-male-pinup-beard"
  },
  {
    url: "/styles/realism/heart-ripped-out-of-chest-LxcMgJmcwt5xY4HBXGJKhQ",
    title: "heart ripped out of chest",
    list_url: "/styles/realism/heart-ripped-out-of-chest"
  },
  {
    url: "/styles/realism/vivere-militare-est-W6Grf865DP1wuZVunTc5ti",
    title: "vivere militare est",
    list_url: "/styles/realism/vivere-militare-est"
  },
  {
    url: "/styles/sketch/angel-wings-with-flowers-6tGkiDf9529KDcTXLhxXEU",
    title: "angel wings with flowers",
    list_url: "/styles/sketch/angel-wings-with-flowers"
  },
  {
    url: "/styles/sketch/lord-shiva-and-lord-hanuman-Bkox39scpbzXbRMmCP71Vb",
    title: "lord shiva and lord hanuman",
    list_url: "/styles/sketch/lord-shiva-and-lord-hanuman"
  },
  {
    url: "/styles/tribal/indus-valley-civilization-QdLfyu9sBKhyGynUAWzWuA",
    title: "indus valley civilization",
    list_url: "/styles/tribal/indus-valley-civilization"
  },
  {
    url: "/styles/black-grey/angel-wings-with-the-name-angel-Gofdp4LbtGndFT3xoRLG27",
    title: "angel wings with the name angel",
    list_url: "/styles/black-grey/angel-wings-with-the-name-angel"
  },
  {
    url: "/styles/black-grey/australian-army-anzac-theme-sleeve-HrDs5NJvp9tZ1o9dFcHzrx",
    title: "australian army anzac theme sleeve",
    list_url: "/styles/black-grey/australian-army-anzac-theme-sleeve"
  },
  {
    url: "/styles/black-grey/i-am-the-highway-audioslave-L6PQYkohFiFUyT1RE313kG",
    title: "i am the highway audioslave",
    list_url: "/styles/black-grey/i-am-the-highway-audioslave"
  },
  {
    url: "/styles/black-grey/money-weed-and-drugs-QKEXyoJmDRUEcy7bHA3v2p",
    title: "money weed and drugs",
    list_url: "/styles/black-grey/money-weed-and-drugs"
  },
  {
    url: "/styles/black-grey/psalm-91-JrDfyBaXsmjmpggK4ZBGgm",
    title: "psalm ",
    list_url: "/styles/black-grey/psalm-91"
  },
  {
    url: "/styles/black-grey/the-name-sara-MuwqBsN6tdtgRkFaHx2X1D",
    title: "the name sara",
    list_url: "/styles/black-grey/the-name-sara"
  },
  {
    url: "/styles/black-grey/two-headed-raven-incest-pintograms-RJRCt9L25LRy8RPEn56ujV",
    title: "two headed raven incest pintograms",
    list_url: "/styles/black-grey/two-headed-raven-incest-pintograms"
  },
  {
    url: "/styles/blackwork/american-traditional-patchwork-sleeve-WqcgRpq8j1fHR5GRFpJLhQ",
    title: "american traditional patchwork sleeve",
    list_url: "/styles/blackwork/american-traditional-patchwork-sleeve"
  },
  {
    url: "/styles/blackwork/mind-over-matter-hand-tattoo-central-cee-4RgavnyhhTUvx7TKNtRfL5",
    title: "mind over matter hand tattoo central cee",
    list_url: "/styles/blackwork/mind-over-matter-hand-tattoo-central-cee"
  },
  {
    url: "/styles/blackwork/osama-bin-laden-skull-Sc8741XmweG5sVCjV78f8x",
    title: "osama bin laden skull",
    list_url: "/styles/blackwork/osama-bin-laden-skull"
  },
  {
    url: "/styles/blackwork/qos-6mywVrujPsC8RD5bXrHz2h",
    title: "qos",
    list_url: "/styles/blackwork/qos"
  },
  {
    url: "/styles/blackwork/qos-love-bbc-studios-fault-XBKceRaBBmV4qqt7pLMaWx",
    title: "qos love bbc studios fault",
    list_url: "/styles/blackwork/qos-love-bbc-studios-fault"
  },
  {
    url: "/styles/dotwork/celtic-father-son-knot-WMQqmbT1Cj65h6PgoFCFX4",
    title: "celtic father son knot",
    list_url: "/styles/dotwork/celtic-father-son-knot"
  },
  {
    url: "/styles/dotwork/dog-name-6x9WLp5AHPj6ZGyBujgXaZ",
    title: "dog name",
    list_url: "/styles/dotwork/dog-name"
  },
  {
    url: "/styles/dotwork/dog-paw-with-daisy-PH6ph2VK84khu6xU7VYYfE",
    title: "dog paw with daisy",
    list_url: "/styles/dotwork/dog-paw-with-daisy"
  },
  {
    url: "/styles/geometric",
    title: "geometric",
    list_url: "/styles/geometric"
  },
  {
    url: "/styles/geometric/christian-Sp1tJNEqDG3Cz4pH5VyYLu",
    title: "christian",
    list_url: "/styles/geometric/christian"
  },
  {
    url: "/styles/geometric/elephant-family-YUH7BprPSRUkWfhBPKWpWE",
    title: "elephant family",
    list_url: "/styles/geometric/elephant-family"
  },
  {
    url: "/styles/geometric/sudarshan-chakra-with-trishul-9Fnvw2bRifrD4quZJMRN3v",
    title: "sudarshan chakra with trishul",
    list_url: "/styles/geometric/sudarshan-chakra-with-trishul"
  },
  {
    url: "/styles/japanese/father-and-son-Rm5eYfsAdKHKBk3zx3NRvc",
    title: "father and son",
    list_url: "/styles/japanese/father-and-son"
  },
  {
    url: "/styles/japanese/samurai-full-back-7YBsTQAD1WHCBeGA7KTfUp",
    title: "samurai full back",
    list_url: "/styles/japanese/samurai-full-back"
  },
  {
    url: "/styles/minimalist/chop-wood-carry-water-KMBhsiY5ANb2uGrUcGxCuf",
    title: "chop wood carry water",
    list_url: "/styles/minimalist/chop-wood-carry-water"
  },
  {
    url: "/styles/minimalist/garth-brooks-lyrics-36YS3K9eifXaPXQaDqH9RG",
    title: "garth brooks lyrics",
    list_url: "/styles/minimalist/garth-brooks-lyrics"
  },
  {
    url: "/styles/minimalist/name-of-my-pragya-M4vkJo7y9zWH3qMRAVYVcA",
    title: "name of my pragya",
    list_url: "/styles/minimalist/name-of-my-pragya"
  },
  {
    url: "/styles/minimalist/right-person-wrong-time-695udC3ozPTqFohMpBfRyZ",
    title: "right person wrong time",
    list_url: "/styles/minimalist/right-person-wrong-time"
  },
  {
    url: "/styles/neotraditional/infinity-symbol-with-3-names-and-a-26kye2gQ14ndJf5jrGP7cq",
    title: "infinity symbol with names and a",
    list_url: "/styles/neotraditional/infinity-symbol-with-3-names-and-a"
  },
  {
    url: "/styles/neotraditional/madhuri-and-mahesh-name-tattoo-9azVDoYaEa17wcxRXPcBwS",
    title: "madhuri and mahesh name tattoo",
    list_url: "/styles/neotraditional/madhuri-and-mahesh-name-tattoo"
  },
  {
    url: "/styles/neotraditional/my-girlfriend-name-harshita-written-2oxWWr43hgwPfWPRp92RQK",
    title: "my girlfriend name harshita written",
    list_url: "/styles/neotraditional/my-girlfriend-name-harshita-written"
  },
  {
    url: "/styles/neotraditional/neha-name-GSThoxCoG8moHDipozey9e",
    title: "neha name",
    list_url: "/styles/neotraditional/neha-name"
  },
  {
    url: "/styles/neotraditional/route-66-sign-n2eP7jEFUMp82WgVyEFzF",
    title: "route sign",
    list_url: "/styles/neotraditional/route-66-sign"
  },
  {
    url: "/styles/neotraditional/varsha-H8aXaVHAiS1st4xVKXcrB1",
    title: "varsha",
    list_url: "/styles/neotraditional/varsha"
  },
  {
    url: "/styles/realism/black-mamba-snake-leg-sleeve-9cB79W5bunSQe3HPGgrNHC",
    title: "black mamba snake leg sleeve",
    list_url: "/styles/realism/black-mamba-snake-leg-sleeve"
  },
  {
    url: "/styles/realism/cocaine-8hpEv1CkSXpGEKm8BrtNdK",
    title: "cocaine",
    list_url: "/styles/realism/cocaine"
  },
  {
    url: "/styles/realism/elegua-ChTcrY6rPoQxktzLcwgsnS",
    title: "elegua",
    list_url: "/styles/realism/elegua"
  },
  {
    url: "/styles/sketch/a-blackwork-tattoo-of-a-hayabusa-7Ubw3M6RfYA2iSYWCYXQkC",
    title: "a blackwork tattoo of a hayabusa",
    list_url: "/styles/sketch/a-blackwork-tattoo-of-a-hayabusa"
  },
  {
    url: "/styles/sketch/a-tree-planted-by-the-water-that-sends-7Dw9R6K6aHbStQ5Ab1xB7f",
    title: "a tree planted by the water that sends",
    list_url: "/styles/sketch/a-tree-planted-by-the-water-that-sends"
  },
  {
    url: "/styles/sketch/amar-XHGhcBFjyv4HYZXC9WHX2F",
    title: "amar",
    list_url: "/styles/sketch/amar"
  },
  {
    url: "/styles/sketch/kailash-parbat-HqURge4DzSGnvn2yq6LmLc",
    title: "kailash parbat",
    list_url: "/styles/sketch/kailash-parbat"
  },
  {
    url: "/styles/sketch/names-aakash-and-akshaya-in-one-tattoo-N2g8UQbRSgUvEohQUasrQN",
    title: "names aakash and akshaya in one tattoo",
    list_url: "/styles/sketch/names-aakash-and-akshaya-in-one-tattoo"
  },
  {
    url: "/styles/sketch/puerto-rico-taino-6Mg8qEb8J4HJvqYz63zLnE",
    title: "puerto rico taino",
    list_url: "/styles/sketch/puerto-rico-taino"
  },
  {
    url: "/styles/sketch/side-view-of-ktm-390-duke-MEVBza9Wy6s2vZVruQEiir",
    title: "side view of ktm duke",
    list_url: "/styles/sketch/side-view-of-ktm-390-duke"
  },
  {
    url: "/styles/sketch/the-name-aurora-with-northen-lights-9TDCYTShreARxfXM9zvJcN",
    title: "the name aurora with northen lights",
    list_url: "/styles/sketch/the-name-aurora-with-northen-lights"
  },
  {
    url: "/styles/traditional/russian-bear-9xdSpcrvTtB2jg3hgJR1p1",
    title: "russian bear",
    list_url: "/styles/traditional/russian-bear"
  },
  {
    url: "/styles/trash-polka/fuck-society-3Tdz7FLVBgfTC4Hps7oht2",
    title: "fuck society",
    list_url: "/styles/trash-polka/fuck-society"
  },
  {
    url: "/styles/tribal/tamil-6XDEfk3XdxMmwnaqjQPUZb",
    title: "tamil",
    list_url: "/styles/tribal/tamil"
  },
  {
    url: "/styles/black-grey/a-rose-with-number-18-in-the-middle-CwSrcRjtHcapYppcXpqtsm",
    title: "a rose with number in the middle",
    list_url: "/styles/black-grey/a-rose-with-number-18-in-the-middle"
  },
  {
    url: "/styles/black-grey/an-intricate-design-of-the-name-ryan-CVWz2TeyGyV69xMJvQPmMU",
    title: "an intricate design of the name ryan",
    list_url: "/styles/black-grey/an-intricate-design-of-the-name-ryan"
  },
  {
    url: "/styles/black-grey/bdsm-dom-and-sub-5RdLsAnEKrFXhXG6AfmPuX",
    title: "bdsm dom and sub",
    list_url: "/styles/black-grey/bdsm-dom-and-sub"
  },
  {
    url: "/styles/black-grey/bitch-prostitute-G1HDs3gbSycqRKnQz1Y2qy",
    title: "bitch prostitute",
    list_url: "/styles/black-grey/bitch-prostitute"
  },
  {
    url: "/styles/black-grey/captain-america-with-shield-GaCX4VqqV7Wa1qHAchPE5H",
    title: "captain america with shield",
    list_url: "/styles/black-grey/captain-america-with-shield"
  },
  {
    url: "/styles/black-grey/compass-on-the-elbow-Xznkf67hetkRt4PmdPsChC",
    title: "compass on the elbow",
    list_url: "/styles/black-grey/compass-on-the-elbow"
  },
  {
    url: "/styles/black-grey/jaya-name-Uw8REwrgVTmyXYiuHvr3Y9",
    title: "jaya name",
    list_url: "/styles/black-grey/jaya-name"
  },
  {
    url: "/styles/black-grey/name-april-with-infinity-and-laurel-EFzUotUvNaWvhbS52ZcrZ9",
    title: "name april with infinity and laurel",
    list_url: "/styles/black-grey/name-april-with-infinity-and-laurel"
  },
  {
    url: "/styles/black-grey/two-black-gay-men-kissing-GNqHgUVQVfp4ouT1e3Hepr",
    title: "two black gay men kissing",
    list_url: "/styles/black-grey/two-black-gay-men-kissing"
  },
  {
    url: "/styles/blackwork/evil-fairy-EGm2iMMym5pfV4pyTQybA2",
    title: "evil fairy",
    list_url: "/styles/blackwork/evil-fairy"
  },
  {
    url: "/styles/blackwork/qos-love-your-bbc-W3kg1BzaLFLMG4J8pjE2ox",
    title: "qos love your bbc",
    list_url: "/styles/blackwork/qos-love-your-bbc"
  },
  {
    url: "/styles/blackwork/queen-crown-of-latin-kings-gang-tatto-RvkatS2ijpHiDHUPeGC9xt",
    title: "queen crown of latin kings gang tatto",
    list_url: "/styles/blackwork/queen-crown-of-latin-kings-gang-tatto"
  },
  {
    url: "/styles/blackwork/viking-symbol-for-dead-brother-6X2BXKTMJFJqDVKRUkUjRm",
    title: "viking symbol for dead brother",
    list_url: "/styles/blackwork/viking-symbol-for-dead-brother"
  },
  {
    url: "/styles/dotwork/a-mother-bird-feeding-her-baby-birds-in-2BrcedRFCoWEYLXGoYM25Z",
    title: "a mother bird feeding her baby birds in",
    list_url: "/styles/dotwork/a-mother-bird-feeding-her-baby-birds-in"
  },
  {
    url: "/styles/dotwork/lake-superior-shoreline-with-kayak-and-PtFsgBb6DHv6rMDngG4az2",
    title: "lake superior shoreline with kayak and",
    list_url: "/styles/dotwork/lake-superior-shoreline-with-kayak-and"
  },
  {
    url: "/styles/dotwork/maa-vaishno-devi-bhawan-and-mata-rani-KvvnpR36UunwDQ4cnLmL2j",
    title: "maa vaishno devi bhawan and mata rani",
    list_url: "/styles/dotwork/maa-vaishno-devi-bhawan-and-mata-rani"
  },
  {
    url: "/styles/dotwork/metis-WZDDj9jyJNAN7SDkovSpFe",
    title: "metis",
    list_url: "/styles/dotwork/metis"
  },
  {
    url: "/styles/dotwork/rajkumar-name-followed-by-bala-ji-tilak-LbaCTYfcvKStSHU5NEzeFn",
    title: "rajkumar name followed by bala ji tilak",
    list_url: "/styles/dotwork/rajkumar-name-followed-by-bala-ji-tilak"
  },
  {
    url: "/styles/dotwork/roshan-name-and-wing-SWHWBRaxQeNjMMevqm5ZRv",
    title: "roshan name and wing",
    list_url: "/styles/dotwork/roshan-name-and-wing"
  },
  {
    url: "/styles/dotwork/sudarshan-name-with-peacocks-Umkqr6j2ajxrQTdp2ASHAh",
    title: "sudarshan name with peacocks",
    list_url: "/styles/dotwork/sudarshan-name-with-peacocks"
  },
  {
    url: "/styles/geometric/369-number-CYvVtXYvJ2hWyNUnZZhfLS",
    title: " number",
    list_url: "/styles/geometric/369-number"
  },
  {
    url: "/styles/geometric/ego-death-Ti2N73sz6JvU1jDib1g29B",
    title: "ego death",
    list_url: "/styles/geometric/ego-death"
  },
  {
    url: "/styles/geometric/parkinson-8ULzPJBg9C2YdSWGiG1Hfn",
    title: "parkinson",
    list_url: "/styles/geometric/parkinson"
  },
  {
    url: "/styles/japanese/waves-with-cherry-blossoms-WdTgvf85fF3ewMYnHNguV3",
    title: "waves with cherry blossoms",
    list_url: "/styles/japanese/waves-with-cherry-blossoms"
  },
  {
    url: "/styles/minimalist/cocker-spaniel-4WPPTjSHe366YwFGTULpi2",
    title: "cocker spaniel",
    list_url: "/styles/minimalist/cocker-spaniel"
  },
  {
    url: "/styles/minimalist/cross-with-daisy-flower-QoaJeN83rYuReEdMTu8ict",
    title: "cross with daisy flower",
    list_url: "/styles/minimalist/cross-with-daisy-flower"
  },
  {
    url: "/styles/minimalist/moon-sun-waves-UQDHK8BVVNEsYkugEs1Vv1",
    title: "moon sun waves",
    list_url: "/styles/minimalist/moon-sun-waves"
  },
  {
    url: "/styles/minimalist/morse-code-circle-shape-9tQZDyig1AwJd4J7d8pGYq",
    title: "morse code circle shape",
    list_url: "/styles/minimalist/morse-code-circle-shape"
  },
  {
    url: "/styles/minimalist/one-step-at-a-time-U9aXUip2R6Z5P7WrBxdzVX",
    title: "one step at a time",
    list_url: "/styles/minimalist/one-step-at-a-time"
  },
  {
    url: "/styles/minimalist/twinkle-little-star-Ebb6phTagnFC58xuijbWsi",
    title: "twinkle little star",
    list_url: "/styles/minimalist/twinkle-little-star"
  },
  {
    url: "/styles/neotraditional/hide-the-name-harini-in-the-tatoo-R6SYSQ7rsAw8RpUUbVX518",
    title: "hide the name harini in the tatoo",
    list_url: "/styles/neotraditional/hide-the-name-harini-in-the-tatoo"
  },
  {
    url: "/styles/neotraditional/james-112-bible-verse-written-TxoRwmkfvVzR9CmiRbNqKg",
    title: "james bible verse written",
    list_url: "/styles/neotraditional/james-112-bible-verse-written"
  },
  {
    url: "/styles/neotraditional/lord-murugan-DUmg13mVQ8Vvt61SyG76TK",
    title: "lord murugan",
    list_url: "/styles/neotraditional/lord-murugan"
  },
  {
    url: "/styles/neotraditional/nitika-name-tattoo-design-for-my-lovely-6xc9tRxdrQugUQBHPpnp9J",
    title: "nitika name tattoo design for my lovely",
    list_url: "/styles/neotraditional/nitika-name-tattoo-design-for-my-lovely"
  },
  {
    url: "/styles/neotraditional/the-7-archangels-with-their-respective-E6J8mofPnrhmUbwt5J1qT1",
    title: "the archangels with their respective",
    list_url: "/styles/neotraditional/the-7-archangels-with-their-respective"
  },
  {
    url: "/styles/neotraditional/trisha-name-tattoo-Jh34j3dYAB1Vgv6L5rC6Bd",
    title: "trisha name tattoo",
    list_url: "/styles/neotraditional/trisha-name-tattoo"
  },
  {
    url: "/styles/neotraditional/work-hard-play-hard-9ZvsHNq48oEngfkJxwfzpy",
    title: "work hard play hard",
    list_url: "/styles/neotraditional/work-hard-play-hard"
  },
  {
    url: "/styles/realism/dragon-wrapping-around-arm-TkrG8PKWDSWHQ3zjY88GFL",
    title: "dragon wrapping around arm",
    list_url: "/styles/realism/dragon-wrapping-around-arm"
  },
  {
    url: "/styles/realism/god-family-country-Um7jzBhxjzPPYVWifHWZje",
    title: "god family country",
    list_url: "/styles/realism/god-family-country"
  },
  {
    url: "/styles/realism/liberte-egalite-fraternite-YQVmF9fs3rDSfuSHfvyBiw",
    title: "liberte egalite fraternite",
    list_url: "/styles/realism/liberte-egalite-fraternite"
  },
  {
    url: "/styles/realism/strength-italian-god-bible-script-K42Rg2RVrrekHdXtqNyvuY",
    title: "strength italian god bible script",
    list_url: "/styles/realism/strength-italian-god-bible-script"
  },
  {
    url: "/styles/sketch/busty-nsfw-anime-waifu-ahegao-CAG4o9fFMtfAgFMjWYdVjz",
    title: "busty nsfw anime waifu ahegao",
    list_url: "/styles/sketch/busty-nsfw-anime-waifu-ahegao"
  },
  {
    url: "/styles/sketch/gayatri-mantra-Sknw1oDGYH73Z4UB7bjPE3",
    title: "gayatri mantra",
    list_url: "/styles/sketch/gayatri-mantra"
  },
  {
    url: "/styles/sketch/leo-and-pisces-together-PAt1pf4YJEBzGsKKYoiWpn",
    title: "leo and pisces together",
    list_url: "/styles/sketch/leo-and-pisces-together"
  },
  {
    url: "/styles/sketch/meth-molecule-structure-AEWwSYcWtxKURoGxKTgnGb",
    title: "meth molecule structure",
    list_url: "/styles/sketch/meth-molecule-structure"
  },
  {
    url: "/styles/sketch/sunflower-dreamcatcher-MUHPsWYk85yhvC2T9ctNQa",
    title: "sunflower dreamcatcher",
    list_url: "/styles/sketch/sunflower-dreamcatcher"
  },
  {
    url: "/styles/traditional/double-l-and-number-19-EG54wr3U4nEdJFKKCXBBTp",
    title: "double l and number ",
    list_url: "/styles/traditional/double-l-and-number-19"
  },
  {
    url: "/styles/traditional/navy-corpsman-CqVSTfb5oK2LPAgp5ygkCH",
    title: "navy corpsman",
    list_url: "/styles/traditional/navy-corpsman"
  },
  {
    url: "/styles/traditional/sisyphus-name-spelled-out-in-greek-A5fgH4pxUiCQbcpcZ4Zh4H",
    title: "sisyphus name spelled out in greek",
    list_url: "/styles/traditional/sisyphus-name-spelled-out-in-greek"
  },
  {
    url: "/styles/traditional/taekwondo-WtLTfoXGWimkWuvPCFWSkj",
    title: "taekwondo",
    list_url: "/styles/traditional/taekwondo"
  },
  {
    url: "/styles/tribal/philippines-and-canada-WeoJehA9CmpJZkh3PbtkTb",
    title: "philippines and canada",
    list_url: "/styles/tribal/philippines-and-canada"
  },
  {
    url: "/styles/3d/sidhu-moosewala-name-8B3RGUNsUGA24JfC2GFsGv",
    title: "sidhu moosewala name",
    list_url: "/styles/3d/sidhu-moosewala-name"
  },
  {
    url: "/styles/black-grey/1-better-everyday-CkgSe9nka6L9nYxjobWPEC",
    title: " better everyday",
    list_url: "/styles/black-grey/1-better-everyday"
  },
  {
    url: "/styles/black-grey/a-tattoo-of-baby-groot-playing-NhP1jFpQn9FSeqPEiXuw3V",
    title: "a tattoo of baby groot playing",
    list_url: "/styles/black-grey/a-tattoo-of-baby-groot-playing"
  },
  {
    url: "/styles/black-grey/cosmos-and-marigold-flowers-UAvd5rCBNAqin5XkH5Ygco",
    title: "cosmos and marigold flowers",
    list_url: "/styles/black-grey/cosmos-and-marigold-flowers"
  },
  {
    url: "/styles/black-grey/reyes-lettering-in-cursive-font-PMfLf4vXxSPRG8SoHTRxtD",
    title: "reyes lettering in cursive font",
    list_url: "/styles/black-grey/reyes-lettering-in-cursive-font"
  },
  {
    url: "/styles/black-grey/xli-Rk66wrT76zRPApyteeDW3F",
    title: "xli",
    list_url: "/styles/black-grey/xli"
  },
  {
    url: "/styles/blackwork/a-butterfly-with-an-owl-eyes-QPLTk21QGyaixXLsCnhWuT",
    title: "a butterfly with an owl eyes",
    list_url: "/styles/blackwork/a-butterfly-with-an-owl-eyes"
  },
  {
    url: "/styles/blackwork/a-wave-of-spiraling-wind-XRAC8tEEFivMA5Z3A5Thq3",
    title: "a wave of spiraling wind",
    list_url: "/styles/blackwork/a-wave-of-spiraling-wind"
  },
  {
    url: "/styles/blackwork/actions-speak-louder-than-words-P7xUS6RFh9kdabLMNSG4d7",
    title: "actions speak louder than words",
    list_url: "/styles/blackwork/actions-speak-louder-than-words"
  },
  {
    url: "/styles/blackwork/black-owned-slut-2tZ274CuBsGW2DxYgs1aPJ",
    title: "black owned slut",
    list_url: "/styles/blackwork/black-owned-slut"
  },
  {
    url: "/styles/blackwork/name-akshara-7SjGcUHghyqxCgPoZdXbQ7",
    title: "name akshara",
    list_url: "/styles/blackwork/name-akshara"
  },
  {
    url: "/styles/dotwork/capricorn-and-gemini-VoYVobQ9nydqD3oJzi75eZ",
    title: "capricorn and gemini",
    list_url: "/styles/dotwork/capricorn-and-gemini"
  },
  {
    url: "/styles/dotwork/compass-north-star-WSTM8P4DyDBQK5F7AaPEpU",
    title: "compass north star",
    list_url: "/styles/dotwork/compass-north-star"
  },
  {
    url: "/styles/dotwork/letter-j-with-letter-d-hidden-QwM8jfenZT4zoNLzPm98J3",
    title: "letter j with letter d hidden",
    list_url: "/styles/dotwork/letter-j-with-letter-d-hidden"
  },
  {
    url: "/styles/japanese/dragon-with-red-spider-lily-EyDPfr9KHyL12XFSt8twgk",
    title: "dragon with red spider lily",
    list_url: "/styles/japanese/dragon-with-red-spider-lily"
  },
  {
    url: "/styles/minimalist/8-life-path-E1QnBpRT782DDR9JmBVffc",
    title: " life path",
    list_url: "/styles/minimalist/8-life-path"
  },
  {
    url: "/styles/minimalist/heart-with-letter-c-Sq6JWJyyZGeG7qHVDUa3Eq",
    title: "heart with letter c",
    list_url: "/styles/minimalist/heart-with-letter-c"
  },
  {
    url: "/styles/minimalist/my-mercy-prevails-over-my-wrath-8oqpMXeRhfDNqB8BsFmcHp",
    title: "my mercy prevails over my wrath",
    list_url: "/styles/minimalist/my-mercy-prevails-over-my-wrath"
  },
  {
    url: "/styles/minimalist/textkarmanye-vadhikaraste-ma-phaleshu-5JGus8vk9aLxhngPKzjay3",
    title: "textkarmanye vadhikaraste ma phaleshu",
    list_url: "/styles/minimalist/textkarmanye-vadhikaraste-ma-phaleshu"
  },
  {
    url: "/styles/minimalist/westie-BGhddXPZfhX1BXq2NXdNJx",
    title: "westie",
    list_url: "/styles/minimalist/westie"
  },
  {
    url: "/styles/minimalist/zach-bryans-east-side-of-sorrow-MtgSvNpLW5qkJuUK3x9QUC",
    title: "zach bryans east side of sorrow",
    list_url: "/styles/minimalist/zach-bryans-east-side-of-sorrow"
  },
  {
    url: "/styles/neotraditional/cherokee-indian-feathers-4BP7gtfaoM7yNhVmYuJG7K",
    title: "cherokee indian feathers",
    list_url: "/styles/neotraditional/cherokee-indian-feathers"
  },
  {
    url: "/styles/neotraditional/italian-roman-calabrian-NmC7UqRDdS8ixPRQUAWfMm",
    title: "italian roman calabrian",
    list_url: "/styles/neotraditional/italian-roman-calabrian"
  },
  {
    url: "/styles/neotraditional/ive-got-a-price-tag-on-this-heavy-head-CUrPEAZGfL75w1s3pPkyKF",
    title: "ive got a price tag on this heavy head",
    list_url: "/styles/neotraditional/ive-got-a-price-tag-on-this-heavy-head"
  },
  {
    url: "/styles/neotraditional/jagan-name-tattoo-VB3cNTdos25bjU3ikbsTzR",
    title: "jagan name tattoo",
    list_url: "/styles/neotraditional/jagan-name-tattoo"
  },
  {
    url: "/styles/neotraditional/max-name-tattoo-Rcjsp6oWbfSzuC8gEEpjRA",
    title: "max name tattoo",
    list_url: "/styles/neotraditional/max-name-tattoo"
  },
  {
    url: "/styles/neotraditional/nikunj-name-in-heartbeats-parallel-EwRdXBnTc831eHVdx3oLQ2",
    title: "nikunj name in heartbeats parallel",
    list_url: "/styles/neotraditional/nikunj-name-in-heartbeats-parallel"
  },
  {
    url: "/styles/neotraditional/punjab-map-with-ak-47-62txkVpJiVbKfonTio4boF",
    title: "punjab map with ak ",
    list_url: "/styles/neotraditional/punjab-map-with-ak-47"
  },
  {
    url: "/styles/neotraditional/satyam-charu-name-tatto-pine-tree-SsqmqNmXcXN46LvZ9gvJX2",
    title: "satyam charu name tatto pine tree",
    list_url: "/styles/neotraditional/satyam-charu-name-tatto-pine-tree"
  },
  {
    url: "/styles/realism/chinese-girl-submissive-slave-4Fe7GXvsX9gvd92vEc2pvD",
    title: "chinese girl submissive slave",
    list_url: "/styles/realism/chinese-girl-submissive-slave"
  },
  {
    url: "/styles/realism/leeds-united-FKDUbkpbqWWw7fiaQ7aBmi",
    title: "leeds united",
    list_url: "/styles/realism/leeds-united"
  },
  {
    url: "/styles/realism/mexican-cartel-SXugTYe1Ex98bfz6zRwLjF",
    title: "mexican cartel",
    list_url: "/styles/realism/mexican-cartel"
  },
  {
    url: "/styles/realism/shanthi-name-with-female-face-4hRMQkH4WwciJZ7dyZtmXf",
    title: "shanthi name with female face",
    list_url: "/styles/realism/shanthi-name-with-female-face"
  },
  {
    url: "/styles/realism/sissyboy-femdom-femboy-girly-8xYuMhd1HxeTxjdi7PPLeX",
    title: "sissyboy femdom femboy girly",
    list_url: "/styles/realism/sissyboy-femdom-femboy-girly"
  },
  {
    url: "/styles/sketch/kenworth-t909-5gLAnbYUdS2Wrs7mjhZabE",
    title: "kenworth t ",
    list_url: "/styles/sketch/kenworth-t909"
  },
  {
    url: "/styles/sketch/kindness-symbol-VwWGCDyTSzmJomtYBGnW4c",
    title: "kindness symbol",
    list_url: "/styles/sketch/kindness-symbol"
  },
  {
    url: "/styles/sketch/rohit-sharmas-jersey-number-45-into-6poGL94smt2wANPiVvn5vh",
    title: "rohit sharmas jersey number into",
    list_url: "/styles/sketch/rohit-sharmas-jersey-number-45-into"
  },
  {
    url: "/styles/sketch/uranus-WTmHKNkjFRzQYzApzMtfWi",
    title: "uranus",
    list_url: "/styles/sketch/uranus"
  },
  {
    url: "/styles/traditional/3-interlocking-letter-cs-RjTH5W3XJBDU1K7qjffFbp",
    title: " interlocking letter cs",
    list_url: "/styles/traditional/3-interlocking-letter-cs"
  },
  {
    url: "/styles/traditional/buddhism-second-arrow-TQ7P3Z3tNAJTNcwiBNU3B9",
    title: "buddhism second arrow",
    list_url: "/styles/traditional/buddhism-second-arrow"
  },
  {
    url: "/styles/traditional/the-name-james-4WSKV1jTx6KRbS8o4tES5X",
    title: "the name james",
    list_url: "/styles/traditional/the-name-james"
  },
  {
    url: "/styles/anime/big-titty-goth-girl-with-tiger-in-bamboo-MDEuwZwLEVn8Cr5cUdjsZK",
    title: "big titty goth girl with tiger in bamboo",
    list_url: "/styles/anime/big-titty-goth-girl-with-tiger-in-bamboo"
  },
  {
    url: "/styles/black-grey/fallen-wounded-knight-with-arrows-in-9gzc1BWAKhT16uhVUwwFeB",
    title: "fallen wounded knight with arrows in",
    list_url: "/styles/black-grey/fallen-wounded-knight-with-arrows-in"
  },
  {
    url: "/styles/black-grey/poem-verse-once-more-into-the-fray-XbCv6BQBtwqonZLZYN2p8S",
    title: "poem verse once more into the fray",
    list_url: "/styles/black-grey/poem-verse-once-more-into-the-fray"
  },
  {
    url: "/styles/black-grey/romans-12-19-Pdqz6fzR3XAoNFv4EPwDxt",
    title: "romans ",
    list_url: "/styles/black-grey/romans-12-19"
  },
  {
    url: "/styles/black-grey/two-face-XitFTQCDsY4Vw6W96rRYPm",
    title: "two face",
    list_url: "/styles/black-grey/two-face"
  },
  {
    url: "/styles/black-grey/valley-of-the-shadow-of-death-Hub5DXDy3xhPeq3z7HGkTA",
    title: "valley of the shadow of death",
    list_url: "/styles/black-grey/valley-of-the-shadow-of-death"
  },
  {
    url: "/styles/black-grey/warhammer-40k-death-watch-2LUx5uSGS8wjRP692GGYE2",
    title: "warhammer k death watch",
    list_url: "/styles/black-grey/warhammer-40k-death-watch"
  },
  {
    url: "/styles/black-grey/wolf-and-owl-JjpHtRPWCE56TEikWWzMjp",
    title: "wolf and owl",
    list_url: "/styles/black-grey/wolf-and-owl"
  },
  {
    url: "/styles/black-grey/yasuke-DDxNwiVLKZzj5FDovHoXbi",
    title: "yasuke",
    list_url: "/styles/black-grey/yasuke"
  },
  {
    url: "/styles/blackwork/a-celtic-knot-ring-NUbfTz9pm968ewFXKcmNWB",
    title: "a celtic knot ring",
    list_url: "/styles/blackwork/a-celtic-knot-ring"
  },
  {
    url: "/styles/blackwork/church-bell-and-a-chain-among-BkFX1hCxAiMB4Aq3AqKZHF",
    title: "church bell and a chain among",
    list_url: "/styles/blackwork/church-bell-and-a-chain-among"
  },
  {
    url: "/styles/blackwork/prem-and-miska-name-3MffAEndfC4ykPUn16UXvQ",
    title: "prem and miska name",
    list_url: "/styles/blackwork/prem-and-miska-name"
  },
  {
    url: "/styles/blackwork/siri-name-NgvH3yQobDixodRjtrZhbd",
    title: "siri name",
    list_url: "/styles/blackwork/siri-name"
  },
  {
    url: "/styles/blackwork/tribal-arawak-taino-NsDoQuqwG3LbgDJVttRFWx",
    title: "tribal arawak taino",
    list_url: "/styles/blackwork/tribal-arawak-taino"
  },
  {
    url: "/styles/cyber-sigilism/font-35uxBVaqy2TqeMPZWujWVq",
    title: "font",
    list_url: "/styles/cyber-sigilism/font"
  },
  {
    url: "/styles/dotwork/dura-lex-sed-lex-TkSzCkjY1ghn7oLiSc4Ef1",
    title: "dura lex sed lex",
    list_url: "/styles/dotwork/dura-lex-sed-lex"
  },
  {
    url: "/styles/dotwork/nsfw-bbc-qos-blacked-JrcgY3sUJEzLZTdx63iNpS",
    title: "nsfw bbc qos blacked",
    list_url: "/styles/dotwork/nsfw-bbc-qos-blacked"
  },
  {
    url: "/styles/dotwork/number-25-combined-with-letters-a-and-m-9BGsKZyTY7rA7HdtJ791zg",
    title: "number combined with letters a and m",
    list_url: "/styles/dotwork/number-25-combined-with-letters-a-and-m"
  },
  {
    url: "/styles/japanese/chrollo-kurapika-chains-ChKWgS224sr7GKfze34FJV",
    title: "chrollo kurapika chains",
    list_url: "/styles/japanese/chrollo-kurapika-chains"
  },
  {
    url: "/styles/minimalist/always-and-forever-5JFxwaVKS9DyjDc53o3ufF",
    title: "always and forever",
    list_url: "/styles/minimalist/always-and-forever"
  },
  {
    url: "/styles/minimalist/angel-number-111-V4p8TYfAuFU5KLQpSJ4bSZ",
    title: "angel number ",
    list_url: "/styles/minimalist/angel-number-111"
  },
  {
    url: "/styles/minimalist/arabic-calligraphy-BHK7AhKS5GD9qiJHLpRszu",
    title: "arabic calligraphy",
    list_url: "/styles/minimalist/arabic-calligraphy"
  },
  {
    url: "/styles/minimalist/chow-chow-TqQ6HmepYgw4EjNa4Aymom",
    title: "chow chow",
    list_url: "/styles/minimalist/chow-chow"
  },
  {
    url: "/styles/minimalist/dragonfly-and-butterfly-merged-together-3vvV2ZbZwckoFzUs62Gbyv",
    title: "dragonfly and butterfly merged together",
    list_url: "/styles/minimalist/dragonfly-and-butterfly-merged-together"
  },
  {
    url: "/styles/minimalist/finn-mccool-irish-hero-symbol-SACS8M9foBYQXLUd5aB6gB",
    title: "finn mccool irish hero symbol",
    list_url: "/styles/minimalist/finn-mccool-irish-hero-symbol"
  },
  {
    url: "/styles/minimalist/i-am-because-you-were-with-a-rose-and-Rp5ZjJ1njuou2HoXjSQ76M",
    title: "i am because you were with a rose and",
    list_url: "/styles/minimalist/i-am-because-you-were-with-a-rose-and"
  },
  {
    url: "/styles/minimalist/indian-classical-music-EMHPHkntggo68GWHphVB2N",
    title: "indian classical music",
    list_url: "/styles/minimalist/indian-classical-music"
  },
  {
    url: "/styles/minimalist/maltese-dog-PCqDo9iEecckhYE3FpMZD3",
    title: "maltese dog",
    list_url: "/styles/minimalist/maltese-dog"
  },
  {
    url: "/styles/minimalist/manifestation-through-the-universal-law-BaSRKdZ8MrQgHykEGLWi3V",
    title: "manifestation through the universal law",
    list_url: "/styles/minimalist/manifestation-through-the-universal-law"
  },
  {
    url: "/styles/minimalist/mother-duck-with-2-ducklings-PL9yadrduwMBUrBH1TmzQq",
    title: "mother duck with ducklings",
    list_url: "/styles/minimalist/mother-duck-with-2-ducklings"
  },
  {
    url: "/styles/minimalist/satoru-gojo-APRVSEXxUBGDdUsegEASo1",
    title: "satoru gojo",
    list_url: "/styles/minimalist/satoru-gojo"
  },
  {
    url: "/styles/minimalist/shibari-X8wc2XpjucJJKddBUUxtdi",
    title: "shibari",
    list_url: "/styles/minimalist/shibari"
  },
  {
    url: "/styles/minimalist/small-alstroemeria-Hwu8tUp7Leym9FUcpEGHEi",
    title: "small alstroemeria",
    list_url: "/styles/minimalist/small-alstroemeria"
  },
  {
    url: "/styles/minimalist/symbol-for-sense-of-urgency-St4MnGTwCW9qTkDGuHfHbX",
    title: "symbol for sense of urgency",
    list_url: "/styles/minimalist/symbol-for-sense-of-urgency"
  },
  {
    url: "/styles/minimalist/the-kalachakra-9FM3Up2Fszw3PM35AmYqBt",
    title: "the kalachakra",
    list_url: "/styles/minimalist/the-kalachakra"
  },
  {
    url: "/styles/neotraditional/fiat-justitia-ruat-caelum-writing-with-T5tdWdLUTvUpBabdzaexS3",
    title: "fiat justitia ruat caelum writing with",
    list_url: "/styles/neotraditional/fiat-justitia-ruat-caelum-writing-with"
  },
  {
    url: "/styles/neotraditional/gopal-name-8fgo78iFGi9fwx8tZYbynw",
    title: "gopal name",
    list_url: "/styles/neotraditional/gopal-name"
  },
  {
    url: "/styles/neotraditional/name-mayra-Xf5YJnq2viwJAVSCfiZ1AQ",
    title: "name mayra",
    list_url: "/styles/neotraditional/name-mayra"
  },
  {
    url: "/styles/neotraditional/r-c-b-logo-and-virat-kohli-photo-and-DD682wYQWb86YeCcUrSJza",
    title: "r c b logo and virat kohli photo and",
    list_url: "/styles/neotraditional/r-c-b-logo-and-virat-kohli-photo-and"
  },
  {
    url: "/styles/neotraditional/rudransh-name-in-sanskrit-and-roman-KCNj3s8PMK1AQSEcTZkGmT",
    title: "rudransh name in sanskrit and roman",
    list_url: "/styles/neotraditional/rudransh-name-in-sanskrit-and-roman"
  },
  {
    url: "/styles/neotraditional/yash-TkooKptV3FeXft5SB9nUwy",
    title: "yash",
    list_url: "/styles/neotraditional/yash"
  },
  {
    url: "/styles/realism/asterix-and-obelix-4y7qxxk78AXtAjyyvXhsTE",
    title: "asterix and obelix",
    list_url: "/styles/realism/asterix-and-obelix"
  },
  {
    url: "/styles/realism/dragon-with-pig-5h7XQ5m2H583c3trXR4aiP",
    title: "dragon with pig",
    list_url: "/styles/realism/dragon-with-pig"
  },
  {
    url: "/styles/realism/ice-dragon-2gm7L92ifh8mqXQmthbhFQ",
    title: "ice dragon",
    list_url: "/styles/realism/ice-dragon"
  },
  {
    url: "/styles/realism/orisha-chango-XiRk5ghtDvXmGwhqz6MuG",
    title: "orisha chango",
    list_url: "/styles/realism/orisha-chango"
  },
  {
    url: "/styles/sketch/navagraha-with-colours-and-weaponry-KdzxGviijzmytnufFAzjBB",
    title: "navagraha with colours and weaponry",
    list_url: "/styles/sketch/navagraha-with-colours-and-weaponry"
  },
  {
    url: "/styles/surrealism/loves-gonna-get-you-killed-NbH2YfkVd4vaz4f5QuEGov",
    title: "loves gonna get you killed",
    list_url: "/styles/surrealism/loves-gonna-get-you-killed"
  },
  {
    url: "/styles/traditional/army-mom-and-air-force-veteran-jeweled-8NhPvNP4NywatRvxAbduEt",
    title: "army mom and air force veteran jeweled",
    list_url: "/styles/traditional/army-mom-and-air-force-veteran-jeweled"
  },
  {
    url: "/styles/traditional/the-letters-m-and-j-QiNeypKuYVTn3mGr5zUG5S",
    title: "the letters m and j",
    list_url: "/styles/traditional/the-letters-m-and-j"
  },
  {
    url: "/styles/anime/big-tittie-goth-mommy-6vDETQ26fyBoneQfooD5iM",
    title: "big tittie goth mommy",
    list_url: "/styles/anime/big-tittie-goth-mommy"
  },
  {
    url: "/styles/black-grey/12-laws-of-the-universe-5nJJjgpQo9g8yqJX17RrHP",
    title: " laws of the universe",
    list_url: "/styles/black-grey/12-laws-of-the-universe"
  },
  {
    url: "/styles/black-grey/gangster-clown-RtQEhtTWgWUzx6MCeuPzrW",
    title: "gangster clown",
    list_url: "/styles/black-grey/gangster-clown"
  },
  {
    url: "/styles/black-grey/kaniel-outis-prison-break-tattoo-2LFZXjRPeJPrtBvkvFAzVm",
    title: "kaniel outis prison break tattoo",
    list_url: "/styles/black-grey/kaniel-outis-prison-break-tattoo"
  },
  {
    url: "/styles/black-grey/letters-r-m-GCUXfFTFqyGYF457kF4vuc",
    title: "letters r m",
    list_url: "/styles/black-grey/letters-r-m"
  },
  {
    url: "/styles/black-grey/lily-and-butterfly-KRv4iRg3zDxEJbzkGmdXfh",
    title: "lily and butterfly",
    list_url: "/styles/black-grey/lily-and-butterfly"
  },
  {
    url: "/styles/black-grey/past-life-of-dark-side-view-AsGGN7Yxg45gCzDLx9pAkT",
    title: "past life of dark side view",
    list_url: "/styles/black-grey/past-life-of-dark-side-view"
  },
  {
    url: "/styles/black-grey/smoke-filler-LZAW8uF7uK27tLPr5Dv1Sb",
    title: "smoke filler",
    list_url: "/styles/black-grey/smoke-filler"
  },
  {
    url: "/styles/blackwork/04071980-roman-numerals-3DyNboceWKYPvTRU2o7b1c",
    title: " roman numerals",
    list_url: "/styles/blackwork/04071980-roman-numerals"
  },
  {
    url: "/styles/blackwork/a-broken-family-tree-with-branches-AAFXP1txT9mhZDzSRsUB9M",
    title: "a broken family tree with branches",
    list_url: "/styles/blackwork/a-broken-family-tree-with-branches"
  },
  {
    url: "/styles/blackwork/female-guardian-angel-SGeUNZQss9PugYVBQeD71G",
    title: "female guardian angel",
    list_url: "/styles/blackwork/female-guardian-angel"
  },
  {
    url: "/styles/blackwork/lamborghini-YLTmLcnHbAsL3hrqPdjV1W",
    title: "lamborghini",
    list_url: "/styles/blackwork/lamborghini"
  },
  {
    url: "/styles/blackwork/let-your-faith-be-bigger-than-your-fear-QFChnAY49Ws1egwagCbT6x",
    title: "let your faith be bigger than your fear",
    list_url: "/styles/blackwork/let-your-faith-be-bigger-than-your-fear"
  },
  {
    url: "/styles/blackwork/mama-bear-with-baby-bear-EMQdhuCxe4c6HGDNrn36P4",
    title: "mama bear with baby bear",
    list_url: "/styles/blackwork/mama-bear-with-baby-bear"
  },
  {
    url: "/styles/blackwork/murder-drones-RQPrnCfhfjGjS58SifwbZ5",
    title: "murder drones",
    list_url: "/styles/blackwork/murder-drones"
  },
  {
    url: "/styles/blackwork/recovery-of-gambling-addiction-XWZdTRgffj45u7wu9wGAmx",
    title: "recovery of gambling addiction",
    list_url: "/styles/blackwork/recovery-of-gambling-addiction"
  },
  {
    url: "/styles/blackwork/st-dismas-and-jesus-on-the-cross-kkwwbZpkSaCxrq1vpPLGj",
    title: "st dismas and jesus on the cross",
    list_url: "/styles/blackwork/st-dismas-and-jesus-on-the-cross"
  },
  {
    url: "/styles/blackwork/unconditional-love-symbol-Hj9Wf6SRDb7V4ivEiEU4Up",
    title: "unconditional love symbol",
    list_url: "/styles/blackwork/unconditional-love-symbol"
  },
  {
    url: "/styles/blackwork/united-states-marine-corps-nco-sword-EgRXWR9EYaSP1wMAHoNRpC",
    title: "united states marine corps nco sword",
    list_url: "/styles/blackwork/united-states-marine-corps-nco-sword"
  },
  {
    url: "/styles/blackwork/vaya-con-dios-N67btrQ8xQLJKX4Z3Qq6CK",
    title: "vaya con dios",
    list_url: "/styles/blackwork/vaya-con-dios"
  },
  {
    url: "/styles/dotwork/kanji-with-angel-wings-back-neck-XgKo76A4twy7j5M2Y84nxU",
    title: "kanji with angel wings back neck",
    list_url: "/styles/dotwork/kanji-with-angel-wings-back-neck"
  },
  {
    url: "/styles/dotwork/letter-t-cover-up-CPzXE2Nos4ePZWG335n7DZ",
    title: "letter t cover up",
    list_url: "/styles/dotwork/letter-t-cover-up"
  },
  {
    url: "/styles/geometric/capricorn-9j7yQYeSKQazFmg1mNBVij",
    title: "capricorn",
    list_url: "/styles/geometric/capricorn"
  },
  {
    url: "/styles/geometric/family-with-zodiac-sign-6HUSnUUa4XBkhHtte7FFzN",
    title: "family with zodiac sign",
    list_url: "/styles/geometric/family-with-zodiac-sign"
  },
  {
    url: "/styles/japanese/angel-TwekEJcxTwRqt1swuxE17",
    title: "angel",
    list_url: "/styles/japanese/angel"
  },
  {
    url: "/styles/japanese/chinese-zodiac-ox-EK1vCP13YTcMReTEnb9YGA",
    title: "chinese zodiac ox",
    list_url: "/styles/japanese/chinese-zodiac-ox"
  },
  {
    url: "/styles/japanese/succubus-womb-tattoo-with-rosese-and-HSrvbhz96SKyGd3qMyo886",
    title: "succubus womb tattoo with rosese and",
    list_url: "/styles/japanese/succubus-womb-tattoo-with-rosese-and"
  },
  {
    url: "/styles/japanese/zodiac-YMmRov2UPLFmo2s1SPqm6C",
    title: "zodiac",
    list_url: "/styles/japanese/zodiac"
  },
  {
    url: "/styles/minimalist/1988-1992-1995-JdgeU2we2m94943VE2nqak",
    title: "1988-1992-1995",
    list_url: "/styles/minimalist/1988-1992-1995"
  },
  {
    url: "/styles/minimalist/ballroom-dance-MXqhpQWgz4R8b2tviSKG1V",
    title: "ballroom dance",
    list_url: "/styles/minimalist/ballroom-dance"
  },
  {
    url: "/styles/minimalist/bdsm-anime-cute-girl-TYuXCV2VEDkcPs4dHhQtKi",
    title: "bdsm anime cute girl",
    list_url: "/styles/minimalist/bdsm-anime-cute-girl"
  },
  {
    url: "/styles/minimalist/burj-khalifa-AQEGf3pJjB9YKbo5R9spki",
    title: "burj khalifa",
    list_url: "/styles/minimalist/burj-khalifa"
  },
  {
    url: "/styles/minimalist/calisthenics-DWS27Kd9gvZDkkz5YhpWdX",
    title: "calisthenics",
    list_url: "/styles/minimalist/calisthenics"
  },
  {
    url: "/styles/minimalist/candy-paolo-nutini-RUqiS4vBWB75kWMrCKDXwB",
    title: "candy paolo nutini",
    list_url: "/styles/minimalist/candy-paolo-nutini"
  },
  {
    url: "/styles/minimalist/gladiolus-and-snowdrop-bouquet-DU3gjhLSi1e4V3rNV6Ukbe",
    title: "gladiolus and snowdrop bouquet",
    list_url: "/styles/minimalist/gladiolus-and-snowdrop-bouquet"
  },
  {
    url: "/styles/minimalist/heron-flying-F2waMdGQJnMMAJkJKCesyA",
    title: "heron flying",
    list_url: "/styles/minimalist/heron-flying"
  },
  {
    url: "/styles/minimalist/kaguya-otsutsuki-naruto-hentai-art-QNyzh7xm64fwi89mq7WkTy",
    title: "kaguya otsutsuki naruto hentai art",
    list_url: "/styles/minimalist/kaguya-otsutsuki-naruto-hentai-art"
  },
  {
    url: "/styles/minimalist/lead-with-love-9mQdqC7XFj5bbFAcoTEd8i",
    title: "lead with love",
    list_url: "/styles/minimalist/lead-with-love"
  },
  {
    url: "/styles/minimalist/nqtd-6uVBaSG1CGFiCmjizsqVFa",
    title: "nqtd",
    list_url: "/styles/minimalist/nqtd"
  },
  {
    url: "/styles/minimalist/ocean-wave-with-stars-and-dog-paw-print-5knCW9uUP9VyQdbGzSdfRn",
    title: "ocean wave with stars and dog paw print",
    list_url: "/styles/minimalist/ocean-wave-with-stars-and-dog-paw-print"
  },
  {
    url: "/styles/minimalist/queen-of-spades-CzrCXt32VbLRdbr7gKAwDY",
    title: "queen of spades",
    list_url: "/styles/minimalist/queen-of-spades"
  },
  {
    url: "/styles/minimalist/romans-1210-be-devoted-to-one-another-CktaadVxztFnvPmzzjsM9A",
    title: "romans be devoted to one another",
    list_url: "/styles/minimalist/romans-1210-be-devoted-to-one-another"
  },
  {
    url: "/styles/neotraditional/b52-bomber-4KLcJHBnyUuhjEPfyTnMwb",
    title: "b bomber",
    list_url: "/styles/neotraditional/b52-bomber"
  },
  {
    url: "/styles/neotraditional/christian-hand-tattoo-4ve5qTDZpudUfyTr4pQgVF",
    title: "christian hand tattoo",
    list_url: "/styles/neotraditional/christian-hand-tattoo"
  },
  {
    url: "/styles/neotraditional/girl-with-her-mouth-sewn-shut-VNcdwshZWyvwcEXhGhr4q8",
    title: "girl with her mouth sewn shut",
    list_url: "/styles/neotraditional/girl-with-her-mouth-sewn-shut"
  },
  {
    url: "/styles/neotraditional/jcb-49bnuUDVG2HJEQVepNTqKe",
    title: "jcb",
    list_url: "/styles/neotraditional/jcb"
  },
  {
    url: "/styles/neotraditional/kalpana-and-punit-name-tattoo-AXFgctceupHG45c8WaqdpM",
    title: "kalpana and punit name tattoo",
    list_url: "/styles/neotraditional/kalpana-and-punit-name-tattoo"
  },
  {
    url: "/styles/neotraditional/machinist-KfdmHUP4JYwL9DS7erxde3",
    title: "machinist",
    list_url: "/styles/neotraditional/machinist"
  },
  {
    url: "/styles/neotraditional/the-name-melissa-XyZG2wRBhaJf1ttzfUoQLb",
    title: "the name melissa",
    list_url: "/styles/neotraditional/the-name-melissa"
  },
  {
    url: "/styles/neotraditional/woman-bent-over-tied-up-with-rope-JsCMEho41YPwdH9SXHe4RS",
    title: "woman bent over tied up with rope",
    list_url: "/styles/neotraditional/woman-bent-over-tied-up-with-rope"
  },
  {
    url: "/styles/realism/bukkake-Avf36r8CnXrCxyJYhLCMm7",
    title: "bukkake",
    list_url: "/styles/realism/bukkake"
  },
  {
    url: "/styles/realism/lesbian-kissing-aWABL1wAcxttNTDSnigx6",
    title: "lesbian kissing",
    list_url: "/styles/realism/lesbian-kissing"
  },
  {
    url: "/styles/realism/lyrics-from-pnks-song-turbulence-with-DdxCNo7vnFCSgTHyr8nMnQ",
    title: "lyrics from pnks song turbulence with",
    list_url: "/styles/realism/lyrics-from-pnks-song-turbulence-with"
  },
  {
    url: "/styles/realism/naked-body-of-a-woman-without-panties-DStCCY4a1ziQRWWjx4V14n",
    title: "naked body of a woman without panties",
    list_url: "/styles/realism/naked-body-of-a-woman-without-panties"
  },
  {
    url: "/styles/realism/name-adi-ELcxYp7t464oJjY5gvfcpZ",
    title: "name adi",
    list_url: "/styles/realism/name-adi"
  },
  {
    url: "/styles/realism/pinup-girl-topless-in-thong-LpRi3jLFuRHsUygAN64TxV",
    title: "pinup girl topless in thong",
    list_url: "/styles/realism/pinup-girl-topless-in-thong"
  },
  {
    url: "/styles/realism/rose-with-writing-inside-stem-B14CgSbmR6niWFXmuKeKJf",
    title: "rose with writing inside stem",
    list_url: "/styles/realism/rose-with-writing-inside-stem"
  },
  {
    url: "/styles/realism/santo-nino-MJStDm7YGbsUCBQfna5r5C",
    title: "santo nino",
    list_url: "/styles/realism/santo-nino"
  },
  {
    url: "/styles/realism/snake-in-a-tree-FFFsNXXjBEYMAGLEeDW3So",
    title: "snake in a tree",
    list_url: "/styles/realism/snake-in-a-tree"
  },
  {
    url: "/styles/realism/submissive-slave-femdom-4DgNrU9pTpaHYW9yWcvaF2",
    title: "submissive slave femdom",
    list_url: "/styles/realism/submissive-slave-femdom"
  },
  {
    url: "/styles/sketch/horror-characters-9TxVTffRNJo5ve9YsRiWry",
    title: "horror characters",
    list_url: "/styles/sketch/horror-characters"
  },
  {
    url: "/styles/sketch/imago-dei-with-flowers-GYqiREUpd3Ss6jBwFcF1Jx",
    title: "imago dei with flowers",
    list_url: "/styles/sketch/imago-dei-with-flowers"
  },
  {
    url: "/styles/sketch/marine-corps-0311-QuAqMXt4wddnH3PTEfDYHH",
    title: "marine corps ",
    list_url: "/styles/sketch/marine-corps-0311"
  },
  {
    url: "/styles/sketch/money-magnet-in-four-leaf-clover-HCSPJsQpLeZmneGLStffxi",
    title: "money magnet in four leaf clover",
    list_url: "/styles/sketch/money-magnet-in-four-leaf-clover"
  },
  {
    url: "/styles/sketch/paw-print-Aj4XaeukeFRRHjdP6CrHku",
    title: "paw print",
    list_url: "/styles/sketch/paw-print"
  },
  {
    url: "/styles/sketch/samudra-manthan-Xi9cizJZSE4bwnA24evrUt",
    title: "samudra manthan",
    list_url: "/styles/sketch/samudra-manthan"
  },
  {
    url: "/styles/stencil/bdsm-triskelion-ESbV8DjC5GoyTCfzAhhRiV",
    title: "bdsm triskelion",
    list_url: "/styles/stencil/bdsm-triskelion"
  },
  {
    url: "/styles/stencil/fullmetal-alchemist-transmutation-circle-Lqb7CgY9pJGs8g6wrRYzKt",
    title: "fullmetal alchemist transmutation circle",
    list_url: "/styles/stencil/fullmetal-alchemist-transmutation-circle"
  },
  {
    url: "/styles/stencil/write-priyanshi-in-different-font-RzdxNatobEUK8j5wAXAUYC",
    title: "write priyanshi in different font",
    list_url: "/styles/stencil/write-priyanshi-in-different-font"
  },
  {
    url: "/styles/surrealism/the-name-logan-R6E97EDczaMh8hCrqWvF2",
    title: "the name logan",
    list_url: "/styles/surrealism/the-name-logan"
  },
  {
    url: "/styles/traditional/bariatric-surgery-744KZBtKrrS1UpN2u4bGKH",
    title: "bariatric surgery",
    list_url: "/styles/traditional/bariatric-surgery"
  },
  {
    url: "/styles/traditional/no-bad-days-5dGGQTww5dPWCziXwdb2B5",
    title: "no bad days",
    list_url: "/styles/traditional/no-bad-days"
  },
  {
    url: "/styles/trash-polka/under-breast-tattoo-a-female-warrior-HvaJyHB1H5HXP1rSbBr3bh",
    title: "under breast tattoo a female warrior",
    list_url: "/styles/trash-polka/under-breast-tattoo-a-female-warrior"
  },
  {
    url: "/styles/tribal/hassan-nasrallah-gdC9ZDJ3TgKt8ozSCBP5E",
    title: "hassan nasrallah",
    list_url: "/styles/tribal/hassan-nasrallah"
  },
  {
    url: "/styles/black-grey/archangel-uriel-PTiNk41p1Aqrimy9BUL9uL",
    title: "archangel uriel",
    list_url: "/styles/black-grey/archangel-uriel"
  },
  {
    url: "/styles/black-grey/chastity-cage-67FLeXA1Ff4PXZejPj6AQu",
    title: "chastity cage",
    list_url: "/styles/black-grey/chastity-cage"
  },
  {
    url: "/styles/black-grey/cuckold-QFu1iUSDZoU3UC4TJUygCr",
    title: "cuckold",
    list_url: "/styles/black-grey/cuckold"
  },
  {
    url: "/styles/black-grey/fire-flame-6518JauvoNaMVPaYtavxAk",
    title: "fire flame",
    list_url: "/styles/black-grey/fire-flame"
  },
  {
    url: "/styles/black-grey/for-whom-the-bell-tolls-metallica-8odiWwpNY15Qrj5FFxDu1f",
    title: "for whom the bell tolls metallica",
    list_url: "/styles/black-grey/for-whom-the-bell-tolls-metallica"
  },
  {
    url: "/styles/black-grey/fuck-feelings-F4pHrJ92KEdgvBDvd9u56f",
    title: "fuck feelings",
    list_url: "/styles/black-grey/fuck-feelings"
  },
  {
    url: "/styles/black-grey/jon-snows-sword-with-the-quote-kill-Qi2fjBJuCkh4JExNrs9FC7",
    title: "jon snows sword with the quote kill",
    list_url: "/styles/black-grey/jon-snows-sword-with-the-quote-kill"
  },
  {
    url: "/styles/black-grey/name-jacqueline-AjgFKNjyCUUrZjfoZStoRj",
    title: "name jacqueline",
    list_url: "/styles/black-grey/name-jacqueline"
  },
  {
    url: "/styles/black-grey/pennis-5u5LhvuQZk33BizDeEWKNC",
    title: "pennis",
    list_url: "/styles/black-grey/pennis"
  },
  {
    url: "/styles/black-grey/raindrops-on-roses-SF3AfExZGRgEXR8zEL5Lj6",
    title: "raindrops on roses",
    list_url: "/styles/black-grey/raindrops-on-roses"
  },
  {
    url: "/styles/black-grey/sonali-name-tattoo-design-CVtnaQYmfPSb9Unpt4ibwt",
    title: "sonali name tattoo design",
    list_url: "/styles/black-grey/sonali-name-tattoo-design"
  },
  {
    url: "/styles/black-grey/whitewater-kayakingwaterfall-kayak-5xbjX3Vq8et5ShAvySRkpM",
    title: "whitewater kayakingwaterfall kayak",
    list_url: "/styles/black-grey/whitewater-kayakingwaterfall-kayak"
  },
  {
    url: "/styles/blackwork/angel-whispering-in-ear-TnE9ovGjGAXHoeZgkx8maK",
    title: "angel whispering in ear",
    list_url: "/styles/blackwork/angel-whispering-in-ear"
  },
  {
    url: "/styles/blackwork/bend-overslim-thick-goth-girlemo-5H3BRPEKAH93yQFZVyUEVX",
    title: "bend overslim thick goth girlemo",
    list_url: "/styles/blackwork/bend-overslim-thick-goth-girlemo"
  },
  {
    url: "/styles/blackwork/cancer-and-virgo-symbols-together-with-859T3LgnjawZVK1unySXeP",
    title: "cancer and virgo symbols together with",
    list_url: "/styles/blackwork/cancer-and-virgo-symbols-together-with"
  },
  {
    url: "/styles/blackwork/demon-neshemiron-in-full-growth-with-DRQxAvsh4taNdetBgdTjCX",
    title: "demon neshemiron in full growth with",
    list_url: "/styles/blackwork/demon-neshemiron-in-full-growth-with"
  },
  {
    url: "/styles/blackwork/gothic-tattoo-design-slut-anime-girl-S83kCp4YF7SXiPVJmVS4Xs",
    title: "gothic tattoo design slut anime girl",
    list_url: "/styles/blackwork/gothic-tattoo-design-slut-anime-girl"
  },
  {
    url: "/styles/blackwork/money-talks-PdahqswBYtWPNqskQsujPW",
    title: "money talks",
    list_url: "/styles/blackwork/money-talks"
  },
  {
    url: "/styles/blackwork/number-27-MaxuL9ARHdRrQ9vG8WiBbD",
    title: "number ",
    list_url: "/styles/blackwork/number-27"
  },
  {
    url: "/styles/blackwork/overcoming-gambling-addiction-5i5n3VSSvMdqpiPAheZoE1",
    title: "overcoming gambling addiction",
    list_url: "/styles/blackwork/overcoming-gambling-addiction"
  },
  {
    url: "/styles/blackwork/poison-tree-with-bats-on-the-sides-and-V9UeVAcYo9ARTS4FimcctV",
    title: "poison tree with bats on the sides and",
    list_url: "/styles/blackwork/poison-tree-with-bats-on-the-sides-and"
  },
  {
    url: "/styles/blackwork/triskele-bdsm-triskelion-4si1HLxzQq1wsvJ7GejiWA",
    title: "triskele bdsm triskelion",
    list_url: "/styles/blackwork/triskele-bdsm-triskelion"
  },
  {
    url: "/styles/blackwork/zulfiqar-sword-2XAs1pEyqM46a3BBfgjutL",
    title: "zulfiqar sword",
    list_url: "/styles/blackwork/zulfiqar-sword"
  },
  {
    url: "/styles/dotwork/bdsm-FKJRKJvu7EeFwFfPb7yfwT",
    title: "bdsm",
    list_url: "/styles/dotwork/bdsm"
  },
  {
    url: "/styles/dotwork/guns-n-roses-sweet-child-o-mine-9YqMiFx1qCQ1hVUQ7Yepyx",
    title: "guns n roses sweet child o mine",
    list_url: "/styles/dotwork/guns-n-roses-sweet-child-o-mine"
  },
  {
    url: "/styles/dotwork/my-name-is-dipali-please-design-a-VGUDYSyhJw1bbxJjf5z2hd",
    title: "my name is dipali please design a",
    list_url: "/styles/dotwork/my-name-is-dipali-please-design-a"
  },
  {
    url: "/styles/dotwork/otomi-indigenous-K46ErByi7EEw4CrPWU2ueM",
    title: "otomi indigenous",
    list_url: "/styles/dotwork/otomi-indigenous"
  },
  {
    url: "/styles/dotwork/psalm-234-with-a-caligraphy-font-FtxWvCKbJW9yqrF8nDmKfy",
    title: "psalm with a caligraphy font",
    list_url: "/styles/dotwork/psalm-234-with-a-caligraphy-font"
  },
  {
    url: "/styles/dotwork/spartan-hoplite-in-battle-stance-9Bny1FG1D8kxFAY8mBacqM",
    title: "spartan hoplite in battle stance",
    list_url: "/styles/dotwork/spartan-hoplite-in-battle-stance"
  },
  {
    url: "/styles/geometric/polish-folk-art-inspired-with-wild-Rwco8xJUHnvuSZeECmAtdF",
    title: "polish folk art inspired with wild",
    list_url: "/styles/geometric/polish-folk-art-inspired-with-wild"
  },
  {
    url: "/styles/graffiti/bad-bitch-throwing-it-back-LsZaRuGa1gebm9oqzTS777",
    title: "bad bitch throwing it back",
    list_url: "/styles/graffiti/bad-bitch-throwing-it-back"
  },
  {
    url: "/styles/minimalist/acatenango-volcano-LpuzWVNPsFHtqTTZzbWGZF",
    title: "acatenango volcano",
    list_url: "/styles/minimalist/acatenango-volcano"
  },
  {
    url: "/styles/minimalist/bible-verse-hebrews-1211-BkWi3ssz2pfgzczUdgLoYg",
    title: "bible verse hebrews ",
    list_url: "/styles/minimalist/bible-verse-hebrews-1211"
  },
  {
    url: "/styles/minimalist/border-terrier-dog-body-curly-tail-Vm8TEXaGVM8t5ya6yhzbvG",
    title: "border terrier dog body curly tail",
    list_url: "/styles/minimalist/border-terrier-dog-body-curly-tail"
  },
  {
    url: "/styles/minimalist/broken-heart-with-name-KrJq9Gd1ugCH6fonomP719",
    title: "broken heart with name",
    list_url: "/styles/minimalist/broken-heart-with-name"
  },
  {
    url: "/styles/minimalist/combination-of-letter-a-and-letter-c-7cy2dj1ud8pXfR6BcS2c2w",
    title: "combination of letter a and letter c",
    list_url: "/styles/minimalist/combination-of-letter-a-and-letter-c"
  },
  {
    url: "/styles/minimalist/field-of-dreams-baseball-4Lic7ntaYRazopux6e7p5k",
    title: "field of dreams baseball",
    list_url: "/styles/minimalist/field-of-dreams-baseball"
  },
  {
    url: "/styles/minimalist/hamster-GN5F9NENQA7Smm9xsco8Qg",
    title: "hamster",
    list_url: "/styles/minimalist/hamster"
  },
  {
    url: "/styles/minimalist/heart-shaped-daisy-wreath-GsPFnGDJtnRqeiTvQGfcQd",
    title: "heart shaped daisy wreath",
    list_url: "/styles/minimalist/heart-shaped-daisy-wreath"
  },
  {
    url: "/styles/minimalist/initials-l-c-AX1pmk8tMBGRySd8sSWLLe",
    title: "initials l c",
    list_url: "/styles/minimalist/initials-l-c"
  },
  {
    url: "/styles/minimalist/land-rover-defender-VFSoDFtq2A9S2GzLeZ1NU6",
    title: "land rover defender",
    list_url: "/styles/minimalist/land-rover-defender"
  },
  {
    url: "/styles/minimalist/name-avantika-around-my-ring-finger-TRAcWpCCy59APzoJ7vYPnU",
    title: "name avantika around my ring finger",
    list_url: "/styles/minimalist/name-avantika-around-my-ring-finger"
  },
  {
    url: "/styles/minimalist/neuromancer-by-william-gibson-BjvrfBT1ErJyDtcoZpvjUW",
    title: "neuromancer by william gibson",
    list_url: "/styles/minimalist/neuromancer-by-william-gibson"
  },
  {
    url: "/styles/minimalist/star-wars-andor-B4hRYrtpJrQ8kp8T432Vqp",
    title: "star wars andor",
    list_url: "/styles/minimalist/star-wars-andor"
  },
  {
    url: "/styles/minimalist/the-phrase-per-aspera-ad-astra-CF4UtAzoxi2cMEsbaW1GF3",
    title: "the phrase per aspera ad astra",
    list_url: "/styles/minimalist/the-phrase-per-aspera-ad-astra"
  },
  {
    url: "/styles/minimalist/v-and-m-letter-31RuXC3PEyHHfywc1A89wD",
    title: "v and m letter",
    list_url: "/styles/minimalist/v-and-m-letter"
  },
  {
    url: "/styles/minimalist/z-letter-with-flowers-VrfjGuXhW5UVnDkuwdY6XP",
    title: "z letter with flowers",
    list_url: "/styles/minimalist/z-letter-with-flowers"
  },
  {
    url: "/styles/neotraditional/548-live-to-ride-ride-to-live-with-WBN7Hvbhsas6X8z5hyNL2B",
    title: " live to ride ride to live with",
    list_url: "/styles/neotraditional/548-live-to-ride-ride-to-live-with"
  },
  {
    url: "/styles/neotraditional/a-lotus-flower-inspired-tree-of-life-ArySYDuDhx5JoTUvJs7kpP",
    title: "a lotus flower inspired tree of life",
    list_url: "/styles/neotraditional/a-lotus-flower-inspired-tree-of-life"
  },
  {
    url: "/styles/neotraditional/final-fantasy-x-J4bv4jp4yyPf2ao6Uk5mot",
    title: "final fantasy x",
    list_url: "/styles/neotraditional/final-fantasy-x"
  },
  {
    url: "/styles/neotraditional/male-succubus-tattoo-KPLBp68QRFV65KoGGjHtHv",
    title: "male succubus tattoo",
    list_url: "/styles/neotraditional/male-succubus-tattoo"
  },
  {
    url: "/styles/neotraditional/michelle-name-tattoo-7BQCNbgqQSNb13Kg7iec9U",
    title: "michelle name tattoo",
    list_url: "/styles/neotraditional/michelle-name-tattoo"
  },
  {
    url: "/styles/neotraditional/mohan-name-written-in-hindi-in-the-5h8m1LCjpqwU1SSuf4gtpS",
    title: "mohan name written in hindi in the",
    list_url: "/styles/neotraditional/mohan-name-written-in-hindi-in-the"
  },
  {
    url: "/styles/neotraditional/mona-name-tattoo-DwJQghj2WTUUkgsg3YZRZR",
    title: "mona name tattoo",
    list_url: "/styles/neotraditional/mona-name-tattoo"
  },
  {
    url: "/styles/neotraditional/non-serviam-text-and-geometric-tattoo-6kPUvcnKpWYZhKoBnWPowe",
    title: "non serviam text and geometric tattoo",
    list_url: "/styles/neotraditional/non-serviam-text-and-geometric-tattoo"
  },
  {
    url: "/styles/neotraditional/pooja-and-kartik-8ivLkz7tGbUK3gxQEMjA5n",
    title: "pooja and kartik",
    list_url: "/styles/neotraditional/pooja-and-kartik"
  },
  {
    url: "/styles/neotraditional/rajeev-name-tattoo-Bd8jV7FqHHHsv9yhRdgdhz",
    title: "rajeev name tattoo",
    list_url: "/styles/neotraditional/rajeev-name-tattoo"
  },
  {
    url: "/styles/neotraditional/sidhu-moosewala-with-ak47-HVpTny73mcF4EjtbvFqggb",
    title: "sidhu moosewala with ak ",
    list_url: "/styles/neotraditional/sidhu-moosewala-with-ak47"
  },
  {
    url: "/styles/neotraditional/whore-3Zc2NtFHpXTmkSUdNvAtmx",
    title: "whore",
    list_url: "/styles/neotraditional/whore"
  },
  {
    url: "/styles/neotraditional/wigan-warriors-NhRC6JQRteU9Y8P6CB7sRo",
    title: "wigan warriors",
    list_url: "/styles/neotraditional/wigan-warriors"
  },
  {
    url: "/styles/neotraditional/wyatts-boner-garage-garage-logo-MSX7LnBXWx1nrcoP8rSxRb",
    title: "wyatts boner garage garage logo",
    list_url: "/styles/neotraditional/wyatts-boner-garage-garage-logo"
  },
  {
    url: "/styles/neotraditional/xxx-1969-01-23-MveozFX6MojLU5eYqxPBvG",
    title: "xxx ",
    list_url: "/styles/neotraditional/xxx-1969-01-23"
  },
  {
    url: "/styles/new-school/orange-ribbon-for-kidney-cancer-ribbon-QP9peWxnXo4UK3f4FVYDKG",
    title: "orange ribbon for kidney cancer ribbon",
    list_url: "/styles/new-school/orange-ribbon-for-kidney-cancer-ribbon"
  },
  {
    url: "/styles/realism/baseball-in-flowers-with-hummingbirds-Fv6ipy4fzkomuHhu5BJQHx",
    title: "baseball in flowers with hummingbirds",
    list_url: "/styles/realism/baseball-in-flowers-with-hummingbirds"
  },
  {
    url: "/styles/realism/constellation-with-name-agastya-J1ZGV6zHu26Vb2CFUkhato",
    title: "constellation with name agastya",
    list_url: "/styles/realism/constellation-with-name-agastya"
  },
  {
    url: "/styles/realism/girl-stretches-her-anus-with-her-8WAE1KQh75nuefSkmAivRS",
    title: "girl stretches her anus with her",
    list_url: "/styles/realism/girl-stretches-her-anus-with-her"
  },
  {
    url: "/styles/realism/half-alive-half-dead-TeaxWCShNYGCMnUxyM99oG",
    title: "half alive half dead",
    list_url: "/styles/realism/half-alive-half-dead"
  },
  {
    url: "/styles/realism/khoisan-bushman-african-tribal-sunrise-EmCKZwJbCWa1Gh6W9fhVAf",
    title: "khoisan bushman african tribal sunrise",
    list_url: "/styles/realism/khoisan-bushman-african-tribal-sunrise"
  },
  {
    url: "/styles/realism/penis-4H9uSSPdueYw8ZEGeDdmaH",
    title: "penis",
    list_url: "/styles/realism/penis"
  },
  {
    url: "/styles/realism/riley-reid-CJ1y9W79iq1MKNPJqC8nnS",
    title: "riley reid",
    list_url: "/styles/realism/riley-reid"
  },
  {
    url: "/styles/sketch/pirate-compass-with-a-kraken-B81QkCC9uLAsNAwGcGEYui",
    title: "pirate compass with a kraken",
    list_url: "/styles/sketch/pirate-compass-with-a-kraken"
  },
  {
    url: "/styles/traditional/aryan-brotherhood-VgsHgFUYPCupMGsBZdgiJw",
    title: "aryan brotherhood",
    list_url: "/styles/traditional/aryan-brotherhood"
  },
  {
    url: "/styles/traditional/heart-with-a-missing-piece-RfiSbLtw8RFLMwrbCYEVLJ",
    title: "heart with a missing piece",
    list_url: "/styles/traditional/heart-with-a-missing-piece"
  },
  {
    url: "/styles/traditional/juice-wrld-abyss-Nqoz1Uv4vXEdCmRhWP6RAw",
    title: "juice wrld abyss",
    list_url: "/styles/traditional/juice-wrld-abyss"
  },
  {
    url: "/styles/traditional/name-theo-in-greek-style-writing-X25SGHFTXjwJJ6J41zisSJ",
    title: "name theo in greek style writing",
    list_url: "/styles/traditional/name-theo-in-greek-style-writing"
  },
  {
    url: "/styles/traditional/smut-books-CHGtdYTfbPbSZ1VZZTtA67",
    title: "smut books",
    list_url: "/styles/traditional/smut-books"
  },
  {
    url: "/styles/tribal/light-bringer-Jyvc4Uv6mXHVci9xxnscqi",
    title: "light bringer",
    list_url: "/styles/tribal/light-bringer"
  },
  {
    url: "/styles/tribal/ushuaia-ibiza-colibri-DytbUwYX2iP1UAbh4kPkvX",
    title: "ushuaia ibiza colibri",
    list_url: "/styles/tribal/ushuaia-ibiza-colibri"
  },
  {
    url: "/styles/3d/agastya-name-written-A1zPEgvMQ28GBjECgViNah",
    title: "agastya name written",
    list_url: "/styles/3d/agastya-name-written"
  },
  {
    url: "/styles/anime/slave-bdsm-ewelina-sub-CckRThS9CpYHPUkLG7mM8e",
    title: "slave bdsm ewelina sub",
    list_url: "/styles/anime/slave-bdsm-ewelina-sub"
  },
  {
    url: "/styles/anime/thicc-milf-hentai-5fXRscAfHkZyYSJvryFTo1",
    title: "thicc milf hentai",
    list_url: "/styles/anime/thicc-milf-hentai"
  },
  {
    url: "/styles/black-grey/angels-fighting-demons-GcoVhcrpzHGWjqCcpeLYiP",
    title: "angels fighting demons",
    list_url: "/styles/black-grey/angels-fighting-demons"
  },
  {
    url: "/styles/black-grey/bald-gay-muscle-bear-with-a-belly-and-PPYjrWzXtGc5mueF72Vc13",
    title: "bald gay muscle bear with a belly and",
    list_url: "/styles/black-grey/bald-gay-muscle-bear-with-a-belly-and"
  },
  {
    url: "/styles/black-grey/big-titty-goth-girl-JRD84VMiagCRwHWwAHxeMs",
    title: "big titty goth girl",
    list_url: "/styles/black-grey/big-titty-goth-girl"
  },
  {
    url: "/styles/black-grey/birth-clock-for-two-kids-with-roman-H2UTQVKXkjMLrvEKxSK2fs",
    title: "birth clock for two kids with roman",
    list_url: "/styles/black-grey/birth-clock-for-two-kids-with-roman"
  },
  {
    url: "/styles/black-grey/colosseum-QtV9pxAbwCwDcfKdJerkdP",
    title: "colosseum",
    list_url: "/styles/black-grey/colosseum"
  },
  {
    url: "/styles/black-grey/feather-and-fingerprint-UZUTXE1Btc8Pr5VZmjcxrZ",
    title: "feather and fingerprint",
    list_url: "/styles/black-grey/feather-and-fingerprint"
  },
  {
    url: "/styles/black-grey/globe-with-plane-3V4MF6mk2gbSZAALSyS2g9",
    title: "globe with plane",
    list_url: "/styles/black-grey/globe-with-plane"
  },
  {
    url: "/styles/black-grey/let-them-and-butterflies-3ZdXeXwW8fZsW2apYzNZj3",
    title: "let them and butterflies",
    list_url: "/styles/black-grey/let-them-and-butterflies"
  },
  {
    url: "/styles/black-grey/liverpool-football-club-logo-dildo-2g6Arho11MVE2ZpP1shT11",
    title: "liverpool football club logo dildo",
    list_url: "/styles/black-grey/liverpool-football-club-logo-dildo"
  },
  {
    url: "/styles/black-grey/loyalty-fonts-3W84nEtP3tY7S7tNhzcZWA",
    title: "loyalty fonts",
    list_url: "/styles/black-grey/loyalty-fonts"
  },
  {
    url: "/styles/black-grey/psalm-37-FN6vmtHjwxoE2ac7yqttuZ",
    title: "psalm ",
    list_url: "/styles/black-grey/psalm-37"
  },
  {
    url: "/styles/black-grey/rose-angel-leg-sleeve-EKE6Fa5oNcWA25mJxYZuhM",
    title: "rose angel leg sleeve",
    list_url: "/styles/black-grey/rose-angel-leg-sleeve"
  },
  {
    url: "/styles/black-grey/submissive-chastity-H1GfkkvkDi46qT2UYm9J9b",
    title: "submissive chastity",
    list_url: "/styles/black-grey/submissive-chastity"
  },
  {
    url: "/styles/black-grey/sushma-95tYr5nx4EGTvr2S9eywn",
    title: "sushma",
    list_url: "/styles/black-grey/sushma"
  },
  {
    url: "/styles/black-grey/war-in-heaven-KathjYQm733Gku2fVEFoSk",
    title: "war in heaven",
    list_url: "/styles/black-grey/war-in-heaven"
  },
  {
    url: "/styles/black-grey/write-a-gayatri-name-in-hindi-text-Lz39NVnN2aSJcetmysoP5W",
    title: "write a gayatri name in hindi text",
    list_url: "/styles/black-grey/write-a-gayatri-name-in-hindi-text"
  },
  {
    url: "/styles/blackwork/a-minimalist-tattoo-of-a-winding-road-NqEm9YaSwqmDG6iPArmdzJ",
    title: "a minimalist tattoo of a winding road",
    list_url: "/styles/blackwork/a-minimalist-tattoo-of-a-winding-road"
  },
  {
    url: "/styles/blackwork/scania-logo-with-a-eagle-that-has-a-UyrzTWk7Zbx3DFbWVnYK4E",
    title: "scania logo with a eagle that has a",
    list_url: "/styles/blackwork/scania-logo-with-a-eagle-that-has-a"
  },
  {
    url: "/styles/dotwork/bouquet-with-lily-of-the-valley-and-JRqM34JodU5KL3ZvSGsLoj",
    title: "bouquet with lily of the valley and",
    list_url: "/styles/dotwork/bouquet-with-lily-of-the-valley-and"
  },
  {
    url: "/styles/dotwork/initials-intertwined-Tto9admbwm3mC4EZgdSX3S",
    title: "initials intertwined",
    list_url: "/styles/dotwork/initials-intertwined"
  },
  {
    url: "/styles/dotwork/my-way-by-frank-sinatra-P9Fe4MqaKbTgMxh5WSpf6u",
    title: "my way by frank sinatra",
    list_url: "/styles/dotwork/my-way-by-frank-sinatra"
  },
  {
    url: "/styles/dotwork/name-tattoo-mayuri-hidden-in-pecock-Q1KdMwkonifMGqN8PQt9Rm",
    title: "name tattoo mayuri hidden in pecock",
    list_url: "/styles/dotwork/name-tattoo-mayuri-hidden-in-pecock"
  },
  {
    url: "/styles/dotwork/r-letter-hidden-in-h-letter-MaE47bgYJJAzBT6sMvE1kE",
    title: "r letter hidden in h letter",
    list_url: "/styles/dotwork/r-letter-hidden-in-h-letter"
  },
  {
    url: "/styles/dotwork/subramanya-swamys-weapon-in-a-dotwork-C471dPQFc88wqfzxqcSfiS",
    title: "subramanya swamys weapon in a dotwork",
    list_url: "/styles/dotwork/subramanya-swamys-weapon-in-a-dotwork"
  },
  {
    url: "/styles/dotwork/weeping-willow-tree-GGmSb2umV3rStqijWBRbtK",
    title: "weeping willow tree",
    list_url: "/styles/dotwork/weeping-willow-tree"
  },
  {
    url: "/styles/geometric/abhi-name-text-on-finger-QUyUWBwor5EQbiRDrnzq7A",
    title: "abhi name text on finger",
    list_url: "/styles/geometric/abhi-name-text-on-finger"
  },
  {
    url: "/styles/geometric/miller-family-crest-VPqNTSbUzvXQ2yPC79i2MW",
    title: "miller family crest",
    list_url: "/styles/geometric/miller-family-crest"
  },
  {
    url: "/styles/geometric/psalm-3418-with-flowers-and-mountains-RyTNzLtMWeDSgJHbq2Xrmo",
    title: "psalm with flowers and mountains",
    list_url: "/styles/geometric/psalm-3418-with-flowers-and-mountains"
  },
  {
    url: "/styles/japanese/futanari-2uNbb1ycuEK7Hkohip4Tkw",
    title: "futanari",
    list_url: "/styles/japanese/futanari"
  },
  {
    url: "/styles/japanese/hannya-mask-full-chest-MCRhVpY7UzJnaZDyQhuDEn",
    title: "hannya mask full chest",
    list_url: "/styles/japanese/hannya-mask-full-chest"
  },
  {
    url: "/styles/japanese/komodo-dragon-XyvdxsGLXYoQKu2T5e1orn",
    title: "komodo dragon",
    list_url: "/styles/japanese/komodo-dragon"
  },
  {
    url: "/styles/minimalist/3-heart-with-birth-date-for-kids-names-SRC5sh3hoXQmLQGsKerxrC",
    title: " heart with birth date for kids names",
    list_url: "/styles/minimalist/3-heart-with-birth-date-for-kids-names"
  },
  {
    url: "/styles/minimalist/anam-cara-9uGWtxqiff7eMDxaKNY1Zu",
    title: "anam cara",
    list_url: "/styles/minimalist/anam-cara"
  },
  {
    url: "/styles/minimalist/august-birth-flower-with-name-in-5LtFLZPkUNpcnBrHsq7PxF",
    title: "august birth flower with name in",
    list_url: "/styles/minimalist/august-birth-flower-with-name-in"
  },
  {
    url: "/styles/minimalist/breaking-generational-curses-JpNaswYzaiTADUrGbi76cv",
    title: "breaking generational curses",
    list_url: "/styles/minimalist/breaking-generational-curses"
  },
  {
    url: "/styles/minimalist/busch-light-mountains-RpvGG3KzH8zbDbeVvSJ2PJ",
    title: "busch light mountains",
    list_url: "/styles/minimalist/busch-light-mountains"
  },
  {
    url: "/styles/minimalist/butterfly-with-letter-p-MGb8jz1QKG1nq6JCY5JaHa",
    title: "butterfly with letter p",
    list_url: "/styles/minimalist/butterfly-with-letter-p"
  },
  {
    url: "/styles/minimalist/celtic-owl-TeWRn2b6UracxSzCkEcZ9Z",
    title: "celtic owl",
    list_url: "/styles/minimalist/celtic-owl"
  },
  {
    url: "/styles/minimalist/cover-me-up-morgan-wallen-lyrics-4Z9KY9YJcnQW6AgcmJijj8",
    title: "cover me up morgan wallen lyrics",
    list_url: "/styles/minimalist/cover-me-up-morgan-wallen-lyrics"
  },
  {
    url: "/styles/minimalist/f-22-raptor-Ro47ePqcoYdmWoRR5Ds82m",
    title: "f raptor",
    list_url: "/styles/minimalist/f-22-raptor"
  },
  {
    url: "/styles/minimalist/i-xxx-mmxix-roman-numerals-9zr7xnxQ9dvS3Q5ChxUnbH",
    title: "i xxx mmxix roman numerals",
    list_url: "/styles/minimalist/i-xxx-mmxix-roman-numerals"
  },
  {
    url: "/styles/minimalist/lion-with-sun-BTm5FTN7M5vsudwfJ1q4cV",
    title: "lion with sun",
    list_url: "/styles/minimalist/lion-with-sun"
  },
  {
    url: "/styles/minimalist/lord-of-the-rings-riders-of-rohan-5Rf5mhgkDkQDjtCKWBkXEP",
    title: "lord of the rings riders of rohan",
    list_url: "/styles/minimalist/lord-of-the-rings-riders-of-rohan"
  },
  {
    url: "/styles/minimalist/roman-numerals-date-RprcsiomDh1oi4A5WdTQTH",
    title: "roman numerals date",
    list_url: "/styles/minimalist/roman-numerals-date"
  },
  {
    url: "/styles/minimalist/the-letters-h-and-t-SeMCJKhzNvVg6LhpB9ne2D",
    title: "the letters h and t",
    list_url: "/styles/minimalist/the-letters-h-and-t"
  },
  {
    url: "/styles/minimalist/tri-hita-karana-balinese-Nr6qNG19Z4cojpQpjCjxbT",
    title: "tri hita karana balinese",
    list_url: "/styles/minimalist/tri-hita-karana-balinese"
  },
  {
    url: "/styles/neotraditional/1-is-too-many-1000-is-never-enough-VjY9uJBSfay5CzRoubpn2f",
    title: " is too many is never enough",
    list_url: "/styles/neotraditional/1-is-too-many-1000-is-never-enough"
  },
  {
    url: "/styles/neotraditional/anindita-name-under-the-phoenix-bird-JR11c95dTUyqzEWUYsMc9v",
    title: "anindita name under the phoenix bird",
    list_url: "/styles/neotraditional/anindita-name-under-the-phoenix-bird"
  },
  {
    url: "/styles/neotraditional/blonde-pinup-girl-getting-choked-U1CgDLNEMenqBamD2if8QS",
    title: "blonde pinup girl getting choked",
    list_url: "/styles/neotraditional/blonde-pinup-girl-getting-choked"
  },
  {
    url: "/styles/neotraditional/flight-attendant-pin-up-girl-black-hair-VbULAXHXwHLSiNnnMzunGr",
    title: "flight attendant pin up girl black hair",
    list_url: "/styles/neotraditional/flight-attendant-pin-up-girl-black-hair"
  },
  {
    url: "/styles/neotraditional/hardik-name-tattoo-with-peacock-feather-3rve2mgiKtTcXM4TkGPYec",
    title: "hardik name tattoo with peacock feather",
    list_url: "/styles/neotraditional/hardik-name-tattoo-with-peacock-feather"
  },
  {
    url: "/styles/neotraditional/leela-name-29WocxrY8jmE1rPCr4e1hM",
    title: "leela name",
    list_url: "/styles/neotraditional/leela-name"
  },
  {
    url: "/styles/neotraditional/let-go-let-god-6QSdqnUSBKcgbdtKZvSciT",
    title: "let go let god",
    list_url: "/styles/neotraditional/let-go-let-god"
  },
  {
    url: "/styles/neotraditional/libertarian-8NtYxGt7t7jyt8MtSSEEi3",
    title: "libertarian",
    list_url: "/styles/neotraditional/libertarian"
  },
  {
    url: "/styles/neotraditional/patience-symbol-AFKAZi7bbxKwgzoz6PXtwG",
    title: "patience symbol",
    list_url: "/styles/neotraditional/patience-symbol"
  },
  {
    url: "/styles/neotraditional/slut-butterfly-5HtY4bwh4oadTSu3A27iuD",
    title: "slut butterfly",
    list_url: "/styles/neotraditional/slut-butterfly"
  },
  {
    url: "/styles/neotraditional/soumya-name-minimalist-tattoo-for-chest-7kFjWxAqhk6eW2sEAkUKdq",
    title: "soumya name minimalist tattoo for chest",
    list_url: "/styles/neotraditional/soumya-name-minimalist-tattoo-for-chest"
  },
  {
    url: "/styles/neotraditional/the-name-logan-in-a-negative-space-QyzJtLD4igMXZ9R4Le15pq",
    title: "the name logan in a negative space",
    list_url: "/styles/neotraditional/the-name-logan-in-a-negative-space"
  },
  {
    url: "/styles/realism/ash-tree-DJssMzJCR5b71GmKBUSY2p",
    title: "ash tree",
    list_url: "/styles/realism/ash-tree"
  },
  {
    url: "/styles/realism/cherokee-rose-QUapmnfkRnbyvKQoyQ17hi",
    title: "cherokee rose",
    list_url: "/styles/realism/cherokee-rose"
  },
  {
    url: "/styles/realism/eagle-calf-Rwj6RLLWC1BdGgj7E6eoRL",
    title: "eagle calf",
    list_url: "/styles/realism/eagle-calf"
  },
  {
    url: "/styles/realism/eurofighter-typhoon-WbWmXSafvSSqfdtNpziuk9",
    title: "eurofighter typhoon",
    list_url: "/styles/realism/eurofighter-typhoon"
  },
  {
    url: "/styles/realism/golden-teacher-mushroom-with-word-7XuZjbbrS2SgMna3spY3iq",
    title: "golden teacher mushroom with word",
    list_url: "/styles/realism/golden-teacher-mushroom-with-word"
  },
  {
    url: "/styles/realism/rosary-tattoo-on-shoulder-GSd7uHXE31Tk99MYXx3f7",
    title: "rosary tattoo on shoulder",
    list_url: "/styles/realism/rosary-tattoo-on-shoulder"
  },
  {
    url: "/styles/realism/rose-with-spider-web-rose-with-spider-9dEQQnpDeufuKPMdT25Rxa",
    title: "rose with spider web rose with spider",
    list_url: "/styles/realism/rose-with-spider-web-rose-with-spider"
  },
  {
    url: "/styles/realism/tetelestai-3fGRgeHzWLToawKiqYmYze",
    title: "tetelestai",
    list_url: "/styles/realism/tetelestai"
  },
  {
    url: "/styles/sketch/1981-roman-numerals-AAEWsSpu6v1xU6EWf88SaS",
    title: " roman numerals",
    list_url: "/styles/sketch/1981-roman-numerals"
  },
  {
    url: "/styles/sketch/chaconia-and-ginger-thomas-flowers-Hdju6xiFGez816FqHyWyWG",
    title: "chaconia and ginger thomas flowers",
    list_url: "/styles/sketch/chaconia-and-ginger-thomas-flowers"
  },
  {
    url: "/styles/sketch/fuck-them-kids-GQGUTuxyBjB12xjPzcr4ZT",
    title: "fuck them kids",
    list_url: "/styles/sketch/fuck-them-kids"
  },
  {
    url: "/styles/sketch/matthew-516-be-the-light-MAbetiQQJrKQUojpR9LZYW",
    title: "matthew be the light",
    list_url: "/styles/sketch/matthew-516-be-the-light"
  },
  {
    url: "/styles/sketch/montana-montserrat-GbVjjNEkFZFBj46qsvsyCG",
    title: "montana montserrat",
    list_url: "/styles/sketch/montana-montserrat"
  },
  {
    url: "/styles/sketch/name-pratiksha-JWCK8fQMiUpG3m2bpNdHif",
    title: "name pratiksha",
    list_url: "/styles/sketch/name-pratiksha"
  },
  {
    url: "/styles/sketch/november-and-april-birth-flowers-VLSFge7JpeNJayW1KaGiw8",
    title: "november and april birth flowers",
    list_url: "/styles/sketch/november-and-april-birth-flowers"
  },
  {
    url: "/styles/sketch/rose-and-thistle-5EDfbgmy4tp3VooKRKYmfn",
    title: "rose and thistle",
    list_url: "/styles/sketch/rose-and-thistle"
  },
  {
    url: "/styles/stencil/a-beautiful-feminine-shemale-4S2oHW9Jp2pCFReXrWgqWm",
    title: "a beautiful feminine shemale",
    list_url: "/styles/stencil/a-beautiful-feminine-shemale"
  },
  {
    url: "/styles/stencil/tattoo-that-says-get-rich-or-die-664gCXKU8ZUeAWWvfnj9kN",
    title: "tattoo that says get rich or die",
    list_url: "/styles/stencil/tattoo-that-says-get-rich-or-die"
  },
  {
    url: "/styles/traditional/embrace-the-suck-EN4fG3cgxYMd6pD9P969rf",
    title: "embrace the suck",
    list_url: "/styles/traditional/embrace-the-suck"
  },
  {
    url: "/styles/traditional/green-bay-packers-M9BUuVEM1CHbtPiLrKKX2F",
    title: "green bay packers",
    list_url: "/styles/traditional/green-bay-packers"
  },
  {
    url: "/styles/tribal/colombian-indigenous-tribes-tribal-MFLBzHrkzZ4DZzpknzQgmX",
    title: "colombian indigenous tribes tribal",
    list_url: "/styles/tribal/colombian-indigenous-tribes-tribal"
  },
  {
    url: "/styles/tribal/huns-8n5APd6iHMYRrdSJymPg7D",
    title: "huns",
    list_url: "/styles/tribal/huns"
  },
  {
    url: "/styles/tribal/kantara-Qq5RNX6xBhMUYvxm8SDuzn",
    title: "kantara",
    list_url: "/styles/tribal/kantara"
  },
  {
    url: "/styles/watercolor/dont-mistake-my-kindness-for-weakness-7kt5MNphXcUMsapgWwNANa",
    title: "dont mistake my kindness for weakness",
    list_url: "/styles/watercolor/dont-mistake-my-kindness-for-weakness"
  },
  {
    url: "/styles/anime/big-titty-goth-girl-bending-over-7KzQWnsqZmXenrVuJb8Xuj",
    title: "big titty goth girl bending over",
    list_url: "/styles/anime/big-titty-goth-girl-bending-over"
  },
  {
    url: "/styles/black-grey/2-clocks-with-dates-and-kids-names-5WtgEMgGbmTeUjMmFdd6cq",
    title: " clocks with dates and kids names",
    list_url: "/styles/black-grey/2-clocks-with-dates-and-kids-names"
  },
  {
    url: "/styles/black-grey/a-palm-tree-and-beach-sunset-with-waves-9Vks7M8JFArHxyfTtXaZMv",
    title: "a palm tree and beach sunset with waves",
    list_url: "/styles/black-grey/a-palm-tree-and-beach-sunset-with-waves"
  },
  {
    url: "/styles/black-grey/a-tree-of-life-in-a-dream-catcher-HFcxUAfWmyoGQBix2Scwqi",
    title: "a tree of life in a dream catcher",
    list_url: "/styles/black-grey/a-tree-of-life-in-a-dream-catcher"
  },
  {
    url: "/styles/black-grey/a-vintage-irish-republican-army-poster-77S2JkjdUZ22baqZhBR83T",
    title: "a vintage irish republican army poster",
    list_url: "/styles/black-grey/a-vintage-irish-republican-army-poster"
  },
  {
    url: "/styles/black-grey/anju-name-tattoo-SJVJA3w17xuX3fu1sr1X96",
    title: "anju name tattoo",
    list_url: "/styles/black-grey/anju-name-tattoo"
  },
  {
    url: "/styles/black-grey/archangel-michael-KiRoteiytJdKy4StwhaDKh",
    title: "archangel michael",
    list_url: "/styles/black-grey/archangel-michael"
  },
  {
    url: "/styles/black-grey/call-of-duty-zombies-2qL8afeYoBgnCo2BDcxT6e",
    title: "call of duty zombies",
    list_url: "/styles/black-grey/call-of-duty-zombies"
  },
  {
    url: "/styles/black-grey/destruction-of-sodom-and-gomorrah-CkEegoSzY22o7dH3TJpKpq",
    title: "destruction of sodom and gomorrah",
    list_url: "/styles/black-grey/destruction-of-sodom-and-gomorrah"
  },
  {
    url: "/styles/black-grey/fuck-the-world-5Pd9ioCQGQcnUoocLREiES",
    title: "fuck the world",
    list_url: "/styles/black-grey/fuck-the-world"
  },
  {
    url: "/styles/black-grey/ive-got-a-price-tag-on-this-heavy-head-K4CnG9ckiZkBnU7wvPrZnB",
    title: "ive got a price tag on this heavy head",
    list_url: "/styles/black-grey/ive-got-a-price-tag-on-this-heavy-head"
  },
  {
    url: "/styles/black-grey/matthew-10-34-KBii9T2Mcrx4GZbUQaQDsu",
    title: "matthew ",
    list_url: "/styles/black-grey/matthew-10-34"
  },
  {
    url: "/styles/black-grey/name-with-a-snake-wrapped-PVGrH44Hqc4fhJ9UqnfBEY",
    title: "name with a snake wrapped",
    list_url: "/styles/black-grey/name-with-a-snake-wrapped"
  },
  {
    url: "/styles/black-grey/owned-owned-submissive-TZemm7L6NybvVCELjzupis",
    title: "owned owned submissive",
    list_url: "/styles/black-grey/owned-owned-submissive"
  },
  {
    url: "/styles/black-grey/rangers-fc-RyZxy3Hri83mL3qXwL5Jqa",
    title: "rangers fc",
    list_url: "/styles/black-grey/rangers-fc"
  },
  {
    url: "/styles/black-grey/royal-marines-dagger-SnBzrthnTkAj9XgtRNgEf4",
    title: "royal marines dagger",
    list_url: "/styles/black-grey/royal-marines-dagger"
  },
  {
    url: "/styles/black-grey/saint-michael-paratrooper-XaTm5xD8XQGFZetZXPzW5Z",
    title: "saint michael paratrooper",
    list_url: "/styles/black-grey/saint-michael-paratrooper"
  },
  {
    url: "/styles/black-grey/st-joseph-TmPWdHkg8baNyPFXJp2CyX",
    title: "st joseph",
    list_url: "/styles/black-grey/st-joseph"
  },
  {
    url: "/styles/black-grey/swati-name-JqUybK4DWDqgJduRJRKMT4",
    title: "swati name",
    list_url: "/styles/black-grey/swati-name"
  },
  {
    url: "/styles/black-grey/the-movie-the-town-nun-tattoo-design-V4YEUJaxcv7JV3HwvF5KPE",
    title: "the movie the town nun tattoo design",
    list_url: "/styles/black-grey/the-movie-the-town-nun-tattoo-design"
  },
  {
    url: "/styles/black-grey/the-name-jude-JFvjdcLPGr2vRiAEowq8P2",
    title: "the name jude",
    list_url: "/styles/black-grey/the-name-jude"
  },
  {
    url: "/styles/black-grey/tuk-tuk-2P6nc9cpEbXeA6ATbHjRC2",
    title: "tuk tuk",
    list_url: "/styles/black-grey/tuk-tuk"
  },
  {
    url: "/styles/black-grey/vijay-name-written-FkmP8LWBrEQPfwUh8SSoLd",
    title: "vijay name written",
    list_url: "/styles/black-grey/vijay-name-written"
  },
  {
    url: "/styles/blackwork/ancient-roman-lion-GHQj2J2vcp2ESuHVenAzab",
    title: "ancient roman lion",
    list_url: "/styles/blackwork/ancient-roman-lion"
  },
  {
    url: "/styles/blackwork/combine-the-german-eagle-and-the-polish-2L9WGBozDc3qpTMLy4c6u2",
    title: "combine the german eagle and the polish",
    list_url: "/styles/blackwork/combine-the-german-eagle-and-the-polish"
  },
  {
    url: "/styles/blackwork/forgotten-by-the-plot-in-you-S2pR59pcETqv3Q26X941Jw",
    title: "forgotten by the plot in you",
    list_url: "/styles/blackwork/forgotten-by-the-plot-in-you"
  },
  {
    url: "/styles/blackwork/hathor-3PLrXk3bUJCxXBCFGDx4e9",
    title: "hathor",
    list_url: "/styles/blackwork/hathor"
  },
  {
    url: "/styles/blackwork/jesus-vine-and-the-branches-john-155-QWHCLYhpJvEnt3AhVEHeuv",
    title: "jesus vine and the branches john ",
    list_url: "/styles/blackwork/jesus-vine-and-the-branches-john-155"
  },
  {
    url: "/styles/blackwork/something-that-depicts-you-vs-you-G3w7q6eZ8R1c1w2QhznLMP",
    title: "something that depicts you vs you",
    list_url: "/styles/blackwork/something-that-depicts-you-vs-you"
  },
  {
    url: "/styles/dotwork/august-birth-flower-gladiolus-and-poppy-TfBkF9D4QCcfELj2RR6v1G",
    title: "august birth flower gladiolus and poppy",
    list_url: "/styles/dotwork/august-birth-flower-gladiolus-and-poppy"
  },
  {
    url: "/styles/dotwork/clouds-Fpu1RmTyYhx2ocsC7Xf5Bw",
    title: "clouds",
    list_url: "/styles/dotwork/clouds"
  },
  {
    url: "/styles/dotwork/create-narsingh-and-savitri-name-tatto-SmM6uajK4tckBp3Dy38uWk",
    title: "create narsingh and savitri name tatto",
    list_url: "/styles/dotwork/create-narsingh-and-savitri-name-tatto"
  },
  {
    url: "/styles/dotwork/dhruv-name-in-code-language-Vg5rchiHPYbbvgHhpvn3Ms",
    title: "dhruv name in code language",
    list_url: "/styles/dotwork/dhruv-name-in-code-language"
  },
  {
    url: "/styles/dotwork/indian-gods-hanuman-ram-sita-lakshman-L6k7ENsnfM7jQSRY5jHu2E",
    title: "indian gods hanuman ram sita lakshman",
    list_url: "/styles/dotwork/indian-gods-hanuman-ram-sita-lakshman"
  },
  {
    url: "/styles/dotwork/latina-queen-of-spades-JBu68ZHpNxi6gEThsnoy4t",
    title: "latina queen of spades",
    list_url: "/styles/dotwork/latina-queen-of-spades"
  },
  {
    url: "/styles/dotwork/mobile-legends-7vTCHvz1h8nDKkk33vk1sB",
    title: "mobile legends",
    list_url: "/styles/dotwork/mobile-legends"
  },
  {
    url: "/styles/dotwork/montu-egyptian-god-of-war-pp1sqyEomWHW8ebmwUZr2",
    title: "montu egyptian god of war",
    list_url: "/styles/dotwork/montu-egyptian-god-of-war"
  },
  {
    url: "/styles/dotwork/name-with-clouds-B7udeJSCwh1rLXRTBVd3pq",
    title: "name with clouds",
    list_url: "/styles/dotwork/name-with-clouds"
  },
  {
    url: "/styles/dotwork/the-name-molly-written-in-a-beautiful-F2a3iayyzEgP8XvNVj6som",
    title: "the name molly written in a beautiful",
    list_url: "/styles/dotwork/the-name-molly-written-in-a-beautiful"
  },
  {
    url: "/styles/dotwork/yamraj-angry-M1PH5qZMTGiib4QQQKLANQ",
    title: "yamraj angry",
    list_url: "/styles/dotwork/yamraj-angry"
  },
  {
    url: "/styles/dotwork/zimbabwe-99KofznPvQfDu8WjTAWZWk",
    title: "zimbabwe",
    list_url: "/styles/dotwork/zimbabwe"
  },
  {
    url: "/styles/geometric/chicago-skyline-L47AFMJCzMWGf3172kvdJv",
    title: "chicago skyline",
    list_url: "/styles/geometric/chicago-skyline"
  },
  {
    url: "/styles/geometric/merkaba-HoeWDPJZpzoNa2vqSBGQoW",
    title: "merkaba",
    list_url: "/styles/geometric/merkaba"
  },
  {
    url: "/styles/japanese/pig-X3KBEwp3xQYBwN9TdHUn5p",
    title: "pig",
    list_url: "/styles/japanese/pig"
  },
  {
    url: "/styles/japanese/sisters-CMPkxfTiYRpNae967RiK3U",
    title: "sisters",
    list_url: "/styles/japanese/sisters"
  },
  {
    url: "/styles/japanese/yuvan-name-tattoo-Q6vm9VsGRLSegTavUrmupJ",
    title: "yuvan name tattoo",
    list_url: "/styles/japanese/yuvan-name-tattoo"
  },
  {
    url: "/styles/minimalist/1-corinthians-134-8-GRttp9oE3VgYiXQpvm3n3s",
    title: " corinthians ",
    list_url: "/styles/minimalist/1-corinthians-134-8"
  },
  {
    url: "/styles/minimalist/a-network-engineer-themed-tattoo-AGn1xCAnMoNc9L6wmzCRqX",
    title: "a network engineer themed tattoo",
    list_url: "/styles/minimalist/a-network-engineer-themed-tattoo"
  },
  {
    url: "/styles/minimalist/aston-villa-1874-PedsoX1eqW9rHSmp3K3PbV",
    title: "aston villa ",
    list_url: "/styles/minimalist/aston-villa-1874"
  },
  {
    url: "/styles/minimalist/berserk-brand-of-sacrifice-7j71XhRiBR11duiYBzKDKn",
    title: "berserk brand of sacrifice",
    list_url: "/styles/minimalist/berserk-brand-of-sacrifice"
  },
  {
    url: "/styles/minimalist/bougainvillea-7XSDEQYt9StsiMy7Qr89dt",
    title: "bougainvillea",
    list_url: "/styles/minimalist/bougainvillea"
  },
  {
    url: "/styles/minimalist/conqueror-N45BgRxYhLjBbakt2SdQGd",
    title: "conqueror",
    list_url: "/styles/minimalist/conqueror"
  },
  {
    url: "/styles/minimalist/flower-bouquet-fine-line-avu6MoFrHzdD6F3ubQg99",
    title: "flower bouquet fine line",
    list_url: "/styles/minimalist/flower-bouquet-fine-line"
  },
  {
    url: "/styles/minimalist/freedom-beauty-truth-and-love-from-6CkQup6AkGDa26NRy1TpAp",
    title: "freedom beauty truth and love from",
    list_url: "/styles/minimalist/freedom-beauty-truth-and-love-from"
  },
  {
    url: "/styles/minimalist/kinky-sissy-slave-pink-leather-collar-6sLurumWFUNQ2dfSBCL2KS",
    title: "kinky sissy slave pink leather collar",
    list_url: "/styles/minimalist/kinky-sissy-slave-pink-leather-collar"
  },
  {
    url: "/styles/minimalist/naked-girl-angel-XkMdF6P29hdnLEuRTr5mW1",
    title: "naked girl angel",
    list_url: "/styles/minimalist/naked-girl-angel"
  },
  {
    url: "/styles/minimalist/no-excuses-UJqGAfyEj9YMWxAxoG2dHq",
    title: "no excuses",
    list_url: "/styles/minimalist/no-excuses"
  },
  {
    url: "/styles/minimalist/paddle-board-9NEzhW1AfofvjEMixwu11j",
    title: "paddle board",
    list_url: "/styles/minimalist/paddle-board"
  },
  {
    url: "/styles/minimalist/pharmacy-WYGhYxH1cZ6p6k2HV1QqJE",
    title: "pharmacy",
    list_url: "/styles/minimalist/pharmacy"
  },
  {
    url: "/styles/minimalist/polish-slavic-UvSzAUqtbuH6V2gkYboTH",
    title: "polish slavic",
    list_url: "/styles/minimalist/polish-slavic"
  },
  {
    url: "/styles/minimalist/small-roller-coaster-doing-a-loop-9cj2kLM3vbAh2SjVoJsJGS",
    title: "small roller coaster doing a loop",
    list_url: "/styles/minimalist/small-roller-coaster-doing-a-loop"
  },
  {
    url: "/styles/minimalist/the-name-ivory-in-a-bold-fancy-cursive-HQDFG4Vox5X3jL2qRGDhXP",
    title: "the name ivory in a bold fancy cursive",
    list_url: "/styles/minimalist/the-name-ivory-in-a-bold-fancy-cursive"
  },
  {
    url: "/styles/minimalist/tulips-and-butterflies-Pyrh1NX5rfU9PsEBCHm1Yc",
    title: "tulips and butterflies",
    list_url: "/styles/minimalist/tulips-and-butterflies"
  },
  {
    url: "/styles/minimalist/words-me-myself-and-i-8BbmLKWXAw3cCuB8cjL5Ya",
    title: "words me myself and i",
    list_url: "/styles/minimalist/words-me-myself-and-i"
  },
  {
    url: "/styles/neotraditional/duty-is-heavier-than-a-mountain-death-WNEAhvYstjrX3jCxobxQxW",
    title: "duty is heavier than a mountain death",
    list_url: "/styles/neotraditional/duty-is-heavier-than-a-mountain-death"
  },
  {
    url: "/styles/neotraditional/ferris-wheel-DDMipcHQcXFkQXVhug3spL",
    title: "ferris wheel",
    list_url: "/styles/neotraditional/ferris-wheel"
  },
  {
    url: "/styles/neotraditional/flowers-and-mountains-8GPbJc22nxAwDBxFPsKGRh",
    title: "flowers and mountains",
    list_url: "/styles/neotraditional/flowers-and-mountains"
  },
  {
    url: "/styles/neotraditional/name-hayden-4ruNDo3fhG6wN7W2reurSm",
    title: "name hayden",
    list_url: "/styles/neotraditional/name-hayden"
  },
  {
    url: "/styles/realism/burn-the-ships-H7jEdQfAQfa4wK8mpxfScK",
    title: "burn the ships",
    list_url: "/styles/realism/burn-the-ships"
  },
  {
    url: "/styles/realism/clouds-and-stars-Vn6FPMnL4yxQxtrusRXpHz",
    title: "clouds and stars",
    list_url: "/styles/realism/clouds-and-stars"
  },
  {
    url: "/styles/realism/enoch-BD92GMmWaviKB1Sm6eJa9L",
    title: "enoch",
    list_url: "/styles/realism/enoch"
  },
  {
    url: "/styles/realism/forex-trading-chart-KBGcGRNYa8DpLLqT2UCJDZ",
    title: "forex trading chart",
    list_url: "/styles/realism/forex-trading-chart"
  },
  {
    url: "/styles/realism/mahak-name-WQkFHJnhx6tZ19iKVzN73o",
    title: "mahak name",
    list_url: "/styles/realism/mahak-name"
  },
  {
    url: "/styles/realism/male-lion-eating-a-koi-fish-4NaUKW1vy7xe4ykPiSMW1x",
    title: "male lion eating a koi fish",
    list_url: "/styles/realism/male-lion-eating-a-koi-fish"
  },
  {
    url: "/styles/realism/naked-female-warrior-ancient-germania-NCV8fqKWfRxUf1X4R7maxG",
    title: "naked female warrior ancient germania",
    list_url: "/styles/realism/naked-female-warrior-ancient-germania"
  },
  {
    url: "/styles/realism/saint-barbara-with-artillery-cross-CDK87M2v7aJpi2W5P2BqR",
    title: "saint barbara with artillery cross",
    list_url: "/styles/realism/saint-barbara-with-artillery-cross"
  },
  {
    url: "/styles/realism/sigma-male-tatoos-WagkZ7FfZcAm8qmXSjY5nx",
    title: "sigma male tatoos",
    list_url: "/styles/realism/sigma-male-tatoos"
  },
  {
    url: "/styles/realism/st-michael-the-archangel-DWZv52yax2dPv4LM7VUWp",
    title: "st michael the archangel",
    list_url: "/styles/realism/st-michael-the-archangel"
  },
  {
    url: "/styles/realism/talk-less-listen-more-7kdCztdJHbtttYURtrmGXi",
    title: "talk less listen more",
    list_url: "/styles/realism/talk-less-listen-more"
  },
  {
    url: "/styles/realism/vidhi-name-written-mRieRt1uZ7gNUXN1ACdfs",
    title: "vidhi name written",
    list_url: "/styles/realism/vidhi-name-written"
  },
  {
    url: "/styles/realism/vk-18-with-crown-on-18-MAp1dSrErk74YYSYU5xCEF",
    title: "vk with crown on ",
    list_url: "/styles/realism/vk-18-with-crown-on-18"
  },
  {
    url: "/styles/stencil/jaydip-name-tattoo-A7NUBD4SrMeJxfXEnLdQfN",
    title: "jaydip name tattoo",
    list_url: "/styles/stencil/jaydip-name-tattoo"
  },
  {
    url: "/styles/stencil/upper-thigh-men-tattoo-HcaGDCAocXvGmRviYX8yLw",
    title: "upper thigh men tattoo",
    list_url: "/styles/stencil/upper-thigh-men-tattoo"
  },
  {
    url: "/styles/traditional/elvis-7hEtmprUEKpGx4MZdiUb3b",
    title: "elvis",
    list_url: "/styles/traditional/elvis"
  },
  {
    url: "/styles/traditional/heart-with-name-banner-NRTYi1qzZ7aGJS4GLsL7xd",
    title: "heart with name banner",
    list_url: "/styles/traditional/heart-with-name-banner"
  },
  {
    url: "/styles/traditional/iron-sharpens-iron-AMaVfnML7JHthsqr7wg84g",
    title: "iron sharpens iron",
    list_url: "/styles/traditional/iron-sharpens-iron"
  },
  {
    url: "/styles/traditional/philippine-mythology-QNBHYyFVhqrzbQas4JM5jg",
    title: "philippine mythology",
    list_url: "/styles/traditional/philippine-mythology"
  },
  {
    url: "/styles/traditional/victor-name-tattoo-with-heart-PwsiVqEEZGu3jVc8VCoiE9",
    title: "victor name tattoo with heart",
    list_url: "/styles/traditional/victor-name-tattoo-with-heart"
  },
  {
    url: "/styles/tribal/slumerican-4QdDRhmd9uQbRmbocYEJ9k",
    title: "slumerican",
    list_url: "/styles/tribal/slumerican"
  },
  {
    url: "/styles/watercolor/deathly-hallows-cover-up-tattoo-design-WkqdEvcyf8QLMFDQuVrakV",
    title: "deathly hallows cover up tattoo design",
    list_url: "/styles/watercolor/deathly-hallows-cover-up-tattoo-design"
  },
  {
    url: "/styles/black-grey/3-children-2-girls-1-boy-facing-away-on-R1HJNfZ4GzqHskTy5fXRqQ",
    title: " children girls boy facing away on",
    list_url: "/styles/black-grey/3-children-2-girls-1-boy-facing-away-on"
  },
  {
    url: "/styles/black-grey/a-rugged-worker-with-a-metal-detector-Qm3KrV5u7Rh4TXBQ3TUGTR",
    title: "a rugged worker with a metal detector",
    list_url: "/styles/black-grey/a-rugged-worker-with-a-metal-detector"
  },
  {
    url: "/styles/black-grey/aarohi-name-XEXKDW9TVK6JbupGXmwq4u",
    title: "aarohi name",
    list_url: "/styles/black-grey/aarohi-name"
  },
  {
    url: "/styles/black-grey/attila-the-hun-FfD2XiQNTZDKyYq9fsvcZ5",
    title: "attila the hun",
    list_url: "/styles/black-grey/attila-the-hun"
  },
  {
    url: "/styles/black-grey/aztec-flowers-7jbEQK9wRkYpFYPpWNBJSC",
    title: "aztec flowers",
    list_url: "/styles/black-grey/aztec-flowers"
  },
  {
    url: "/styles/black-grey/bbc-hentai-tattoo-MB7ju9NW2vry3yeucmg1hg",
    title: "bbc hentai tattoo",
    list_url: "/styles/black-grey/bbc-hentai-tattoo"
  },
  {
    url: "/styles/black-grey/cherub-with-mac-10-gun-eSjNaXuCMxBRBAS3Y5XQo",
    title: "cherub with mac gun",
    list_url: "/styles/black-grey/cherub-with-mac-10-gun"
  },
  {
    url: "/styles/black-grey/feather-paw-print-SXFuCs2kAa3qFMCJmJrmbz",
    title: "feather paw print",
    list_url: "/styles/black-grey/feather-paw-print"
  },
  {
    url: "/styles/black-grey/jesus-with-angels-L1yjZxrpTJaCjMEKtFAEWQ",
    title: "jesus with angels",
    list_url: "/styles/black-grey/jesus-with-angels"
  },
  {
    url: "/styles/black-grey/jesus-with-clouds-5ih6GBnqJ3Pt9jNREJvu9u",
    title: "jesus with clouds",
    list_url: "/styles/black-grey/jesus-with-clouds"
  },
  {
    url: "/styles/black-grey/lightning-striking-a-tree-X7ejJimnVXa37L2a8bCFA2",
    title: "lightning striking a tree",
    list_url: "/styles/black-grey/lightning-striking-a-tree"
  },
  {
    url: "/styles/black-grey/naked-girl-riding-a-monkey-L5G7F3KztEP4qry73RDbei",
    title: "naked girl riding a monkey",
    list_url: "/styles/black-grey/naked-girl-riding-a-monkey"
  },
  {
    url: "/styles/black-grey/oracle-matter-dragon-UWvWZPYNZFcbtU4HiViSWJ",
    title: "oracle matter dragon",
    list_url: "/styles/black-grey/oracle-matter-dragon"
  },
  {
    url: "/styles/black-grey/pin-up-girl-riding-bomb-YaRR72zGP3xbteWU9VnuK2",
    title: "pin up girl riding bomb",
    list_url: "/styles/black-grey/pin-up-girl-riding-bomb"
  },
  {
    url: "/styles/black-grey/ulfhednar-in-norse-runes-Ak7D7cdfBXNrqP6WaiFnMe",
    title: "ulfhednar in norse runes",
    list_url: "/styles/black-grey/ulfhednar-in-norse-runes"
  },
  {
    url: "/styles/black-grey/viking-father-and-daughter-tattoo-5LNejy24pfqLGV6KEP1DnF",
    title: "viking father and daughter tattoo",
    list_url: "/styles/black-grey/viking-father-and-daughter-tattoo"
  },
  {
    url: "/styles/black-grey/world-map-7NZaegmi4XSqziLRhK4jfq",
    title: "world map",
    list_url: "/styles/black-grey/world-map"
  },
  {
    url: "/styles/blackwork/angel-and-devil-whisper-ear-neck-tattoo-8KqS8v6eBNSpqVE3QmvUBd",
    title: "angel and devil whisper ear neck tattoo",
    list_url: "/styles/blackwork/angel-and-devil-whisper-ear-neck-tattoo"
  },
  {
    url: "/styles/blackwork/anime-ragna-crimson-2xUmwWL9SEv2VpqEj2pFh5",
    title: "anime ragna crimson",
    list_url: "/styles/blackwork/anime-ragna-crimson"
  },
  {
    url: "/styles/blackwork/bengali-folk-art-EJW542ok6gdLZg7nUGgGpA",
    title: "bengali folk art",
    list_url: "/styles/blackwork/bengali-folk-art"
  },
  {
    url: "/styles/blackwork/charon-the-ferryman-W6s2e5rcvkhePCs23B4DSE",
    title: "charon the ferryman",
    list_url: "/styles/blackwork/charon-the-ferryman"
  },
  {
    url: "/styles/blackwork/do-not-go-gentle-into-that-good-night-W9fumQvhgf8Hapx4BHQBNs",
    title: "do not go gentle into that good night",
    list_url: "/styles/blackwork/do-not-go-gentle-into-that-good-night"
  },
  {
    url: "/styles/blackwork/firefighter-axe-with-isaiah-68-bible-bNeDv3HaMwwdZk7KrxeL9",
    title: "firefighter axe with isaiah bible",
    list_url: "/styles/blackwork/firefighter-axe-with-isaiah-68-bible"
  },
  {
    url: "/styles/blackwork/forgive-me-for-my-sins-Vwph6GShiUYS7RpsyMaQbN",
    title: "forgive me for my sins",
    list_url: "/styles/blackwork/forgive-me-for-my-sins"
  },
  {
    url: "/styles/blackwork/hooponopono-inspired-tattoo-with-a-8JHccPG74i77XVkz55gDut",
    title: "hooponopono inspired tattoo with a",
    list_url: "/styles/blackwork/hooponopono-inspired-tattoo-with-a"
  },
  {
    url: "/styles/blackwork/huey-and-riley-from-the-boondocks-DRVWbNvBfqR9QQQR3GFFT1",
    title: "huey and riley from the boondocks",
    list_url: "/styles/blackwork/huey-and-riley-from-the-boondocks"
  },
  {
    url: "/styles/blackwork/jordan-logo-holding-a-gun-Xy8ueHQZ2snyN1cCfK8uA1",
    title: "jordan logo holding a gun",
    list_url: "/styles/blackwork/jordan-logo-holding-a-gun"
  },
  {
    url: "/styles/blackwork/ohio-state-buckeyes-CTkqQfx8wJ7Z9R4bL1zJp",
    title: "ohio state buckeyes",
    list_url: "/styles/blackwork/ohio-state-buckeyes"
  },
  {
    url: "/styles/blackwork/tushar-name-VESVAdsSsQdDmKcJ83zZgF",
    title: "tushar name",
    list_url: "/styles/blackwork/tushar-name"
  },
  {
    url: "/styles/blackwork/you-and-me-against-the-world-4m79e35QpQAwbjyVTPP4LC",
    title: "you and me against the world",
    list_url: "/styles/blackwork/you-and-me-against-the-world"
  },
  {
    url: "/styles/color-infused-black-grey/demon-fucking-angel-XLrfG2NdQYWUPVsMUsNGgV",
    title: "demon fucking angel",
    list_url: "/styles/color-infused-black-grey/demon-fucking-angel"
  },
  {
    url: "/styles/dotwork/cross-with-tree-HZCU8Hp5BsQYoBGLfJFNTw",
    title: "cross with tree",
    list_url: "/styles/dotwork/cross-with-tree"
  },
  {
    url: "/styles/dotwork/judiasm-and-hebrew-term-rak-chazak-amats-32iKhURu4fpkRk8dtoTzvR",
    title: "judiasm and hebrew term rak chazak amats",
    list_url: "/styles/dotwork/judiasm-and-hebrew-term-rak-chazak-amats"
  },
  {
    url: "/styles/dotwork/lotus-flower-semicolon-6D31wPApUi2UtzDkmHszBq",
    title: "lotus flower semicolon",
    list_url: "/styles/dotwork/lotus-flower-semicolon"
  },
  {
    url: "/styles/dotwork/nayan-name-9wCwE5EoqwkeWAZrU8X9NB",
    title: "nayan name",
    list_url: "/styles/dotwork/nayan-name"
  },
  {
    url: "/styles/dotwork/peacock-feather-with-name-omkar-NhtD9xG2u7A8rTRqjNaan",
    title: "peacock feather with name omkar",
    list_url: "/styles/dotwork/peacock-feather-with-name-omkar"
  },
  {
    url: "/styles/dotwork/september-13-in-roman-numerals-with-BynJQouHMVvRy6wpLhqtay",
    title: "september in roman numerals with",
    list_url: "/styles/dotwork/september-13-in-roman-numerals-with"
  },
  {
    url: "/styles/dotwork/small-joker-tattoo-XBpb9RcAzvZUcBwkqK7jcJ",
    title: "small joker tattoo",
    list_url: "/styles/dotwork/small-joker-tattoo"
  },
  {
    url: "/styles/dotwork/yamaha-yzf-r125-72hQT32HXoBL2MBfqwX1ms",
    title: "yamaha yzf r ",
    list_url: "/styles/dotwork/yamaha-yzf-r125"
  },
  {
    url: "/styles/japanese/asura-MWw9jVAjBienc8FRtzPdaP",
    title: "asura",
    list_url: "/styles/japanese/asura"
  },
  {
    url: "/styles/japanese/karate-LwKZgfoqmFPG3W2hDLM9nc",
    title: "karate",
    list_url: "/styles/japanese/karate"
  },
  {
    url: "/styles/japanese/life-and-death-2KXhRxCNWVGgFCVkTfmmAF",
    title: "life and death",
    list_url: "/styles/japanese/life-and-death"
  },
  {
    url: "/styles/japanese/monogatari-LcnHqggjqwqLzV7TM7sNeH",
    title: "monogatari",
    list_url: "/styles/japanese/monogatari"
  },
  {
    url: "/styles/japanese/oni-mask-arm-sleeve-DT8BtrATDa9TVzpA3wp3Y6",
    title: "oni mask arm sleeve",
    list_url: "/styles/japanese/oni-mask-arm-sleeve"
  },
  {
    url: "/styles/japanese/spider-lily-flower-from-tokyo-ghoul-EwKLmffpHHYvgoFJMEj5vp",
    title: "spider lily flower from tokyo ghoul",
    list_url: "/styles/japanese/spider-lily-flower-from-tokyo-ghoul"
  },
  {
    url: "/styles/minimalist/3-point-simple-king-crown-with-leaves-PRtBxdFUDyBauWjGU8EgDn",
    title: " point simple king crown with leaves",
    list_url: "/styles/minimalist/3-point-simple-king-crown-with-leaves"
  },
  {
    url: "/styles/minimalist/angel-wings-with-dates-H5e7T4fCFmSaoX9tvTz2mJ",
    title: "angel wings with dates",
    list_url: "/styles/minimalist/angel-wings-with-dates"
  },
  {
    url: "/styles/minimalist/binary-code-W8VUgG2tcpHG7GmanoLxrF",
    title: "binary code",
    list_url: "/styles/minimalist/binary-code"
  },
  {
    url: "/styles/minimalist/bojack-horseman-Kqqq5rT8978CvjRKu2FXPf",
    title: "bojack horseman",
    list_url: "/styles/minimalist/bojack-horseman"
  },
  {
    url: "/styles/minimalist/burn-the-ships-J52fNt8J83Qvikuubxu5Ni",
    title: "burn the ships",
    list_url: "/styles/minimalist/burn-the-ships"
  },
  {
    url: "/styles/minimalist/circe-PPUdrij9c5iCXNrquMMiWs",
    title: "circe",
    list_url: "/styles/minimalist/circe"
  },
  {
    url: "/styles/minimalist/coldplay-viva-la-vida-GYvS15253Hfep3Lvtp39E4",
    title: "coldplay viva la vida",
    list_url: "/styles/minimalist/coldplay-viva-la-vida"
  },
  {
    url: "/styles/minimalist/crossed-axes-RmyejRX1Wdkn3GEABfn5jz",
    title: "crossed axes",
    list_url: "/styles/minimalist/crossed-axes"
  },
  {
    url: "/styles/minimalist/duck-you-like-showing-middle-finger-49RSrxyv7zZpL7PAULZ5ey",
    title: "duck you like showing middle finger",
    list_url: "/styles/minimalist/duck-you-like-showing-middle-finger"
  },
  {
    url: "/styles/minimalist/galatians-220-JGUhYGNA6Bp4FG54a2DBCt",
    title: "galatians ",
    list_url: "/styles/minimalist/galatians-220"
  },
  {
    url: "/styles/minimalist/king-charles-cavalier-NAaKdEzNupze32YN5WgWnb",
    title: "king charles cavalier",
    list_url: "/styles/minimalist/king-charles-cavalier"
  },
  {
    url: "/styles/minimalist/morgan-wallen-lyrics-VgF5H7ZUBykUKiqcjLBP6V",
    title: "morgan wallen lyrics",
    list_url: "/styles/minimalist/morgan-wallen-lyrics"
  },
  {
    url: "/styles/minimalist/philippians-46-formed-into-a-cross-8vEbAzB2ykxS6NTgZ7ZMD3",
    title: "philippians formed into a cross",
    list_url: "/styles/minimalist/philippians-46-formed-into-a-cross"
  },
  {
    url: "/styles/minimalist/selfish-QfZqFpBZGgZXhAGa1DXHLQ",
    title: "selfish",
    list_url: "/styles/minimalist/selfish"
  },
  {
    url: "/styles/minimalist/sikh-sword-77dpVCZSn6rjyVZXRpMMue",
    title: "sikh sword",
    list_url: "/styles/minimalist/sikh-sword"
  },
  {
    url: "/styles/minimalist/simple-ls-initials-5zQQyXDTxy6eAybBRMvu5Q",
    title: "simple ls initials",
    list_url: "/styles/minimalist/simple-ls-initials"
  },
  {
    url: "/styles/minimalist/slow-down-youre-doing-fine-LhuM9h3nLPfdJBoyDr69xq",
    title: "slow down youre doing fine",
    list_url: "/styles/minimalist/slow-down-youre-doing-fine"
  },
  {
    url: "/styles/minimalist/the-letters-j-d-and-s-DsWxxRtpkRqEpL3Cxk49MK",
    title: "the letters j d and s",
    list_url: "/styles/minimalist/the-letters-j-d-and-s"
  },
  {
    url: "/styles/minimalist/xenomorph-MrBSwLyDwtWoVJWD35NoBK",
    title: "xenomorph",
    list_url: "/styles/minimalist/xenomorph"
  },
  {
    url: "/styles/minimalist/zoroastrian-VVgAHAtvgHLx5KuymxQPSm",
    title: "zoroastrian",
    list_url: "/styles/minimalist/zoroastrian"
  },
  {
    url: "/styles/neotraditional/3-sunflowers-KXnARnkaJ7RL9Uv2sPUV4L",
    title: " sunflowers",
    list_url: "/styles/neotraditional/3-sunflowers"
  },
  {
    url: "/styles/neotraditional/doyle-family-crest-incorporating-irish-4xkBCxXbttNrpHuWyj2RAV",
    title: "doyle family crest incorporating irish",
    list_url: "/styles/neotraditional/doyle-family-crest-incorporating-irish"
  },
  {
    url: "/styles/neotraditional/jayden-in-old-english-font-QSy8UPA8UxozuzKMZugAgH",
    title: "jayden in old english font",
    list_url: "/styles/neotraditional/jayden-in-old-english-font"
  },
  {
    url: "/styles/neotraditional/jesus-is-the-way-the-truth-and-the-life-2gWsZuUyr3qYioXdZb8Rtc",
    title: "jesus is the way the truth and the life",
    list_url: "/styles/neotraditional/jesus-is-the-way-the-truth-and-the-life"
  },
  {
    url: "/styles/neotraditional/scottish-crest-campbell-clan-crest-Y2oBnpF71w2GyfZRmJBmHx",
    title: "scottish crest campbell clan crest",
    list_url: "/styles/neotraditional/scottish-crest-campbell-clan-crest"
  },
  {
    url: "/styles/neotraditional/teofimo-lopez-back-tattoo-BgSZJCQ9ere35QmZJiePqp",
    title: "teofimo lopez back tattoo",
    list_url: "/styles/neotraditional/teofimo-lopez-back-tattoo"
  },
  {
    url: "/styles/neotraditional/usha-my-wife-name-yKgak5AjpACrQbkrgaWKf",
    title: "usha my wife name",
    list_url: "/styles/neotraditional/usha-my-wife-name"
  },
  {
    url: "/styles/neotraditional/with-name-chanchal-XHxKGdYXQeEh7SfxVa4EjX",
    title: "with name chanchal",
    list_url: "/styles/neotraditional/with-name-chanchal"
  },
  {
    url: "/styles/realism/a-tattoo-design-of-a-burnley-fc-logo-ck4ERj8Ew89NgT39dvNys",
    title: "a tattoo design of a burnley fc logo",
    list_url: "/styles/realism/a-tattoo-design-of-a-burnley-fc-logo"
  },
  {
    url: "/styles/realism/archangel-michael-with-shield-and-sword-PMYio8yZbsZSbaxRhdaUsP",
    title: "archangel michael with shield and sword",
    list_url: "/styles/realism/archangel-michael-with-shield-and-sword"
  },
  {
    url: "/styles/realism/bwc-slut-QctRaEK34K5DwPA6Jf3JVP",
    title: "bwc slut",
    list_url: "/styles/realism/bwc-slut"
  },
  {
    url: "/styles/realism/girl-with-bandana-over-face-FVaXi19TGRqGH3ZPSrFBhe",
    title: "girl with bandana over face",
    list_url: "/styles/realism/girl-with-bandana-over-face"
  },
  {
    url: "/styles/realism/lightning-storm-clouds-FDgXRgTrkpgj1FYpZeyxHT",
    title: "lightning storm clouds",
    list_url: "/styles/realism/lightning-storm-clouds"
  },
  {
    url: "/styles/realism/lsd-molecule-5uy2UwCgkhuBAbazfDpqk9",
    title: "lsd molecule",
    list_url: "/styles/realism/lsd-molecule"
  },
  {
    url: "/styles/realism/name-cindy-with-a-heart-FAGK14ykScRazRco8Mjw89",
    title: "name cindy with a heart",
    list_url: "/styles/realism/name-cindy-with-a-heart"
  },
  {
    url: "/styles/realism/native-american-eagle-feather-WdfwxMEw6ke2AVspd1sGhd",
    title: "native american eagle feather",
    list_url: "/styles/realism/native-american-eagle-feather"
  },
  {
    url: "/styles/realism/past-master-mason-S9qZhW3NGx3XzohtPWvYfs",
    title: "past master mason",
    list_url: "/styles/realism/past-master-mason"
  },
  {
    url: "/styles/realism/phoenix-breaking-chains-YMGJpbVPZwktTX3ZYvNFoR",
    title: "phoenix breaking chains",
    list_url: "/styles/realism/phoenix-breaking-chains"
  },
  {
    url: "/styles/realism/the-bible-verse-mark-836-HQywZ3Z6h4tQVY7Qp19sRJ",
    title: "the bible verse mark ",
    list_url: "/styles/realism/the-bible-verse-mark-836"
  },
  {
    url: "/styles/realism/tree-with-lightning-strike-T2LLqjv2pCANqqSKWWeM5q",
    title: "tree with lightning strike",
    list_url: "/styles/realism/tree-with-lightning-strike"
  },
  {
    url: "/styles/sketch/butterfly-with-lily-of-the-valleys-and-McEoJR1Hb1vKaXa1zHPn4s",
    title: "butterfly with lily of the valleys and",
    list_url: "/styles/sketch/butterfly-with-lily-of-the-valleys-and"
  },
  {
    url: "/styles/sketch/leo-with-sagittarius-WhVpRkYab1HWNCwQGFmWcW",
    title: "leo with sagittarius",
    list_url: "/styles/sketch/leo-with-sagittarius"
  },
  {
    url: "/styles/sketch/matching-capricorn-and-aries-KM4jeQiaeBMacicn3vr2M5",
    title: "matching capricorn and aries",
    list_url: "/styles/sketch/matching-capricorn-and-aries"
  },
  {
    url: "/styles/traditional/altius-citius-fortius-3ZgdNJQkQMNnLsmWA7BndK",
    title: "altius citius fortius",
    list_url: "/styles/traditional/altius-citius-fortius"
  },
  {
    url: "/styles/traditional/ironworker-8ZXPqQB4yQb3H2qD4VkFrx",
    title: "ironworker",
    list_url: "/styles/traditional/ironworker"
  },
  {
    url: "/styles/traditional/lawn-bowls-9KFGk3BVeS1TqEo7GLXv92",
    title: "lawn bowls",
    list_url: "/styles/traditional/lawn-bowls"
  },
  {
    url: "/styles/traditional/live-free-or-die-R6LsZdmFb7jFdBFoK5CkBh",
    title: "live free or die",
    list_url: "/styles/traditional/live-free-or-die"
  },
  {
    url: "/styles/traditional/maclean-clan-crest-with-maclean-tartan-Phsx4HH9VE5L26PMVzRcvN",
    title: "maclean clan crest with maclean tartan",
    list_url: "/styles/traditional/maclean-clan-crest-with-maclean-tartan"
  },
  {
    url: "/styles/traditional/prince-of-persia-two-thrones-the-game-BdrDFmKNAGA9mVuNE1ApAd",
    title: "prince of persia two thrones the game",
    list_url: "/styles/traditional/prince-of-persia-two-thrones-the-game"
  },
  {
    url: "/styles/traditional/the-name-kerry-in-a-heart-5K2HsWAR4uHWhNQtRbmWVs",
    title: "the name kerry in a heart",
    list_url: "/styles/traditional/the-name-kerry-in-a-heart"
  },
  {
    url: "/styles/traditional/weather-vane-V9RpZ1wnGm9ZRxTkScgZnY",
    title: "weather vane",
    list_url: "/styles/traditional/weather-vane"
  },
  {
    url: "/styles/traditional/who-dares-wins-RU9iU6NxHPN7ni7VsYZ1q2",
    title: "who dares wins",
    list_url: "/styles/traditional/who-dares-wins"
  },
  {
    url: "/styles/black-grey/broken-clock-gears-AgAfYhvsGy4EJzLCwvNKd1",
    title: "broken clock gears",
    list_url: "/styles/black-grey/broken-clock-gears"
  },
  {
    url: "/styles/black-grey/canada-flag-7Xp9X3AK41BTUuV1ofA36s",
    title: "canada flag",
    list_url: "/styles/black-grey/canada-flag"
  },
  {
    url: "/styles/black-grey/chest-tattoo-with-one-side-phoenix-61xTBxZ7piwLmsPLPatTLX",
    title: "chest tattoo with one side phoenix",
    list_url: "/styles/black-grey/chest-tattoo-with-one-side-phoenix"
  },
  {
    url: "/styles/black-grey/create-a-tattoo-of-a-makk-balla-family-J413sn7v8PvTZkxwPnni9Z",
    title: "create a tattoo of a makk balla family",
    list_url: "/styles/black-grey/create-a-tattoo-of-a-makk-balla-family"
  },
  {
    url: "/styles/black-grey/filler-cloud-R63QxA3aesB1fB9v2gYzX7",
    title: "filler cloud",
    list_url: "/styles/black-grey/filler-cloud"
  },
  {
    url: "/styles/black-grey/heart-ripped-out-of-chest-dripping-UsmDwATTohynQzyDbSPXgY",
    title: "heart ripped out of chest dripping",
    list_url: "/styles/black-grey/heart-ripped-out-of-chest-dripping"
  },
  {
    url: "/styles/black-grey/infinity-with-shiva-damaru-Z5YJug3Au5zzDaMpYUSJK",
    title: "infinity with shiva damaru",
    list_url: "/styles/black-grey/infinity-with-shiva-damaru"
  },
  {
    url: "/styles/black-grey/juan-in-cursive-with-dove-under-name-HWBGfv22LNgBRkGfDCHdgh",
    title: "juan in cursive with dove under name",
    list_url: "/styles/black-grey/juan-in-cursive-with-dove-under-name"
  },
  {
    url: "/styles/black-grey/phoenix-rising-from-the-ashes-QWNRnLLt4vmLvqXFiZTV7E",
    title: "phoenix rising from the ashes",
    list_url: "/styles/black-grey/phoenix-rising-from-the-ashes"
  },
  {
    url: "/styles/black-grey/pohutukawa-4wdh9WYuH11LYRZR7g9y1A",
    title: "pohutukawa",
    list_url: "/styles/black-grey/pohutukawa"
  },
  {
    url: "/styles/black-grey/seven-spanish-angels-catholic-full-leg-CgWJTYA9E8cfaVPHgqcN6v",
    title: "seven spanish angels catholic full leg",
    list_url: "/styles/black-grey/seven-spanish-angels-catholic-full-leg"
  },
  {
    url: "/styles/black-grey/shrek-fucking-fiona-NiLDhKPfmeNFq3hekVVHig",
    title: "shrek fucking fiona",
    list_url: "/styles/black-grey/shrek-fucking-fiona"
  },
  {
    url: "/styles/black-grey/shreya-name-VEVYYmCXFjHkNvRd7Yq3a7",
    title: "shreya name",
    list_url: "/styles/black-grey/shreya-name"
  },
  {
    url: "/styles/black-grey/sleve-with-small-route-66-sign-4-5ssGVijcoX7u5qKN7vKJ5b",
    title: "sleve with small route sign ",
    list_url: "/styles/black-grey/sleve-with-small-route-66-sign-4"
  },
  {
    url: "/styles/black-grey/text-ave-christus-rex-JjG7Gnj1mBiebimi9YpPuy",
    title: "text ave christus rex",
    list_url: "/styles/black-grey/text-ave-christus-rex"
  },
  {
    url: "/styles/black-grey/the-name-marie-GSbCsoZxN273UfhdRPPuRn",
    title: "the name marie",
    list_url: "/styles/black-grey/the-name-marie"
  },
  {
    url: "/styles/black-grey/tiger-hiding-in-tall-grass-Bx2ztdSu2zpFyxoUfntNH2",
    title: "tiger hiding in tall grass",
    list_url: "/styles/black-grey/tiger-hiding-in-tall-grass"
  },
  {
    url: "/styles/black-grey/two-word-ambigram-generator-B88Cc1trBWKGvAndYExm2",
    title: "two word ambigram generator",
    list_url: "/styles/black-grey/two-word-ambigram-generator"
  },
  {
    url: "/styles/black-grey/two-word-ambigram-generator-Q1PkFAunVxp3Pg46qz3JHA",
    title: "two word ambigram generator",
    list_url: "/styles/black-grey/two-word-ambigram-generator"
  },
  {
    url: "/styles/black-grey/usmc-0621-radio-operator-6R6fWxKW5sKzKLA39WpqkN",
    title: "usmc radio operator",
    list_url: "/styles/black-grey/usmc-0621-radio-operator"
  },
  {
    url: "/styles/blackwork/a-millwright-working-on-a-mechanical-9nkncs2NigPCa5UXCBYHXP",
    title: "a millwright working on a mechanical",
    list_url: "/styles/blackwork/a-millwright-working-on-a-mechanical"
  },
  {
    url: "/styles/blackwork/chinook-helicopter-HLo8qHobdwrBVb9maVak8m",
    title: "chinook helicopter",
    list_url: "/styles/blackwork/chinook-helicopter"
  },
  {
    url: "/styles/blackwork/filipino-tribal-arm-sleeve-pangasinan-2o4FR1UccLYLHDGDiFUJvV",
    title: "filipino tribal arm sleeve pangasinan",
    list_url: "/styles/blackwork/filipino-tribal-arm-sleeve-pangasinan"
  },
  {
    url: "/styles/blackwork/hotwife-ACqMvFmEaguKLoBstxqwG4",
    title: "hotwife",
    list_url: "/styles/blackwork/hotwife"
  },
  {
    url: "/styles/blackwork/joy-of-my-life-chris-stapleton-SCup5gqdBcTuBPvHX9WJcU",
    title: "joy of my life chris stapleton",
    list_url: "/styles/blackwork/joy-of-my-life-chris-stapleton"
  },
  {
    url: "/styles/blackwork/lord-shiva-hanuman-and-ganesha-together-S51Ug5LWxLQ3mdmApWDsP9",
    title: "lord shiva hanuman and ganesha together",
    list_url: "/styles/blackwork/lord-shiva-hanuman-and-ganesha-together"
  },
  {
    url: "/styles/blackwork/middlesbrough-football-club-badge-4GR59AS2w3NFHguXLsRGF6",
    title: "middlesbrough football club badge",
    list_url: "/styles/blackwork/middlesbrough-football-club-badge"
  },
  {
    url: "/styles/blackwork/mockingbird-HRrLYUjqmYR8jFSEEFk3Lf",
    title: "mockingbird",
    list_url: "/styles/blackwork/mockingbird"
  },
  {
    url: "/styles/blackwork/nike-logo-UDNnTLyTgj4SgGNNZNwgSX",
    title: "nike logo",
    list_url: "/styles/blackwork/nike-logo"
  },
  {
    url: "/styles/blackwork/rolex-crown-HUstZuQeoHDkrgbqgqdKxc",
    title: "rolex crown",
    list_url: "/styles/blackwork/rolex-crown"
  },
  {
    url: "/styles/blackwork/the-name-romi-3R3df4wae4GCvCbh76K35G",
    title: "the name romi",
    list_url: "/styles/blackwork/the-name-romi"
  },
  {
    url: "/styles/blackwork/tyaga-shanti-anantam-with-infinity-RgTi2A3Ty8PrZ6eR3Cdxsk",
    title: "tyaga shanti anantam with infinity",
    list_url: "/styles/blackwork/tyaga-shanti-anantam-with-infinity"
  },
  {
    url: "/styles/blackwork/versace-DdDjNLRNB6izWkSrrZ4M9W",
    title: "versace",
    list_url: "/styles/blackwork/versace"
  },
  {
    url: "/styles/dotwork/1percent-better-everyday-9ZX3AWS5w5AbAWCM12cssL",
    title: " percent better everyday",
    list_url: "/styles/dotwork/1percent-better-everyday"
  },
  {
    url: "/styles/dotwork/a-native-american-indian-riding-a-horse-YVamQ16wszxs2e38aWZM86",
    title: "a native american indian riding a horse",
    list_url: "/styles/dotwork/a-native-american-indian-riding-a-horse"
  },
  {
    url: "/styles/dotwork/barasingha-8FkAJN2CqBxyDyxotg8KKp",
    title: "barasingha",
    list_url: "/styles/dotwork/barasingha"
  },
  {
    url: "/styles/dotwork/father-with-two-sons-Fzh32tt5twDcL5154JSvPX",
    title: "father with two sons",
    list_url: "/styles/dotwork/father-with-two-sons"
  },
  {
    url: "/styles/dotwork/no-love-lost-Fn4EKQsgHAVcr3QqT8kmhb",
    title: "no love lost",
    list_url: "/styles/dotwork/no-love-lost"
  },
  {
    url: "/styles/dotwork/pirate-compass-2oKgAWZEsmnsVsPdnmciLJ",
    title: "pirate compass",
    list_url: "/styles/dotwork/pirate-compass"
  },
  {
    url: "/styles/dotwork/pratu-7rFCs5Uu8ktyakgKA9XdRR",
    title: "pratu",
    list_url: "/styles/dotwork/pratu"
  },
  {
    url: "/styles/dotwork/prisha-KQKmyF6DRa7XoXxQPtVGxE",
    title: "prisha",
    list_url: "/styles/dotwork/prisha"
  },
  {
    url: "/styles/dotwork/roman-numeral-tattoo-on-inner-bicep-LmdTuzuBqNjw1tKNAUNQcD",
    title: "roman numeral tattoo on inner bicep",
    list_url: "/styles/dotwork/roman-numeral-tattoo-on-inner-bicep"
  },
  {
    url: "/styles/dotwork/tejaswini-8VxoYSCLVTiZU6KNwm3W72",
    title: "tejaswini",
    list_url: "/styles/dotwork/tejaswini"
  },
  {
    url: "/styles/dotwork/trishul-with-ant-asti-prarambh-Fg5ZDiTzGcoT8SvdG5BpcJ",
    title: "trishul with ant asti prarambh",
    list_url: "/styles/dotwork/trishul-with-ant-asti-prarambh"
  },
  {
    url: "/styles/dotwork/write-name-sunita-mxing-with-saanjh-ViCqHQfHwfQ4GRm1Sm5Cx6",
    title: "write name sunita mxing with saanjh",
    list_url: "/styles/dotwork/write-name-sunita-mxing-with-saanjh"
  },
  {
    url: "/styles/dotwork/xavier-name-FbBNrDkTC5Dap1DZxtYtRb",
    title: "xavier name",
    list_url: "/styles/dotwork/xavier-name"
  },
  {
    url: "/styles/geometric/doctor-strange-Q97r64mvN1VT9ZttKPSSV3",
    title: "doctor strange",
    list_url: "/styles/geometric/doctor-strange"
  },
  {
    url: "/styles/japanese/cancer-zodiac-with-koi-fish-GaLM1CMaGVXRQhPn6E9MTL",
    title: "cancer zodiac with koi fish",
    list_url: "/styles/japanese/cancer-zodiac-with-koi-fish"
  },
  {
    url: "/styles/japanese/feral-angry-duck-T9kW6yFg2T6SxEDirpeQ26",
    title: "feral angry duck",
    list_url: "/styles/japanese/feral-angry-duck"
  },
  {
    url: "/styles/japanese/three-headed-dragon-2u2m3DAsnx1KH8vTATcdAi",
    title: "three headed dragon",
    list_url: "/styles/japanese/three-headed-dragon"
  },
  {
    url: "/styles/minimalist/airplane-window-AnzsF5nf87ybpfUsUgChCD",
    title: "airplane window",
    list_url: "/styles/minimalist/airplane-window"
  },
  {
    url: "/styles/minimalist/batman-outline-drawing-tattoo-L6baVh9qgW1XW6xkCXATtK",
    title: "batman outline drawing tattoo",
    list_url: "/styles/minimalist/batman-outline-drawing-tattoo"
  },
  {
    url: "/styles/minimalist/bon-iver-22-a-million-Hq73aCydKCV2qMZj3wdVaZ",
    title: "bon iver a million",
    list_url: "/styles/minimalist/bon-iver-22-a-million"
  },
  {
    url: "/styles/minimalist/canadian-military-service-GBYvYmJe9Ha8s7RcDZdMtw",
    title: "canadian military service",
    list_url: "/styles/minimalist/canadian-military-service"
  },
  {
    url: "/styles/minimalist/crocus-GyGkuo6vFE1amPMDQ8P4vx",
    title: "crocus",
    list_url: "/styles/minimalist/crocus"
  },
  {
    url: "/styles/minimalist/cruz-de-la-victoria-asturias-BZfXuSTmvTfWGhWCp8XkYu",
    title: "cruz de la victoria asturias",
    list_url: "/styles/minimalist/cruz-de-la-victoria-asturias"
  },
  {
    url: "/styles/minimalist/july-and-october-birth-flowers-U4dC17FELsAJBT9YjKAnhb",
    title: "july and october birth flowers",
    list_url: "/styles/minimalist/july-and-october-birth-flowers"
  },
  {
    url: "/styles/minimalist/letters-c-and-d-TLASxTuK5rsih1H7xf1VEo",
    title: "letters c and d",
    list_url: "/styles/minimalist/letters-c-and-d"
  },
  {
    url: "/styles/minimalist/lust-symbol-ENgqbQyCFrQadcmY3VYazA",
    title: "lust symbol",
    list_url: "/styles/minimalist/lust-symbol"
  },
  {
    url: "/styles/minimalist/manchester-united-Gtp1xgwsn9hfUG4nom6fS3",
    title: "manchester united",
    list_url: "/styles/minimalist/manchester-united"
  },
  {
    url: "/styles/minimalist/murphys-law-9GKq1Gs3ykER5MnadD1wsi",
    title: "murphys law",
    list_url: "/styles/minimalist/murphys-law"
  },
  {
    url: "/styles/minimalist/name-adi-A4dDerrEHt3z9XPUV4kCJy",
    title: "name adi",
    list_url: "/styles/minimalist/name-adi"
  },
  {
    url: "/styles/minimalist/robin-hood-MMbfrLFpBi9drvdZcXa1ba",
    title: "robin hood",
    list_url: "/styles/minimalist/robin-hood"
  },
  {
    url: "/styles/minimalist/socialist-fist-holding-rose-EFAcocdfk51Ci1mKv26kVU",
    title: "socialist fist holding rose",
    list_url: "/styles/minimalist/socialist-fist-holding-rose"
  },
  {
    url: "/styles/neotraditional/1986-roman-numerals-intertwined-with-4JYZtXhrhkaoVsmywddfoi",
    title: " roman numerals intertwined with",
    list_url: "/styles/neotraditional/1986-roman-numerals-intertwined-with"
  },
  {
    url: "/styles/neotraditional/anime-henti-big-breast-girl-RwsWY8jaLtatH9SBz1popt",
    title: "anime henti big breast girl",
    list_url: "/styles/neotraditional/anime-henti-big-breast-girl"
  },
  {
    url: "/styles/neotraditional/archangel-jophiel-YViA3Y9sXof7mbrLBphN2d",
    title: "archangel jophiel",
    list_url: "/styles/neotraditional/archangel-jophiel"
  },
  {
    url: "/styles/neotraditional/aryan-name-incorporated-KdNiPzZ5m65H1Ab226hB1m",
    title: "aryan name incorporated",
    list_url: "/styles/neotraditional/aryan-name-incorporated"
  },
  {
    url: "/styles/neotraditional/eagle-with-gun-4q237xDqNQKGcyDpF74W8k",
    title: "eagle with gun",
    list_url: "/styles/neotraditional/eagle-with-gun"
  },
  {
    url: "/styles/neotraditional/everton-archibald-leitch-blue-design-TCJ5seE8S2so2maLFTEMAe",
    title: "everton archibald leitch blue design",
    list_url: "/styles/neotraditional/everton-archibald-leitch-blue-design"
  },
  {
    url: "/styles/neotraditional/liza-name-heart-shaped-lock-99F3zMYYsYeJKZdbLsq9gw",
    title: "liza name heart shaped lock",
    list_url: "/styles/neotraditional/liza-name-heart-shaped-lock"
  },
  {
    url: "/styles/neotraditional/name-tattoo-ramya-8vgL78P3y6zoJMJoKy7D44",
    title: "name tattoo ramya",
    list_url: "/styles/neotraditional/name-tattoo-ramya"
  },
  {
    url: "/styles/neotraditional/revanth-nagalaxmi-rudransh-names-TJka2yFF8sqUq7PY2WwRnK",
    title: "revanth nagalaxmi rudransh names",
    list_url: "/styles/neotraditional/revanth-nagalaxmi-rudransh-names"
  },
  {
    url: "/styles/neotraditional/shambhavi-name-tattoo-design-inspired-FRF3sRPCNrvPuMizZJa8wS",
    title: "shambhavi name tattoo design inspired",
    list_url: "/styles/neotraditional/shambhavi-name-tattoo-design-inspired"
  },
  {
    url: "/styles/neotraditional/shweta-YRh1QyRaRmzqRkKe37WGQ4",
    title: "shweta",
    list_url: "/styles/neotraditional/shweta"
  },
  {
    url: "/styles/neotraditional/tennessee-vols-XzvWMtfz1yAfUZcD3qKNKS",
    title: "tennessee vols",
    list_url: "/styles/neotraditional/tennessee-vols"
  },
  {
    url: "/styles/neotraditional/the-name-abigail-in-cursive-writing-HaFHw7tQThK6ZS92oC74uZ",
    title: "the name abigail in cursive writing",
    list_url: "/styles/neotraditional/the-name-abigail-in-cursive-writing"
  },
  {
    url: "/styles/neotraditional/virgo-and-libra-zodiac-sign-combined-in-78H8zUW98S3J3smrfeTkUD",
    title: "virgo and libra zodiac sign combined in",
    list_url: "/styles/neotraditional/virgo-and-libra-zodiac-sign-combined-in"
  },
  {
    url: "/styles/neotraditional/volcano-of-ometepe-nicaragua-6GoVRCc1KkCKZqt7UAXVXm",
    title: "volcano of ometepe nicaragua",
    list_url: "/styles/neotraditional/volcano-of-ometepe-nicaragua"
  },
  {
    url: "/styles/new-school/godparents-8pv9AfUezBvBAR9nA3X4jE",
    title: "godparents",
    list_url: "/styles/new-school/godparents"
  },
  {
    url: "/styles/realism/a-plow-H8PD45F3KWFZ24EhPakmHN",
    title: "a plow",
    list_url: "/styles/realism/a-plow"
  },
  {
    url: "/styles/realism/castle-with-a-dragon-flying-over-it-9Dg6iBpbC1NPjgsHio7ERG",
    title: "castle with a dragon flying over it",
    list_url: "/styles/realism/castle-with-a-dragon-flying-over-it"
  },
  {
    url: "/styles/realism/child-on-swing-with-tree-WRa9GP6EfrenLDGWMg44gX",
    title: "child on swing with tree",
    list_url: "/styles/realism/child-on-swing-with-tree"
  },
  {
    url: "/styles/realism/family-nan-and-grandad-HoQB3FzkVtwwFxhRCYgpk3",
    title: "family nan and grandad",
    list_url: "/styles/realism/family-nan-and-grandad"
  },
  {
    url: "/styles/realism/inca-the-condor-puma-and-serpent-WyJqcE2R7cwHHvsms8WGWG",
    title: "inca the condor puma and serpent",
    list_url: "/styles/realism/inca-the-condor-puma-and-serpent"
  },
  {
    url: "/styles/realism/joker-smoking-8ZX6QCaDTWUjUCpiF1nuyn",
    title: "joker smoking",
    list_url: "/styles/realism/joker-smoking"
  },
  {
    url: "/styles/realism/mckenzie-clan-crest-luceo-non-uro-2jZiuioprHbDMDf6XGAJG5",
    title: "mckenzie clan crest luceo non uro",
    list_url: "/styles/realism/mckenzie-clan-crest-luceo-non-uro"
  },
  {
    url: "/styles/realism/momma-bear-and-3-cubs-WjsgKqZG3QH6SJCxqNv8PA",
    title: "momma bear and cubs",
    list_url: "/styles/realism/momma-bear-and-3-cubs"
  },
  {
    url: "/styles/realism/robert-name-infinity-heart-symbol-EPKHm9y2bz83yWq7NUg7VY",
    title: "robert name infinity heart symbol",
    list_url: "/styles/realism/robert-name-infinity-heart-symbol"
  },
  {
    url: "/styles/realism/sagittarius-XUyF2Xv9iJFRVAK5A8rASH",
    title: "sagittarius",
    list_url: "/styles/realism/sagittarius"
  },
  {
    url: "/styles/realism/tree-of-life-with-clouds-FYNKyxqVBqffKFZzK5hEED",
    title: "tree of life with clouds",
    list_url: "/styles/realism/tree-of-life-with-clouds"
  },
  {
    url: "/styles/sketch/boquet-of-larkspur-water-lily-NZMRzeq5Q3b7hK4Vb8rRkp",
    title: "boquet of larkspur water lily",
    list_url: "/styles/sketch/boquet-of-larkspur-water-lily"
  },
  {
    url: "/styles/sketch/coram-deo-ochwC78xjGRe1tXUkT6om",
    title: "coram deo",
    list_url: "/styles/sketch/coram-deo"
  },
  {
    url: "/styles/sketch/mickey-minnie-and-pluto-disney-NJXqxSRboGntGVHciayNa9",
    title: "mickey minnie and pluto disney",
    list_url: "/styles/sketch/mickey-minnie-and-pluto-disney"
  },
  {
    url: "/styles/sketch/tattoo-black-and-white-sketch-joker-FYKrpGuWKkd7237GdcqFTH",
    title: "tattoo black and white sketch joker",
    list_url: "/styles/sketch/tattoo-black-and-white-sketch-joker"
  },
  {
    url: "/styles/sketch/vikrant-name-T48NGDodZ6pm2iBKHL7wnX",
    title: "vikrant name",
    list_url: "/styles/sketch/vikrant-name"
  },
  {
    url: "/styles/stencil/chicano-clown-girl-face-3AXLxMWdKLeAsBwC9uUb9s",
    title: "chicano clown girl face",
    list_url: "/styles/stencil/chicano-clown-girl-face"
  },
  {
    url: "/styles/stencil/rebel-flag-3A5pk9dJJk7UbzPnXHLKPQ",
    title: "rebel flag",
    list_url: "/styles/stencil/rebel-flag"
  },
  {
    url: "/styles/surrealism/a-man-fighting-a-bear-RkrV6Y2nBJf4C7rMAN4rax",
    title: "a man fighting a bear",
    list_url: "/styles/surrealism/a-man-fighting-a-bear"
  },
  {
    url: "/styles/traditional/libertarianism-HQaBJmnLcaVbw6idyBLfYm",
    title: "libertarianism",
    list_url: "/styles/traditional/libertarianism"
  },
  {
    url: "/styles/traditional/name-as-vivaan-LCK1XpkshCREmdWVpypvfP",
    title: "name as vivaan",
    list_url: "/styles/traditional/name-as-vivaan"
  },
  {
    url: "/styles/traditional/portuguese-caravel-GRiNnei3G3ko95pDy9ysmT",
    title: "portuguese caravel",
    list_url: "/styles/traditional/portuguese-caravel"
  },
  {
    url: "/styles/traditional/sleep-token-LdivHMkh8YgzN5psGjuwu",
    title: "sleep token",
    list_url: "/styles/traditional/sleep-token"
  },
  {
    url: "/styles/traditional/walnut-tree-EsQWoSrvxnr9x63bZYY6FS",
    title: "walnut tree",
    list_url: "/styles/traditional/walnut-tree"
  },
  {
    url: "/styles/tribal/arm-sleeve-of-polynesian-christian-cross-MsGNAtJiSr7B6GfwCgiLcX",
    title: "arm sleeve of polynesian christian cross",
    list_url: "/styles/tribal/arm-sleeve-of-polynesian-christian-cross"
  },
  {
    url: "/styles/tribal/maori-symbol-of-life-and-family-Qhv8SCc1TynExe8PZEUNvX",
    title: "maori symbol of life and family",
    list_url: "/styles/tribal/maori-symbol-of-life-and-family"
  },
  {
    url: "/styles/black-grey/1916-easter-rising-Tvvi8mNY1K2FWWYgZtXJ3Z",
    title: " easter rising",
    list_url: "/styles/black-grey/1916-easter-rising"
  },
  {
    url: "/styles/black-grey/2005-numbers-29GfKijheXwWS8uzto8XJf",
    title: " numbers",
    list_url: "/styles/black-grey/2005-numbers"
  },
  {
    url: "/styles/black-grey/alea-iacta-est-with-dices-hanged-XU3EyjRa7AVKbYzhopuWHV",
    title: "alea iacta est with dices hanged",
    list_url: "/styles/black-grey/alea-iacta-est-with-dices-hanged"
  },
  {
    url: "/styles/black-grey/anglo-saxon-NTfTd5WeQXnhmZTJEto6KJ",
    title: "anglo saxon",
    list_url: "/styles/black-grey/anglo-saxon"
  },
  {
    url: "/styles/black-grey/armor-gauntlet-S1ErK8yn5c3D9wasPQYMLs",
    title: "armor gauntlet",
    list_url: "/styles/black-grey/armor-gauntlet"
  },
  {
    url: "/styles/black-grey/avenged-sevenfold-life-is-but-a-dream-ETcHgWZyKimCKhAd4Md66a",
    title: "avenged sevenfold life is but a dream",
    list_url: "/styles/black-grey/avenged-sevenfold-life-is-but-a-dream"
  },
  {
    url: "/styles/black-grey/england-three-lions-N4huZt2mSXpGU8aXyNkAeE",
    title: "england three lions",
    list_url: "/styles/black-grey/england-three-lions"
  },
  {
    url: "/styles/black-grey/failure-is-not-an-option-9QFVEqWoegbMF4VwWnJ8ng",
    title: "failure is not an option",
    list_url: "/styles/black-grey/failure-is-not-an-option"
  },
  {
    url: "/styles/black-grey/forget-me-not-flowers-with-7-small-2tvnPqHF3Auz4wWpHnNCg5",
    title: "forget me not flowers with small",
    list_url: "/styles/black-grey/forget-me-not-flowers-with-7-small"
  },
  {
    url: "/styles/black-grey/greek-mythology-leg-sleeve-5MM2MJPUC9USkPw97mSxXM",
    title: "greek mythology leg sleeve",
    list_url: "/styles/black-grey/greek-mythology-leg-sleeve"
  },
  {
    url: "/styles/black-grey/jean-last-name-cursive-fire-layer-UYcHTueRLUxh8WPhdXNU1d",
    title: "jean last name cursive fire layer",
    list_url: "/styles/black-grey/jean-last-name-cursive-fire-layer"
  },
  {
    url: "/styles/black-grey/ladybug-on-sunflower-8ViureLUWcsEUQQGFparLi",
    title: "ladybug on sunflower",
    list_url: "/styles/black-grey/ladybug-on-sunflower"
  },
  {
    url: "/styles/black-grey/massey-ferguson-tractor-with-cardinal-BWjodGBHVPrfGtMPJaGi5n",
    title: "massey ferguson tractor with cardinal",
    list_url: "/styles/black-grey/massey-ferguson-tractor-with-cardinal"
  },
  {
    url: "/styles/black-grey/medusa-with-breast-HBUPwFDXvcFavZrCSEXUuG",
    title: "medusa with breast",
    list_url: "/styles/black-grey/medusa-with-breast"
  },
  {
    url: "/styles/black-grey/nintendo-ADWRZS6EG2pUPf6JQTFwMC",
    title: "nintendo",
    list_url: "/styles/black-grey/nintendo"
  },
  {
    url: "/styles/black-grey/norse-mythology-owl-5rpSpMvhoDqkmCLreXePRg",
    title: "norse mythology owl",
    list_url: "/styles/black-grey/norse-mythology-owl"
  },
  {
    url: "/styles/black-grey/patchwork-QD4X3VSHqEBVzoeDeYTW86",
    title: "patchwork",
    list_url: "/styles/black-grey/patchwork"
  },
  {
    url: "/styles/black-grey/smile-now-cry-later-clowns-chicano-FQMxPGAtxNTGTgeieyYj9Y",
    title: "smile now cry later clowns chicano",
    list_url: "/styles/black-grey/smile-now-cry-later-clowns-chicano"
  },
  {
    url: "/styles/black-grey/song-thrush-bird-with-purple-lilly-in-DMy49pzW5iruaEgyxLeZq4",
    title: "song thrush bird with purple lilly in",
    list_url: "/styles/black-grey/song-thrush-bird-with-purple-lilly-in"
  },
  {
    url: "/styles/black-grey/text-whatever-it-takes-HERV9H2sq2h6ZA2FRLmgSb",
    title: "text whatever it takes",
    list_url: "/styles/black-grey/text-whatever-it-takes"
  },
  {
    url: "/styles/black-grey/the-name-reena-with-birds-and-freedom-4t5BcM11L5ot7UTB3mRR6k",
    title: "the name reena with birds and freedom",
    list_url: "/styles/black-grey/the-name-reena-with-birds-and-freedom"
  },
  {
    url: "/styles/black-grey/wolf-head-in-forest-with-reflection-in-Rov8hJ3aaELa298zqNTNK9",
    title: "wolf head in forest with reflection in",
    list_url: "/styles/black-grey/wolf-head-in-forest-with-reflection-in"
  },
  {
    url: "/styles/black-grey/wrap-vine-with-names-of-god-adonai-el-EFN7kQBTm3zS8a6KWJVe2h",
    title: "wrap vine with names of god adonai el",
    list_url: "/styles/black-grey/wrap-vine-with-names-of-god-adonai-el"
  },
  {
    url: "/styles/black-grey/zodiac-sign-gemini-with-name-K8yguZwyn1Q9EPUUj2R1ok",
    title: "zodiac sign gemini with name",
    list_url: "/styles/black-grey/zodiac-sign-gemini-with-name"
  },
  {
    url: "/styles/blackwork/abi-name-tattoo-KaAKet1PavvvjoU7KV7jKP",
    title: "abi name tattoo",
    list_url: "/styles/blackwork/abi-name-tattoo"
  },
  {
    url: "/styles/blackwork/coheed-and-cambria-keywork-dragonfly-6E1PjGvgGvpUvgGuKTVbSE",
    title: "coheed and cambria keywork dragonfly",
    list_url: "/styles/blackwork/coheed-and-cambria-keywork-dragonfly"
  },
  {
    url: "/styles/blackwork/cuckold-chastity-AEyZX5z5sQVHZfswwqYHLZ",
    title: "cuckold chastity",
    list_url: "/styles/blackwork/cuckold-chastity"
  },
  {
    url: "/styles/blackwork/def-leppard-BJ6rBhpn7QjT6TkQ8VBLaC",
    title: "def leppard",
    list_url: "/styles/blackwork/def-leppard"
  },
  {
    url: "/styles/blackwork/helen-of-troy-2vXjeCyTfn1MJKcuRzCcKS",
    title: "helen of troy",
    list_url: "/styles/blackwork/helen-of-troy"
  },
  {
    url: "/styles/blackwork/im-broken-Qtp3s4gvNjBZ4piWdgnAsC",
    title: "im broken",
    list_url: "/styles/blackwork/im-broken"
  },
  {
    url: "/styles/blackwork/joker-smile-hand-tattoo-CpFwysvb9dHueyzyS2DLfA",
    title: "joker smile hand tattoo",
    list_url: "/styles/blackwork/joker-smile-hand-tattoo"
  },
  {
    url: "/styles/blackwork/juice-wrld-inspired-tattoo-999-abyss-KzKa56zEdqHoSv2ZXYpcm2",
    title: "juice wrld inspired tattoo abyss",
    list_url: "/styles/blackwork/juice-wrld-inspired-tattoo-999-abyss"
  },
  {
    url: "/styles/blackwork/kendrick-lamar-count-me-out-ToUpdyGGPgYpE8ubfkuGVP",
    title: "kendrick lamar count me out",
    list_url: "/styles/blackwork/kendrick-lamar-count-me-out"
  },
  {
    url: "/styles/blackwork/kerala-LTfzsfmRKj46HJVWwmZb9t",
    title: "kerala",
    list_url: "/styles/blackwork/kerala"
  },
  {
    url: "/styles/blackwork/love-never-fails-7wq5xyjU2iXTcA6YshKPr2",
    title: "love never fails",
    list_url: "/styles/blackwork/love-never-fails"
  },
  {
    url: "/styles/blackwork/manchester-united-munich-clock-JxMVz4HWuw2wYnTA9bhXUQ",
    title: "manchester united munich clock",
    list_url: "/styles/blackwork/manchester-united-munich-clock"
  },
  {
    url: "/styles/blackwork/pusy-XZVDi9LvPu6J8qwyRvewkG",
    title: "pusy",
    list_url: "/styles/blackwork/pusy"
  },
  {
    url: "/styles/blackwork/silver-springs-fleetwood-mac-lyrics-RdKsfhkVgmbHCHdxt6mUUt",
    title: "silver springs fleetwood mac lyrics",
    list_url: "/styles/blackwork/silver-springs-fleetwood-mac-lyrics"
  },
  {
    url: "/styles/blackwork/simple-lettering-the-name-melody-with-JdQW4q12Mxq9JKYKDUtXHh",
    title: "simple lettering the name melody with",
    list_url: "/styles/blackwork/simple-lettering-the-name-melody-with"
  },
  {
    url: "/styles/blackwork/suresh-name-QKaDj2wDeasAUXfRP8BE3y",
    title: "suresh name",
    list_url: "/styles/blackwork/suresh-name"
  },
  {
    url: "/styles/blackwork/the-phrase-alea-iacta-est-H1BiLAkgQ7C6TehQMzmDqG",
    title: "the phrase alea iacta est",
    list_url: "/styles/blackwork/the-phrase-alea-iacta-est"
  },
  {
    url: "/styles/blackwork/woman-with-curly-chicano-style-naked-SfVNps3SLQHUuALD9xRwet",
    title: "woman with curly chicano style naked",
    list_url: "/styles/blackwork/woman-with-curly-chicano-style-naked"
  },
  {
    url: "/styles/dotwork/conans-sword-from-conan-the-barbarian-7rkb8rVsPEeJ1mwzyCw1pu",
    title: "conans sword from conan the barbarian",
    list_url: "/styles/dotwork/conans-sword-from-conan-the-barbarian"
  },
  {
    url: "/styles/dotwork/flute-with-peacock-feather-name-is-pooja-7w5qMZhuWzSHfepSQfVHB8",
    title: "flute with peacock feather name is pooja",
    list_url: "/styles/dotwork/flute-with-peacock-feather-name-is-pooja"
  },
  {
    url: "/styles/dotwork/jet-ski-RvRkL74Xiyu8nsNpAMkYhE",
    title: "jet ski",
    list_url: "/styles/dotwork/jet-ski"
  },
  {
    url: "/styles/dotwork/mongolian-warrior-X88KkpXme4UyMgb4um9nC9",
    title: "mongolian warrior",
    list_url: "/styles/dotwork/mongolian-warrior"
  },
  {
    url: "/styles/dotwork/taj-KPpcxEkyVzFFYEAcrTZhF1",
    title: "taj",
    list_url: "/styles/dotwork/taj"
  },
  {
    url: "/styles/dotwork/vladimir-putin-6J2mSifovWaP7Aog3NMtqd",
    title: "vladimir putin",
    list_url: "/styles/dotwork/vladimir-putin"
  },
  {
    url: "/styles/geometric/border-collie-51Duh29iG9kUKcJvLnqPcR",
    title: "border collie",
    list_url: "/styles/geometric/border-collie"
  },
  {
    url: "/styles/geometric/earth-wind-fire-water-2M53GRLRwhjFbrgM9B5Dpj",
    title: "earth wind fire water",
    list_url: "/styles/geometric/earth-wind-fire-water"
  },
  {
    url: "/styles/geometric/vi-veri-veniversum-vivus-vici-sacred-QjQbWrcFeRGMvbat7qZXDm",
    title: "vi veri veniversum vivus vici sacred",
    list_url: "/styles/geometric/vi-veri-veniversum-vivus-vici-sacred"
  },
  {
    url: "/styles/ignorant/hawthorn-flower-BbxBrn38zN3VNYDEqifJFu",
    title: "hawthorn flower",
    list_url: "/styles/ignorant/hawthorn-flower"
  },
  {
    url: "/styles/japanese/black-jaguar-BdYG86FiYGyiyNJvrpkY6G",
    title: "black jaguar",
    list_url: "/styles/japanese/black-jaguar"
  },
  {
    url: "/styles/japanese/broken-soul-Mf2EpMeYqFrppEGct9hFiZ",
    title: "broken soul",
    list_url: "/styles/japanese/broken-soul"
  },
  {
    url: "/styles/japanese/death-before-dishonor-words-over-a-Hc9HnnLVZneKhDCQj8uiTw",
    title: "death before dishonor words over a",
    list_url: "/styles/japanese/death-before-dishonor-words-over-a"
  },
  {
    url: "/styles/japanese/dove-DUh6L3zVgjch33VxPKbRkJ",
    title: "dove",
    list_url: "/styles/japanese/dove"
  },
  {
    url: "/styles/japanese/full-leg-samurai-armour-tattoo-men-PDWTDcC7bwLubSyCQynGBc",
    title: "full leg samurai armour tattoo men",
    list_url: "/styles/japanese/full-leg-samurai-armour-tattoo-men"
  },
  {
    url: "/styles/japanese/kung-fu-panda-GdsfWHJdbcCyHWxvbKcv9E",
    title: "kung fu panda",
    list_url: "/styles/japanese/kung-fu-panda"
  },
  {
    url: "/styles/japanese/my-mercy-prevails-over-my-wrath-75RzfSNHjeTGQ21GRtxQsm",
    title: "my mercy prevails over my wrath",
    list_url: "/styles/japanese/my-mercy-prevails-over-my-wrath"
  },
  {
    url: "/styles/minimalist/1111-forever-infinity-AsfVBidPPAYZLRazYYpKAn",
    title: " forever infinity",
    list_url: "/styles/minimalist/1111-forever-infinity"
  },
  {
    url: "/styles/minimalist/a-spreadsheet-themed-tattoo-VzPq6UV4Vm6AxewR8EFtKT",
    title: "a spreadsheet themed tattoo",
    list_url: "/styles/minimalist/a-spreadsheet-themed-tattoo"
  },
  {
    url: "/styles/minimalist/a-unicorn-surrounded-by-celtic-knots-YA1mbWGkK3LyhY5oC5NLXZ",
    title: "a unicorn surrounded by celtic knots",
    list_url: "/styles/minimalist/a-unicorn-surrounded-by-celtic-knots"
  },
  {
    url: "/styles/minimalist/aj-tattoo-hidden-initials-incorporated-KtS48cQ9KSB2EQpFkU8B7C",
    title: "aj tattoo hidden initials incorporated",
    list_url: "/styles/minimalist/aj-tattoo-hidden-initials-incorporated"
  },
  {
    url: "/styles/minimalist/aster-and-honeysuckle-HokHssP2gVwqR3enefL3fN",
    title: "aster and honeysuckle",
    list_url: "/styles/minimalist/aster-and-honeysuckle"
  },
  {
    url: "/styles/minimalist/bend-overslim-thick-goth-girlemo-F8ySDi4ZN3b4T6xkY76SWM",
    title: "bend overslim thick goth girlemo",
    list_url: "/styles/minimalist/bend-overslim-thick-goth-girlemo"
  },
  {
    url: "/styles/minimalist/c-j-VgL8a58HA3gUhT2zjdpGRa",
    title: "c j",
    list_url: "/styles/minimalist/c-j"
  },
  {
    url: "/styles/minimalist/cannabis-thc-molecule-418P6uY9GLac9zLxPLeiyk",
    title: "cannabis thc molecule",
    list_url: "/styles/minimalist/cannabis-thc-molecule"
  },
  {
    url: "/styles/minimalist/coldplay-VamfRW68ccUHKagsneEFWX",
    title: "coldplay",
    list_url: "/styles/minimalist/coldplay"
  },
  {
    url: "/styles/minimalist/combination-of-letter-r-and-n-PG8BK7tocDQDsnotuVoJpA",
    title: "combination of letter r and n",
    list_url: "/styles/minimalist/combination-of-letter-r-and-n"
  },
  {
    url: "/styles/minimalist/ems-paramedic-JTZ6qu4jTk54E132yKs6Ph",
    title: "ems paramedic",
    list_url: "/styles/minimalist/ems-paramedic"
  },
  {
    url: "/styles/minimalist/fiddlehead-fern-PNcubUD7FryTDw6aFqLpiB",
    title: "fiddlehead fern",
    list_url: "/styles/minimalist/fiddlehead-fern"
  },
  {
    url: "/styles/minimalist/lily-of-the-valley-flower-and-larkspur-YaFYAiwxm3itaULdNt3GPj",
    title: "lily of the valley flower and larkspur",
    list_url: "/styles/minimalist/lily-of-the-valley-flower-and-larkspur"
  },
  {
    url: "/styles/minimalist/martini-glass-RDT52SVwsQ1y7fbKtGbNZB",
    title: "martini glass",
    list_url: "/styles/minimalist/martini-glass"
  },
  {
    url: "/styles/minimalist/mini-cooper-F7kC8k6gQHh4KEMqpoDr81",
    title: "mini cooper",
    list_url: "/styles/minimalist/mini-cooper"
  },
  {
    url: "/styles/minimalist/mom-and-baby-sea-turtle-U6mHTNx8a8u4L3KBzX3Q9",
    title: "mom and baby sea turtle",
    list_url: "/styles/minimalist/mom-and-baby-sea-turtle"
  },
  {
    url: "/styles/minimalist/porshe-911-gt3-rs-FWwJ5pu7uur1z9nzPUzbaV",
    title: "porshe gt rs",
    list_url: "/styles/minimalist/porshe-911-gt3-rs"
  },
  {
    url: "/styles/minimalist/prasanna-Djb15T5w7gsNhH7PyCGD4n",
    title: "prasanna",
    list_url: "/styles/minimalist/prasanna"
  },
  {
    url: "/styles/minimalist/rooted-in-christ-BrWTuZxYxCavbhnnTtj3qv",
    title: "rooted in christ",
    list_url: "/styles/minimalist/rooted-in-christ"
  },
  {
    url: "/styles/minimalist/saguaro-cactus-with-mountains-and-sun-AEDU5KhPSPG7mpZSRk36Kq",
    title: "saguaro cactus with mountains and sun",
    list_url: "/styles/minimalist/saguaro-cactus-with-mountains-and-sun"
  },
  {
    url: "/styles/minimalist/tree-of-life-RhrcBZCbdnNJdZAu1oDFMo",
    title: "tree of life",
    list_url: "/styles/minimalist/tree-of-life"
  },
  {
    url: "/styles/minimalist/valkyrie-wings-8NHXaAAFYJRxh3RuNDP1Lm",
    title: "valkyrie wings",
    list_url: "/styles/minimalist/valkyrie-wings"
  },
  {
    url: "/styles/minimalist/violet-iris-honeysuckle-aster-bouquet-Y7dh2sMD4KC6vqDrj2AcoG",
    title: "violet iris honeysuckle aster bouquet",
    list_url: "/styles/minimalist/violet-iris-honeysuckle-aster-bouquet"
  },
  {
    url: "/styles/neotraditional/1985-in-roman-numerals-intertwined-V6pyuMvngkuSi9Gm4xhmNe",
    title: " in roman numerals intertwined",
    list_url: "/styles/neotraditional/1985-in-roman-numerals-intertwined"
  },
  {
    url: "/styles/neotraditional/compass-with-the-initials-of-my-family-Kg7SaU6QWk21r1NYJmsbUg",
    title: "compass with the initials of my family",
    list_url: "/styles/neotraditional/compass-with-the-initials-of-my-family"
  },
  {
    url: "/styles/neotraditional/gemini-tattoo-2-sides-of-a-face-angel-YNqW3buXiRz62UD6ZAoBG9",
    title: "gemini tattoo sides of a face angel",
    list_url: "/styles/neotraditional/gemini-tattoo-2-sides-of-a-face-angel"
  },
  {
    url: "/styles/neotraditional/golf-hole-in-one-F94sE9cuwJQMCcjNPt7ixq",
    title: "golf hole in one",
    list_url: "/styles/neotraditional/golf-hole-in-one"
  },
  {
    url: "/styles/neotraditional/khukuri-X4G4AFkHzQ6judDCGpUnSK",
    title: "khukuri",
    list_url: "/styles/neotraditional/khukuri"
  },
  {
    url: "/styles/neotraditional/mount-everest-base-camp-VrRr2pmTQN7BYMWw9bcRtb",
    title: "mount everest base camp",
    list_url: "/styles/neotraditional/mount-everest-base-camp"
  },
  {
    url: "/styles/neotraditional/name-hazel-with-date-06052024-2ZxANFhVnpAfoSsfjEdEHQ",
    title: "name hazel with date ",
    list_url: "/styles/neotraditional/name-hazel-with-date-06052024"
  },
  {
    url: "/styles/neotraditional/saint-michael-archangel-lion-JeSep7XuRb77AwShraYSDZ",
    title: "saint michael archangel lion",
    list_url: "/styles/neotraditional/saint-michael-archangel-lion"
  },
  {
    url: "/styles/neotraditional/siri-name-tattoo-NnzYGxwWJFhTR8rDCU6KR4",
    title: "siri name tattoo",
    list_url: "/styles/neotraditional/siri-name-tattoo"
  },
  {
    url: "/styles/neotraditional/text-bnwo-ALYwMZtQqY2CNus1SNpQpV",
    title: "text bnwo",
    list_url: "/styles/neotraditional/text-bnwo"
  },
  {
    url: "/styles/realism/angel-wings-on-chest-9agvVv5YE4STrA96zvaYGD",
    title: "angel wings on chest",
    list_url: "/styles/realism/angel-wings-on-chest"
  },
  {
    url: "/styles/realism/armor-gauntlet-8SKcFiSbjDU1t1q6ay9bPv",
    title: "armor gauntlet",
    list_url: "/styles/realism/armor-gauntlet"
  },
  {
    url: "/styles/realism/bahamas-tropical-palm-trees-with-59AKPb9LLeS5YoszqxPJCn",
    title: "bahamas tropical palm trees with",
    list_url: "/styles/realism/bahamas-tropical-palm-trees-with"
  },
  {
    url: "/styles/realism/erzengel-gabriel-NbiTffkjRMqp6u878TCbvH",
    title: "erzengel gabriel",
    list_url: "/styles/realism/erzengel-gabriel"
  },
  {
    url: "/styles/realism/gay-hairy-muscle-male-pinup-beard-7TaCFjSpcPqoGMsWscxE34",
    title: "gay hairy muscle male pinup beard",
    list_url: "/styles/realism/gay-hairy-muscle-male-pinup-beard"
  },
  {
    url: "/styles/realism/horse-and-angel-3j3CXHQqH98xqUdggKaR6y",
    title: "horse and angel",
    list_url: "/styles/realism/horse-and-angel"
  },
  {
    url: "/styles/realism/hypnos-god-of-sleep-WtTQ59FZiQFFgppy3ESpfW",
    title: "hypnos god of sleep",
    list_url: "/styles/realism/hypnos-god-of-sleep"
  },
  {
    url: "/styles/realism/legends-never-die-PMLdKcs4YfBSBois8YWTmi",
    title: "legends never die",
    list_url: "/styles/realism/legends-never-die"
  },
  {
    url: "/styles/realism/mont-blanc-skyline-BmgfigmvaeShpW5s1fJact",
    title: "mont blanc skyline",
    list_url: "/styles/realism/mont-blanc-skyline"
  },
  {
    url: "/styles/realism/pranay-ALvy4AE6DGVwr3x5xSF1Fo",
    title: "pranay",
    list_url: "/styles/realism/pranay"
  },
  {
    url: "/styles/realism/silver-jews-and-putple-mountains-logo-faWgs3q3Ly873sZ2WY71g",
    title: "silver jews and putple mountains logo",
    list_url: "/styles/realism/silver-jews-and-putple-mountains-logo"
  },
  {
    url: "/styles/realism/st-john-the-baptist-pTUukYWLkSR22SNuZaJpB",
    title: "st john the baptist",
    list_url: "/styles/realism/st-john-the-baptist"
  },
  {
    url: "/styles/realism/tree-rod-of-asclepius-murphy-family-7t1Zm5hobSyqgGAjeoBXBf",
    title: "tree rod of asclepius murphy family",
    list_url: "/styles/realism/tree-rod-of-asclepius-murphy-family"
  },
  {
    url: "/styles/realism/virgin-mary-holding-baby-jesus-RE5Ccva9L4nYSbHFUfgMSr",
    title: "virgin mary holding baby jesus",
    list_url: "/styles/realism/virgin-mary-holding-baby-jesus"
  },
  {
    url: "/styles/realism/yin-and-yang-jaguar-and-shark-XS3Ndgd9xnraxVQYB3KxJ8",
    title: "yin and yang jaguar and shark",
    list_url: "/styles/realism/yin-and-yang-jaguar-and-shark"
  },
  {
    url: "/styles/sketch/ashok-stambh-PdiQMe1DCUuy3DVE6pccuZ",
    title: "ashok stambh",
    list_url: "/styles/sketch/ashok-stambh"
  },
  {
    url: "/styles/sketch/h-and-j-letters-9zs5zFUvjmhSJU7CMt7AJP",
    title: "h and j letters",
    list_url: "/styles/sketch/h-and-j-letters"
  },
  {
    url: "/styles/sketch/hummingbird-and-bald-eagle-VsWAZSDorpR22LfiF27sVr",
    title: "hummingbird and bald eagle",
    list_url: "/styles/sketch/hummingbird-and-bald-eagle"
  },
  {
    url: "/styles/sketch/marine-corps-eagle-globe-and-anchor-J82Q6BHfeyKF7TWreERr5m",
    title: "marine corps eagle globe and anchor",
    list_url: "/styles/sketch/marine-corps-eagle-globe-and-anchor"
  },
  {
    url: "/styles/sketch/roses-with-hummingbird-AV655imuXS1wn6jY8ezZy",
    title: "roses with hummingbird",
    list_url: "/styles/sketch/roses-with-hummingbird"
  },
  {
    url: "/styles/stencil/elian-script-8EKZV9w9ze4hkcndvv3nvn",
    title: "elian script",
    list_url: "/styles/stencil/elian-script"
  },
  {
    url: "/styles/stencil/neck-tattoo-on-the-front-of-the-neck-2LDeofjdLMqR545QgMhy3X",
    title: "neck tattoo on the front of the neck",
    list_url: "/styles/stencil/neck-tattoo-on-the-front-of-the-neck"
  },
  {
    url: "/styles/traditional/royal-navy-Y7cro2SNYwLUYCXkLedbq3",
    title: "royal navy",
    list_url: "/styles/traditional/royal-navy"
  },
  {
    url: "/styles/tribal/hungry-male-womb-tattoo-R2c1odzyjZWbDtRBGuXc3z",
    title: "hungry male womb tattoo",
    list_url: "/styles/tribal/hungry-male-womb-tattoo"
  },
  {
    url: "/styles/western-font",
    title: "western",
    list_url: "/styles/western"
  },
  {
    url: "/styles/abstract/murder-drones-flying-overhead-6XDkdxE1tLqHtVMn1WBNwM",
    title: "murder drones flying overhead",
    list_url: "/styles/abstract/murder-drones-flying-overhead"
  },
  {
    url: "/styles/anime/hentai-girl-squirting-69H1agZubz5q7ytjVuzAAc",
    title: "hentai girl squirting",
    list_url: "/styles/anime/hentai-girl-squirting"
  },
  {
    url: "/styles/anime/killua-42bCuN8QXhYkpbbiadqaiB",
    title: "killua",
    list_url: "/styles/anime/killua"
  },
  {
    url: "/styles/anime/misa-amane-from-death-note-is-depicted-NmTWKdadftvWkYnmdDfTGS",
    title: "misa amane from death note is depicted",
    list_url: "/styles/anime/misa-amane-from-death-note-is-depicted"
  },
  {
    url: "/styles/black-grey/1964-chevrolet-impala-9hxQjSxE4bURdrY384Tbez",
    title: " chevrolet impala",
    list_url: "/styles/black-grey/1964-chevrolet-impala"
  },
  {
    url: "/styles/black-grey/aqua-tofana-poison-bottle-belladonna-454HooZBXXKwzUAPcXPaDV",
    title: "aqua tofana poison bottle belladonna",
    list_url: "/styles/black-grey/aqua-tofana-poison-bottle-belladonna"
  },
  {
    url: "/styles/black-grey/bbc-qos-blacked-4EXnpewDNzBevQVuY1arrf",
    title: "bbc qos blacked",
    list_url: "/styles/black-grey/bbc-qos-blacked"
  },
  {
    url: "/styles/black-grey/clock-tree-of-life-EkgWBZEfqHD1J4SJvJcNNs",
    title: "clock tree of life",
    list_url: "/styles/black-grey/clock-tree-of-life"
  },
  {
    url: "/styles/black-grey/drilling-rig-6kxo2CMd8yyzb4VtE44mB1",
    title: "drilling rig",
    list_url: "/styles/black-grey/drilling-rig"
  },
  {
    url: "/styles/black-grey/flanagan-family-crest-featuring-roots-4BFcPq54Rg47RDXW3AXKSf",
    title: "flanagan family crest featuring roots",
    list_url: "/styles/black-grey/flanagan-family-crest-featuring-roots"
  },
  {
    url: "/styles/black-grey/generation-x-with-the-year-1976-GyLvNxP2fsrccqXPdeVTaa",
    title: "generation x with the year ",
    list_url: "/styles/black-grey/generation-x-with-the-year-1976"
  },
  {
    url: "/styles/black-grey/good-versus-evil-sleeve-YD313gCrmXEujpNKgGz4ZL",
    title: "good versus evil sleeve",
    list_url: "/styles/black-grey/good-versus-evil-sleeve"
  },
  {
    url: "/styles/black-grey/haunting-adeline-by-h-d-carlton-rose-DbDXVRMKUw1xZ6MhPJ1myW",
    title: "haunting adeline by h d carlton rose",
    list_url: "/styles/black-grey/haunting-adeline-by-h-d-carlton-rose"
  },
  {
    url: "/styles/black-grey/honda-dio-scooter-with-bird-and-dog-RTPDX5u9GQvuNKqcWvvArx",
    title: "honda dio scooter with bird and dog",
    list_url: "/styles/black-grey/honda-dio-scooter-with-bird-and-dog"
  },
  {
    url: "/styles/black-grey/jordan-name-with-design-inspired-xSBoThN3XWoy71A3VLd74",
    title: "jordan name with design inspired",
    list_url: "/styles/black-grey/jordan-name-with-design-inspired"
  },
  {
    url: "/styles/black-grey/kamar-wheel-and-human-death-Qvq6dP6LfcBTm7yV6GEUDk",
    title: "kamar wheel and human death",
    list_url: "/styles/black-grey/kamar-wheel-and-human-death"
  },
  {
    url: "/styles/black-grey/lone-wolf-with-sigma-symbol-on-its-head-zLuawEHFTVBPAhegkHp1N",
    title: "lone wolf with sigma symbol on its head",
    list_url: "/styles/black-grey/lone-wolf-with-sigma-symbol-on-its-head"
  },
  {
    url: "/styles/black-grey/lost-time-VUJKQoan4EnL2X92NyToDe",
    title: "lost time",
    list_url: "/styles/black-grey/lost-time"
  },
  {
    url: "/styles/black-grey/mad-hatter-hat-RUTtxRNL7ayoyXg4HHhMpE",
    title: "mad hatter hat",
    list_url: "/styles/black-grey/mad-hatter-hat"
  },
  {
    url: "/styles/black-grey/name-tatto-with-just-the-name-joan-with-AngTpYJ5xTxnfDh7Aacwg6",
    title: "name tatto with just the name joan with",
    list_url: "/styles/black-grey/name-tatto-with-just-the-name-joan-with"
  },
  {
    url: "/styles/black-grey/newcastle-united-BC7P8Pj8UZWLXZzM6gxx8p",
    title: "newcastle united",
    list_url: "/styles/black-grey/newcastle-united"
  },
  {
    url: "/styles/black-grey/nikita-name-V2aM9C32oRzvc2ppHHXJUm",
    title: "nikita name",
    list_url: "/styles/black-grey/nikita-name"
  },
  {
    url: "/styles/black-grey/number-8-tattoo-with-a-crown-and-wings-CMVwAuXMx2fJJFQengrWNj",
    title: "number tattoo with a crown and wings",
    list_url: "/styles/black-grey/number-8-tattoo-with-a-crown-and-wings"
  },
  {
    url: "/styles/black-grey/police-k9-police-dog-FDfR673jKihxYrvi6UjCHg",
    title: "police k police dog",
    list_url: "/styles/black-grey/police-k9-police-dog"
  },
  {
    url: "/styles/black-grey/sarita-dinesh-name-tattoo-Ammz4Rv63PPvdtdkdQXN1j",
    title: "sarita dinesh name tattoo",
    list_url: "/styles/black-grey/sarita-dinesh-name-tattoo"
  },
  {
    url: "/styles/black-grey/scorpion-with-roses-NSvLpUjBQ3XPPhPqrfBp8h",
    title: "scorpion with roses",
    list_url: "/styles/black-grey/scorpion-with-roses"
  },
  {
    url: "/styles/black-grey/teenage-mutant-ninja-turtles-4NWs6jtqAL7wFwcJuuPfhz",
    title: "teenage mutant ninja turtles",
    list_url: "/styles/black-grey/teenage-mutant-ninja-turtles"
  },
  {
    url: "/styles/black-grey/the-letter-x-K63ewtvFg6rVg1mKMXnuWP",
    title: "the letter x",
    list_url: "/styles/black-grey/the-letter-x"
  },
  {
    url: "/styles/black-grey/the-only-way-out-is-through-7auv3N6j5XdJzjVfyUMaDY",
    title: "the only way out is through",
    list_url: "/styles/black-grey/the-only-way-out-is-through"
  },
  {
    url: "/styles/black-grey/thin-blue-line-flag-HiqM2WSaWRRbQZbUuYf4z9",
    title: "thin blue line flag",
    list_url: "/styles/black-grey/thin-blue-line-flag"
  },
  {
    url: "/styles/black-grey/wolf-and-phoenix-KmPRqaPRTMKsbnSkoUgs8U",
    title: "wolf and phoenix",
    list_url: "/styles/black-grey/wolf-and-phoenix"
  },
  {
    url: "/styles/blackwork/anchor-palm-tree-H6XBGppx5Pt4RWZn5eghSY",
    title: "anchor palm tree",
    list_url: "/styles/blackwork/anchor-palm-tree"
  },
  {
    url: "/styles/blackwork/apellido-herrera-RXacdrnsFFSn33EYKS2Acc",
    title: "apellido herrera",
    list_url: "/styles/blackwork/apellido-herrera"
  },
  {
    url: "/styles/blackwork/apurva-in-hindi-calligraphy-V7hFcG13LZeA7zo3g7uBHx",
    title: "apurva in hindi calligraphy",
    list_url: "/styles/blackwork/apurva-in-hindi-calligraphy"
  },
  {
    url: "/styles/blackwork/aries-and-gemini-9AyWCBscK3XNWwu5Wr9es1",
    title: "aries and gemini",
    list_url: "/styles/blackwork/aries-and-gemini"
  },
  {
    url: "/styles/blackwork/beautiful-female-guardian-angel-ESPGwtHA2SSQbDUNnMw9tV",
    title: "beautiful female guardian angel",
    list_url: "/styles/blackwork/beautiful-female-guardian-angel"
  },
  {
    url: "/styles/blackwork/gothic-sleeve-WXSPNfk9EpPNkQpcXc6fg9",
    title: "gothic sleeve",
    list_url: "/styles/blackwork/gothic-sleeve"
  },
  {
    url: "/styles/blackwork/guitar-pick-K9usXZiJrgKPyMkAUSfiBA",
    title: "guitar pick",
    list_url: "/styles/blackwork/guitar-pick"
  },
  {
    url: "/styles/blackwork/irish-republican-army-inspired-leg-TtqGDDaCNVwg87sZLXnL1",
    title: "irish republican army inspired leg",
    list_url: "/styles/blackwork/irish-republican-army-inspired-leg"
  },
  {
    url: "/styles/blackwork/louisiana-cajun-inspired-fleur-de-lis-VpZwyBwbygP1tZmyUsCqgK",
    title: "louisiana cajun inspired fleur de lis",
    list_url: "/styles/blackwork/louisiana-cajun-inspired-fleur-de-lis"
  },
  {
    url: "/styles/blackwork/police-k9-handler-NcjAyAVtAdpuawhuhepT14",
    title: "police k handler",
    list_url: "/styles/blackwork/police-k9-handler"
  },
  {
    url: "/styles/blackwork/sayali-name-9Ex5atodeAwXz1vY8EEyiE",
    title: "sayali name",
    list_url: "/styles/blackwork/sayali-name"
  },
  {
    url: "/styles/blackwork/scottish-claymore-with-macdonald-clan-Ej7gTKcs46gm7fAdkyU9nq",
    title: "scottish claymore with macdonald clan",
    list_url: "/styles/blackwork/scottish-claymore-with-macdonald-clan"
  },
  {
    url: "/styles/blackwork/sharon-name-8T76SDEzhfhxuZ26FsDLiR",
    title: "sharon name",
    list_url: "/styles/blackwork/sharon-name"
  },
  {
    url: "/styles/blackwork/skeleton-on-skis-Ek6AYKDvBXVc3TiasPvjc2",
    title: "skeleton on skis",
    list_url: "/styles/blackwork/skeleton-on-skis"
  },
  {
    url: "/styles/blackwork/submarine-dolphins-WNWiaJFw16BYJY6Qc4jJ7B",
    title: "submarine dolphins",
    list_url: "/styles/blackwork/submarine-dolphins"
  },
  {
    url: "/styles/blackwork/the-name-tanisha-MXB21b5or6p8mtjjyRWvXe",
    title: "the name tanisha",
    list_url: "/styles/blackwork/the-name-tanisha"
  },
  {
    url: "/styles/blackwork/tony-ferguson-angel-wings-6hNd7HaArjKHABf9XwruvQ",
    title: "tony ferguson angel wings",
    list_url: "/styles/blackwork/tony-ferguson-angel-wings"
  },
  {
    url: "/styles/dotwork/a-cross-with-the-words-deus-ubique-HAEXxWWf39DXmfL4F2oFLh",
    title: "a cross with the words deus ubique",
    list_url: "/styles/dotwork/a-cross-with-the-words-deus-ubique"
  },
  {
    url: "/styles/dotwork/butterfly-with-phoenix-2bughAdvJRTfURqEcLZmKH",
    title: "butterfly with phoenix",
    list_url: "/styles/dotwork/butterfly-with-phoenix"
  },
  {
    url: "/styles/dotwork/geeta-name-in-ganpati-design-WKrV7J1uJi2ZDUggpuN1uo",
    title: "geeta name in ganpati design",
    list_url: "/styles/dotwork/geeta-name-in-ganpati-design"
  },
  {
    url: "/styles/dotwork/improvise-adapt-overcome-MZSwLcxhGJG4c3WhArGKK7",
    title: "improvise adapt overcome",
    list_url: "/styles/dotwork/improvise-adapt-overcome"
  },
  {
    url: "/styles/dotwork/iris-goo-goo-dolls-8kscnv1HSxdoaLsuvM2PVm",
    title: "iris goo goo dolls",
    list_url: "/styles/dotwork/iris-goo-goo-dolls"
  },
  {
    url: "/styles/dotwork/k-bar-knife-with-usmc-on-it-6r4Ytqyy6VE6ug78KUCG5a",
    title: "k bar knife with usmc on it",
    list_url: "/styles/dotwork/k-bar-knife-with-usmc-on-it"
  },
  {
    url: "/styles/dotwork/rabbit-with-gun-NLLwvFhjVAVMpzHbWAJr8M",
    title: "rabbit with gun",
    list_url: "/styles/dotwork/rabbit-with-gun"
  },
  {
    url: "/styles/dotwork/rudraksh-with-name-kabir-and-pratap-2U3aEEm1HkFHS7ptYAGNXe",
    title: "rudraksh with name kabir and pratap",
    list_url: "/styles/dotwork/rudraksh-with-name-kabir-and-pratap"
  },
  {
    url: "/styles/dotwork/shani-name-X65W4uq7XRQWg8MWSc9qAv",
    title: "shani name",
    list_url: "/styles/dotwork/shani-name"
  },
  {
    url: "/styles/dotwork/teja-Jca8ZjRYKNB7NMkypR67x8",
    title: "teja",
    list_url: "/styles/dotwork/teja"
  },
  {
    url: "/styles/dotwork/thin-line-spiralling-galaxy-Kdi8v3PqjkUhfVbFzzjMVL",
    title: "thin line spiralling galaxy",
    list_url: "/styles/dotwork/thin-line-spiralling-galaxy"
  },
  {
    url: "/styles/dotwork/tree-of-life-sliding-inside-an-hourglass-VDeyNiM8jnkKKJUiwJYZzK",
    title: "tree of life sliding inside an hourglass",
    list_url: "/styles/dotwork/tree-of-life-sliding-inside-an-hourglass"
  },
  {
    url: "/styles/geometric/buddhist-vajra-HH5VAK5aMtV9MxJjSrih8k",
    title: "buddhist vajra",
    list_url: "/styles/geometric/buddhist-vajra"
  },
  {
    url: "/styles/gothic/nobody-is-coming-to-save-you-PARPRyzzDY1vERfPvXC27e",
    title: "nobody is coming to save you",
    list_url: "/styles/gothic/nobody-is-coming-to-save-you"
  },
  {
    url: "/styles/japanese/9-magatama-LETZBdZHhgviMgB5Kdaf2s",
    title: " magatama",
    list_url: "/styles/japanese/9-magatama"
  },
  {
    url: "/styles/japanese/a-blue-jade-vine-flower-KT8vRXdEbnkvG5aeKLs7Kg",
    title: "a blue jade vine flower",
    list_url: "/styles/japanese/a-blue-jade-vine-flower"
  },
  {
    url: "/styles/japanese/cancer-zodiac-sign-MEMppwpEvajJ3Sm9gpGL1L",
    title: "cancer zodiac sign",
    list_url: "/styles/japanese/cancer-zodiac-sign"
  },
  {
    url: "/styles/japanese/eccedentesiast-6SQ2fqcppFaVULMTisJUTw",
    title: "eccedentesiast",
    list_url: "/styles/japanese/eccedentesiast"
  },
  {
    url: "/styles/japanese/faith-over-fear-BpU28aDandU3ikD5ukmzv5",
    title: "faith over fear",
    list_url: "/styles/japanese/faith-over-fear"
  },
  {
    url: "/styles/japanese/intertwined-letters-l-and-m-JD34Jt6nZR3vXvvbJNq2r2",
    title: "intertwined letters l and m",
    list_url: "/styles/japanese/intertwined-letters-l-and-m"
  },
  {
    url: "/styles/japanese/kyokushin-karate-kanji-kanku-5TrPx2MH9dyBZzejJLuMvf",
    title: "kyokushin karate kanji kanku",
    list_url: "/styles/japanese/kyokushin-karate-kanji-kanku"
  },
  {
    url: "/styles/japanese/okinawa-QEuNgUZkqN92c45HyMAHHv",
    title: "okinawa",
    list_url: "/styles/japanese/okinawa"
  },
  {
    url: "/styles/japanese/sagittarius-QHUXUvDVpwHE3bF5RJFXgg",
    title: "sagittarius",
    list_url: "/styles/japanese/sagittarius"
  },
  {
    url: "/styles/japanese/shiba-inu-Su49sAkwGnG22ubNSuRX43",
    title: "shiba inu",
    list_url: "/styles/japanese/shiba-inu"
  },
  {
    url: "/styles/japanese/small-tattoo-of-dragon-ball-goku-that-TUWS82UChDZdP3z5b4VyvB",
    title: "small tattoo of dragon ball goku that",
    list_url: "/styles/japanese/small-tattoo-of-dragon-ball-goku-that"
  },
  {
    url: "/styles/japanese/symbol-that-shows-pain-and-strength-42MRCtboq5fAwVY4Suoygo",
    title: "symbol that shows pain and strength",
    list_url: "/styles/japanese/symbol-that-shows-pain-and-strength"
  },
  {
    url: "/styles/japanese/torii-gate-with-cherry-blossom-tree-GqyfDT6fJU5nRP3JToPsEM",
    title: "torii gate with cherry blossom tree",
    list_url: "/styles/japanese/torii-gate-with-cherry-blossom-tree"
  },
  {
    url: "/styles/minimalist/1968-and-1972-in-roman-numerals-QdesyG8mvt7UJB153LPzCz",
    title: " and in roman numerals",
    list_url: "/styles/minimalist/1968-and-1972-in-roman-numerals"
  },
  {
    url: "/styles/minimalist/5-leaf-clover-4dRort86ZPy7sZqKNAaZJJ",
    title: " leaf clover",
    list_url: "/styles/minimalist/5-leaf-clover"
  },
  {
    url: "/styles/minimalist/5-pikake-hawaiian-flower-with-nac-mJ8aHsGtruSccMuEmQgwA",
    title: " pikake hawaiian flower with nac",
    list_url: "/styles/minimalist/5-pikake-hawaiian-flower-with-nac"
  },
  {
    url: "/styles/minimalist/8-and-24-kobe-bryant-Lswk3hXKG362d89QvmgYrp",
    title: " and kobe bryant",
    list_url: "/styles/minimalist/8-and-24-kobe-bryant"
  },
  {
    url: "/styles/minimalist/a-fine-line-tatoo-of-a-vine-with-leaves-GYowvyddsMtSP9Nb3uokyp",
    title: "a fine line tatoo of a vine with leaves",
    list_url: "/styles/minimalist/a-fine-line-tatoo-of-a-vine-with-leaves"
  },
  {
    url: "/styles/minimalist/a-lotus-flower-that-attract-money-good-MJFyY2iW4m1NVpKHVWWVdE",
    title: "a lotus flower that attract money good",
    list_url: "/styles/minimalist/a-lotus-flower-that-attract-money-good"
  },
  {
    url: "/styles/minimalist/as-above-so-below-as-within-so-JwamtKDEKw8TYTmqN2BFRD",
    title: "as above so below as within so",
    list_url: "/styles/minimalist/as-above-so-below-as-within-so"
  },
  {
    url: "/styles/minimalist/black-and-white-bumble-bee-Ut1anU13gRLqTZKFhBZmMt",
    title: "black and white bumble bee",
    list_url: "/styles/minimalist/black-and-white-bumble-bee"
  },
  {
    url: "/styles/minimalist/catwoman-H91HMdrseadqCLmpT1VN9F",
    title: "catwoman",
    list_url: "/styles/minimalist/catwoman"
  },
  {
    url: "/styles/minimalist/contentment-8MutkkqPqfStyiHsrzXnWU",
    title: "contentment",
    list_url: "/styles/minimalist/contentment"
  },
  {
    url: "/styles/minimalist/crow-6cy2uYf16F5p69PKiRY4Af",
    title: "crow",
    list_url: "/styles/minimalist/crow"
  },
  {
    url: "/styles/minimalist/digimon-RXtaXZaDXCqffYoeJtmZ9U",
    title: "digimon",
    list_url: "/styles/minimalist/digimon"
  },
  {
    url: "/styles/minimalist/if-you-have-faith-the-size-of-a-mustard-EHEtV2vP1aCARCAnnq38Ss",
    title: "if you have faith the size of a mustard",
    list_url: "/styles/minimalist/if-you-have-faith-the-size-of-a-mustard"
  },
  {
    url: "/styles/minimalist/jack-russell-terrier-EY8gkKknc4xgy9AG6PFKEt",
    title: "jack russell terrier",
    list_url: "/styles/minimalist/jack-russell-terrier"
  },
  {
    url: "/styles/minimalist/letter-c-s-A5vxqN9iA45aWHXuaiJ3wk",
    title: "letter c s",
    list_url: "/styles/minimalist/letter-c-s"
  },
  {
    url: "/styles/minimalist/morning-glory-and-carnation-flower-7edch9S1yJsk7y99KJKhZ1",
    title: "morning glory and carnation flower",
    list_url: "/styles/minimalist/morning-glory-and-carnation-flower"
  },
  {
    url: "/styles/minimalist/philippians-413-in-hebrew-text-JMRGpiKcBxLurzTCTdaPCd",
    title: "philippians in hebrew text",
    list_url: "/styles/minimalist/philippians-413-in-hebrew-text"
  },
  {
    url: "/styles/neotraditional/a-plague-tale-requiem-XbniFqWKnEesci27Ayf5V1",
    title: "a plague tale requiem",
    list_url: "/styles/neotraditional/a-plague-tale-requiem"
  },
  {
    url: "/styles/neotraditional/arrow-with-genesis-273-5scDyAntouoP46yXKwRyEu",
    title: "arrow with genesis ",
    list_url: "/styles/neotraditional/arrow-with-genesis-273"
  },
  {
    url: "/styles/neotraditional/calla-lily-and-rose-bouquet-tattoo-2iWsUQbVe12w9pXFFqVe7q",
    title: "calla lily and rose bouquet tattoo",
    list_url: "/styles/neotraditional/calla-lily-and-rose-bouquet-tattoo"
  },
  {
    url: "/styles/neotraditional/hungarian-folktales-CK47mmKC7jRvX3bgjTJKjU",
    title: "hungarian folktales",
    list_url: "/styles/neotraditional/hungarian-folktales"
  },
  {
    url: "/styles/neotraditional/name-marisa-with-a-butterfly-B2kSXHQDxPCDSBNdvABSBi",
    title: "name marisa with a butterfly",
    list_url: "/styles/neotraditional/name-marisa-with-a-butterfly"
  },
  {
    url: "/styles/neotraditional/name-tattoo-robert-with-heart-shaped-LCGeZN4ZmSWgk4S4FkCkm1",
    title: "name tattoo robert with heart shaped",
    list_url: "/styles/neotraditional/name-tattoo-robert-with-heart-shaped"
  },
  {
    url: "/styles/neotraditional/noah-name-5sUUfpvh8SvoTmvV5TCxXR",
    title: "noah name",
    list_url: "/styles/neotraditional/noah-name"
  },
  {
    url: "/styles/neotraditional/raghav-name-with-flute-surrounded-XBC6trHp7h4mv4fked4XLv",
    title: "raghav name with flute surrounded",
    list_url: "/styles/neotraditional/raghav-name-with-flute-surrounded"
  },
  {
    url: "/styles/neotraditional/ramesh-name-tattoo-with-king-crown-and-QDLQDriSvPXc5VSTA43P27",
    title: "ramesh name tattoo with king crown and",
    list_url: "/styles/neotraditional/ramesh-name-tattoo-with-king-crown-and"
  },
  {
    url: "/styles/neotraditional/sakshi-named-6HxpNJcB8euypgU7L8cE51",
    title: "sakshi named",
    list_url: "/styles/neotraditional/sakshi-named"
  },
  {
    url: "/styles/neotraditional/sarvam-anityam-ETnbTf4ZWvc2vs5nTZ1gtv",
    title: "sarvam anityam",
    list_url: "/styles/neotraditional/sarvam-anityam"
  },
  {
    url: "/styles/neotraditional/tattoo-with-mira-name-written-9br85cpoymhQEFxc7UqubP",
    title: "tattoo with mira name written",
    list_url: "/styles/neotraditional/tattoo-with-mira-name-written"
  },
  {
    url: "/styles/neotraditional/the-name-holly-in-a-fancy-font-GN2BX1wbBUgX7qAdt2dwM9",
    title: "the name holly in a fancy font",
    list_url: "/styles/neotraditional/the-name-holly-in-a-fancy-font"
  },
  {
    url: "/styles/neotraditional/thomas-name-tattoo-7opHN4bMQrQsKYv516to2F",
    title: "thomas name tattoo",
    list_url: "/styles/neotraditional/thomas-name-tattoo"
  },
  {
    url: "/styles/neotraditional/troll-QHeiLwxvcEfiqC4fjb3KCc",
    title: "troll",
    list_url: "/styles/neotraditional/troll"
  },
  {
    url: "/styles/neotraditional/vijaya-lakshmi-name-together-FuQtyCvTwm2vV7oPvxb4u9",
    title: "vijaya lakshmi name together",
    list_url: "/styles/neotraditional/vijaya-lakshmi-name-together"
  },
  {
    url: "/styles/neotraditional/virgin-mary-pinup-girl-KTiz7ysiro7jofKdC438i9",
    title: "virgin mary pinup girl",
    list_url: "/styles/neotraditional/virgin-mary-pinup-girl"
  },
  {
    url: "/styles/new-school/grease-monkey-HTX2WhuU7JU1ctJh3KgDpf",
    title: "grease monkey",
    list_url: "/styles/new-school/grease-monkey"
  },
  {
    url: "/styles/realism/archangel-michael-battling-a-dragon-CGxB8B6mfMEgXhcDe8RhRo",
    title: "archangel michael battling a dragon",
    list_url: "/styles/realism/archangel-michael-battling-a-dragon"
  },
  {
    url: "/styles/realism/demons-crawling-out-of-hell-R19vqaANuYFJYFpaPGK5fZ",
    title: "demons crawling out of hell",
    list_url: "/styles/realism/demons-crawling-out-of-hell"
  },
  {
    url: "/styles/realism/dolphin-and-butterfly-UYQCwp6RD4nNNNBoN8VJQS",
    title: "dolphin and butterfly",
    list_url: "/styles/realism/dolphin-and-butterfly"
  },
  {
    url: "/styles/realism/dragon-fights-with-an-angel-TeBLYz7jRYYVRB1v4dYCdW",
    title: "dragon fights with an angel",
    list_url: "/styles/realism/dragon-fights-with-an-angel"
  },
  {
    url: "/styles/realism/drug-dealer-Vmein4TxcVTxMQJLbwciRC",
    title: "drug dealer",
    list_url: "/styles/realism/drug-dealer"
  },
  {
    url: "/styles/realism/green-eye-B8uuHqsbfnKWhS3LCUYkSY",
    title: "green eye",
    list_url: "/styles/realism/green-eye"
  },
  {
    url: "/styles/realism/joseph-from-bible-story-SVPYRbz73BYPnQ7k7BwmF",
    title: "joseph from bible story",
    list_url: "/styles/realism/joseph-from-bible-story"
  },
  {
    url: "/styles/realism/libra-tattoos-for-men-Rx9jfQEKmiodBwTXLwvrTR",
    title: "libra tattoos for men",
    list_url: "/styles/realism/libra-tattoos-for-men"
  },
  {
    url: "/styles/realism/lion-statue-Wb4hgrU1Zh9RzdQTyn69n3",
    title: "lion statue",
    list_url: "/styles/realism/lion-statue"
  },
  {
    url: "/styles/realism/logo-for-a-fashion-brand-name-called-9XBprtEBKnxeR1WhEKCdwe",
    title: "logo for a fashion brand name called",
    list_url: "/styles/realism/logo-for-a-fashion-brand-name-called"
  },
  {
    url: "/styles/realism/poison-dart-frogs-2RV3u7zy6AbNzZRimovtm9",
    title: "poison dart frogs",
    list_url: "/styles/realism/poison-dart-frogs"
  },
  {
    url: "/styles/realism/rhea-ripley-wwe-4nHiXEYxrDZkFLMarEUV5r",
    title: "rhea ripley wwe",
    list_url: "/styles/realism/rhea-ripley-wwe"
  },
  {
    url: "/styles/realism/robin-bird-for-rememberance-of-mom-dad-X6Ddrce9e1cLZH6JZQDUAM",
    title: "robin bird for rememberance of mom dad",
    list_url: "/styles/realism/robin-bird-for-rememberance-of-mom-dad"
  },
  {
    url: "/styles/realism/scottish-robertson-clan-crest-UR18qbiTQd5CXDzbHfYjzL",
    title: "scottish robertson clan crest",
    list_url: "/styles/realism/scottish-robertson-clan-crest"
  },
  {
    url: "/styles/realism/tattoo-of-a-bull-and-bear-fighting-UZ68LMNscs7eM4GrxsSDr9",
    title: "tattoo of a bull and bear fighting",
    list_url: "/styles/realism/tattoo-of-a-bull-and-bear-fighting"
  },
  {
    url: "/styles/realism/the-silhouette-of-a-man-walking-a-path-K69JyxwFYu3SfEqsmiJHeh",
    title: "the silhouette of a man walking a path",
    list_url: "/styles/realism/the-silhouette-of-a-man-walking-a-path"
  },
  {
    url: "/styles/realism/tiger-family-Nf1j1t8wu24uDA32Mpuka6",
    title: "tiger family",
    list_url: "/styles/realism/tiger-family"
  },
  {
    url: "/styles/sketch/badass-E2fRUBs1hFA4cBwJKqx17X",
    title: "badass",
    list_url: "/styles/sketch/badass"
  },
  {
    url: "/styles/sketch/carnations-snowdrops-daisy-sweet-pea-DaWGrUcNYi3RkuuvcGffcB",
    title: "carnations snowdrops daisy sweet pea",
    list_url: "/styles/sketch/carnations-snowdrops-daisy-sweet-pea"
  },
  {
    url: "/styles/sketch/lily-and-hibiscus-flowers-with-ocean-M5EpjcpvLiGXD91UEjLgKd",
    title: "lily and hibiscus flowers with ocean",
    list_url: "/styles/sketch/lily-and-hibiscus-flowers-with-ocean"
  },
  {
    url: "/styles/sketch/naked-anime-girl-with-small-breasts-Vq5j7dmnLP1ceFXc2fDkzT",
    title: "naked anime girl with small breasts",
    list_url: "/styles/sketch/naked-anime-girl-with-small-breasts"
  },
  {
    url: "/styles/sketch/sandy-name-KbVHNENS7qsaWUbkmMY2qT",
    title: "sandy name",
    list_url: "/styles/sketch/sandy-name"
  },
  {
    url: "/styles/sketch/the-name-natasha-with-a-heart-R7NT2jAoKTno8mgb7N1YVQ",
    title: "the name natasha with a heart",
    list_url: "/styles/sketch/the-name-natasha-with-a-heart"
  },
  {
    url: "/styles/sketch/words-with-clouds-in-the-back-KKHcjvmBsqrioQRbRFYt42",
    title: "words with clouds in the back",
    list_url: "/styles/sketch/words-with-clouds-in-the-back"
  },
  {
    url: "/styles/stencil/aryan-brotherhood-A2Zt7DDkBi8LmWFVicQW7n",
    title: "aryan brotherhood",
    list_url: "/styles/stencil/aryan-brotherhood"
  },
  {
    url: "/styles/stencil/kinky-sissy-slave-pink-leather-collar-R69itoQqnP1GqdkoVBhwtf",
    title: "kinky sissy slave pink leather collar",
    list_url: "/styles/stencil/kinky-sissy-slave-pink-leather-collar"
  },
  {
    url: "/styles/stencil/viking-wolfsangel-DMiYRQXqTiTBtDWCbVgVUi",
    title: "viking wolfsangel",
    list_url: "/styles/stencil/viking-wolfsangel"
  },
  {
    url: "/styles/surrealism/you-are-my-sunshine-FhkNyUFGLkGW5cscxfaYQZ",
    title: "you are my sunshine",
    list_url: "/styles/surrealism/you-are-my-sunshine"
  },
  {
    url: "/styles/traditional/alvin-from-the-chipmunks-6gVzLCVNr3QxvQffTK62hw",
    title: "alvin from the chipmunks",
    list_url: "/styles/traditional/alvin-from-the-chipmunks"
  },
  {
    url: "/styles/traditional/colombian-XLaksXWbmAgq8kf8zq4pNa",
    title: "colombian",
    list_url: "/styles/traditional/colombian"
  },
  {
    url: "/styles/traditional/crotch-tattoo-design-from-the-name-KVAUKQW4EWtBJXupT51WdT",
    title: "crotch tattoo design from the name",
    list_url: "/styles/traditional/crotch-tattoo-design-from-the-name"
  },
  {
    url: "/styles/traditional/cyprus-7HFwrCnKh9zv7YFSHfvA2F",
    title: "cyprus",
    list_url: "/styles/traditional/cyprus"
  },
  {
    url: "/styles/traditional/kal-chakra-Vej9aFGJfZhPbWZrEjA1TZ",
    title: "kal chakra",
    list_url: "/styles/traditional/kal-chakra"
  },
  {
    url: "/styles/traditional/letters-m-and-e-cursive-with-a-heart-Y73Zah2DzHoJewmB5qex64",
    title: "letters m and e cursive with a heart",
    list_url: "/styles/traditional/letters-m-and-e-cursive-with-a-heart"
  },
  {
    url: "/styles/traditional/tarzan-9XzA4hL3bLiuw8XWzX5wHq",
    title: "tarzan",
    list_url: "/styles/traditional/tarzan"
  },
  {
    url: "/styles/traditional/water-earth-sky-space-AuZXpNsCoPyhG14iTpT9HT",
    title: "water earth sky space",
    list_url: "/styles/traditional/water-earth-sky-space"
  },
  {
    url: "/styles/trash-polka/poz-hiv-toxic-MfhrbaV6tETS8ktiniKBXN",
    title: "poz hiv toxic",
    list_url: "/styles/trash-polka/poz-hiv-toxic"
  },
  {
    url: "/styles/tribal/denver-broncos-logo-P5YK9PCCHw9cyezotjcXqY",
    title: "denver broncos logo",
    list_url: "/styles/tribal/denver-broncos-logo"
  },
  {
    url: "/styles/tribal/military-with-fallen-soldier-3seqyqCQHLqXYYb5cpPSaL",
    title: "military with fallen soldier",
    list_url: "/styles/tribal/military-with-fallen-soldier"
  },
  {
    url: "/styles/tribal/name-arya-FkF4DeNpVxrSkyJhTkuS2Y",
    title: "name arya",
    list_url: "/styles/tribal/name-arya"
  },
  {
    url: "/styles/tribal/polynesian-neck-tattoo-5vBvLFsfaPQqV1aNa3W9m5",
    title: "polynesian neck tattoo",
    list_url: "/styles/tribal/polynesian-neck-tattoo"
  },
  {
    url: "/styles/tribal/the-name-beth-in-a-heart-with-an-arrow-9i3qWqnZxc5xDzA7MT9xyv",
    title: "the name beth in a heart with an arrow",
    list_url: "/styles/tribal/the-name-beth-in-a-heart-with-an-arrow"
  },
  {
    url: "/styles/watercolor/symbolism-for-cycle-breaker-SZeD4cfxs4r5LvdqCRPGK5",
    title: "symbolism for cycle breaker",
    list_url: "/styles/watercolor/symbolism-for-cycle-breaker"
  },
  {
    url: "/styles/anime/couple-tattoo-AszZU3WcSTMhEG2jAk2mFN",
    title: "couple tattoo",
    list_url: "/styles/anime/couple-tattoo"
  },
  {
    url: "/styles/anime/sissy-slave-pink-leather-GZngMzkRq5vff5J3LHXDTY",
    title: "sissy slave pink leather",
    list_url: "/styles/anime/sissy-slave-pink-leather"
  },
  {
    url: "/styles/anime/slutty-milf-baker-with-the-writing-RWdjJoEAcdSZ27Qwboo5zU",
    title: "slutty milf baker with the writing",
    list_url: "/styles/anime/slutty-milf-baker-with-the-writing"
  },
  {
    url: "/styles/black-grey/angel-in-a-tree-HXJuKscG92VfgQMEd7uE73",
    title: "angel in a tree",
    list_url: "/styles/black-grey/angel-in-a-tree"
  },
  {
    url: "/styles/black-grey/anunnaki-9QDfBNAhvCVz49EuJk61cL",
    title: "anunnaki",
    list_url: "/styles/black-grey/anunnaki"
  },
  {
    url: "/styles/black-grey/audere-est-facerewriting-latinarabic-DrSb7h5YQxW3tmR7BJGcGj",
    title: "audere est facerewriting latinarabic",
    list_url: "/styles/black-grey/audere-est-facerewriting-latinarabic"
  },
  {
    url: "/styles/black-grey/blood-makes-u-related-loyalty-makes-you-X7sbmE6ej6773Fg7phPQNy",
    title: "blood makes u related loyalty makes you",
    list_url: "/styles/black-grey/blood-makes-u-related-loyalty-makes-you"
  },
  {
    url: "/styles/black-grey/daughter-name-millie-8Wys8rq9B7JtoD9CMTjktn",
    title: "daughter name millie",
    list_url: "/styles/black-grey/daughter-name-millie"
  },
  {
    url: "/styles/black-grey/dead-sunflower-QscASbvwooptUZv7h4WYu5",
    title: "dead sunflower",
    list_url: "/styles/black-grey/dead-sunflower"
  },
  {
    url: "/styles/black-grey/donkey-kong-PdR6uj3JFwsKQcEwpDAx4b",
    title: "donkey kong",
    list_url: "/styles/black-grey/donkey-kong"
  },
  {
    url: "/styles/black-grey/dragon-ball-z-shenron-wrap-around-arm-Cg984sta5cper6S2iaRec8",
    title: "dragon ball z shenron wrap around arm",
    list_url: "/styles/black-grey/dragon-ball-z-shenron-wrap-around-arm"
  },
  {
    url: "/styles/black-grey/el-chapo-guzman-el-mayo-zambada-CFRJiEwU5bNaXoUsvHRUXH",
    title: "el chapo guzman el mayo zambada",
    list_url: "/styles/black-grey/el-chapo-guzman-el-mayo-zambada"
  },
  {
    url: "/styles/black-grey/femdom-GfUDSdLLG2pvENUjq1KNKr",
    title: "femdom",
    list_url: "/styles/black-grey/femdom"
  },
  {
    url: "/styles/black-grey/forearm-tattoo-of-mars-the-roman-god-of-QFivwy1CHQFknEs5VxddZW",
    title: "forearm tattoo of mars the roman god of",
    list_url: "/styles/black-grey/forearm-tattoo-of-mars-the-roman-god-of"
  },
  {
    url: "/styles/black-grey/gangster-with-hood-and-guns-NY4RTZpZQ16EwWQZa45g5T",
    title: "gangster with hood and guns",
    list_url: "/styles/black-grey/gangster-with-hood-and-guns"
  },
  {
    url: "/styles/black-grey/hanuman-with-ganesha-WMaXhDPsEnWNhijrqQyG3t",
    title: "hanuman with ganesha",
    list_url: "/styles/black-grey/hanuman-with-ganesha"
  },
  {
    url: "/styles/black-grey/harry-potters-patronus-deer-MEdZFY1SpiEWSchzWxeMw6",
    title: "harry potters patronus deer",
    list_url: "/styles/black-grey/harry-potters-patronus-deer"
  },
  {
    url: "/styles/black-grey/hermione-granger-pinup-girl-bikini-Gk2WX8Y86i8GeAe6wNZvuT",
    title: "hermione granger pinup girl bikini",
    list_url: "/styles/black-grey/hermione-granger-pinup-girl-bikini"
  },
  {
    url: "/styles/black-grey/jesus-with-1911-gun-BsoUdQ8nURFkShuRty89nH",
    title: "jesus with gun",
    list_url: "/styles/black-grey/jesus-with-1911-gun"
  },
  {
    url: "/styles/black-grey/kiran-name-tattoo-with-arrow-surrounded-XAZq9nxPzV5WicUArBCmSD",
    title: "kiran name tattoo with arrow surrounded",
    list_url: "/styles/black-grey/kiran-name-tattoo-with-arrow-surrounded"
  },
  {
    url: "/styles/black-grey/krampus-QUfX8D6p6GCf6f6doNriBK",
    title: "krampus",
    list_url: "/styles/black-grey/krampus"
  },
  {
    url: "/styles/black-grey/maine-coon-cat-hunting-RvA4hnC4EczGz2Qa8DwAX2",
    title: "maine coon cat hunting",
    list_url: "/styles/black-grey/maine-coon-cat-hunting"
  },
  {
    url: "/styles/black-grey/malcolm-x-ChHwcxgcosUEFPBX3aeaxv",
    title: "malcolm x",
    list_url: "/styles/black-grey/malcolm-x"
  },
  {
    url: "/styles/black-grey/mayan-temple-R6Bt7ShiC87zZo9pa1smGX",
    title: "mayan temple",
    list_url: "/styles/black-grey/mayan-temple"
  },
  {
    url: "/styles/black-grey/medusa-turning-phoenix-SHccMrFju7DggK1kZ8d8Pn",
    title: "medusa turning phoenix",
    list_url: "/styles/black-grey/medusa-turning-phoenix"
  },
  {
    url: "/styles/black-grey/miyamoto-musashi-HVtCSRsrezXapkHw6MJAvE",
    title: "miyamoto musashi",
    list_url: "/styles/black-grey/miyamoto-musashi"
  },
  {
    url: "/styles/black-grey/mugunghwa-flower-with-korean-tradition-SJXMQy4X7Nfna1DJkvvJkU",
    title: "mugunghwa flower with korean tradition",
    list_url: "/styles/black-grey/mugunghwa-flower-with-korean-tradition"
  },
  {
    url: "/styles/black-grey/no-risk-no-reward-with-money-G8Mn7Mh3icvX3RvifXB3J8",
    title: "no risk no reward with money",
    list_url: "/styles/black-grey/no-risk-no-reward-with-money"
  },
  {
    url: "/styles/black-grey/patriotic-arm-sleeve-about-kids-names-JiqmJ32TPs2kjmyCSE7zud",
    title: "patriotic arm sleeve about kids names",
    list_url: "/styles/black-grey/patriotic-arm-sleeve-about-kids-names"
  },
  {
    url: "/styles/black-grey/prabhas-WzLcS3BE8mbLqgWs9xUpMN",
    title: "prabhas",
    list_url: "/styles/black-grey/prabhas"
  },
  {
    url: "/styles/black-grey/psalm-373-4-DpNgttPvMvKFupsdf4ZxAZ",
    title: "psalm ",
    list_url: "/styles/black-grey/psalm-373-4"
  },
  {
    url: "/styles/black-grey/roman-numerals-viixxmmxxii-C5Mkpc6PUJ8MsycugKtx3w",
    title: "roman numerals viixxmmxxii",
    list_url: "/styles/black-grey/roman-numerals-viixxmmxxii"
  },
  {
    url: "/styles/black-grey/st-dymphna-M1kAqjZQUcNuNCRymiPAxo",
    title: "st dymphna",
    list_url: "/styles/black-grey/st-dymphna"
  },
  {
    url: "/styles/black-grey/succubus-and-incubus-making-love-R3t7kkKijMciMNGk32cS8P",
    title: "succubus and incubus making love",
    list_url: "/styles/black-grey/succubus-and-incubus-making-love"
  },
  {
    url: "/styles/black-grey/temple-street-13-26ErUrEkwoGNP1K8NgkRo7",
    title: "temple street ",
    list_url: "/styles/black-grey/temple-street-13"
  },
  {
    url: "/styles/black-grey/the-last-of-us-ellie-and-joel-SEfiZSKjsX5sJTi8niSvkL",
    title: "the last of us ellie and joel",
    list_url: "/styles/black-grey/the-last-of-us-ellie-and-joel"
  },
  {
    url: "/styles/black-grey/time-flies-Ad59cYRHzy924EAd5bMUWZ",
    title: "time flies",
    list_url: "/styles/black-grey/time-flies"
  },
  {
    url: "/styles/black-grey/xxx-tentacion-tree-CGhYcCnCJHFcuaaZCpBVL6",
    title: "xxx tentacion tree",
    list_url: "/styles/black-grey/xxx-tentacion-tree"
  },
  {
    url: "/styles/blackwork/aiygiwgwyaiydiwdwy-2QQKczmYanzXYNAbsq2hMP",
    title: "aiygiwgwyaiydiwdwy",
    list_url: "/styles/blackwork/aiygiwgwyaiydiwdwy"
  },
  {
    url: "/styles/blackwork/buddha-meditating-under-a-bodhi-tree-8Xw6JEeCfyLugd6Qcdm5GD",
    title: "buddha meditating under a bodhi tree",
    list_url: "/styles/blackwork/buddha-meditating-under-a-bodhi-tree"
  },
  {
    url: "/styles/blackwork/butterfly-bat-SCJx4VhEoqxmcveV1Jaz3a",
    title: "butterfly bat",
    list_url: "/styles/blackwork/butterfly-bat"
  },
  {
    url: "/styles/blackwork/cover-up-tattoo-shoulder-blade-5wnartHhpRqkZQtMX4PnNc",
    title: "cover up tattoo shoulder blade",
    list_url: "/styles/blackwork/cover-up-tattoo-shoulder-blade"
  },
  {
    url: "/styles/blackwork/hic-sunt-leones-DXL3frzJxdiYh15WHwm3U2",
    title: "hic sunt leones",
    list_url: "/styles/blackwork/hic-sunt-leones"
  },
  {
    url: "/styles/blackwork/indian-men-leg-tattoo-QPyG7KZ1aSR9KP8AWb995k",
    title: "indian men leg tattoo",
    list_url: "/styles/blackwork/indian-men-leg-tattoo"
  },
  {
    url: "/styles/blackwork/maine-coon-SfeGTxnP9TxCGgXPjXWqNE",
    title: "maine coon",
    list_url: "/styles/blackwork/maine-coon"
  },
  {
    url: "/styles/blackwork/nordische-mythologie-skaldenmet-HrhDqVxzMxr4KqRERU6dT9",
    title: "nordische mythologie skaldenmet",
    list_url: "/styles/blackwork/nordische-mythologie-skaldenmet"
  },
  {
    url: "/styles/blackwork/paw-print-on-pubic-mound-Jat75xCdxCdM63mz6cEXDJ",
    title: "paw print on pubic mound",
    list_url: "/styles/blackwork/paw-print-on-pubic-mound"
  },
  {
    url: "/styles/blackwork/raf-emblem-8ga6xFkKEmumbw7ciKm8PA",
    title: "raf emblem",
    list_url: "/styles/blackwork/raf-emblem"
  },
  {
    url: "/styles/blackwork/reggie-name-in-cursive-with-crown-E427zQGu2MuNdCSJ6uKKpp",
    title: "reggie name in cursive with crown",
    list_url: "/styles/blackwork/reggie-name-in-cursive-with-crown"
  },
  {
    url: "/styles/blackwork/scania-truck-with-the-v8-eagle-with-a-9wzQpzk8e7u9mb8pQWz7rx",
    title: "scania truck with the v eagle with a",
    list_url: "/styles/blackwork/scania-truck-with-the-v8-eagle-with-a"
  },
  {
    url: "/styles/blackwork/sunflower-with-breast-cancer-ribbon-TAdE87AxmBYDjDqMDcdWz2",
    title: "sunflower with breast cancer ribbon",
    list_url: "/styles/blackwork/sunflower-with-breast-cancer-ribbon"
  },
  {
    url: "/styles/blackwork/twenty-one-pilots-oldies-station-with-BHai87k5epnXvFHBzBHU5a",
    title: "twenty one pilots oldies station with",
    list_url: "/styles/blackwork/twenty-one-pilots-oldies-station-with"
  },
  {
    url: "/styles/dotwork/a-snake-wrapped-around-an-arrow-Vy6ie65fR8E7JC3Xk93oez",
    title: "a snake wrapped around an arrow",
    list_url: "/styles/dotwork/a-snake-wrapped-around-an-arrow"
  },
  {
    url: "/styles/dotwork/advait-LtfkLuhTFgEr7QkaZPGEu7",
    title: "advait",
    list_url: "/styles/dotwork/advait"
  },
  {
    url: "/styles/dotwork/half-devil-half-god-V63ewrFpTyoD5JrdDzTxpC",
    title: "half devil half god",
    list_url: "/styles/dotwork/half-devil-half-god"
  },
  {
    url: "/styles/dotwork/id-rather-die-on-my-feet-than-live-on-5xscChHv7AfqRkiojrupWi",
    title: "id rather die on my feet than live on",
    list_url: "/styles/dotwork/id-rather-die-on-my-feet-than-live-on"
  },
  {
    url: "/styles/dotwork/josefina-in-cursive-SWHy3pyP5rbLjry4FAFKgx",
    title: "josefina in cursive",
    list_url: "/styles/dotwork/josefina-in-cursive"
  },
  {
    url: "/styles/dotwork/krishna-arjuna-and-karna-WE22NDyAkqrJzSwpYoCmDC",
    title: "krishna arjuna and karna",
    list_url: "/styles/dotwork/krishna-arjuna-and-karna"
  },
  {
    url: "/styles/dotwork/mahabharat-karna-sun-symbol-on-antha-CThZupy8kT89Wt6n7G4Z4s",
    title: "mahabharat karna sun symbol on antha",
    list_url: "/styles/dotwork/mahabharat-karna-sun-symbol-on-antha"
  },
  {
    url: "/styles/dotwork/me-against-the-world-DdorBXuJVDwmHko4LY6JKS",
    title: "me against the world",
    list_url: "/styles/dotwork/me-against-the-world"
  },
  {
    url: "/styles/dotwork/moni-name-tatoo-CHPqtjnSY63mCeCiJvJYDg",
    title: "moni name tatoo",
    list_url: "/styles/dotwork/moni-name-tatoo"
  },
  {
    url: "/styles/dotwork/phoenix-with-breast-cancer-pink-ribbon-QS8o2mo7QTeAnLB8qMdQih",
    title: "phoenix with breast cancer pink ribbon",
    list_url: "/styles/dotwork/phoenix-with-breast-cancer-pink-ribbon"
  },
  {
    url: "/styles/dotwork/skull-with-dragonfly-6uNVFdma5ChF5N8SesanPv",
    title: "skull with dragonfly",
    list_url: "/styles/dotwork/skull-with-dragonfly"
  },
  {
    url: "/styles/dotwork/snake-and-cancer-zodiac-6jBkP7BGR4Uh4EzpTtCmZ7",
    title: "snake and cancer zodiac",
    list_url: "/styles/dotwork/snake-and-cancer-zodiac"
  },
  {
    url: "/styles/geometric/anime-7gX2m5ANZacmt2nVTZ6iBh",
    title: "anime",
    list_url: "/styles/geometric/anime"
  },
  {
    url: "/styles/japanese/3-peonys-with-a-lily-of-the-valley-3UFsrzh5nEX6vwcJ9B2jN7",
    title: " peonys with a lily of the valley",
    list_url: "/styles/japanese/3-peonys-with-a-lily-of-the-valley"
  },
  {
    url: "/styles/japanese/asian-dragon-fights-a-scorpion-9khtW8hvRjM4w5JMfaH49M",
    title: "asian dragon fights a scorpion",
    list_url: "/styles/japanese/asian-dragon-fights-a-scorpion"
  },
  {
    url: "/styles/japanese/dragon-with-lightning-CMKiiHHLaVXSLhPjHLPM4U",
    title: "dragon with lightning",
    list_url: "/styles/japanese/dragon-with-lightning"
  },
  {
    url: "/styles/japanese/kintsugi-PRfbLVU9ntsTrYh5WKbrJ6",
    title: "kintsugi",
    list_url: "/styles/japanese/kintsugi"
  },
  {
    url: "/styles/japanese/letters-r-r-6L9Nx6VPaG1kmXVyrD2SNZ",
    title: "letters r r",
    list_url: "/styles/japanese/letters-r-r"
  },
  {
    url: "/styles/japanese/memento-mori-TM4nCoSCsWjyuN8nvWZbqB",
    title: "memento mori",
    list_url: "/styles/japanese/memento-mori"
  },
  {
    url: "/styles/japanese/octopus-6dJf17oe4zW9DfNg6jxJSo",
    title: "octopus",
    list_url: "/styles/japanese/octopus"
  },
  {
    url: "/styles/japanese/orchid-6xubWngLvHihKVpKR5QGU7",
    title: "orchid",
    list_url: "/styles/japanese/orchid"
  },
  {
    url: "/styles/japanese/volcano-LGsN1VQPnsw4X1V1x3CQJF",
    title: "volcano",
    list_url: "/styles/japanese/volcano"
  },
  {
    url: "/styles/japanese/waterfall-6McYE7pxvYYPYTxGs4pYcU",
    title: "waterfall",
    list_url: "/styles/japanese/waterfall"
  },
  {
    url: "/styles/japanese/wing-M87GQzCHE5UdMbEJ5VTtf9",
    title: "wing",
    list_url: "/styles/japanese/wing"
  },
  {
    url: "/styles/minimalist/a-fine-line-sunrise-at-a-silhouette-VhPMvfxMtJKYumtd7nzb5i",
    title: "a fine line sunrise at a silhouette",
    list_url: "/styles/minimalist/a-fine-line-sunrise-at-a-silhouette"
  },
  {
    url: "/styles/minimalist/a-traditional-design-of-a-mulberry-HJsFDjemENciUwJRxLDuoh",
    title: "a traditional design of a mulberry",
    list_url: "/styles/minimalist/a-traditional-design-of-a-mulberry"
  },
  {
    url: "/styles/minimalist/ashok-and-manasa-Bk5h3qZE6U3GDWPmN4L42Y",
    title: "ashok and manasa",
    list_url: "/styles/minimalist/ashok-and-manasa"
  },
  {
    url: "/styles/minimalist/atheist-LzasY7LSLUojdu2HCrWY4p",
    title: "atheist",
    list_url: "/styles/minimalist/atheist"
  },
  {
    url: "/styles/minimalist/balance-U3BVtJ3kNCZtiEWGbbncHh",
    title: "balance",
    list_url: "/styles/minimalist/balance"
  },
  {
    url: "/styles/minimalist/baptism-V7FRfnaZDnuPcuyJNpWbE5",
    title: "baptism",
    list_url: "/styles/minimalist/baptism"
  },
  {
    url: "/styles/minimalist/benjamin-FUqyu34HBkx2J6WuCQKeN9",
    title: "benjamin",
    list_url: "/styles/minimalist/benjamin"
  },
  {
    url: "/styles/minimalist/boa-vista-cape-verde-K1ePjSaR32ATdjDKLU58Aa",
    title: "boa vista cape verde",
    list_url: "/styles/minimalist/boa-vista-cape-verde"
  },
  {
    url: "/styles/minimalist/brick-wall-being-built-5XB8S1HKBZVbpywFBZMrtf",
    title: "brick wall being built",
    list_url: "/styles/minimalist/brick-wall-being-built"
  },
  {
    url: "/styles/minimalist/budapest-XjRRqiGE97SPjC7HxCZgZo",
    title: "budapest",
    list_url: "/styles/minimalist/budapest"
  },
  {
    url: "/styles/minimalist/da-vinci-code-life-science-XWy9FCDLHPG64Bhgv3oLeN",
    title: "da vinci code life science",
    list_url: "/styles/minimalist/da-vinci-code-life-science"
  },
  {
    url: "/styles/minimalist/electrical-electronics-engineering-STpFeYRZAQ76Jv59QZxmcC",
    title: "electrical electronics engineering",
    list_url: "/styles/minimalist/electrical-electronics-engineering"
  },
  {
    url: "/styles/minimalist/entropy-formula-with-the-words-order-WnnXGMQHKcTVHwbvqQ7wAy",
    title: "entropy formula with the words order",
    list_url: "/styles/minimalist/entropy-formula-with-the-words-order"
  },
  {
    url: "/styles/minimalist/flower-garland-H8KvqnCgbA8MNRnuV7Q5A6",
    title: "flower garland",
    list_url: "/styles/minimalist/flower-garland"
  },
  {
    url: "/styles/minimalist/freediving-3zeUukeycLW2QdFThEmqdf",
    title: "freediving",
    list_url: "/styles/minimalist/freediving"
  },
  {
    url: "/styles/minimalist/gladiolus-flower-purple-name-letter-VKmM4ZVPimneeMoxEwhxrK",
    title: "gladiolus flower purple name letter",
    list_url: "/styles/minimalist/gladiolus-flower-purple-name-letter"
  },
  {
    url: "/styles/minimalist/hobbit-door-TaVHLqDYfBcA9HMtBZACJd",
    title: "hobbit door",
    list_url: "/styles/minimalist/hobbit-door"
  },
  {
    url: "/styles/minimalist/infinity-symbol-with-letter-c-and-QwrGbLaLcYrroWjES8Rvbg",
    title: "infinity symbol with letter c and",
    list_url: "/styles/minimalist/infinity-symbol-with-letter-c-and"
  },
  {
    url: "/styles/minimalist/justin-name-tattoo-Cmi6SkkrXWhvFEy1Ruyze",
    title: "justin name tattoo",
    list_url: "/styles/minimalist/justin-name-tattoo"
  },
  {
    url: "/styles/minimalist/lavender-and-lily-of-the-valley-flower-AZzthpfvd9sPdezZFnyC71",
    title: "lavender and lily of the valley flower",
    list_url: "/styles/minimalist/lavender-and-lily-of-the-valley-flower"
  },
  {
    url: "/styles/minimalist/letter-r-with-dog-paw-7ucgGNnRFaUwajx4bJ9tNe",
    title: "letter r with dog paw",
    list_url: "/styles/minimalist/letter-r-with-dog-paw"
  },
  {
    url: "/styles/minimalist/march-july-and-october-birth-flower-2QvZRkE11RHpf7GCRXFSPU",
    title: "march july and october birth flower",
    list_url: "/styles/minimalist/march-july-and-october-birth-flower"
  },
  {
    url: "/styles/minimalist/miscarriage-pregnancy-loss-baby-6khYptVZyysjGHND4PsUzd",
    title: "miscarriage pregnancy loss baby",
    list_url: "/styles/minimalist/miscarriage-pregnancy-loss-baby"
  },
  {
    url: "/styles/minimalist/name-shay-VDtFYcXPZ1zLkkegjaCd6U",
    title: "name shay",
    list_url: "/styles/minimalist/name-shay"
  },
  {
    url: "/styles/minimalist/sk-sturm-graz-flag-6bZbPPaRqzAmTp7pqHWqfq",
    title: "sk sturm graz flag",
    list_url: "/styles/minimalist/sk-sturm-graz-flag"
  },
  {
    url: "/styles/minimalist/sora-and-keyblade-from-kingdom-hearts-CG2oVhjqdzayWSCk5xeeqJ",
    title: "sora and keyblade from kingdom hearts",
    list_url: "/styles/minimalist/sora-and-keyblade-from-kingdom-hearts"
  },
  {
    url: "/styles/minimalist/taj-mahal-XuyZrwE6bYkTW394LwVSXo",
    title: "taj mahal",
    list_url: "/styles/minimalist/taj-mahal"
  },
  {
    url: "/styles/minimalist/the-sun-the-moon-and-the-truth-LWRoFu3hT7W95VNSwPEdeN",
    title: "the sun the moon and the truth",
    list_url: "/styles/minimalist/the-sun-the-moon-and-the-truth"
  },
  {
    url: "/styles/minimalist/yorkie-poo-dog-outline-tattoo-89N4Rni3kXxNtceNw6qLss",
    title: "yorkie poo dog outline tattoo",
    list_url: "/styles/minimalist/yorkie-poo-dog-outline-tattoo"
  },
  {
    url: "/styles/neotraditional/alka-yDLczwVs7GpbgQsG1tBtp",
    title: "alka",
    list_url: "/styles/neotraditional/alka"
  },
  {
    url: "/styles/neotraditional/angel-wings-with-name-angela-GAjEBtBwpbKWf3ZhSAWTto",
    title: "angel wings with name angela",
    list_url: "/styles/neotraditional/angel-wings-with-name-angela"
  },
  {
    url: "/styles/neotraditional/devil-and-angel-whispering-behind-ear-25XgnAAPRsPNMh3yDYzeqw",
    title: "devil and angel whispering behind ear",
    list_url: "/styles/neotraditional/devil-and-angel-whispering-behind-ear"
  },
  {
    url: "/styles/neotraditional/i-love-you-to-infinity-and-beyond-J8hL61fXLEPQfR17FPEoFq",
    title: "i love you to infinity and beyond",
    list_url: "/styles/neotraditional/i-love-you-to-infinity-and-beyond"
  },
  {
    url: "/styles/neotraditional/kagutsuchi-6iy4pdd3ur8BaEzCtpBrEG",
    title: "kagutsuchi",
    list_url: "/styles/neotraditional/kagutsuchi"
  },
  {
    url: "/styles/neotraditional/karishma-GaJDL48wGgdoaWZwBcCfgG",
    title: "karishma",
    list_url: "/styles/neotraditional/karishma"
  },
  {
    url: "/styles/neotraditional/marine-engineer-LAV7HKJvVFbveu7aNyg1qq",
    title: "marine engineer",
    list_url: "/styles/neotraditional/marine-engineer"
  },
  {
    url: "/styles/neotraditional/mom-elephant-and-3-babies-all-holding-74zhCBavsuBWGJZKvoZ9Jb",
    title: "mom elephant and babies all holding",
    list_url: "/styles/neotraditional/mom-elephant-and-3-babies-all-holding"
  },
  {
    url: "/styles/neotraditional/niranjan-meghana-MQtfM5FoBEwECnivgUhG2r",
    title: "niranjan meghana",
    list_url: "/styles/neotraditional/niranjan-meghana"
  },
  {
    url: "/styles/neotraditional/owl-and-snake-GoaLFy4JaRp3DoXt3N3E2h",
    title: "owl and snake",
    list_url: "/styles/neotraditional/owl-and-snake"
  },
  {
    url: "/styles/neotraditional/push-on-through-twenty-one-pilots-CjSEybXJfyLdd1a96Qd22k",
    title: "push on through twenty one pilots",
    list_url: "/styles/neotraditional/push-on-through-twenty-one-pilots"
  },
  {
    url: "/styles/neotraditional/roman-numeral-09-14-1994-9iG73T4VqvQ9neS6ppc7ij",
    title: "roman numeral ",
    list_url: "/styles/neotraditional/roman-numeral-09-14-1994"
  },
  {
    url: "/styles/neotraditional/ruby-name-tattoo-on-hand-N7eL9mbN1jBsz32voywuoK",
    title: "ruby name tattoo on hand",
    list_url: "/styles/neotraditional/ruby-name-tattoo-on-hand"
  },
  {
    url: "/styles/neotraditional/safavid-dynasty-tattoo-Pyvbr4JeohM5SvVrbGNNb9",
    title: "safavid dynasty tattoo",
    list_url: "/styles/neotraditional/safavid-dynasty-tattoo"
  },
  {
    url: "/styles/neotraditional/sahil-name-in-urdu-EHGpU1qExu6zn8UMc53tsf",
    title: "sahil name in urdu",
    list_url: "/styles/neotraditional/sahil-name-in-urdu"
  },
  {
    url: "/styles/neotraditional/tau-gamma-phi-logo-APJQ2ZVX4R4K6JYNBeQ9a5",
    title: "tau gamma phi logo",
    list_url: "/styles/neotraditional/tau-gamma-phi-logo"
  },
  {
    url: "/styles/neotraditional/the-name-angela-J6iMCC4oyuDasWRNa2NKhs",
    title: "the name angela",
    list_url: "/styles/neotraditional/the-name-angela"
  },
  {
    url: "/styles/neotraditional/the-name-kyle-ChrT3e3AcGwUACD9T2YBuW",
    title: "the name kyle",
    list_url: "/styles/neotraditional/the-name-kyle"
  },
  {
    url: "/styles/new-school/melted-smiley-face-with-x-as-eyes-CjHg6uvyQ1HSDD3VzR1aNA",
    title: "melted smiley face with x as eyes",
    list_url: "/styles/new-school/melted-smiley-face-with-x-as-eyes"
  },
  {
    url: "/styles/new-school/rose-name-katie-VFdP93DpYD8oCZMHdAdUXQ",
    title: "rose name katie",
    list_url: "/styles/new-school/rose-name-katie"
  },
  {
    url: "/styles/realism/an-infinity-symbol-with-music-notes-QkFvqqoeoJU33vmFneQSKc",
    title: "an infinity symbol with music notes",
    list_url: "/styles/realism/an-infinity-symbol-with-music-notes"
  },
  {
    url: "/styles/realism/compass-with-snake-Wxo2P9rHEfwZDYQp3GCRA8",
    title: "compass with snake",
    list_url: "/styles/realism/compass-with-snake"
  },
  {
    url: "/styles/realism/dallas-cowboys-LS8dWd179kD1W7nNtsHF1P",
    title: "dallas cowboys",
    list_url: "/styles/realism/dallas-cowboys"
  },
  {
    url: "/styles/realism/elk-with-mountains-FKwHkYcPYUc6gX9TNSDXK6",
    title: "elk with mountains",
    list_url: "/styles/realism/elk-with-mountains"
  },
  {
    url: "/styles/realism/futanari-FcLs9x4mm7x55Lo51xCMNa",
    title: "futanari",
    list_url: "/styles/realism/futanari"
  },
  {
    url: "/styles/realism/irish-sea-god-manannan-mac-lir-XEASXd6sRYL3YDD2birBxe",
    title: "irish sea god manannan mac lir",
    list_url: "/styles/realism/irish-sea-god-manannan-mac-lir"
  },
  {
    url: "/styles/realism/john-1513-bible-verse-AVWW93dyGvVaNkqT9VgJTc",
    title: "john bible verse",
    list_url: "/styles/realism/john-1513-bible-verse"
  },
  {
    url: "/styles/realism/phoenix-with-infinity-A47poCundNAehM4L47VtUE",
    title: "phoenix with infinity",
    list_url: "/styles/realism/phoenix-with-infinity"
  },
  {
    url: "/styles/realism/skull-and-cross-LVPfCbyAYYTboTWM2AjqRN",
    title: "skull and cross",
    list_url: "/styles/realism/skull-and-cross"
  },
  {
    url: "/styles/realism/steampunk-owl-WHynRFarYup7sFEWjLL2zy",
    title: "steampunk owl",
    list_url: "/styles/realism/steampunk-owl"
  },
  {
    url: "/styles/sketch/a-phoenix-coming-out-of-a-lotus-flower-J9eR5eYkpm9mv1unfrgq3U",
    title: "a phoenix coming out of a lotus flower",
    list_url: "/styles/sketch/a-phoenix-coming-out-of-a-lotus-flower"
  },
  {
    url: "/styles/sketch/aster-carnation-violet-carnation-FGz2Wij5ayt1J1uVSefhez",
    title: "aster carnation violet carnation",
    list_url: "/styles/sketch/aster-carnation-violet-carnation"
  },
  {
    url: "/styles/sketch/gohan-ssj2-5RQzgLWz6GEHcrBPWbSCKb",
    title: "gohan ssj ",
    list_url: "/styles/sketch/gohan-ssj2"
  },
  {
    url: "/styles/sketch/indalo-man-KXdEpEH68tg98RkYF95kZQ",
    title: "indalo man",
    list_url: "/styles/sketch/indalo-man"
  },
  {
    url: "/styles/sketch/infinity-symbol-names-written-VKpXCzwjJzvuckV8LtY3QA",
    title: "infinity symbol names written",
    list_url: "/styles/sketch/infinity-symbol-names-written"
  },
  {
    url: "/styles/sketch/oma-68SvHER9xz3G1kdJ3ucme6",
    title: "oma",
    list_url: "/styles/sketch/oma"
  },
  {
    url: "/styles/sketch/orange-cat-playing-chasing-a-butterfly-GcVvxfFAbNbmBU22pKyKQr",
    title: "orange cat playing chasing a butterfly",
    list_url: "/styles/sketch/orange-cat-playing-chasing-a-butterfly"
  },
  {
    url: "/styles/sketch/osprey-4XuKQTZUnfG1Dgm45naGD5",
    title: "osprey",
    list_url: "/styles/sketch/osprey"
  },
  {
    url: "/styles/sketch/simran-LW97szzGGd2n9u4v7bZaRB",
    title: "simran",
    list_url: "/styles/sketch/simran"
  },
  {
    url: "/styles/sketch/the-letter-f-with-a-heart-wrapped-VYp2Q5zoLe4kLCc7asBSBG",
    title: "the letter f with a heart wrapped",
    list_url: "/styles/sketch/the-letter-f-with-a-heart-wrapped"
  },
  {
    url: "/styles/sketch/trust-in-the-lord-with-all-your-heart-WkNaRm85fSHRWYhMa7BJok",
    title: "trust in the lord with all your heart",
    list_url: "/styles/sketch/trust-in-the-lord-with-all-your-heart"
  },
  {
    url: "/styles/stencil/blackfoot-cherokee-symbols-of-strength-TioUSX9QS5VHTuburPh9su",
    title: "blackfoot cherokee symbols of strength",
    list_url: "/styles/stencil/blackfoot-cherokee-symbols-of-strength"
  },
  {
    url: "/styles/stencil/godspeed-YWQwqVYTaM7ZVJ93cqrGc8",
    title: "godspeed",
    list_url: "/styles/stencil/godspeed"
  },
  {
    url: "/styles/stencil/stairway-to-heaven-with-clock-CdJvdxDKWWSQY262PZWae2",
    title: "stairway to heaven with clock",
    list_url: "/styles/stencil/stairway-to-heaven-with-clock"
  },
  {
    url: "/styles/traditional/an-eye-with-angel-wings-7A1Vv7ic1YhYFCaQBDD3ZE",
    title: "an eye with angel wings",
    list_url: "/styles/traditional/an-eye-with-angel-wings"
  },
  {
    url: "/styles/traditional/bbw-MNEEwznttyA8GPBGwvMt1m",
    title: "bbw",
    list_url: "/styles/traditional/bbw"
  },
  {
    url: "/styles/traditional/dog-nose-print-surrounded-by-dahlia-QbKYRbz4Mv45VYmnEM8uPL",
    title: "dog nose print surrounded by dahlia",
    list_url: "/styles/traditional/dog-nose-print-surrounded-by-dahlia"
  },
  {
    url: "/styles/traditional/second-chance-SLsMi7C5f96CW3WdZHm7hM",
    title: "second chance",
    list_url: "/styles/traditional/second-chance"
  },
  {
    url: "/styles/traditional/thick-pin-up-girl-one-breast-exposed-NGKsGALuzoHcLtDGaq5NEM",
    title: "thick pin up girl one breast exposed",
    list_url: "/styles/traditional/thick-pin-up-girl-one-breast-exposed"
  },
  {
    url: "/styles/tribal/bolivia-with-culture-9ocZaDWMNYDygvv7bqcyy9",
    title: "bolivia with culture",
    list_url: "/styles/tribal/bolivia-with-culture"
  },
  {
    url: "/styles/woodcut/hope-and-in-the-mirror-adolf-hitler-Jt3wQnkfr84hXbvShodAU2",
    title: "hope and in the mirror adolf hitler",
    list_url: "/styles/woodcut/hope-and-in-the-mirror-adolf-hitler"
  },
  {
    url: "/styles/biomechanical/angel-wings-Cu7FHUKy9cguCo2Pyozyo3",
    title: "angel wings",
    list_url: "/styles/biomechanical/angel-wings"
  },
  {
    url: "/styles/black-grey/aries-taurus-cusp-RYWhiFFZL7Kx6WqD1sC9Eu",
    title: "aries taurus cusp",
    list_url: "/styles/black-grey/aries-taurus-cusp"
  },
  {
    url: "/styles/black-grey/bible-verse-psalm-287-YSHjeQitqGrWgW33wSxbEr",
    title: "bible verse psalm ",
    list_url: "/styles/black-grey/bible-verse-psalm-287"
  },
  {
    url: "/styles/black-grey/bur-oak-tree-with-roots-82xMecqmYT7CA4phMDwGCW",
    title: "bur oak tree with roots",
    list_url: "/styles/black-grey/bur-oak-tree-with-roots"
  },
  {
    url: "/styles/black-grey/celtic-knot-stag-antlers-GsELwryPJNoZmGSgLYK5rK",
    title: "celtic knot stag antlers",
    list_url: "/styles/black-grey/celtic-knot-stag-antlers"
  },
  {
    url: "/styles/black-grey/construction-hard-hat-Ee9ramewWdqQYbWg65TkHd",
    title: "construction hard hat",
    list_url: "/styles/black-grey/construction-hard-hat"
  },
  {
    url: "/styles/black-grey/daddys-little-slut-H4sEcs6M44b4DUSHSR9qtY",
    title: "daddys little slut",
    list_url: "/styles/black-grey/daddys-little-slut"
  },
  {
    url: "/styles/black-grey/daisy-flower-masculine-tattoo-E5MBqeFBdpmmuKGeuULw1G",
    title: "daisy flower masculine tattoo",
    list_url: "/styles/black-grey/daisy-flower-masculine-tattoo"
  },
  {
    url: "/styles/black-grey/day-of-the-dead-angel-GWQ4Sd2BZsdZNUUzEAEPkR",
    title: "day of the dead angel",
    list_url: "/styles/black-grey/day-of-the-dead-angel"
  },
  {
    url: "/styles/black-grey/dove-with-clouds-A3f7Gffknxeu231dqMzRaQ",
    title: "dove with clouds",
    list_url: "/styles/black-grey/dove-with-clouds"
  },
  {
    url: "/styles/black-grey/enochian-power-and-protect-rune-W2BpgT6wHCKGwCqjsHN5tU",
    title: "enochian power and protect rune",
    list_url: "/styles/black-grey/enochian-power-and-protect-rune"
  },
  {
    url: "/styles/black-grey/eve-eating-the-apple-RLyuQVM27ixobQ7JnuREvc",
    title: "eve eating the apple",
    list_url: "/styles/black-grey/eve-eating-the-apple"
  },
  {
    url: "/styles/black-grey/flux-capacitor-from-back-to-the-future-7ARw5qmyzyEAEuji2UFVK5",
    title: "flux capacitor from back to the future",
    list_url: "/styles/black-grey/flux-capacitor-from-back-to-the-future"
  },
  {
    url: "/styles/black-grey/freightliner-truck-KLYXK5ZmfdBJdph1rrJEk1",
    title: "freightliner truck",
    list_url: "/styles/black-grey/freightliner-truck"
  },
  {
    url: "/styles/black-grey/full-leg-sleeve-featuring-ocean-AAYDhsRW7rbQhxdzZzsqS8",
    title: "full leg sleeve featuring ocean",
    list_url: "/styles/black-grey/full-leg-sleeve-featuring-ocean"
  },
  {
    url: "/styles/black-grey/hard-fought-hallelujah-UGpKVRu43xonHhssYeoukm",
    title: "hard fought hallelujah",
    list_url: "/styles/black-grey/hard-fought-hallelujah"
  },
  {
    url: "/styles/black-grey/hello-kitty-QjLuFMfAuio5jmdAJz6bus",
    title: "hello kitty",
    list_url: "/styles/black-grey/hello-kitty"
  },
  {
    url: "/styles/black-grey/honeycomb-mandala-6k7dAdMrKoBsQ9sJVE773q",
    title: "honeycomb mandala",
    list_url: "/styles/black-grey/honeycomb-mandala"
  },
  {
    url: "/styles/black-grey/japanese-temple-CwoWJatFGvibyTsc26qKBD",
    title: "japanese temple",
    list_url: "/styles/black-grey/japanese-temple"
  },
  {
    url: "/styles/black-grey/jesus-transfiguration-X2ZCBWQD2dnujiRQnoamAs",
    title: "jesus transfiguration",
    list_url: "/styles/black-grey/jesus-transfiguration"
  },
  {
    url: "/styles/black-grey/killua-zoldyck-Dbuza3AJZznd72bt6NYhRC",
    title: "killua zoldyck",
    list_url: "/styles/black-grey/killua-zoldyck"
  },
  {
    url: "/styles/black-grey/leo-virgo-cusp-BQB8CSp6QZNQGceF9G7ouu",
    title: "leo virgo cusp",
    list_url: "/styles/black-grey/leo-virgo-cusp"
  },
  {
    url: "/styles/black-grey/make-a-inner-forearm-tattoo-that-says-7doy8QmQdCoRRtKjU2E6G3",
    title: "make a inner forearm tattoo that says",
    list_url: "/styles/black-grey/make-a-inner-forearm-tattoo-that-says"
  },
  {
    url: "/styles/black-grey/maple-leaf-2dxCk6SjAViXh5wvQHZF31",
    title: "maple leaf",
    list_url: "/styles/black-grey/maple-leaf"
  },
  {
    url: "/styles/black-grey/mermaid-siren-evil-beautiful-face-3KvXQBmGMMTzTBFXxiJQj3",
    title: "mermaid siren evil beautiful face",
    list_url: "/styles/black-grey/mermaid-siren-evil-beautiful-face"
  },
  {
    url: "/styles/black-grey/old-english-last-name-ramos-written-34NTX4kDiFfnrKrW5JGogE",
    title: "old english last name ramos written",
    list_url: "/styles/black-grey/old-english-last-name-ramos-written"
  },
  {
    url: "/styles/black-grey/peony-H3KVUCk7AA1toqHUUDuuAc",
    title: "peony",
    list_url: "/styles/black-grey/peony"
  },
  {
    url: "/styles/black-grey/playing-card-joker-H659kKv6NCPymiYuLpTf85",
    title: "playing card joker",
    list_url: "/styles/black-grey/playing-card-joker"
  },
  {
    url: "/styles/black-grey/poinsettia-BRRCztqFnf3sV66sNoGb8e",
    title: "poinsettia",
    list_url: "/styles/black-grey/poinsettia"
  },
  {
    url: "/styles/black-grey/proverbs-35-6-SZP4YdPmVpr3KS9TVCzaYY",
    title: "proverbs ",
    list_url: "/styles/black-grey/proverbs-35-6"
  },
  {
    url: "/styles/black-grey/return-of-the-prodigal-son-NBewDZTEvfEtuxdafwHyfy",
    title: "return of the prodigal son",
    list_url: "/styles/black-grey/return-of-the-prodigal-son"
  },
  {
    url: "/styles/black-grey/roman-numeral-date-on-tricep-SEiTJ3EoSKdVfMUuWZ8m1n",
    title: "roman numeral date on tricep",
    list_url: "/styles/black-grey/roman-numeral-date-on-tricep"
  },
  {
    url: "/styles/black-grey/rose-with-ariana-name-written-WkrfKwxkdCMFpJN5NqX7KK",
    title: "rose with ariana name written",
    list_url: "/styles/black-grey/rose-with-ariana-name-written"
  },
  {
    url: "/styles/black-grey/susmi-kutty-name-with-eyes-W27bavJJXQJ5ww52uwYbZM",
    title: "susmi kutty name with eyes",
    list_url: "/styles/black-grey/susmi-kutty-name-with-eyes"
  },
  {
    url: "/styles/black-grey/teddy-bear-holding-a-heart-with-the-KRU37rSsNnwvyF7gJR72eg",
    title: "teddy bear holding a heart with the",
    list_url: "/styles/black-grey/teddy-bear-holding-a-heart-with-the"
  },
  {
    url: "/styles/black-grey/thanos-GVE1VDRsJyjNG8Y49Ji1Qm",
    title: "thanos",
    list_url: "/styles/black-grey/thanos"
  },
  {
    url: "/styles/black-grey/the-name-sadie-3vZCHDAXZYGzT3N8hzLN1a",
    title: "the name sadie",
    list_url: "/styles/black-grey/the-name-sadie"
  },
  {
    url: "/styles/black-grey/tree-of-life-neck-AeEpFJEVS53AQ79axJWgwz",
    title: "tree of life neck",
    list_url: "/styles/black-grey/tree-of-life-neck"
  },
  {
    url: "/styles/black-grey/venu-sree-name-A7xFMopkRBSNtxvqaYm3Hk",
    title: "venu sree name",
    list_url: "/styles/black-grey/venu-sree-name"
  },
  {
    url: "/styles/black-grey/virgo-libra-zodiac-sign-FBDWtRbvwYW5DWvwKKMuL7",
    title: "virgo libra zodiac sign",
    list_url: "/styles/black-grey/virgo-libra-zodiac-sign"
  },
  {
    url: "/styles/blackwork/143-FNtaf91jvK2Yhcz4AAoKuY",
    title: " ",
    list_url: "/styles/blackwork/143"
  },
  {
    url: "/styles/blackwork/2-corinthians-129-BrWCDsgmyDchsheUdDpHp4",
    title: " corinthians ",
    list_url: "/styles/blackwork/2-corinthians-129"
  },
  {
    url: "/styles/blackwork/a-holy-spirit-christian-dove-pNVAN4SAr6R64utvHUgJK",
    title: "a holy spirit christian dove",
    list_url: "/styles/blackwork/a-holy-spirit-christian-dove"
  },
  {
    url: "/styles/blackwork/adolf-hitler-MS7UsQkxj15kGi1jxmE5yY",
    title: "adolf hitler",
    list_url: "/styles/blackwork/adolf-hitler"
  },
  {
    url: "/styles/blackwork/aries-and-virgo-symbols-combined-with-a-SDpDWxBD1Fo3bZw4hg2HYC",
    title: "aries and virgo symbols combined with a",
    list_url: "/styles/blackwork/aries-and-virgo-symbols-combined-with-a"
  },
  {
    url: "/styles/blackwork/australian-coat-of-arms-RGnPZUjH23JAomx2GwZxpL",
    title: "australian coat of arms",
    list_url: "/styles/blackwork/australian-coat-of-arms"
  },
  {
    url: "/styles/blackwork/bearpaws-with-feathers-blackfeet-tribe-NQPxadzBwd4A4zvrFDQJmj",
    title: "bearpaws with feathers blackfeet tribe",
    list_url: "/styles/blackwork/bearpaws-with-feathers-blackfeet-tribe"
  },
  {
    url: "/styles/blackwork/black-dove-9aE1pmtyo68wVVftWnqpCJ",
    title: "black dove",
    list_url: "/styles/blackwork/black-dove"
  },
  {
    url: "/styles/blackwork/blood-aint-thicker-than-water-but-mud-UkFGmaihfLE2RFLSkiazgY",
    title: "blood aint thicker than water but mud",
    list_url: "/styles/blackwork/blood-aint-thicker-than-water-but-mud"
  },
  {
    url: "/styles/blackwork/british-army-ww2-scene-MeJUqezFfBYZ5rxPPCrZ6F",
    title: "british army ww scene",
    list_url: "/styles/blackwork/british-army-ww2-scene"
  },
  {
    url: "/styles/blackwork/broken-clock-towers-with-birds-flying-UszAvn9YHBH4KorEoJheZk",
    title: "broken clock towers with birds flying",
    list_url: "/styles/blackwork/broken-clock-towers-with-birds-flying"
  },
  {
    url: "/styles/blackwork/clown-with-gun-N3WfLqUbsS5ThAYP8TB3aa",
    title: "clown with gun",
    list_url: "/styles/blackwork/clown-with-gun"
  },
  {
    url: "/styles/blackwork/ilia-topuria-back-tatto-but-replace-a-T42rQvgt7bjz3fN4KDdKuQ",
    title: "ilia topuria back tatto but replace a",
    list_url: "/styles/blackwork/ilia-topuria-back-tatto-but-replace-a"
  },
  {
    url: "/styles/blackwork/interlocking-wedding-rings-SzQ5AsT6oAMuDraAMoBrvo",
    title: "interlocking wedding rings",
    list_url: "/styles/blackwork/interlocking-wedding-rings"
  },
  {
    url: "/styles/blackwork/mandala-leg-sleeve-with-elephant-2smty8fhkqDDPE6QmLLkwm",
    title: "mandala leg sleeve with elephant",
    list_url: "/styles/blackwork/mandala-leg-sleeve-with-elephant"
  },
  {
    url: "/styles/blackwork/mother-highland-cow-with-two-baby-cows-Sc9bjRSPmqfKNzwhZtgKYm",
    title: "mother highland cow with two baby cows",
    list_url: "/styles/blackwork/mother-highland-cow-with-two-baby-cows"
  },
  {
    url: "/styles/blackwork/motorcycle-riding-into-sunset-JNSbLfjFhbA9WVCeN4ibRY",
    title: "motorcycle riding into sunset",
    list_url: "/styles/blackwork/motorcycle-riding-into-sunset"
  },
  {
    url: "/styles/blackwork/name-shanu-subtly-integrated-into-the-8XqQJbrwyTHUCwTpUSV7Dj",
    title: "name shanu subtly integrated into the",
    list_url: "/styles/blackwork/name-shanu-subtly-integrated-into-the"
  },
  {
    url: "/styles/blackwork/nipsey-hussle-victory-lap-tmc-vynl-GB8xzFfUSt6jcqEHFFEAut",
    title: "nipsey hussle victory lap tmc vynl",
    list_url: "/styles/blackwork/nipsey-hussle-victory-lap-tmc-vynl"
  },
  {
    url: "/styles/blackwork/norse-mythology-leg-Noh8EnAeUD3hpqs9MWyvkL",
    title: "norse mythology leg",
    list_url: "/styles/blackwork/norse-mythology-leg"
  },
  {
    url: "/styles/blackwork/nova-scotia-78nLmP9wU1cA86UNtLWCvt",
    title: "nova scotia",
    list_url: "/styles/blackwork/nova-scotia"
  },
  {
    url: "/styles/blackwork/pravya-and-trisha-Asg6atRZKsgKShqj6LG1i1",
    title: "pravya and trisha",
    list_url: "/styles/blackwork/pravya-and-trisha"
  },
  {
    url: "/styles/blackwork/raven-on-chest-L73U6FhTEusRdtrjNWped3",
    title: "raven on chest",
    list_url: "/styles/blackwork/raven-on-chest"
  },
  {
    url: "/styles/blackwork/rembrandts-storm-on-the-sea-of-galilee-7G5mWKgLtW2AK1akKHc5vu",
    title: "rembrandts storm on the sea of galilee",
    list_url: "/styles/blackwork/rembrandts-storm-on-the-sea-of-galilee"
  },
  {
    url: "/styles/blackwork/seek-first-the-kingdom-of-god-LZ6nR8c5Np5xPAqeHiNpV6",
    title: "seek first the kingdom of god",
    list_url: "/styles/blackwork/seek-first-the-kingdom-of-god"
  },
  {
    url: "/styles/blackwork/southampton-fc-club-crest-3kNsJtqAK65NEw6S3NDXJC",
    title: "southampton fc club crest",
    list_url: "/styles/blackwork/southampton-fc-club-crest"
  },
  {
    url: "/styles/blackwork/the-lords-prayer-81i46k7nWDCQdNsKUaWQBF",
    title: "the lords prayer",
    list_url: "/styles/blackwork/the-lords-prayer"
  },
  {
    url: "/styles/blackwork/tied-up-anime-girl-with-roses-TrZ3v1PHxodBbzjvvAfYrR",
    title: "tied up anime girl with roses",
    list_url: "/styles/blackwork/tied-up-anime-girl-with-roses"
  },
  {
    url: "/styles/blackwork/tom-and-jerry-with-guns-9pTBK5LTJDby8H82LxBVsr",
    title: "tom and jerry with guns",
    list_url: "/styles/blackwork/tom-and-jerry-with-guns"
  },
  {
    url: "/styles/blackwork/viking-rune-arm-band-U7GKGH2TsEzpkaeXMXAXdC",
    title: "viking rune arm band",
    list_url: "/styles/blackwork/viking-rune-arm-band"
  },
  {
    url: "/styles/blackwork/you-reap-what-you-sow-galatians-67-2KPN13diumk4kqrRXYMCD6",
    title: "you reap what you sow galatians ",
    list_url: "/styles/blackwork/you-reap-what-you-sow-galatians-67"
  },
  {
    url: "/styles/dotwork/a-map-of-israel-CWYenMU3JKANRB6vmBY8GC",
    title: "a map of israel",
    list_url: "/styles/dotwork/a-map-of-israel"
  },
  {
    url: "/styles/dotwork/a-raven-perched-on-a-stack-of-books-AuhQVjLXgXY6z1Mjf3GP5j",
    title: "a raven perched on a stack of books",
    list_url: "/styles/dotwork/a-raven-perched-on-a-stack-of-books"
  },
  {
    url: "/styles/dotwork/an-angel-and-devil-playing-tug-of-war-V6PKdzMcvWTSVxEkx5WD8N",
    title: "an angel and devil playing tug of war",
    list_url: "/styles/dotwork/an-angel-and-devil-playing-tug-of-war"
  },
  {
    url: "/styles/dotwork/billionaire-life-4jfCtq6uYPpdDvB8tjdYg5",
    title: "billionaire life",
    list_url: "/styles/dotwork/billionaire-life"
  },
  {
    url: "/styles/dotwork/burning-bush-FuyBSbTapLK4KGhXwTN1fC",
    title: "burning bush",
    list_url: "/styles/dotwork/burning-bush"
  },
  {
    url: "/styles/dotwork/deer-antler-and-fish-hook-infinity-LUEfeVRXtbxn2XkbE4WXwx",
    title: "deer antler and fish hook infinity",
    list_url: "/styles/dotwork/deer-antler-and-fish-hook-infinity"
  },
  {
    url: "/styles/dotwork/dragon-and-taurus-KcYjTgVA2JtPrury3DHdw5",
    title: "dragon and taurus",
    list_url: "/styles/dotwork/dragon-and-taurus"
  },
  {
    url: "/styles/dotwork/geri-and-freki-odins-wolves-in-a-KdMvwUgTyNcW3tb3McjA1c",
    title: "geri and freki odins wolves in a",
    list_url: "/styles/dotwork/geri-and-freki-odins-wolves-in-a"
  },
  {
    url: "/styles/dotwork/gonzalez-family-crest-RSViRcGeP9j89S6VaxFZnb",
    title: "gonzalez family crest",
    list_url: "/styles/dotwork/gonzalez-family-crest"
  },
  {
    url: "/styles/dotwork/hand-tattoo-skeleton-design-with-KXrmAXoHreYteeR91pumdz",
    title: "hand tattoo skeleton design with",
    list_url: "/styles/dotwork/hand-tattoo-skeleton-design-with"
  },
  {
    url: "/styles/dotwork/heart-with-letter-l-and-k-AmoLNCKBMVFJ5mW7EtKizc",
    title: "heart with letter l and k",
    list_url: "/styles/dotwork/heart-with-letter-l-and-k"
  },
  {
    url: "/styles/dotwork/indian-rupee-logo-L19be1eAAK2RrAM6wa3SpD",
    title: "indian rupee logo",
    list_url: "/styles/dotwork/indian-rupee-logo"
  },
  {
    url: "/styles/dotwork/ka-tet-symbol-dark-tower-PvuhjDZKZNK59NJR1tk72o",
    title: "ka tet symbol dark tower",
    list_url: "/styles/dotwork/ka-tet-symbol-dark-tower"
  },
  {
    url: "/styles/dotwork/manisha-name-L87WXmZGmdDZR6J3oSSwZS",
    title: "manisha name",
    list_url: "/styles/dotwork/manisha-name"
  },
  {
    url: "/styles/dotwork/meghana-E1aQysgubR4ayQghV9jj5E",
    title: "meghana",
    list_url: "/styles/dotwork/meghana"
  },
  {
    url: "/styles/dotwork/nankurunaisa-SeMw6hwk14fgLpLmDrFWXL",
    title: "nankurunaisa",
    list_url: "/styles/dotwork/nankurunaisa"
  },
  {
    url: "/styles/dotwork/snake-eating-rat-TQbZjvtGtoq41Uqe2x6fju",
    title: "snake eating rat",
    list_url: "/styles/dotwork/snake-eating-rat"
  },
  {
    url: "/styles/dotwork/tbate-novel-GD5ZXhad6zGefcsvZ6zss9",
    title: "tbate novel",
    list_url: "/styles/dotwork/tbate-novel"
  },
  {
    url: "/styles/dotwork/the-name-tiffany-with-roses-and-tulips-WqX1ffrfdgq77Ln9fWzCep",
    title: "the name tiffany with roses and tulips",
    list_url: "/styles/dotwork/the-name-tiffany-with-roses-and-tulips"
  },
  {
    url: "/styles/dotwork/tron-legacy-Q6FRRCN1123vfdSNaYSy7m",
    title: "tron legacy",
    list_url: "/styles/dotwork/tron-legacy"
  },
  {
    url: "/styles/dotwork/vincere-aut-mori-AUSgZhEfoVMfEsYNV7x8F5",
    title: "vincere aut mori",
    list_url: "/styles/dotwork/vincere-aut-mori"
  },
  {
    url: "/styles/geometric/bauhaus-XnHU58jwjn5KsVVWikbUSf",
    title: "bauhaus",
    list_url: "/styles/geometric/bauhaus"
  },
  {
    url: "/styles/geometric/harihara-avatar-of-vishnu-and-shiva-SnMBDhs5U15j4D5o7nz4Mw",
    title: "harihara avatar of vishnu and shiva",
    list_url: "/styles/geometric/harihara-avatar-of-vishnu-and-shiva"
  },
  {
    url: "/styles/geometric/jera-rune-PezLGeogNkk568rLZ6YqKM",
    title: "jera rune",
    list_url: "/styles/geometric/jera-rune"
  },
  {
    url: "/styles/geometric/lotus-flower-men-BBpHo6Pan1fjv64xrZ5F5j",
    title: "lotus flower men",
    list_url: "/styles/geometric/lotus-flower-men"
  },
  {
    url: "/styles/geometric/medieval-armor-single-arm-bracer-WBqxPN1HbvccZCsYhn3TNp",
    title: "medieval armor single arm bracer",
    list_url: "/styles/geometric/medieval-armor-single-arm-bracer"
  },
  {
    url: "/styles/geometric/sun-and-moon-kissing-each-other-LuvxrHEsxC8nUAWdaFiPck",
    title: "sun and moon kissing each other",
    list_url: "/styles/geometric/sun-and-moon-kissing-each-other"
  },
  {
    url: "/styles/geometric/topographic-map-Nvjmk2FbKsC62zHWdFMGEU",
    title: "topographic map",
    list_url: "/styles/geometric/topographic-map"
  },
  {
    url: "/styles/gothic-font",
    title: "gothic",
    list_url: "/styles/gothic"
  },
  {
    url: "/styles/gothic/near-death-experience-F2V57h77Mb5bk6M9313te4",
    title: "near death experience",
    list_url: "/styles/gothic/near-death-experience"
  },
  {
    url: "/styles/japanese/a-lone-tree-bending-under-the-force-of-6Z5wAYjnJ58aNNY1wVNusm",
    title: "a lone tree bending under the force of",
    list_url: "/styles/japanese/a-lone-tree-bending-under-the-force-of"
  },
  {
    url: "/styles/japanese/eye-4Y4sq6TGQ3sYdFxmzZCHVL",
    title: "eye",
    list_url: "/styles/japanese/eye"
  },
  {
    url: "/styles/japanese/furinkazan-8NRRi7xXTEdDFxLXzvT83N",
    title: "furinkazan",
    list_url: "/styles/japanese/furinkazan"
  },
  {
    url: "/styles/japanese/geisha-with-umbrella-MLhgTxA91PYqU5ygQjVGWA",
    title: "geisha with umbrella",
    list_url: "/styles/japanese/geisha-with-umbrella"
  },
  {
    url: "/styles/japanese/irezumi-YVbhr6wiQ3VPHXQEmKyJHX",
    title: "irezumi",
    list_url: "/styles/japanese/irezumi"
  },
  {
    url: "/styles/japanese/luffy-gear-5-HyAWdFtvqiJ3uJsAwmLqSm",
    title: "luffy gear ",
    list_url: "/styles/japanese/luffy-gear-5"
  },
  {
    url: "/styles/japanese/neck-tattoo-FrDReHFYkAoCqoV4nDprcP",
    title: "neck tattoo",
    list_url: "/styles/japanese/neck-tattoo"
  },
  {
    url: "/styles/japanese/nio-guardians-LfEqzv7QwUYJs5Gj57VP3S",
    title: "nio guardians",
    list_url: "/styles/japanese/nio-guardians"
  },
  {
    url: "/styles/japanese/peacock-feather-black-and-white-NwNyGNBAtyD8AKjjLyb3SM",
    title: "peacock feather black and white",
    list_url: "/styles/japanese/peacock-feather-black-and-white"
  },
  {
    url: "/styles/japanese/ryu-hayabusa-9GgwyDCEgjoGvgPyHDxsuV",
    title: "ryu hayabusa",
    list_url: "/styles/japanese/ryu-hayabusa"
  },
  {
    url: "/styles/japanese/the-letters-sj-Kp1uwiYk1TW7DgBb9TxYrY",
    title: "the letters sj",
    list_url: "/styles/japanese/the-letters-sj"
  },
  {
    url: "/styles/japanese/trust-no-one-B4fuY4ehNyirDuyJ2Ngz2R",
    title: "trust no one",
    list_url: "/styles/japanese/trust-no-one"
  },
  {
    url: "/styles/minimalist/143-with-infinity-symbol-below-it-XrvCGt5NQ6cWszFqaqkj7y",
    title: " with infinity symbol below it",
    list_url: "/styles/minimalist/143-with-infinity-symbol-below-it"
  },
  {
    url: "/styles/minimalist/3-cute-ducks-in-a-row-behind-mama-duck-Fk3deUpUiq4P3Hs1VH7SCK",
    title: " cute ducks in a row behind mama duck",
    list_url: "/styles/minimalist/3-cute-ducks-in-a-row-behind-mama-duck"
  },
  {
    url: "/styles/minimalist/420-ErZ91RXvyKvwm9PxidpVnX",
    title: " ",
    list_url: "/styles/minimalist/420"
  },
  {
    url: "/styles/minimalist/7-chakras-HR1EpKAjzkhsG3ovg9fYA3",
    title: " chakras",
    list_url: "/styles/minimalist/7-chakras"
  },
  {
    url: "/styles/minimalist/9222002-and-7102006-in-roman-numerals-KB8ushXRhPg4MKTFtovCwH",
    title: " and in roman numerals",
    list_url: "/styles/minimalist/9222002-and-7102006-in-roman-numerals"
  },
  {
    url: "/styles/minimalist/anusha-QUcaYDVQ3buEkNeAnkfxR2",
    title: "anusha",
    list_url: "/styles/minimalist/anusha"
  },
  {
    url: "/styles/minimalist/archie-JrgmwUhhSoKfPFZ2GKtCAb",
    title: "archie",
    list_url: "/styles/minimalist/archie"
  },
  {
    url: "/styles/minimalist/ayurnamat-JNsWPaf6rceNuvVkMDbWoz",
    title: "ayurnamat",
    list_url: "/styles/minimalist/ayurnamat"
  },
  {
    url: "/styles/minimalist/basque-Gh2QzcqgeMvfhLd45eM9qP",
    title: "basque",
    list_url: "/styles/minimalist/basque"
  },
  {
    url: "/styles/minimalist/bikini-line-feminine-YT8SdrreVAZEZ2imeKYRXb",
    title: "bikini line feminine",
    list_url: "/styles/minimalist/bikini-line-feminine"
  },
  {
    url: "/styles/minimalist/bridge-over-troubled-water-B467P7LLvW7r7UoCEbiNg4",
    title: "bridge over troubled water",
    list_url: "/styles/minimalist/bridge-over-troubled-water"
  },
  {
    url: "/styles/minimalist/calypso-greek-myth-BdRjVMJ3rR63ezpCTPPYEA",
    title: "calypso greek myth",
    list_url: "/styles/minimalist/calypso-greek-myth"
  },
  {
    url: "/styles/minimalist/chinese-flowers-Uc72ZK7rRizkuh6ZUjmNxQ",
    title: "chinese flowers",
    list_url: "/styles/minimalist/chinese-flowers"
  },
  {
    url: "/styles/minimalist/cross-with-dogwood-flowers-wrapped-AGjc1VvXSLGAaNobxUgBNk",
    title: "cross with dogwood flowers wrapped",
    list_url: "/styles/minimalist/cross-with-dogwood-flowers-wrapped"
  },
  {
    url: "/styles/minimalist/flock-of-birds-flying-for-men-TcDfrUTZXEXmWuSUWmztBd",
    title: "flock of birds flying for men",
    list_url: "/styles/minimalist/flock-of-birds-flying-for-men"
  },
  {
    url: "/styles/minimalist/i-vow-you-vow-we-vow-DTF3L8Cpi1k6eu6434fpUd",
    title: "i vow you vow we vow",
    list_url: "/styles/minimalist/i-vow-you-vow-we-vow"
  },
  {
    url: "/styles/minimalist/incomplete-love-9tk1BjswGUKrRFKqfWkg85",
    title: "incomplete love",
    list_url: "/styles/minimalist/incomplete-love"
  },
  {
    url: "/styles/minimalist/lotus-flower-nam-myoho-renge-kyo-6H23LopQ7UD8Cwno6PoxqZ",
    title: "lotus flower nam myoho renge kyo",
    list_url: "/styles/minimalist/lotus-flower-nam-myoho-renge-kyo"
  },
  {
    url: "/styles/minimalist/may-birth-month-flowers-the-taurus-UQ894r7moFv2Db2gj8bAHU",
    title: "may birth month flowers the taurus",
    list_url: "/styles/minimalist/may-birth-month-flowers-the-taurus"
  },
  {
    url: "/styles/minimalist/men-gymnastics-Xy15u866njbyza539uSZgB",
    title: "men gymnastics",
    list_url: "/styles/minimalist/men-gymnastics"
  },
  {
    url: "/styles/minimalist/moon-and-pine-tree-MSECrd1ak7xH2asBLewxCp",
    title: "moon and pine tree",
    list_url: "/styles/minimalist/moon-and-pine-tree"
  },
  {
    url: "/styles/minimalist/morpankh-with-shri-krishna-bansuri-Fm98PHfuwRUvGif8Fyjgd2",
    title: "morpankh with shri krishna bansuri",
    list_url: "/styles/minimalist/morpankh-with-shri-krishna-bansuri"
  },
  {
    url: "/styles/minimalist/opele-ifa-orishas-oxum-and-ogum-and-C2d8tjGDKgLi8r8f4eivur",
    title: "opele ifa orishas oxum and ogum and",
    list_url: "/styles/minimalist/opele-ifa-orishas-oxum-and-ogum-and"
  },
  {
    url: "/styles/minimalist/paragliding-4Wc6jVooThhojAZxQ23LBz",
    title: "paragliding",
    list_url: "/styles/minimalist/paragliding"
  },
  {
    url: "/styles/minimalist/pencil-writing-the-word-dad-heartbeat-JmDSKdKs1sf4icxGubbJCx",
    title: "pencil writing the word dad heartbeat",
    list_url: "/styles/minimalist/pencil-writing-the-word-dad-heartbeat"
  },
  {
    url: "/styles/minimalist/rope-cross-U585u93gHGxGeLYPZ1psyG",
    title: "rope cross",
    list_url: "/styles/minimalist/rope-cross"
  },
  {
    url: "/styles/minimalist/serenity-courage-wisdom-xxx-iv-mcmxcvi-2MNEknADAmGjjiYmP6u5A2",
    title: "serenity courage wisdom xxx iv mcmxcvi",
    list_url: "/styles/minimalist/serenity-courage-wisdom-xxx-iv-mcmxcvi"
  },
  {
    url: "/styles/minimalist/shar-pei-WFg8ymFWcMYePjxUFeec6N",
    title: "shar pei",
    list_url: "/styles/minimalist/shar-pei"
  },
  {
    url: "/styles/minimalist/small-fine-line-iris-flower-CNMQNJi1DVVUeZtc2aWTV5",
    title: "small fine line iris flower",
    list_url: "/styles/minimalist/small-fine-line-iris-flower"
  },
  {
    url: "/styles/minimalist/vines-and-flowers-going-down-the-spine-9EXt3rR36xfd6hJoN6YpYr",
    title: "vines and flowers going down the spine",
    list_url: "/styles/minimalist/vines-and-flowers-going-down-the-spine"
  },
  {
    url: "/styles/minimalist/wakeboarding-5BmfYoGpUxLQwMnQkyFrss",
    title: "wakeboarding",
    list_url: "/styles/minimalist/wakeboarding"
  },
  {
    url: "/styles/minimalist/waterfall-8oWbhTZKbGrzC5AbhCP1Di",
    title: "waterfall",
    list_url: "/styles/minimalist/waterfall"
  },
  {
    url: "/styles/minimalist/wedding-ring-9a961WHLhUUajfwpSMxpL3",
    title: "wedding ring",
    list_url: "/styles/minimalist/wedding-ring"
  },
  {
    url: "/styles/neotraditional/49ers-JMkESMcZwU1dSpcFbJ3JMi",
    title: " ers",
    list_url: "/styles/neotraditional/49ers"
  },
  {
    url: "/styles/neotraditional/a-rose-with-lily-of-the-valley-flower-GAMVQ1vNYEaSu7RN2sPFQt",
    title: "a rose with lily of the valley flower",
    list_url: "/styles/neotraditional/a-rose-with-lily-of-the-valley-flower"
  },
  {
    url: "/styles/neotraditional/a-tattoo-of-name-somu-sami-7sjiPcgyYy55sRRutvUdJj",
    title: "a tattoo of name somu sami",
    list_url: "/styles/neotraditional/a-tattoo-of-name-somu-sami"
  },
  {
    url: "/styles/neotraditional/althea-P1EcF94JdmQMmPo5YPUsWw",
    title: "althea",
    list_url: "/styles/neotraditional/althea"
  },
  {
    url: "/styles/neotraditional/aut-vincere-aut-mori-chicano-font-BWdz4TKr7jq9u9z7NNN2B4",
    title: "aut vincere aut mori chicano font",
    list_url: "/styles/neotraditional/aut-vincere-aut-mori-chicano-font"
  },
  {
    url: "/styles/neotraditional/baby-dolphin-swimming-with-mom-dolphin-RYxDptCDWaK2gcgsBYsM8z",
    title: "baby dolphin swimming with mom dolphin",
    list_url: "/styles/neotraditional/baby-dolphin-swimming-with-mom-dolphin"
  },
  {
    url: "/styles/neotraditional/bondage-QtsQswm6aAVSWFLnJbm4oV",
    title: "bondage",
    list_url: "/styles/neotraditional/bondage"
  },
  {
    url: "/styles/neotraditional/curvy-pinup-girl-NFySWx7sLgNsk172b9aJ8Q",
    title: "curvy pinup girl",
    list_url: "/styles/neotraditional/curvy-pinup-girl"
  },
  {
    url: "/styles/neotraditional/divya-name-tattoo-AfocEaRsqoqd9tswYh7gZ4",
    title: "divya name tattoo",
    list_url: "/styles/neotraditional/divya-name-tattoo"
  },
  {
    url: "/styles/neotraditional/doctor-who-and-tardis-and-gallifreyan-LjjMfTXxuoXU2BQEkVDkMD",
    title: "doctor who and tardis and gallifreyan",
    list_url: "/styles/neotraditional/doctor-who-and-tardis-and-gallifreyan"
  },
  {
    url: "/styles/neotraditional/heart-with-the-letter-j-and-r-3oUt3SiFEjuqe46AYuegqF",
    title: "heart with the letter j and r",
    list_url: "/styles/neotraditional/heart-with-the-letter-j-and-r"
  },
  {
    url: "/styles/neotraditional/hentai-dark-twisted-abstract-female-UydZ2p7eDenQXiAvRktWw2",
    title: "hentai dark twisted abstract female",
    list_url: "/styles/neotraditional/hentai-dark-twisted-abstract-female"
  },
  {
    url: "/styles/neotraditional/interstellar-morse-code-stay-QpjP817TZMKwwuK8u3RRCF",
    title: "interstellar morse code stay",
    list_url: "/styles/neotraditional/interstellar-morse-code-stay"
  },
  {
    url: "/styles/neotraditional/inti-sun-with-1965-in-roman-numerals-RdDXf5G13Gz6wq8mubYehD",
    title: "inti sun with in roman numerals",
    list_url: "/styles/neotraditional/inti-sun-with-1965-in-roman-numerals"
  },
  {
    url: "/styles/neotraditional/kubera-god-of-wealth-87ymM1AHAjXgu8dvNAUYMg",
    title: "kubera god of wealth",
    list_url: "/styles/neotraditional/kubera-god-of-wealth"
  },
  {
    url: "/styles/neotraditional/maat-egyptian-goddess-of-balance-3UdXKVzKDpXhu5m55grrZj",
    title: "maat egyptian goddess of balance",
    list_url: "/styles/neotraditional/maat-egyptian-goddess-of-balance"
  },
  {
    url: "/styles/neotraditional/masters-call-marty-robbins-MmnxpXuUiNMVLJgN6oHqpH",
    title: "masters call marty robbins",
    list_url: "/styles/neotraditional/masters-call-marty-robbins"
  },
  {
    url: "/styles/neotraditional/misa-from-death-note-with-big-breast-7S8adYdf69vPpc8aCU7dgw",
    title: "misa from death note with big breast",
    list_url: "/styles/neotraditional/misa-from-death-note-with-big-breast"
  },
  {
    url: "/styles/neotraditional/realistic-jaguar-tattoo-back-of-shoulder-8kYH6PGRkUCcFanjKq1T3z",
    title: "realistic jaguar tattoo back of shoulder",
    list_url: "/styles/neotraditional/realistic-jaguar-tattoo-back-of-shoulder"
  },
  {
    url: "/styles/neotraditional/redneck-7wmRgBPNMrHSXdymgULuKQ",
    title: "redneck",
    list_url: "/styles/neotraditional/redneck"
  },
  {
    url: "/styles/neotraditional/santiago-name-tattoo-8ifwSYeToLYBg1HNWLjjpp",
    title: "santiago name tattoo",
    list_url: "/styles/neotraditional/santiago-name-tattoo"
  },
  {
    url: "/styles/neotraditional/shraddha-name-tattoo-RxTEA5vJ3LxqDT8ap4TCci",
    title: "shraddha name tattoo",
    list_url: "/styles/neotraditional/shraddha-name-tattoo"
  },
  {
    url: "/styles/neotraditional/smile-through-the-pain-VPQiPZyqxuL8zjFza4XYg6",
    title: "smile through the pain",
    list_url: "/styles/neotraditional/smile-through-the-pain"
  },
  {
    url: "/styles/neotraditional/sonder-written-in-cursive-CsT5hXeQ8f2ipoUfQhF7Qq",
    title: "sonder written in cursive",
    list_url: "/styles/neotraditional/sonder-written-in-cursive"
  },
  {
    url: "/styles/neotraditional/sunflower-rose-lily-of-the-valley-J76Jnwic4i62MwFPMLAgZv",
    title: "sunflower rose lily of the valley",
    list_url: "/styles/neotraditional/sunflower-rose-lily-of-the-valley"
  },
  {
    url: "/styles/neotraditional/teddy-bear-with-angel-wings-flying-BvxJE7Wt6YsJCNMK64fjp1",
    title: "teddy bear with angel wings flying",
    list_url: "/styles/neotraditional/teddy-bear-with-angel-wings-flying"
  },
  {
    url: "/styles/neotraditional/the-name-kelly-with-a-heart-9fBCBgbzb1Rt2RniDGzKUN",
    title: "the name kelly with a heart",
    list_url: "/styles/neotraditional/the-name-kelly-with-a-heart"
  },
  {
    url: "/styles/neotraditional/unbowed-unbent-unbroken-EnqmM8ZQyMdziqADAfEg58",
    title: "unbowed unbent unbroken",
    list_url: "/styles/neotraditional/unbowed-unbent-unbroken"
  },
  {
    url: "/styles/neotraditional/wilson-family-crest-type-tatoo-AsvTGXoZNy6ZbpPRBwV3Ah",
    title: "wilson family crest type tatoo",
    list_url: "/styles/neotraditional/wilson-family-crest-type-tatoo"
  },
  {
    url: "/styles/new-school/storm-clouds-with-lightning-NP5mVLCABQQpihq6ixvDDR",
    title: "storm clouds with lightning",
    list_url: "/styles/new-school/storm-clouds-with-lightning"
  },
  {
    url: "/styles/realism/1908-inter-milan-logo-9mcaGsLWEJsFZYxth7Htgh",
    title: " inter milan logo",
    list_url: "/styles/realism/1908-inter-milan-logo"
  },
  {
    url: "/styles/realism/arched-old-english-font-pray-for-me-P6AsnEfmKuJJ4cDpkeqA8b",
    title: "arched old english font pray for me",
    list_url: "/styles/realism/arched-old-english-font-pray-for-me"
  },
  {
    url: "/styles/realism/black-white-hulk-with-glowing-green-4chJ7mEGKcNwcqX5xsM3hJ",
    title: "black white hulk with glowing green",
    list_url: "/styles/realism/black-white-hulk-with-glowing-green"
  },
  {
    url: "/styles/realism/butterfly-with-flower-wings-TqVgdXSyZq27zJxWiFZt5T",
    title: "butterfly with flower wings",
    list_url: "/styles/realism/butterfly-with-flower-wings"
  },
  {
    url: "/styles/realism/camorra-HMMPgE26ehnvDnhGq6sSHh",
    title: "camorra",
    list_url: "/styles/realism/camorra"
  },
  {
    url: "/styles/realism/celtic-cross-tree-of-life-intertwined-2dquepR24jQCoFKq6WtvdE",
    title: "celtic cross tree of life intertwined",
    list_url: "/styles/realism/celtic-cross-tree-of-life-intertwined"
  },
  {
    url: "/styles/realism/elephant-and-tiger-9J5vdVDCfoBiVFUiuj8xfe",
    title: "elephant and tiger",
    list_url: "/styles/realism/elephant-and-tiger"
  },
  {
    url: "/styles/realism/evil-nun-LVkr3vcMHnmRew5Dn71p27",
    title: "evil nun",
    list_url: "/styles/realism/evil-nun"
  },
  {
    url: "/styles/realism/infinity-symbol-with-a-name-joel-dario-Gdey4FLYpTabB53Mbtnn4r",
    title: "infinity symbol with a name joel dario",
    list_url: "/styles/realism/infinity-symbol-with-a-name-joel-dario"
  },
  {
    url: "/styles/realism/mary-magdalene-SNG5W5QrAhj1KAKV5w2x5o",
    title: "mary magdalene",
    list_url: "/styles/realism/mary-magdalene"
  },
  {
    url: "/styles/realism/money-power-respect-TAZA1YDBSFkWTjTyCZyf4t",
    title: "money power respect",
    list_url: "/styles/realism/money-power-respect"
  },
  {
    url: "/styles/realism/native-arm-band-with-eagle-feather-and-CEcpuT6vzJ1N8UXXpxCXb3",
    title: "native arm band with eagle feather and",
    list_url: "/styles/realism/native-arm-band-with-eagle-feather-and"
  },
  {
    url: "/styles/realism/poop-BXPpa31aErVcoVkw44QHgT",
    title: "poop",
    list_url: "/styles/realism/poop"
  },
  {
    url: "/styles/realism/scotland-charles-rennie-mackintosh-443h7TpVfercxtigXwHdBD",
    title: "scotland charles rennie mackintosh",
    list_url: "/styles/realism/scotland-charles-rennie-mackintosh"
  },
  {
    url: "/styles/sketch/aries-ram-with-honeysuckle-and-thistle-6XgPkh2rgh5GrVg2iNkwEm",
    title: "aries ram with honeysuckle and thistle",
    list_url: "/styles/sketch/aries-ram-with-honeysuckle-and-thistle"
  },
  {
    url: "/styles/sketch/daffodil-and-water-lily-flowers-YF8DezVGVydJrpj1Vo4o2s",
    title: "daffodil and water lily flowers",
    list_url: "/styles/sketch/daffodil-and-water-lily-flowers"
  },
  {
    url: "/styles/sketch/dove-rose-clock-FT5LoHDZthmdudnjAy1umC",
    title: "dove rose clock",
    list_url: "/styles/sketch/dove-rose-clock"
  },
  {
    url: "/styles/sketch/january-july-and-august-birth-flowers-A2U6qwndPwAAfUjpcPMj11",
    title: "january july and august birth flowers",
    list_url: "/styles/sketch/january-july-and-august-birth-flowers"
  },
  {
    url: "/styles/sketch/man-and-woman-walking-away-in-a-field-EqPrvWUjjkzdbSfrQhuweF",
    title: "man and woman walking away in a field",
    list_url: "/styles/sketch/man-and-woman-walking-away-in-a-field"
  },
  {
    url: "/styles/sketch/muslim-chest-tattoo-with-islamic-words-LJeUGdV8xgCKkh6UovSiK9",
    title: "muslim chest tattoo with islamic words",
    list_url: "/styles/sketch/muslim-chest-tattoo-with-islamic-words"
  },
  {
    url: "/styles/sketch/philippians-13-HM1pAkpnq2CaBaTgGJofQp",
    title: "philippians ",
    list_url: "/styles/sketch/philippians-13"
  },
  {
    url: "/styles/sketch/smile-now-cry-later-D7MoMnGeJa81qyKKXTPwku",
    title: "smile now cry later",
    list_url: "/styles/sketch/smile-now-cry-later"
  },
  {
    url: "/styles/sketch/southern-live-oak-into-evergreen-tree-SMcvceXwWdpGShkYojriFA",
    title: "southern live oak into evergreen tree",
    list_url: "/styles/sketch/southern-live-oak-into-evergreen-tree"
  },
  {
    url: "/styles/sketch/xavier-rudd-music-KGGjdUwQ8ZKZa9hxb98HGX",
    title: "xavier rudd music",
    list_url: "/styles/sketch/xavier-rudd-music"
  },
  {
    url: "/styles/stencil/blackfoot-cherokee-symbols-of-strength-D1L5sXUSKrdXgLhXMdi6Sb",
    title: "blackfoot cherokee symbols of strength",
    list_url: "/styles/stencil/blackfoot-cherokee-symbols-of-strength"
  },
  {
    url: "/styles/stencil/memento-mori-with-compass-and-clock-WCeHpVmo5gpPYHQAs5kjWW",
    title: "memento mori with compass and clock",
    list_url: "/styles/stencil/memento-mori-with-compass-and-clock"
  },
  {
    url: "/styles/stencil/qos-queen-of-spades-NoTRM9wJLnKhKayxJrSqmZ",
    title: "qos queen of spades",
    list_url: "/styles/stencil/qos-queen-of-spades"
  },
  {
    url: "/styles/traditional/bats-and-butterflies-forming-the-shape-XeYTSL7CcXFqHypQofs9wa",
    title: "bats and butterflies forming the shape",
    list_url: "/styles/traditional/bats-and-butterflies-forming-the-shape"
  },
  {
    url: "/styles/traditional/celtic-rose-F5VZ5FK87PQMs5ATk9DeVm",
    title: "celtic rose",
    list_url: "/styles/traditional/celtic-rose"
  },
  {
    url: "/styles/traditional/gay-pinup-male-sailor-smoking-a-bXMLmHJREGqfPHprgzekn",
    title: "gay pinup male sailor smoking a",
    list_url: "/styles/traditional/gay-pinup-male-sailor-smoking-a"
  },
  {
    url: "/styles/traditional/maat-feather-RXymZ1oDqxFoHFZpfZxAfQ",
    title: "maat feather",
    list_url: "/styles/traditional/maat-feather"
  },
  {
    url: "/styles/traditional/mayfly-MWJApb1LVFwR3XiSfeynSQ",
    title: "mayfly",
    list_url: "/styles/traditional/mayfly"
  },
  {
    url: "/styles/traditional/shrestha-name-written-TrnfRqbTA2aZ8s93LcLbVz",
    title: "shrestha name written",
    list_url: "/styles/traditional/shrestha-name-written"
  },
  {
    url: "/styles/traditional/the-name-trina-in-cursive-with-a-purple-PxazXi6NPbipmep1Doqmoq",
    title: "the name trina in cursive with a purple",
    list_url: "/styles/traditional/the-name-trina-in-cursive-with-a-purple"
  },
  {
    url: "/styles/traditional/we-walk-by-faith-not-by-sight-written-5AnHkD6n4Fdj2fbtU4tPoM",
    title: "we walk by faith not by sight written",
    list_url: "/styles/traditional/we-walk-by-faith-not-by-sight-written"
  },
  {
    url: "/styles/tribal/baltic-M7Gee5oQ2r8a31owyZVjqb",
    title: "baltic",
    list_url: "/styles/tribal/baltic"
  },
  {
    url: "/styles/tribal/cover-up-thick-om-symbol-UpEwp3h3Qq83QsPog6n4Xz",
    title: "cover up thick om symbol",
    list_url: "/styles/tribal/cover-up-thick-om-symbol"
  },
  {
    url: "/styles/tribal/small-indalo-man-symbol-variation-4YJGmM1LbG47keX1W8ZWTz",
    title: "small indalo man symbol variation",
    list_url: "/styles/tribal/small-indalo-man-symbol-variation"
  },
  {
    url: "/styles/watercolor/robin-bird-5RpHdDkS3Wu6DKxzNYBK4v",
    title: "robin bird",
    list_url: "/styles/watercolor/robin-bird"
  },
  {
    url: "/styles/anime/brother-and-sister-3sZzGrzriKXp6vVZVuRLuk",
    title: "brother and sister",
    list_url: "/styles/anime/brother-and-sister"
  },
  {
    url: "/styles/anime/rei-ayanami-pelada-em-uma-cruz-NoRVqswAAFWeW73HQYkL28",
    title: "rei ayanami pelada em uma cruz",
    list_url: "/styles/anime/rei-ayanami-pelada-em-uma-cruz"
  },
  {
    url: "/styles/biomechanical/marvel-comics-wolverine-4K1ZhXUoHesUPUUNVg9Sv6",
    title: "marvel comics wolverine",
    list_url: "/styles/biomechanical/marvel-comics-wolverine"
  },
  {
    url: "/styles/black-grey/1991-roman-numerals-TUWjt4o6V49Rk42vqgcuoM",
    title: " roman numerals",
    list_url: "/styles/black-grey/1991-roman-numerals"
  },
  {
    url: "/styles/black-grey/adonis-greek-god-QQvHDVE5NkPRDRipoMSUPo",
    title: "adonis greek god",
    list_url: "/styles/black-grey/adonis-greek-god"
  },
  {
    url: "/styles/black-grey/african-medusa-with-dreadlocks-RZQ1SAskEEbePojvydr4Lm",
    title: "african medusa with dreadlocks",
    list_url: "/styles/black-grey/african-medusa-with-dreadlocks"
  },
  {
    url: "/styles/black-grey/angel-wings-birth-flowers-KMxaX4N1useq8yQR96tmRw",
    title: "angel wings birth flowers",
    list_url: "/styles/black-grey/angel-wings-birth-flowers"
  },
  {
    url: "/styles/black-grey/angels-and-demons-sleeve-U1kMYwEnXvoqzYnLPAeUvG",
    title: "angels and demons sleeve",
    list_url: "/styles/black-grey/angels-and-demons-sleeve"
  },
  {
    url: "/styles/black-grey/baby-footprint-with-name-date-of-QgWJAvSFPkeM4sAsQRnnDk",
    title: "baby footprint with name date of",
    list_url: "/styles/black-grey/baby-footprint-with-name-date-of"
  },
  {
    url: "/styles/black-grey/back-of-leg-and-back-of-knee-tattoo-8W1k7Y2FRGLfew9SfiUsS1",
    title: "back of leg and back of knee tattoo",
    list_url: "/styles/black-grey/back-of-leg-and-back-of-knee-tattoo"
  },
  {
    url: "/styles/black-grey/bend-overslim-thick-goth-girlemo-VfmmyXNEpuAiRXuXxaM6Y5",
    title: "bend overslim thick goth girlemo",
    list_url: "/styles/black-grey/bend-overslim-thick-goth-girlemo"
  },
  {
    url: "/styles/black-grey/blackpool-tower-surrounded-DpfwzNm31wh4SfF742tcbC",
    title: "blackpool tower surrounded",
    list_url: "/styles/black-grey/blackpool-tower-surrounded"
  },
  {
    url: "/styles/black-grey/c8-corvette-stingray-Nfv9wVy82AbYZpe9ei2iDB",
    title: "c corvette stingray",
    list_url: "/styles/black-grey/c8-corvette-stingray"
  },
  {
    url: "/styles/black-grey/coast-guard-emblem-with-a-mermaid-and-96UPxxWGq274kch45U6oXP",
    title: "coast guard emblem with a mermaid and",
    list_url: "/styles/black-grey/coast-guard-emblem-with-a-mermaid-and"
  },
  {
    url: "/styles/black-grey/cross-with-blessed-written-on-neck-R8iDnB4TR8u1mtAWz2ujjf",
    title: "cross with blessed written on neck",
    list_url: "/styles/black-grey/cross-with-blessed-written-on-neck"
  },
  {
    url: "/styles/black-grey/dagda-irish-god-CXe2gNjw3f7G2MNjYKrh1V",
    title: "dagda irish god",
    list_url: "/styles/black-grey/dagda-irish-god"
  },
  {
    url: "/styles/black-grey/dragon-flowers-book-open-book-6m4f1hkSZA22TWGgAuQGYi",
    title: "dragon flowers book open book",
    list_url: "/styles/black-grey/dragon-flowers-book-open-book"
  },
  {
    url: "/styles/black-grey/dragon-in-a-heart-shape-CdtjregQ9GAe4JnmMJ7aLu",
    title: "dragon in a heart shape",
    list_url: "/styles/black-grey/dragon-in-a-heart-shape"
  },
  {
    url: "/styles/black-grey/eucharistic-monstrance-AiHjKiMh6E1WqB4vGQZgP7",
    title: "eucharistic monstrance",
    list_url: "/styles/black-grey/eucharistic-monstrance"
  },
  {
    url: "/styles/black-grey/female-chest-tattoo-gothic-mandala-7FktPtxBL5DL3TWNAwiQgn",
    title: "female chest tattoo gothic mandala",
    list_url: "/styles/black-grey/female-chest-tattoo-gothic-mandala"
  },
  {
    url: "/styles/black-grey/flowers-and-scorpion-tattoo-D3xvENVqFTdGTJQwxMWFco",
    title: "flowers and scorpion tattoo",
    list_url: "/styles/black-grey/flowers-and-scorpion-tattoo"
  },
  {
    url: "/styles/black-grey/g59-T81K2marNpJkAqxCPbeCaR",
    title: "g ",
    list_url: "/styles/black-grey/g59"
  },
  {
    url: "/styles/black-grey/gift-of-god-YKwY48FpEDxdJJHwetLAX8",
    title: "gift of god",
    list_url: "/styles/black-grey/gift-of-god"
  },
  {
    url: "/styles/black-grey/heart-shaped-lock-and-key-tattoo-with-GxzZR8Z9AkvyEA29CqsdgW",
    title: "heart shaped lock and key tattoo with",
    list_url: "/styles/black-grey/heart-shaped-lock-and-key-tattoo-with"
  },
  {
    url: "/styles/black-grey/isaiah-43-18-19-7Tw2eGHdEcoPkf6Lv3r7V3",
    title: "isaiah ",
    list_url: "/styles/black-grey/isaiah-43-18-19"
  },
  {
    url: "/styles/black-grey/jeevitha-name-tattoo-TBhXZ4zvaSQJGHU4aCg66t",
    title: "jeevitha name tattoo",
    list_url: "/styles/black-grey/jeevitha-name-tattoo"
  },
  {
    url: "/styles/black-grey/maclean-clan-crest-with-thistle-and-DkKkd7759gwvABe4nB93EZ",
    title: "maclean clan crest with thistle and",
    list_url: "/styles/black-grey/maclean-clan-crest-with-thistle-and"
  },
  {
    url: "/styles/black-grey/mandala-and-clock-Ja9D5bvHhi7uRycg2G7ddA",
    title: "mandala and clock",
    list_url: "/styles/black-grey/mandala-and-clock"
  },
  {
    url: "/styles/black-grey/maria-name-B2WmZziJ2FYfsxV6aNd29v",
    title: "maria name",
    list_url: "/styles/black-grey/maria-name"
  },
  {
    url: "/styles/black-grey/matthew-196-99DSDefJ45tHzY5squFaVK",
    title: "matthew ",
    list_url: "/styles/black-grey/matthew-196"
  },
  {
    url: "/styles/black-grey/mickey-mouse-smoking-weed-XXnruPcoeH3dDy2TQzXV3B",
    title: "mickey mouse smoking weed",
    list_url: "/styles/black-grey/mickey-mouse-smoking-weed"
  },
  {
    url: "/styles/black-grey/moral-compass-LqgD3SxuXJb8K7azYBStcA",
    title: "moral compass",
    list_url: "/styles/black-grey/moral-compass"
  },
  {
    url: "/styles/black-grey/mother-and-daughter-gothic-fairy-7Y8jYew7WT9y2THDYmP6WZ",
    title: "mother and daughter gothic fairy",
    list_url: "/styles/black-grey/mother-and-daughter-gothic-fairy"
  },
  {
    url: "/styles/black-grey/my-mercy-prevails-my-wrath-written-in-A21AWh4QMsfMsBroGDiJLo",
    title: "my mercy prevails my wrath written in",
    list_url: "/styles/black-grey/my-mercy-prevails-my-wrath-written-in"
  },
  {
    url: "/styles/black-grey/name-ajay-date-of-birth-december-12-LCbpTsnxmTu9z2sdNFZEFM",
    title: "name ajay date of birth december ",
    list_url: "/styles/black-grey/name-ajay-date-of-birth-december-12"
  },
  {
    url: "/styles/black-grey/name-nik-JBqfcwbWcZPzo34dDSoYUx",
    title: "name nik",
    list_url: "/styles/black-grey/name-nik"
  },
  {
    url: "/styles/black-grey/parthenon-SA3tsepG6yPsv4GcpDZizP",
    title: "parthenon",
    list_url: "/styles/black-grey/parthenon"
  },
  {
    url: "/styles/black-grey/roman-numeral-1958-date-tattoo-XosxfyjbLFdAK9bWYmTJrn",
    title: "roman numeral date tattoo",
    list_url: "/styles/black-grey/roman-numeral-1958-date-tattoo"
  },
  {
    url: "/styles/black-grey/seth-egyptian-god-tfj6z7PuTtpX92PEQoNUN",
    title: "seth egyptian god",
    list_url: "/styles/black-grey/seth-egyptian-god"
  },
  {
    url: "/styles/black-grey/slut-maid-sissy-WcXpJj3zAv1wGTuDrYAirL",
    title: "slut maid sissy",
    list_url: "/styles/black-grey/slut-maid-sissy"
  },
  {
    url: "/styles/black-grey/spearfishing-GyG6HZkUEB4bRLmeR4pYxi",
    title: "spearfishing",
    list_url: "/styles/black-grey/spearfishing"
  },
  {
    url: "/styles/black-grey/tattoo-based-on-the-apparition-by-sleep-9isxzZzsYL1uoLYpGbT15G",
    title: "tattoo based on the apparition by sleep",
    list_url: "/styles/black-grey/tattoo-based-on-the-apparition-by-sleep"
  },
  {
    url: "/styles/black-grey/tattoo-with-the-word-milele-the-3Judg9fYuS2ne8BKyyBToR",
    title: "tattoo with the word milele the",
    list_url: "/styles/black-grey/tattoo-with-the-word-milele-the"
  },
  {
    url: "/styles/black-grey/the-name-sammy-written-on-forearm-TsuByinAK1nLGuykA3V54D",
    title: "the name sammy written on forearm",
    list_url: "/styles/black-grey/the-name-sammy-written-on-forearm"
  },
  {
    url: "/styles/black-grey/the-night-belongs-to-you-euclid-by-MuP6mQF2EwDziwrT3GkRnx",
    title: "the night belongs to you euclid by",
    list_url: "/styles/black-grey/the-night-belongs-to-you-euclid-by"
  },
  {
    url: "/styles/black-grey/theju-indhu-name-RbHsf84sZd42PL9yL94kiv",
    title: "theju indhu name",
    list_url: "/styles/black-grey/theju-indhu-name"
  },
  {
    url: "/styles/black-grey/tree-of-life-tattoo-featuring-bible-Th6k2o4VviDzB71o88LQnZ",
    title: "tree of life tattoo featuring bible",
    list_url: "/styles/black-grey/tree-of-life-tattoo-featuring-bible"
  },
  {
    url: "/styles/black-grey/walk-by-faith-not-by-sight-MzGwh4kB7y5VmuhDPS7LQf",
    title: "walk by faith not by sight",
    list_url: "/styles/black-grey/walk-by-faith-not-by-sight"
  },
  {
    url: "/styles/black-grey/zodiac-sign-taurus-month-may-year-of-RZXpeN9pnfjHht78W91tVG",
    title: "zodiac sign taurus month may year of",
    list_url: "/styles/black-grey/zodiac-sign-taurus-month-may-year-of"
  },
  {
    url: "/styles/blackwork/a-little-boy-sitting-on-the-moon-2JR9fvD34sQYG2DVJ8YyQu",
    title: "a little boy sitting on the moon",
    list_url: "/styles/blackwork/a-little-boy-sitting-on-the-moon"
  },
  {
    url: "/styles/blackwork/a-sword-with-wings-and-an-eye-C5G5cLSJShvUcGZptN3AwH",
    title: "a sword with wings and an eye",
    list_url: "/styles/blackwork/a-sword-with-wings-and-an-eye"
  },
  {
    url: "/styles/blackwork/aa-symbol-of-a-triangle-inside-a-VkwUZLpAdysEUeGetW7nZp",
    title: "aa symbol of a triangle inside a",
    list_url: "/styles/blackwork/aa-symbol-of-a-triangle-inside-a"
  },
  {
    url: "/styles/blackwork/ambigram-of-names-bhavana-and-neeraja-G9Q2q5C58c4ewFWSyy9tca",
    title: "ambigram of names bhavana and neeraja",
    list_url: "/styles/blackwork/ambigram-of-names-bhavana-and-neeraja"
  },
  {
    url: "/styles/blackwork/birth-date-in-roman-numerals-742009-FQJcQqj4miGNBqrE8qjMqB",
    title: "birth date in roman numerals ",
    list_url: "/styles/blackwork/birth-date-in-roman-numerals-742009"
  },
  {
    url: "/styles/blackwork/bnwo-MgKomPZd17VAZeL22hYP88",
    title: "bnwo",
    list_url: "/styles/blackwork/bnwo"
  },
  {
    url: "/styles/blackwork/celtic-pagan-tuatha-de-danann-lugh-NLZt1RR6aSCoU4aPb3eGAQ",
    title: "celtic pagan tuatha de danann lugh",
    list_url: "/styles/blackwork/celtic-pagan-tuatha-de-danann-lugh"
  },
  {
    url: "/styles/blackwork/cross-with-hummingbird-LwBBRnuPFcMs5wAYJpo2w2",
    title: "cross with hummingbird",
    list_url: "/styles/blackwork/cross-with-hummingbird"
  },
  {
    url: "/styles/blackwork/dirty-flat-cap-WquajXPGp1iVmuTUzWSpyL",
    title: "dirty flat cap",
    list_url: "/styles/blackwork/dirty-flat-cap"
  },
  {
    url: "/styles/blackwork/fc-barcelona-logo-3zWDrk8i2twwZLcbtr4fZM",
    title: "fc barcelona logo",
    list_url: "/styles/blackwork/fc-barcelona-logo"
  },
  {
    url: "/styles/blackwork/goth-neck-tattoo-EWhUSzxxGDafQQC375GbHj",
    title: "goth neck tattoo",
    list_url: "/styles/blackwork/goth-neck-tattoo"
  },
  {
    url: "/styles/blackwork/grim-reaper-holding-newborn-baby-3iau34dTPc19VzNt7vqENW",
    title: "grim reaper holding newborn baby",
    list_url: "/styles/blackwork/grim-reaper-holding-newborn-baby"
  },
  {
    url: "/styles/blackwork/infinity-symbol-hourglass-CSaSBDMxy2G2M9KeJAsLhp",
    title: "infinity symbol hourglass",
    list_url: "/styles/blackwork/infinity-symbol-hourglass"
  },
  {
    url: "/styles/blackwork/letter-d-with-butterfly-QQ57aPc1wFczepSLTcPjXD",
    title: "letter d with butterfly",
    list_url: "/styles/blackwork/letter-d-with-butterfly"
  },
  {
    url: "/styles/blackwork/lologram-from-arrival-movie-that-means-KX7CoswQn9JDdgDYVs8qJX",
    title: "lologram from arrival movie that means",
    list_url: "/styles/blackwork/lologram-from-arrival-movie-that-means"
  },
  {
    url: "/styles/blackwork/octopus-wrap-around-leg-D9TTBE43VEQLUVn5m39GY2",
    title: "octopus wrap around leg",
    list_url: "/styles/blackwork/octopus-wrap-around-leg"
  },
  {
    url: "/styles/blackwork/philippians-313-roman-numerals-and-4cVqK4SG8SJ9jKtGZ7Uw1T",
    title: "philippians roman numerals and",
    list_url: "/styles/blackwork/philippians-313-roman-numerals-and"
  },
  {
    url: "/styles/blackwork/premier-league-fa-cup-and-champions-UNhtKkHEJG9XkYaoXPLbZF",
    title: "premier league fa cup and champions",
    list_url: "/styles/blackwork/premier-league-fa-cup-and-champions"
  },
  {
    url: "/styles/blackwork/queens-of-the-stone-age-2fJejtmvk1mcYbxtzSQKxS",
    title: "queens of the stone age",
    list_url: "/styles/blackwork/queens-of-the-stone-age"
  },
  {
    url: "/styles/blackwork/raghav-name-with-flute-with-peacock-PtMZhXdTWxwMBuq2NX9gmK",
    title: "raghav name with flute with peacock",
    list_url: "/styles/blackwork/raghav-name-with-flute-with-peacock"
  },
  {
    url: "/styles/blackwork/revelation-62-SUyLquVWBBwRkwaCu1NESD",
    title: "revelation ",
    list_url: "/styles/blackwork/revelation-62"
  },
  {
    url: "/styles/blackwork/set-of-irons-firefighter-YN9JBbNMKB9DKns46hmcyE",
    title: "set of irons firefighter",
    list_url: "/styles/blackwork/set-of-irons-firefighter"
  },
  {
    url: "/styles/blackwork/the-statue-of-god-from-solo-leveling-4USQd8VQjp5XBXvoD3VDmC",
    title: "the statue of god from solo leveling",
    list_url: "/styles/blackwork/the-statue-of-god-from-solo-leveling"
  },
  {
    url: "/styles/blackwork/v-twin-motorcycle-engine-P6WKkLtE92358HbF1yNQgF",
    title: "v twin motorcycle engine",
    list_url: "/styles/blackwork/v-twin-motorcycle-engine"
  },
  {
    url: "/styles/blackwork/vedanshi-name-SxxHB1vkEqMQqovGYy5UnE",
    title: "vedanshi name",
    list_url: "/styles/blackwork/vedanshi-name"
  },
  {
    url: "/styles/blackwork/viking-and-brother-HfYfhHQPmLWNg92iFtmc74",
    title: "viking and brother",
    list_url: "/styles/blackwork/viking-and-brother"
  },
  {
    url: "/styles/blackwork/weeping-may-endure-for-a-night-but-joy-PBrZqbRovJh8nzUcxr4heu",
    title: "weeping may endure for a night but joy",
    list_url: "/styles/blackwork/weeping-may-endure-for-a-night-but-joy"
  },
  {
    url: "/styles/chicano",
    title: "chicano",
    list_url: "/styles/chicano"
  },
  {
    url: "/styles/cyber-sigilism/a-sword-cybersigilism-with-occult-JfjgY3zeYGLfxXwSENcWFz",
    title: "a sword cybersigilism with occult",
    list_url: "/styles/cyber-sigilism/a-sword-cybersigilism-with-occult"
  },
  {
    url: "/styles/dotwork/a-horse-and-snake-intertwined-in-a-yin-STnb2w78ymN75VEnW4HsVz",
    title: "a horse and snake intertwined in a yin",
    list_url: "/styles/dotwork/a-horse-and-snake-intertwined-in-a-yin"
  },
  {
    url: "/styles/dotwork/abigail-Af3BcDAFBvoaSUmSzF1iro",
    title: "abigail",
    list_url: "/styles/dotwork/abigail"
  },
  {
    url: "/styles/dotwork/angel-sitting-on-a-moon-praying-UGquuBray7khrGSaRZfiYH",
    title: "angel sitting on a moon praying",
    list_url: "/styles/dotwork/angel-sitting-on-a-moon-praying"
  },
  {
    url: "/styles/dotwork/angel-wings-and-a-rose-X7asKLPavFo1FywS2PFVyp",
    title: "angel wings and a rose",
    list_url: "/styles/dotwork/angel-wings-and-a-rose"
  },
  {
    url: "/styles/dotwork/angels-see-no-evil-hear-no-evil-speak-Rrefi2jNnGxMU2LryM4iGY",
    title: "angels see no evil hear no evil speak",
    list_url: "/styles/dotwork/angels-see-no-evil-hear-no-evil-speak"
  },
  {
    url: "/styles/dotwork/aquarius-and-leo-8YoaL8ytXhhiDXawrJNDGo",
    title: "aquarius and leo",
    list_url: "/styles/dotwork/aquarius-and-leo"
  },
  {
    url: "/styles/dotwork/bajra-STxpMUguSTASCyksBbarQB",
    title: "bajra",
    list_url: "/styles/dotwork/bajra"
  },
  {
    url: "/styles/dotwork/bible-verse-in-a-scroll-33kT1J5Lbxi7p1Ln3e57cd",
    title: "bible verse in a scroll",
    list_url: "/styles/dotwork/bible-verse-in-a-scroll"
  },
  {
    url: "/styles/dotwork/breast-cancer-ribbon-with-a-feather-UP21UUfAVzJy2Z1sMeAz85",
    title: "breast cancer ribbon with a feather",
    list_url: "/styles/dotwork/breast-cancer-ribbon-with-a-feather"
  },
  {
    url: "/styles/dotwork/christian-cross-with-proverbs-35-6-EcN953uAATymS8Uw1v9zuQ",
    title: "christian cross with proverbs ",
    list_url: "/styles/dotwork/christian-cross-with-proverbs-35-6"
  },
  {
    url: "/styles/dotwork/devi-X3YjoYxrjBfdYbTE7482YD",
    title: "devi",
    list_url: "/styles/dotwork/devi"
  },
  {
    url: "/styles/dotwork/ford-mustang-shelby-gt500-LMcA7EdTr1ucMc8ebTrbWn",
    title: "ford mustang shelby gt ",
    list_url: "/styles/dotwork/ford-mustang-shelby-gt500"
  },
  {
    url: "/styles/dotwork/get-rich-or-die-tryin-7XDspk9hvGrbZwujUz4EDf",
    title: "get rich or die tryin",
    list_url: "/styles/dotwork/get-rich-or-die-tryin"
  },
  {
    url: "/styles/dotwork/hammer-and-sickle-tattoo-communist-GrtiaSTq83rWbWNNYCqUaH",
    title: "hammer and sickle tattoo communist",
    list_url: "/styles/dotwork/hammer-and-sickle-tattoo-communist"
  },
  {
    url: "/styles/dotwork/inter-milan-logo-with-snake-37oFng1BbapkzacqvWFQCn",
    title: "inter milan logo with snake",
    list_url: "/styles/dotwork/inter-milan-logo-with-snake"
  },
  {
    url: "/styles/dotwork/jackie-HB6sjNHxdwrNot2wZNNbqw",
    title: "jackie",
    list_url: "/styles/dotwork/jackie"
  },
  {
    url: "/styles/dotwork/letters-l-and-m-NaHz2NtFBwCXgkgiaStNGV",
    title: "letters l and m",
    list_url: "/styles/dotwork/letters-l-and-m"
  },
  {
    url: "/styles/dotwork/marine-scout-sniper-6FSJV9MZdqqPYbN83Kinwm",
    title: "marine scout sniper",
    list_url: "/styles/dotwork/marine-scout-sniper"
  },
  {
    url: "/styles/dotwork/sirius-star-with-orions-belt-and-a-B3FwJg9kSP1MJNSiUaCG6h",
    title: "sirius star with orions belt and a",
    list_url: "/styles/dotwork/sirius-star-with-orions-belt-and-a"
  },
  {
    url: "/styles/dotwork/sumerian-anunnaki-symbol-intertwined-Jj3ptRYPT4su5qXWG6vaNC",
    title: "sumerian anunnaki symbol intertwined",
    list_url: "/styles/dotwork/sumerian-anunnaki-symbol-intertwined"
  },
  {
    url: "/styles/dotwork/yorkie-poo-dog-stained-glass-8WMA86x3cBGzmJqSoRjmTX",
    title: "yorkie poo dog stained glass",
    list_url: "/styles/dotwork/yorkie-poo-dog-stained-glass"
  },
  {
    url: "/styles/dotwork/zion-national-park-4XGShenu6TpM4DHbDa2H8N",
    title: "zion national park",
    list_url: "/styles/dotwork/zion-national-park"
  },
  {
    url: "/styles/geometric/a-compass-and-a-clock-YRxiSPpNskLwh2vv8yWNwW",
    title: "a compass and a clock",
    list_url: "/styles/geometric/a-compass-and-a-clock"
  },
  {
    url: "/styles/geometric/amazigh-moroccan-tribal-half-leg-men-YPecsugYa5dLpcpNFeMR6a",
    title: "amazigh moroccan tribal half leg men",
    list_url: "/styles/geometric/amazigh-moroccan-tribal-half-leg-men"
  },
  {
    url: "/styles/geometric/ashu-name-on-neck-CznkhC17voq3sihH6DyM7W",
    title: "ashu name on neck",
    list_url: "/styles/geometric/ashu-name-on-neck"
  },
  {
    url: "/styles/geometric/belgian-malinois-LUrF4KWvRs5Fu6Bry7hVLQ",
    title: "belgian malinois",
    list_url: "/styles/geometric/belgian-malinois"
  },
  {
    url: "/styles/geometric/compass-MnVfRvtU7tiXxH4TZ2MbR7",
    title: "compass",
    list_url: "/styles/geometric/compass"
  },
  {
    url: "/styles/geometric/dragon-8f8htGQMeimNhPKKQVEk3J",
    title: "dragon",
    list_url: "/styles/geometric/dragon"
  },
  {
    url: "/styles/geometric/sagittarius-compass-manly-T7aekR8xnq8qGAN19BZMV8",
    title: "sagittarius compass manly",
    list_url: "/styles/geometric/sagittarius-compass-manly"
  },
  {
    url: "/styles/japanese/bee-YBxu5eUHELw3Wnp52s99Z2",
    title: "bee",
    list_url: "/styles/japanese/bee"
  },
  {
    url: "/styles/japanese/cats-ninja-YS2Q6mMiMPp8BKK6qQSCLV",
    title: "cats ninja",
    list_url: "/styles/japanese/cats-ninja"
  },
  {
    url: "/styles/japanese/cherry-blossom-with-butterfly-6cfDjJRmdUFtx1p2pDuYEx",
    title: "cherry blossom with butterfly",
    list_url: "/styles/japanese/cherry-blossom-with-butterfly"
  },
  {
    url: "/styles/japanese/couple-tattoos-HPvtkngavtY2Vt3QadVAB2",
    title: "couple tattoos",
    list_url: "/styles/japanese/couple-tattoos"
  },
  {
    url: "/styles/japanese/hannya-mask-on-full-neck-CqYTMgbyra75XFuGwC8khs",
    title: "hannya mask on full neck",
    list_url: "/styles/japanese/hannya-mask-on-full-neck"
  },
  {
    url: "/styles/japanese/metin2-2jBeJHoEFg16rKbEDy71RD",
    title: "metin ",
    list_url: "/styles/japanese/metin2"
  },
  {
    url: "/styles/japanese/olive-branch-fire-cloud-wave-armband-RnCGeZnCjFAGv2ZR85NXXj",
    title: "olive branch fire cloud wave armband",
    list_url: "/styles/japanese/olive-branch-fire-cloud-wave-armband"
  },
  {
    url: "/styles/japanese/oni-mask-on-forearm-3c7irRENpEaVXy6JFdPdLK",
    title: "oni mask on forearm",
    list_url: "/styles/japanese/oni-mask-on-forearm"
  },
  {
    url: "/styles/japanese/rope-DRojyuyXGFEDgVfSeDkwS9",
    title: "rope",
    list_url: "/styles/japanese/rope"
  },
  {
    url: "/styles/japanese/samurai-frog-riding-on-turtle-back-FDjgKyyg7MRYwzGgK4vgTN",
    title: "samurai frog riding on turtle back",
    list_url: "/styles/japanese/samurai-frog-riding-on-turtle-back"
  },
  {
    url: "/styles/japanese/samurai-shoulder-armor-MSfjrmZvmSwj28aV68v9YS",
    title: "samurai shoulder armor",
    list_url: "/styles/japanese/samurai-shoulder-armor"
  },
  {
    url: "/styles/japanese/snake-5LGyts7UeHfmC5Px8eh9QQ",
    title: "snake",
    list_url: "/styles/japanese/snake"
  },
  {
    url: "/styles/japanese/sun-and-moon-JWLTSTNNxWqYsC1AoQFvCZ",
    title: "sun and moon",
    list_url: "/styles/japanese/sun-and-moon"
  },
  {
    url: "/styles/minimalist/1942-DRLNgvo3ktPrWhHzwzVJsL",
    title: " ",
    list_url: "/styles/minimalist/1942"
  },
  {
    url: "/styles/minimalist/a-minimalist-design-of-the-nofx-band-JzwGr6YVQUtqiwXHcgg7TF",
    title: "a minimalist design of the nofx band",
    list_url: "/styles/minimalist/a-minimalist-design-of-the-nofx-band"
  },
  {
    url: "/styles/minimalist/aiygiwgwy-aiydiwdwy-Lgv22uA6FsbZ4siQMHwCPS",
    title: "aiygiwgwy aiydiwdwy",
    list_url: "/styles/minimalist/aiygiwgwy-aiydiwdwy"
  },
  {
    url: "/styles/minimalist/alexander-the-great-Tz8gNNiiNDaXMPswJfu1vg",
    title: "alexander the great",
    list_url: "/styles/minimalist/alexander-the-great"
  },
  {
    url: "/styles/minimalist/angel-wings-with-semicolon-in-the-MuTT8UriqrSPqQrPzgr4tm",
    title: "angel wings with semicolon in the",
    list_url: "/styles/minimalist/angel-wings-with-semicolon-in-the"
  },
  {
    url: "/styles/minimalist/angel-wings-with-the-word-dad-memorial-XvMWPy2eiQ5GJDKGJnSKf",
    title: "angel wings with the word dad memorial",
    list_url: "/styles/minimalist/angel-wings-with-the-word-dad-memorial"
  },
  {
    url: "/styles/minimalist/anime-girl-big-cleavage-bikini-CUFsRoaqtcy8pgTsLrxmy4",
    title: "anime girl big cleavage bikini",
    list_url: "/styles/minimalist/anime-girl-big-cleavage-bikini"
  },
  {
    url: "/styles/minimalist/aphrodite-and-athena-symbol-6nRZgfEBVNEZnMmKstFzhg",
    title: "aphrodite and athena symbol",
    list_url: "/styles/minimalist/aphrodite-and-athena-symbol"
  },
  {
    url: "/styles/minimalist/artemis-and-apollo-NBG8gFy8tcDirudFqsXYPB",
    title: "artemis and apollo",
    list_url: "/styles/minimalist/artemis-and-apollo"
  },
  {
    url: "/styles/minimalist/bacchus-GYaMcnwBB9oV6LuXypbRue",
    title: "bacchus",
    list_url: "/styles/minimalist/bacchus"
  },
  {
    url: "/styles/minimalist/broken-compass-TyfAwNX3vMqfRRDc2pSUJA",
    title: "broken compass",
    list_url: "/styles/minimalist/broken-compass"
  },
  {
    url: "/styles/minimalist/californication-M8g1UUVDXP2njts49gsXHs",
    title: "californication",
    list_url: "/styles/minimalist/californication"
  },
  {
    url: "/styles/minimalist/car-AwJJYwy8E3RiXLJYg5o7Gr",
    title: "car",
    list_url: "/styles/minimalist/car"
  },
  {
    url: "/styles/minimalist/cartoon-ghost-with-middle-finger-VXGKPpHVFJRgUvdCvyZyG2",
    title: "cartoon ghost with middle finger",
    list_url: "/styles/minimalist/cartoon-ghost-with-middle-finger"
  },
  {
    url: "/styles/minimalist/celtic-grandmother-knot-symbol-CgSqJstda49MVc2q9NdnCm",
    title: "celtic grandmother knot symbol",
    list_url: "/styles/minimalist/celtic-grandmother-knot-symbol"
  },
  {
    url: "/styles/minimalist/conch-shell-4KaZf3LjchQufzD7DAMySi",
    title: "conch shell",
    list_url: "/styles/minimalist/conch-shell"
  },
  {
    url: "/styles/minimalist/consider-the-lilies-of-the-field-how-GH4awqarqjaET9YBJ2uVWw",
    title: "consider the lilies of the field how",
    list_url: "/styles/minimalist/consider-the-lilies-of-the-field-how"
  },
  {
    url: "/styles/minimalist/cursive-letter-s-tattoo-RvvF3f9MsTm7F8destmG7r",
    title: "cursive letter s tattoo",
    list_url: "/styles/minimalist/cursive-letter-s-tattoo"
  },
  {
    url: "/styles/minimalist/d-and-c-letter-7k77FBQhEnevJLF8o3CNvD",
    title: "d and c letter",
    list_url: "/styles/minimalist/d-and-c-letter"
  },
  {
    url: "/styles/minimalist/d-m-initials-8XNwrKx6VfSwUexMEZEaGx",
    title: "d m initials",
    list_url: "/styles/minimalist/d-m-initials"
  },
  {
    url: "/styles/minimalist/forget-me-not-and-poppy-flower-black-Kb7G7RswmUWWw4L1kWxzC",
    title: "forget me not and poppy flower black",
    list_url: "/styles/minimalist/forget-me-not-and-poppy-flower-black"
  },
  {
    url: "/styles/minimalist/girl-friend-name-sneha-roses-and-love-VYqSSjiF2uY2XsQG4Y7wUH",
    title: "girl friend name sneha roses and love",
    list_url: "/styles/minimalist/girl-friend-name-sneha-roses-and-love"
  },
  {
    url: "/styles/minimalist/half-the-world-away-NVQcQQFFyDzASdf3yspreH",
    title: "half the world away",
    list_url: "/styles/minimalist/half-the-world-away"
  },
  {
    url: "/styles/minimalist/infinity-symbol-with-rose-carnation-BqU5gmc5h2bQknyWCXnqjc",
    title: "infinity symbol with rose carnation",
    list_url: "/styles/minimalist/infinity-symbol-with-rose-carnation"
  },
  {
    url: "/styles/minimalist/larkspur-lily-of-the-valley-aster-RCJKpeR8eyirtfEziiB4VZ",
    title: "larkspur lily of the valley aster",
    list_url: "/styles/minimalist/larkspur-lily-of-the-valley-aster"
  },
  {
    url: "/styles/minimalist/letter-s-and-c-M1ULf83biwAkH1RR3BeJUd",
    title: "letter s and c",
    list_url: "/styles/minimalist/letter-s-and-c"
  },
  {
    url: "/styles/minimalist/live-like-you-were-dying-by-tim-mcgraw-6puZ4xPToiegMmgSNQJbyh",
    title: "live like you were dying by tim mcgraw",
    list_url: "/styles/minimalist/live-like-you-were-dying-by-tim-mcgraw"
  },
  {
    url: "/styles/minimalist/lizzy-mcalpine-ceilings-simple-BCdh7GKdxYeQWy8oSXAVZt",
    title: "lizzy mcalpine ceilings simple",
    list_url: "/styles/minimalist/lizzy-mcalpine-ceilings-simple"
  },
  {
    url: "/styles/minimalist/minecraft-ender-dragon-JBPpD7g5z3koTAMuR3rCxw",
    title: "minecraft ender dragon",
    list_url: "/styles/minimalist/minecraft-ender-dragon"
  },
  {
    url: "/styles/minimalist/mukti-Hv8EdN6EcaHa3otB2tcuZq",
    title: "mukti",
    list_url: "/styles/minimalist/mukti"
  },
  {
    url: "/styles/minimalist/radiohead-in-rainbows-XB7b44yTyfPLaXzNqHiBRR",
    title: "radiohead in rainbows",
    list_url: "/styles/minimalist/radiohead-in-rainbows"
  },
  {
    url: "/styles/minimalist/rose-daisy-and-sunflower-UyHeyvi6r9kM6s2K7c3q1g",
    title: "rose daisy and sunflower",
    list_url: "/styles/minimalist/rose-daisy-and-sunflower"
  },
  {
    url: "/styles/minimalist/single-red-rose-line-art-tattoo-simple-WL3gPEXzmTAFqQerZjPhdq",
    title: "single red rose line art tattoo simple",
    list_url: "/styles/minimalist/single-red-rose-line-art-tattoo-simple"
  },
  {
    url: "/styles/minimalist/sydney-opera-house-and-kiwi-bird-WC44UksvjSgzAC7usQWVU5",
    title: "sydney opera house and kiwi bird",
    list_url: "/styles/minimalist/sydney-opera-house-and-kiwi-bird"
  },
  {
    url: "/styles/minimalist/table-mountain-south-africa-CppPJx2iBfwhUjTy9TX2z",
    title: "table mountain south africa",
    list_url: "/styles/minimalist/table-mountain-south-africa"
  },
  {
    url: "/styles/minimalist/tara-VWKyiTa55CKanyFsZYSE2H",
    title: "tara",
    list_url: "/styles/minimalist/tara"
  },
  {
    url: "/styles/minimalist/tattoo-with-3-initials-m-b-and-m-letter-6ExM6uYDjBLXDEawKGPJ6T",
    title: "tattoo with initials m b and m letter",
    list_url: "/styles/minimalist/tattoo-with-3-initials-m-b-and-m-letter"
  },
  {
    url: "/styles/minimalist/teddy-bear-holding-a-flower-EmTzwB5BLx19Cn9xkpkSwv",
    title: "teddy bear holding a flower",
    list_url: "/styles/minimalist/teddy-bear-holding-a-flower"
  },
  {
    url: "/styles/minimalist/the-letters-tk-on-finger-Cc1feaGYg54xDgx9gk81fp",
    title: "the letters tk on finger",
    list_url: "/styles/minimalist/the-letters-tk-on-finger"
  },
  {
    url: "/styles/minimalist/the-name-hafsa-in-urdu-764YhhQJy3wGKPLKaCBUgJ",
    title: "the name hafsa in urdu",
    list_url: "/styles/minimalist/the-name-hafsa-in-urdu"
  },
  {
    url: "/styles/minimalist/theres-escape-in-escaping-UwqYKRCSecVy9UsHetHB5n",
    title: "theres escape in escaping",
    list_url: "/styles/minimalist/theres-escape-in-escaping"
  },
  {
    url: "/styles/minimalist/trust-the-process-cursive-writing-8B2UjofgxP5X3abPQsczVA",
    title: "trust the process cursive writing",
    list_url: "/styles/minimalist/trust-the-process-cursive-writing"
  },
  {
    url: "/styles/minimalist/two-sisters-and-a-brother-4Gd2WH3GjgAeabBFCmpXfe",
    title: "two sisters and a brother",
    list_url: "/styles/minimalist/two-sisters-and-a-brother"
  },
  {
    url: "/styles/minimalist/xanax-JPyWvRNuG1JhDx6YRGo56",
    title: "xanax",
    list_url: "/styles/minimalist/xanax"
  },
  {
    url: "/styles/minimalist/yucca-flower-KoyRaAXRFsAkf9FcZxuhw7",
    title: "yucca flower",
    list_url: "/styles/minimalist/yucca-flower"
  },
  {
    url: "/styles/minimalist/zipper-PuxUrCovXVx2QLeY7eE1DP",
    title: "zipper",
    list_url: "/styles/minimalist/zipper"
  },
  {
    url: "/styles/neotraditional/airsoft-guns-VdEmihaLmkCJjUnzPfydAU",
    title: "airsoft guns",
    list_url: "/styles/neotraditional/airsoft-guns"
  },
  {
    url: "/styles/neotraditional/based-on-the-song-champagne-coast-by-385aY9KvKE95S22rM8AT7n",
    title: "based on the song champagne coast by",
    list_url: "/styles/neotraditional/based-on-the-song-champagne-coast-by"
  },
  {
    url: "/styles/neotraditional/blade-marvel-comics-U4xXXwVGnRAtvDo9dcVpPq",
    title: "blade marvel comics",
    list_url: "/styles/neotraditional/blade-marvel-comics"
  },
  {
    url: "/styles/neotraditional/buddha-and-his-elephant-JAxNniB6geJCnYVcvdsjP7",
    title: "buddha and his elephant",
    list_url: "/styles/neotraditional/buddha-and-his-elephant"
  },
  {
    url: "/styles/neotraditional/cross-with-lily-flower-72TVUSZWBMrAh2zFyjYrVk",
    title: "cross with lily flower",
    list_url: "/styles/neotraditional/cross-with-lily-flower"
  },
  {
    url: "/styles/neotraditional/cross-with-words-let-go-let-god-CXz8omaNhJnin5pZU1VdqN",
    title: "cross with words let go let god",
    list_url: "/styles/neotraditional/cross-with-words-let-go-let-god"
  },
  {
    url: "/styles/neotraditional/curly-red-haired-pin-up-girl-standing-UA4MeTa3es94H26xJkpTMR",
    title: "curly red haired pin up girl standing",
    list_url: "/styles/neotraditional/curly-red-haired-pin-up-girl-standing"
  },
  {
    url: "/styles/neotraditional/deepak-4bDuhTbuVquahH9AYmEk94",
    title: "deepak",
    list_url: "/styles/neotraditional/deepak"
  },
  {
    url: "/styles/neotraditional/desert-storm-veteran-WKeVayThSXnxnG7Q2pEhXu",
    title: "desert storm veteran",
    list_url: "/styles/neotraditional/desert-storm-veteran"
  },
  {
    url: "/styles/neotraditional/he-fought-like-hell-to-keep-the-wolves-KhBaGLvR8VTZgQANCG2Hnu",
    title: "he fought like hell to keep the wolves",
    list_url: "/styles/neotraditional/he-fought-like-hell-to-keep-the-wolves"
  },
  {
    url: "/styles/neotraditional/holly-flowers-daisy-flower-567x8QmmTjYwP6cH4drF6Z",
    title: "holly flowers daisy flower",
    list_url: "/styles/neotraditional/holly-flowers-daisy-flower"
  },
  {
    url: "/styles/neotraditional/jackalope-YQZ6ENDHMvT7HYxZhEgQp9",
    title: "jackalope",
    list_url: "/styles/neotraditional/jackalope"
  },
  {
    url: "/styles/neotraditional/jaidev-name-6ZrD4Me9hVWGvrvb56P2Lm",
    title: "jaidev name",
    list_url: "/styles/neotraditional/jaidev-name"
  },
  {
    url: "/styles/neotraditional/kickboxing-ADwmtzjmfpNDzvQ5wXrpwo",
    title: "kickboxing",
    list_url: "/styles/neotraditional/kickboxing"
  },
  {
    url: "/styles/neotraditional/letter-j-and-e-forming-a-heart-shape-GWNtxBRBgnRZYNkMW92Vsi",
    title: "letter j and e forming a heart shape",
    list_url: "/styles/neotraditional/letter-j-and-e-forming-a-heart-shape"
  },
  {
    url: "/styles/neotraditional/letters-s-r-LzwYsQzUnzX7csfDZxjQzv",
    title: "letters s r",
    list_url: "/styles/neotraditional/letters-s-r"
  },
  {
    url: "/styles/neotraditional/liverpool-fc-emblem-and-crystal-palace-5E3VPiCLB5Uhh8SnaamUXi",
    title: "liverpool fc emblem and crystal palace",
    list_url: "/styles/neotraditional/liverpool-fc-emblem-and-crystal-palace"
  },
  {
    url: "/styles/neotraditional/lotus-flower-and-dream-catcher-81efeJkrCnrmaUtcj7fCUx",
    title: "lotus flower and dream catcher",
    list_url: "/styles/neotraditional/lotus-flower-and-dream-catcher"
  },
  {
    url: "/styles/neotraditional/mustang-p51-mustang-plane-Fdf4NBHr6X9Jr1pWtDZJdW",
    title: "mustang p mustang plane",
    list_url: "/styles/neotraditional/mustang-p51-mustang-plane"
  },
  {
    url: "/styles/neotraditional/olivia-name-QQz96hgnqQKsVi1jTASLBv",
    title: "olivia name",
    list_url: "/styles/neotraditional/olivia-name"
  },
  {
    url: "/styles/neotraditional/outline-of-mountains-with-montani-SdEcz9GBXJQjJGSw9iRKGT",
    title: "outline of mountains with montani",
    list_url: "/styles/neotraditional/outline-of-mountains-with-montani"
  },
  {
    url: "/styles/neotraditional/pene-MFrvTJN8VGzBMzAMPudXFJ",
    title: "pene",
    list_url: "/styles/neotraditional/pene"
  },
  {
    url: "/styles/neotraditional/protect-your-peace-XpRoWC35foXnQZNbc7djg",
    title: "protect your peace",
    list_url: "/styles/neotraditional/protect-your-peace"
  },
  {
    url: "/styles/neotraditional/raven-on-snake-7iQk3NqDtuLKJLY8uycVri",
    title: "raven on snake",
    list_url: "/styles/neotraditional/raven-on-snake"
  },
  {
    url: "/styles/neotraditional/saint-michael-with-a-machine-gun-7YePUgH794bgs5c4mZDTCj",
    title: "saint michael with a machine gun",
    list_url: "/styles/neotraditional/saint-michael-with-a-machine-gun"
  },
  {
    url: "/styles/neotraditional/sauron-2AFZzNP2SeYuKyi5qyPf8Z",
    title: "sauron",
    list_url: "/styles/neotraditional/sauron"
  },
  {
    url: "/styles/neotraditional/sidhu-moosewala-NgGwC9PHoWzBLc66Rdyazn",
    title: "sidhu moosewala",
    list_url: "/styles/neotraditional/sidhu-moosewala"
  },
  {
    url: "/styles/neotraditional/two-family-names-on-chest-tattoo-HtPME9UHv2oHyD6SqTWqkq",
    title: "two family names on chest tattoo",
    list_url: "/styles/neotraditional/two-family-names-on-chest-tattoo"
  },
  {
    url: "/styles/neotraditional/virat-kohli-Ba7Fgvu8qRaF7fcy8nzEYA",
    title: "virat kohli",
    list_url: "/styles/neotraditional/virat-kohli"
  },
  {
    url: "/styles/new-school/grandmother-an-granddaughter-5pRjHZGkULMR517jiMG3RQ",
    title: "grandmother an granddaughter",
    list_url: "/styles/new-school/grandmother-an-granddaughter"
  },
  {
    url: "/styles/realism/celtic-bull-5NBjhDRfZUj1XfzQhyA37C",
    title: "celtic bull",
    list_url: "/styles/realism/celtic-bull"
  },
  {
    url: "/styles/realism/crystal-name-written-with-daisy-flower-GuronCuTrETFQsmL63mGbT",
    title: "crystal name written with daisy flower",
    list_url: "/styles/realism/crystal-name-written-with-daisy-flower"
  },
  {
    url: "/styles/realism/disney-stitch-on-a-motorbike-racing-A7nccyftGTXtzcU3rPX4xR",
    title: "disney stitch on a motorbike racing",
    list_url: "/styles/realism/disney-stitch-on-a-motorbike-racing"
  },
  {
    url: "/styles/realism/femdom-figure-5AU52G3oeqzDouJrYkdSEa",
    title: "femdom figure",
    list_url: "/styles/realism/femdom-figure"
  },
  {
    url: "/styles/realism/happy-and-sad-mask-BFNLpCqsD7ZL8SU9mk36aN",
    title: "happy and sad mask",
    list_url: "/styles/realism/happy-and-sad-mask"
  },
  {
    url: "/styles/realism/harley-davidson-motorcycle-with-wings-HZpvzuczGpMXkthSxZByEp",
    title: "harley davidson motorcycle with wings",
    list_url: "/styles/realism/harley-davidson-motorcycle-with-wings"
  },
  {
    url: "/styles/realism/jesus-christ-holding-a-ak-47-rifle-GTzqqMeg8s61S1kHkXVrKY",
    title: "jesus christ holding a ak rifle",
    list_url: "/styles/realism/jesus-christ-holding-a-ak-47-rifle"
  },
  {
    url: "/styles/realism/lamborghini-VkUGjZvwEPAFPmzV5r8N16",
    title: "lamborghini",
    list_url: "/styles/realism/lamborghini"
  },
  {
    url: "/styles/realism/leg-sleeve-mountains-trees-8M1cd8ALH4WZ67fek2uiR4",
    title: "leg sleeve mountains trees",
    list_url: "/styles/realism/leg-sleeve-mountains-trees"
  },
  {
    url: "/styles/realism/maharana-pratap-3HG7zNMCHVpXDuQ1fqvGgh",
    title: "maharana pratap",
    list_url: "/styles/realism/maharana-pratap"
  },
  {
    url: "/styles/realism/mercedes-name-with-roses-in-cursive-Fyi9sqDwKug7KieihoaBtB",
    title: "mercedes name with roses in cursive",
    list_url: "/styles/realism/mercedes-name-with-roses-in-cursive"
  },
  {
    url: "/styles/realism/new-york-build-new-york-knicks-RNFNcthc5UnFnBBJY9uVA1",
    title: "new york build new york knicks",
    list_url: "/styles/realism/new-york-build-new-york-knicks"
  },
  {
    url: "/styles/realism/nigga-JEmicHTiAJL7rEqvo6uzbc",
    title: "nigga",
    list_url: "/styles/realism/nigga"
  },
  {
    url: "/styles/realism/odins-ravens-wolves-and-tree-of-life-AzXeGFM2L8NG7uk1sK4BFt",
    title: "odins ravens wolves and tree of life",
    list_url: "/styles/realism/odins-ravens-wolves-and-tree-of-life"
  },
  {
    url: "/styles/realism/poseidon-zeus-hades-Fhm8ywn3vZcHapvWDnxZ1L",
    title: "poseidon zeus hades",
    list_url: "/styles/realism/poseidon-zeus-hades"
  },
  {
    url: "/styles/realism/scarface-tony-montana-3iJm5ZpWPgD1g6UHmTRZAN",
    title: "scarface tony montana",
    list_url: "/styles/realism/scarface-tony-montana"
  },
  {
    url: "/styles/realism/silhouette-dad-and-son-on-the-beach-at-Et3XZzawCeJrv9dXSXm9aY",
    title: "silhouette dad and son on the beach at",
    list_url: "/styles/realism/silhouette-dad-and-son-on-the-beach-at"
  },
  {
    url: "/styles/realism/sun-rays-shining-through-clouds-6qgKozp44y5hSKjpLZ17NU",
    title: "sun rays shining through clouds",
    list_url: "/styles/realism/sun-rays-shining-through-clouds"
  },
  {
    url: "/styles/realism/vishnu-shiva-Gdwczact6pgwvwkjJf6VF",
    title: "vishnu shiva",
    list_url: "/styles/realism/vishnu-shiva"
  },
  {
    url: "/styles/realism/yemaya-orisha-upper-arm-MyYMztPDzu29Qe4i9KxroR",
    title: "yemaya orisha upper arm",
    list_url: "/styles/realism/yemaya-orisha-upper-arm"
  },
  {
    url: "/styles/sketch/barbed-wire-and-flower-2ESbbXeNEJGDQvsueWp8YC",
    title: "barbed wire and flower",
    list_url: "/styles/sketch/barbed-wire-and-flower"
  },
  {
    url: "/styles/sketch/comparison-is-the-thief-of-joy-T9XwKhEnW2kqCJ1WoVU1wV",
    title: "comparison is the thief of joy",
    list_url: "/styles/sketch/comparison-is-the-thief-of-joy"
  },
  {
    url: "/styles/sketch/flower-with-name-R1W3RQfyz2tX4nLyVZQ8B5",
    title: "flower with name",
    list_url: "/styles/sketch/flower-with-name"
  },
  {
    url: "/styles/sketch/forearm-design-with-names-sonu-YMpyJaAoYWtpCUj9qeD8Xg",
    title: "forearm design with names sonu",
    list_url: "/styles/sketch/forearm-design-with-names-sonu"
  },
  {
    url: "/styles/sketch/goldfinch-RQ3QpAPrrfQSDzrbXQJaj8",
    title: "goldfinch",
    list_url: "/styles/sketch/goldfinch"
  },
  {
    url: "/styles/sketch/heart-with-letters-vd-PH5a3Ebzq4S7iDbmWprAVf",
    title: "heart with letters vd",
    list_url: "/styles/sketch/heart-with-letters-vd"
  },
  {
    url: "/styles/sketch/pavani-adarsh-ThK3KCVkRjSo8DLLAa6s7W",
    title: "pavani adarsh",
    list_url: "/styles/sketch/pavani-adarsh"
  },
  {
    url: "/styles/sketch/rose-with-chain-S5nbBiGuFWkZFYTkZ6kqV4",
    title: "rose with chain",
    list_url: "/styles/sketch/rose-with-chain"
  },
  {
    url: "/styles/sketch/tatoo-in-which-letter-s-and-d-are-KEjY9vBjfCDCGuo69L3Tgu",
    title: "tatoo in which letter s and d are",
    list_url: "/styles/sketch/tatoo-in-which-letter-s-and-d-are"
  },
  {
    url: "/styles/sketch/tea-cup-on-books-WBeNLWzqvJMvrSedoN4ekF",
    title: "tea cup on books",
    list_url: "/styles/sketch/tea-cup-on-books"
  },
  {
    url: "/styles/sketch/wattle-RQeoeA5wU6vFcGLgbsSDbh",
    title: "wattle",
    list_url: "/styles/sketch/wattle"
  },
  {
    url: "/styles/stencil/luffy-UEvVfuFEyodYgT5F7TnRkp",
    title: "luffy",
    list_url: "/styles/stencil/luffy"
  },
  {
    url: "/styles/surrealism/salsa-dancers-RTzFTGd5R4WQVGYWMjHBCk",
    title: "salsa dancers",
    list_url: "/styles/surrealism/salsa-dancers"
  },
  {
    url: "/styles/traditional/endometrial-cancer-awareness-ribbon-RyssWRLyeL37VTz52Ce93Y",
    title: "endometrial cancer awareness ribbon",
    list_url: "/styles/traditional/endometrial-cancer-awareness-ribbon"
  },
  {
    url: "/styles/traditional/god-country-corps-pray-for-war-UKzTRVpEVzaXQ28XuVkQ1v",
    title: "god country corps pray for war",
    list_url: "/styles/traditional/god-country-corps-pray-for-war"
  },
  {
    url: "/styles/traditional/initials-j-w-Dmfc3c4P9wQiX739DPnn5i",
    title: "initials j w",
    list_url: "/styles/traditional/initials-j-w"
  },
  {
    url: "/styles/traditional/june-bug-BycdKGFFXqvUcWoyeAGSah",
    title: "june bug",
    list_url: "/styles/traditional/june-bug"
  },
  {
    url: "/styles/traditional/memento-mori-with-jesus-christ-on-the-MFHBjbcUc9KLAnNummoksE",
    title: "memento mori with jesus christ on the",
    list_url: "/styles/traditional/memento-mori-with-jesus-christ-on-the"
  },
  {
    url: "/styles/traditional/mexican-women-with-sombrero-and-a-75F6jQN5bUBt285DFHMfFf",
    title: "mexican women with sombrero and a",
    list_url: "/styles/traditional/mexican-women-with-sombrero-and-a"
  },
  {
    url: "/styles/traditional/octopus-with-diving-helmet-K1m3Q9mCTqgngKX1NLy8gD",
    title: "octopus with diving helmet",
    list_url: "/styles/traditional/octopus-with-diving-helmet"
  },
  {
    url: "/styles/traditional/roman-numerals-12-14-and-22-D7khApC912TzDcxWuhRf4M",
    title: "roman numerals and ",
    list_url: "/styles/traditional/roman-numerals-12-14-and-22"
  },
  {
    url: "/styles/traditional/wolf-with-roses-in-mouth-opposite-wolf-VGNV6KVRE2Lng92fqvkD99",
    title: "wolf with roses in mouth opposite wolf",
    list_url: "/styles/traditional/wolf-with-roses-in-mouth-opposite-wolf"
  },
  {
    url: "/styles/tribal/aztec-mexican-armband-9nLwYZvstUKMacaLftauSe",
    title: "aztec mexican armband",
    list_url: "/styles/tribal/aztec-mexican-armband"
  },
  {
    url: "/styles/tribal/classroom-of-the-elite-Cb7TaE6NVTEwpU1gSPrZHt",
    title: "classroom of the elite",
    list_url: "/styles/tribal/classroom-of-the-elite"
  },
  {
    url: "/styles/tribal/ilocano-tribal-trdT4FWPzGsQL8LnHrYyb",
    title: "ilocano tribal",
    list_url: "/styles/tribal/ilocano-tribal"
  },
  {
    url: "/styles/tribal/sierra-leone-JmT9gexYt9T2nsC3xTZfQV",
    title: "sierra leone",
    list_url: "/styles/tribal/sierra-leone"
  },
  {
    url: "/styles/tribal/three-skulls-covering-eyes-mouth-and-6qyjFdJkETo2nE72n1zs9f",
    title: "three skulls covering eyes mouth and",
    list_url: "/styles/tribal/three-skulls-covering-eyes-mouth-and"
  },
  {
    url: "/styles/tribal/xxx-iii-tatoo-DRiSg2da9nstRUPB3yAzCn",
    title: "xxx iii tatoo",
    list_url: "/styles/tribal/xxx-iii-tatoo"
  },
  {
    url: "/styles/abstract/goth-girl-bbw-pinup-girl-5wsZtb39LEeK47rz5yx32L",
    title: "goth girl bbw pinup girl",
    list_url: "/styles/abstract/goth-girl-bbw-pinup-girl"
  },
  {
    url: "/styles/anime/kaiser-blue-lock-CkZkg45UESHBxMn9kfd9u6",
    title: "kaiser blue lock",
    list_url: "/styles/anime/kaiser-blue-lock"
  },
  {
    url: "/styles/anime/mordekaiser-nRLQ9diXnkQkXGZ9RMebe",
    title: "mordekaiser",
    list_url: "/styles/anime/mordekaiser"
  },
  {
    url: "/styles/black-grey",
    title: "black",
    list_url: "/styles/black"
  },
  {
    url: "/styles/black-grey/a-detailed-anatomical-heart-with-gears-DVkfbW4eEgNTnmRxFFWpsD",
    title: "a detailed anatomical heart with gears",
    list_url: "/styles/black-grey/a-detailed-anatomical-heart-with-gears"
  },
  {
    url: "/styles/black-grey/a-portrait-of-a-strong-female-warrior-FAw6YDrs6HMwZxsHEVQY2t",
    title: "a portrait of a strong female warrior",
    list_url: "/styles/black-grey/a-portrait-of-a-strong-female-warrior"
  },
  {
    url: "/styles/black-grey/african-sunset-with-elephant-UyHWiJUUkyW7HUfUHfgCJz",
    title: "african sunset with elephant",
    list_url: "/styles/black-grey/african-sunset-with-elephant"
  },
  {
    url: "/styles/black-grey/alan-wake-2-control-KW2pMg78bRDGgPvyLVC5Vr",
    title: "alan wake control",
    list_url: "/styles/black-grey/alan-wake-2-control"
  },
  {
    url: "/styles/black-grey/amandeep-kaur-6nvx3R2KP1HKzK1eqcWDSa",
    title: "amandeep kaur",
    list_url: "/styles/black-grey/amandeep-kaur"
  },
  {
    url: "/styles/black-grey/angel-wings-with-finger-print-in-middle-4YFo36TWadyTZKftoaoFcA",
    title: "angel wings with finger print in middle",
    list_url: "/styles/black-grey/angel-wings-with-finger-print-in-middle"
  },
  {
    url: "/styles/black-grey/angel-with-an-ak-47-4UkfVB7t7yPFu924AD1XK",
    title: "angel with an ak ",
    list_url: "/styles/black-grey/angel-with-an-ak-47"
  },
  {
    url: "/styles/black-grey/angry-sun-and-fire-aura-PpGKKSXLWzaeoFiEqTQGzr",
    title: "angry sun and fire aura",
    list_url: "/styles/black-grey/angry-sun-and-fire-aura"
  },
  {
    url: "/styles/black-grey/archangel-michael-and-gabriel-Lix2XGTt8e6LFPAj2bauUi",
    title: "archangel michael and gabriel",
    list_url: "/styles/black-grey/archangel-michael-and-gabriel"
  },
  {
    url: "/styles/black-grey/bat-with-flowers-HR9bR2cidwSbY3yqwYwJNZ",
    title: "bat with flowers",
    list_url: "/styles/black-grey/bat-with-flowers"
  },
  {
    url: "/styles/black-grey/bible-verse-jeremiah-2911-cursive-font-BjnYQh7QGsEhUQir7aEeiU",
    title: "bible verse jeremiah cursive font",
    list_url: "/styles/black-grey/bible-verse-jeremiah-2911-cursive-font"
  },
  {
    url: "/styles/black-grey/biomech-bionic-cyborg-arm-shoulder-and-WabxkYbDivg1Lh3zPfB8wk",
    title: "biomech bionic cyborg arm shoulder and",
    list_url: "/styles/black-grey/biomech-bionic-cyborg-arm-shoulder-and"
  },
  {
    url: "/styles/black-grey/born-to-die-cursive-lana-del-rey-DMwTmw6rpzJbtLBhfXKDQF",
    title: "born to die cursive lana del rey",
    list_url: "/styles/black-grey/born-to-die-cursive-lana-del-rey"
  },
  {
    url: "/styles/black-grey/butterfly-landing-on-flower-NxWHEPpf4KVtSHpJWNJ9UR",
    title: "butterfly landing on flower",
    list_url: "/styles/black-grey/butterfly-landing-on-flower"
  },
  {
    url: "/styles/black-grey/cabin-in-the-woods-UvNyPxz8youuiHWNa63Qdz",
    title: "cabin in the woods",
    list_url: "/styles/black-grey/cabin-in-the-woods"
  },
  {
    url: "/styles/black-grey/children-holding-hands-3-girls-1-boy-MDC8Lav4vJ6rrpAuV1ByfV",
    title: "children holding hands girls boy",
    list_url: "/styles/black-grey/children-holding-hands-3-girls-1-boy"
  },
  {
    url: "/styles/black-grey/chrysanthemum-peonylily-of-the-valley-55dxwNyuxwaJGroDv63xPu",
    title: "chrysanthemum peonylily of the valley",
    list_url: "/styles/black-grey/chrysanthemum-peonylily-of-the-valley"
  },
  {
    url: "/styles/black-grey/crow-feather-2KSHdosyxSYThVfbdNotxm",
    title: "crow feather",
    list_url: "/styles/black-grey/crow-feather"
  },
  {
    url: "/styles/black-grey/dale-earnhardt-number-3-crosses-and-RNygqktm9HQJQLTmUr4G3J",
    title: "dale earnhardt number crosses and",
    list_url: "/styles/black-grey/dale-earnhardt-number-3-crosses-and"
  },
  {
    url: "/styles/black-grey/dark-romance-books-surrounded-by-florals-2hTNu9EGARuqNd4aeupuq8",
    title: "dark romance books surrounded by florals",
    list_url: "/styles/black-grey/dark-romance-books-surrounded-by-florals"
  },
  {
    url: "/styles/black-grey/daylily-LWEzud9XYecSKxoqmwUD61",
    title: "daylily",
    list_url: "/styles/black-grey/daylily"
  },
  {
    url: "/styles/black-grey/dhanashree-name-tattoo-in-roman-letters-Ey2kKF8fTnwxXysni7fBKE",
    title: "dhanashree name tattoo in roman letters",
    list_url: "/styles/black-grey/dhanashree-name-tattoo-in-roman-letters"
  },
  {
    url: "/styles/black-grey/diamonds-in-the-trees-pentagrams-in-the-N2MD7Dd4zmvSzQMx9CdjJx",
    title: "diamonds in the trees pentagrams in the",
    list_url: "/styles/black-grey/diamonds-in-the-trees-pentagrams-in-the"
  },
  {
    url: "/styles/black-grey/dove-memorial-L831dXAiWuLk9HktqNha9z",
    title: "dove memorial",
    list_url: "/styles/black-grey/dove-memorial"
  },
  {
    url: "/styles/black-grey/eureka-stockade-flag-with-australian-UbzLwTLUX7z6bUR6ExMYHD",
    title: "eureka stockade flag with australian",
    list_url: "/styles/black-grey/eureka-stockade-flag-with-australian"
  },
  {
    url: "/styles/black-grey/evil-skull-4BcfpS3ECtwK85jQiWS4bQ",
    title: "evil skull",
    list_url: "/styles/black-grey/evil-skull"
  },
  {
    url: "/styles/black-grey/female-shoulder-tattoo-including-floral-GrcNH1YmztdRDzRPrGTVjk",
    title: "female shoulder tattoo including floral",
    list_url: "/styles/black-grey/female-shoulder-tattoo-including-floral"
  },
  {
    url: "/styles/black-grey/femboy-6pVaFdEuqmZfXykNuFMqt2",
    title: "femboy",
    list_url: "/styles/black-grey/femboy"
  },
  {
    url: "/styles/black-grey/florence-nightingale-lantern-shining-KHkecLkGyCVp8Ru6WGqtja",
    title: "florence nightingale lantern shining",
    list_url: "/styles/black-grey/florence-nightingale-lantern-shining"
  },
  {
    url: "/styles/black-grey/flowers-skulls-butterflies-VqXc2VDSYeEhhmbPw3Sxdf",
    title: "flowers skulls butterflies",
    list_url: "/styles/black-grey/flowers-skulls-butterflies"
  },
  {
    url: "/styles/black-grey/ganesha-with-lotus-flower-DVbp1ztH4C5k6sxJPCzRtg",
    title: "ganesha with lotus flower",
    list_url: "/styles/black-grey/ganesha-with-lotus-flower"
  },
  {
    url: "/styles/black-grey/garcia-coat-of-arms-strength-family-7m4hqfXcwE1kC8QqeMFnWS",
    title: "garcia coat of arms strength family",
    list_url: "/styles/black-grey/garcia-coat-of-arms-strength-family"
  },
  {
    url: "/styles/black-grey/gay-bear-culture-NFWVviAS741B7yWgQtZqRr",
    title: "gay bear culture",
    list_url: "/styles/black-grey/gay-bear-culture"
  },
  {
    url: "/styles/black-grey/god-is-my-judge-FFSzF8YGRMSdf193BjFBdR",
    title: "god is my judge",
    list_url: "/styles/black-grey/god-is-my-judge"
  },
  {
    url: "/styles/black-grey/greek-god-pan-7akyuxYjJq5K11GA8CvmqZ",
    title: "greek god pan",
    list_url: "/styles/black-grey/greek-god-pan"
  },
  {
    url: "/styles/black-grey/harry-potter-dementor-LhyC1piC1QvprHYc9SX49E",
    title: "harry potter dementor",
    list_url: "/styles/black-grey/harry-potter-dementor"
  },
  {
    url: "/styles/black-grey/indica-cannabis-flowers-RSvzQsEvKJkaJPurPZkdQ3",
    title: "indica cannabis flowers",
    list_url: "/styles/black-grey/indica-cannabis-flowers"
  },
  {
    url: "/styles/black-grey/initials-jb-AKcRft8Yjf1NoYKWdpkirk",
    title: "initials jb",
    list_url: "/styles/black-grey/initials-jb"
  },
  {
    url: "/styles/black-grey/jamaican-coat-of-arms-and-the-american-EXDndr4ueBAW4rGbYv81Ex",
    title: "jamaican coat of arms and the american",
    list_url: "/styles/black-grey/jamaican-coat-of-arms-and-the-american"
  },
  {
    url: "/styles/black-grey/japanese-3-faces-servian-MECA3SqBZm5dFQF1JxAa5p",
    title: "japanese faces servian",
    list_url: "/styles/black-grey/japanese-3-faces-servian"
  },
  {
    url: "/styles/black-grey/kyrie-eleison-LVgeXCPDgDveWsbzAvPEex",
    title: "kyrie eleison",
    list_url: "/styles/black-grey/kyrie-eleison"
  },
  {
    url: "/styles/black-grey/letters-v-r-KhWK2Ucrv9y3rbwSNAefNS",
    title: "letters v r",
    list_url: "/styles/black-grey/letters-v-r"
  },
  {
    url: "/styles/black-grey/lightning-in-a-bottle-Wx1qj72uFdsS5dkEB1o4Cg",
    title: "lightning in a bottle",
    list_url: "/styles/black-grey/lightning-in-a-bottle"
  },
  {
    url: "/styles/black-grey/lily-and-dragonfly-SYhos4c5ZgueSzTDmoZn91",
    title: "lily and dragonfly",
    list_url: "/styles/black-grey/lily-and-dragonfly"
  },
  {
    url: "/styles/black-grey/love-you-to-the-moon-and-back-XC7zfF29ALAGP22MkaufGB",
    title: "love you to the moon and back",
    list_url: "/styles/black-grey/love-you-to-the-moon-and-back"
  },
  {
    url: "/styles/black-grey/matterhorn-TcXZNvnjbSsxgetvowVXge",
    title: "matterhorn",
    list_url: "/styles/black-grey/matterhorn"
  },
  {
    url: "/styles/black-grey/murphy-family-crest-H5Xo3wHy3rh8Wvf75eMBs3",
    title: "murphy family crest",
    list_url: "/styles/black-grey/murphy-family-crest"
  },
  {
    url: "/styles/black-grey/my-flaws-burn-through-my-skin-like-JbhS8DgPNkUrdQRuD9XYBF",
    title: "my flaws burn through my skin like",
    list_url: "/styles/black-grey/my-flaws-burn-through-my-skin-like"
  },
  {
    url: "/styles/black-grey/name-diego-in-cursive-font-5yyyzHghgDGhqPrjXz7P7J",
    title: "name diego in cursive font",
    list_url: "/styles/black-grey/name-diego-in-cursive-font"
  },
  {
    url: "/styles/black-grey/name-kittu-XPKqcLe4goRpSQuDfLduYr",
    title: "name kittu",
    list_url: "/styles/black-grey/name-kittu"
  },
  {
    url: "/styles/black-grey/navy-boatswain-mate-crossed-anchors-9YXq6icTnm3DaomSSRvpQR",
    title: "navy boatswain mate crossed anchors",
    list_url: "/styles/black-grey/navy-boatswain-mate-crossed-anchors"
  },
  {
    url: "/styles/black-grey/navy-chief-petty-officer-anchor-with-T2rXyYoha1nBve4QNWZ4SA",
    title: "navy chief petty officer anchor with",
    list_url: "/styles/black-grey/navy-chief-petty-officer-anchor-with"
  },
  {
    url: "/styles/black-grey/neha-name-for-armband-Xzoi1fkC5LqEB8fXY1kMEX",
    title: "neha name for armband",
    list_url: "/styles/black-grey/neha-name-for-armband"
  },
  {
    url: "/styles/black-grey/nemesis-goddess-of-revenge-supernova-XuSH2aCeDXR4crdSu7veob",
    title: "nemesis goddess of revenge supernova",
    list_url: "/styles/black-grey/nemesis-goddess-of-revenge-supernova"
  },
  {
    url: "/styles/black-grey/never-forget-where-you-came-from-8VP53mfBm7juqNgsfWk6hE",
    title: "never forget where you came from",
    list_url: "/styles/black-grey/never-forget-where-you-came-from"
  },
  {
    url: "/styles/black-grey/new-orleans-voodoo-9BzeFKcmvKPTRQY1iAXGAx",
    title: "new orleans voodoo",
    list_url: "/styles/black-grey/new-orleans-voodoo"
  },
  {
    url: "/styles/black-grey/new-york-yankees-HMVk9AtD34mdJ6rbPuMzUn",
    title: "new york yankees",
    list_url: "/styles/black-grey/new-york-yankees"
  },
  {
    url: "/styles/black-grey/numbers-999-juice-wrld-font-ANnVdGhqVbqJEX2d8na5Vh",
    title: "numbers juice wrld font",
    list_url: "/styles/black-grey/numbers-999-juice-wrld-font"
  },
  {
    url: "/styles/black-grey/oliver-name-tattoo-8ed8V55dXYpe3RHMMRoneM",
    title: "oliver name tattoo",
    list_url: "/styles/black-grey/oliver-name-tattoo"
  },
  {
    url: "/styles/black-grey/portulaca-flower-with-colibri-D1aVp4MnYpaqw1WbY9Ergd",
    title: "portulaca flower with colibri",
    list_url: "/styles/black-grey/portulaca-flower-with-colibri"
  },
  {
    url: "/styles/black-grey/proverbs-1822-VATdt6q5DPnojX5uhVAvJ1",
    title: "proverbs ",
    list_url: "/styles/black-grey/proverbs-1822"
  },
  {
    url: "/styles/black-grey/ram-skull-chest-tattoo-BGtbYVsL4Em2H4WkrCdd4U",
    title: "ram skull chest tattoo",
    list_url: "/styles/black-grey/ram-skull-chest-tattoo"
  },
  {
    url: "/styles/black-grey/ray-gun-7MoUBN8SrVYgxnuZVoN9jY",
    title: "ray gun",
    list_url: "/styles/black-grey/ray-gun"
  },
  {
    url: "/styles/black-grey/roman-armor-tattoo-StW2KosBK7BawbuBHYgLit",
    title: "roman armor tattoo",
    list_url: "/styles/black-grey/roman-armor-tattoo"
  },
  {
    url: "/styles/black-grey/sagittarius-tattoo-with-woman-archer-9aM7CNdZqDa8L7oFWzqwYg",
    title: "sagittarius tattoo with woman archer",
    list_url: "/styles/black-grey/sagittarius-tattoo-with-woman-archer"
  },
  {
    url: "/styles/black-grey/saurav-name-written-underneath-flower-JWhrA1Qzbc2aF5st7tKA7U",
    title: "saurav name written underneath flower",
    list_url: "/styles/black-grey/saurav-name-written-underneath-flower"
  },
  {
    url: "/styles/black-grey/see-no-evil-hear-see-speak-no-evil-baby-B1MufZV3b41Zti9r27cRuc",
    title: "see no evil hear see speak no evil baby",
    list_url: "/styles/black-grey/see-no-evil-hear-see-speak-no-evil-baby"
  },
  {
    url: "/styles/black-grey/smile-now-cry-later-masks-AYozcvGmXBfhMi2APjjgBU",
    title: "smile now cry later masks",
    list_url: "/styles/black-grey/smile-now-cry-later-masks"
  },
  {
    url: "/styles/black-grey/sonia-name-tattoo-3ABSC3hbcVNDhRzPf1tRVp",
    title: "sonia name tattoo",
    list_url: "/styles/black-grey/sonia-name-tattoo"
  },
  {
    url: "/styles/black-grey/south-carolina-state-logo-and-803-going-9Y6yBPHfXekGcPgMyiRe6j",
    title: "south carolina state logo and going",
    list_url: "/styles/black-grey/south-carolina-state-logo-and-803-going"
  },
  {
    url: "/styles/black-grey/spartacus-QPeT9npSruaHCXgzh269XA",
    title: "spartacus",
    list_url: "/styles/black-grey/spartacus"
  },
  {
    url: "/styles/black-grey/spirit-lead-me-where-my-trust-is-9rBtPeQadky1hbJiMWp2oU",
    title: "spirit lead me where my trust is",
    list_url: "/styles/black-grey/spirit-lead-me-where-my-trust-is"
  },
  {
    url: "/styles/black-grey/stihl-chain-saw-blade-cutting-XMknK2EanzcXevUXHcxHTB",
    title: "stihl chain saw blade cutting",
    list_url: "/styles/black-grey/stihl-chain-saw-blade-cutting"
  },
  {
    url: "/styles/black-grey/t-k-letters-GcUsxCfiy7YRHWUsNKWcec",
    title: "t k letters",
    list_url: "/styles/black-grey/t-k-letters"
  },
  {
    url: "/styles/black-grey/tada-gan-iarracht-VA2vM2XoVHeDHn55myDYNY",
    title: "tada gan iarracht",
    list_url: "/styles/black-grey/tada-gan-iarracht"
  },
  {
    url: "/styles/black-grey/target-62RvGmSuabqmNCzZ5JbUKG",
    title: "target",
    list_url: "/styles/black-grey/target"
  },
  {
    url: "/styles/black-grey/the-letters-bd-97Pb2fUcaEYtmkRe9bgMVB",
    title: "the letters bd",
    list_url: "/styles/black-grey/the-letters-bd"
  },
  {
    url: "/styles/black-grey/the-name-kobe-in-cursive-writing-with-AB7JSvaFbAS2eN34y7joye",
    title: "the name kobe in cursive writing with",
    list_url: "/styles/black-grey/the-name-kobe-in-cursive-writing-with"
  },
  {
    url: "/styles/black-grey/the-name-maxine-fancy-writing-love-MHinRCFrJR3rkrX5kM1USt",
    title: "the name maxine fancy writing love",
    list_url: "/styles/black-grey/the-name-maxine-fancy-writing-love"
  },
  {
    url: "/styles/black-grey/three-crosses-at-calvary-XAheeVXRwZhHFMqPbNYxW3",
    title: "three crosses at calvary",
    list_url: "/styles/black-grey/three-crosses-at-calvary"
  },
  {
    url: "/styles/black-grey/tree-of-life-with-angel-wings-8xnd5uq83hYZS56EGhVXGh",
    title: "tree of life with angel wings",
    list_url: "/styles/black-grey/tree-of-life-with-angel-wings"
  },
  {
    url: "/styles/black-grey/viking-crown-26zT87m6PoRCCY1pJfdUPk",
    title: "viking crown",
    list_url: "/styles/black-grey/viking-crown"
  },
  {
    url: "/styles/black-grey/vishnu-name-written-SuTsvnRM8jkrCeee4FZ5Dm",
    title: "vishnu name written",
    list_url: "/styles/black-grey/vishnu-name-written"
  },
  {
    url: "/styles/black-grey/western-flower-bull-skul-S3jbUhQAaXm2cK17rdxTQc",
    title: "western flower bull skul",
    list_url: "/styles/black-grey/western-flower-bull-skul"
  },
  {
    url: "/styles/black-grey/wolf-with-arrows-in-his-back-TNeaoz63G9Cf49KxvY1hp4",
    title: "wolf with arrows in his back",
    list_url: "/styles/black-grey/wolf-with-arrows-in-his-back"
  },
  {
    url: "/styles/black-grey/word-simul-justus-et-peccator-around-a-P3kwmC9g7Tx3fFnfyHu6Mu",
    title: "word simul justus et peccator around a",
    list_url: "/styles/black-grey/word-simul-justus-et-peccator-around-a"
  },
  {
    url: "/styles/blackwork/a-heart-shape-with-the-name-corey-LHnuDmPXL848NiQDTR9wJs",
    title: "a heart shape with the name corey",
    list_url: "/styles/blackwork/a-heart-shape-with-the-name-corey"
  },
  {
    url: "/styles/blackwork/amat-victoria-curam-AsgAbPNUrjFSbQjqPUxp9b",
    title: "amat victoria curam",
    list_url: "/styles/blackwork/amat-victoria-curam"
  },
  {
    url: "/styles/blackwork/angel-vs-demon-neck-tattoo-MWshn2GERVFx95ZMjWmpT7",
    title: "angel vs demon neck tattoo",
    list_url: "/styles/blackwork/angel-vs-demon-neck-tattoo"
  },
  {
    url: "/styles/blackwork/april-8th-2025-in-roman-numerals-Ja2diHC9Gj7s6GGAs2jRNg",
    title: "april th in roman numerals",
    list_url: "/styles/blackwork/april-8th-2025-in-roman-numerals"
  },
  {
    url: "/styles/blackwork/banks-of-a-river-EEaVC2Gor9rDyEsMnKaPty",
    title: "banks of a river",
    list_url: "/styles/blackwork/banks-of-a-river"
  },
  {
    url: "/styles/blackwork/bat-on-neck-Qfk9qyHAbZQgjWSDKbXbYX",
    title: "bat on neck",
    list_url: "/styles/blackwork/bat-on-neck"
  },
  {
    url: "/styles/blackwork/birmingham-city-football-club-SVFmYoN2CGPAKSLqZ8uMkf",
    title: "birmingham city football club",
    list_url: "/styles/blackwork/birmingham-city-football-club"
  },
  {
    url: "/styles/blackwork/cage-the-elephant-4jzMsdSHd6FaH2NNrvVHbP",
    title: "cage the elephant",
    list_url: "/styles/blackwork/cage-the-elephant"
  },
  {
    url: "/styles/blackwork/cellphone-repair-HFsWxdJrmRFZNJLz8aAvuj",
    title: "cellphone repair",
    list_url: "/styles/blackwork/cellphone-repair"
  },
  {
    url: "/styles/blackwork/chinese-female-warrior-weilding-a-sword-YDCKabUPBa7Evvh2hR1rWQ",
    title: "chinese female warrior weilding a sword",
    list_url: "/styles/blackwork/chinese-female-warrior-weilding-a-sword"
  },
  {
    url: "/styles/blackwork/couples-tattoo-phoenix-rising-from-fire-Vz7Z3Wo8oRo5edvRkoz7Sg",
    title: "couples tattoo phoenix rising from fire",
    list_url: "/styles/blackwork/couples-tattoo-phoenix-rising-from-fire"
  },
  {
    url: "/styles/blackwork/crest-of-calabria-italy-stone-wall-VnLE3dbuCht5Wca9et2Gk9",
    title: "crest of calabria italy stone wall",
    list_url: "/styles/blackwork/crest-of-calabria-italy-stone-wall"
  },
  {
    url: "/styles/blackwork/demon-asmodeus-WKDAk73fWs2p7d8yWSfkwW",
    title: "demon asmodeus",
    list_url: "/styles/blackwork/demon-asmodeus"
  },
  {
    url: "/styles/blackwork/dilligaf-DsHpjFmP68hdV7T6NmGvm5",
    title: "dilligaf",
    list_url: "/styles/blackwork/dilligaf"
  },
  {
    url: "/styles/blackwork/dragon-perched-on-and-around-the-knee-Pr7TiEGxzMYYoqW2t3jDbr",
    title: "dragon perched on and around the knee",
    list_url: "/styles/blackwork/dragon-perched-on-and-around-the-knee"
  },
  {
    url: "/styles/blackwork/ems-star-of-life-8Gf9xzCuMBDj1d3ysgQyM1",
    title: "ems star of life",
    list_url: "/styles/blackwork/ems-star-of-life"
  },
  {
    url: "/styles/blackwork/factorio-E2yFjvMR4wnLzDKBRF8mVz",
    title: "factorio",
    list_url: "/styles/blackwork/factorio"
  },
  {
    url: "/styles/blackwork/fenrir-hel-jormungandr-AfQc2k1xzWycpJq8jNzc7X",
    title: "fenrir hel jormungandr",
    list_url: "/styles/blackwork/fenrir-hel-jormungandr"
  },
  {
    url: "/styles/blackwork/girl-taking-off-shirt-revaling-skull-94zV7UUdy3Fuc6LmKD8ZCx",
    title: "girl taking off shirt revaling skull",
    list_url: "/styles/blackwork/girl-taking-off-shirt-revaling-skull"
  },
  {
    url: "/styles/blackwork/greek-temple-in-ruins-4c7G1WZ35pSFRhGmEwUrg7",
    title: "greek temple in ruins",
    list_url: "/styles/blackwork/greek-temple-in-ruins"
  },
  {
    url: "/styles/blackwork/heart-hidden-letter-a-2k1EEXi18YSDBqE2KhK1WR",
    title: "heart hidden letter a",
    list_url: "/styles/blackwork/heart-hidden-letter-a"
  },
  {
    url: "/styles/blackwork/hunter-s-thompson-tribute-with-buy-the-VR7YLa9Q5YCCnaUUBwpq4i",
    title: "hunter s thompson tribute with buy the",
    list_url: "/styles/blackwork/hunter-s-thompson-tribute-with-buy-the"
  },
  {
    url: "/styles/blackwork/jesus-cross-with-last-name-LBZeYMeNbe3XtQH2AAZ9Av",
    title: "jesus cross with last name",
    list_url: "/styles/blackwork/jesus-cross-with-last-name"
  },
  {
    url: "/styles/blackwork/jonathan-name-AyKUdnRmheYMQ2D4CUDZ5d",
    title: "jonathan name",
    list_url: "/styles/blackwork/jonathan-name"
  },
  {
    url: "/styles/blackwork/joshua-19-in-roman-numerals-6xhWu6t4XpwqXUhS1Xy5Ka",
    title: "joshua in roman numerals",
    list_url: "/styles/blackwork/joshua-19-in-roman-numerals"
  },
  {
    url: "/styles/blackwork/lotus-flower-overlaying-an-enso-circle-FBy1w6RP64cYG8ZigWKZVa",
    title: "lotus flower overlaying an enso circle",
    list_url: "/styles/blackwork/lotus-flower-overlaying-an-enso-circle"
  },
  {
    url: "/styles/blackwork/male-angel-with-wings-for-on-the-back-2xQBht6qmwkdSSJTHfDa5",
    title: "male angel with wings for on the back",
    list_url: "/styles/blackwork/male-angel-with-wings-for-on-the-back"
  },
  {
    url: "/styles/blackwork/my-flaws-burn-through-my-skin-like-5n64At4oFD4JBFaKEhuSRG",
    title: "my flaws burn through my skin like",
    list_url: "/styles/blackwork/my-flaws-burn-through-my-skin-like"
  },
  {
    url: "/styles/blackwork/nirbhau-nirvair-gtB4TPQJR3HXXtH1FYQPn",
    title: "nirbhau nirvair",
    list_url: "/styles/blackwork/nirbhau-nirvair"
  },
  {
    url: "/styles/blackwork/octopus-on-ring-finger-8praGKhYV4ETeDGZaZ7NRj",
    title: "octopus on ring finger",
    list_url: "/styles/blackwork/octopus-on-ring-finger"
  },
  {
    url: "/styles/blackwork/ogun-NAaHYVqAMsYfTUPX8tbUvq",
    title: "ogun",
    list_url: "/styles/blackwork/ogun"
  },
  {
    url: "/styles/blackwork/open-heart-surgery-DNaQVcZk5nouojpN8azSWM",
    title: "open heart surgery",
    list_url: "/styles/blackwork/open-heart-surgery"
  },
  {
    url: "/styles/blackwork/outer-wilds-eye-coordinates-but-nordic-GSVaCU1drY5tmKQnUHYKN5",
    title: "outer wilds eye coordinates but nordic",
    list_url: "/styles/blackwork/outer-wilds-eye-coordinates-but-nordic"
  },
  {
    url: "/styles/blackwork/pride-of-barbados-YFRWvcmFUaenF73PbxkSzk",
    title: "pride of barbados",
    list_url: "/styles/blackwork/pride-of-barbados"
  },
  {
    url: "/styles/blackwork/reasons-to-live-give-reasons-to-die-E7mceBXdTWa2ya4WhjJRmQ",
    title: "reasons to live give reasons to die",
    list_url: "/styles/blackwork/reasons-to-live-give-reasons-to-die"
  },
  {
    url: "/styles/blackwork/roman-god-pluto-with-cerberus-6Sot48Xk1vpskb2tQPLMv4",
    title: "roman god pluto with cerberus",
    list_url: "/styles/blackwork/roman-god-pluto-with-cerberus"
  },
  {
    url: "/styles/blackwork/roman-numeral-with-rose-Y97gYC8A1aEGtwc7D56wC",
    title: "roman numeral with rose",
    list_url: "/styles/blackwork/roman-numeral-with-rose"
  },
  {
    url: "/styles/blackwork/small-999-juice-wrld-V1C5ddyfj2yxdeef7NRCdt",
    title: "small juice wrld",
    list_url: "/styles/blackwork/small-999-juice-wrld"
  },
  {
    url: "/styles/blackwork/st-michael-stepping-on-snake-wrapped-WqywfKAUjYq2H9AU96kV1",
    title: "st michael stepping on snake wrapped",
    list_url: "/styles/blackwork/st-michael-stepping-on-snake-wrapped"
  },
  {
    url: "/styles/blackwork/the-order-of-the-white-lotus-avatar-the-LAq7ZhCtUDuPkVZrQjq512",
    title: "the order of the white lotus avatar the",
    list_url: "/styles/blackwork/the-order-of-the-white-lotus-avatar-the"
  },
  {
    url: "/styles/blackwork/throat-chakra-MBAmTDCrbq4dqqzu6f3BpR",
    title: "throat chakra",
    list_url: "/styles/blackwork/throat-chakra"
  },
  {
    url: "/styles/cyber-sigilism/spider-lily-flowers-JAUHguhh8XUZH7rKtst6Tq",
    title: "spider lily flowers",
    list_url: "/styles/cyber-sigilism/spider-lily-flowers"
  },
  {
    url: "/styles/dotwork/a-mafia-with-a-turkish-crescent-moon-47PcEhE18LRwQfgNFFfzBf",
    title: "a mafia with a turkish crescent moon",
    list_url: "/styles/dotwork/a-mafia-with-a-turkish-crescent-moon"
  },
  {
    url: "/styles/dotwork/astaroth-demon-T1mjbh7guKxrFiMEv5FymB",
    title: "astaroth demon",
    list_url: "/styles/dotwork/astaroth-demon"
  },
  {
    url: "/styles/dotwork/august-17-2006-in-roman-numerals-6WMiqwmjyTsxG7U7po35T5",
    title: "august in roman numerals",
    list_url: "/styles/dotwork/august-17-2006-in-roman-numerals"
  },
  {
    url: "/styles/dotwork/bird-wraped-in-music-notes-UBiuC4G8iCgbr78rjPAwQ6",
    title: "bird wraped in music notes",
    list_url: "/styles/dotwork/bird-wraped-in-music-notes"
  },
  {
    url: "/styles/dotwork/change-date-0309-to-ishani-CwmkCkhMPCNRVo64GMNGt1",
    title: "change date to ishani",
    list_url: "/styles/dotwork/change-date-0309-to-ishani"
  },
  {
    url: "/styles/dotwork/create-a-tattoo-featuring-a-caregiver-CaycR3nSgQGVn7Km7PpN27",
    title: "create a tattoo featuring a caregiver",
    list_url: "/styles/dotwork/create-a-tattoo-featuring-a-caregiver"
  },
  {
    url: "/styles/dotwork/maurya-dynasty-JnPHm1EDu1JCFX9nWM25nm",
    title: "maurya dynasty",
    list_url: "/styles/dotwork/maurya-dynasty"
  },
  {
    url: "/styles/dotwork/my-kingdom-for-a-kiss-upon-her-shoulder-LKges52v3Pc9pWdsFsQjea",
    title: "my kingdom for a kiss upon her shoulder",
    list_url: "/styles/dotwork/my-kingdom-for-a-kiss-upon-her-shoulder"
  },
  {
    url: "/styles/dotwork/nle-choppa-LafobLpEeatPE2diuB48iJ",
    title: "nle choppa",
    list_url: "/styles/dotwork/nle-choppa"
  },
  {
    url: "/styles/dotwork/palm-tree-with-turtle-S1RS9n41nCh4G6cnxpPgmk",
    title: "palm tree with turtle",
    list_url: "/styles/dotwork/palm-tree-with-turtle"
  },
  {
    url: "/styles/dotwork/radiohead-weird-fishes-arpeggi-LHPVGguKmjYpBW5WJWQx1J",
    title: "radiohead weird fishes arpeggi",
    list_url: "/styles/dotwork/radiohead-weird-fishes-arpeggi"
  },
  {
    url: "/styles/dotwork/rose-phoenix-NNxA77ixjd7KLfFGfG9vJR",
    title: "rose phoenix",
    list_url: "/styles/dotwork/rose-phoenix"
  },
  {
    url: "/styles/dotwork/sindhu-3ifdmLdvnoMgALQ5zXSXvz",
    title: "sindhu",
    list_url: "/styles/dotwork/sindhu"
  },
  {
    url: "/styles/dotwork/tatuaje-de-flor-cataleya-con-el-nombre-FxZbvGJTDr4fpBHamii8jg",
    title: "tatuaje de flor cataleya con el nombre",
    list_url: "/styles/dotwork/tatuaje-de-flor-cataleya-con-el-nombre"
  },
  {
    url: "/styles/dotwork/third-eye-with-lotus-flower-L4TwyYoacBBw4pPHGhfq9f",
    title: "third eye with lotus flower",
    list_url: "/styles/dotwork/third-eye-with-lotus-flower"
  },
  {
    url: "/styles/dotwork/tree-of-life-stars-GrWqveVRi19Duryfbk2d1v",
    title: "tree of life stars",
    list_url: "/styles/dotwork/tree-of-life-stars"
  },
  {
    url: "/styles/dotwork/xbox-controller-5fSTXiPwVu7G82yMymkTK6",
    title: "xbox controller",
    list_url: "/styles/dotwork/xbox-controller"
  },
  {
    url: "/styles/dotwork/yogi-bear-AM1C6oRWsWDsv9K9yztYg",
    title: "yogi bear",
    list_url: "/styles/dotwork/yogi-bear"
  },
  {
    url: "/styles/dotwork/yung-lean-7PX1MnpsSm6MqRkCF8dq5H",
    title: "yung lean",
    list_url: "/styles/dotwork/yung-lean"
  },
  {
    url: "/styles/geometric/arrow-with-name-axel-DRx9dpibyUVxb2PTzBgeNv",
    title: "arrow with name axel",
    list_url: "/styles/geometric/arrow-with-name-axel"
  },
  {
    url: "/styles/geometric/christian-saint-benedict-medal-GcRGSye5yAKPou2fmR7YUg",
    title: "christian saint benedict medal",
    list_url: "/styles/geometric/christian-saint-benedict-medal"
  },
  {
    url: "/styles/geometric/danu-goddess-and-wildflowers-FTwKGNBZd8sTF3X9wNfwoV",
    title: "danu goddess and wildflowers",
    list_url: "/styles/geometric/danu-goddess-and-wildflowers"
  },
  {
    url: "/styles/geometric/heart-in-heart-with-letter-m-EkMeD3QNUJidsoagFtLNR9",
    title: "heart in heart with letter m",
    list_url: "/styles/geometric/heart-in-heart-with-letter-m"
  },
  {
    url: "/styles/geometric/metronome-RvruKmtLZkWpknoUQn2oS9",
    title: "metronome",
    list_url: "/styles/geometric/metronome"
  },
  {
    url: "/styles/geometric/puffin-TwzcdFTfyrwoVGPV9Pnxhm",
    title: "puffin",
    list_url: "/styles/geometric/puffin"
  },
  {
    url: "/styles/geometric/rabbit-WkXxVXaxaMLYcn7RBJTGT2",
    title: "rabbit",
    list_url: "/styles/geometric/rabbit"
  },
  {
    url: "/styles/geometric/saint-michael-archangel-D7CrphfJME2cszHfgX2EYX",
    title: "saint michael archangel",
    list_url: "/styles/geometric/saint-michael-archangel"
  },
  {
    url: "/styles/geometric/shadow-koi-fish-5NfnGQrfo69FxMjHxgWrXN",
    title: "shadow koi fish",
    list_url: "/styles/geometric/shadow-koi-fish"
  },
  {
    url: "/styles/geometric/tattoo-design-of-pashupatinath-temple-8jK1haHtkNpESdeTsYTYV6",
    title: "tattoo design of pashupatinath temple",
    list_url: "/styles/geometric/tattoo-design-of-pashupatinath-temple"
  },
  {
    url: "/styles/geometric/words-romans-1212-with-cross-RC6zchm78eVwfPo9LJqEF6",
    title: "words romans with cross",
    list_url: "/styles/geometric/words-romans-1212-with-cross"
  },
  {
    url: "/styles/japanese/a-samurai-kneeling-down-on-one-knee-3HQZRwUaEd72e1DA4dqFrE",
    title: "a samurai kneeling down on one knee",
    list_url: "/styles/japanese/a-samurai-kneeling-down-on-one-knee"
  },
  {
    url: "/styles/japanese/bull-FcakYW6k5Lg6M6BNWfeYUo",
    title: "bull",
    list_url: "/styles/japanese/bull"
  },
  {
    url: "/styles/japanese/chinese-clouds-with-red-sun-DWQcuaJAdz6TtMYWeSUkdb",
    title: "chinese clouds with red sun",
    list_url: "/styles/japanese/chinese-clouds-with-red-sun"
  },
  {
    url: "/styles/japanese/chinese-foo-dog-sitting-in-a-cloud-MCdA97VsrVu8EBvHN84826",
    title: "chinese foo dog sitting in a cloud",
    list_url: "/styles/japanese/chinese-foo-dog-sitting-in-a-cloud"
  },
  {
    url: "/styles/japanese/hashirama-senju-ViogMQzePy67qQJqV9sqn6",
    title: "hashirama senju",
    list_url: "/styles/japanese/hashirama-senju"
  },
  {
    url: "/styles/japanese/japanese-three-faces-proverb-TgyESnpwzjZJdezkEbv1bZ",
    title: "japanese three faces proverb",
    list_url: "/styles/japanese/japanese-three-faces-proverb"
  },
  {
    url: "/styles/japanese/kintsugi-heart-GipbgqUtBtaCCRDfUt7ZKH",
    title: "kintsugi heart",
    list_url: "/styles/japanese/kintsugi-heart"
  },
  {
    url: "/styles/japanese/mother-and-son-Jj6yySFqMCUZDkkFaq9ntJ",
    title: "mother and son",
    list_url: "/styles/japanese/mother-and-son"
  },
  {
    url: "/styles/japanese/oni-demon-throat-9nwvRddrBvwVxfEj3wgook",
    title: "oni demon throat",
    list_url: "/styles/japanese/oni-demon-throat"
  },
  {
    url: "/styles/japanese/owl-oni-mask-CMBoXPtx76KwAedsgWBWbW",
    title: "owl oni mask",
    list_url: "/styles/japanese/owl-oni-mask"
  },
  {
    url: "/styles/japanese/panther-with-lotus-flowers-KKNNUsA2VptCJmpNtaVqkZ",
    title: "panther with lotus flowers",
    list_url: "/styles/japanese/panther-with-lotus-flowers"
  },
  {
    url: "/styles/japanese/samurai-shiba-inu-japan-style-tattoo-6yBmmJjhcFZZ9AeD9phWj6",
    title: "samurai shiba inu japan style tattoo",
    list_url: "/styles/japanese/samurai-shiba-inu-japan-style-tattoo"
  },
  {
    url: "/styles/japanese/snake-and-phoenix-9rvDqhqaDT7t5ModvRJ2ED",
    title: "snake and phoenix",
    list_url: "/styles/japanese/snake-and-phoenix"
  },
  {
    url: "/styles/japanese/soul-eater-sun-and-moon-Gw9BS5Lv7k6QKcnSjMW13X",
    title: "soul eater sun and moon",
    list_url: "/styles/japanese/soul-eater-sun-and-moon"
  },
  {
    url: "/styles/minimalist/1956-chevy-bel-air-XDuLXDe3fEwH2y1bSR1sq3",
    title: " chevy bel air",
    list_url: "/styles/minimalist/1956-chevy-bel-air"
  },
  {
    url: "/styles/minimalist/3-birds-flying-in-circle-shape-8yodTNy9RyhGypwhKBeL7z",
    title: " birds flying in circle shape",
    list_url: "/styles/minimalist/3-birds-flying-in-circle-shape"
  },
  {
    url: "/styles/minimalist/a-minimalist-tattoo-design-of-a-greek-D7d15pfQoUxenGaDtmtYc2",
    title: "a minimalist tattoo design of a greek",
    list_url: "/styles/minimalist/a-minimalist-tattoo-design-of-a-greek"
  },
  {
    url: "/styles/minimalist/a-tattoo-design-with-hidden-name-yogi-KwQF3tUtZpcoxSrBHhJ7LC",
    title: "a tattoo design with hidden name yogi",
    list_url: "/styles/minimalist/a-tattoo-design-with-hidden-name-yogi"
  },
  {
    url: "/styles/minimalist/angel-wings-and-in-between-with-m-YKmSbBqbhUEkatxCGE6N4L",
    title: "angel wings and in between with m",
    list_url: "/styles/minimalist/angel-wings-and-in-between-with-m"
  },
  {
    url: "/styles/minimalist/bee-on-honeycomb-MsPMMLbYtandoiyWbQmgC8",
    title: "bee on honeycomb",
    list_url: "/styles/minimalist/bee-on-honeycomb"
  },
  {
    url: "/styles/minimalist/binary-sunset-star-wars-EwHiw2xux2nPN471KFvUnT",
    title: "binary sunset star wars",
    list_url: "/styles/minimalist/binary-sunset-star-wars"
  },
  {
    url: "/styles/minimalist/border-collie-face-fine-line-XCFYq1C1B2N1XfZpExEP4w",
    title: "border collie face fine line",
    list_url: "/styles/minimalist/border-collie-face-fine-line"
  },
  {
    url: "/styles/minimalist/bouquet-of-lily-of-the-valley-poppy-PYgBLPmCXGT6bivpcPFNrj",
    title: "bouquet of lily of the valley poppy",
    list_url: "/styles/minimalist/bouquet-of-lily-of-the-valley-poppy"
  },
  {
    url: "/styles/minimalist/c4-BxPsJrBmCTT4HpBUXKL7km",
    title: "c ",
    list_url: "/styles/minimalist/c4"
  },
  {
    url: "/styles/minimalist/cattail-NiKohoWPXVsAdxmjwpsVUt",
    title: "cattail",
    list_url: "/styles/minimalist/cattail"
  },
  {
    url: "/styles/minimalist/chemical-engineering-symbols-AKnxBPsrUmWBt3BjHJF7Re",
    title: "chemical engineering symbols",
    list_url: "/styles/minimalist/chemical-engineering-symbols"
  },
  {
    url: "/styles/minimalist/chiron-JpsnEkWgjnoj2UUnXHrQA7",
    title: "chiron",
    list_url: "/styles/minimalist/chiron"
  },
  {
    url: "/styles/minimalist/christian-cross-with-psalms-144-1-NAoEtrBHZGY44hRLssSZW3",
    title: "christian cross with psalms ",
    list_url: "/styles/minimalist/christian-cross-with-psalms-144-1"
  },
  {
    url: "/styles/minimalist/cliff-jumping-Sqj6g9c2TTBiVvm2TewzUq",
    title: "cliff jumping",
    list_url: "/styles/minimalist/cliff-jumping"
  },
  {
    url: "/styles/minimalist/coco-chanel-St1meDg3P3ZpvME6zcp4KY",
    title: "coco chanel",
    list_url: "/styles/minimalist/coco-chanel"
  },
  {
    url: "/styles/minimalist/daffodil-daisy-morning-glory-flowers-MeiYDk1V5CzEbaiuMML4ME",
    title: "daffodil daisy morning glory flowers",
    list_url: "/styles/minimalist/daffodil-daisy-morning-glory-flowers"
  },
  {
    url: "/styles/minimalist/daffodil-violet-sweet-pea-KUbLHw163Ve7Kh2XC3Sj62",
    title: "daffodil violet sweet pea",
    list_url: "/styles/minimalist/daffodil-violet-sweet-pea"
  },
  {
    url: "/styles/minimalist/drain-gang-MvJYc6GaTpUrJWtGyAmF4t",
    title: "drain gang",
    list_url: "/styles/minimalist/drain-gang"
  },
  {
    url: "/styles/minimalist/dungeon-master-dnd-3yz7q9m5asbKvFikSS6hF7",
    title: "dungeon master dnd",
    list_url: "/styles/minimalist/dungeon-master-dnd"
  },
  {
    url: "/styles/minimalist/eeyore-USM4MD8k9vKjehwv4hHnfM",
    title: "eeyore",
    list_url: "/styles/minimalist/eeyore"
  },
  {
    url: "/styles/minimalist/elephant-mom-and-2-babies-FTdUgXtDyYEcyAUGG8s9kE",
    title: "elephant mom and babies",
    list_url: "/styles/minimalist/elephant-mom-and-2-babies"
  },
  {
    url: "/styles/minimalist/gameboy-Bkiw9HBgZkKy82WDZhMuUU",
    title: "gameboy",
    list_url: "/styles/minimalist/gameboy"
  },
  {
    url: "/styles/minimalist/grape-vine-with-words-i-am-the-vine-6WbXnqE7Eka5pT223D3d8Z",
    title: "grape vine with words i am the vine",
    list_url: "/styles/minimalist/grape-vine-with-words-i-am-the-vine"
  },
  {
    url: "/styles/minimalist/heart-with-c-and-t-initials-R1dvG1CGukTPdRWfn6bmvy",
    title: "heart with c and t initials",
    list_url: "/styles/minimalist/heart-with-c-and-t-initials"
  },
  {
    url: "/styles/minimalist/heart-with-the-names-gopal-and-shalini-UEUspRrtyW8pxf7ptoVgWB",
    title: "heart with the names gopal and shalini",
    list_url: "/styles/minimalist/heart-with-the-names-gopal-and-shalini"
  },
  {
    url: "/styles/minimalist/hidden-letters-c-and-b-9NY64si9YMT2XKJtkNEeY7",
    title: "hidden letters c and b",
    list_url: "/styles/minimalist/hidden-letters-c-and-b"
  },
  {
    url: "/styles/minimalist/hummingbird-with-watch-and-lotus-flower-R9znXm651S5jrnZiEzvB9R",
    title: "hummingbird with watch and lotus flower",
    list_url: "/styles/minimalist/hummingbird-with-watch-and-lotus-flower"
  },
  {
    url: "/styles/minimalist/jesus-is-my-savior-my-king-my-god-97Mu4SBkJyxbZ4xXU2uDo8",
    title: "jesus is my savior my king my god",
    list_url: "/styles/minimalist/jesus-is-my-savior-my-king-my-god"
  },
  {
    url: "/styles/minimalist/lotus-flower-with-turtle-4iagYqQyQ4FXGqq24yHv9k",
    title: "lotus flower with turtle",
    list_url: "/styles/minimalist/lotus-flower-with-turtle"
  },
  {
    url: "/styles/minimalist/mama-and-papa-8oZ9QrXj5GLYgRZtdYYRP9",
    title: "mama and papa",
    list_url: "/styles/minimalist/mama-and-papa"
  },
  {
    url: "/styles/minimalist/moon-shaped-letter-c-LRDQH9eDoh3bbHtxVJVRjY",
    title: "moon shaped letter c",
    list_url: "/styles/minimalist/moon-shaped-letter-c"
  },
  {
    url: "/styles/minimalist/name-amira-UvL8kEMKJy6v83LDDHMxUv",
    title: "name amira",
    list_url: "/styles/minimalist/name-amira"
  },
  {
    url: "/styles/minimalist/rhea-name-NC4CQKBJyuiuAYAegeHXEY",
    title: "rhea name",
    list_url: "/styles/minimalist/rhea-name"
  },
  {
    url: "/styles/minimalist/silver-surfer-Sw7cxDeLrZjBo9sub8sPL4",
    title: "silver surfer",
    list_url: "/styles/minimalist/silver-surfer"
  },
  {
    url: "/styles/minimalist/theodore-20230516-C5GUb6Z7onfEEcLjL9HYti",
    title: "theodore ",
    list_url: "/styles/minimalist/theodore-20230516"
  },
  {
    url: "/styles/minimalist/three-little-pigs-32QzRQiMEStbbHr4b7sNrm",
    title: "three little pigs",
    list_url: "/styles/minimalist/three-little-pigs"
  },
  {
    url: "/styles/minimalist/whistle-AmLtFjEmR4jpwVowDMM8zq",
    title: "whistle",
    list_url: "/styles/minimalist/whistle"
  },
  {
    url: "/styles/neotraditional/alyssa-name-tattoo-with-roses-all-L4C9MroTjvUvGm9bs2qJcm",
    title: "alyssa name tattoo with roses all",
    list_url: "/styles/neotraditional/alyssa-name-tattoo-with-roses-all"
  },
  {
    url: "/styles/neotraditional/angel-wings-with-name-VyFhUVUMcxP5XbbbtStsiK",
    title: "angel wings with name",
    list_url: "/styles/neotraditional/angel-wings-with-name"
  },
  {
    url: "/styles/neotraditional/batman-robin-redhood-nightwing-GL1BA1C5MdcKR77Qwj3jRm",
    title: "batman robin redhood nightwing",
    list_url: "/styles/neotraditional/batman-robin-redhood-nightwing"
  },
  {
    url: "/styles/neotraditional/brooklyn-name-tattoo-MEERch3FaccmP3azhMo6u7",
    title: "brooklyn name tattoo",
    list_url: "/styles/neotraditional/brooklyn-name-tattoo"
  },
  {
    url: "/styles/neotraditional/cherub-angel-hear-no-evil-see-no-evil-KNp7cPh2uwrVsr2YKD5E5M",
    title: "cherub angel hear no evil see no evil",
    list_url: "/styles/neotraditional/cherub-angel-hear-no-evil-see-no-evil"
  },
  {
    url: "/styles/neotraditional/cross-of-lorraine-LEqcB97NHzfEbiLd48NYXf",
    title: "cross of lorraine",
    list_url: "/styles/neotraditional/cross-of-lorraine"
  },
  {
    url: "/styles/neotraditional/curse-of-writing-savannah-name-on-neck-K2M7C34MVQv5irn8gERUGZ",
    title: "curse of writing savannah name on neck",
    list_url: "/styles/neotraditional/curse-of-writing-savannah-name-on-neck"
  },
  {
    url: "/styles/neotraditional/destiny-warlock-HBzrUHVAPZw1CWXM2RJpqD",
    title: "destiny warlock",
    list_url: "/styles/neotraditional/destiny-warlock"
  },
  {
    url: "/styles/neotraditional/fragile-x-syndrome-awareness-5S7qNfSnzUPkWN2rr4EqcG",
    title: "fragile x syndrome awareness",
    list_url: "/styles/neotraditional/fragile-x-syndrome-awareness"
  },
  {
    url: "/styles/neotraditional/fuck-love-written-in-chinese-DzmTWM5kBkeH7GrjwDhygg",
    title: "fuck love written in chinese",
    list_url: "/styles/neotraditional/fuck-love-written-in-chinese"
  },
  {
    url: "/styles/neotraditional/go-with-your-gut-dragon-warrior-panda-2Rkq8ncaG7PRDoDfZYVn5Q",
    title: "go with your gut dragon warrior panda",
    list_url: "/styles/neotraditional/go-with-your-gut-dragon-warrior-panda"
  },
  {
    url: "/styles/neotraditional/lip-print-with-daddys-little-slut-VYTsCUrseu7e6UEBdaS4e3",
    title: "lip print with daddys little slut",
    list_url: "/styles/neotraditional/lip-print-with-daddys-little-slut"
  },
  {
    url: "/styles/neotraditional/mila-armani-in-cursive-writing-SyrNU1MM18kVVc5zH7n95V",
    title: "mila armani in cursive writing",
    list_url: "/styles/neotraditional/mila-armani-in-cursive-writing"
  },
  {
    url: "/styles/neotraditional/name-of-theresa-Kt3b9Ci3LRbkLvrpdjedtT",
    title: "name of theresa",
    list_url: "/styles/neotraditional/name-of-theresa"
  },
  {
    url: "/styles/neotraditional/nicolo-machiavelli-JYeQ8xRgaJHo62rMHGhgoS",
    title: "nicolo machiavelli",
    list_url: "/styles/neotraditional/nicolo-machiavelli"
  },
  {
    url: "/styles/neotraditional/siri-name-tattoo-3RG4WcNPCagGpx5sFpSMUC",
    title: "siri name tattoo",
    list_url: "/styles/neotraditional/siri-name-tattoo"
  },
  {
    url: "/styles/neotraditional/star-wars-sith-code-in-aurebesh-6N6V2NPHGUY2MzgRiHshg6",
    title: "star wars sith code in aurebesh",
    list_url: "/styles/neotraditional/star-wars-sith-code-in-aurebesh"
  },
  {
    url: "/styles/neotraditional/tanit-god-symbol-59JyVncYcfkGb9W6mXa2Ub",
    title: "tanit god symbol",
    list_url: "/styles/neotraditional/tanit-god-symbol"
  },
  {
    url: "/styles/neotraditional/tattoo-for-firstborn-named-arlo-6wpkcgiJhEd3vKbqmwBHZP",
    title: "tattoo for firstborn named arlo",
    list_url: "/styles/neotraditional/tattoo-for-firstborn-named-arlo"
  },
  {
    url: "/styles/neotraditional/the-name-mark-written-with-claw-marks-YCxfnjDxt2KTLasvqV2A6G",
    title: "the name mark written with claw marks",
    list_url: "/styles/neotraditional/the-name-mark-written-with-claw-marks"
  },
  {
    url: "/styles/neotraditional/thyroid-cancer-survivor-symbol-NNA193iQyBFKJccBAqv2oY",
    title: "thyroid cancer survivor symbol",
    list_url: "/styles/neotraditional/thyroid-cancer-survivor-symbol"
  },
  {
    url: "/styles/neotraditional/trust-no-bitch-devil-tiger-red-H4mHWZHQoYYyZJYC1tBzai",
    title: "trust no bitch devil tiger red",
    list_url: "/styles/neotraditional/trust-no-bitch-devil-tiger-red"
  },
  {
    url: "/styles/neotraditional/viking-symbol-for-father-and-son-mixed-PxxjYX84SX7Tsw2KEHfVhP",
    title: "viking symbol for father and son mixed",
    list_url: "/styles/neotraditional/viking-symbol-for-father-and-son-mixed"
  },
  {
    url: "/styles/neotraditional/water-lily-poppy-and-violet-flower-FEghkzf3jGzpkxnvmGm6mw",
    title: "water lily poppy and violet flower",
    list_url: "/styles/neotraditional/water-lily-poppy-and-violet-flower"
  },
  {
    url: "/styles/new-school/treasure-map-R3dZpdahDJEV2N6RteX2oJ",
    title: "treasure map",
    list_url: "/styles/new-school/treasure-map"
  },
  {
    url: "/styles/new-school/two-women-kissing-with-their-tongue-K4mhEJaRLHhvoanm3p8EFt",
    title: "two women kissing with their tongue",
    list_url: "/styles/new-school/two-women-kissing-with-their-tongue"
  },
  {
    url: "/styles/realism/a-wolf-with-red-eyes-2qUQxmKtS83rTrXnBBZwSq",
    title: "a wolf with red eyes",
    list_url: "/styles/realism/a-wolf-with-red-eyes"
  },
  {
    url: "/styles/realism/alberta-wild-roses-wheat-fields-VEod6ch6S16Tb2AoSPnUxF",
    title: "alberta wild roses wheat fields",
    list_url: "/styles/realism/alberta-wild-roses-wheat-fields"
  },
  {
    url: "/styles/realism/angel-with-dreads-CBHFQCxReS9k6jTpzjnVHZ",
    title: "angel with dreads",
    list_url: "/styles/realism/angel-with-dreads"
  },
  {
    url: "/styles/realism/atlas-holding-the-world-hercules-V5ixEM9bi5VxF8qbCKMD9Z",
    title: "atlas holding the world hercules",
    list_url: "/styles/realism/atlas-holding-the-world-hercules"
  },
  {
    url: "/styles/realism/drug-cartel-theme-sleeve-5WNaYXdtidunkaVfeuTTrB",
    title: "drug cartel theme sleeve",
    list_url: "/styles/realism/drug-cartel-theme-sleeve"
  },
  {
    url: "/styles/realism/f22-raptor-EDGaUJ6vPRz9GZBUErJmDq",
    title: "f raptor",
    list_url: "/styles/realism/f22-raptor"
  },
  {
    url: "/styles/realism/father-and-son-basketball-4TQGQ2qHQ9rBAmT6fcUjjL",
    title: "father and son basketball",
    list_url: "/styles/realism/father-and-son-basketball"
  },
  {
    url: "/styles/realism/garcia-lettering-in-old-english-font-Co7Jy6JR799uwsKt6DnssL",
    title: "garcia lettering in old english font",
    list_url: "/styles/realism/garcia-lettering-in-old-english-font"
  },
  {
    url: "/styles/realism/hemanth-name-with-lion-face-on-N3KhfLpgdDb7RhSdWgcBW",
    title: "hemanth name with lion face on",
    list_url: "/styles/realism/hemanth-name-with-lion-face-on"
  },
  {
    url: "/styles/realism/red-hand-of-ulster-S6B3JJdQsWDWdsx8sfVssX",
    title: "red hand of ulster",
    list_url: "/styles/realism/red-hand-of-ulster"
  },
  {
    url: "/styles/realism/serbian-eagle-YCs1tgCRyfVTrwoK9o6czB",
    title: "serbian eagle",
    list_url: "/styles/realism/serbian-eagle"
  },
  {
    url: "/styles/realism/shield-of-faith-2MUEeex4biSQbpvdpzukwk",
    title: "shield of faith",
    list_url: "/styles/realism/shield-of-faith"
  },
  {
    url: "/styles/realism/spider-webs-and-spider-with-flowers-Jq9JWkzHgveHfSpQkT4iKC",
    title: "spider webs and spider with flowers",
    list_url: "/styles/realism/spider-webs-and-spider-with-flowers"
  },
  {
    url: "/styles/realism/three-goddesses-mother-maiden-crone-2vm2EuZBwFv4hwSLgE3d9U",
    title: "three goddesses mother maiden crone",
    list_url: "/styles/realism/three-goddesses-mother-maiden-crone"
  },
  {
    url: "/styles/realism/tiger-in-jungle-EGfU3gpWDev75oS8RT9iaM",
    title: "tiger in jungle",
    list_url: "/styles/realism/tiger-in-jungle"
  },
  {
    url: "/styles/realism/tree-of-life-half-alive-half-dead-CpZtUH34S54H8Hfk6GiK17",
    title: "tree of life half alive half dead",
    list_url: "/styles/realism/tree-of-life-half-alive-half-dead"
  },
  {
    url: "/styles/realism/warrior-from-ottoman-empire-or-mongol-88KL1V7vJAnfQdT5fGVGh",
    title: "warrior from ottoman empire or mongol",
    list_url: "/styles/realism/warrior-from-ottoman-empire-or-mongol"
  },
  {
    url: "/styles/sketch/a-phoenix-and-a-hummingbird-9hAfKUdCXWufSdSWZMj7bc",
    title: "a phoenix and a hummingbird",
    list_url: "/styles/sketch/a-phoenix-and-a-hummingbird"
  },
  {
    url: "/styles/sketch/an-hourglass-with-butterfly-wings-8K9JHBFAtwnfvHEwHpcLfp",
    title: "an hourglass with butterfly wings",
    list_url: "/styles/sketch/an-hourglass-with-butterfly-wings"
  },
  {
    url: "/styles/sketch/clock-333-CseMiRkgb2LCLdzd7jAG4h",
    title: "clock ",
    list_url: "/styles/sketch/clock-333"
  },
  {
    url: "/styles/sketch/coin-flipping-6yGue66hNFjEJziX4P1cHd",
    title: "coin flipping",
    list_url: "/styles/sketch/coin-flipping"
  },
  {
    url: "/styles/sketch/ephesians-28-9-for-by-grace-you-have-5bZVsP2VC492toCewihrhK",
    title: "ephesians for by grace you have",
    list_url: "/styles/sketch/ephesians-28-9-for-by-grace-you-have"
  },
  {
    url: "/styles/sketch/fear-nothing-conquer-everything-with-TmiG7P3aQRysZ2J7kSvpYS",
    title: "fear nothing conquer everything with",
    list_url: "/styles/sketch/fear-nothing-conquer-everything-with"
  },
  {
    url: "/styles/sketch/raju-and-neetu-BdDb2QFUMLNpJDEd83uTS4",
    title: "raju and neetu",
    list_url: "/styles/sketch/raju-and-neetu"
  },
  {
    url: "/styles/sketch/rowboat-2Jjx4KqXsXmj3GT1KpYbJ2",
    title: "rowboat",
    list_url: "/styles/sketch/rowboat"
  },
  {
    url: "/styles/sketch/russian-doll-UWPnJ3rtUBQtqtF69tyEuZ",
    title: "russian doll",
    list_url: "/styles/sketch/russian-doll"
  },
  {
    url: "/styles/sketch/small-paw-print-with-a-princess-crown-6JbtkraGtziiSqesRhLHmK",
    title: "small paw print with a princess crown",
    list_url: "/styles/sketch/small-paw-print-with-a-princess-crown"
  },
  {
    url: "/styles/sketch/starve-the-ego-feed-the-soul-BjUFDaZVRTDRAkzRXaV3EA",
    title: "starve the ego feed the soul",
    list_url: "/styles/sketch/starve-the-ego-feed-the-soul"
  },
  {
    url: "/styles/sketch/vaishno-devi-bhawan-katra-and-mata-rani-Ak45vu3ZLHpyYGWrKeb2iM",
    title: "vaishno devi bhawan katra and mata rani",
    list_url: "/styles/sketch/vaishno-devi-bhawan-katra-and-mata-rani"
  },
  {
    url: "/styles/stencil/heart-bubbles-7DzsD7XMxto45mwsCVAguN",
    title: "heart bubbles",
    list_url: "/styles/stencil/heart-bubbles"
  },
  {
    url: "/styles/stencil/juice-wrld-9ZcZBRNYYLYFu2mYUoiSTg",
    title: "juice wrld",
    list_url: "/styles/stencil/juice-wrld"
  },
  {
    url: "/styles/stencil/kj-Ruj9aSGRZUBf6ce2bCZcp3",
    title: "kj",
    list_url: "/styles/stencil/kj"
  },
  {
    url: "/styles/stencil/lich-adventure-time-tattoo-design-WjMq3h9QwKECQfuNsvzPWu",
    title: "lich adventure time tattoo design",
    list_url: "/styles/stencil/lich-adventure-time-tattoo-design"
  },
  {
    url: "/styles/surrealism/the-platons-allegory-of-the-cave-G1XT1Tat9FGdAzAde2S24d",
    title: "the platons allegory of the cave",
    list_url: "/styles/surrealism/the-platons-allegory-of-the-cave"
  },
  {
    url: "/styles/traditional/an-arborist-climbing-a-tree-G7cASH2yFpnR7ug6bxCgWN",
    title: "an arborist climbing a tree",
    list_url: "/styles/traditional/an-arborist-climbing-a-tree"
  },
  {
    url: "/styles/traditional/an-illegitimi-non-carborundum-quote-WShTETKepNKpLJWDqdQNFP",
    title: "an illegitimi non carborundum quote",
    list_url: "/styles/traditional/an-illegitimi-non-carborundum-quote"
  },
  {
    url: "/styles/traditional/bangladesh-H3JxLp3TrvfNEJWuLRmSLc",
    title: "bangladesh",
    list_url: "/styles/traditional/bangladesh"
  },
  {
    url: "/styles/traditional/cowboy-biker-3xoFwjtiDSpBjrnJbh1crm",
    title: "cowboy biker",
    list_url: "/styles/traditional/cowboy-biker"
  },
  {
    url: "/styles/traditional/endless-knot-with-bodhi-tree-PB8SA4Jm5d7kFjbQhZ57e5",
    title: "endless knot with bodhi tree",
    list_url: "/styles/traditional/endless-knot-with-bodhi-tree"
  },
  {
    url: "/styles/traditional/f15-strike-eagle-ENP1b13XNPB5H6S2tWuLZw",
    title: "f strike eagle",
    list_url: "/styles/traditional/f15-strike-eagle"
  },
  {
    url: "/styles/traditional/helicopter-SGTEiSSxY1rPpcYj63AiS1",
    title: "helicopter",
    list_url: "/styles/traditional/helicopter"
  },
  {
    url: "/styles/traditional/lacrosse-2HzZWwkeATL8FQ4Apyk9ae",
    title: "lacrosse",
    list_url: "/styles/traditional/lacrosse"
  },
  {
    url: "/styles/traditional/lily-with-bee-EFAq3UfCEVxfEAdYZrWuZF",
    title: "lily with bee",
    list_url: "/styles/traditional/lily-with-bee"
  },
  {
    url: "/styles/traditional/lucky-penny-9Sk6oyJMvV5hfi3JwfDXVm",
    title: "lucky penny",
    list_url: "/styles/traditional/lucky-penny"
  },
  {
    url: "/styles/traditional/name-nivi-viaan-and-kiara-HRwSwiPDie9EzdTEGebGDK",
    title: "name nivi viaan and kiara",
    list_url: "/styles/traditional/name-nivi-viaan-and-kiara"
  },
  {
    url: "/styles/traditional/time-in-a-bottle-time-turning-into-a-Kgm2rUbjFjyfmqFeXA631x",
    title: "time in a bottle time turning into a",
    list_url: "/styles/traditional/time-in-a-bottle-time-turning-into-a"
  },
  {
    url: "/styles/traditional/trap-house-X199G33rCnv4bvqfUqJpEU",
    title: "trap house",
    list_url: "/styles/traditional/trap-house"
  },
  {
    url: "/styles/trash-polka/ahegao-girl-side-view-sloppy-tongue-3pke1hE6vExewjFgvwpZk",
    title: "ahegao girl side view sloppy tongue",
    list_url: "/styles/trash-polka/ahegao-girl-side-view-sloppy-tongue"
  },
  {
    url: "/styles/tribal/dragon-climbing-back-of-the-right-NpBDSmxM8CjF5tS4MGZgjg",
    title: "dragon climbing back of the right",
    list_url: "/styles/tribal/dragon-climbing-back-of-the-right"
  },
  {
    url: "/styles/tribal/mauri-4W3QJcFPuXXQu2MLrVNFhV",
    title: "mauri",
    list_url: "/styles/tribal/mauri"
  },
  {
    url: "/styles/tribal/polynesian-arm-sleeve-9yS9bFTUk21nkw6S1iwuqr",
    title: "polynesian arm sleeve",
    list_url: "/styles/tribal/polynesian-arm-sleeve"
  },
  {
    url: "/styles/watercolor/disney-castle-and-fireworks-GGaXpUwNowktCbxrgg2qzi",
    title: "disney castle and fireworks",
    list_url: "/styles/watercolor/disney-castle-and-fireworks"
  },
  {
    url: "/styles/woodcut/type-tito-double-p-in-cursive-and-a-DBtG6FkWFiCmpZ4Qpa9duK",
    title: "type tito double p in cursive and a",
    list_url: "/styles/woodcut/type-tito-double-p-in-cursive-and-a"
  },
  {
    url: "/styles/3d/vaidehi-name-tattoo-MCLwHJgoasA4TxDshho54R",
    title: "vaidehi name tattoo",
    list_url: "/styles/3d/vaidehi-name-tattoo"
  },
  {
    url: "/styles/anime/devil-may-cry-5-vergil-GoVigW9WzukyGx1DQweCuG",
    title: "devil may cry vergil",
    list_url: "/styles/anime/devil-may-cry-5-vergil"
  },
  {
    url: "/styles/anime/sissyboy-femdom-femboy-girly-WTm9YkuuVHa9RhhTyD5iBV",
    title: "sissyboy femdom femboy girly",
    list_url: "/styles/anime/sissyboy-femdom-femboy-girly"
  },
  {
    url: "/styles/anime/transexual-bimbo-fornication-LJKkU1292FzJeVatfVsbWt",
    title: "transexual bimbo fornication",
    list_url: "/styles/anime/transexual-bimbo-fornication"
  },
  {
    url: "/styles/anime/xena-warrior-princess-with-her-chakram-KqdKDzRjSasYjoZNC5TKTN",
    title: "xena warrior princess with her chakram",
    list_url: "/styles/anime/xena-warrior-princess-with-her-chakram"
  },
  {
    url: "/styles/biomechanical/king-of-hearts-g-gundam-2vL4AmQ3qEJUgkF6VPcssP",
    title: "king of hearts g gundam",
    list_url: "/styles/biomechanical/king-of-hearts-g-gundam"
  },
  {
    url: "/styles/biomechanical/warhammer-40k-salamanders-heavy-power-BA7ufwUGLqSpjnBJQMkM2Y",
    title: "warhammer k salamanders heavy power",
    list_url: "/styles/biomechanical/warhammer-40k-salamanders-heavy-power"
  },
  {
    url: "/styles/black-grey/3-archangel-3AXGhaxD45afhGBb65LBRJ",
    title: " archangel",
    list_url: "/styles/black-grey/3-archangel"
  },
  {
    url: "/styles/black-grey/911-twin-towers-attack-on-pearl-QYw7DjQQAWwUDQGRJgSbVv",
    title: " twin towers attack on pearl",
    list_url: "/styles/black-grey/911-twin-towers-attack-on-pearl"
  },
  {
    url: "/styles/black-grey/a-black-panther-with-green-eyes-hand-SkVPfeF12FH9nw1xEgjsbe",
    title: "a black panther with green eyes hand",
    list_url: "/styles/black-grey/a-black-panther-with-green-eyes-hand"
  },
  {
    url: "/styles/black-grey/anika-and-ritika-daughters-name-in-one-LwEKYMHya6ceSe1QDHj2cR",
    title: "anika and ritika daughters name in one",
    list_url: "/styles/black-grey/anika-and-ritika-daughters-name-in-one"
  },
  {
    url: "/styles/black-grey/archangel-chamuel-WyXgBtzY1duXx6adkTkwDZ",
    title: "archangel chamuel",
    list_url: "/styles/black-grey/archangel-chamuel"
  },
  {
    url: "/styles/black-grey/artillery-TPDPiV1AdzwuXWX5jvaWAQ",
    title: "artillery",
    list_url: "/styles/black-grey/artillery"
  },
  {
    url: "/styles/black-grey/babli-name-written-Az61RvNHy6pXbnMTfWAPYi",
    title: "babli name written",
    list_url: "/styles/black-grey/babli-name-written"
  },
  {
    url: "/styles/black-grey/bumble-bee-daisy-chain-dragonfly-8eLZ3p554i8Y1cv3sPYq7a",
    title: "bumble bee daisy chain dragonfly",
    list_url: "/styles/black-grey/bumble-bee-daisy-chain-dragonfly"
  },
  {
    url: "/styles/black-grey/calypso-greek-myth-YXtJVfppa1wVNtZy74JwUK",
    title: "calypso greek myth",
    list_url: "/styles/black-grey/calypso-greek-myth"
  },
  {
    url: "/styles/black-grey/celtic-woman-warrior-DT4vpu1vf92myxD29XRPSD",
    title: "celtic woman warrior",
    list_url: "/styles/black-grey/celtic-woman-warrior"
  },
  {
    url: "/styles/black-grey/cosmos-and-honeysuckle-flowers-RLwPN21QspUuqYXox8k1r7",
    title: "cosmos and honeysuckle flowers",
    list_url: "/styles/black-grey/cosmos-and-honeysuckle-flowers"
  },
  {
    url: "/styles/black-grey/danielle-name-B9TQYZEwzxPesT9zJ8RV51",
    title: "danielle name",
    list_url: "/styles/black-grey/danielle-name"
  },
  {
    url: "/styles/black-grey/danny-in-cursive-font-5nkdvG3NXta2jyjJJY8iCk",
    title: "danny in cursive font",
    list_url: "/styles/black-grey/danny-in-cursive-font"
  },
  {
    url: "/styles/black-grey/demonic-alice-and-mad-hatter-in-QDSLm3iiGMdeuJUwHGgTBE",
    title: "demonic alice and mad hatter in",
    list_url: "/styles/black-grey/demonic-alice-and-mad-hatter-in"
  },
  {
    url: "/styles/black-grey/devil-may-cry-vergil-yamato-sword-A72z9wkqchMweqCTMGtTiT",
    title: "devil may cry vergil yamato sword",
    list_url: "/styles/black-grey/devil-may-cry-vergil-yamato-sword"
  },
  {
    url: "/styles/black-grey/dragon-ball-z-sleeve-tattoo-design-8B2MFvvbK5EzmUt1Y4BML2",
    title: "dragon ball z sleeve tattoo design",
    list_url: "/styles/black-grey/dragon-ball-z-sleeve-tattoo-design"
  },
  {
    url: "/styles/black-grey/dune-fear-is-the-mind-killer-XmyrR5EwqtFhYSu721K28c",
    title: "dune fear is the mind killer",
    list_url: "/styles/black-grey/dune-fear-is-the-mind-killer"
  },
  {
    url: "/styles/black-grey/faith-family-freedom-CmttoGJuFcngsuNNA23Gd4",
    title: "faith family freedom",
    list_url: "/styles/black-grey/faith-family-freedom"
  },
  {
    url: "/styles/black-grey/family-crest-kelly-representing-UNSENRu4CZ1XbfweYCZb8P",
    title: "family crest kelly representing",
    list_url: "/styles/black-grey/family-crest-kelly-representing"
  },
  {
    url: "/styles/black-grey/fierce-god-kaala-bhairav-2GAy55fbXVb1EkRXQhsNuf",
    title: "fierce god kaala bhairav",
    list_url: "/styles/black-grey/fierce-god-kaala-bhairav"
  },
  {
    url: "/styles/black-grey/flower-butterfly-clock-8oa6MLvhDvHHHvKa634V8h",
    title: "flower butterfly clock",
    list_url: "/styles/black-grey/flower-butterfly-clock"
  },
  {
    url: "/styles/black-grey/forest-fern-flowers-shoulder-collarbone-D7eAwDQi8KXNWTEvs2ymAn",
    title: "forest fern flowers shoulder collarbone",
    list_url: "/styles/black-grey/forest-fern-flowers-shoulder-collarbone"
  },
  {
    url: "/styles/black-grey/garter-thigh-with-dagger-2wSimWuKcAkbcr63G8nN7S",
    title: "garter thigh with dagger",
    list_url: "/styles/black-grey/garter-thigh-with-dagger"
  },
  {
    url: "/styles/black-grey/garza-last-name-tattoo-PXhxtiLbZA7iwV35VQnCTJ",
    title: "garza last name tattoo",
    list_url: "/styles/black-grey/garza-last-name-tattoo"
  },
  {
    url: "/styles/black-grey/heart-ribbon-and-name-rita-V48NJy7gTcUjY71HPkis8R",
    title: "heart ribbon and name rita",
    list_url: "/styles/black-grey/heart-ribbon-and-name-rita"
  },
  {
    url: "/styles/black-grey/hibiscus-flower-hummingbird-7YpkGhwBkrQEH6CqAqQtdP",
    title: "hibiscus flower hummingbird",
    list_url: "/styles/black-grey/hibiscus-flower-hummingbird"
  },
  {
    url: "/styles/black-grey/inner-bicep-tattoo-RdhzurBaXyXjN541nh8q7u",
    title: "inner bicep tattoo",
    list_url: "/styles/black-grey/inner-bicep-tattoo"
  },
  {
    url: "/styles/black-grey/its-better-to-be-a-warrior-in-a-garden-2eveQK6wVBDiGk7MGXSFpq",
    title: "its better to be a warrior in a garden",
    list_url: "/styles/black-grey/its-better-to-be-a-warrior-in-a-garden"
  },
  {
    url: "/styles/black-grey/jesus-and-devil-playing-chess-CSPPJkERHPXXDbLJjy7pbK",
    title: "jesus and devil playing chess",
    list_url: "/styles/black-grey/jesus-and-devil-playing-chess"
  },
  {
    url: "/styles/black-grey/killdozer-Uoeoh6asLuYtoxR1AY6BZ2",
    title: "killdozer",
    list_url: "/styles/black-grey/killdozer"
  },
  {
    url: "/styles/black-grey/kitsune-in-the-form-of-a-woman-naked-TJbp5F9bZwBKgDPrsA5tBN",
    title: "kitsune in the form of a woman naked",
    list_url: "/styles/black-grey/kitsune-in-the-form-of-a-woman-naked"
  },
  {
    url: "/styles/black-grey/leaf-CFaNrn6izNnj9SGBo9PWpt",
    title: "leaf",
    list_url: "/styles/black-grey/leaf"
  },
  {
    url: "/styles/black-grey/lefty-sm-Dug7nY861DhAKZYGo923nH",
    title: "lefty sm",
    list_url: "/styles/black-grey/lefty-sm"
  },
  {
    url: "/styles/black-grey/leo-capricorn-and-virgo-3AXzLrQ5gkHWd62qHNNah8",
    title: "leo capricorn and virgo",
    list_url: "/styles/black-grey/leo-capricorn-and-virgo"
  },
  {
    url: "/styles/black-grey/letter-j-and-a-kings-crown-Wm2rGRLRQ8u7SejYPetpay",
    title: "letter j and a kings crown",
    list_url: "/styles/black-grey/letter-j-and-a-kings-crown"
  },
  {
    url: "/styles/black-grey/loyalty-respect-27SS4La3VHnkVVMG5ADoKu",
    title: "loyalty respect",
    list_url: "/styles/black-grey/loyalty-respect"
  },
  {
    url: "/styles/black-grey/macedonian-vergina-sun-symbol-BdBKYM1NgfuFEGPGbQ4cyr",
    title: "macedonian vergina sun symbol",
    list_url: "/styles/black-grey/macedonian-vergina-sun-symbol"
  },
  {
    url: "/styles/black-grey/marvin-the-martian-KngHTPvueMDGSvgvUa58sj",
    title: "marvin the martian",
    list_url: "/styles/black-grey/marvin-the-martian"
  },
  {
    url: "/styles/black-grey/medjay-badge-72EGH1aKey8DntBsD6K7nj",
    title: "medjay badge",
    list_url: "/styles/black-grey/medjay-badge"
  },
  {
    url: "/styles/black-grey/mexican-cultural-tattoo-rose-tattoo-EQ3FnSknEkfXnStsGLHxmS",
    title: "mexican cultural tattoo rose tattoo",
    list_url: "/styles/black-grey/mexican-cultural-tattoo-rose-tattoo"
  },
  {
    url: "/styles/black-grey/mind-over-matter-central-cee-tattoo-Hf9nxFnLHSGWQehr2qzDBE",
    title: "mind over matter central cee tattoo",
    list_url: "/styles/black-grey/mind-over-matter-central-cee-tattoo"
  },
  {
    url: "/styles/black-grey/money-over-bitches-MY4WZhCvSahC9HtvpNJEbA",
    title: "money over bitches",
    list_url: "/styles/black-grey/money-over-bitches"
  },
  {
    url: "/styles/black-grey/mum-and-dad-monkey-with-baby-monkey-63XgXwnTNqMM5roHkfqGSo",
    title: "mum and dad monkey with baby monkey",
    list_url: "/styles/black-grey/mum-and-dad-monkey-with-baby-monkey"
  },
  {
    url: "/styles/black-grey/mushu-dragon-from-mulan-Pdi2S9TSxe3G357SjdrCV4",
    title: "mushu dragon from mulan",
    list_url: "/styles/black-grey/mushu-dragon-from-mulan"
  },
  {
    url: "/styles/black-grey/music-notes-flower-Q6En2EnfJqkjDcAEN2bftJ",
    title: "music notes flower",
    list_url: "/styles/black-grey/music-notes-flower"
  },
  {
    url: "/styles/black-grey/naked-anime-girl-from-behind-erotic-Ra3rnCU5QUUkRecEwzfGr7",
    title: "naked anime girl from behind erotic",
    list_url: "/styles/black-grey/naked-anime-girl-from-behind-erotic"
  },
  {
    url: "/styles/black-grey/name-written-brittany-6U8F57DtrdDxtQmRx6GVdH",
    title: "name written brittany",
    list_url: "/styles/black-grey/name-written-brittany"
  },
  {
    url: "/styles/black-grey/narendra-name-tattoo-LCmuTqdzRbQN4ZT7tmt2By",
    title: "narendra name tattoo",
    list_url: "/styles/black-grey/narendra-name-tattoo"
  },
  {
    url: "/styles/black-grey/native-american-spirit-horse-CXwTMviFMB55Y6tT76ama7",
    title: "native american spirit horse",
    list_url: "/styles/black-grey/native-american-spirit-horse"
  },
  {
    url: "/styles/black-grey/newcastle-united-football-club-logo-MHN7qS6Wc222XgA5cumUYw",
    title: "newcastle united football club logo",
    list_url: "/styles/black-grey/newcastle-united-football-club-logo"
  },
  {
    url: "/styles/black-grey/nicole-name-tattoo-XwkAHU4ytdytsBF2wPzQkb",
    title: "nicole name tattoo",
    list_url: "/styles/black-grey/nicole-name-tattoo"
  },
  {
    url: "/styles/black-grey/proverbs-1717-LaFB4UW2iLNHndYux8KhBX",
    title: "proverbs ",
    list_url: "/styles/black-grey/proverbs-1717"
  },
  {
    url: "/styles/black-grey/quote-burn-the-boats-FcWtddk17NU2QU3wePsiiP",
    title: "quote burn the boats",
    list_url: "/styles/black-grey/quote-burn-the-boats"
  },
  {
    url: "/styles/black-grey/rod-and-staff-CaGmES1W6AFmQBVrYEwEHt",
    title: "rod and staff",
    list_url: "/styles/black-grey/rod-and-staff"
  },
  {
    url: "/styles/black-grey/roman-numerals-date-june-18-2015-april-Ft14rfZEw3Mw1oyCFpw1wb",
    title: "roman numerals date june april",
    list_url: "/styles/black-grey/roman-numerals-date-june-18-2015-april"
  },
  {
    url: "/styles/black-grey/romans-828-bible-verse-NxfeDYtSDjU3rRLHqDcMeg",
    title: "romans bible verse",
    list_url: "/styles/black-grey/romans-828-bible-verse"
  },
  {
    url: "/styles/black-grey/roses-with-vines-C5KdHqR5QwnEhFzQC22zi8",
    title: "roses with vines",
    list_url: "/styles/black-grey/roses-with-vines"
  },
  {
    url: "/styles/black-grey/script-adrian-SRonnrUnCevoZxaakS8WaK",
    title: "script adrian",
    list_url: "/styles/black-grey/script-adrian"
  },
  {
    url: "/styles/black-grey/shobha-name-C6jwGUW4iQ9z5pBE34tad8",
    title: "shobha name",
    list_url: "/styles/black-grey/shobha-name"
  },
  {
    url: "/styles/black-grey/skull-ripping-skin-NWwj7CGLG48BtyaAo2MFjS",
    title: "skull ripping skin",
    list_url: "/styles/black-grey/skull-ripping-skin"
  },
  {
    url: "/styles/black-grey/st-michael-angel-with-skull-as-head-7V6HdNa91how7ZB7gEPTDv",
    title: "st michael angel with skull as head",
    list_url: "/styles/black-grey/st-michael-angel-with-skull-as-head"
  },
  {
    url: "/styles/black-grey/star-trek-enterprise-PK6kYfPPfk1tCt4ZueNawn",
    title: "star trek enterprise",
    list_url: "/styles/black-grey/star-trek-enterprise"
  },
  {
    url: "/styles/black-grey/star-wars-light-side-vs-dark-side-simple-3g5urYg9xw6RNsqjvVapor",
    title: "star wars light side vs dark side simple",
    list_url: "/styles/black-grey/star-wars-light-side-vs-dark-side-simple"
  },
  {
    url: "/styles/black-grey/sun-rays-shining-through-clouds-5rgPWiEL9EfxGEh1gv71KT",
    title: "sun rays shining through clouds",
    list_url: "/styles/black-grey/sun-rays-shining-through-clouds"
  },
  {
    url: "/styles/black-grey/sundrop-flower-from-tangled-EotUj4T6HbEjdREH9Pmsx2",
    title: "sundrop flower from tangled",
    list_url: "/styles/black-grey/sundrop-flower-from-tangled"
  },
  {
    url: "/styles/black-grey/sword-with-roman-numerals-of-1-8-2008-Hu4bU1AmGJkz6xuXBo4boD",
    title: "sword with roman numerals of ",
    list_url: "/styles/black-grey/sword-with-roman-numerals-of-1-8-2008"
  },
  {
    url: "/styles/black-grey/the-name-morgan-behind-the-ear-5XukhhE1z62d2KpF5aaY66",
    title: "the name morgan behind the ear",
    list_url: "/styles/black-grey/the-name-morgan-behind-the-ear"
  },
  {
    url: "/styles/black-grey/the-oath-of-spartacus-the-misanthrope-3D7DjWH4UDUG4pUsHjKRdQ",
    title: "the oath of spartacus the misanthrope",
    list_url: "/styles/black-grey/the-oath-of-spartacus-the-misanthrope"
  },
  {
    url: "/styles/black-grey/the-ride-is-worth-the-fall-EWmcD7Cb1wBjbVivDJUfTj",
    title: "the ride is worth the fall",
    list_url: "/styles/black-grey/the-ride-is-worth-the-fall"
  },
  {
    url: "/styles/black-grey/titanfall-2-MUpcGUjhgBRHYzNjjsyKZj",
    title: "titanfall ",
    list_url: "/styles/black-grey/titanfall-2"
  },
  {
    url: "/styles/black-grey/two-hands-reaching-out-to-each-other-MNJzvVd1hTsjgHjqDLjL95",
    title: "two hands reaching out to each other",
    list_url: "/styles/black-grey/two-hands-reaching-out-to-each-other"
  },
  {
    url: "/styles/black-grey/umbreon-pokemon-TJhUyck1ef2vaaNZsvB6q7",
    title: "umbreon pokemon",
    list_url: "/styles/black-grey/umbreon-pokemon"
  },
  {
    url: "/styles/black-grey/utrinque-paratus-for-the-letter-with-DiBr65DxTGdfFD2Vi85cdB",
    title: "utrinque paratus for the letter with",
    list_url: "/styles/black-grey/utrinque-paratus-for-the-letter-with"
  },
  {
    url: "/styles/black-grey/veritas-aequitas-boondock-saints-RoSY9mRVu6Aad2auipuqZg",
    title: "veritas aequitas boondock saints",
    list_url: "/styles/black-grey/veritas-aequitas-boondock-saints"
  },
  {
    url: "/styles/black-grey/warrior-style-saint-michael-archangel-Nws8tTCZ1uCk4P1F5Fengn",
    title: "warrior style saint michael archangel",
    list_url: "/styles/black-grey/warrior-style-saint-michael-archangel"
  },
  {
    url: "/styles/black-grey/water-lily-and-larkspur-flower-PwLNzy4xPfhWJajmp6fSwo",
    title: "water lily and larkspur flower",
    list_url: "/styles/black-grey/water-lily-and-larkspur-flower"
  },
  {
    url: "/styles/black-grey/world-of-warcraft-holy-priest-Q3Lucnrvwg4AkPkf4YoBMY",
    title: "world of warcraft holy priest",
    list_url: "/styles/black-grey/world-of-warcraft-holy-priest"
  },
  {
    url: "/styles/blackwork/7-horses-in-one-horse-face-5K252S9ojkmDGfZeXXP159",
    title: " horses in one horse face",
    list_url: "/styles/blackwork/7-horses-in-one-horse-face"
  },
  {
    url: "/styles/blackwork/a-spider-lily-intertwined-with-a-koi-6vmUaLKcvbHKmPJVJtVHaR",
    title: "a spider lily intertwined with a koi",
    list_url: "/styles/blackwork/a-spider-lily-intertwined-with-a-koi"
  },
  {
    url: "/styles/blackwork/a-tattoo-design-featuring-a-metis-3XteaSPqq51No5Ftkdcv6E",
    title: "a tattoo design featuring a metis",
    list_url: "/styles/blackwork/a-tattoo-design-featuring-a-metis"
  },
  {
    url: "/styles/blackwork/alcatraz-swim-V6MhJiQgxACa8yhvoGXTRP",
    title: "alcatraz swim",
    list_url: "/styles/blackwork/alcatraz-swim"
  },
  {
    url: "/styles/blackwork/allison-name-tattoo-QSZoMev7rhxHgKJtw5B9oi",
    title: "allison name tattoo",
    list_url: "/styles/blackwork/allison-name-tattoo"
  },
  {
    url: "/styles/blackwork/ambigram-of-words-saint-thief-in-7LcWRumMgiyMwjUxhUPQvt",
    title: "ambigram of words saint thief in",
    list_url: "/styles/blackwork/ambigram-of-words-saint-thief-in"
  },
  {
    url: "/styles/blackwork/an-anchor-with-rope-tide-to-arm-KSrBU61M5HDm57tX281D8z",
    title: "an anchor with rope tide to arm",
    list_url: "/styles/blackwork/an-anchor-with-rope-tide-to-arm"
  },
  {
    url: "/styles/blackwork/archangel-michael-sigil-combined-with-a-ApWeysfv42aRQfN6ax5VAa",
    title: "archangel michael sigil combined with a",
    list_url: "/styles/blackwork/archangel-michael-sigil-combined-with-a"
  },
  {
    url: "/styles/blackwork/baby-angels-see-no-evil-hear-no-evil-GnmL1ar4nvDMuVwwgaT8LC",
    title: "baby angels see no evil hear no evil",
    list_url: "/styles/blackwork/baby-angels-see-no-evil-hear-no-evil"
  },
  {
    url: "/styles/blackwork/bhishma-pitamah-mahabharata-HEoyUVimvSxUurGDBmZ5vR",
    title: "bhishma pitamah mahabharata",
    list_url: "/styles/blackwork/bhishma-pitamah-mahabharata"
  },
  {
    url: "/styles/blackwork/black-woman-with-locs-U5FNfmrovvAFSyFZJ1bkEB",
    title: "black woman with locs",
    list_url: "/styles/blackwork/black-woman-with-locs"
  },
  {
    url: "/styles/blackwork/bmw-m3-ERqhweJRqVaSZm2YoS5SfT",
    title: "bmw m ",
    list_url: "/styles/blackwork/bmw-m3"
  },
  {
    url: "/styles/blackwork/born-to-die-lana-del-rey-3EjVtYwWMWaNoHJK2BgwbH",
    title: "born to die lana del rey",
    list_url: "/styles/blackwork/born-to-die-lana-del-rey"
  },
  {
    url: "/styles/blackwork/car-v8-engine-HuALGY3bPTSi2oePxtRRvs",
    title: "car v engine",
    list_url: "/styles/blackwork/car-v8-engine"
  },
  {
    url: "/styles/blackwork/chinese-zodiac-rooster-Rvy5ZB5xKNjyjuTZdDJ6dz",
    title: "chinese zodiac rooster",
    list_url: "/styles/blackwork/chinese-zodiac-rooster"
  },
  {
    url: "/styles/blackwork/deadpool-and-cable-XYjcA4q8KioeCT16E4gQ9w",
    title: "deadpool and cable",
    list_url: "/styles/blackwork/deadpool-and-cable"
  },
  {
    url: "/styles/blackwork/deftones-diamond-eyes-album-cover-owl-R9YRdFfs9CyvruKenVgtM",
    title: "deftones diamond eyes album cover owl",
    list_url: "/styles/blackwork/deftones-diamond-eyes-album-cover-owl"
  },
  {
    url: "/styles/blackwork/femboy-9DZsudN5t5Gg4H6ucqA9DD",
    title: "femboy",
    list_url: "/styles/blackwork/femboy"
  },
  {
    url: "/styles/blackwork/grim-reaper-holding-pit-bull-dogs-2u2piQv7RiR8YVd2uyMRE8",
    title: "grim reaper holding pit bull dogs",
    list_url: "/styles/blackwork/grim-reaper-holding-pit-bull-dogs"
  },
  {
    url: "/styles/blackwork/half-venom-half-spiderman-face-black-MxK5aphm7qYBmdeJ8Dkr5o",
    title: "half venom half spiderman face black",
    list_url: "/styles/blackwork/half-venom-half-spiderman-face-black"
  },
  {
    url: "/styles/blackwork/lenca-heritage-3ApAAWnn24BZ1KDGQsS9Sp",
    title: "lenca heritage",
    list_url: "/styles/blackwork/lenca-heritage"
  },
  {
    url: "/styles/blackwork/lifes-a-gamble-DuQZALxRAg72KpZhBUw9NP",
    title: "lifes a gamble",
    list_url: "/styles/blackwork/lifes-a-gamble"
  },
  {
    url: "/styles/blackwork/lion-celtic-knots-ARerXwwtqMGMudQFEVHPFb",
    title: "lion celtic knots",
    list_url: "/styles/blackwork/lion-celtic-knots"
  },
  {
    url: "/styles/blackwork/london-double-decker-bus-2p5NaNY48RygSsTFyemh8Q",
    title: "london double decker bus",
    list_url: "/styles/blackwork/london-double-decker-bus"
  },
  {
    url: "/styles/blackwork/lord-of-the-rings-forearm-2BKNcT32LjKVBDwTsq9dtr",
    title: "lord of the rings forearm",
    list_url: "/styles/blackwork/lord-of-the-rings-forearm"
  },
  {
    url: "/styles/blackwork/makoa-hawaiian-warrior-with-hawaiian-TjyUJaxyGQ6XH1mYFxH4AE",
    title: "makoa hawaiian warrior with hawaiian",
    list_url: "/styles/blackwork/makoa-hawaiian-warrior-with-hawaiian"
  },
  {
    url: "/styles/blackwork/name-anjali-Qydy9vSqeyyEuhTtY5rahp",
    title: "name anjali",
    list_url: "/styles/blackwork/name-anjali"
  },
  {
    url: "/styles/blackwork/notre-dame-fighting-irish-5vovdP7BXPMxCCb7Yo25sD",
    title: "notre dame fighting irish",
    list_url: "/styles/blackwork/notre-dame-fighting-irish"
  },
  {
    url: "/styles/blackwork/papa-bear-with-cubs-playing-JgrHiNoUjXJ2ChP4AEtdVL",
    title: "papa bear with cubs playing",
    list_url: "/styles/blackwork/papa-bear-with-cubs-playing"
  },
  {
    url: "/styles/blackwork/phrase-oh-heavenly-father-bear-TnxYwZCbu7SDPAk99zHFj5",
    title: "phrase oh heavenly father bear",
    list_url: "/styles/blackwork/phrase-oh-heavenly-father-bear"
  },
  {
    url: "/styles/blackwork/radhika-name-tattoo-GxRxx7t3NYhKAAmrMhAXyZ",
    title: "radhika name tattoo",
    list_url: "/styles/blackwork/radhika-name-tattoo"
  },
  {
    url: "/styles/blackwork/rose-with-heartbeat-for-stem-7jaHtMkSw3fVWfQAKajd2V",
    title: "rose with heartbeat for stem",
    list_url: "/styles/blackwork/rose-with-heartbeat-for-stem"
  },
  {
    url: "/styles/blackwork/sermon-on-the-mount-jesus-WQPg18PV2tBzSpeeEwa6oi",
    title: "sermon on the mount jesus",
    list_url: "/styles/blackwork/sermon-on-the-mount-jesus"
  },
  {
    url: "/styles/blackwork/shoulder-pad-Xx2PvtwbxhvB1b3widggrM",
    title: "shoulder pad",
    list_url: "/styles/blackwork/shoulder-pad"
  },
  {
    url: "/styles/blackwork/slow-is-smooth-smooth-is-fast-Lx9PYebKmY6Kkdt9dRYgxz",
    title: "slow is smooth smooth is fast",
    list_url: "/styles/blackwork/slow-is-smooth-smooth-is-fast"
  },
  {
    url: "/styles/blackwork/squiggly-lines-4wxfrw8etuAfEXqz894wGK",
    title: "squiggly lines",
    list_url: "/styles/blackwork/squiggly-lines"
  },
  {
    url: "/styles/blackwork/st-andrew-cross-represented-with-wide-5kxm9bDJGYw6XPrDqMdi8d",
    title: "st andrew cross represented with wide",
    list_url: "/styles/blackwork/st-andrew-cross-represented-with-wide"
  },
  {
    url: "/styles/blackwork/tatya-vinchu-BZisHvK8b5ZJvEb6nn9ncn",
    title: "tatya vinchu",
    list_url: "/styles/blackwork/tatya-vinchu"
  },
  {
    url: "/styles/blackwork/the-lion-and-the-phoenix-7VcuGtQaQuHCGuc1iarxaw",
    title: "the lion and the phoenix",
    list_url: "/styles/blackwork/the-lion-and-the-phoenix"
  },
  {
    url: "/styles/blackwork/the-name-angie-VRZLuNFVtDxQYL46QwSipj",
    title: "the name angie",
    list_url: "/styles/blackwork/the-name-angie"
  },
  {
    url: "/styles/blackwork/tibetan-snow-lion-X1dCigdtK6qWFD5czGxr17",
    title: "tibetan snow lion",
    list_url: "/styles/blackwork/tibetan-snow-lion"
  },
  {
    url: "/styles/blackwork/veena-T4v78c1eN57PxnCTzSpFyJ",
    title: "veena",
    list_url: "/styles/blackwork/veena"
  },
  {
    url: "/styles/blackwork/weight-of-the-world-on-your-shoulders-R6hwV4KznsfaRPWgicZMAc",
    title: "weight of the world on your shoulders",
    list_url: "/styles/blackwork/weight-of-the-world-on-your-shoulders"
  },
  {
    url: "/styles/blackwork/white-wolf-fighting-black-wolf-DGmVycxtyQxGPU2LgpMsoC",
    title: "white wolf fighting black wolf",
    list_url: "/styles/blackwork/white-wolf-fighting-black-wolf"
  },
  {
    url: "/styles/blackwork/yash-and-shruti-name-logo-tattoo-for-LYcmRWUzBhrMEWHRwETQMC",
    title: "yash and shruti name logo tattoo for",
    list_url: "/styles/blackwork/yash-and-shruti-name-logo-tattoo-for"
  },
  {
    url: "/styles/blackwork/yggdrasil-with-ratatoskr-a9VdjXgwme4n3YruGtb2J",
    title: "yggdrasil with ratatoskr",
    list_url: "/styles/blackwork/yggdrasil-with-ratatoskr"
  },
  {
    url: "/styles/chicano/bengali-girl-wearing-saree-RV4nYPE9KZ227ykDx11adM",
    title: "bengali girl wearing saree",
    list_url: "/styles/chicano/bengali-girl-wearing-saree"
  },
  {
    url: "/styles/chicano/gangster-font-with-letters-j-l-m-HGCdU8Lm1w3if5Xw7B8Mun",
    title: "gangster font with letters j l m",
    list_url: "/styles/chicano/gangster-font-with-letters-j-l-m"
  },
  {
    url: "/styles/cyber-sigilism/roses-RKmjUZqBB9FFFv4FZwgkm8",
    title: "roses",
    list_url: "/styles/cyber-sigilism/roses"
  },
  {
    url: "/styles/dotwork/an-ancient-celtic-symbol-of-gratitude-FsAJX1kkUJKXi7HtcrY7Et",
    title: "an ancient celtic symbol of gratitude",
    list_url: "/styles/dotwork/an-ancient-celtic-symbol-of-gratitude"
  },
  {
    url: "/styles/dotwork/busty-anime-goth-girl-with-black-hair-PMm1LbSQRvBDtcwa4UW6CH",
    title: "busty anime goth girl with black hair",
    list_url: "/styles/dotwork/busty-anime-goth-girl-with-black-hair"
  },
  {
    url: "/styles/dotwork/bwc-8HCv1EENmoNEk2Ya87MLiM",
    title: "bwc",
    list_url: "/styles/dotwork/bwc"
  },
  {
    url: "/styles/dotwork/dolphin-in-hibiscus-flowers-MDgHxovhNupgg81oMjoaRD",
    title: "dolphin in hibiscus flowers",
    list_url: "/styles/dotwork/dolphin-in-hibiscus-flowers"
  },
  {
    url: "/styles/dotwork/erika-name-TFQBrm8zadkZidW2Jq21sA",
    title: "erika name",
    list_url: "/styles/dotwork/erika-name"
  },
  {
    url: "/styles/dotwork/feminine-bald-eagle-with-flowers-VcHsCsoBQ5PniY5nfktcv7",
    title: "feminine bald eagle with flowers",
    list_url: "/styles/dotwork/feminine-bald-eagle-with-flowers"
  },
  {
    url: "/styles/dotwork/foot-ankle-tattoo-a-robin-the-bird-32CAHHKgXPGdjuRmPD55iV",
    title: "foot ankle tattoo a robin the bird",
    list_url: "/styles/dotwork/foot-ankle-tattoo-a-robin-the-bird"
  },
  {
    url: "/styles/dotwork/fvck-luv-duki-cro-MvBEMpo56QqbXYw8YBjS1h",
    title: "fvck luv duki cro",
    list_url: "/styles/dotwork/fvck-luv-duki-cro"
  },
  {
    url: "/styles/dotwork/goku-and-chi-chi-N3EAnzSR3Z74XBj7P2sy73",
    title: "goku and chi chi",
    list_url: "/styles/dotwork/goku-and-chi-chi"
  },
  {
    url: "/styles/dotwork/guatemala-volcanoes-piramids-tecun-QE1xMW5K5jRJSySgbjmZet",
    title: "guatemala volcanoes piramids tecun",
    list_url: "/styles/dotwork/guatemala-volcanoes-piramids-tecun"
  },
  {
    url: "/styles/dotwork/holy-spirit-dove-on-fire-FkEnRpQWZpLZMhsKj9V6BD",
    title: "holy spirit dove on fire",
    list_url: "/styles/dotwork/holy-spirit-dove-on-fire"
  },
  {
    url: "/styles/dotwork/italian-mafia-SPqKpzfD2oWE9XMuYMm1Rs",
    title: "italian mafia",
    list_url: "/styles/dotwork/italian-mafia"
  },
  {
    url: "/styles/dotwork/lotus-flower-with-wolf-FTtdeYUDiuuWAFcUMRn2P5",
    title: "lotus flower with wolf",
    list_url: "/styles/dotwork/lotus-flower-with-wolf"
  },
  {
    url: "/styles/dotwork/map-of-guyana-with-a-jaguar-inside-3CU5KQF4XBFxgwCf7gzfSy",
    title: "map of guyana with a jaguar inside",
    list_url: "/styles/dotwork/map-of-guyana-with-a-jaguar-inside"
  },
  {
    url: "/styles/dotwork/medusa-with-lotus-flowers-in-air-AxDRwUTEkVaM5YH3KtWWqn",
    title: "medusa with lotus flowers in air",
    list_url: "/styles/dotwork/medusa-with-lotus-flowers-in-air"
  },
  {
    url: "/styles/dotwork/meth-pipe-skull-DSDoqqNxPkWqZJpfiv651X",
    title: "meth pipe skull",
    list_url: "/styles/dotwork/meth-pipe-skull"
  },
  {
    url: "/styles/dotwork/never-satisfied-55gQGqMykMNy59vKVp4L53",
    title: "never satisfied",
    list_url: "/styles/dotwork/never-satisfied"
  },
  {
    url: "/styles/dotwork/omnia-in-bonum-9LNyrSnKhAHrCTBLdMzBsz",
    title: "omnia in bonum",
    list_url: "/styles/dotwork/omnia-in-bonum"
  },
  {
    url: "/styles/dotwork/queen-crown-of-latin-kings-gang-tatto-DrojqBiMvpHW62oWsGKXo5",
    title: "queen crown of latin kings gang tatto",
    list_url: "/styles/dotwork/queen-crown-of-latin-kings-gang-tatto"
  },
  {
    url: "/styles/dotwork/real-steel-atom-6if1S8EZU8UYhaVGaaKYYv",
    title: "real steel atom",
    list_url: "/styles/dotwork/real-steel-atom"
  },
  {
    url: "/styles/dotwork/ring-finger-tattoo-to-find-letter-b-BCtw3PAXr8rNrbycyTrVK2",
    title: "ring finger tattoo to find letter b",
    list_url: "/styles/dotwork/ring-finger-tattoo-to-find-letter-b"
  },
  {
    url: "/styles/dotwork/satvik-written-in-korean-AKnrKMkdkBV94WWvnGnBUZ",
    title: "satvik written in korean",
    list_url: "/styles/dotwork/satvik-written-in-korean"
  },
  {
    url: "/styles/dotwork/sun-and-horse-RrxjxtgPxHKMdVrzEY8FFU",
    title: "sun and horse",
    list_url: "/styles/dotwork/sun-and-horse"
  },
  {
    url: "/styles/dotwork/viking-outer-bicep-CS46REVxukFvGnCypJpiRx",
    title: "viking outer bicep",
    list_url: "/styles/dotwork/viking-outer-bicep"
  },
  {
    url: "/styles/dotwork/water-fairy-RRE6dKRgafvgJrfxFYk3Qz",
    title: "water fairy",
    list_url: "/styles/dotwork/water-fairy"
  },
  {
    url: "/styles/geometric/constellation-cassiopeia-34v72pAR2quNJyyF1yLqtY",
    title: "constellation cassiopeia",
    list_url: "/styles/geometric/constellation-cassiopeia"
  },
  {
    url: "/styles/geometric/dhanu-rashi-PXKHaNoGXaaxgaYwwn8jNB",
    title: "dhanu rashi",
    list_url: "/styles/geometric/dhanu-rashi"
  },
  {
    url: "/styles/geometric/f-18-super-hornet-MuvCWURcveAtiZTXDvbCXq",
    title: "f super hornet",
    list_url: "/styles/geometric/f-18-super-hornet"
  },
  {
    url: "/styles/geometric/mandala-and-geometric-knee-TPWdM1bgMnbg1PzScXUixt",
    title: "mandala and geometric knee",
    list_url: "/styles/geometric/mandala-and-geometric-knee"
  },
  {
    url: "/styles/geometric/serenity-prayer-Fdxfujt8UNB1bhNbRrzStZ",
    title: "serenity prayer",
    list_url: "/styles/geometric/serenity-prayer"
  },
  {
    url: "/styles/geometric/siddhi-name-tattoo-in-curve-unique-JrhYCixg9ZWFvNLrwkgze4",
    title: "siddhi name tattoo in curve unique",
    list_url: "/styles/geometric/siddhi-name-tattoo-in-curve-unique"
  },
  {
    url: "/styles/gothic/letters-jm-initials-8PnqNMRTx1nbtY8XxrdcEo",
    title: "letters jm initials",
    list_url: "/styles/gothic/letters-jm-initials"
  },
  {
    url: "/styles/japanese/bend-overslim-thick-goth-girlemo-JAGXbBY2cCerokw6yhBe3P",
    title: "bend overslim thick goth girlemo",
    list_url: "/styles/japanese/bend-overslim-thick-goth-girlemo"
  },
  {
    url: "/styles/japanese/blue-cloud-WTQgFXCRJDoqxu3Avf97a8",
    title: "blue cloud",
    list_url: "/styles/japanese/blue-cloud"
  },
  {
    url: "/styles/japanese/dachshund-8P6HUgg9oXaKPdJuKKxaDf",
    title: "dachshund",
    list_url: "/styles/japanese/dachshund"
  },
  {
    url: "/styles/japanese/half-sleeve-irezumi-waves-G2dEcyZYy6Lw7fsD3CU37U",
    title: "half sleeve irezumi waves",
    list_url: "/styles/japanese/half-sleeve-irezumi-waves"
  },
  {
    url: "/styles/japanese/hummingbird-2tccpmkqXcmQsVPEtJsMi9",
    title: "hummingbird",
    list_url: "/styles/japanese/hummingbird"
  },
  {
    url: "/styles/japanese/kirin-Tz1tVePtnb15eUca1RHwEQ",
    title: "kirin",
    list_url: "/styles/japanese/kirin"
  },
  {
    url: "/styles/japanese/mulberry-tree-URgyEFGvsqctVKPrpX6yPz",
    title: "mulberry tree",
    list_url: "/styles/japanese/mulberry-tree"
  },
  {
    url: "/styles/japanese/patchwork-leg-tattoo-GxH2xfiLtKgHacrcw8iXND",
    title: "patchwork leg tattoo",
    list_url: "/styles/japanese/patchwork-leg-tattoo"
  },
  {
    url: "/styles/japanese/pin-up-girl-4u5V7WCCjGi9jPRAmRmFbd",
    title: "pin up girl",
    list_url: "/styles/japanese/pin-up-girl"
  },
  {
    url: "/styles/japanese/snake-and-koi-fish-in-the-collarbone-QTZozMSbjv9F1oFQCPa4zd",
    title: "snake and koi fish in the collarbone",
    list_url: "/styles/japanese/snake-and-koi-fish-in-the-collarbone"
  },
  {
    url: "/styles/japanese/succubus-UxfBxvtxomwQfVBSaKouUs",
    title: "succubus",
    list_url: "/styles/japanese/succubus"
  },
  {
    url: "/styles/japanese/torii-gate-5rA9Y55V7xGf8gbwngQSje",
    title: "torii gate",
    list_url: "/styles/japanese/torii-gate"
  },
  {
    url: "/styles/japanese/viraj-name-with-dragon-69pjw6SDyX5UCXUY83sCmA",
    title: "viraj name with dragon",
    list_url: "/styles/japanese/viraj-name-with-dragon"
  },
  {
    url: "/styles/japanese/yin-yang-panther-and-tiger-GC8nQv4iGfr2BxuPkhCvZB",
    title: "yin yang panther and tiger",
    list_url: "/styles/japanese/yin-yang-panther-and-tiger"
  },
  {
    url: "/styles/minimalist/2011-in-roman-numerals-GPWbVgMvjx9gFc54o5ZvAM",
    title: " in roman numerals",
    list_url: "/styles/minimalist/2011-in-roman-numerals"
  },
  {
    url: "/styles/minimalist/6-6-23-in-roman-numerals-letter-l-VAuSFhT6U42dAhLwY5vraj",
    title: " in roman numerals letter l",
    list_url: "/styles/minimalist/6-6-23-in-roman-numerals-letter-l"
  },
  {
    url: "/styles/minimalist/a-bouquet-of-snowdrop-flower-cosmos-3v7ubsJmVsG7tsG3B75gu4",
    title: "a bouquet of snowdrop flower cosmos",
    list_url: "/styles/minimalist/a-bouquet-of-snowdrop-flower-cosmos"
  },
  {
    url: "/styles/minimalist/a-british-shorthair-cat-AQmahiAcnQe8SWx4QH1sRC",
    title: "a british shorthair cat",
    list_url: "/styles/minimalist/a-british-shorthair-cat"
  },
  {
    url: "/styles/minimalist/a-combination-of-the-names-sharon-AQdevsdAjUMu5S74KXskWN",
    title: "a combination of the names sharon",
    list_url: "/styles/minimalist/a-combination-of-the-names-sharon"
  },
  {
    url: "/styles/minimalist/a-fine-line-tattoo-of-three-flowers-VXRuovm3X6vRZG8xzurXz6",
    title: "a fine line tattoo of three flowers",
    list_url: "/styles/minimalist/a-fine-line-tattoo-of-three-flowers"
  },
  {
    url: "/styles/minimalist/a-minimalist-tattoo-design-of-children-UsbyTi9EHbajbYR8BuJkEf",
    title: "a minimalist tattoo design of children",
    list_url: "/styles/minimalist/a-minimalist-tattoo-design-of-children"
  },
  {
    url: "/styles/minimalist/a-symbol-of-enduring-great-hardship-on-8tgJcL7NZrvg268r9DV2UY",
    title: "a symbol of enduring great hardship on",
    list_url: "/styles/minimalist/a-symbol-of-enduring-great-hardship-on"
  },
  {
    url: "/styles/minimalist/anime-bleach-SCwbMRgMByMXendmNYxYZ",
    title: "anime bleach",
    list_url: "/styles/minimalist/anime-bleach"
  },
  {
    url: "/styles/minimalist/anytime-anywhere-2kx2bbU5pvgfMr1hKk7xzK",
    title: "anytime anywhere",
    list_url: "/styles/minimalist/anytime-anywhere"
  },
  {
    url: "/styles/minimalist/arrow-with-snake-BNT7xvxqttZgDMsEtDYoSN",
    title: "arrow with snake",
    list_url: "/styles/minimalist/arrow-with-snake"
  },
  {
    url: "/styles/minimalist/azaleas-GGrpgiuYDz9s1iy15zGFnf",
    title: "azaleas",
    list_url: "/styles/minimalist/azaleas"
  },
  {
    url: "/styles/minimalist/baseball-diamond-Ub92H1Dovqo53e1JjyapuT",
    title: "baseball diamond",
    list_url: "/styles/minimalist/baseball-diamond"
  },
  {
    url: "/styles/minimalist/bean-sprout-saphirre-forget-me-not-PpANuMvcFfJpCcaCphhdf2",
    title: "bean sprout saphirre forget me not",
    list_url: "/styles/minimalist/bean-sprout-saphirre-forget-me-not"
  },
  {
    url: "/styles/minimalist/bharatanatyam-tattoo-4RbBpi9hCBf48YAQH5dVFy",
    title: "bharatanatyam tattoo",
    list_url: "/styles/minimalist/bharatanatyam-tattoo"
  },
  {
    url: "/styles/minimalist/boo-monsters-inc-NRjzpA3c72Tit1jsRFkGxe",
    title: "boo monsters inc",
    list_url: "/styles/minimalist/boo-monsters-inc"
  },
  {
    url: "/styles/minimalist/bts-whalien-52-whale-RiSq8E4QfiPUSHfSWXhG1N",
    title: "bts whalien whale",
    list_url: "/styles/minimalist/bts-whalien-52-whale"
  },
  {
    url: "/styles/minimalist/bulbasaur-LqeiuDNcPsdbv4Zr7ukTsz",
    title: "bulbasaur",
    list_url: "/styles/minimalist/bulbasaur"
  },
  {
    url: "/styles/minimalist/cherub-angel-QKbSMPqpkBN81KWpvVrcXx",
    title: "cherub angel",
    list_url: "/styles/minimalist/cherub-angel"
  },
  {
    url: "/styles/minimalist/chewbacca-head-only-roaring-J5fm8wZfDyAZzrKyojZVgS",
    title: "chewbacca head only roaring",
    list_url: "/styles/minimalist/chewbacca-head-only-roaring"
  },
  {
    url: "/styles/minimalist/chromosome-17-smith-magenis-62cdRm66qgvwuvgZH3EUHD",
    title: "chromosome smith magenis",
    list_url: "/styles/minimalist/chromosome-17-smith-magenis"
  },
  {
    url: "/styles/minimalist/claddagh-314CbBBofiB6jcZmUiMcKA",
    title: "claddagh",
    list_url: "/styles/minimalist/claddagh"
  },
  {
    url: "/styles/minimalist/coors-light-mountains-Rq7913szWs7UBXcn7p6pq4",
    title: "coors light mountains",
    list_url: "/styles/minimalist/coors-light-mountains"
  },
  {
    url: "/styles/minimalist/crow-MdEXs7mb93BrmS5YJQFT4c",
    title: "crow",
    list_url: "/styles/minimalist/crow"
  },
  {
    url: "/styles/minimalist/cursive-letters-with-the-initials-jg-432oHMMAA7WVCMBHYRzyfT",
    title: "cursive letters with the initials jg",
    list_url: "/styles/minimalist/cursive-letters-with-the-initials-jg"
  },
  {
    url: "/styles/minimalist/fahrenheit-451-ray-bradbury-PEPb2aV3jqsYV4ZTPyYSwt",
    title: "fahrenheit ray bradbury",
    list_url: "/styles/minimalist/fahrenheit-451-ray-bradbury"
  },
  {
    url: "/styles/minimalist/fearless-symbol-FfKjh3ehUXxrBft3e9Qd2Y",
    title: "fearless symbol",
    list_url: "/styles/minimalist/fearless-symbol"
  },
  {
    url: "/styles/minimalist/get-busy-living-or-get-busy-dying-NGWef2r9yfSJFwPagACH8W",
    title: "get busy living or get busy dying",
    list_url: "/styles/minimalist/get-busy-living-or-get-busy-dying"
  },
  {
    url: "/styles/minimalist/ghost-skull-mask-call-of-duty-modern-EhKw28FuvVnwvQfZaL8THe",
    title: "ghost skull mask call of duty modern",
    list_url: "/styles/minimalist/ghost-skull-mask-call-of-duty-modern"
  },
  {
    url: "/styles/minimalist/girl-smoking-a-cigarette-5Sa6TvzYURcFGjhTXmkJh9",
    title: "girl smoking a cigarette",
    list_url: "/styles/minimalist/girl-smoking-a-cigarette"
  },
  {
    url: "/styles/minimalist/hic-et-nunc-VHQL3LX8kgS4hVkGs4Rrmg",
    title: "hic et nunc",
    list_url: "/styles/minimalist/hic-et-nunc"
  },
  {
    url: "/styles/minimalist/hidden-letter-l-in-a-butterfly-9MXJctpxsz8xqs1YNcoyT7",
    title: "hidden letter l in a butterfly",
    list_url: "/styles/minimalist/hidden-letter-l-in-a-butterfly"
  },
  {
    url: "/styles/minimalist/hozier-song-lyrics-9xnwUZUTHNyqZQpiodQ2br",
    title: "hozier song lyrics",
    list_url: "/styles/minimalist/hozier-song-lyrics"
  },
  {
    url: "/styles/minimalist/hsv-1887-WTRfPjypH7WUvP7ntTAuwa",
    title: "hsv ",
    list_url: "/styles/minimalist/hsv-1887"
  },
  {
    url: "/styles/minimalist/jar-of-fireflies-JaXDTwVXsyjg6JjHMK5Fnp",
    title: "jar of fireflies",
    list_url: "/styles/minimalist/jar-of-fireflies"
  },
  {
    url: "/styles/minimalist/laminin-KiHHQSK3WNUAnWSBMVSxrG",
    title: "laminin",
    list_url: "/styles/minimalist/laminin"
  },
  {
    url: "/styles/minimalist/letter-b-with-angel-wings-and-infinity-Rq5zwtV3HgzSCMcXuKZru3",
    title: "letter b with angel wings and infinity",
    list_url: "/styles/minimalist/letter-b-with-angel-wings-and-infinity"
  },
  {
    url: "/styles/minimalist/letter-n-hidden-KRAEkZT8urFcgLZQCgx9eW",
    title: "letter n hidden",
    list_url: "/styles/minimalist/letter-n-hidden"
  },
  {
    url: "/styles/minimalist/lolita-name-written-B5B1fRLt8Z5ZLhPDBnXvgN",
    title: "lolita name written",
    list_url: "/styles/minimalist/lolita-name-written"
  },
  {
    url: "/styles/minimalist/lord-huron-KavFUvQTx4SbygkGWeZRAf",
    title: "lord huron",
    list_url: "/styles/minimalist/lord-huron"
  },
  {
    url: "/styles/minimalist/maltese-dog-MtAGF2hXjjW9WDDjtDyvZX",
    title: "maltese dog",
    list_url: "/styles/minimalist/maltese-dog"
  },
  {
    url: "/styles/minimalist/mango-tree-R5sqsjmNb87DJ7xBAQzUrV",
    title: "mango tree",
    list_url: "/styles/minimalist/mango-tree"
  },
  {
    url: "/styles/minimalist/mental-health-awareness-green-ribbon-4MdNySL838KvnAADnYPcxJ",
    title: "mental health awareness green ribbon",
    list_url: "/styles/minimalist/mental-health-awareness-green-ribbon"
  },
  {
    url: "/styles/minimalist/messi-XeTpfHo2uQRCKb6sPNxBzg",
    title: "messi",
    list_url: "/styles/minimalist/messi"
  },
  {
    url: "/styles/minimalist/mountain-trees-moon-and-waves-with-sun-7GLL3b5WdjmHprChrjqwVA",
    title: "mountain trees moon and waves with sun",
    list_url: "/styles/minimalist/mountain-trees-moon-and-waves-with-sun"
  },
  {
    url: "/styles/minimalist/mufasa-and-sarabi-2vNSuGAwWERqXE1XX8CyF2",
    title: "mufasa and sarabi",
    list_url: "/styles/minimalist/mufasa-and-sarabi"
  },
  {
    url: "/styles/minimalist/name-ivan-FuZVPsjeLQRZ2kU7PQi8T5",
    title: "name ivan",
    list_url: "/styles/minimalist/name-ivan"
  },
  {
    url: "/styles/minimalist/name-maya-WpymCjxnpXEDL1skVQ6rar",
    title: "name maya",
    list_url: "/styles/minimalist/name-maya"
  },
  {
    url: "/styles/minimalist/nana-in-sanskrit-script-font-XKt16DKJAtCHV8tVtNmfMB",
    title: "nana in sanskrit script font",
    list_url: "/styles/minimalist/nana-in-sanskrit-script-font"
  },
  {
    url: "/styles/minimalist/nymphomaniac-6SWsHJL9JMKGLq94CkmB42",
    title: "nymphomaniac",
    list_url: "/styles/minimalist/nymphomaniac"
  },
  {
    url: "/styles/minimalist/poop-emoji-outline-QSsC6NsAPhQPGmPYwpJ1Bp",
    title: "poop emoji outline",
    list_url: "/styles/minimalist/poop-emoji-outline"
  },
  {
    url: "/styles/minimalist/poppy-flower-larkspur-flower-poppy-G4BDap2UFd6ERuESGHM5yU",
    title: "poppy flower larkspur flower poppy",
    list_url: "/styles/minimalist/poppy-flower-larkspur-flower-poppy"
  },
  {
    url: "/styles/minimalist/puerto-rican-national-flower-YHeCkkSuYaA1PRAUFC3dym",
    title: "puerto rican national flower",
    list_url: "/styles/minimalist/puerto-rican-national-flower"
  },
  {
    url: "/styles/minimalist/semia-9mnG2dxYHJKspKHLjPTBJT",
    title: "semia",
    list_url: "/styles/minimalist/semia"
  },
  {
    url: "/styles/minimalist/star-wars-resistance-logo-three-stars-WqBGUSx5LjWpfdemKmDiFF",
    title: "star wars resistance logo three stars",
    list_url: "/styles/minimalist/star-wars-resistance-logo-three-stars"
  },
  {
    url: "/styles/minimalist/step-mom-step-son-tattoo-design-E4YMBLKHTiQJ4hphx7jscY",
    title: "step mom step son tattoo design",
    list_url: "/styles/minimalist/step-mom-step-son-tattoo-design"
  },
  {
    url: "/styles/minimalist/subaru-impreza-gc8-7ECeNjKw2ShuDJ2zELRC2z",
    title: "subaru impreza gc ",
    list_url: "/styles/minimalist/subaru-impreza-gc8"
  },
  {
    url: "/styles/minimalist/sun-and-ocean-scene-with-sagar-name-9WFePW8FTMxP7QEbK3b6sh",
    title: "sun and ocean scene with sagar name",
    list_url: "/styles/minimalist/sun-and-ocean-scene-with-sagar-name"
  },
  {
    url: "/styles/minimalist/tambourine-PuJCZwm7eboXnURhV5SFR9",
    title: "tambourine",
    list_url: "/styles/minimalist/tambourine"
  },
  {
    url: "/styles/minimalist/thy-will-be-done-PqQZGc6Ks6SZd1i9ieutcu",
    title: "thy will be done",
    list_url: "/styles/minimalist/thy-will-be-done"
  },
  {
    url: "/styles/minimalist/year-of-birth-2003-and-2006-Lj9F9xy5auenxNiir7Doy8",
    title: "year of birth and ",
    list_url: "/styles/minimalist/year-of-birth-2003-and-2006"
  },
  {
    url: "/styles/neotraditional/3-doves-flying-QH3ZcVm6cWuJrgsBfpkbbA",
    title: " doves flying",
    list_url: "/styles/neotraditional/3-doves-flying"
  },
  {
    url: "/styles/neotraditional/celtic-cross-scorpion-1993-year-YDAC6y6Ti92RpjEsDvkvWL",
    title: "celtic cross scorpion year",
    list_url: "/styles/neotraditional/celtic-cross-scorpion-1993-year"
  },
  {
    url: "/styles/neotraditional/date-of-birth-14-march-2001-zodiac-sign-6DjXZ4HTuXPRwhaGbXtiQG",
    title: "date of birth march zodiac sign",
    list_url: "/styles/neotraditional/date-of-birth-14-march-2001-zodiac-sign"
  },
  {
    url: "/styles/neotraditional/dgk-F4gvSeNb32yR6P2npTj9wH",
    title: "dgk",
    list_url: "/styles/neotraditional/dgk"
  },
  {
    url: "/styles/neotraditional/dolphin-and-rose-Gfva1c4imPozBzoboLCWLi",
    title: "dolphin and rose",
    list_url: "/styles/neotraditional/dolphin-and-rose"
  },
  {
    url: "/styles/neotraditional/dragon-shoulder-blade-2axVFWo46w5BP14bisyF5d",
    title: "dragon shoulder blade",
    list_url: "/styles/neotraditional/dragon-shoulder-blade"
  },
  {
    url: "/styles/neotraditional/feminine-dagger-tattoo-DDc7UkxSwUHzSiTmShVEZR",
    title: "feminine dagger tattoo",
    list_url: "/styles/neotraditional/feminine-dagger-tattoo"
  },
  {
    url: "/styles/neotraditional/gurkha-khukuri-but-one-is-angel-the-24ZErKVfLmyqY2Wakmc6qh",
    title: "gurkha khukuri but one is angel the",
    list_url: "/styles/neotraditional/gurkha-khukuri-but-one-is-angel-the"
  },
  {
    url: "/styles/neotraditional/harsh-name-tattoo-with-trishul-trident-X3xna5RNAfetQo3zYegDqx",
    title: "harsh name tattoo with trishul trident",
    list_url: "/styles/neotraditional/harsh-name-tattoo-with-trishul-trident"
  },
  {
    url: "/styles/neotraditional/heart-with-the-name-peter-WfxJstshLwPUFQAwZkFW93",
    title: "heart with the name peter",
    list_url: "/styles/neotraditional/heart-with-the-name-peter"
  },
  {
    url: "/styles/neotraditional/korean-norigae-cherry-blossom-tree-and-CDZxUSQiiy6XWf1YRjUrco",
    title: "korean norigae cherry blossom tree and",
    list_url: "/styles/neotraditional/korean-norigae-cherry-blossom-tree-and"
  },
  {
    url: "/styles/neotraditional/lettering-the-name-diana-LCkeyVGQKT68CMBXobUz1e",
    title: "lettering the name diana",
    list_url: "/styles/neotraditional/lettering-the-name-diana"
  },
  {
    url: "/styles/neotraditional/lucy-GPWSVzH2J1YUYJi9TPMNwH",
    title: "lucy",
    list_url: "/styles/neotraditional/lucy"
  },
  {
    url: "/styles/neotraditional/maple-syrup-dripping-XpY1XEW1FiVP7e4SgFGayG",
    title: "maple syrup dripping",
    list_url: "/styles/neotraditional/maple-syrup-dripping"
  },
  {
    url: "/styles/neotraditional/name-jessica-with-crown-and-date-2Ysqdy9BZSnZNroAE61y3d",
    title: "name jessica with crown and date",
    list_url: "/styles/neotraditional/name-jessica-with-crown-and-date"
  },
  {
    url: "/styles/neotraditional/native-american-armband-with-feather-Ly9gAjoG2FzF9szKMByaiB",
    title: "native american armband with feather",
    list_url: "/styles/neotraditional/native-american-armband-with-feather"
  },
  {
    url: "/styles/neotraditional/ratchet-clank-92WJQKQLFjSZ76Y2omRe64",
    title: "ratchet clank",
    list_url: "/styles/neotraditional/ratchet-clank"
  },
  {
    url: "/styles/neotraditional/sandra-name-tattoo-design-Dj7GyhqhyS8WL24c9FqR5t",
    title: "sandra name tattoo design",
    list_url: "/styles/neotraditional/sandra-name-tattoo-design"
  },
  {
    url: "/styles/neotraditional/shotokan-karate-tiger-surrounded-3yHTrHTYXhtTK2zYZx4Zu1",
    title: "shotokan karate tiger surrounded",
    list_url: "/styles/neotraditional/shotokan-karate-tiger-surrounded"
  },
  {
    url: "/styles/neotraditional/suits-netflix-series-EXkxdXchRJYjftcPjaofjJ",
    title: "suits netflix series",
    list_url: "/styles/neotraditional/suits-netflix-series"
  },
  {
    url: "/styles/neotraditional/surbhi-7qJFJyVf3KDbcdt8ZSFfSV",
    title: "surbhi",
    list_url: "/styles/neotraditional/surbhi"
  },
  {
    url: "/styles/neotraditional/the-apostle-of-myrkul-bg3-SGsWeE34tkKv3ta7XnU4QA",
    title: "the apostle of myrkul bg ",
    list_url: "/styles/neotraditional/the-apostle-of-myrkul-bg3"
  },
  {
    url: "/styles/neotraditional/viking-symbol-of-mother-F78rs3jbWNYtZNN8sziAdU",
    title: "viking symbol of mother",
    list_url: "/styles/neotraditional/viking-symbol-of-mother"
  },
  {
    url: "/styles/neotraditional/woman-warrior-goddess-AQDHFwZonhD1hFSuF4BVhz",
    title: "woman warrior goddess",
    list_url: "/styles/neotraditional/woman-warrior-goddess"
  },
  {
    url: "/styles/neotraditional/words-feral-RRsGu3p9XtWiUGHqGzU1BT",
    title: "words feral",
    list_url: "/styles/neotraditional/words-feral"
  },
  {
    url: "/styles/neotraditional/yellow-brick-road-winding-2QU5Wh2SA4Bp9EPqdAp2Cg",
    title: "yellow brick road winding",
    list_url: "/styles/neotraditional/yellow-brick-road-winding"
  },
  {
    url: "/styles/realism/a-tattoo-that-has-the-name-martha-with-NtLXHwtWGZo4QC213vG5kT",
    title: "a tattoo that has the name martha with",
    list_url: "/styles/realism/a-tattoo-that-has-the-name-martha-with"
  },
  {
    url: "/styles/realism/alhamdulillah-in-arabic-Xor9vfcPLq56XM7xd3YiYw",
    title: "alhamdulillah in arabic",
    list_url: "/styles/realism/alhamdulillah-in-arabic"
  },
  {
    url: "/styles/realism/andean-condor-WKZXSDQ8sm3p1jDX4DBBH9",
    title: "andean condor",
    list_url: "/styles/realism/andean-condor"
  },
  {
    url: "/styles/realism/artorias-sif-dark-souls-PpqC4LSSASeucoatLQbghK",
    title: "artorias sif dark souls",
    list_url: "/styles/realism/artorias-sif-dark-souls"
  },
  {
    url: "/styles/realism/disabled-man-in-wheelchair-SUY5UZkoNRynbJ4DF4Qrk6",
    title: "disabled man in wheelchair",
    list_url: "/styles/realism/disabled-man-in-wheelchair"
  },
  {
    url: "/styles/realism/family-crest-featuring-a-shield-and-a-8Ebo7GCPD7Adbnn9w2Paa3",
    title: "family crest featuring a shield and a",
    list_url: "/styles/realism/family-crest-featuring-a-shield-and-a"
  },
  {
    url: "/styles/realism/gods-hand-reaching-down-from-the-986VkjNo5H85u9rT97ResE",
    title: "gods hand reaching down from the",
    list_url: "/styles/realism/gods-hand-reaching-down-from-the"
  },
  {
    url: "/styles/realism/greek-god-hades-PBpFVjT3VLsZ5ZfgnvyJx",
    title: "greek god hades",
    list_url: "/styles/realism/greek-god-hades"
  },
  {
    url: "/styles/realism/jessica-rabbit-with-a-cigarette-CpJwGVtQhK1rbEa8rCqF6z",
    title: "jessica rabbit with a cigarette",
    list_url: "/styles/realism/jessica-rabbit-with-a-cigarette"
  },
  {
    url: "/styles/realism/kneeling-knight-templar-QuWw77FHjNbeixTekTpRMr",
    title: "kneeling knight templar",
    list_url: "/styles/realism/kneeling-knight-templar"
  },
  {
    url: "/styles/realism/lightning-on-a-arm-T4UUD6xXUgvN5nqpx7VETN",
    title: "lightning on a arm",
    list_url: "/styles/realism/lightning-on-a-arm"
  },
  {
    url: "/styles/realism/marine-corps-with-skulls-and-usmc-flag-5UyBRgeXC7SiL9nsVYzuYW",
    title: "marine corps with skulls and usmc flag",
    list_url: "/styles/realism/marine-corps-with-skulls-and-usmc-flag"
  },
  {
    url: "/styles/realism/native-american-wrist-tattoo-bracelet-FaCHEHymjCkdtMQAeQNBt8",
    title: "native american wrist tattoo bracelet",
    list_url: "/styles/realism/native-american-wrist-tattoo-bracelet"
  },
  {
    url: "/styles/realism/owl-and-wolf-tattoo-on-forearm-Ue2SPAzU3yeUXWjaGys64A",
    title: "owl and wolf tattoo on forearm",
    list_url: "/styles/realism/owl-and-wolf-tattoo-on-forearm"
  },
  {
    url: "/styles/realism/premeditatio-malorum-Ev3kVUavz4fFuH2jVQvtzu",
    title: "premeditatio malorum",
    list_url: "/styles/realism/premeditatio-malorum"
  },
  {
    url: "/styles/realism/purple-heart-military-RbbJanJFYKASQfMYkLbxUT",
    title: "purple heart military",
    list_url: "/styles/realism/purple-heart-military"
  },
  {
    url: "/styles/realism/ritika-name-tattoo-MBPBY7FhQ4YDbDcdqsKbxF",
    title: "ritika name tattoo",
    list_url: "/styles/realism/ritika-name-tattoo"
  },
  {
    url: "/styles/realism/sasha-grey-5a37Y6kURXTgvh2YdRgqkQ",
    title: "sasha grey",
    list_url: "/styles/realism/sasha-grey"
  },
  {
    url: "/styles/realism/scania-truck-EhKJcmMTPwuXpaCF9GD7cV",
    title: "scania truck",
    list_url: "/styles/realism/scania-truck"
  },
  {
    url: "/styles/realism/scarface-phrase-the-world-is-yours-5CMwowqXkDfQVfJs5NfBjN",
    title: "scarface phrase the world is yours",
    list_url: "/styles/realism/scarface-phrase-the-world-is-yours"
  },
  {
    url: "/styles/realism/the-hornbill-ME6yycFoJ3JtatKVz1i4n4",
    title: "the hornbill",
    list_url: "/styles/realism/the-hornbill"
  },
  {
    url: "/styles/realism/undertaker-wwe-A7c3sLGjNmuo7oFpfX47uj",
    title: "undertaker wwe",
    list_url: "/styles/realism/undertaker-wwe"
  },
  {
    url: "/styles/sketch/5-leaf-clover-of-black-clover-Aok1ajMucSEphEnxVsmwAG",
    title: " leaf clover of black clover",
    list_url: "/styles/sketch/5-leaf-clover-of-black-clover"
  },
  {
    url: "/styles/sketch/cartoon-gallbladder-SwueN9SvaW5rVYQtmZfKBY",
    title: "cartoon gallbladder",
    list_url: "/styles/sketch/cartoon-gallbladder"
  },
  {
    url: "/styles/sketch/duck-with-lightsaber-51K327HssouGMYJbUNmiwp",
    title: "duck with lightsaber",
    list_url: "/styles/sketch/duck-with-lightsaber"
  },
  {
    url: "/styles/sketch/fake-plastic-trees-by-radiohead-songs-8PxkHyiDcNfEYR4jo8Hosd",
    title: "fake plastic trees by radiohead songs",
    list_url: "/styles/sketch/fake-plastic-trees-by-radiohead-songs"
  },
  {
    url: "/styles/sketch/letter-v-wearing-a-crown-XBwCFWygrVa1ws2fBXtwvw",
    title: "letter v wearing a crown",
    list_url: "/styles/sketch/letter-v-wearing-a-crown"
  },
  {
    url: "/styles/sketch/lion-with-crown-of-thorns-UME8DKH28UvvLpexY8m5V1",
    title: "lion with crown of thorns",
    list_url: "/styles/sketch/lion-with-crown-of-thorns"
  },
  {
    url: "/styles/sketch/mountain-with-vk18-7PW6YyacLe7njGrZg2mH1J",
    title: "mountain with vk ",
    list_url: "/styles/sketch/mountain-with-vk18"
  },
  {
    url: "/styles/sketch/red-eared-slider-turtle-5RT73LdnX2a7KNhEb9FSxz",
    title: "red eared slider turtle",
    list_url: "/styles/sketch/red-eared-slider-turtle"
  },
  {
    url: "/styles/sketch/the-initials-hm-in-a-small-simple-Y1wjTQCB91e7jrapfkHpAG",
    title: "the initials hm in a small simple",
    list_url: "/styles/sketch/the-initials-hm-in-a-small-simple"
  },
  {
    url: "/styles/stencil/money-monopoly-donald-duck-WozorY4qWhbMHimoXPVymz",
    title: "money monopoly donald duck",
    list_url: "/styles/stencil/money-monopoly-donald-duck"
  },
  {
    url: "/styles/stencil/name-jordan-with-clouds-and-moon-VXADyPzvJKqibvvwHLHVCB",
    title: "name jordan with clouds and moon",
    list_url: "/styles/stencil/name-jordan-with-clouds-and-moon"
  },
  {
    url: "/styles/stencil/word-tattoo-enkrateia-udWVyG6hk4HMWRHpUABYF",
    title: "word tattoo enkrateia",
    list_url: "/styles/stencil/word-tattoo-enkrateia"
  },
  {
    url: "/styles/surrealism/chicken-with-gun-EkSBmFVpD1sxv9AmnARZXN",
    title: "chicken with gun",
    list_url: "/styles/surrealism/chicken-with-gun"
  },
  {
    url: "/styles/surrealism/shin-godzilla-SmBRXzCXsfWVKQ944498Kd",
    title: "shin godzilla",
    list_url: "/styles/surrealism/shin-godzilla"
  },
  {
    url: "/styles/traditional/baby-angel-smoking-a-cigarette-RiUcSReQMMW2hxZhdcgzdy",
    title: "baby angel smoking a cigarette",
    list_url: "/styles/traditional/baby-angel-smoking-a-cigarette"
  },
  {
    url: "/styles/traditional/blue-collar-UGhC9XFEiy77ATsZ2wJkmQ",
    title: "blue collar",
    list_url: "/styles/traditional/blue-collar"
  },
  {
    url: "/styles/traditional/carpe-diem-K3qjQtc52smTCiBf1sbNFn",
    title: "carpe diem",
    list_url: "/styles/traditional/carpe-diem"
  },
  {
    url: "/styles/traditional/native-american-pinup-girl-6PtrToGmg5UENEAaYJ6gLp",
    title: "native american pinup girl",
    list_url: "/styles/traditional/native-american-pinup-girl"
  },
  {
    url: "/styles/traditional/sg-sj-6mpqQ3iCTgXw3RH43QD4Fb",
    title: "sg sj",
    list_url: "/styles/traditional/sg-sj"
  },
  {
    url: "/styles/tribal/dileep-manjiri-anushree-apoorva-chandni-2SaivhLLCnb5w2M4F1WWSZ",
    title: "dileep manjiri anushree apoorva chandni",
    list_url: "/styles/tribal/dileep-manjiri-anushree-apoorva-chandni"
  },
  {
    url: "/styles/tribal/polynesian-inspired-with-xhosa-patterns-Xhm6zfY9s8YJNubtu5cv3E",
    title: "polynesian inspired with xhosa patterns",
    list_url: "/styles/tribal/polynesian-inspired-with-xhosa-patterns"
  },
  {
    url: "/styles/tribal/salmon-5gyZys2aWAsDb4ZrZX2aVs",
    title: "salmon",
    list_url: "/styles/tribal/salmon"
  },
  {
    url: "/styles/watercolor/artemis-athena-goddess-D3ZqSU5VmF1EJVrgrYKdSp",
    title: "artemis athena goddess",
    list_url: "/styles/watercolor/artemis-athena-goddess"
  },
  {
    url: "/styles/anime/erwin-smith-rage-speech-attack-on-titan-3BfAvdsZqqGfRKhHS7Voin",
    title: "erwin smith rage speech attack on titan",
    list_url: "/styles/anime/erwin-smith-rage-speech-attack-on-titan"
  },
  {
    url: "/styles/anime/gojo-satoru-symbol-R2GvPXLrtNu4J1wkEcRJP1",
    title: "gojo satoru symbol",
    list_url: "/styles/anime/gojo-satoru-symbol"
  },
  {
    url: "/styles/anime/hello-kitty-with-ak-47-EDyjpQnf7iSwY4s2xhK9NU",
    title: "hello kitty with ak ",
    list_url: "/styles/anime/hello-kitty-with-ak-47"
  },
  {
    url: "/styles/anime/log-pose-of-one-piece-JUn9cuULuUY1ibXRwALJZp",
    title: "log pose of one piece",
    list_url: "/styles/anime/log-pose-of-one-piece"
  },
  {
    url: "/styles/anime/nezuko-vines-around-arm-9FqijviCvuLe6RYof8mynu",
    title: "nezuko vines around arm",
    list_url: "/styles/anime/nezuko-vines-around-arm"
  },
  {
    url: "/styles/anime/pokemon-luxray-with-lightning-KbbpKfwGrxG18EziwsiS26",
    title: "pokemon luxray with lightning",
    list_url: "/styles/anime/pokemon-luxray-with-lightning"
  },
  {
    url: "/styles/anime/sasuke-uchiha-sasuke-REpDnSusa8tJcaoEef8Vau",
    title: "sasuke uchiha sasuke",
    list_url: "/styles/anime/sasuke-uchiha-sasuke"
  },
  {
    url: "/styles/anime/succubus-heart-Vq81HtbwLN9ukWE9Upd62c",
    title: "succubus heart",
    list_url: "/styles/anime/succubus-heart"
  },
  {
    url: "/styles/anime/transexual-bimbo-fornication-UvbPm2PJGaxaX7b9ZUE4qh",
    title: "transexual bimbo fornication",
    list_url: "/styles/anime/transexual-bimbo-fornication"
  },
  {
    url: "/styles/anime/vash-stampede-from-trigun-6k3XHN8SfwufARodH53BVE",
    title: "vash stampede from trigun",
    list_url: "/styles/anime/vash-stampede-from-trigun"
  },
  {
    url: "/styles/black-grey/07032003-in-roman-numerals-qEzRT1W4d9VFBGKgTi2ii",
    title: " in roman numerals",
    list_url: "/styles/black-grey/07032003-in-roman-numerals"
  },
  {
    url: "/styles/black-grey/2000s-emo-girl-Mdg4Q4f67sRtNwNH1jCePn",
    title: " s emo girl",
    list_url: "/styles/black-grey/2000s-emo-girl"
  },
  {
    url: "/styles/black-grey/6-winged-angel-ABd1icYapsiHDfrck8uex",
    title: " winged angel",
    list_url: "/styles/black-grey/6-winged-angel"
  },
  {
    url: "/styles/black-grey/a-ghost-smoking-a-weed-bong-NGYrBYqKSbuPGXNy7h7e5G",
    title: "a ghost smoking a weed bong",
    list_url: "/styles/black-grey/a-ghost-smoking-a-weed-bong"
  },
  {
    url: "/styles/black-grey/a-little-kid-shadow-figure-walking-up-3sDVViN2Stb2VYaipGDf7r",
    title: "a little kid shadow figure walking up",
    list_url: "/styles/black-grey/a-little-kid-shadow-figure-walking-up"
  },
  {
    url: "/styles/black-grey/a-silhouette-of-johnny-marr-playing-F2UnRDDmiBs2w12YS5b4qi",
    title: "a silhouette of johnny marr playing",
    list_url: "/styles/black-grey/a-silhouette-of-johnny-marr-playing"
  },
  {
    url: "/styles/black-grey/acdc-WP8yebjdYf155zwDZ61gwf",
    title: "acdc",
    list_url: "/styles/black-grey/acdc"
  },
  {
    url: "/styles/black-grey/adam-and-eve-with-an-apple-with-a-snake-3MVdXSf3LFGfCuYRPCqvB5",
    title: "adam and eve with an apple with a snake",
    list_url: "/styles/black-grey/adam-and-eve-with-an-apple-with-a-snake"
  },
  {
    url: "/styles/black-grey/an-ottoman-warrior-LKZVi9E3mEhYnd64uHPCuq",
    title: "an ottoman warrior",
    list_url: "/styles/black-grey/an-ottoman-warrior"
  },
  {
    url: "/styles/black-grey/an-ouroboros-with-a-worm-2sLdWH7puV9zZtwQ468mfe",
    title: "an ouroboros with a worm",
    list_url: "/styles/black-grey/an-ouroboros-with-a-worm"
  },
  {
    url: "/styles/black-grey/andre-name-tattoo-PDUANHWCYsMghP9WLj5Syy",
    title: "andre name tattoo",
    list_url: "/styles/black-grey/andre-name-tattoo"
  },
  {
    url: "/styles/black-grey/angel-with-the-words-loyalty-above-all-ChQgbJWVujGESz28uu7ADj",
    title: "angel with the words loyalty above all",
    list_url: "/styles/black-grey/angel-with-the-words-loyalty-above-all"
  },
  {
    url: "/styles/black-grey/angelina-name-tattoo-JA5UMw2UHLPYYG4PbuCzhU",
    title: "angelina name tattoo",
    list_url: "/styles/black-grey/angelina-name-tattoo"
  },
  {
    url: "/styles/black-grey/ashwin-QTmGKDGq8MxSUwcEiCUgHv",
    title: "ashwin",
    list_url: "/styles/black-grey/ashwin"
  },
  {
    url: "/styles/black-grey/aslan-from-narnia-3w7raw67jagD3ebyJpM3CN",
    title: "aslan from narnia",
    list_url: "/styles/black-grey/aslan-from-narnia"
  },
  {
    url: "/styles/black-grey/atlanta-braves-tomahawk-Dh8ir5RQDKXExTZ6AYdZUd",
    title: "atlanta braves tomahawk",
    list_url: "/styles/black-grey/atlanta-braves-tomahawk"
  },
  {
    url: "/styles/black-grey/beyblade-dranzer-VfaojFu5UQQCxFFDWLv3Z4",
    title: "beyblade dranzer",
    list_url: "/styles/black-grey/beyblade-dranzer"
  },
  {
    url: "/styles/black-grey/bible-verse-matthew-54-written-YQAqic1xEAuL7FPqCzfhpV",
    title: "bible verse matthew written",
    list_url: "/styles/black-grey/bible-verse-matthew-54-written"
  },
  {
    url: "/styles/black-grey/birds-flying-out-of-the-clock-Hn9Q3hzECdrYCGr8xyQoFR",
    title: "birds flying out of the clock",
    list_url: "/styles/black-grey/birds-flying-out-of-the-clock"
  },
  {
    url: "/styles/black-grey/bmw-e36-320i-coupe-RpALnvomcJXbmPzVi21yws",
    title: "bmw e i coupe",
    list_url: "/styles/black-grey/bmw-e36-320i-coupe"
  },
  {
    url: "/styles/black-grey/boner-garage-garage-logo-DEg8DAwETm84rxMWEKzHZn",
    title: "boner garage garage logo",
    list_url: "/styles/black-grey/boner-garage-garage-logo"
  },
  {
    url: "/styles/black-grey/bugs-bunny-double-barrel-shotgun-8T7Geo52JxKMCNcEMkchUR",
    title: "bugs bunny double barrel shotgun",
    list_url: "/styles/black-grey/bugs-bunny-double-barrel-shotgun"
  },
  {
    url: "/styles/black-grey/burning-money-4g8fdtG9zrUJZV1uW3bUdf",
    title: "burning money",
    list_url: "/styles/black-grey/burning-money"
  },
  {
    url: "/styles/black-grey/carl-johnson-cj-gta-san-andreas-and-Sva9VyeEZqSYwaoq5cB5ot",
    title: "carl johnson cj gta san andreas and",
    list_url: "/styles/black-grey/carl-johnson-cj-gta-san-andreas-and"
  },
  {
    url: "/styles/black-grey/charlemagne-and-bahkauv-C69mYuSgr2UHve8KRbVfbz",
    title: "charlemagne and bahkauv",
    list_url: "/styles/black-grey/charlemagne-and-bahkauv"
  },
  {
    url: "/styles/black-grey/chelsea-name-written-BMRsPEe15XbpkNsaZVoC9c",
    title: "chelsea name written",
    list_url: "/styles/black-grey/chelsea-name-written"
  },
  {
    url: "/styles/black-grey/cherub-devil-27y2ujgayAcsz87SZ1uzLk",
    title: "cherub devil",
    list_url: "/styles/black-grey/cherub-devil"
  },
  {
    url: "/styles/black-grey/chucky-holding-an-assault-rifle-ak47-BPuyYVYeHusME6NSQ5haJF",
    title: "chucky holding an assault rifle ak ",
    list_url: "/styles/black-grey/chucky-holding-an-assault-rifle-ak47"
  },
  {
    url: "/styles/black-grey/clock-with-baby-footprint-and-flowers-DtF8DCvW7saSWQTPddAPH6",
    title: "clock with baby footprint and flowers",
    list_url: "/styles/black-grey/clock-with-baby-footprint-and-flowers"
  },
  {
    url: "/styles/black-grey/clown-face-coming-out-of-ripped-skin-CRDMp4WRNP6Z7XvwSRJUQP",
    title: "clown face coming out of ripped skin",
    list_url: "/styles/black-grey/clown-face-coming-out-of-ripped-skin"
  },
  {
    url: "/styles/black-grey/coilover-shock-Xo44iNE8sF8aWMydipdyFT",
    title: "coilover shock",
    list_url: "/styles/black-grey/coilover-shock"
  },
  {
    url: "/styles/black-grey/constant-battle-between-good-and-evil-FLger77nt72MmwJfRRDHiV",
    title: "constant battle between good and evil",
    list_url: "/styles/black-grey/constant-battle-between-good-and-evil"
  },
  {
    url: "/styles/black-grey/cowboy-on-horse-with-shadow-of-native-9hThbbv1dLpsZFoeZ7YHb4",
    title: "cowboy on horse with shadow of native",
    list_url: "/styles/black-grey/cowboy-on-horse-with-shadow-of-native"
  },
  {
    url: "/styles/black-grey/cowboy-rope-cactus-flowers-FcuhWxbugYvoGttp2y44gs",
    title: "cowboy rope cactus flowers",
    list_url: "/styles/black-grey/cowboy-rope-cactus-flowers"
  },
  {
    url: "/styles/black-grey/cross-with-dragon-NvRPZtrzRGs8VqsecseEZ",
    title: "cross with dragon",
    list_url: "/styles/black-grey/cross-with-dragon"
  },
  {
    url: "/styles/black-grey/crucifixion-of-jesus-christ-and-dismas-RJ4SxLX3KFZDpkfb8ZzHZT",
    title: "crucifixion of jesus christ and dismas",
    list_url: "/styles/black-grey/crucifixion-of-jesus-christ-and-dismas"
  },
  {
    url: "/styles/black-grey/cute-salt-and-pepper-shaker-U1drx3o4RQgMj2in8XRgps",
    title: "cute salt and pepper shaker",
    list_url: "/styles/black-grey/cute-salt-and-pepper-shaker"
  },
  {
    url: "/styles/black-grey/cyber-sigilism-arm-4s45PNkEcX6PEDpEcxbXL9",
    title: "cyber sigilism arm",
    list_url: "/styles/black-grey/cyber-sigilism-arm"
  },
  {
    url: "/styles/black-grey/dance-with-the-devil-JVnJk3zWCCToCb8DawNfCX",
    title: "dance with the devil",
    list_url: "/styles/black-grey/dance-with-the-devil"
  },
  {
    url: "/styles/black-grey/devil-may-cry-dante-8QpLqGR9hLhFNjkE5t1wCv",
    title: "devil may cry dante",
    list_url: "/styles/black-grey/devil-may-cry-dante"
  },
  {
    url: "/styles/black-grey/donald-duck-with-money-bag-L4gHWij9JGkeK2dG4QUsqG",
    title: "donald duck with money bag",
    list_url: "/styles/black-grey/donald-duck-with-money-bag"
  },
  {
    url: "/styles/black-grey/dont-let-the-hard-days-win-Tuv5Wg3mfJFm753z9YVX3f",
    title: "dont let the hard days win",
    list_url: "/styles/black-grey/dont-let-the-hard-days-win"
  },
  {
    url: "/styles/black-grey/eisbaren-berlin-dynamo-1954-HE6CN5Y8CAAfghh5inX82",
    title: "eisbaren berlin dynamo ",
    list_url: "/styles/black-grey/eisbaren-berlin-dynamo-1954"
  },
  {
    url: "/styles/black-grey/english-roberts-family-crest-with-lion-RfnN1CsSmHeNfEtrrkYbTo",
    title: "english roberts family crest with lion",
    list_url: "/styles/black-grey/english-roberts-family-crest-with-lion"
  },
  {
    url: "/styles/black-grey/eye-of-the-storm-japanese-7SknP8o8kyeL22Y5Lej8vZ",
    title: "eye of the storm japanese",
    list_url: "/styles/black-grey/eye-of-the-storm-japanese"
  },
  {
    url: "/styles/black-grey/faded-stars-FJGjiivZjbxEum6dXjVM1b",
    title: "faded stars",
    list_url: "/styles/black-grey/faded-stars"
  },
  {
    url: "/styles/black-grey/feather-arm-band-2Fxkg4uz4vfzkPxd5y3ZBV",
    title: "feather arm band",
    list_url: "/styles/black-grey/feather-arm-band"
  },
  {
    url: "/styles/black-grey/finnish-tribal-with-sisu-symbol-in-NyGJdRScAoM1qyMbQwCN98",
    title: "finnish tribal with sisu symbol in",
    list_url: "/styles/black-grey/finnish-tribal-with-sisu-symbol-in"
  },
  {
    url: "/styles/black-grey/galaxy-cover-up-on-left-shoulder-F762M7KCoVEmx4VBfzkrAz",
    title: "galaxy cover up on left shoulder",
    list_url: "/styles/black-grey/galaxy-cover-up-on-left-shoulder"
  },
  {
    url: "/styles/black-grey/garden-of-eden-snake-and-forbidden-fruit-NwsLcKTb6vszW1fzdmR15B",
    title: "garden of eden snake and forbidden fruit",
    list_url: "/styles/black-grey/garden-of-eden-snake-and-forbidden-fruit"
  },
  {
    url: "/styles/black-grey/god-and-devil-chess-board-JErm67tAv8ixYQjmc2jhbK",
    title: "god and devil chess board",
    list_url: "/styles/black-grey/god-and-devil-chess-board"
  },
  {
    url: "/styles/black-grey/gothic-satanic-tramp-stamp-d9gyTju8Y88rEkk9M3twA",
    title: "gothic satanic tramp stamp",
    list_url: "/styles/black-grey/gothic-satanic-tramp-stamp"
  },
  {
    url: "/styles/black-grey/graveyard-scene-with-tombstones-Qzd5tSPbUzsraJgxHpxrQ3",
    title: "graveyard scene with tombstones",
    list_url: "/styles/black-grey/graveyard-scene-with-tombstones"
  },
  {
    url: "/styles/black-grey/greek-angel-5QCFeMRURDNBstoY1JXtJg",
    title: "greek angel",
    list_url: "/styles/black-grey/greek-angel"
  },
  {
    url: "/styles/black-grey/greek-spartan-with-cross-and-american-5aqcnycKKdf5xDxDJW7tSz",
    title: "greek spartan with cross and american",
    list_url: "/styles/black-grey/greek-spartan-with-cross-and-american"
  },
  {
    url: "/styles/black-grey/guardian-angel-standing-over-soldier-8m44oDhnHfBb1KguE6zhf7",
    title: "guardian angel standing over soldier",
    list_url: "/styles/black-grey/guardian-angel-standing-over-soldier"
  },
  {
    url: "/styles/black-grey/hathor-MSrb3PQ8wxAA7zNbzApqd4",
    title: "hathor",
    list_url: "/styles/black-grey/hathor"
  },
  {
    url: "/styles/black-grey/hot-stripper-smoking-cigarette-FazxZ9xKg2bDUFTPog8VV9",
    title: "hot stripper smoking cigarette",
    list_url: "/styles/black-grey/hot-stripper-smoking-cigarette"
  },
  {
    url: "/styles/black-grey/hummingbird-with-bible-verse-and-roses-8DC8eDz4PFZrVTGCGuWXZh",
    title: "hummingbird with bible verse and roses",
    list_url: "/styles/black-grey/hummingbird-with-bible-verse-and-roses"
  },
  {
    url: "/styles/black-grey/idf-carburetor-QpvcivRd7VfwDNDq8kmEvt",
    title: "idf carburetor",
    list_url: "/styles/black-grey/idf-carburetor"
  },
  {
    url: "/styles/black-grey/kings-crown-celtic-spear-filigree-WRP3o1b5pXVyp8FWhpXbX7",
    title: "kings crown celtic spear filigree",
    list_url: "/styles/black-grey/kings-crown-celtic-spear-filigree"
  },
  {
    url: "/styles/black-grey/laugh-now-cry-later-japanese-oni-mask-C3GmVuVXuY78CmTQw4PkTt",
    title: "laugh now cry later japanese oni mask",
    list_url: "/styles/black-grey/laugh-now-cry-later-japanese-oni-mask"
  },
  {
    url: "/styles/black-grey/letter-k-kings-crown-RL6Loqxf8HuJ8ErLybivBV",
    title: "letter k kings crown",
    list_url: "/styles/black-grey/letter-k-kings-crown"
  },
  {
    url: "/styles/black-grey/lifeline-with-name-romeo-and-a-paw-D4sbBBvSGocpvYyqseab4V",
    title: "lifeline with name romeo and a paw",
    list_url: "/styles/black-grey/lifeline-with-name-romeo-and-a-paw"
  },
  {
    url: "/styles/black-grey/lola-bunny-5a3G7i1Z8vmUWfDDQtq5Yh",
    title: "lola bunny",
    list_url: "/styles/black-grey/lola-bunny"
  },
  {
    url: "/styles/black-grey/mallard-and-wood-duck-flying-JfsAnLmcTkZmRUu4UHewHs",
    title: "mallard and wood duck flying",
    list_url: "/styles/black-grey/mallard-and-wood-duck-flying"
  },
  {
    url: "/styles/black-grey/man-with-biomechanical-chest-tattoo-GVM2MkhFVZJX2ZAregWNUW",
    title: "man with biomechanical chest tattoo",
    list_url: "/styles/black-grey/man-with-biomechanical-chest-tattoo"
  },
  {
    url: "/styles/black-grey/melanie-name-tattoo-Lvm5KAuuFJyy8jtogmNtCk",
    title: "melanie name tattoo",
    list_url: "/styles/black-grey/melanie-name-tattoo"
  },
  {
    url: "/styles/black-grey/memorial-tattoo-for-aunt-dvFXCTqrT5gGBRM5qxz28",
    title: "memorial tattoo for aunt",
    list_url: "/styles/black-grey/memorial-tattoo-for-aunt"
  },
  {
    url: "/styles/black-grey/middle-earth-map-UPZ311bVvGP9tNwHgDQApy",
    title: "middle earth map",
    list_url: "/styles/black-grey/middle-earth-map"
  },
  {
    url: "/styles/black-grey/midra-lord-of-frenzied-flame-elden-ring-BQXC9boUkt5nCKV7ChpJBL",
    title: "midra lord of frenzied flame elden ring",
    list_url: "/styles/black-grey/midra-lord-of-frenzied-flame-elden-ring"
  },
  {
    url: "/styles/black-grey/mila-name-EiM7ScCyAXpvK5habcMQUj",
    title: "mila name",
    list_url: "/styles/black-grey/mila-name"
  },
  {
    url: "/styles/black-grey/name-aaliyah-HiT3EdETBhh3eZLDAip2oG",
    title: "name aaliyah",
    list_url: "/styles/black-grey/name-aaliyah"
  },
  {
    url: "/styles/black-grey/name-araceli-VDUkNBgVD4Li4iow3vxRWc",
    title: "name araceli",
    list_url: "/styles/black-grey/name-araceli"
  },
  {
    url: "/styles/black-grey/nautical-kraken-scandinavian-valheim-78hmZtoV6HBojoaXxb7SnC",
    title: "nautical kraken scandinavian valheim",
    list_url: "/styles/black-grey/nautical-kraken-scandinavian-valheim"
  },
  {
    url: "/styles/black-grey/old-english-font-brown-pride-CPasmeuAQbFGaLapbxZwgA",
    title: "old english font brown pride",
    list_url: "/styles/black-grey/old-english-font-brown-pride"
  },
  {
    url: "/styles/black-grey/portrait-of-angry-kangal-dog-in-black-NxLNnqATBFzCcRHfhzLWhj",
    title: "portrait of angry kangal dog in black",
    list_url: "/styles/black-grey/portrait-of-angry-kangal-dog-in-black"
  },
  {
    url: "/styles/black-grey/sahil-name-in-urdu-language-nRSwms84KpS3R2b2j5oxG",
    title: "sahil name in urdu language",
    list_url: "/styles/black-grey/sahil-name-in-urdu-language"
  },
  {
    url: "/styles/black-grey/sandzak-Dp6YAZkw3VtRACbdobmwb",
    title: "sandzak",
    list_url: "/styles/black-grey/sandzak"
  },
  {
    url: "/styles/black-grey/sathya-and-suma-TeKYiD5k5pXzFhj22pAAS5",
    title: "sathya and suma",
    list_url: "/styles/black-grey/sathya-and-suma"
  },
  {
    url: "/styles/black-grey/shattered-heart-VrzWJUAzUgfVsgBjUj2vue",
    title: "shattered heart",
    list_url: "/styles/black-grey/shattered-heart"
  },
  {
    url: "/styles/black-grey/skeleton-bride-and-groom-holding-hands-8S1Wzhv9AzMUB5FVwJ83tT",
    title: "skeleton bride and groom holding hands",
    list_url: "/styles/black-grey/skeleton-bride-and-groom-holding-hands"
  },
  {
    url: "/styles/black-grey/skeleton-hand-around-throat-with-Svf4soco7iZLQCYoucZGCL",
    title: "skeleton hand around throat with",
    list_url: "/styles/black-grey/skeleton-hand-around-throat-with"
  },
  {
    url: "/styles/black-grey/ssc-napoli-WkLS9AGjWPKpdRCvQjmBkS",
    title: "ssc napoli",
    list_url: "/styles/black-grey/ssc-napoli"
  },
  {
    url: "/styles/black-grey/steam-train-8WnSgoEG5nuLwtXW85Ek7A",
    title: "steam train",
    list_url: "/styles/black-grey/steam-train"
  },
  {
    url: "/styles/black-grey/sunflower-floral-above-knee-tattoo-UZi3xC62h3qhZEWqrQa5xQ",
    title: "sunflower floral above knee tattoo",
    list_url: "/styles/black-grey/sunflower-floral-above-knee-tattoo"
  },
  {
    url: "/styles/black-grey/sunflower-with-music-notes-JVS425yCnHGSpDBUkL7kUH",
    title: "sunflower with music notes",
    list_url: "/styles/black-grey/sunflower-with-music-notes"
  },
  {
    url: "/styles/black-grey/super-mario-C75AFz1tFhPeBLgP5n7XnU",
    title: "super mario",
    list_url: "/styles/black-grey/super-mario"
  },
  {
    url: "/styles/black-grey/the-lords-prayer-in-script-font-with-XfqYWE6ayb98Hw9xfKR9Y4",
    title: "the lords prayer in script font with",
    list_url: "/styles/black-grey/the-lords-prayer-in-script-font-with"
  },
  {
    url: "/styles/black-grey/the-name-ashley-fancy-script-V64UrrcbUKuK2tCGSwuLwR",
    title: "the name ashley fancy script",
    list_url: "/styles/black-grey/the-name-ashley-fancy-script"
  },
  {
    url: "/styles/black-grey/the-name-tommy-Rc9ukmgb2Y8fDkNHb5bGpw",
    title: "the name tommy",
    list_url: "/styles/black-grey/the-name-tommy"
  },
  {
    url: "/styles/black-grey/the-word-sacrifice-in-cursive-font-FNqTHpLGzgBxFsfjeHzW",
    title: "the word sacrifice in cursive font",
    list_url: "/styles/black-grey/the-word-sacrifice-in-cursive-font"
  },
  {
    url: "/styles/black-grey/to-dare-is-to-do-AQQ2vPgGFEiMKuhF6eo24W",
    title: "to dare is to do",
    list_url: "/styles/black-grey/to-dare-is-to-do"
  },
  {
    url: "/styles/black-grey/vortex-tattoo-YcUVCGzg7LWkTdZ5WYbaqG",
    title: "vortex tattoo",
    list_url: "/styles/black-grey/vortex-tattoo"
  },
  {
    url: "/styles/black-grey/warhammer-40k-blood-angels-UzVeanwCtRcAdVK7iNHrpF",
    title: "warhammer k blood angels",
    list_url: "/styles/black-grey/warhammer-40k-blood-angels"
  },
  {
    url: "/styles/black-grey/what-we-do-in-life-echoes-in-eternity-Eaqeqb2uWgDhM6NQV5tMk3",
    title: "what we do in life echoes in eternity",
    list_url: "/styles/black-grey/what-we-do-in-life-echoes-in-eternity"
  },
  {
    url: "/styles/black-grey/witchy-best-friend-tattoo-KKwEYMw2JKa1AwXDPoVXwH",
    title: "witchy best friend tattoo",
    list_url: "/styles/black-grey/witchy-best-friend-tattoo"
  },
  {
    url: "/styles/black-grey/word-family-written-in-elegant-script-AJfRTtPRC5CBkFgYD4g7FZ",
    title: "word family written in elegant script",
    list_url: "/styles/black-grey/word-family-written-in-elegant-script"
  },
  {
    url: "/styles/black-grey/wuthering-heights-book-DUyfEV6NYKQo1ngrpX6hu2",
    title: "wuthering heights book",
    list_url: "/styles/black-grey/wuthering-heights-book"
  },
  {
    url: "/styles/black-grey/yankee-stadium-facade-CEEb3kkwzWeTVY5Kwx8Wsf",
    title: "yankee stadium facade",
    list_url: "/styles/black-grey/yankee-stadium-facade"
  },
  {
    url: "/styles/black-grey/zodiac-sign-libra-x-year-of-the-monkey-BYfoL4rzFq8ycs1WN6m37D",
    title: "zodiac sign libra x year of the monkey",
    list_url: "/styles/black-grey/zodiac-sign-libra-x-year-of-the-monkey"
  },
  {
    url: "/styles/blackwork/2017-ford-f150-PUWeYvgAkvKsbV6bAAWC8m",
    title: " ford f ",
    list_url: "/styles/blackwork/2017-ford-f150"
  },
  {
    url: "/styles/blackwork/911-in-roman-numerals-WZatZrc6nAHVKg8kA3KAHw",
    title: " in roman numerals",
    list_url: "/styles/blackwork/911-in-roman-numerals"
  },
  {
    url: "/styles/blackwork/a-pair-of-angel-wings-wrapped-around-a-54GJQ5KzKX55GNHGtXfTK5",
    title: "a pair of angel wings wrapped around a",
    list_url: "/styles/blackwork/a-pair-of-angel-wings-wrapped-around-a"
  },
  {
    url: "/styles/blackwork/a-sword-and-shield-add-a-compass-dont-2wT1G7nLxGeUUx48VL7eap",
    title: "a sword and shield add a compass dont",
    list_url: "/styles/blackwork/a-sword-and-shield-add-a-compass-dont"
  },
  {
    url: "/styles/blackwork/alice-falling-down-the-rabbit-hole-CSJ8bZs6S3nCE16P5DixoM",
    title: "alice falling down the rabbit hole",
    list_url: "/styles/blackwork/alice-falling-down-the-rabbit-hole"
  },
  {
    url: "/styles/blackwork/american-flag-with-roses-45CSrrcMWKRAV7m4sjjJAx",
    title: "american flag with roses",
    list_url: "/styles/blackwork/american-flag-with-roses"
  },
  {
    url: "/styles/blackwork/american-traditional-lily-7zzgoE5DK3v66tqcukN6wT",
    title: "american traditional lily",
    list_url: "/styles/blackwork/american-traditional-lily"
  },
  {
    url: "/styles/blackwork/archangel-michael-killing-coiled-snake-UmF1AjUBBBG1RwWG1Hjy52",
    title: "archangel michael killing coiled snake",
    list_url: "/styles/blackwork/archangel-michael-killing-coiled-snake"
  },
  {
    url: "/styles/blackwork/arm-sleeve-tattoo-good-vs-evil-G1hcxVkSZUnc1de1u2TviD",
    title: "arm sleeve tattoo good vs evil",
    list_url: "/styles/blackwork/arm-sleeve-tattoo-good-vs-evil"
  },
  {
    url: "/styles/blackwork/astrix-trance-6UueC92g2k6SxLGy2WXb4a",
    title: "astrix trance",
    list_url: "/styles/blackwork/astrix-trance"
  },
  {
    url: "/styles/blackwork/athena-lettering-font-tattoo-EFw4BxjpjHCGzgL8YiaB9X",
    title: "athena lettering font tattoo",
    list_url: "/styles/blackwork/athena-lettering-font-tattoo"
  },
  {
    url: "/styles/blackwork/aztec-eagle-C9tH9xcgAtJtGSgquQSV46",
    title: "aztec eagle",
    list_url: "/styles/blackwork/aztec-eagle"
  },
  {
    url: "/styles/blackwork/beautiful-feminine-solar-plexus-tattoo-MEhhXmJqDzL7NrWdsT5o6f",
    title: "beautiful feminine solar plexus tattoo",
    list_url: "/styles/blackwork/beautiful-feminine-solar-plexus-tattoo"
  },
  {
    url: "/styles/blackwork/bio-mechanical-leg-sleeve-with-piston-8JrnzX7o6Uid1h544TGH1W",
    title: "bio mechanical leg sleeve with piston",
    list_url: "/styles/blackwork/bio-mechanical-leg-sleeve-with-piston"
  },
  {
    url: "/styles/blackwork/black-jesus-SRqpxLNPzZ1cG3fEYacUGY",
    title: "black jesus",
    list_url: "/styles/blackwork/black-jesus"
  },
  {
    url: "/styles/blackwork/blackout-tattoo-of-hands-RBSdpfrG6pqgWUs2pJVQ7R",
    title: "blackout tattoo of hands",
    list_url: "/styles/blackwork/blackout-tattoo-of-hands"
  },
  {
    url: "/styles/blackwork/boeing-747-4fva41joj5GLHkjLCew1DC",
    title: "boeing ",
    list_url: "/styles/blackwork/boeing-747"
  },
  {
    url: "/styles/blackwork/bridge-to-terabithia-DHzoZ6RB4XHsJedX1YsamX",
    title: "bridge to terabithia",
    list_url: "/styles/blackwork/bridge-to-terabithia"
  },
  {
    url: "/styles/blackwork/calligraphic-calligraphy-archie-and-JLR5uNh4kN8BWuYyNZ7oam",
    title: "calligraphic calligraphy archie and",
    list_url: "/styles/blackwork/calligraphic-calligraphy-archie-and"
  },
  {
    url: "/styles/blackwork/ceiba-tree-in-fog-in-the-costa-rican-KoFcVXrXW38YpaueKcvmZk",
    title: "ceiba tree in fog in the costa rican",
    list_url: "/styles/blackwork/ceiba-tree-in-fog-in-the-costa-rican"
  },
  {
    url: "/styles/blackwork/chevrolet-impala-VHmnqEPNb7dHBnWegqvdHP",
    title: "chevrolet impala",
    list_url: "/styles/blackwork/chevrolet-impala"
  },
  {
    url: "/styles/blackwork/chief-native-american-skull-warrior-5x4DF7rJz5fUtQcHvPTVwd",
    title: "chief native american skull warrior",
    list_url: "/styles/blackwork/chief-native-american-skull-warrior"
  },
  {
    url: "/styles/blackwork/chucky-holding-his-pistol-XKkXLDs8Kh5m2wzYrEqFf8",
    title: "chucky holding his pistol",
    list_url: "/styles/blackwork/chucky-holding-his-pistol"
  },
  {
    url: "/styles/blackwork/davisking-family-crest-Sz9Kvg9yyFtYvHFuyfUBv3",
    title: "davisking family crest",
    list_url: "/styles/blackwork/davisking-family-crest"
  },
  {
    url: "/styles/blackwork/donald-duck-gangster-with-louis-vuitton-Rv3G52CaaW5sZPhax2HPdZ",
    title: "donald duck gangster with louis vuitton",
    list_url: "/styles/blackwork/donald-duck-gangster-with-louis-vuitton"
  },
  {
    url: "/styles/blackwork/egyptian-god-khonsu-ANJTByrGT13Gf5GjUByXBW",
    title: "egyptian god khonsu",
    list_url: "/styles/blackwork/egyptian-god-khonsu"
  },
  {
    url: "/styles/blackwork/fear-ruins-life-FbcRTq1YMPMWG1J7rxuTFb",
    title: "fear ruins life",
    list_url: "/styles/blackwork/fear-ruins-life"
  },
  {
    url: "/styles/blackwork/fury-brad-pitt-tank-bibleww2-AXjmGtH8m9X1HMJVZEPo5A",
    title: "fury brad pitt tank bibleww ",
    list_url: "/styles/blackwork/fury-brad-pitt-tank-bibleww2"
  },
  {
    url: "/styles/blackwork/gl-4GtYpSHiQ3M5KRM9biXwLP",
    title: "gl",
    list_url: "/styles/blackwork/gl"
  },
  {
    url: "/styles/blackwork/gothic-back-tattoo-women-Gm7pqLK9rmwGu8gu7Xb9PQ",
    title: "gothic back tattoo women",
    list_url: "/styles/blackwork/gothic-back-tattoo-women"
  },
  {
    url: "/styles/blackwork/greek-mythology-aphrodite-libra-RdDhTQsozV1YcEeKSWLm7L",
    title: "greek mythology aphrodite libra",
    list_url: "/styles/blackwork/greek-mythology-aphrodite-libra"
  },
  {
    url: "/styles/blackwork/harry-potter-platform-9-34-hogwarts-KQPXzfYyrn9UpC7HjWj5np",
    title: "harry potter platform hogwarts",
    list_url: "/styles/blackwork/harry-potter-platform-9-34-hogwarts"
  },
  {
    url: "/styles/blackwork/heart-shape-with-double-j-letters-XfCzp8x3S2N8BYc7tMfu3N",
    title: "heart shape with double j letters",
    list_url: "/styles/blackwork/heart-shape-with-double-j-letters"
  },
  {
    url: "/styles/blackwork/hentai-girl-moaning-PmRsGxJCn8Dm5eXAkEpREt",
    title: "hentai girl moaning",
    list_url: "/styles/blackwork/hentai-girl-moaning"
  },
  {
    url: "/styles/blackwork/lifes-a-gamble-Pnr2L5Jmsy41iiaGDmsfUc",
    title: "lifes a gamble",
    list_url: "/styles/blackwork/lifes-a-gamble"
  },
  {
    url: "/styles/blackwork/linkin-park-album-the-hunting-party-LE7xuuGPj88jSh7hGuyL4P",
    title: "linkin park album the hunting party",
    list_url: "/styles/blackwork/linkin-park-album-the-hunting-party"
  },
  {
    url: "/styles/blackwork/malcom-x-holding-ak-47-gun-dressed-like-3wYotouSBcKXM46W53Ht4v",
    title: "malcom x holding ak gun dressed like",
    list_url: "/styles/blackwork/malcom-x-holding-ak-47-gun-dressed-like"
  },
  {
    url: "/styles/blackwork/mansa-musa-HNNpsxkfn9KYuR4sDWWcdE",
    title: "mansa musa",
    list_url: "/styles/blackwork/mansa-musa"
  },
  {
    url: "/styles/blackwork/money-power-women-drugs-MLpLygWz9QYxg7ScVbH8md",
    title: "money power women drugs",
    list_url: "/styles/blackwork/money-power-women-drugs"
  },
  {
    url: "/styles/blackwork/moral-compass-with-old-ship-wheel-Y5uZ667qKgKJSTRF4n4Vqx",
    title: "moral compass with old ship wheel",
    list_url: "/styles/blackwork/moral-compass-with-old-ship-wheel"
  },
  {
    url: "/styles/blackwork/ojas-MGUV5e5Uhh9QonRCtXFKMq",
    title: "ojas",
    list_url: "/styles/blackwork/ojas"
  },
  {
    url: "/styles/blackwork/our-revenge-will-be-the-laughter-of-RSCjYyQeWar45zxnaBCgCe",
    title: "our revenge will be the laughter of",
    list_url: "/styles/blackwork/our-revenge-will-be-the-laughter-of"
  },
  {
    url: "/styles/blackwork/roshan-name-written-NQ2fN1EgE7M8LoT6LdoNo8",
    title: "roshan name written",
    list_url: "/styles/blackwork/roshan-name-written"
  },
  {
    url: "/styles/blackwork/samurai-next-to-a-japanese-house-KKp1kZDaKZmhAXtWQp2b7N",
    title: "samurai next to a japanese house",
    list_url: "/styles/blackwork/samurai-next-to-a-japanese-house"
  },
  {
    url: "/styles/blackwork/santa-muerte-con-rosas-LcPs38xMWjehPE6MyVZZzk",
    title: "santa muerte con rosas",
    list_url: "/styles/blackwork/santa-muerte-con-rosas"
  },
  {
    url: "/styles/blackwork/santa-muerte-sentada-en-su-trono-con-su-Rv7RzptUJUKmLxTBDvoA2a",
    title: "santa muerte sentada en su trono con su",
    list_url: "/styles/blackwork/santa-muerte-sentada-en-su-trono-con-su"
  },
  {
    url: "/styles/blackwork/sycamore-tree-9UxXhW2k917nrv3KMDjdwr",
    title: "sycamore tree",
    list_url: "/styles/blackwork/sycamore-tree"
  },
  {
    url: "/styles/blackwork/the-logo-of-a-black-metal-band-medieval-f7Qq8a5bM2FaTax59oKD3",
    title: "the logo of a black metal band medieval",
    list_url: "/styles/blackwork/the-logo-of-a-black-metal-band-medieval"
  },
  {
    url: "/styles/blackwork/the-name-amari-in-bubble-letters-89DsxXzS8dunzWhghyaP9Y",
    title: "the name amari in bubble letters",
    list_url: "/styles/blackwork/the-name-amari-in-bubble-letters"
  },
  {
    url: "/styles/blackwork/the-numbers-546-732AvJbyFc2LJgncug4xcE",
    title: "the numbers ",
    list_url: "/styles/blackwork/the-numbers-546"
  },
  {
    url: "/styles/blackwork/three-crosses-6fWnXP8mcanwrxywDLZ1J5",
    title: "three crosses",
    list_url: "/styles/blackwork/three-crosses"
  },
  {
    url: "/styles/blackwork/tooled-leather-cross-9nuZGV51DLsZy3NjySbCsJ",
    title: "tooled leather cross",
    list_url: "/styles/blackwork/tooled-leather-cross"
  },
  {
    url: "/styles/blackwork/two-crowns-for-her-AVpMFHvBMnwH7U8cRPKpwb",
    title: "two crowns for her",
    list_url: "/styles/blackwork/two-crowns-for-her"
  },
  {
    url: "/styles/blackwork/warhammer-40k-adeptus-custodes-Tvr3DgaxnFkkWBWurkDvQK",
    title: "warhammer k adeptus custodes",
    list_url: "/styles/blackwork/warhammer-40k-adeptus-custodes"
  },
  {
    url: "/styles/blackwork/withered-rose-CyBLCj59iJyzDoyHVCnw7K",
    title: "withered rose",
    list_url: "/styles/blackwork/withered-rose"
  },
  {
    url: "/styles/blackwork/zeus-poseidon-and-hades-8D1yYrtC15S2SmRdrmiEyv",
    title: "zeus poseidon and hades",
    list_url: "/styles/blackwork/zeus-poseidon-and-hades"
  },
  {
    url: "/styles/cursive-font/love-yourz-XEYcHg2yMQf922NDCstzJZ",
    title: "love yourz",
    list_url: "/styles/cursive-font/love-yourz"
  },
  {
    url: "/styles/dotwork/archangel-sigil-W7GKJekVJTh7PaBDfcMoLV",
    title: "archangel sigil",
    list_url: "/styles/dotwork/archangel-sigil"
  },
  {
    url: "/styles/dotwork/aztec-collar-UcNsFm519a1GWZ2JqYFCsa",
    title: "aztec collar",
    list_url: "/styles/dotwork/aztec-collar"
  },
  {
    url: "/styles/dotwork/bible-verse-mark-923-oh-lord-i-GtGjh8iGwNf4kRiJYwRmFS",
    title: "bible verse mark oh lord i",
    list_url: "/styles/dotwork/bible-verse-mark-923-oh-lord-i"
  },
  {
    url: "/styles/dotwork/bmw-Dj5z9oXZcEKSEji3Amz9jQ",
    title: "bmw",
    list_url: "/styles/dotwork/bmw"
  },
  {
    url: "/styles/dotwork/butterfly-rose-vine-wrapping-around-6ke4oyhhVd32hY4sofPx6m",
    title: "butterfly rose vine wrapping around",
    list_url: "/styles/dotwork/butterfly-rose-vine-wrapping-around"
  },
  {
    url: "/styles/dotwork/chicano-gangster-looney-tunes-Rdqz7yXhqmAS5aBAAsGwtq",
    title: "chicano gangster looney tunes",
    list_url: "/styles/dotwork/chicano-gangster-looney-tunes"
  },
  {
    url: "/styles/dotwork/chinese-zodiac-pig-9Z1tkAsGEQt6N51BedfmM5",
    title: "chinese zodiac pig",
    list_url: "/styles/dotwork/chinese-zodiac-pig"
  },
  {
    url: "/styles/dotwork/cupid-with-ak-JsGAnM6aBkC79pkWC2NGWs",
    title: "cupid with ak",
    list_url: "/styles/dotwork/cupid-with-ak"
  },
  {
    url: "/styles/dotwork/cursive-letter-f-LSCxwXprEYEtzWphK7XfV6",
    title: "cursive letter f",
    list_url: "/styles/dotwork/cursive-letter-f"
  },
  {
    url: "/styles/dotwork/deus-ex-machina-PCDkqhTiMYfjc5eNantxSe",
    title: "deus ex machina",
    list_url: "/styles/dotwork/deus-ex-machina"
  },
  {
    url: "/styles/dotwork/dog-paw-with-a-semicolon-VBtVBcF57eNfACDoVPCHwd",
    title: "dog paw with a semicolon",
    list_url: "/styles/dotwork/dog-paw-with-a-semicolon"
  },
  {
    url: "/styles/dotwork/dragon-ball-shenron-Hxx8R5L31kaUBFNozmyYqD",
    title: "dragon ball shenron",
    list_url: "/styles/dotwork/dragon-ball-shenron"
  },
  {
    url: "/styles/dotwork/dragon-cute-couple-tattoo-6pkNJZ9Uu7PTEbdh713oLs",
    title: "dragon cute couple tattoo",
    list_url: "/styles/dotwork/dragon-cute-couple-tattoo"
  },
  {
    url: "/styles/dotwork/final-fantasy-16-ifrit-Ro4SgQQMcQS7L2o4Kx1Kd6",
    title: "final fantasy ifrit",
    list_url: "/styles/dotwork/final-fantasy-16-ifrit"
  },
  {
    url: "/styles/dotwork/fox-with-three-eyes-8WiPJDUvFAbtrduA2gJNDp",
    title: "fox with three eyes",
    list_url: "/styles/dotwork/fox-with-three-eyes"
  },
  {
    url: "/styles/dotwork/gorilla-family-hiking-through-a-lush-XKKhPFej9EzjQ5x69qyda9",
    title: "gorilla family hiking through a lush",
    list_url: "/styles/dotwork/gorilla-family-hiking-through-a-lush"
  },
  {
    url: "/styles/dotwork/gucci-FKfx9Sezh1s8yuCGLQcTsP",
    title: "gucci",
    list_url: "/styles/dotwork/gucci"
  },
  {
    url: "/styles/dotwork/guns-n-roses-sweet-child-o-mine-6d73Fmds5n9BzzWK7y8es9",
    title: "guns n roses sweet child o mine",
    list_url: "/styles/dotwork/guns-n-roses-sweet-child-o-mine"
  },
  {
    url: "/styles/dotwork/houston-astros-FQ6ZDmkCvuL3cnsEeG3iGi",
    title: "houston astros",
    list_url: "/styles/dotwork/houston-astros"
  },
  {
    url: "/styles/dotwork/landslide-by-fleetwood-mac-LWrUj3LN6bM3LEHA22V4Xo",
    title: "landslide by fleetwood mac",
    list_url: "/styles/dotwork/landslide-by-fleetwood-mac"
  },
  {
    url: "/styles/dotwork/mayan-tribal-for-the-back-neck-Mb5iNvvmkpuNK6MyvEMkqQ",
    title: "mayan tribal for the back neck",
    list_url: "/styles/dotwork/mayan-tribal-for-the-back-neck"
  },
  {
    url: "/styles/dotwork/mia-name-with-princess-crown-4xxocAjNrwf17ZXsj5eQ8K",
    title: "mia name with princess crown",
    list_url: "/styles/dotwork/mia-name-with-princess-crown"
  },
  {
    url: "/styles/dotwork/milwaukee-skyline-39K9Zo9D4uWucW7WSGxnFw",
    title: "milwaukee skyline",
    list_url: "/styles/dotwork/milwaukee-skyline"
  },
  {
    url: "/styles/dotwork/number-26-12-1986-in-roman-numerals-7Jh95BCv3s8DDbjUnrsTwN",
    title: "number in roman numerals",
    list_url: "/styles/dotwork/number-26-12-1986-in-roman-numerals"
  },
  {
    url: "/styles/dotwork/ornn-YJyo7jrW6sFTcZHQ1fvPeV",
    title: "ornn",
    list_url: "/styles/dotwork/ornn"
  },
  {
    url: "/styles/dotwork/scottish-irish-and-german-heritage-AEfdLVwdEAUTRpHt8rVEhG",
    title: "scottish irish and german heritage",
    list_url: "/styles/dotwork/scottish-irish-and-german-heritage"
  },
  {
    url: "/styles/dotwork/skeleton-hand-SBEk46x6wTUPdyVKUZH9CB",
    title: "skeleton hand",
    list_url: "/styles/dotwork/skeleton-hand"
  },
  {
    url: "/styles/dotwork/strippers-FEepsLJYXsbj29K6goEA4t",
    title: "strippers",
    list_url: "/styles/dotwork/strippers"
  },
  {
    url: "/styles/dotwork/tenerife-island-with-palm-tree-and-the-RsQq3XMbaoCYSCZLZ6ZCYu",
    title: "tenerife island with palm tree and the",
    list_url: "/styles/dotwork/tenerife-island-with-palm-tree-and-the"
  },
  {
    url: "/styles/dotwork/the-norns-KmGhm16CVjEjneGX7u8AaB",
    title: "the norns",
    list_url: "/styles/dotwork/the-norns"
  },
  {
    url: "/styles/dotwork/the-special-warfare-insignia-navy-seal-NS2q4BzVimFJwKEgM1bSNZ",
    title: "the special warfare insignia navy seal",
    list_url: "/styles/dotwork/the-special-warfare-insignia-navy-seal"
  },
  {
    url: "/styles/dotwork/trishul-with-snake-VD6ZTyDSztyqqU9bFASX4d",
    title: "trishul with snake",
    list_url: "/styles/dotwork/trishul-with-snake"
  },
  {
    url: "/styles/dotwork/use-the-bible-verse-proverbs-423-above-HtmgyAxmPG7bZobzQMvkU5",
    title: "use the bible verse proverbs above",
    list_url: "/styles/dotwork/use-the-bible-verse-proverbs-423-above"
  },
  {
    url: "/styles/dotwork/vimal-name-3mJw6CDFT7zXmAuWHTV3QA",
    title: "vimal name",
    list_url: "/styles/dotwork/vimal-name"
  },
  {
    url: "/styles/dotwork/western-taipan-snake-6hbjLyHeh4FvkmLfUbNT4v",
    title: "western taipan snake",
    list_url: "/styles/dotwork/western-taipan-snake"
  },
  {
    url: "/styles/gangster-font",
    title: "gangster",
    list_url: "/styles/gangster"
  },
  {
    url: "/styles/geometric/2023-roman-numerals-5FzJpRbs3mbR7AciyKnbir",
    title: " roman numerals",
    list_url: "/styles/geometric/2023-roman-numerals"
  },
  {
    url: "/styles/geometric/3-faced-medusa-face-SMq1Nn7rvFLoXEaSXpPSPR",
    title: " faced medusa face",
    list_url: "/styles/geometric/3-faced-medusa-face"
  },
  {
    url: "/styles/geometric/assassins-creed-hidden-blade-PP7ATzQwHA1u2nympsSStd",
    title: "assassins creed hidden blade",
    list_url: "/styles/geometric/assassins-creed-hidden-blade"
  },
  {
    url: "/styles/geometric/brahman-YHMd2rW5fpYbjFEmEmTaPT",
    title: "brahman",
    list_url: "/styles/geometric/brahman"
  },
  {
    url: "/styles/geometric/david-bowie-ziggy-stardust-lightning-SC9WyvYpq8fNmpXF7RnwNU",
    title: "david bowie ziggy stardust lightning",
    list_url: "/styles/geometric/david-bowie-ziggy-stardust-lightning"
  },
  {
    url: "/styles/geometric/moon-elephant-angel-wing-5bFMuQrYTKAjoZPGwMcgTY",
    title: "moon elephant angel wing",
    list_url: "/styles/geometric/moon-elephant-angel-wing"
  },
  {
    url: "/styles/geometric/two-ravens-TZcBZzWhJnW9ESZgmysHDp",
    title: "two ravens",
    list_url: "/styles/geometric/two-ravens"
  },
  {
    url: "/styles/geometric/urvi-5wKNWSBGqN6K3VGnuPP1fm",
    title: "urvi",
    list_url: "/styles/geometric/urvi"
  },
  {
    url: "/styles/ignorant/bubble-letters-king-5BQxovn3XXL6CcRLEzcsCc",
    title: "bubble letters king",
    list_url: "/styles/ignorant/bubble-letters-king"
  },
  {
    url: "/styles/ignorant/for-the-name-sandhya-Wu68p5R9QFHowotefuqaZT",
    title: "for the name sandhya",
    list_url: "/styles/ignorant/for-the-name-sandhya"
  },
  {
    url: "/styles/japanese/angel-DfUwvf57eLpgB1LB7HBkKU",
    title: "angel",
    list_url: "/styles/japanese/angel"
  },
  {
    url: "/styles/japanese/cherry-blossom-with-moon-KRTNWsiaF539FzZdcxu7uE",
    title: "cherry blossom with moon",
    list_url: "/styles/japanese/cherry-blossom-with-moon"
  },
  {
    url: "/styles/japanese/dragon-turtle-WqgFJDNWLpCZaEsJL8vwSJ",
    title: "dragon turtle",
    list_url: "/styles/japanese/dragon-turtle"
  },
  {
    url: "/styles/japanese/geisha-with-katana-Gn61dVDEdg4XEGNQsBTGPk",
    title: "geisha with katana",
    list_url: "/styles/japanese/geisha-with-katana"
  },
  {
    url: "/styles/japanese/godzilla-RfRYw8ThrfSF8GLqqFbFnp",
    title: "godzilla",
    list_url: "/styles/japanese/godzilla"
  },
  {
    url: "/styles/japanese/irezumi-black-grey-tattoo-whit-samurai-AXDSHfduWnBdkSocZLT77i",
    title: "irezumi black grey tattoo whit samurai",
    list_url: "/styles/japanese/irezumi-black-grey-tattoo-whit-samurai"
  },
  {
    url: "/styles/japanese/kingdom-hearts-nobody-JYBQ6hCRm9cLgSFiUqy6dJ",
    title: "kingdom hearts nobody",
    list_url: "/styles/japanese/kingdom-hearts-nobody"
  },
  {
    url: "/styles/japanese/love-kanji-9EjQ3mh2B5XeuCsqaapHJX",
    title: "love kanji",
    list_url: "/styles/japanese/love-kanji"
  },
  {
    url: "/styles/japanese/lucky-coins-TJsKAfJhujhyD2fCvBRHAg",
    title: "lucky coins",
    list_url: "/styles/japanese/lucky-coins"
  },
  {
    url: "/styles/japanese/mia-9jKfiS6XSJSgVfrsyKg44W",
    title: "mia",
    list_url: "/styles/japanese/mia"
  },
  {
    url: "/styles/japanese/monkey-on-tree-GjKSm9YrsQoy4SQhpPsSWt",
    title: "monkey on tree",
    list_url: "/styles/japanese/monkey-on-tree"
  },
  {
    url: "/styles/japanese/nissan-skyline-r34-5yeJhAjsApg3PPDPZixmHK",
    title: "nissan skyline r ",
    list_url: "/styles/japanese/nissan-skyline-r34"
  },
  {
    url: "/styles/japanese/peacock-Ectvxfqmz1PK679YFQ1Die",
    title: "peacock",
    list_url: "/styles/japanese/peacock"
  },
  {
    url: "/styles/japanese/phoenix-with-snake-82N2gnndiqtzgWSU9jBxjA",
    title: "phoenix with snake",
    list_url: "/styles/japanese/phoenix-with-snake"
  },
  {
    url: "/styles/japanese/pisces-with-mermaid-X4qquX9KCNuf9wCcouzg45",
    title: "pisces with mermaid",
    list_url: "/styles/japanese/pisces-with-mermaid"
  },
  {
    url: "/styles/japanese/ryuk-SV5eCpJ8FuKcriEoxcYFwN",
    title: "ryuk",
    list_url: "/styles/japanese/ryuk"
  },
  {
    url: "/styles/japanese/samurai-jack-q13DJe5mTcLbCs9Vicorr",
    title: "samurai jack",
    list_url: "/styles/japanese/samurai-jack"
  },
  {
    url: "/styles/japanese/samurai-sword-through-arm-on-elbow-T5PWDPrh89vu1UVjCzNUiN",
    title: "samurai sword through arm on elbow",
    list_url: "/styles/japanese/samurai-sword-through-arm-on-elbow"
  },
  {
    url: "/styles/japanese/smoke-with-eye-QG5ztxnekbQxex3eboXwiv",
    title: "smoke with eye",
    list_url: "/styles/japanese/smoke-with-eye"
  },
  {
    url: "/styles/japanese/straw-hat-ronin-XkNvTRcKoods36SircEnAL",
    title: "straw hat ronin",
    list_url: "/styles/japanese/straw-hat-ronin"
  },
  {
    url: "/styles/japanese/susanoo-itachi-7MUnF1U272mQq8QU11z3qR",
    title: "susanoo itachi",
    list_url: "/styles/japanese/susanoo-itachi"
  },
  {
    url: "/styles/japanese/tcb-LgSaNwmCDhqQjKa8CBJPXG",
    title: "tcb",
    list_url: "/styles/japanese/tcb"
  },
  {
    url: "/styles/minimalist/2-penguins-facing-each-other-and-one-KoiboCTdcM1PHFpT1VqN2P",
    title: " penguins facing each other and one",
    list_url: "/styles/minimalist/2-penguins-facing-each-other-and-one"
  },
  {
    url: "/styles/minimalist/777-TLLe7hiKi5PFXZ5LKprSU7",
    title: " ",
    list_url: "/styles/minimalist/777"
  },
  {
    url: "/styles/minimalist/a-delicate-tattoo-of-a-loaf-of-bread-WSuR93UggfxssLuHU3Xt7W",
    title: "a delicate tattoo of a loaf of bread",
    list_url: "/styles/minimalist/a-delicate-tattoo-of-a-loaf-of-bread"
  },
  {
    url: "/styles/minimalist/a-minimal-mens-chest-tattoo-with-greek-4gaC9fbfFXpFHt2PXD8zr7",
    title: "a minimal mens chest tattoo with greek",
    list_url: "/styles/minimalist/a-minimal-mens-chest-tattoo-with-greek"
  },
  {
    url: "/styles/minimalist/a-minimalist-and-simple-beagle-D5wiSb3HqP2RSwSHw9NLFx",
    title: "a minimalist and simple beagle",
    list_url: "/styles/minimalist/a-minimalist-and-simple-beagle"
  },
  {
    url: "/styles/minimalist/a-minimalist-tattoo-of-a-black-and-red-Mx4PAq2zjwyt9emtw22jzb",
    title: "a minimalist tattoo of a black and red",
    list_url: "/styles/minimalist/a-minimalist-tattoo-of-a-black-and-red"
  },
  {
    url: "/styles/minimalist/a-red-tailed-hawk-41uwUrt7JSkpDtYGe6W3iT",
    title: "a red tailed hawk",
    list_url: "/styles/minimalist/a-red-tailed-hawk"
  },
  {
    url: "/styles/minimalist/a-text-that-says-you-bleed-just-to-Dx33xg1Vf8unZvdKFnT4VP",
    title: "a text that says you bleed just to",
    list_url: "/styles/minimalist/a-text-that-says-you-bleed-just-to"
  },
  {
    url: "/styles/minimalist/ace-spades-V9kGYpqTWzfiqmSRy2ehXu",
    title: "ace spades",
    list_url: "/styles/minimalist/ace-spades"
  },
  {
    url: "/styles/minimalist/allergy-to-penicillin-DFt9v82hifBp4pHrsBPUQk",
    title: "allergy to penicillin",
    list_url: "/styles/minimalist/allergy-to-penicillin"
  },
  {
    url: "/styles/minimalist/amira-name-EYDisZocaeFNfjvW8mt9mB",
    title: "amira name",
    list_url: "/styles/minimalist/amira-name"
  },
  {
    url: "/styles/minimalist/amor-integritas-honestas-et-Sk8VGTPnHXRuaLnRxZUZY1",
    title: "amor integritas honestas et",
    list_url: "/styles/minimalist/amor-integritas-honestas-et"
  },
  {
    url: "/styles/minimalist/anchor-and-semicolon-Ss3NUBrp9nuzUaerv5F8ps",
    title: "anchor and semicolon",
    list_url: "/styles/minimalist/anchor-and-semicolon"
  },
  {
    url: "/styles/minimalist/angel-wings-X4LvEcZEbxYuksSwzNpCH6",
    title: "angel wings",
    list_url: "/styles/minimalist/angel-wings"
  },
  {
    url: "/styles/minimalist/apple-tree-branch-surrounded-by-flowers-Jvk3y2sGCLet1BNUfmHZce",
    title: "apple tree branch surrounded by flowers",
    list_url: "/styles/minimalist/apple-tree-branch-surrounded-by-flowers"
  },
  {
    url: "/styles/minimalist/bart-simpson-holding-up-middle-finger-TBqnYtSKZKBuyVrmYcViQD",
    title: "bart simpson holding up middle finger",
    list_url: "/styles/minimalist/bart-simpson-holding-up-middle-finger"
  },
  {
    url: "/styles/minimalist/benson-boone-symbol-inspired-tattoo-ApYSp5LcWXiRkMB626KKj9",
    title: "benson boone symbol inspired tattoo",
    list_url: "/styles/minimalist/benson-boone-symbol-inspired-tattoo"
  },
  {
    url: "/styles/minimalist/boxing-hand-wraps-P38HXEBMgBz565ZzJoxaQA",
    title: "boxing hand wraps",
    list_url: "/styles/minimalist/boxing-hand-wraps"
  },
  {
    url: "/styles/minimalist/boyfriend-name-69qmERyfJpc6hnFj4DiMBH",
    title: "boyfriend name",
    list_url: "/styles/minimalist/boyfriend-name"
  },
  {
    url: "/styles/minimalist/boywithuke-D7L7g82LAyJSfX7eppbKJ",
    title: "boywithuke",
    list_url: "/styles/minimalist/boywithuke"
  },
  {
    url: "/styles/minimalist/brave-new-world-aldous-huxley-RYM6PG3gRPuTcpTCVud1FC",
    title: "brave new world aldous huxley",
    list_url: "/styles/minimalist/brave-new-world-aldous-huxley"
  },
  {
    url: "/styles/minimalist/brent-faiyaz-48Jfbutz8R6QUR7BzpXG6f",
    title: "brent faiyaz",
    list_url: "/styles/minimalist/brent-faiyaz"
  },
  {
    url: "/styles/minimalist/chase-the-bag-NXgWVs1jV9Zyh2d9UFfwL9",
    title: "chase the bag",
    list_url: "/styles/minimalist/chase-the-bag"
  },
  {
    url: "/styles/minimalist/cherry-blossom-with-katana-sword-58vKypEKDeeEzPJaaR6wgs",
    title: "cherry blossom with katana sword",
    list_url: "/styles/minimalist/cherry-blossom-with-katana-sword"
  },
  {
    url: "/styles/minimalist/curlew-FuYAgyyFFsqU3xVWdXTaNb",
    title: "curlew",
    list_url: "/styles/minimalist/curlew"
  },
  {
    url: "/styles/minimalist/dad-and-son-walking-VWoBkofE9zUXqqHAytyoN8",
    title: "dad and son walking",
    list_url: "/styles/minimalist/dad-and-son-walking"
  },
  {
    url: "/styles/minimalist/everything-happens-for-a-reason-in-74JVNfeParNieLGieF7jGi",
    title: "everything happens for a reason in",
    list_url: "/styles/minimalist/everything-happens-for-a-reason-in"
  },
  {
    url: "/styles/minimalist/fc-barcelona-9TeoBEB4b1u2MDw1rpLE9t",
    title: "fc barcelona",
    list_url: "/styles/minimalist/fc-barcelona"
  },
  {
    url: "/styles/minimalist/flowers-in-smoke-8DdyM6Wkq5CgV6tfC9fBJZ",
    title: "flowers in smoke",
    list_url: "/styles/minimalist/flowers-in-smoke"
  },
  {
    url: "/styles/minimalist/french-words-la-vie-est-belle-2VDkHQnPWvR9ezmeNEcfHb",
    title: "french words la vie est belle",
    list_url: "/styles/minimalist/french-words-la-vie-est-belle"
  },
  {
    url: "/styles/minimalist/gloria-in-excelsis-deo-HnwDQYpuQBnJ9GbgzRuHtC",
    title: "gloria in excelsis deo",
    list_url: "/styles/minimalist/gloria-in-excelsis-deo"
  },
  {
    url: "/styles/minimalist/handm-V89ToCMPt1ZsojWgxRgwct",
    title: "handm",
    list_url: "/styles/minimalist/handm"
  },
  {
    url: "/styles/minimalist/honey-pot-7hWndYoXFVCRbZepWPQPVT",
    title: "honey pot",
    list_url: "/styles/minimalist/honey-pot"
  },
  {
    url: "/styles/minimalist/just-do-it-4izCkAfq718nqmXWXUYwGU",
    title: "just do it",
    list_url: "/styles/minimalist/just-do-it"
  },
  {
    url: "/styles/minimalist/letters-ag-7pcZkDhWzhzakDHnMREPmU",
    title: "letters ag",
    list_url: "/styles/minimalist/letters-ag"
  },
  {
    url: "/styles/minimalist/letters-peace-will-win-fear-will-lose-J4e35szmyR4TY1gYeh5Kqn",
    title: "letters peace will win fear will lose",
    list_url: "/styles/minimalist/letters-peace-will-win-fear-will-lose"
  },
  {
    url: "/styles/minimalist/life-goes-on-XfHGNiMJzq8YToKrpXPVrC",
    title: "life goes on",
    list_url: "/styles/minimalist/life-goes-on"
  },
  {
    url: "/styles/minimalist/lily-CqZgRZNubRYyxVEvZ8qtt7",
    title: "lily",
    list_url: "/styles/minimalist/lily"
  },
  {
    url: "/styles/minimalist/lorraine-name-written-KVDA48uKbz6kncGNt3ct93",
    title: "lorraine name written",
    list_url: "/styles/minimalist/lorraine-name-written"
  },
  {
    url: "/styles/minimalist/micah-78-bible-verse-U8tDDwmz8NrE5xUN3cTrvs",
    title: "micah bible verse",
    list_url: "/styles/minimalist/micah-78-bible-verse"
  },
  {
    url: "/styles/minimalist/my-daughter-name-is-arya-and-my-vignesh-CQcENzakZpT421xstBnmNg",
    title: "my daughter name is arya and my vignesh",
    list_url: "/styles/minimalist/my-daughter-name-is-arya-and-my-vignesh"
  },
  {
    url: "/styles/minimalist/rishi-name-tattoo-JkXgjDtMWSx1n1YMtZGd1v",
    title: "rishi name tattoo",
    list_url: "/styles/minimalist/rishi-name-tattoo"
  },
  {
    url: "/styles/minimalist/sahlo-folina-NXNtwurW649oyciMYpwovu",
    title: "sahlo folina",
    list_url: "/styles/minimalist/sahlo-folina"
  },
  {
    url: "/styles/minimalist/shiva-MpbpwvMzRRpuoUcEaoMJMs",
    title: "shiva",
    list_url: "/styles/minimalist/shiva"
  },
  {
    url: "/styles/minimalist/simple-letter-b-king-crown-above-it-4bWsdCSzKbzGAnZXnnZwoc",
    title: "simple letter b king crown above it",
    list_url: "/styles/minimalist/simple-letter-b-king-crown-above-it"
  },
  {
    url: "/styles/minimalist/small-fine-line-wispy-single-lily-JYVwmJAvTwxpVh1L6mgppd",
    title: "small fine line wispy single lily",
    list_url: "/styles/minimalist/small-fine-line-wispy-single-lily"
  },
  {
    url: "/styles/minimalist/small-minimal-back-tattoo-women-Ktnfkufkct9TrPwBGyFobV",
    title: "small minimal back tattoo women",
    list_url: "/styles/minimalist/small-minimal-back-tattoo-women"
  },
  {
    url: "/styles/minimalist/stewie-griffin-with-a-gun-SGWwMWS3h1VgT8dDYaeU3q",
    title: "stewie griffin with a gun",
    list_url: "/styles/minimalist/stewie-griffin-with-a-gun"
  },
  {
    url: "/styles/minimalist/sunflower-arrow-1111-7cZCKs6zr3RdtZa5ipW3bg",
    title: "sunflower arrow ",
    list_url: "/styles/minimalist/sunflower-arrow-1111"
  },
  {
    url: "/styles/minimalist/tears-dry-on-their-own-MXwvPSEnXbcxarphxi8UPj",
    title: "tears dry on their own",
    list_url: "/styles/minimalist/tears-dry-on-their-own"
  },
  {
    url: "/styles/minimalist/to-kill-a-mockingbird-HEL5iV81WJe7ZLdbx2V6v",
    title: "to kill a mockingbird",
    list_url: "/styles/minimalist/to-kill-a-mockingbird"
  },
  {
    url: "/styles/minimalist/trinacria-WvHSr9h5CJ8JvWza54VtNG",
    title: "trinacria",
    list_url: "/styles/minimalist/trinacria"
  },
  {
    url: "/styles/minimalist/ukulele-SwERFvapQ3fmDwgy2VkwYg",
    title: "ukulele",
    list_url: "/styles/minimalist/ukulele"
  },
  {
    url: "/styles/minimalist/veridis-quo-text-behind-the-earfrom-Wg587j6QugZyySAB8sN8GM",
    title: "veridis quo text behind the earfrom",
    list_url: "/styles/minimalist/veridis-quo-text-behind-the-earfrom"
  },
  {
    url: "/styles/neotraditional/828-in-roman-numerals-LmEJzzeketWsHg355Wu9qc",
    title: " in roman numerals",
    list_url: "/styles/neotraditional/828-in-roman-numerals"
  },
  {
    url: "/styles/neotraditional/abhimanyu-name-on-key-PqtBpkkXniZSoRqvPnRYnJ",
    title: "abhimanyu name on key",
    list_url: "/styles/neotraditional/abhimanyu-name-on-key"
  },
  {
    url: "/styles/neotraditional/bat-hanging-upside-down-with-lace-wings-SttAfcCXWspJfee5CJ4rru",
    title: "bat hanging upside down with lace wings",
    list_url: "/styles/neotraditional/bat-hanging-upside-down-with-lace-wings"
  },
  {
    url: "/styles/neotraditional/chelsea-fc-lion-2cov5cWgVmjCgcYkPdQ9us",
    title: "chelsea fc lion",
    list_url: "/styles/neotraditional/chelsea-fc-lion"
  },
  {
    url: "/styles/neotraditional/desi-girl-in-saree-GFhE95kVkCKmskNpgEHeqV",
    title: "desi girl in saree",
    list_url: "/styles/neotraditional/desi-girl-in-saree"
  },
  {
    url: "/styles/neotraditional/disney-villain-black-and-white-tattoo-HtU7mDh7d8j5vXrAcZhAiH",
    title: "disney villain black and white tattoo",
    list_url: "/styles/neotraditional/disney-villain-black-and-white-tattoo"
  },
  {
    url: "/styles/neotraditional/dog-in-cowboy-hat-A69MXnpMQzeS9GRNBhh2rR",
    title: "dog in cowboy hat",
    list_url: "/styles/neotraditional/dog-in-cowboy-hat"
  },
  {
    url: "/styles/neotraditional/elmo-with-gun-6qGApqK1PBHoZsn7792XnU",
    title: "elmo with gun",
    list_url: "/styles/neotraditional/elmo-with-gun"
  },
  {
    url: "/styles/neotraditional/erra-invent-animate-currents-silent-88FxUvWPyvGMsW69iznQcE",
    title: "erra invent animate currents silent",
    list_url: "/styles/neotraditional/erra-invent-animate-currents-silent"
  },
  {
    url: "/styles/neotraditional/erykah-badu-5QdMxfB1eeV2ESSV8QptVi",
    title: "erykah badu",
    list_url: "/styles/neotraditional/erykah-badu"
  },
  {
    url: "/styles/neotraditional/everlasting-love-TywwmTnBRBb8TGvgvDtH6o",
    title: "everlasting love",
    list_url: "/styles/neotraditional/everlasting-love"
  },
  {
    url: "/styles/neotraditional/frida-kahlo-with-kun-faya-kun-tattto-A3BwwnSgJwL8oPfRA8Fj9",
    title: "frida kahlo with kun faya kun tattto",
    list_url: "/styles/neotraditional/frida-kahlo-with-kun-faya-kun-tattto"
  },
  {
    url: "/styles/neotraditional/into-your-hands-i-commit-my-spirit-ySu9NZD2577uSPvMeprKS",
    title: "into your hands i commit my spirit",
    list_url: "/styles/neotraditional/into-your-hands-i-commit-my-spirit"
  },
  {
    url: "/styles/neotraditional/jasmine-flower-for-male-J97pps2gi1DYnRU7ycaeNi",
    title: "jasmine flower for male",
    list_url: "/styles/neotraditional/jasmine-flower-for-male"
  },
  {
    url: "/styles/neotraditional/jehovah-vertically-and-adonai-QtAhRGkABuvQgEDTnLcz3c",
    title: "jehovah vertically and adonai",
    list_url: "/styles/neotraditional/jehovah-vertically-and-adonai"
  },
  {
    url: "/styles/neotraditional/jesus-on-white-horse-QdVddBFVEhJELhzWY1DguY",
    title: "jesus on white horse",
    list_url: "/styles/neotraditional/jesus-on-white-horse"
  },
  {
    url: "/styles/neotraditional/l-and-r-letter-BhfFPo7YtBvZaQZgQqQTR1",
    title: "l and r letter",
    list_url: "/styles/neotraditional/l-and-r-letter"
  },
  {
    url: "/styles/neotraditional/laughing-buddha-MUimS5UVcbJYLkzCnBZCpJ",
    title: "laughing buddha",
    list_url: "/styles/neotraditional/laughing-buddha"
  },
  {
    url: "/styles/neotraditional/man-united-munich-clock-within-mufc-N9iJ9rYUuwV6KEmkpSuEZV",
    title: "man united munich clock within mufc",
    list_url: "/styles/neotraditional/man-united-munich-clock-within-mufc"
  },
  {
    url: "/styles/neotraditional/mariah-xp21m7jgVDn3LB94sXXZ7",
    title: "mariah",
    list_url: "/styles/neotraditional/mariah"
  },
  {
    url: "/styles/neotraditional/morrigan-celtic-goddess-72Z9xFuEYVNxqH14pvgwEZ",
    title: "morrigan celtic goddess",
    list_url: "/styles/neotraditional/morrigan-celtic-goddess"
  },
  {
    url: "/styles/neotraditional/naga-dragon-laos-MEt5RtTvCC5yhnbSPQh5ZB",
    title: "naga dragon laos",
    list_url: "/styles/neotraditional/naga-dragon-laos"
  },
  {
    url: "/styles/neotraditional/name-amal-GCJwSfkyFgYGnx8JQgnv8X",
    title: "name amal",
    list_url: "/styles/neotraditional/name-amal"
  },
  {
    url: "/styles/neotraditional/qos-queen-of-spades-De3qtjYD9wKgzF6N5NJ4sX",
    title: "qos queen of spades",
    list_url: "/styles/neotraditional/qos-queen-of-spades"
  },
  {
    url: "/styles/neotraditional/saint-nicholas-5ry2sHjXU92MJqxWNDaiGQ",
    title: "saint nicholas",
    list_url: "/styles/neotraditional/saint-nicholas"
  },
  {
    url: "/styles/neotraditional/scooby-doo-and-shaggy-smoking-YA57PRM3UVSjbgYYjBFiZS",
    title: "scooby doo and shaggy smoking",
    list_url: "/styles/neotraditional/scooby-doo-and-shaggy-smoking"
  },
  {
    url: "/styles/neotraditional/shoganai-7ok4xM2YTwHSSvZ5eYLmkZ",
    title: "shoganai",
    list_url: "/styles/neotraditional/shoganai"
  },
  {
    url: "/styles/neotraditional/skeleton-hand-holding-flowers-Pkj6LAtj9VVstaFrN7bAsh",
    title: "skeleton hand holding flowers",
    list_url: "/styles/neotraditional/skeleton-hand-holding-flowers"
  },
  {
    url: "/styles/neotraditional/skeleton-hand-middle-finger-tattoo-font-XGcaaC7s8SqMZjmphLBuWQ",
    title: "skeleton hand middle finger tattoo font",
    list_url: "/styles/neotraditional/skeleton-hand-middle-finger-tattoo-font"
  },
  {
    url: "/styles/neotraditional/spirit-of-ecstasy-rolls-royce-emblem-3or1GSKrVrrs7Nm9Q2nEVc",
    title: "spirit of ecstasy rolls royce emblem",
    list_url: "/styles/neotraditional/spirit-of-ecstasy-rolls-royce-emblem"
  },
  {
    url: "/styles/neotraditional/star-wars-JrbhMBXZScE5ZimHxP3kik",
    title: "star wars",
    list_url: "/styles/neotraditional/star-wars"
  },
  {
    url: "/styles/neotraditional/sunflower-with-angel-wings-surrounded-E2o62iZwJWAuuk8CB3ubhA",
    title: "sunflower with angel wings surrounded",
    list_url: "/styles/neotraditional/sunflower-with-angel-wings-surrounded"
  },
  {
    url: "/styles/neotraditional/tejas-LCZANneJotfnHm6eKZwQdP",
    title: "tejas",
    list_url: "/styles/neotraditional/tejas"
  },
  {
    url: "/styles/neotraditional/the-motherland-calls-statue-GRbGtuZoxTLRib37Ekix9w",
    title: "the motherland calls statue",
    list_url: "/styles/neotraditional/the-motherland-calls-statue"
  },
  {
    url: "/styles/neotraditional/the-name-enzo-66Ju5h17Qx814QhymGgCv3",
    title: "the name enzo",
    list_url: "/styles/neotraditional/the-name-enzo"
  },
  {
    url: "/styles/neotraditional/the-name-lauren-in-the-sky-filled-with-L2hVNJ6gTTnZDMqAo1LxJW",
    title: "the name lauren in the sky filled with",
    list_url: "/styles/neotraditional/the-name-lauren-in-the-sky-filled-with"
  },
  {
    url: "/styles/neotraditional/the-quote-blood-in-blood-out-but-the-8i6xjfe3fYkZ2VYviFRMWW",
    title: "the quote blood in blood out but the",
    list_url: "/styles/neotraditional/the-quote-blood-in-blood-out-but-the"
  },
  {
    url: "/styles/neotraditional/vishal-4iMMRdDFd6nvyxRex8shdc",
    title: "vishal",
    list_url: "/styles/neotraditional/vishal"
  },
  {
    url: "/styles/neotraditional/w-a-s-d-keys-on-the-gaming-computer-Av2YHVjZhv9i8P5WLArYG2",
    title: "w a s d keys on the gaming computer",
    list_url: "/styles/neotraditional/w-a-s-d-keys-on-the-gaming-computer"
  },
  {
    url: "/styles/new-school/money-magnet-GwBREZM98rXMSfAeMBH4kV",
    title: "money magnet",
    list_url: "/styles/new-school/money-magnet"
  },
  {
    url: "/styles/realism/a-grim-reaper-holding-a-machine-gun-v3i2tL5cNgCgdn29zk6hG",
    title: "a grim reaper holding a machine gun",
    list_url: "/styles/realism/a-grim-reaper-holding-a-machine-gun"
  },
  {
    url: "/styles/realism/a-wolf-with-wings-carries-the-soul-of-a-UMLM4Lg34qnnZmdHPLYJde",
    title: "a wolf with wings carries the soul of a",
    list_url: "/styles/realism/a-wolf-with-wings-carries-the-soul-of-a"
  },
  {
    url: "/styles/realism/african-lion-Ke1wH79v3Xv2FU65g6gxqQ",
    title: "african lion",
    list_url: "/styles/realism/african-lion"
  },
  {
    url: "/styles/realism/aircraft-engine-airbus-6d7qpFAcB2YntuP54yceYh",
    title: "aircraft engine airbus",
    list_url: "/styles/realism/aircraft-engine-airbus"
  },
  {
    url: "/styles/realism/ares-and-athena-GjKtyiMrzpsQaHsMdHUMer",
    title: "ares and athena",
    list_url: "/styles/realism/ares-and-athena"
  },
  {
    url: "/styles/realism/avi-name-Jja7viNrqUUdksy2euJXWE",
    title: "avi name",
    list_url: "/styles/realism/avi-name"
  },
  {
    url: "/styles/realism/baby-cheetah-YAYQBYhrRZWuCTk78KHgRP",
    title: "baby cheetah",
    list_url: "/styles/realism/baby-cheetah"
  },
  {
    url: "/styles/realism/blue-dragon-and-red-phoenix-Tgfo1S3MmvLNpoMz97o3Hg",
    title: "blue dragon and red phoenix",
    list_url: "/styles/realism/blue-dragon-and-red-phoenix"
  },
  {
    url: "/styles/realism/blue-hibiscus-F1VDzxAJiw8mwmDGpfHxFW",
    title: "blue hibiscus",
    list_url: "/styles/realism/blue-hibiscus"
  },
  {
    url: "/styles/realism/calla-lily-G8GKynnH3ZvZVepwRFQoGn",
    title: "calla lily",
    list_url: "/styles/realism/calla-lily"
  },
  {
    url: "/styles/realism/christ-the-redeemer-T9i77rsWBymYCyQvUHD9zX",
    title: "christ the redeemer",
    list_url: "/styles/realism/christ-the-redeemer"
  },
  {
    url: "/styles/realism/condor-puma-serpent-inca-trilogy-XWMCdKUzhwfU7LdrHnm1WH",
    title: "condor puma serpent inca trilogy",
    list_url: "/styles/realism/condor-puma-serpent-inca-trilogy"
  },
  {
    url: "/styles/realism/create-a-biomechanical-arm-sleeve-LsGFBpdbxPSE3Jb2UFmT1U",
    title: "create a biomechanical arm sleeve",
    list_url: "/styles/realism/create-a-biomechanical-arm-sleeve"
  },
  {
    url: "/styles/realism/disneys-stitch-aka-experiment-626-PxUJmyaqEqR9amCu2b1LAL",
    title: "disneys stitch aka experiment ",
    list_url: "/styles/realism/disneys-stitch-aka-experiment-626"
  },
  {
    url: "/styles/realism/full-wrecker-tow-truck-AQNYYNQr8htNSv6KZ12XHY",
    title: "full wrecker tow truck",
    list_url: "/styles/realism/full-wrecker-tow-truck"
  },
  {
    url: "/styles/realism/grim-reaper-holding-heart-REp7RkPn7x2Gbo56J1bHd2",
    title: "grim reaper holding heart",
    list_url: "/styles/realism/grim-reaper-holding-heart"
  },
  {
    url: "/styles/realism/indian-warrior-GoxyYjK1gqH1e9oFMe2tk8",
    title: "indian warrior",
    list_url: "/styles/realism/indian-warrior"
  },
  {
    url: "/styles/realism/jay-and-silent-bob-AYkAhmCPLTGp16GrLkFA45",
    title: "jay and silent bob",
    list_url: "/styles/realism/jay-and-silent-bob"
  },
  {
    url: "/styles/realism/jaya-name-written-KnG73DJmN2gRCp8ZJ2Qeke",
    title: "jaya name written",
    list_url: "/styles/realism/jaya-name-written"
  },
  {
    url: "/styles/realism/keir-starmer-7E4W7PuDFyQ6rtkmw3fpn",
    title: "keir starmer",
    list_url: "/styles/realism/keir-starmer"
  },
  {
    url: "/styles/realism/kidney-cancer-awarness-HHQUTK66GkxjCkJ15EpD4M",
    title: "kidney cancer awarness",
    list_url: "/styles/realism/kidney-cancer-awarness"
  },
  {
    url: "/styles/realism/lion-with-cub-showing-bond-of-father-NvZKeULetuUWR4f4gMaypE",
    title: "lion with cub showing bond of father",
    list_url: "/styles/realism/lion-with-cub-showing-bond-of-father"
  },
  {
    url: "/styles/realism/mallard-curl-feather-with-amber-dog-eye-QCpEBi5FC5DGWbFwoF6vj9",
    title: "mallard curl feather with amber dog eye",
    list_url: "/styles/realism/mallard-curl-feather-with-amber-dog-eye"
  },
  {
    url: "/styles/realism/nipple-replacemt-flower-6gNbAzAzJAo5znikQbAqiT",
    title: "nipple replacemt flower",
    list_url: "/styles/realism/nipple-replacemt-flower"
  },
  {
    url: "/styles/realism/phrase-karma-is-a-bitch-UP9GHmjid1uRHPMVLUYAeL",
    title: "phrase karma is a bitch",
    list_url: "/styles/realism/phrase-karma-is-a-bitch"
  },
  {
    url: "/styles/realism/roses-with-scroll-YTGRCBuJzBWzeZZino41oC",
    title: "roses with scroll",
    list_url: "/styles/realism/roses-with-scroll"
  },
  {
    url: "/styles/realism/sagittarius-zodiac-sign-for-under-ear-8qXajmym16XyL3QsxUd6Hk",
    title: "sagittarius zodiac sign for under ear",
    list_url: "/styles/realism/sagittarius-zodiac-sign-for-under-ear"
  },
  {
    url: "/styles/realism/ski-mask-gun-and-trust-no-one-hand-ToiqkHqhr56AL6D6z4QZ6S",
    title: "ski mask gun and trust no one hand",
    list_url: "/styles/realism/ski-mask-gun-and-trust-no-one-hand"
  },
  {
    url: "/styles/realism/sleeve-of-letters-r-and-a-with-a-crown-8egSHywRUfNka75vMMfBUS",
    title: "sleeve of letters r and a with a crown",
    list_url: "/styles/realism/sleeve-of-letters-r-and-a-with-a-crown"
  },
  {
    url: "/styles/realism/solum-in-mortem-finiat-officium-CtcVVUA5uBFhXB5nTHGwY9",
    title: "solum in mortem finiat officium",
    list_url: "/styles/realism/solum-in-mortem-finiat-officium"
  },
  {
    url: "/styles/realism/there-is-no-tomorrow-learn-R46QNcwpZH4yWm8dSUn5fK",
    title: "there is no tomorrow learn",
    list_url: "/styles/realism/there-is-no-tomorrow-learn"
  },
  {
    url: "/styles/sketch/accept-what-is-let-go-of-what-was-Tq7woTbGQMo9PBcuAeWEwF",
    title: "accept what is let go of what was",
    list_url: "/styles/sketch/accept-what-is-let-go-of-what-was"
  },
  {
    url: "/styles/sketch/an-edgy-tattoo-design-combining-a-bank-BuiiamDPkz2i2Bb4CcMXuo",
    title: "an edgy tattoo design combining a bank",
    list_url: "/styles/sketch/an-edgy-tattoo-design-combining-a-bank"
  },
  {
    url: "/styles/sketch/anime-thick-succubus-6kMexeSZKESMSecTK5HkNx",
    title: "anime thick succubus",
    list_url: "/styles/sketch/anime-thick-succubus"
  },
  {
    url: "/styles/sketch/burning-rose-with-burning-skull-hand-EpGGsjfhPDTWppvsxnGEeg",
    title: "burning rose with burning skull hand",
    list_url: "/styles/sketch/burning-rose-with-burning-skull-hand"
  },
  {
    url: "/styles/sketch/butterfly-with-smile-now-cry-later-faces-Uaca1ZU5jf1jh43XbekfQC",
    title: "butterfly with smile now cry later faces",
    list_url: "/styles/sketch/butterfly-with-smile-now-cry-later-faces"
  },
  {
    url: "/styles/sketch/christian-cross-with-chain-and-lion-GQpiyRa74v1kkEFWX9NZxi",
    title: "christian cross with chain and lion",
    list_url: "/styles/sketch/christian-cross-with-chain-and-lion"
  },
  {
    url: "/styles/sketch/ecg-heartbeat-with-letter-h-and-m-XhLk22vj2L9rsaW9A6Xesg",
    title: "ecg heartbeat with letter h and m",
    list_url: "/styles/sketch/ecg-heartbeat-with-letter-h-and-m"
  },
  {
    url: "/styles/sketch/mother-leopard-two-cubs-and-flowers-Rt9Ba7hK1NkBdCGVLhdENH",
    title: "mother leopard two cubs and flowers",
    list_url: "/styles/sketch/mother-leopard-two-cubs-and-flowers"
  },
  {
    url: "/styles/sketch/panther-climbing-up-a-tree-SRkUiavV85sR444aDxown6",
    title: "panther climbing up a tree",
    list_url: "/styles/sketch/panther-climbing-up-a-tree"
  },
  {
    url: "/styles/sketch/pretty-girl-bandana-over-face-EFS71NWS5yyQywJvbFpzGf",
    title: "pretty girl bandana over face",
    list_url: "/styles/sketch/pretty-girl-bandana-over-face"
  },
  {
    url: "/styles/sketch/rodrigo-and-maricel-name-in-one-cross-5YYeEFhm5nZKigHRQzCNwE",
    title: "rodrigo and maricel name in one cross",
    list_url: "/styles/sketch/rodrigo-and-maricel-name-in-one-cross"
  },
  {
    url: "/styles/sketch/sigma-PKxBUQ1diH7D9tUd3ZcGgt",
    title: "sigma",
    list_url: "/styles/sketch/sigma"
  },
  {
    url: "/styles/sketch/skull-hear-no-evil-speak-no-evil-see-no-DckGnJ4WffK3Aw5AjKaY4",
    title: "skull hear no evil speak no evil see no",
    list_url: "/styles/sketch/skull-hear-no-evil-speak-no-evil-see-no"
  },
  {
    url: "/styles/sketch/smile-now-cry-later-mask-AeS7sRyxDVVvfNxUXgZBcZ",
    title: "smile now cry later mask",
    list_url: "/styles/sketch/smile-now-cry-later-mask"
  },
  {
    url: "/styles/sketch/tom-sawyer-and-huckleberry-finn-XkZzTLHyHhMKNhsZkB8nrH",
    title: "tom sawyer and huckleberry finn",
    list_url: "/styles/sketch/tom-sawyer-and-huckleberry-finn"
  },
  {
    url: "/styles/sketch/uh60-blackhawk-helicopter-XkR34aDHkzLyVJWLuADsoR",
    title: "uh blackhawk helicopter",
    list_url: "/styles/sketch/uh60-blackhawk-helicopter"
  },
  {
    url: "/styles/sketch/woman-devil-horns-holding-an-female-Rtax8puE9hc5fNMyGb8SxH",
    title: "woman devil horns holding an female",
    list_url: "/styles/sketch/woman-devil-horns-holding-an-female"
  },
  {
    url: "/styles/stencil/rosary-Sb2wGENuVWoVyUN8qqEfVQ",
    title: "rosary",
    list_url: "/styles/stencil/rosary"
  },
  {
    url: "/styles/surrealism/bend-overslim-thick-goth-girlemo-Wi811JUg9CT22pDzjrQ8cw",
    title: "bend overslim thick goth girlemo",
    list_url: "/styles/surrealism/bend-overslim-thick-goth-girlemo"
  },
  {
    url: "/styles/surrealism/blue-phoenix-4EG22UT6LZhyrBfMdV135R",
    title: "blue phoenix",
    list_url: "/styles/surrealism/blue-phoenix"
  },
  {
    url: "/styles/surrealism/bojack-horseman-the-view-from-halfway-53pDSmvwdMnMoydhGfb9dM",
    title: "bojack horseman the view from halfway",
    list_url: "/styles/surrealism/bojack-horseman-the-view-from-halfway"
  },
  {
    url: "/styles/surrealism/drum-YYHJzEfroqu1oeyDdEkTDd",
    title: "drum",
    list_url: "/styles/surrealism/drum"
  },
  {
    url: "/styles/surrealism/lsd-acid-trip-H6PaMaUEu3Sa5Aavgf9HJc",
    title: "lsd acid trip",
    list_url: "/styles/surrealism/lsd-acid-trip"
  },
  {
    url: "/styles/traditional/831-8-letters-3-words-9one-meaning-i-Dgm1Q4wj1AzoKUfRwapsWZ",
    title: " letters words one meaning i",
    list_url: "/styles/traditional/831-8-letters-3-words-9one-meaning-i"
  },
  {
    url: "/styles/traditional/a-traditional-style-tattoo-of-a-guava-ASTs2SRep17DysXMiYvAfv",
    title: "a traditional style tattoo of a guava",
    list_url: "/styles/traditional/a-traditional-style-tattoo-of-a-guava"
  },
  {
    url: "/styles/traditional/barbed-wire-in-a-horseshoe-shape-outline-Lfw2eyPiZnUx5VpQN65kB2",
    title: "barbed wire in a horseshoe shape outline",
    list_url: "/styles/traditional/barbed-wire-in-a-horseshoe-shape-outline"
  },
  {
    url: "/styles/traditional/billie-eilish-hit-me-hard-and-soft-8c6n4cuNAT6Rc9sTqRpLNB",
    title: "billie eilish hit me hard and soft",
    list_url: "/styles/traditional/billie-eilish-hit-me-hard-and-soft"
  },
  {
    url: "/styles/traditional/flor-amapola-XA5kK7K17CzZyv1t7fd5gs",
    title: "flor amapola",
    list_url: "/styles/traditional/flor-amapola"
  },
  {
    url: "/styles/traditional/hogwarts-castle-Q5fZKhZbvfTKw4YKB2iVZ7",
    title: "hogwarts castle",
    list_url: "/styles/traditional/hogwarts-castle"
  },
  {
    url: "/styles/traditional/hot-stuff-devil-riding-a-motorcycle-M1PZD4DEU6GVZcuXqwJoLb",
    title: "hot stuff devil riding a motorcycle",
    list_url: "/styles/traditional/hot-stuff-devil-riding-a-motorcycle"
  },
  {
    url: "/styles/traditional/jamaican-flag-7i4ZdnXopSPs8ukescccJJ",
    title: "jamaican flag",
    list_url: "/styles/traditional/jamaican-flag"
  },
  {
    url: "/styles/traditional/manchester-united-devil-8spFzGdzFgyWEAT7wvmw3G",
    title: "manchester united devil",
    list_url: "/styles/traditional/manchester-united-devil"
  },
  {
    url: "/styles/traditional/men-chest-skull-wings-roses-5wQ6re4vng1GFfivod2Ert",
    title: "men chest skull wings roses",
    list_url: "/styles/traditional/men-chest-skull-wings-roses"
  },
  {
    url: "/styles/traditional/native-american-pinup-girl-VU3DKC5Bh6vooxgqy3buEc",
    title: "native american pinup girl",
    list_url: "/styles/traditional/native-american-pinup-girl"
  },
  {
    url: "/styles/traditional/ruthlessness-is-mercy-upon-ourselves-Cohfe4QbDyayNdWn3DBWs2",
    title: "ruthlessness is mercy upon ourselves",
    list_url: "/styles/traditional/ruthlessness-is-mercy-upon-ourselves"
  },
  {
    url: "/styles/traditional/soldier-of-linkin-park-meteora-album-BboipNfuopK53M79JWrf3f",
    title: "soldier of linkin park meteora album",
    list_url: "/styles/traditional/soldier-of-linkin-park-meteora-album"
  },
  {
    url: "/styles/traditional/star-with-diamond-VBjXVfqAB9DuZTFamQCoSx",
    title: "star with diamond",
    list_url: "/styles/traditional/star-with-diamond"
  },
  {
    url: "/styles/traditional/virgo-and-capricorn-SRrRUXcVVcGyCaPQGaLDks",
    title: "virgo and capricorn",
    list_url: "/styles/traditional/virgo-and-capricorn"
  },
  {
    url: "/styles/traditional/wasp-LKLZHWzjBZ5qkcHhnyzZXC",
    title: "wasp",
    list_url: "/styles/traditional/wasp"
  },
  {
    url: "/styles/traditional/whole-back-tattoo-grim-reaper-holding-4gN88P3iRDTgRsqP9WyKLM",
    title: "whole back tattoo grim reaper holding",
    list_url: "/styles/traditional/whole-back-tattoo-grim-reaper-holding"
  },
  {
    url: "/styles/tribal/el-salvador-culture-volcano-mayan-CKafy2VxCP2Fzsgx2dnZXW",
    title: "el salvador culture volcano mayan",
    list_url: "/styles/tribal/el-salvador-culture-volcano-mayan"
  },
  {
    url: "/styles/tribal/ironman-triathlon-EoBYvtYHRvy3MgSUGzM38x",
    title: "ironman triathlon",
    list_url: "/styles/tribal/ironman-triathlon"
  },
  {
    url: "/styles/tribal/knee-tattoos-6Se1atye3kQF5BMqihKqub",
    title: "knee tattoos",
    list_url: "/styles/tribal/knee-tattoos"
  },
  {
    url: "/styles/tribal/pintaderas-canarias-guanches-YTC6RE9HEebwKNQruRJCm9",
    title: "pintaderas canarias guanches",
    list_url: "/styles/tribal/pintaderas-canarias-guanches"
  },
  {
    url: "/styles/watercolor/phoenix-with-semi-colon-and-text-let-AX8b1oKVmpSLS7mMyJZ1fa",
    title: "phoenix with semi colon and text let",
    list_url: "/styles/watercolor/phoenix-with-semi-colon-and-text-let"
  },
  {
    url: "/styles/anime/black-minimalist-solo-leveling-sung-jin-TZTtxKhN2ELpRH7Xe37bYz",
    title: "black minimalist solo leveling sung jin",
    list_url: "/styles/anime/black-minimalist-solo-leveling-sung-jin"
  },
  {
    url: "/styles/anime/collarbone-Y2Wc2d46QUvds1PqjqmyQ1",
    title: "collarbone",
    list_url: "/styles/anime/collarbone"
  },
  {
    url: "/styles/anime/digimon-pokemon-yu-gi-oh-dragon-ball-C3n2ptJtZisiB5gJ3TKqMr",
    title: "digimon pokemon yu gi oh dragon ball",
    list_url: "/styles/anime/digimon-pokemon-yu-gi-oh-dragon-ball"
  },
  {
    url: "/styles/anime/fatalis-monster-hunter-PN2W68cwTRTEgxhz7B38ZK",
    title: "fatalis monster hunter",
    list_url: "/styles/anime/fatalis-monster-hunter"
  },
  {
    url: "/styles/anime/nana-manga-smoking-cigarette-FAaAPP1WMZ1hbrKC2B6fZj",
    title: "nana manga smoking cigarette",
    list_url: "/styles/anime/nana-manga-smoking-cigarette"
  },
  {
    url: "/styles/anime/palkia-41e1KbL1J4Uo6v4FcDenuY",
    title: "palkia",
    list_url: "/styles/anime/palkia"
  },
  {
    url: "/styles/anime/suraj-name-in-sanskrit-KELEKXqCoD1AqmUKgN6Pn4",
    title: "suraj name in sanskrit",
    list_url: "/styles/anime/suraj-name-in-sanskrit"
  },
  {
    url: "/styles/anime/the-ship-thousand-sunny-from-one-piece-JXoznFeGW12DD3wJXjaNuf",
    title: "the ship thousand sunny from one piece",
    list_url: "/styles/anime/the-ship-thousand-sunny-from-one-piece"
  },
  {
    url: "/styles/biomechanical/inner-bicep-P49LXKcxCKeeA9MUuTihrs",
    title: "inner bicep",
    list_url: "/styles/biomechanical/inner-bicep"
  },
  {
    url: "/styles/black-grey/1978-AWHCkBxMCCCpXL9UMcPTgZ",
    title: " ",
    list_url: "/styles/black-grey/1978"
  },
  {
    url: "/styles/black-grey/2-koi-fish-gemini-zodiac-sign-Q6WfbLUeMBkQitH33yUEdC",
    title: " koi fish gemini zodiac sign",
    list_url: "/styles/black-grey/2-koi-fish-gemini-zodiac-sign"
  },
  {
    url: "/styles/black-grey/4-letter-name-aran-4JKiEPh2NQeVimwVGHnQnj",
    title: " letter name aran",
    list_url: "/styles/black-grey/4-letter-name-aran"
  },
  {
    url: "/styles/black-grey/a-bird-breaking-free-from-chains-4MA5ED7o1GqCjDcJ8JMYxB",
    title: "a bird breaking free from chains",
    list_url: "/styles/black-grey/a-bird-breaking-free-from-chains"
  },
  {
    url: "/styles/black-grey/a-tattoo-design-of-a-four-wheeler-EHtMGHD4iwYxtdP3R2FDjb",
    title: "a tattoo design of a four wheeler",
    list_url: "/styles/black-grey/a-tattoo-design-of-a-four-wheeler"
  },
  {
    url: "/styles/black-grey/a-welsh-love-spoon-interwoven-twin-7LcrJedp5wAYGoGGRXhk4",
    title: "a welsh love spoon interwoven twin",
    list_url: "/styles/black-grey/a-welsh-love-spoon-interwoven-twin"
  },
  {
    url: "/styles/black-grey/aishu-VRZMBHHcrCtFcbo6n76tks",
    title: "aishu",
    list_url: "/styles/black-grey/aishu"
  },
  {
    url: "/styles/black-grey/ammit-the-egyptian-god-GaEXhyu3UusFirq35FYoUY",
    title: "ammit the egyptian god",
    list_url: "/styles/black-grey/ammit-the-egyptian-god"
  },
  {
    url: "/styles/black-grey/angel-ak-47-XgsvmmPeHsQy4kGRGZmt7Z",
    title: "angel ak ",
    list_url: "/styles/black-grey/angel-ak-47"
  },
  {
    url: "/styles/black-grey/angel-wings-with-stars-WB4LG7bwR4LPDNxNTEmH3z",
    title: "angel wings with stars",
    list_url: "/styles/black-grey/angel-wings-with-stars"
  },
  {
    url: "/styles/black-grey/angels-doing-dove-MB6YHC5icKydMXVAJA9Xq1",
    title: "angels doing dove",
    list_url: "/styles/black-grey/angels-doing-dove"
  },
  {
    url: "/styles/black-grey/aniyahs-name-with-thorns-intertwined-BbQyEPieKGkJir9nXEVmo1",
    title: "aniyahs name with thorns intertwined",
    list_url: "/styles/black-grey/aniyahs-name-with-thorns-intertwined"
  },
  {
    url: "/styles/black-grey/anonymous-mask-inspired-3tkN8JshLoTbwZzmzyhcQr",
    title: "anonymous mask inspired",
    list_url: "/styles/black-grey/anonymous-mask-inspired"
  },
  {
    url: "/styles/black-grey/balinese-barong-6S8yWS42r3TwhwhivGdNVi",
    title: "balinese barong",
    list_url: "/styles/black-grey/balinese-barong"
  },
  {
    url: "/styles/black-grey/baseball-seams-Vm4sCbXmG2F7UmrEcmmZeG",
    title: "baseball seams",
    list_url: "/styles/black-grey/baseball-seams"
  },
  {
    url: "/styles/black-grey/bees-honey-bee-hive-2WhuWgCKpdCVjxBbe8ZyE8",
    title: "bees honey bee hive",
    list_url: "/styles/black-grey/bees-honey-bee-hive"
  },
  {
    url: "/styles/black-grey/black-and-white-tree-frog-G7gchV2QKzJMVxruRtx3DX",
    title: "black and white tree frog",
    list_url: "/styles/black-grey/black-and-white-tree-frog"
  },
  {
    url: "/styles/black-grey/black-and-white-watercolor-style-lilac-9dncwuKZNcSxun1d9E6nwd",
    title: "black and white watercolor style lilac",
    list_url: "/styles/black-grey/black-and-white-watercolor-style-lilac"
  },
  {
    url: "/styles/black-grey/breat-cancel-ribbon-with-the-name-tanya-5uXrNh6QbaHwoRcD9ZCgAj",
    title: "breat cancel ribbon with the name tanya",
    list_url: "/styles/black-grey/breat-cancel-ribbon-with-the-name-tanya"
  },
  {
    url: "/styles/black-grey/bull-skull-with-lily-of-the-valley-UtmrxYqns1tGoW5ndKQ5Hy",
    title: "bull skull with lily of the valley",
    list_url: "/styles/black-grey/bull-skull-with-lily-of-the-valley"
  },
  {
    url: "/styles/black-grey/bullets-smoking-gun-2ixx88jFRhMZ8dZ531M7Fc",
    title: "bullets smoking gun",
    list_url: "/styles/black-grey/bullets-smoking-gun"
  },
  {
    url: "/styles/black-grey/butterfly-on-a-leaf-J96QCYVoauhfQWCytPJGtF",
    title: "butterfly on a leaf",
    list_url: "/styles/black-grey/butterfly-on-a-leaf"
  },
  {
    url: "/styles/black-grey/california-state-flag-bear-6a4Rj2aJiaUPDkihFBeJFk",
    title: "california state flag bear",
    list_url: "/styles/black-grey/california-state-flag-bear"
  },
  {
    url: "/styles/black-grey/calligraphy-stephanie-name-tattoo-DiVzQxA7HhRUNqwrPdxGpQ",
    title: "calligraphy stephanie name tattoo",
    list_url: "/styles/black-grey/calligraphy-stephanie-name-tattoo"
  },
  {
    url: "/styles/black-grey/capital-letter-p-with-a-crown-4QxFfrDoYNWWLth3rGf5t3",
    title: "capital letter p with a crown",
    list_url: "/styles/black-grey/capital-letter-p-with-a-crown"
  },
  {
    url: "/styles/black-grey/carlos-name-H15sX2Dib29nepdSf2UUUS",
    title: "carlos name",
    list_url: "/styles/black-grey/carlos-name"
  },
  {
    url: "/styles/black-grey/cattleya-orchid-3HPS9rkfMdipMUYjXwy4xY",
    title: "cattleya orchid",
    list_url: "/styles/black-grey/cattleya-orchid"
  },
  {
    url: "/styles/black-grey/cccp-B4BK9YebFU8HXKJqMbqEq1",
    title: "cccp",
    list_url: "/styles/black-grey/cccp"
  },
  {
    url: "/styles/black-grey/cherubs-T8p5kLEheGLMc2xTVMevYb",
    title: "cherubs",
    list_url: "/styles/black-grey/cherubs"
  },
  {
    url: "/styles/black-grey/chinese-zodiac-ox-UVY6Afnyi8WdSXE1He7azJ",
    title: "chinese zodiac ox",
    list_url: "/styles/black-grey/chinese-zodiac-ox"
  },
  {
    url: "/styles/black-grey/chinese-zodiac-rabbit-8dnKu6EUR6MD7zvsuHkguM",
    title: "chinese zodiac rabbit",
    list_url: "/styles/black-grey/chinese-zodiac-rabbit"
  },
  {
    url: "/styles/black-grey/chinese-zodiac-wood-pig-with-earth-TkADyb7h3PfjxgbYZXfJzd",
    title: "chinese zodiac wood pig with earth",
    list_url: "/styles/black-grey/chinese-zodiac-wood-pig-with-earth"
  },
  {
    url: "/styles/black-grey/darkgreen-skibidi-toilet-WgjcMfFPu26jCh6EKss2SJ",
    title: "darkgreen skibidi toilet",
    list_url: "/styles/black-grey/darkgreen-skibidi-toilet"
  },
  {
    url: "/styles/black-grey/dbz-goku-vegeta-gohan-broly-dragon-ball-GGHzUkosLYYFUmsfbEdCDo",
    title: "dbz goku vegeta gohan broly dragon ball",
    list_url: "/styles/black-grey/dbz-goku-vegeta-gohan-broly-dragon-ball"
  },
  {
    url: "/styles/black-grey/devil-baby-XpEdMPCbmBFz8CVarqn5D7",
    title: "devil baby",
    list_url: "/styles/black-grey/devil-baby"
  },
  {
    url: "/styles/black-grey/devil-killing-angel-HrLTPvpbCCpc6ofb9tEyQM",
    title: "devil killing angel",
    list_url: "/styles/black-grey/devil-killing-angel"
  },
  {
    url: "/styles/black-grey/dolphin-with-a-rose-R1YgfpckesnKMNntCDoLx7",
    title: "dolphin with a rose",
    list_url: "/styles/black-grey/dolphin-with-a-rose"
  },
  {
    url: "/styles/black-grey/dove-carrying-cancer-ribbon-in-its-beak-AnMb5onDPESr4bzSeXSqYV",
    title: "dove carrying cancer ribbon in its beak",
    list_url: "/styles/black-grey/dove-carrying-cancer-ribbon-in-its-beak"
  },
  {
    url: "/styles/black-grey/dove-carrying-rosary-beads-A2TSgXLX9kynHwAxXeYJXC",
    title: "dove carrying rosary beads",
    list_url: "/styles/black-grey/dove-carrying-rosary-beads"
  },
  {
    url: "/styles/black-grey/elephant-tattoo-woman-theme-on-thigh-HudwqzZGyjRtuCpUgYV2nn",
    title: "elephant tattoo woman theme on thigh",
    list_url: "/styles/black-grey/elephant-tattoo-woman-theme-on-thigh"
  },
  {
    url: "/styles/black-grey/evil-woman-face-multiple-eyes-rolled-XFu8ECF421L5TdjeXHp8E6",
    title: "evil woman face multiple eyes rolled",
    list_url: "/styles/black-grey/evil-woman-face-multiple-eyes-rolled"
  },
  {
    url: "/styles/black-grey/family-husband-with-wife-and-daughter-QpwcSWNsbkkSjtqwaLn7cZ",
    title: "family husband with wife and daughter",
    list_url: "/styles/black-grey/family-husband-with-wife-and-daughter"
  },
  {
    url: "/styles/black-grey/fenrir-with-chains-Ucoi2XNCa91aVp9t6CQzJw",
    title: "fenrir with chains",
    list_url: "/styles/black-grey/fenrir-with-chains"
  },
  {
    url: "/styles/black-grey/fingers-crossed-gift-of-discernment-DxN15ykS29jECReYE3Y4Xz",
    title: "fingers crossed gift of discernment",
    list_url: "/styles/black-grey/fingers-crossed-gift-of-discernment"
  },
  {
    url: "/styles/black-grey/flowers-books-butterfly-BKbG2gLceBxiYbzuNeivue",
    title: "flowers books butterfly",
    list_url: "/styles/black-grey/flowers-books-butterfly"
  },
  {
    url: "/styles/black-grey/flowers-filler-background-of-flower-PXsSMJHc2pkv8FiU7TrHdf",
    title: "flowers filler background of flower",
    list_url: "/styles/black-grey/flowers-filler-background-of-flower"
  },
  {
    url: "/styles/black-grey/freddy-krueger-FbngcTpV4daFqUEGyuEZKU",
    title: "freddy krueger",
    list_url: "/styles/black-grey/freddy-krueger"
  },
  {
    url: "/styles/black-grey/garter-belt-with-pistol-attached-to-it-C17FVM3eeTfLGYCrV4oHw3",
    title: "garter belt with pistol attached to it",
    list_url: "/styles/black-grey/garter-belt-with-pistol-attached-to-it"
  },
  {
    url: "/styles/black-grey/genie-from-the-lamp-84UREvNGA7HWDMojqJ6i4s",
    title: "genie from the lamp",
    list_url: "/styles/black-grey/genie-from-the-lamp"
  },
  {
    url: "/styles/black-grey/gods-hand-coming-down-from-heaven-VM3L8G7UNB3NT4Fo1wQobc",
    title: "gods hand coming down from heaven",
    list_url: "/styles/black-grey/gods-hand-coming-down-from-heaven"
  },
  {
    url: "/styles/black-grey/gothic-girl-holding-black-widow-spider-TixqWbcxGYF27Sm9Nct6Jt",
    title: "gothic girl holding black widow spider",
    list_url: "/styles/black-grey/gothic-girl-holding-black-widow-spider"
  },
  {
    url: "/styles/black-grey/grim-reaper-with-a-draco-gun-PxbxxzEHDXTVuPnU6DGtkN",
    title: "grim reaper with a draco gun",
    list_url: "/styles/black-grey/grim-reaper-with-a-draco-gun"
  },
  {
    url: "/styles/black-grey/gundam-wing-zero-tallgeese-fleugal-W7jJHnieUFzxpm2Lh1nnz5",
    title: "gundam wing zero tallgeese fleugal",
    list_url: "/styles/black-grey/gundam-wing-zero-tallgeese-fleugal"
  },
  {
    url: "/styles/black-grey/half-dead-half-alive-sunflower-with-QXdFjdgQUAyTE9FMMdYmhD",
    title: "half dead half alive sunflower with",
    list_url: "/styles/black-grey/half-dead-half-alive-sunflower-with"
  },
  {
    url: "/styles/black-grey/heart-locketkeypearlscrying-MMbBLZTe6on3H8ZPj9eGzb",
    title: "heart locketkeypearlscrying",
    list_url: "/styles/black-grey/heart-locketkeypearlscrying"
  },
  {
    url: "/styles/black-grey/heart-with-tree-roots-VovKcpDG65GyoKo7Z8WCQM",
    title: "heart with tree roots",
    list_url: "/styles/black-grey/heart-with-tree-roots"
  },
  {
    url: "/styles/black-grey/hindu-god-ohm-symbol-with-bhadrakali-JqGYuAYzjvHiKT8jSKshUs",
    title: "hindu god ohm symbol with bhadrakali",
    list_url: "/styles/black-grey/hindu-god-ohm-symbol-with-bhadrakali"
  },
  {
    url: "/styles/black-grey/horror-movie-sleeve-RFqTm4Aqm7DYTxoN5iJZVT",
    title: "horror movie sleeve",
    list_url: "/styles/black-grey/horror-movie-sleeve"
  },
  {
    url: "/styles/black-grey/human-heart-with-tree-of-life-MLa6ohTUnoMAuvWrRRwva7",
    title: "human heart with tree of life",
    list_url: "/styles/black-grey/human-heart-with-tree-of-life"
  },
  {
    url: "/styles/black-grey/im-the-worst-by-treaty-oak-revival-W6xTS3BMWrLZBYrCMdqxN2",
    title: "im the worst by treaty oak revival",
    list_url: "/styles/black-grey/im-the-worst-by-treaty-oak-revival"
  },
  {
    url: "/styles/black-grey/inner-bicep-6e1ersSmehUcUehCthFqNu",
    title: "inner bicep",
    list_url: "/styles/black-grey/inner-bicep"
  },
  {
    url: "/styles/black-grey/iris-flower-YQQAj1DanrDTEBAWRVR5W3",
    title: "iris flower",
    list_url: "/styles/black-grey/iris-flower"
  },
  {
    url: "/styles/black-grey/ivy-leaves-baby-hand-rose-name-ivy-22C8mAzYuYH7iQjFiPhmux",
    title: "ivy leaves baby hand rose name ivy",
    list_url: "/styles/black-grey/ivy-leaves-baby-hand-rose-name-ivy"
  },
  {
    url: "/styles/black-grey/izanami-the-godess-of-death-RYk8G2h8nr1cELBiA5Fgdj",
    title: "izanami the godess of death",
    list_url: "/styles/black-grey/izanami-the-godess-of-death"
  },
  {
    url: "/styles/black-grey/jade-flower-bouquet-FbnVp8iELgVhrEkPmbRp2M",
    title: "jade flower bouquet",
    list_url: "/styles/black-grey/jade-flower-bouquet"
  },
  {
    url: "/styles/black-grey/japanese-negative-space-forearm-sleeve-4yWHv5mwnfQArNB8x7FovH",
    title: "japanese negative space forearm sleeve",
    list_url: "/styles/black-grey/japanese-negative-space-forearm-sleeve"
  },
  {
    url: "/styles/black-grey/jeepers-creepers-CnkyA2dwJkNa8YrQccgqbY",
    title: "jeepers creepers",
    list_url: "/styles/black-grey/jeepers-creepers"
  },
  {
    url: "/styles/black-grey/jesus-preaching-the-sermon-on-the-mount-8YhvFFF1T1a7nvEb7bRs15",
    title: "jesus preaching the sermon on the mount",
    list_url: "/styles/black-grey/jesus-preaching-the-sermon-on-the-mount"
  },
  {
    url: "/styles/black-grey/kaws-see-no-evil-speak-no-evil-hear-no-NwXR74fCgNiomcqYxjAttm",
    title: "kaws see no evil speak no evil hear no",
    list_url: "/styles/black-grey/kaws-see-no-evil-speak-no-evil-hear-no"
  },
  {
    url: "/styles/black-grey/laugh-now-cry-later-joker-version-PrefEVxqd7Qy2g7tHBywZi",
    title: "laugh now cry later joker version",
    list_url: "/styles/black-grey/laugh-now-cry-later-joker-version"
  },
  {
    url: "/styles/black-grey/leeds-united-peacock-FGDSghzQteFaReEqR7VMB1",
    title: "leeds united peacock",
    list_url: "/styles/black-grey/leeds-united-peacock"
  },
  {
    url: "/styles/black-grey/luke-1019-bible-verse-V2FYzRJVAA51kotW27Uo2d",
    title: "luke bible verse",
    list_url: "/styles/black-grey/luke-1019-bible-verse"
  },
  {
    url: "/styles/black-grey/mandalorian-mythosaur-skull-UTtoetjSYFUvFeWbGdfVUi",
    title: "mandalorian mythosaur skull",
    list_url: "/styles/black-grey/mandalorian-mythosaur-skull"
  },
  {
    url: "/styles/black-grey/mantis-shrimp-4897yTb5M7kAjXavJ67LuU",
    title: "mantis shrimp",
    list_url: "/styles/black-grey/mantis-shrimp"
  },
  {
    url: "/styles/black-grey/matthew-19-GsPR6RuPYAng3VbdSxnQE1",
    title: "matthew ",
    list_url: "/styles/black-grey/matthew-19"
  },
  {
    url: "/styles/black-grey/medieval-gothic-sword-57193ACHNtpPsdHKxvbFee",
    title: "medieval gothic sword",
    list_url: "/styles/black-grey/medieval-gothic-sword"
  },
  {
    url: "/styles/black-grey/medusa-tattoo-without-snakes-and-with-J8Z1y4bBLCn5M5qyhSJTWK",
    title: "medusa tattoo without snakes and with",
    list_url: "/styles/black-grey/medusa-tattoo-without-snakes-and-with"
  },
  {
    url: "/styles/black-grey/mickey-mouse-smoking-Pru6ACSQXZD8XJ9aWQt1sq",
    title: "mickey mouse smoking",
    list_url: "/styles/black-grey/mickey-mouse-smoking"
  },
  {
    url: "/styles/black-grey/mom-bull-with-a-baby-bull-a-scorpion-ArEcXg4NZ75gLiRsp5xqcs",
    title: "mom bull with a baby bull a scorpion",
    list_url: "/styles/black-grey/mom-bull-with-a-baby-bull-a-scorpion"
  },
  {
    url: "/styles/black-grey/morel-mushroom-3q7Y9ZDqQSJs9PSRrP8J25",
    title: "morel mushroom",
    list_url: "/styles/black-grey/morel-mushroom"
  },
  {
    url: "/styles/black-grey/mountain-bike-ride-Ve5u23sUkYERkfhrC4v94e",
    title: "mountain bike ride",
    list_url: "/styles/black-grey/mountain-bike-ride"
  },
  {
    url: "/styles/black-grey/mowgli-and-bagheera-jungle-book-PGh88g6jK8R6X6ZgKG2zvP",
    title: "mowgli and bagheera jungle book",
    list_url: "/styles/black-grey/mowgli-and-bagheera-jungle-book"
  },
  {
    url: "/styles/black-grey/music-themed-on-outer-forearm-half-WxKT6BKrQsWbGzhZHisbSd",
    title: "music themed on outer forearm half",
    list_url: "/styles/black-grey/music-themed-on-outer-forearm-half"
  },
  {
    url: "/styles/black-grey/my-mothers-keeper-AbvuptJgGZBJWiQ4guvdLW",
    title: "my mothers keeper",
    list_url: "/styles/black-grey/my-mothers-keeper"
  },
  {
    url: "/styles/black-grey/native-american-neck-MCc5mFGRPkADy8v1mFwi6M",
    title: "native american neck",
    list_url: "/styles/black-grey/native-american-neck"
  },
  {
    url: "/styles/black-grey/ned-kelly-UHrSsDyEGs42HMpa7UvaWE",
    title: "ned kelly",
    list_url: "/styles/black-grey/ned-kelly"
  },
  {
    url: "/styles/black-grey/neo-traditional-eagle-with-a-sun-behind-FzbMYNeFrBACLWZoYVQxqq",
    title: "neo traditional eagle with a sun behind",
    list_url: "/styles/black-grey/neo-traditional-eagle-with-a-sun-behind"
  },
  {
    url: "/styles/black-grey/neon-genesis-evangelion-seele-A3tSPCv2nATpE9ywZ9GuPy",
    title: "neon genesis evangelion seele",
    list_url: "/styles/black-grey/neon-genesis-evangelion-seele"
  },
  {
    url: "/styles/black-grey/new-zealand-pikorua-4VQt8x6RkiEXdFymUrobdH",
    title: "new zealand pikorua",
    list_url: "/styles/black-grey/new-zealand-pikorua"
  },
  {
    url: "/styles/black-grey/no-risk-no-reward-A3PCkKxZJ8VcATzUoFVGXc",
    title: "no risk no reward",
    list_url: "/styles/black-grey/no-risk-no-reward"
  },
  {
    url: "/styles/black-grey/ocean-waves-with-2-sea-creatures-in-arm-BHafaQdCQP4fiJtMGX1Mvc",
    title: "ocean waves with sea creatures in arm",
    list_url: "/styles/black-grey/ocean-waves-with-2-sea-creatures-in-arm"
  },
  {
    url: "/styles/black-grey/old-pirate-ship-ghost-ship-8CRAdE7veG3hgEZLX5Tgx1",
    title: "old pirate ship ghost ship",
    list_url: "/styles/black-grey/old-pirate-ship-ghost-ship"
  },
  {
    url: "/styles/black-grey/our-father-in-heaven-2fJ72pPuv7sz7TdPwB3wAa",
    title: "our father in heaven",
    list_url: "/styles/black-grey/our-father-in-heaven"
  },
  {
    url: "/styles/black-grey/padayon-japanese-writing-surrounded-by-SY7eBLDGdgbGrTx7zou9DE",
    title: "padayon japanese writing surrounded by",
    list_url: "/styles/black-grey/padayon-japanese-writing-surrounded-by"
  },
  {
    url: "/styles/black-grey/phillies-logo-with-liberty-bell-8cVpVPMjmRDLF4RuEeYPZQ",
    title: "phillies logo with liberty bell",
    list_url: "/styles/black-grey/phillies-logo-with-liberty-bell"
  },
  {
    url: "/styles/black-grey/pirates-of-the-caribbean-up-is-down-TjFjN36FxEf7vmg6MRV1Tk",
    title: "pirates of the caribbean up is down",
    list_url: "/styles/black-grey/pirates-of-the-caribbean-up-is-down"
  },
  {
    url: "/styles/black-grey/poison-tree-no-color-with-a-dove-flying-XA5to3kKnubXPbsV1cBvXo",
    title: "poison tree no color with a dove flying",
    list_url: "/styles/black-grey/poison-tree-no-color-with-a-dove-flying"
  },
  {
    url: "/styles/black-grey/poison-tree-with-doves-AdunjGZk5H3bEBaE8kRKen",
    title: "poison tree with doves",
    list_url: "/styles/black-grey/poison-tree-with-doves"
  },
  {
    url: "/styles/black-grey/poison-tree-with-roots-and-doves-in-the-B1r87mKDoKVorSccZ89jpj",
    title: "poison tree with roots and doves in the",
    list_url: "/styles/black-grey/poison-tree-with-roots-and-doves-in-the"
  },
  {
    url: "/styles/black-grey/pompeii-volcano-explosion-EDMZeNTT2fQHxXmvZM7Ukj",
    title: "pompeii volcano explosion",
    list_url: "/styles/black-grey/pompeii-volcano-explosion"
  },
  {
    url: "/styles/black-grey/pubic-XvaRLzftt86QyD4hRUTEKY",
    title: "pubic",
    list_url: "/styles/black-grey/pubic"
  },
  {
    url: "/styles/black-grey/punjab-map-Uf4ACeTi1kbUJ46miaiNg3",
    title: "punjab map",
    list_url: "/styles/black-grey/punjab-map"
  },
  {
    url: "/styles/black-grey/realistic-anatomical-heart-with-snake-5oaTTdjoqWsz4jiXi5BHAU",
    title: "realistic anatomical heart with snake",
    list_url: "/styles/black-grey/realistic-anatomical-heart-with-snake"
  },
  {
    url: "/styles/black-grey/reyansh-5TQfSzGYJxh9f38HSymXzd",
    title: "reyansh",
    list_url: "/styles/black-grey/reyansh"
  },
  {
    url: "/styles/black-grey/ripped-cracked-skin-brick-wall-inside-Whq4a8jVTaCGSyiic3ZRbr",
    title: "ripped cracked skin brick wall inside",
    list_url: "/styles/black-grey/ripped-cracked-skin-brick-wall-inside"
  },
  {
    url: "/styles/black-grey/riverside-bell-3w8L2i782fX3Et9VAH3buU",
    title: "riverside bell",
    list_url: "/styles/black-grey/riverside-bell"
  },
  {
    url: "/styles/black-grey/roman-numeral-7-H4HqbHUvww4PcdBqKunpEJ",
    title: "roman numeral ",
    list_url: "/styles/black-grey/roman-numeral-7"
  },
  {
    url: "/styles/black-grey/rosary-with-cursive-names-of-family-EqQ33iMKSYkwsVUzYybupk",
    title: "rosary with cursive names of family",
    list_url: "/styles/black-grey/rosary-with-cursive-names-of-family"
  },
  {
    url: "/styles/black-grey/saint-michael-neck-tattoo-REzoNBFcpUBfkkihiMT9B2",
    title: "saint michael neck tattoo",
    list_url: "/styles/black-grey/saint-michael-neck-tattoo"
  },
  {
    url: "/styles/black-grey/self-harm-scar-cover-up-XuVR2KU9edx6Qj4Y8wbKAN",
    title: "self harm scar cover up",
    list_url: "/styles/black-grey/self-harm-scar-cover-up"
  },
  {
    url: "/styles/black-grey/shubham-name-with-strength-theme-GKvZywG9tE7GQxgSM3ZMPw",
    title: "shubham name with strength theme",
    list_url: "/styles/black-grey/shubham-name-with-strength-theme"
  },
  {
    url: "/styles/black-grey/small-cross-with-words-jeremiah-2911-73MbANE9rbCvssNd1NXGBN",
    title: "small cross with words jeremiah ",
    list_url: "/styles/black-grey/small-cross-with-words-jeremiah-2911"
  },
  {
    url: "/styles/black-grey/small-goddess-isis-tattoo-micro-realism-BQ13qQRXsBks6z7y4v6MqN",
    title: "small goddess isis tattoo micro realism",
    list_url: "/styles/black-grey/small-goddess-isis-tattoo-micro-realism"
  },
  {
    url: "/styles/black-grey/smile-now-cry-later-4iXAFoLo4hih5EJSp4s9CM",
    title: "smile now cry later",
    list_url: "/styles/black-grey/smile-now-cry-later"
  },
  {
    url: "/styles/black-grey/snake-9oZM2k38hUKKzcAhv8LWpK",
    title: "snake",
    list_url: "/styles/black-grey/snake"
  },
  {
    url: "/styles/black-grey/snake-wrapped-around-broken-bird-cage-WV7uqB1jqiGys5kgzyT4Ag",
    title: "snake wrapped around broken bird cage",
    list_url: "/styles/black-grey/snake-wrapped-around-broken-bird-cage"
  },
  {
    url: "/styles/black-grey/sonia-name-tattoo-TdsT6vUiesKB4cjiAiAEYa",
    title: "sonia name tattoo",
    list_url: "/styles/black-grey/sonia-name-tattoo"
  },
  {
    url: "/styles/black-grey/sonia-name-tattoo-flowers-CXyqPwUwCWC7EHrDXUc72L",
    title: "sonia name tattoo flowers",
    list_url: "/styles/black-grey/sonia-name-tattoo-flowers"
  },
  {
    url: "/styles/black-grey/south-carolina-flag-crescent-moon-with-RHVdXBG5mZKgHsbQSJGogy",
    title: "south carolina flag crescent moon with",
    list_url: "/styles/black-grey/south-carolina-flag-crescent-moon-with"
  },
  {
    url: "/styles/black-grey/spirit-of-ecstasy-U5w14oEsQfcnPHJydim3Zm",
    title: "spirit of ecstasy",
    list_url: "/styles/black-grey/spirit-of-ecstasy"
  },
  {
    url: "/styles/black-grey/stomach-tattoo-CVwpgRqdaBvgpkU6hTJFkD",
    title: "stomach tattoo",
    list_url: "/styles/black-grey/stomach-tattoo"
  },
  {
    url: "/styles/black-grey/submissive-bdsm-symbol-combined-with-PN1onWgQgXwWcfskUgjWbQ",
    title: "submissive bdsm symbol combined with",
    list_url: "/styles/black-grey/submissive-bdsm-symbol-combined-with"
  },
  {
    url: "/styles/black-grey/sully-monsters-inc-aggression-mike-p8L9rDLVs6sVAnZ7dsoaZ",
    title: "sully monsters inc aggression mike",
    list_url: "/styles/black-grey/sully-monsters-inc-aggression-mike"
  },
  {
    url: "/styles/black-grey/tatto-of-the-name-mya-UNQSD2jW94UAc8syLv2jxX",
    title: "tatto of the name mya",
    list_url: "/styles/black-grey/tatto-of-the-name-mya"
  },
  {
    url: "/styles/black-grey/tattoo-design-charlotte-name-written-XTvQxX2HRjhZsFBGdB8otU",
    title: "tattoo design charlotte name written",
    list_url: "/styles/black-grey/tattoo-design-charlotte-name-written"
  },
  {
    url: "/styles/black-grey/tawny-frogmouth-with-native-australian-3Qdi4VRHrRrdYMdcuEBLfW",
    title: "tawny frogmouth with native australian",
    list_url: "/styles/black-grey/tawny-frogmouth-with-native-australian"
  },
  {
    url: "/styles/black-grey/teddy-bear-DwcrrnSet3gdkMmNHQAsjs",
    title: "teddy bear",
    list_url: "/styles/black-grey/teddy-bear"
  },
  {
    url: "/styles/black-grey/the-4-symbols-of-stoicism-zeno-of-citium-6R6YCKg3TyAwQrdGv7RbmB",
    title: "the symbols of stoicism zeno of citium",
    list_url: "/styles/black-grey/the-4-symbols-of-stoicism-zeno-of-citium"
  },
  {
    url: "/styles/black-grey/the-name-ace-4Lu7yo3aQrPZbjb5RaG22e",
    title: "the name ace",
    list_url: "/styles/black-grey/the-name-ace"
  },
  {
    url: "/styles/black-grey/the-name-durai-with-a-peacock-feather-2GVX6LEzJ2XPFVPo9c32zG",
    title: "the name durai with a peacock feather",
    list_url: "/styles/black-grey/the-name-durai-with-a-peacock-feather"
  },
  {
    url: "/styles/black-grey/the-penitent-one-from-blasphemous-CMP2dPaPZhfZXGgdPnADgg",
    title: "the penitent one from blasphemous",
    list_url: "/styles/black-grey/the-penitent-one-from-blasphemous"
  },
  {
    url: "/styles/black-grey/time-cast-a-spell-on-you-but-you-wont-FuLYLTgUUEbkz7ARTG2UL4",
    title: "time cast a spell on you but you wont",
    list_url: "/styles/black-grey/time-cast-a-spell-on-you-but-you-wont"
  },
  {
    url: "/styles/black-grey/time-death-skull-clock-YVTt4x2TCHvRx5HpihrkMM",
    title: "time death skull clock",
    list_url: "/styles/black-grey/time-death-skull-clock"
  },
  {
    url: "/styles/black-grey/trinidad-and-tobago-flag-EVoZGRdK4KSo5JUYjokp6H",
    title: "trinidad and tobago flag",
    list_url: "/styles/black-grey/trinidad-and-tobago-flag"
  },
  {
    url: "/styles/black-grey/uzi-UitztrwxAvzXYxVdQwsste",
    title: "uzi",
    list_url: "/styles/black-grey/uzi"
  },
  {
    url: "/styles/black-grey/virgin-mary-with-roses-QNU7nxhvEpkDkC6qLQ2Jsa",
    title: "virgin mary with roses",
    list_url: "/styles/black-grey/virgin-mary-with-roses"
  },
  {
    url: "/styles/black-grey/wagon-wheel-with-the-names-maggie-FC5HzCRdrwCzRzxVoXm2wH",
    title: "wagon wheel with the names maggie",
    list_url: "/styles/black-grey/wagon-wheel-with-the-names-maggie"
  },
  {
    url: "/styles/black-grey/wings-with-words-gone-but-not-AuHuzDST1Jk4GVuf8dRCQ2",
    title: "wings with words gone but not",
    list_url: "/styles/black-grey/wings-with-words-gone-but-not"
  },
  {
    url: "/styles/black-grey/word-stay-dangerous-BTbejPVNy4zqGgUzH8umPa",
    title: "word stay dangerous",
    list_url: "/styles/black-grey/word-stay-dangerous"
  },
  {
    url: "/styles/blackwork/3-christian-cross-for-stomach-DHZ6W9csMsm3MSsbDMxiiT",
    title: " christian cross for stomach",
    list_url: "/styles/blackwork/3-christian-cross-for-stomach"
  },
  {
    url: "/styles/blackwork/a-bible-verse-in-spanish-JC5RytWoEHHx5NNXwB5LGM",
    title: "a bible verse in spanish",
    list_url: "/styles/blackwork/a-bible-verse-in-spanish"
  },
  {
    url: "/styles/blackwork/a-gangster-rabbit-holding-a-tommy-gun-7nP1XApdkmnkR19PG5ioUi",
    title: "a gangster rabbit holding a tommy gun",
    list_url: "/styles/blackwork/a-gangster-rabbit-holding-a-tommy-gun"
  },
  {
    url: "/styles/blackwork/a-s-r-lettering-HK8f9FxuYCUMgpXaH39EAP",
    title: "a s r lettering",
    list_url: "/styles/blackwork/a-s-r-lettering"
  },
  {
    url: "/styles/blackwork/a-silhouette-of-a-family-walking-on-the-NvwhBzieM55S1b4U7fpa58",
    title: "a silhouette of a family walking on the",
    list_url: "/styles/blackwork/a-silhouette-of-a-family-walking-on-the"
  },
  {
    url: "/styles/blackwork/a-stylized-dewalt-power-tool-surrounded-29SHLZvT2zzBqRrKWqRsry",
    title: "a stylized dewalt power tool surrounded",
    list_url: "/styles/blackwork/a-stylized-dewalt-power-tool-surrounded"
  },
  {
    url: "/styles/blackwork/air-force-and-persian-gulf-BYhAT6t3BrCiEPxem1ix8r",
    title: "air force and persian gulf",
    list_url: "/styles/blackwork/air-force-and-persian-gulf"
  },
  {
    url: "/styles/blackwork/alexander-the-great-WDqQc6TVQyNKUGnRfF9chE",
    title: "alexander the great",
    list_url: "/styles/blackwork/alexander-the-great"
  },
  {
    url: "/styles/blackwork/alter-ego-KiRG9CaqPydJ8H2rYrZeVN",
    title: "alter ego",
    list_url: "/styles/blackwork/alter-ego"
  },
  {
    url: "/styles/blackwork/angel-stepping-on-the-devils-head-in-SEWLYT2qjP5fGNaeNtaMAt",
    title: "angel stepping on the devils head in",
    list_url: "/styles/blackwork/angel-stepping-on-the-devils-head-in"
  },
  {
    url: "/styles/blackwork/angel-wings-with-sword-back-tattoo-9gQSNF48SS4eXmnwM2tKdF",
    title: "angel wings with sword back tattoo",
    list_url: "/styles/blackwork/angel-wings-with-sword-back-tattoo"
  },
  {
    url: "/styles/blackwork/aut-inveniam-viam-aut-faciam-written-on-ESvR6UQMqoPK62e3PeyVGw",
    title: "aut inveniam viam aut faciam written on",
    list_url: "/styles/blackwork/aut-inveniam-viam-aut-faciam-written-on"
  },
  {
    url: "/styles/blackwork/avicii-logo-SdMJ9MmmL1FHVCH36iufN",
    title: "avicii logo",
    list_url: "/styles/blackwork/avicii-logo"
  },
  {
    url: "/styles/blackwork/bart-simpson-smoking-a-blunt-Kd5tBbLZBxEEYDqxjWarwX",
    title: "bart simpson smoking a blunt",
    list_url: "/styles/blackwork/bart-simpson-smoking-a-blunt"
  },
  {
    url: "/styles/blackwork/ben-10-omnitrix-logo-redesign-4fLFCHr5pHZ6T93R83N6SK",
    title: "ben omnitrix logo redesign",
    list_url: "/styles/blackwork/ben-10-omnitrix-logo-redesign"
  },
  {
    url: "/styles/blackwork/birds-on-a-ribbon-Kyy7jfDoWhXgh9pGfH3Qo7",
    title: "birds on a ribbon",
    list_url: "/styles/blackwork/birds-on-a-ribbon"
  },
  {
    url: "/styles/blackwork/broken-ribs-with-heart-8cqt1Tbw4E3WJh6Xt5trKK",
    title: "broken ribs with heart",
    list_url: "/styles/blackwork/broken-ribs-with-heart"
  },
  {
    url: "/styles/blackwork/chaos-symbol-with-an-eye-in-the-middle-K2WSh4tm1fn29HhgB7Mxbk",
    title: "chaos symbol with an eye in the middle",
    list_url: "/styles/blackwork/chaos-symbol-with-an-eye-in-the-middle"
  },
  {
    url: "/styles/blackwork/chastity-cage-6XRKFXcJshRvgHvEgyxRCo",
    title: "chastity cage",
    list_url: "/styles/blackwork/chastity-cage"
  },
  {
    url: "/styles/blackwork/chernabog-BRXb2DYQpajGYdDvjnrtVx",
    title: "chernabog",
    list_url: "/styles/blackwork/chernabog"
  },
  {
    url: "/styles/blackwork/chinese-dragon-patchwork-half-sleeve-8FUHmzYV9EnAywofV911Lg",
    title: "chinese dragon patchwork half sleeve",
    list_url: "/styles/blackwork/chinese-dragon-patchwork-half-sleeve"
  },
  {
    url: "/styles/blackwork/christian-cross-half-sleeve-UUR3uoRDvZByyFgtgMNcmt",
    title: "christian cross half sleeve",
    list_url: "/styles/blackwork/christian-cross-half-sleeve"
  },
  {
    url: "/styles/blackwork/crown-with-cursive-letter-r-GmcQkEBMMAacC6RZP9FG8K",
    title: "crown with cursive letter r",
    list_url: "/styles/blackwork/crown-with-cursive-letter-r"
  },
  {
    url: "/styles/blackwork/dark-sign-from-dark-souls-YYUGqiQLJR8dJZV3ZdQbzS",
    title: "dark sign from dark souls",
    list_url: "/styles/blackwork/dark-sign-from-dark-souls"
  },
  {
    url: "/styles/blackwork/death-guard-40k-universe-ENy91xVVQo6byzMU4ebLK3",
    title: "death guard k universe",
    list_url: "/styles/blackwork/death-guard-40k-universe"
  },
  {
    url: "/styles/blackwork/deepshikha-and-soumya-names-written-EKjFnSYbjf8CWQNfpmAGb8",
    title: "deepshikha and soumya names written",
    list_url: "/styles/blackwork/deepshikha-and-soumya-names-written"
  },
  {
    url: "/styles/blackwork/devil-arm-EDLy3YZkdErWPmGBeRePTt",
    title: "devil arm",
    list_url: "/styles/blackwork/devil-arm"
  },
  {
    url: "/styles/blackwork/donald-duck-money-MfjwRLHdEDx9dEXSHGANsr",
    title: "donald duck money",
    list_url: "/styles/blackwork/donald-duck-money"
  },
  {
    url: "/styles/blackwork/dripping-blood-heart-HL9BtKbpGzKyQcWFSvbpSB",
    title: "dripping blood heart",
    list_url: "/styles/blackwork/dripping-blood-heart"
  },
  {
    url: "/styles/blackwork/evil-rotting-tree-9A6tSBYphHWkA5tEB75YmP",
    title: "evil rotting tree",
    list_url: "/styles/blackwork/evil-rotting-tree"
  },
  {
    url: "/styles/blackwork/fake-it-til-you-make-it-6nfHptUpcKy7UMwDWqdLHo",
    title: "fake it til you make it",
    list_url: "/styles/blackwork/fake-it-til-you-make-it"
  },
  {
    url: "/styles/blackwork/feminine-bat-flying-6K3bNGSJKi5bnkfyRVSizG",
    title: "feminine bat flying",
    list_url: "/styles/blackwork/feminine-bat-flying"
  },
  {
    url: "/styles/blackwork/forearm-cuff-blackout-Wb196tzf7Qb8KiW7zy17om",
    title: "forearm cuff blackout",
    list_url: "/styles/blackwork/forearm-cuff-blackout"
  },
  {
    url: "/styles/blackwork/ghost-rider-FxojyiWkL4WLVAMr3eGAFh",
    title: "ghost rider",
    list_url: "/styles/blackwork/ghost-rider"
  },
  {
    url: "/styles/blackwork/gothic-window-N8TmALcXaKWHaqU1eJq4Gh",
    title: "gothic window",
    list_url: "/styles/blackwork/gothic-window"
  },
  {
    url: "/styles/blackwork/halo-unsc-tattoo-design-Ux5EGP2Zh9mTRy6AMRGMPz",
    title: "halo unsc tattoo design",
    list_url: "/styles/blackwork/halo-unsc-tattoo-design"
  },
  {
    url: "/styles/blackwork/hip-hop-dancer-in-the-street-VWfucV6qiFueEPVBe9utaz",
    title: "hip hop dancer in the street",
    list_url: "/styles/blackwork/hip-hop-dancer-in-the-street"
  },
  {
    url: "/styles/blackwork/how-about-a-tattoo-of-an-open-bible-2dmCe8WKQ9uToZet8w5niw",
    title: "how about a tattoo of an open bible",
    list_url: "/styles/blackwork/how-about-a-tattoo-of-an-open-bible"
  },
  {
    url: "/styles/blackwork/ibew-logo-42PKhYdktY4pw69CQwN8UW",
    title: "ibew logo",
    list_url: "/styles/blackwork/ibew-logo"
  },
  {
    url: "/styles/blackwork/inland-empire-disco-elysium-PCTjiMZJAHQeAXe8Pho58R",
    title: "inland empire disco elysium",
    list_url: "/styles/blackwork/inland-empire-disco-elysium"
  },
  {
    url: "/styles/blackwork/ivy-grown-on-a-brick-wall-EoDwkguMEKvh8K2TMUi6vP",
    title: "ivy grown on a brick wall",
    list_url: "/styles/blackwork/ivy-grown-on-a-brick-wall"
  },
  {
    url: "/styles/blackwork/jerusalem-cross-ihs-3a21CLkn5Z3aocpbYStdCW",
    title: "jerusalem cross ihs",
    list_url: "/styles/blackwork/jerusalem-cross-ihs"
  },
  {
    url: "/styles/blackwork/julius-caesar-leaf-crown-skull-D1RYJDgYiHqJT94yWjyihf",
    title: "julius caesar leaf crown skull",
    list_url: "/styles/blackwork/julius-caesar-leaf-crown-skull"
  },
  {
    url: "/styles/blackwork/just-the-name-elijah-in-cursive-DwRjbc9QahdSThLGoiiagi",
    title: "just the name elijah in cursive",
    list_url: "/styles/blackwork/just-the-name-elijah-in-cursive"
  },
  {
    url: "/styles/blackwork/lei-flowers-and-ti-leafs-with-leilani-HKgNnvQWW5rFKupSN9TRwU",
    title: "lei flowers and ti leafs with leilani",
    list_url: "/styles/blackwork/lei-flowers-and-ti-leafs-with-leilani"
  },
  {
    url: "/styles/blackwork/lologram-from-arrival-movie-that-means-NaTTYgL3WspZX6BFmicxYS",
    title: "lologram from arrival movie that means",
    list_url: "/styles/blackwork/lologram-from-arrival-movie-that-means"
  },
  {
    url: "/styles/blackwork/lord-shiva-lord-hanuman-lord-krishna-9uciZM3GAmMNyXEauCHQ1r",
    title: "lord shiva lord hanuman lord krishna",
    list_url: "/styles/blackwork/lord-shiva-lord-hanuman-lord-krishna"
  },
  {
    url: "/styles/blackwork/marathon-continues-flags-JnE2Q42tNQS5fcRFUcaWYa",
    title: "marathon continues flags",
    list_url: "/styles/blackwork/marathon-continues-flags"
  },
  {
    url: "/styles/blackwork/marsupilami-M15oovWdC19Qz32xTSNrGw",
    title: "marsupilami",
    list_url: "/styles/blackwork/marsupilami"
  },
  {
    url: "/styles/blackwork/moth-to-a-flame-VQahbZvvTSEXCEFovXLMB7",
    title: "moth to a flame",
    list_url: "/styles/blackwork/moth-to-a-flame"
  },
  {
    url: "/styles/blackwork/nanna-EubekZ4bFLzc6PPHJNcWxa",
    title: "nanna",
    list_url: "/styles/blackwork/nanna"
  },
  {
    url: "/styles/blackwork/neon-genesis-evangelion-wings-cross-VwYVCsGdLdgyHGWSQkMPuv",
    title: "neon genesis evangelion wings cross",
    list_url: "/styles/blackwork/neon-genesis-evangelion-wings-cross"
  },
  {
    url: "/styles/blackwork/ocean-wave-and-ship-AQ6tGgRYV4AvrGYs66kAYZ",
    title: "ocean wave and ship",
    list_url: "/styles/blackwork/ocean-wave-and-ship"
  },
  {
    url: "/styles/blackwork/polish-winged-hussar-no-horse-irish-Th6gWb2GQUMTQYYo2NBS2S",
    title: "polish winged hussar no horse irish",
    list_url: "/styles/blackwork/polish-winged-hussar-no-horse-irish"
  },
  {
    url: "/styles/blackwork/prodigy-ant-Tm8YhfSzoCkiSFgV5j4Xxq",
    title: "prodigy ant",
    list_url: "/styles/blackwork/prodigy-ant"
  },
  {
    url: "/styles/blackwork/rare-word-GdnrHfinxTDCwfgRpQ1qE8",
    title: "rare word",
    list_url: "/styles/blackwork/rare-word"
  },
  {
    url: "/styles/blackwork/roman-soldiergladiator-using-a-lion-ETqeDiZ8MNetGJEyBdyAjL",
    title: "roman soldiergladiator using a lion",
    list_url: "/styles/blackwork/roman-soldiergladiator-using-a-lion"
  },
  {
    url: "/styles/blackwork/rose-licking-knife-Ugjn9XcssWMWDkKary5krN",
    title: "rose licking knife",
    list_url: "/styles/blackwork/rose-licking-knife"
  },
  {
    url: "/styles/blackwork/saber-with-anime-fate-stay-night-8d67A9iqTJhBAS2VUidoL3",
    title: "saber with anime fate stay night",
    list_url: "/styles/blackwork/saber-with-anime-fate-stay-night"
  },
  {
    url: "/styles/blackwork/shadow-self-4Qn6CZteJMdfkrhzqz4Qww",
    title: "shadow self",
    list_url: "/styles/blackwork/shadow-self"
  },
  {
    url: "/styles/blackwork/skeleton-hand-holding-an-hourglass-LUex7bknvunriCmArJbHFn",
    title: "skeleton hand holding an hourglass",
    list_url: "/styles/blackwork/skeleton-hand-holding-an-hourglass"
  },
  {
    url: "/styles/blackwork/skyrim-dragon-language-6TrUHP3KV6KCrxVju6G1r4",
    title: "skyrim dragon language",
    list_url: "/styles/blackwork/skyrim-dragon-language"
  },
  {
    url: "/styles/blackwork/space-marine-warhammer-40k-ultramarine-3fpSg1n8TKeiX81zFaZA78",
    title: "space marine warhammer k ultramarine",
    list_url: "/styles/blackwork/space-marine-warhammer-40k-ultramarine"
  },
  {
    url: "/styles/blackwork/split-personality-GFkvJGjtCehLe4fuMzbSb5",
    title: "split personality",
    list_url: "/styles/blackwork/split-personality"
  },
  {
    url: "/styles/blackwork/surfing-penguin-NuCceNvztV1xWRZDpiaW7D",
    title: "surfing penguin",
    list_url: "/styles/blackwork/surfing-penguin"
  },
  {
    url: "/styles/blackwork/sword-sting-from-lord-of-the-rings-N5E8qzNcxsd3kBD4zbnHMZ",
    title: "sword sting from lord of the rings",
    list_url: "/styles/blackwork/sword-sting-from-lord-of-the-rings"
  },
  {
    url: "/styles/blackwork/the-roma-gypsy-symbol-a-NmnBqrAP7ab8wkEUYSnutJ",
    title: "the roma gypsy symbol a",
    list_url: "/styles/blackwork/the-roma-gypsy-symbol-a"
  },
  {
    url: "/styles/blackwork/the-thinker-X2YffctTxJ3yEv2pZAJTk4",
    title: "the thinker",
    list_url: "/styles/blackwork/the-thinker"
  },
  {
    url: "/styles/blackwork/thresh-league-of-legends-P9qRdaNBSCMZmKJwMgUYqW",
    title: "thresh league of legends",
    list_url: "/styles/blackwork/thresh-league-of-legends"
  },
  {
    url: "/styles/blackwork/tribal-puerto-rican-neck-tattoo-with-AvrqYcqDMJMQD3q7h1ktSR",
    title: "tribal puerto rican neck tattoo with",
    list_url: "/styles/blackwork/tribal-puerto-rican-neck-tattoo-with"
  },
  {
    url: "/styles/blackwork/tuning-bmw-e39-touring-ATqGEppMnvmNPXd1TLb8UE",
    title: "tuning bmw e touring",
    list_url: "/styles/blackwork/tuning-bmw-e39-touring"
  },
  {
    url: "/styles/blackwork/two-swords-are-crossed-GUzkshsg1JBpbEhwCwLZt8",
    title: "two swords are crossed",
    list_url: "/styles/blackwork/two-swords-are-crossed"
  },
  {
    url: "/styles/blackwork/ulcerative-colitis-survivor-and-work-is-UxrRezofJrkKxqDuJKtNKB",
    title: "ulcerative colitis survivor and work is",
    list_url: "/styles/blackwork/ulcerative-colitis-survivor-and-work-is"
  },
  {
    url: "/styles/blackwork/vikingpagan-themed-raven-tattoo-chest-Kk7EFknCuA8xVHAsKQXc7K",
    title: "vikingpagan themed raven tattoo chest",
    list_url: "/styles/blackwork/vikingpagan-themed-raven-tattoo-chest"
  },
  {
    url: "/styles/blackwork/virgin-mary-crying-blood-4pXGvhpNELC54pNGqcVq2f",
    title: "virgin mary crying blood",
    list_url: "/styles/blackwork/virgin-mary-crying-blood"
  },
  {
    url: "/styles/blackwork/wargreymon-digimon-KC6LXGdKLE1UAJy6XHg6dE",
    title: "wargreymon digimon",
    list_url: "/styles/blackwork/wargreymon-digimon"
  },
  {
    url: "/styles/blackwork/warrior-arjuna-pointing-a-bow-and-arrow-HfghhDSuyjJwiwjQA7W5XU",
    title: "warrior arjuna pointing a bow and arrow",
    list_url: "/styles/blackwork/warrior-arjuna-pointing-a-bow-and-arrow"
  },
  {
    url: "/styles/blackwork/wave-with-the-letter-g-s-crown-2FxSMLLiVTvv4tXDCQwt3M",
    title: "wave with the letter g s crown",
    list_url: "/styles/blackwork/wave-with-the-letter-g-s-crown"
  },
  {
    url: "/styles/blackwork/weed-leaf-HAVkuvaSAjBD7eF4gapSiU",
    title: "weed leaf",
    list_url: "/styles/blackwork/weed-leaf"
  },
  {
    url: "/styles/blackwork/write-mh-ubi-tu-ibi-ego-NnAm3njVC8PWPZgkZokZbP",
    title: "write mh ubi tu ibi ego",
    list_url: "/styles/blackwork/write-mh-ubi-tu-ibi-ego"
  },
  {
    url: "/styles/chicano/seattle-mariners-cross-EfdoeZVkQosaoAHVZRZ1yq",
    title: "seattle mariners cross",
    list_url: "/styles/chicano/seattle-mariners-cross"
  },
  {
    url: "/styles/cyber-sigilism/eye-6HQLPSc7MjxfuNRojvXBM4",
    title: "eye",
    list_url: "/styles/cyber-sigilism/eye"
  },
  {
    url: "/styles/cyber-sigilism/letters-HUs3uBczgZ3UB74so8eSQC",
    title: "letters",
    list_url: "/styles/cyber-sigilism/letters"
  },
  {
    url: "/styles/dotwork/3-point-simple-king-crown-with-leaves-VU7FR41CgdYGEVo7eBGJFh",
    title: " point simple king crown with leaves",
    list_url: "/styles/dotwork/3-point-simple-king-crown-with-leaves"
  },
  {
    url: "/styles/dotwork/a-skull-with-a-rose-in-its-mouth-U5fCAyj6YbSdRU7ZbgPpeY",
    title: "a skull with a rose in its mouth",
    list_url: "/styles/dotwork/a-skull-with-a-rose-in-its-mouth"
  },
  {
    url: "/styles/dotwork/alfa-romeo-quadrifoglio-HYMBvQhNZggoUtgxQiJmx8",
    title: "alfa romeo quadrifoglio",
    list_url: "/styles/dotwork/alfa-romeo-quadrifoglio"
  },
  {
    url: "/styles/dotwork/angel-wings-with-clouds-D9W4wAM2HUrTaq9xjDdNCm",
    title: "angel wings with clouds",
    list_url: "/styles/dotwork/angel-wings-with-clouds"
  },
  {
    url: "/styles/dotwork/aztec-pyramid-FvgT5wgWda1ZD6SasBpfme",
    title: "aztec pyramid",
    list_url: "/styles/dotwork/aztec-pyramid"
  },
  {
    url: "/styles/dotwork/beautiful-african-queen-YUjM4Xx5k2NGDK67sTMNrf",
    title: "beautiful african queen",
    list_url: "/styles/dotwork/beautiful-african-queen"
  },
  {
    url: "/styles/dotwork/carta-rey-de-corazones-LfHxiggDaDjwCtUhPZtx1v",
    title: "carta rey de corazones",
    list_url: "/styles/dotwork/carta-rey-de-corazones"
  },
  {
    url: "/styles/dotwork/celtic-cross-made-out-if-kids-names-MJyCXEHf8FbQrw5hjLu31A",
    title: "celtic cross made out if kids names",
    list_url: "/styles/dotwork/celtic-cross-made-out-if-kids-names"
  },
  {
    url: "/styles/dotwork/dutch-lion-english-lion-Hy5mYo2G7NfPPc3NNZZsr2",
    title: "dutch lion english lion",
    list_url: "/styles/dotwork/dutch-lion-english-lion"
  },
  {
    url: "/styles/dotwork/f14-tomcat-fighter-jet-plane-flying-in-XXdZd88sYm7ZVj5x3qBFac",
    title: "f tomcat fighter jet plane flying in",
    list_url: "/styles/dotwork/f14-tomcat-fighter-jet-plane-flying-in"
  },
  {
    url: "/styles/dotwork/geometric-tree-of-life-AJb3Hn59Jb9VSHN5QPJ9H",
    title: "geometric tree of life",
    list_url: "/styles/dotwork/geometric-tree-of-life"
  },
  {
    url: "/styles/dotwork/hammock-camping-VJU8Vujzxj5MpQCAdfpheJ",
    title: "hammock camping",
    list_url: "/styles/dotwork/hammock-camping"
  },
  {
    url: "/styles/dotwork/harshitha-avinash-3tEVEYxSbVbqHD3QLxtKon",
    title: "harshitha avinash",
    list_url: "/styles/dotwork/harshitha-avinash"
  },
  {
    url: "/styles/dotwork/inception-spinning-top-5dcRcjpthWrjjVzeDEVTYf",
    title: "inception spinning top",
    list_url: "/styles/dotwork/inception-spinning-top"
  },
  {
    url: "/styles/dotwork/jupiter-god-with-vedic-text-W3ovLWvLYN7fkTNMQeJ4Uk",
    title: "jupiter god with vedic text",
    list_url: "/styles/dotwork/jupiter-god-with-vedic-text"
  },
  {
    url: "/styles/dotwork/lada-niva-9eXjaA5e4jCQGPRxpvpZhE",
    title: "lada niva",
    list_url: "/styles/dotwork/lada-niva"
  },
  {
    url: "/styles/dotwork/lord-of-the-rings-simple-tattoo-misty-Xs7riw9z9PKSdDvAGf3sYV",
    title: "lord of the rings simple tattoo misty",
    list_url: "/styles/dotwork/lord-of-the-rings-simple-tattoo-misty"
  },
  {
    url: "/styles/dotwork/lotus-flower-GgJhDf2er2d41AnhoK5ttn",
    title: "lotus flower",
    list_url: "/styles/dotwork/lotus-flower"
  },
  {
    url: "/styles/dotwork/lover-loner-tRdheKPPabYMC9vKQR1ba",
    title: "lover loner",
    list_url: "/styles/dotwork/lover-loner"
  },
  {
    url: "/styles/dotwork/mandala-design-areola-tattoo-M2V4gb9pKwsq82adiKD6hR",
    title: "mandala design areola tattoo",
    list_url: "/styles/dotwork/mandala-design-areola-tattoo"
  },
  {
    url: "/styles/dotwork/mom-tiger-with-baby-tiger-mom-tiger-YSnFSnPgR5MiQNLuuqjBep",
    title: "mom tiger with baby tiger mom tiger",
    list_url: "/styles/dotwork/mom-tiger-with-baby-tiger-mom-tiger"
  },
  {
    url: "/styles/dotwork/mother-and-two-children-tree-life-love-PdwJJmaA2h5Y186t4YDvBs",
    title: "mother and two children tree life love",
    list_url: "/styles/dotwork/mother-and-two-children-tree-life-love"
  },
  {
    url: "/styles/dotwork/nevaeh-VuePYC2fiTVj1Vd1WgibR7",
    title: "nevaeh",
    list_url: "/styles/dotwork/nevaeh"
  },
  {
    url: "/styles/dotwork/owl-flying-holding-an-hourglass-KrEPzCKQrjne3vPrSPTXWJ",
    title: "owl flying holding an hourglass",
    list_url: "/styles/dotwork/owl-flying-holding-an-hourglass"
  },
  {
    url: "/styles/dotwork/palm-tree-with-surfboard-and-turtle-4rkBrUoaeS7HaTctypWmuo",
    title: "palm tree with surfboard and turtle",
    list_url: "/styles/dotwork/palm-tree-with-surfboard-and-turtle"
  },
  {
    url: "/styles/dotwork/paternal-orphan-S9MMduYM2GbfsWtdTk1XpX",
    title: "paternal orphan",
    list_url: "/styles/dotwork/paternal-orphan"
  },
  {
    url: "/styles/dotwork/pipil-warrior-9UZFZ3CdeE7Y3wLA1xwMQq",
    title: "pipil warrior",
    list_url: "/styles/dotwork/pipil-warrior"
  },
  {
    url: "/styles/dotwork/rattle-snake-skeleton-with-cowboy-hat-Tez6nWPGTMpURQEHcBgcHV",
    title: "rattle snake skeleton with cowboy hat",
    list_url: "/styles/dotwork/rattle-snake-skeleton-with-cowboy-hat"
  },
  {
    url: "/styles/dotwork/rhodesian-ridgeback-BQ8af59QySiyAXfGds89Es",
    title: "rhodesian ridgeback",
    list_url: "/styles/dotwork/rhodesian-ridgeback"
  },
  {
    url: "/styles/dotwork/saint-thomas-aquinas-9ThAHRVxB8T9Hd4hY2C8WG",
    title: "saint thomas aquinas",
    list_url: "/styles/dotwork/saint-thomas-aquinas"
  },
  {
    url: "/styles/dotwork/skull-in-the-cloud-6zsojSoYMXcLDSPYtdFbaA",
    title: "skull in the cloud",
    list_url: "/styles/dotwork/skull-in-the-cloud"
  },
  {
    url: "/styles/dotwork/st-george-7Zn66Vw4kBFfCGT6viApnm",
    title: "st george",
    list_url: "/styles/dotwork/st-george"
  },
  {
    url: "/styles/dotwork/symbolic-tattoo-of-the-fc-barcelona-7ZRRUog4NLHjM7adkHvmva",
    title: "symbolic tattoo of the fc barcelona",
    list_url: "/styles/dotwork/symbolic-tattoo-of-the-fc-barcelona"
  },
  {
    url: "/styles/dotwork/tall-cake-with-hot-hentai-women-Ne1p5jvBTRoeim2Bupy6X7",
    title: "tall cake with hot hentai women",
    list_url: "/styles/dotwork/tall-cake-with-hot-hentai-women"
  },
  {
    url: "/styles/dotwork/twin-peaks-fire-walk-with-me-N2BM4ECUfDFkBwL1U3b1xd",
    title: "twin peaks fire walk with me",
    list_url: "/styles/dotwork/twin-peaks-fire-walk-with-me"
  },
  {
    url: "/styles/dotwork/warhammer-alpha-legion-6wxojm3UZjizjhtmkGuayL",
    title: "warhammer alpha legion",
    list_url: "/styles/dotwork/warhammer-alpha-legion"
  },
  {
    url: "/styles/dotwork/white-nun-orchid-flower-with-guatemala-24qrKhzd3Q28d2Q26WX4vQ",
    title: "white nun orchid flower with guatemala",
    list_url: "/styles/dotwork/white-nun-orchid-flower-with-guatemala"
  },
  {
    url: "/styles/dotwork/white-tiger-Q3AimHDDKJUfL75kpJvKXu",
    title: "white tiger",
    list_url: "/styles/dotwork/white-tiger"
  },
  {
    url: "/styles/dotwork/wing-ridden-angel-Rdwxtm1WN3MKjg6R6bRvzG",
    title: "wing ridden angel",
    list_url: "/styles/dotwork/wing-ridden-angel"
  },
  {
    url: "/styles/dotwork/wonder-pets-smoking-weed-Dsn18cNbb9gQh2geivuRKG",
    title: "wonder pets smoking weed",
    list_url: "/styles/dotwork/wonder-pets-smoking-weed"
  },
  {
    url: "/styles/dotwork/write-11-59-use-this-sentence-to-fill-K3Q7cSQRadB6gRYi74kh8M",
    title: "write use this sentence to fill",
    list_url: "/styles/dotwork/write-11-59-use-this-sentence-to-fill"
  },
  {
    url: "/styles/geometric/a-dragon-and-a-pisces-sign-HajKibe3C7RdX8vPo9PCGz",
    title: "a dragon and a pisces sign",
    list_url: "/styles/geometric/a-dragon-and-a-pisces-sign"
  },
  {
    url: "/styles/geometric/acdc-lyrics-a-touch-too-much-XS8S4sj3VLbwwX5r6G3mz3",
    title: "acdc lyrics a touch too much",
    list_url: "/styles/geometric/acdc-lyrics-a-touch-too-much"
  },
  {
    url: "/styles/geometric/animals-LFeCQKKMAnYmhNspAYKWQy",
    title: "animals",
    list_url: "/styles/geometric/animals"
  },
  {
    url: "/styles/geometric/baby-groot-5iCjZmv6YGQuKDtq9s2oS8",
    title: "baby groot",
    list_url: "/styles/geometric/baby-groot"
  },
  {
    url: "/styles/geometric/book-and-tree-2v5Le9TbfwozoEsQQB2N47",
    title: "book and tree",
    list_url: "/styles/geometric/book-and-tree"
  },
  {
    url: "/styles/geometric/english-bull-terrier-R7sRtokhp898XQfqnjECGj",
    title: "english bull terrier",
    list_url: "/styles/geometric/english-bull-terrier"
  },
  {
    url: "/styles/geometric/holy-trinity-FhS92ucmC446DnUyggwSfR",
    title: "holy trinity",
    list_url: "/styles/geometric/holy-trinity"
  },
  {
    url: "/styles/geometric/name-tatto-design-with-name-anaya-4pcBLc2BbB3v6t1cwmNcsk",
    title: "name tatto design with name anaya",
    list_url: "/styles/geometric/name-tatto-design-with-name-anaya"
  },
  {
    url: "/styles/geometric/owl-with-fox-SgQj9pnaX9Q3LARZmn81Tv",
    title: "owl with fox",
    list_url: "/styles/geometric/owl-with-fox"
  },
  {
    url: "/styles/geometric/tree-of-life-mandala-XPBtb582suFDHcpd7VDtHf",
    title: "tree of life mandala",
    list_url: "/styles/geometric/tree-of-life-mandala"
  },
  {
    url: "/styles/geometric/triangle-waves-9pKBYFX6J2HgPfN2H8uj25",
    title: "triangle waves",
    list_url: "/styles/geometric/triangle-waves"
  },
  {
    url: "/styles/gothic/dark-flower-WWAFZ9LW4eta6ppSzk8ffY",
    title: "dark flower",
    list_url: "/styles/gothic/dark-flower"
  },
  {
    url: "/styles/japanese/a-traditional-irezumi-arm-sleeve-with-a-4reXZfkNFpWQ6kVad1YdxU",
    title: "a traditional irezumi arm sleeve with a",
    list_url: "/styles/japanese/a-traditional-irezumi-arm-sleeve-with-a"
  },
  {
    url: "/styles/japanese/akali-EkjLpMutrH5omTiNbrcrcV",
    title: "akali",
    list_url: "/styles/japanese/akali"
  },
  {
    url: "/styles/japanese/andrew-tate-Duvi5Yzd1bZoucD3XkntE8",
    title: "andrew tate",
    list_url: "/styles/japanese/andrew-tate"
  },
  {
    url: "/styles/japanese/captain-levi-ackerman-XzFbzxQAMhbZdEkvWF2gQT",
    title: "captain levi ackerman",
    list_url: "/styles/japanese/captain-levi-ackerman"
  },
  {
    url: "/styles/japanese/cracked-oni-mask-97S5AsWoqzw6beRjjf6nyp",
    title: "cracked oni mask",
    list_url: "/styles/japanese/cracked-oni-mask"
  },
  {
    url: "/styles/japanese/dragon-holding-dragon-ball-5jYXt1CsRnaHGRWJhZNupJ",
    title: "dragon holding dragon ball",
    list_url: "/styles/japanese/dragon-holding-dragon-ball"
  },
  {
    url: "/styles/japanese/hannya-mask-full-back-yakuza-56yPruMwL2uPcGwWRNi7F6",
    title: "hannya mask full back yakuza",
    list_url: "/styles/japanese/hannya-mask-full-back-yakuza"
  },
  {
    url: "/styles/japanese/inari-okami-fox-PdKPYQKgXX6JXJmx4L9U1P",
    title: "inari okami fox",
    list_url: "/styles/japanese/inari-okami-fox"
  },
  {
    url: "/styles/japanese/jorogumo-is-a-deadly-spider-woman-able-8tX4kiHDAmb8oZFXqztxcg",
    title: "jorogumo is a deadly spider woman able",
    list_url: "/styles/japanese/jorogumo-is-a-deadly-spider-woman-able"
  },
  {
    url: "/styles/japanese/life-and-death-koi-fish-from-avatar-CLwbEPTLsp7wSi1QV2gUJ7",
    title: "life and death koi fish from avatar",
    list_url: "/styles/japanese/life-and-death-koi-fish-from-avatar"
  },
  {
    url: "/styles/japanese/oni-skull-mask-NsYYNEszLoB31o74MBqBRi",
    title: "oni skull mask",
    list_url: "/styles/japanese/oni-skull-mask"
  },
  {
    url: "/styles/japanese/ox-WRfjLPkVWBrkZhjbQjW4Ft",
    title: "ox",
    list_url: "/styles/japanese/ox"
  },
  {
    url: "/styles/japanese/samurai-head-7sQdLgwz17MZR58bKvrbTj",
    title: "samurai head",
    list_url: "/styles/japanese/samurai-head"
  },
  {
    url: "/styles/japanese/seven-deadly-sins-dragon-sin-BvvRe2hjCHoRucdnzbZvi4",
    title: "seven deadly sins dragon sin",
    list_url: "/styles/japanese/seven-deadly-sins-dragon-sin"
  },
  {
    url: "/styles/japanese/shinigami-god-of-death-M8133AuRaLUCdU6Rf8eqYi",
    title: "shinigami god of death",
    list_url: "/styles/japanese/shinigami-god-of-death"
  },
  {
    url: "/styles/japanese/snake-spider-hybrid-creature-combining-RJv7R6n6cU5bxNg9DSNczf",
    title: "snake spider hybrid creature combining",
    list_url: "/styles/japanese/snake-spider-hybrid-creature-combining"
  },
  {
    url: "/styles/japanese/street-fighter-akuma-R5oZavHcd4X2sMb1hr9gtC",
    title: "street fighter akuma",
    list_url: "/styles/japanese/street-fighter-akuma"
  },
  {
    url: "/styles/japanese/survey-corps-from-attack-on-titan-HKVLeJzVoL27BsdsN6mepB",
    title: "survey corps from attack on titan",
    list_url: "/styles/japanese/survey-corps-from-attack-on-titan"
  },
  {
    url: "/styles/japanese/symmetrical-dragon-tramp-stamp-QtSuHhnvD2pVST6ccQkusE",
    title: "symmetrical dragon tramp stamp",
    list_url: "/styles/japanese/symmetrical-dragon-tramp-stamp"
  },
  {
    url: "/styles/japanese/use-these-roman-numerals-xxviii-D1pAzipNwPx36wrV2iXrou",
    title: "use these roman numerals xxviii",
    list_url: "/styles/japanese/use-these-roman-numerals-xxviii"
  },
  {
    url: "/styles/japanese/ying-yang-gemini-twin-koi-fish-for-the-7Ytpbdgf8c2qHndDTDCh5R",
    title: "ying yang gemini twin koi fish for the",
    list_url: "/styles/japanese/ying-yang-gemini-twin-koi-fish-for-the"
  },
  {
    url: "/styles/minimalist/1963-1966-and-1999-roman-numerals-REdtu3Nsf4sH9D4woVyPwb",
    title: " and roman numerals",
    list_url: "/styles/minimalist/1963-1966-and-1999-roman-numerals"
  },
  {
    url: "/styles/minimalist/808-SYdqHCYjnojFqUd1v98FEi",
    title: " ",
    list_url: "/styles/minimalist/808"
  },
  {
    url: "/styles/minimalist/a-5-leaf-clover-in-thin-line-BZCL9CbuZQEHh2akgczfSD",
    title: "a leaf clover in thin line",
    list_url: "/styles/minimalist/a-5-leaf-clover-in-thin-line"
  },
  {
    url: "/styles/minimalist/a-book-with-pages-turning-into-birds-2TYwv4fViohqrRD8DvbSAu",
    title: "a book with pages turning into birds",
    list_url: "/styles/minimalist/a-book-with-pages-turning-into-birds"
  },
  {
    url: "/styles/minimalist/a-flash-tattoo-of-zinedine-zidane-AmkUJxUgyY7qC7onF9HMLM",
    title: "a flash tattoo of zinedine zidane",
    list_url: "/styles/minimalist/a-flash-tattoo-of-zinedine-zidane"
  },
  {
    url: "/styles/minimalist/a-minimalist-tattoo-of-a-cancer-zodiac-4c47RTgTLDt75dB6weXGWQ",
    title: "a minimalist tattoo of a cancer zodiac",
    list_url: "/styles/minimalist/a-minimalist-tattoo-of-a-cancer-zodiac"
  },
  {
    url: "/styles/minimalist/a-simple-outline-of-a-blooming-flower-DdsBAG7PBEQbBp9UnMMvNY",
    title: "a simple outline of a blooming flower",
    list_url: "/styles/minimalist/a-simple-outline-of-a-blooming-flower"
  },
  {
    url: "/styles/minimalist/a-small-stick-figure-looking-up-at-a-UtsdbgXjiYCvn2NEz1yRf2",
    title: "a small stick figure looking up at a",
    list_url: "/styles/minimalist/a-small-stick-figure-looking-up-at-a"
  },
  {
    url: "/styles/minimalist/abstract-porch-swing-4Fsrnwf1EJ53u1v4jDUAL9",
    title: "abstract porch swing",
    list_url: "/styles/minimalist/abstract-porch-swing"
  },
  {
    url: "/styles/minimalist/alexander-the-great-7Jen9yArG4hPKqi133Qv5Y",
    title: "alexander the great",
    list_url: "/styles/minimalist/alexander-the-great"
  },
  {
    url: "/styles/minimalist/angel-wings-with-sword-back-tattoo-Jyj7F8uGcAJa3HeJdBftha",
    title: "angel wings with sword back tattoo",
    list_url: "/styles/minimalist/angel-wings-with-sword-back-tattoo"
  },
  {
    url: "/styles/minimalist/aphrodite-UMDj2Gw7dwrX1jJtE4tnJw",
    title: "aphrodite",
    list_url: "/styles/minimalist/aphrodite"
  },
  {
    url: "/styles/minimalist/arabesque-XCFrrTMc3F95D6naN96LYh",
    title: "arabesque",
    list_url: "/styles/minimalist/arabesque"
  },
  {
    url: "/styles/minimalist/area-code-717-and-603-Xs5DYjWDEbPenqK9sKzuhA",
    title: "area code and ",
    list_url: "/styles/minimalist/area-code-717-and-603"
  },
  {
    url: "/styles/minimalist/army-tank-BHvt7F78hn3LsitvUJ7SzA",
    title: "army tank",
    list_url: "/styles/minimalist/army-tank"
  },
  {
    url: "/styles/minimalist/barbie-BZL29YiaAWRu8gGFQn7bM9",
    title: "barbie",
    list_url: "/styles/minimalist/barbie"
  },
  {
    url: "/styles/minimalist/batman-symbol-VJV7RVis5nTxV86R2J6fjS",
    title: "batman symbol",
    list_url: "/styles/minimalist/batman-symbol"
  },
  {
    url: "/styles/minimalist/bible-verse-and-flower-N2t24PZAYurnx4Gmeeob4g",
    title: "bible verse and flower",
    list_url: "/styles/minimalist/bible-verse-and-flower"
  },
  {
    url: "/styles/minimalist/bird-on-a-wire-watching-two-birds-fly-Td5E5wJfuFFmYpyveUBzkV",
    title: "bird on a wire watching two birds fly",
    list_url: "/styles/minimalist/bird-on-a-wire-watching-two-birds-fly"
  },
  {
    url: "/styles/minimalist/birth-flower-libra-zodiac-sign-7nWgxkr496oVszGQAJx8Yi",
    title: "birth flower libra zodiac sign",
    list_url: "/styles/minimalist/birth-flower-libra-zodiac-sign"
  },
  {
    url: "/styles/minimalist/blackjack-cards-floating-RRaos7Y97UYLBcAPNtoPux",
    title: "blackjack cards floating",
    list_url: "/styles/minimalist/blackjack-cards-floating"
  },
  {
    url: "/styles/minimalist/border-terrier-dog-XAvD48rca87WinHeGVg1Aq",
    title: "border terrier dog",
    list_url: "/styles/minimalist/border-terrier-dog"
  },
  {
    url: "/styles/minimalist/broken-tree-with-many-roots-with-bat-GL5BMZ1uy93PV66vLQHqBh",
    title: "broken tree with many roots with bat",
    list_url: "/styles/minimalist/broken-tree-with-many-roots-with-bat"
  },
  {
    url: "/styles/minimalist/burnt-toast-theory-PshTxVgXs6dmqoEjsqqTgo",
    title: "burnt toast theory",
    list_url: "/styles/minimalist/burnt-toast-theory"
  },
  {
    url: "/styles/minimalist/butterfly-wings-with-initials-and-the-NQ5Ge7f7zdoMek5du28brA",
    title: "butterfly wings with initials and the",
    list_url: "/styles/minimalist/butterfly-wings-with-initials-and-the"
  },
  {
    url: "/styles/minimalist/christian-cross-writen-memento-mori-PmKmXyZuH62m2aNCt7KUdX",
    title: "christian cross writen memento mori",
    list_url: "/styles/minimalist/christian-cross-writen-memento-mori"
  },
  {
    url: "/styles/minimalist/concert-NhFv5LRNbv1x1CFgENaXRp",
    title: "concert",
    list_url: "/styles/minimalist/concert"
  },
  {
    url: "/styles/minimalist/coram-deo-phrase-with-cross-W6Kb92kmZqKVcbx9vwW39q",
    title: "coram deo phrase with cross",
    list_url: "/styles/minimalist/coram-deo-phrase-with-cross"
  },
  {
    url: "/styles/minimalist/cover-up-for-the-numbers-98-KfPBM8M2DMaNEGFFiyVyFf",
    title: "cover up for the numbers ",
    list_url: "/styles/minimalist/cover-up-for-the-numbers-98"
  },
  {
    url: "/styles/minimalist/crucifix-in-a-circle-romans-12-19-6sYJp2jHtgQfNnFKYU42bZ",
    title: "crucifix in a circle romans ",
    list_url: "/styles/minimalist/crucifix-in-a-circle-romans-12-19"
  },
  {
    url: "/styles/minimalist/cursive-writing-taylor-swift-fearless-4FZWB9uNXRcANVvhYEYhus",
    title: "cursive writing taylor swift fearless",
    list_url: "/styles/minimalist/cursive-writing-taylor-swift-fearless"
  },
  {
    url: "/styles/minimalist/cute-frog-4nJ8QNgFdttYpAKgJAQD8h",
    title: "cute frog",
    list_url: "/styles/minimalist/cute-frog"
  },
  {
    url: "/styles/minimalist/cybertribal-spine-vertebrae-SV35G6Em5SQWgsFYTjNFDu",
    title: "cybertribal spine vertebrae",
    list_url: "/styles/minimalist/cybertribal-spine-vertebrae"
  },
  {
    url: "/styles/minimalist/daddy-issues-8mh5XXt7RgSp6RyySVjt9x",
    title: "daddy issues",
    list_url: "/styles/minimalist/daddy-issues"
  },
  {
    url: "/styles/minimalist/daisy-lily-of-the-flower-and-carnation-A2MSUr1YT2neDv2Svt5A2W",
    title: "daisy lily of the flower and carnation",
    list_url: "/styles/minimalist/daisy-lily-of-the-flower-and-carnation"
  },
  {
    url: "/styles/minimalist/delphinium-bouquet-fine-line-Tpj9gVHZGwSSS34ZLucMW9",
    title: "delphinium bouquet fine line",
    list_url: "/styles/minimalist/delphinium-bouquet-fine-line"
  },
  {
    url: "/styles/minimalist/elephant-tattoo-for-old-women-on-forearm-GyVXNKfK5E1hy7Jd4khSo7",
    title: "elephant tattoo for old women on forearm",
    list_url: "/styles/minimalist/elephant-tattoo-for-old-women-on-forearm"
  },
  {
    url: "/styles/minimalist/fine-line-elephant-F66X2ZPFVTJ4CcpkLKrx2x",
    title: "fine line elephant",
    list_url: "/styles/minimalist/fine-line-elephant"
  },
  {
    url: "/styles/minimalist/galatasaray-WmZCF2HpneWjCZ5vyvVdEJ",
    title: "galatasaray",
    list_url: "/styles/minimalist/galatasaray"
  },
  {
    url: "/styles/minimalist/gladiator-helmet-StuCrx3gG9HeNMdCc1kxyy",
    title: "gladiator helmet",
    list_url: "/styles/minimalist/gladiator-helmet"
  },
  {
    url: "/styles/minimalist/gnothi-seauton-G5puUy1523fjMqMP68rNSf",
    title: "gnothi seauton",
    list_url: "/styles/minimalist/gnothi-seauton"
  },
  {
    url: "/styles/minimalist/gummy-bear-4a12QVdNmkwDPHf5L6gUr1",
    title: "gummy bear",
    list_url: "/styles/minimalist/gummy-bear"
  },
  {
    url: "/styles/minimalist/heart-moon-sun-stars-SMTSJUwfJeqvjG1KwccUdh",
    title: "heart moon sun stars",
    list_url: "/styles/minimalist/heart-moon-sun-stars"
  },
  {
    url: "/styles/minimalist/heart-with-cursive-letter-n-letter-MzeycXSpMuCh57D1Ycy4Mj",
    title: "heart with cursive letter n letter",
    list_url: "/styles/minimalist/heart-with-cursive-letter-n-letter"
  },
  {
    url: "/styles/minimalist/i-am-strong-KYpFiaZYtNaitPBbsh4K",
    title: "i am strong",
    list_url: "/styles/minimalist/i-am-strong"
  },
  {
    url: "/styles/minimalist/individually-were-whole-but-together-5H15Jx31uVYiVjEs7vSwkb",
    title: "individually were whole but together",
    list_url: "/styles/minimalist/individually-were-whole-but-together"
  },
  {
    url: "/styles/minimalist/infinity-heart-moon-sun-546g7fwVcSW2CXzMFYPW6g",
    title: "infinity heart moon sun",
    list_url: "/styles/minimalist/infinity-heart-moon-sun"
  },
  {
    url: "/styles/minimalist/jesus-walking-on-water-7NCY51qyEtqUyGfedELKHo",
    title: "jesus walking on water",
    list_url: "/styles/minimalist/jesus-walking-on-water"
  },
  {
    url: "/styles/minimalist/king-queen-joker-jack-six-and-2-cards-XPEkZzLKgcqAsJ95B1d4eZ",
    title: "king queen joker jack six and cards",
    list_url: "/styles/minimalist/king-queen-joker-jack-six-and-2-cards"
  },
  {
    url: "/styles/minimalist/life-before-death-strength-before-6gWxHjr2485GD78bYtNqRw",
    title: "life before death strength before",
    list_url: "/styles/minimalist/life-before-death-strength-before"
  },
  {
    url: "/styles/minimalist/luke-137-bible-verse-4MMRirqy46deXdeXCU97c9",
    title: "luke bible verse",
    list_url: "/styles/minimalist/luke-137-bible-verse"
  },
  {
    url: "/styles/minimalist/mila-name-M9EfaxS2TXa3M8ptADhhBM",
    title: "mila name",
    list_url: "/styles/minimalist/mila-name"
  },
  {
    url: "/styles/minimalist/mobius-strip-that-wraps-around-the-arm-G19d3EcxyXsRgtnG2FQhnk",
    title: "mobius strip that wraps around the arm",
    list_url: "/styles/minimalist/mobius-strip-that-wraps-around-the-arm"
  },
  {
    url: "/styles/minimalist/nomes-nathan-HRsM59LLhADYwjvUFF9L2Q",
    title: "nomes nathan",
    list_url: "/styles/minimalist/nomes-nathan"
  },
  {
    url: "/styles/minimalist/tartarus-C3jWuYZWMcRDZGTFBPtUdR",
    title: "tartarus",
    list_url: "/styles/minimalist/tartarus"
  },
  {
    url: "/styles/minimalist/time-heals-all-wounds-9nrT8gQwDDHG7MhyNtXYqj",
    title: "time heals all wounds",
    list_url: "/styles/minimalist/time-heals-all-wounds"
  },
  {
    url: "/styles/minimalist/tonka-truck-743S2PpGZPtWiCq14wtNDo",
    title: "tonka truck",
    list_url: "/styles/minimalist/tonka-truck"
  },
  {
    url: "/styles/minimalist/transgender-Tdfj6WzjgvMAvCRm9R9pwy",
    title: "transgender",
    list_url: "/styles/minimalist/transgender"
  },
  {
    url: "/styles/minimalist/tribute-to-jack-johnson-RqG937pTGSxXN4XyvpPw27",
    title: "tribute to jack johnson",
    list_url: "/styles/minimalist/tribute-to-jack-johnson"
  },
  {
    url: "/styles/minimalist/victory-or-valhalla-TF9CteDHYZjFWwXXmrGjJe",
    title: "victory or valhalla",
    list_url: "/styles/minimalist/victory-or-valhalla"
  },
  {
    url: "/styles/minimalist/witcher-3-Vy9ZqrfVGyguUQ8JuqHUAY",
    title: "witcher ",
    list_url: "/styles/minimalist/witcher-3"
  },
  {
    url: "/styles/neotraditional/a-stick-of-dynamite-it-was-dynamite-EpSqqbnmQ5WeNcnmKuUxBV",
    title: "a stick of dynamite it was dynamite",
    list_url: "/styles/neotraditional/a-stick-of-dynamite-it-was-dynamite"
  },
  {
    url: "/styles/neotraditional/angemon-3bAGLxPebtM7SgD1sw69iL",
    title: "angemon",
    list_url: "/styles/neotraditional/angemon"
  },
  {
    url: "/styles/neotraditional/antonio-gaudi-style-tattoo-VAsHaihYPf6mvfoxQpDtFs",
    title: "antonio gaudi style tattoo",
    list_url: "/styles/neotraditional/antonio-gaudi-style-tattoo"
  },
  {
    url: "/styles/neotraditional/ashwin-name-with-heart-and-jupiter-6uqwjv2BQKKoedFyXMP9U8",
    title: "ashwin name with heart and jupiter",
    list_url: "/styles/neotraditional/ashwin-name-with-heart-and-jupiter"
  },
  {
    url: "/styles/neotraditional/balinese-barong-tattoo-Gz8k3HdHxUrwarJ6mJuhVE",
    title: "balinese barong tattoo",
    list_url: "/styles/neotraditional/balinese-barong-tattoo"
  },
  {
    url: "/styles/neotraditional/bible-verse-romans-818-AUJiiNMy7TNtieZ9C28bgV",
    title: "bible verse romans ",
    list_url: "/styles/neotraditional/bible-verse-romans-818"
  },
  {
    url: "/styles/neotraditional/club-dinamo-zagreb-badge-and-lion-7aCg5A4aRhDSNQaQD2Y1q4",
    title: "club dinamo zagreb badge and lion",
    list_url: "/styles/neotraditional/club-dinamo-zagreb-badge-and-lion"
  },
  {
    url: "/styles/neotraditional/daisy-flower-name-stem-being-held-YRgSbyDhiRx5AsAg1rRUUK",
    title: "daisy flower name stem being held",
    list_url: "/styles/neotraditional/daisy-flower-name-stem-being-held"
  },
  {
    url: "/styles/neotraditional/ephesians-320-21-PBMQRxPsxNhpBN1dhZB6BW",
    title: "ephesians ",
    list_url: "/styles/neotraditional/ephesians-320-21"
  },
  {
    url: "/styles/neotraditional/fibromyalgia-Ej9KWM3GjWgcNysz1WYEpD",
    title: "fibromyalgia",
    list_url: "/styles/neotraditional/fibromyalgia"
  },
  {
    url: "/styles/neotraditional/graffiti-of-the-name-samuel-MxijskJJJQfV7VQHGpn2nF",
    title: "graffiti of the name samuel",
    list_url: "/styles/neotraditional/graffiti-of-the-name-samuel"
  },
  {
    url: "/styles/neotraditional/grateful-dead-lightning-bolt-4LjwN7iFNkrfY729YebF4R",
    title: "grateful dead lightning bolt",
    list_url: "/styles/neotraditional/grateful-dead-lightning-bolt"
  },
  {
    url: "/styles/neotraditional/hidden-initials-of-j-w-t-SUEw3spF4YQSKJstLYtJzf",
    title: "hidden initials of j w t",
    list_url: "/styles/neotraditional/hidden-initials-of-j-w-t"
  },
  {
    url: "/styles/neotraditional/homer-simpson-strangling-lisa-and-bart-3tV9U9Vb2eFWBMyo6VrsDx",
    title: "homer simpson strangling lisa and bart",
    list_url: "/styles/neotraditional/homer-simpson-strangling-lisa-and-bart"
  },
  {
    url: "/styles/neotraditional/hxh-phantom-troupe-spider-Sj4MHcEFz49ErGHy55Mp18",
    title: "hxh phantom troupe spider",
    list_url: "/styles/neotraditional/hxh-phantom-troupe-spider"
  },
  {
    url: "/styles/neotraditional/jesus-christ-45XksxGTTJgvvRMhsGpxwW",
    title: "jesus christ",
    list_url: "/styles/neotraditional/jesus-christ"
  },
  {
    url: "/styles/neotraditional/marigold-and-narcissus-shoulder-flowers-U4MzVPjKu4wVq3qUcNFmLM",
    title: "marigold and narcissus shoulder flowers",
    list_url: "/styles/neotraditional/marigold-and-narcissus-shoulder-flowers"
  },
  {
    url: "/styles/neotraditional/marlboro-cigarettes-6fz3T93w3LTERd3BDPkdHF",
    title: "marlboro cigarettes",
    list_url: "/styles/neotraditional/marlboro-cigarettes"
  },
  {
    url: "/styles/neotraditional/millwright-FxJdQyKMtoEWbtkzf1HoHQ",
    title: "millwright",
    list_url: "/styles/neotraditional/millwright"
  },
  {
    url: "/styles/neotraditional/mono-no-aware-Juat9XGnUFr8kqvLVLvWCS",
    title: "mono no aware",
    list_url: "/styles/neotraditional/mono-no-aware"
  },
  {
    url: "/styles/neotraditional/name-anvi-Pwh3em33vnfL4P1Uoi2Yo9",
    title: "name anvi",
    list_url: "/styles/neotraditional/name-anvi"
  },
  {
    url: "/styles/neotraditional/nelson-mandela-mandala-YJGegujiPdo7VRdTGqZX4J",
    title: "nelson mandela mandala",
    list_url: "/styles/neotraditional/nelson-mandela-mandala"
  },
  {
    url: "/styles/neotraditional/odysseus-bow-and-arrow-XgzUX28tdz6YXrFM89PWtS",
    title: "odysseus bow and arrow",
    list_url: "/styles/neotraditional/odysseus-bow-and-arrow"
  },
  {
    url: "/styles/neotraditional/patchwork-tattoos-all-YH1qibWwQDs6euNcvWZ7cw",
    title: "patchwork tattoos all",
    list_url: "/styles/neotraditional/patchwork-tattoos-all"
  },
  {
    url: "/styles/neotraditional/r2-d2-and-c-3po-5z21C3WL33FuipoADfUP5x",
    title: "r d and c po",
    list_url: "/styles/neotraditional/r2-d2-and-c-3po"
  },
  {
    url: "/styles/neotraditional/roman-gladius-style-sword-KAMVS4vN9dsqp8NkPqaGdr",
    title: "roman gladius style sword",
    list_url: "/styles/neotraditional/roman-gladius-style-sword"
  },
  {
    url: "/styles/neotraditional/sailor-jerry-pinup-girl-bikini-Lavya2P8GBoY89Ty4RLAB3",
    title: "sailor jerry pinup girl bikini",
    list_url: "/styles/neotraditional/sailor-jerry-pinup-girl-bikini"
  },
  {
    url: "/styles/neotraditional/spanish-aztec-tribal-fore-arm-sleeve-3RSztPbdGsqXJN215pG4Yn",
    title: "spanish aztec tribal fore arm sleeve",
    list_url: "/styles/neotraditional/spanish-aztec-tribal-fore-arm-sleeve"
  },
  {
    url: "/styles/neotraditional/thc-molecule-structure-with-a-full-HUyJAT1J9tYwZpskXpy3Dd",
    title: "thc molecule structure with a full",
    list_url: "/styles/neotraditional/thc-molecule-structure-with-a-full"
  },
  {
    url: "/styles/neotraditional/the-name-dante-with-hearts-tramp-stamp-4LGacJSMZsCTrebcvw1cZK",
    title: "the name dante with hearts tramp stamp",
    list_url: "/styles/neotraditional/the-name-dante-with-hearts-tramp-stamp"
  },
  {
    url: "/styles/neotraditional/two-eagles-descending-wind-going-MKqFv9NLy8fb5YvrbvoZ8V",
    title: "two eagles descending wind going",
    list_url: "/styles/neotraditional/two-eagles-descending-wind-going"
  },
  {
    url: "/styles/neotraditional/uterine-cancer-ribbon-intertwined-with-TAf49iNT4LRbfS9b6Ztvh6",
    title: "uterine cancer ribbon intertwined with",
    list_url: "/styles/neotraditional/uterine-cancer-ribbon-intertwined-with"
  },
  {
    url: "/styles/neotraditional/witcher-geralt-ciri-silver-sword-HetjNNkQMntWSgmKYRS5Qk",
    title: "witcher geralt ciri silver sword",
    list_url: "/styles/neotraditional/witcher-geralt-ciri-silver-sword"
  },
  {
    url: "/styles/neotraditional/yarkuzar-VhBCdLhHaVtzMYzXb1ifjG",
    title: "yarkuzar",
    list_url: "/styles/neotraditional/yarkuzar"
  },
  {
    url: "/styles/neotraditional/zeta-phi-beta-sorority-FMEhvAoGY2bCAGB8KRrMfQ",
    title: "zeta phi beta sorority",
    list_url: "/styles/neotraditional/zeta-phi-beta-sorority"
  },
  {
    url: "/styles/new-school/gangster-bugs-bunny-8GGm1rJKVTB7jkUMPK4tBv",
    title: "gangster bugs bunny",
    list_url: "/styles/new-school/gangster-bugs-bunny"
  },
  {
    url: "/styles/new-school/litany-against-fear-N39xsrEsTKenyxrCnS6DY8",
    title: "litany against fear",
    list_url: "/styles/new-school/litany-against-fear"
  },
  {
    url: "/styles/new-school/warhammer-chaos-undivided-symbol-DLtfh4qkk2rTZC9YGdRRvA",
    title: "warhammer chaos undivided symbol",
    list_url: "/styles/new-school/warhammer-chaos-undivided-symbol"
  },
  {
    url: "/styles/realism/american-flag-that-says-we-the-people-FpWhRXGzhxqDQBc4ZRzxSn",
    title: "american flag that says we the people",
    list_url: "/styles/realism/american-flag-that-says-we-the-people"
  },
  {
    url: "/styles/realism/angels-and-clouds-8LpUPbsuVken25WCLMPX5L",
    title: "angels and clouds",
    list_url: "/styles/realism/angels-and-clouds"
  },
  {
    url: "/styles/realism/aramaic-yhwh-john-316-jesus-crucified-BK8fmRC4vJRTw1Be8BQeXj",
    title: "aramaic yhwh john jesus crucified",
    list_url: "/styles/realism/aramaic-yhwh-john-316-jesus-crucified"
  },
  {
    url: "/styles/realism/avatar-pandora-QXfw2sSXkEQHBoFCNFPP5K",
    title: "avatar pandora",
    list_url: "/styles/realism/avatar-pandora"
  },
  {
    url: "/styles/realism/back-to-the-future-delorean-QTcsjCLsdPJtEXbhvuEgK2",
    title: "back to the future delorean",
    list_url: "/styles/realism/back-to-the-future-delorean"
  },
  {
    url: "/styles/realism/billy-talent-two-album-logo-with-birds-F6moxi5GCEhnhS2Xy4Hpa9",
    title: "billy talent two album logo with birds",
    list_url: "/styles/realism/billy-talent-two-album-logo-with-birds"
  },
  {
    url: "/styles/realism/castor-and-pollux-9tbxrxvYA58HZEDSfQgvF3",
    title: "castor and pollux",
    list_url: "/styles/realism/castor-and-pollux"
  },
  {
    url: "/styles/realism/daffodil-and-lily-of-the-valley-bouquet-XraTznhb7uGUKCigDMny7L",
    title: "daffodil and lily of the valley bouquet",
    list_url: "/styles/realism/daffodil-and-lily-of-the-valley-bouquet"
  },
  {
    url: "/styles/realism/dragon-and-butterfly-ELGZbKgwTGSkvcyY82AHu4",
    title: "dragon and butterfly",
    list_url: "/styles/realism/dragon-and-butterfly"
  },
  {
    url: "/styles/realism/dragon-and-moon-and-sun-YSgPpnNtZt3ir4vCQGX6WP",
    title: "dragon and moon and sun",
    list_url: "/styles/realism/dragon-and-moon-and-sun"
  },
  {
    url: "/styles/realism/filipino-tribal-arm-sleeve-pangasinan-HAqGSnyhKsorxK5gijfkpH",
    title: "filipino tribal arm sleeve pangasinan",
    list_url: "/styles/realism/filipino-tribal-arm-sleeve-pangasinan"
  },
  {
    url: "/styles/realism/folded-american-flag-Ef8YU5BbewMj3ZpfbK48",
    title: "folded american flag",
    list_url: "/styles/realism/folded-american-flag"
  },
  {
    url: "/styles/realism/hands-holding-3-baby-angels-GFxv4CnJxBuc4wCGnfkCBk",
    title: "hands holding baby angels",
    list_url: "/styles/realism/hands-holding-3-baby-angels"
  },
  {
    url: "/styles/realism/hooligans-4DazuTSaAmqSZPCA4bQpi9",
    title: "hooligans",
    list_url: "/styles/realism/hooligans"
  },
  {
    url: "/styles/realism/kkvsh-long-tongue-2f4fffdU6UuPUiteFZbhK8",
    title: "kkvsh long tongue",
    list_url: "/styles/realism/kkvsh-long-tongue"
  },
  {
    url: "/styles/realism/lady-blowing-kiss-UUCe3PTMguWYSMfyzb13d5",
    title: "lady blowing kiss",
    list_url: "/styles/realism/lady-blowing-kiss"
  },
  {
    url: "/styles/realism/lotus-flower-tummy-tuck-wkD1YNFabQmdGUCnBg25B",
    title: "lotus flower tummy tuck",
    list_url: "/styles/realism/lotus-flower-tummy-tuck"
  },
  {
    url: "/styles/realism/mami-wata-7y8Mm9Exjx35rhbnd18oQn",
    title: "mami wata",
    list_url: "/styles/realism/mami-wata"
  },
  {
    url: "/styles/realism/millipede-vdkEk1Hvx7AtvZBEjLsYT",
    title: "millipede",
    list_url: "/styles/realism/millipede"
  },
  {
    url: "/styles/realism/mona-lisa-Ft3dgtTA5Dpz4RvB8RoaEQ",
    title: "mona lisa",
    list_url: "/styles/realism/mona-lisa"
  },
  {
    url: "/styles/realism/money-bag-words-rags-to-riches-61GsKcTzuzoffeAR3mvgS3",
    title: "money bag words rags to riches",
    list_url: "/styles/realism/money-bag-words-rags-to-riches"
  },
  {
    url: "/styles/realism/name-tattoo-of-vaani-devish-and-chetna-JQq6xdyAxyARJUPGDmZdmQ",
    title: "name tattoo of vaani devish and chetna",
    list_url: "/styles/realism/name-tattoo-of-vaani-devish-and-chetna"
  },
  {
    url: "/styles/realism/nephilim-CWMt7wWURysBGKjVKUndKN",
    title: "nephilim",
    list_url: "/styles/realism/nephilim"
  },
  {
    url: "/styles/realism/never-fold-never-back-down-NEvzZzQc2UBcU7Kn6fpwoh",
    title: "never fold never back down",
    list_url: "/styles/realism/never-fold-never-back-down"
  },
  {
    url: "/styles/realism/omerta-HrRyz2fohVJuyZPwdrWEFA",
    title: "omerta",
    list_url: "/styles/realism/omerta"
  },
  {
    url: "/styles/realism/owl-in-neck-CZcWkpaPSUtysATaKBTweM",
    title: "owl in neck",
    list_url: "/styles/realism/owl-in-neck"
  },
  {
    url: "/styles/realism/praying-hands-with-roses-CNozbK95iN11s1gundWvDX",
    title: "praying hands with roses",
    list_url: "/styles/realism/praying-hands-with-roses"
  },
  {
    url: "/styles/realism/san-judas-tadeo-and-virgen-of-guadalupe-ULjzQBoEw5a4hPxHFNSfBT",
    title: "san judas tadeo and virgen of guadalupe",
    list_url: "/styles/realism/san-judas-tadeo-and-virgen-of-guadalupe"
  },
  {
    url: "/styles/realism/thor-mjolnir-marvel-arm-sleeve-XNDbJiq56f8WD9NW3cdaZH",
    title: "thor mjolnir marvel arm sleeve",
    list_url: "/styles/realism/thor-mjolnir-marvel-arm-sleeve"
  },
  {
    url: "/styles/realism/tree-of-life-on-fire-burning-ApirjbLaa9H5nA8jm57Ayv",
    title: "tree of life on fire burning",
    list_url: "/styles/realism/tree-of-life-on-fire-burning"
  },
  {
    url: "/styles/realism/tsukuyomi-amaterasu-susanoo-VNu2ErT5BafZj5x3B8KGAJ",
    title: "tsukuyomi amaterasu susanoo",
    list_url: "/styles/realism/tsukuyomi-amaterasu-susanoo"
  },
  {
    url: "/styles/sketch/deer-antler-with-flowers-C99uswwNqoQHNoQCzgQyws",
    title: "deer antler with flowers",
    list_url: "/styles/sketch/deer-antler-with-flowers"
  },
  {
    url: "/styles/sketch/devil-girl-rolling-eyes-looking-PTxHUruFd8PUdqHcXoh3X4",
    title: "devil girl rolling eyes looking",
    list_url: "/styles/sketch/devil-girl-rolling-eyes-looking"
  },
  {
    url: "/styles/sketch/dum-dum-lollipop-Ai96VgZKJQTLXYmEV6YnJb",
    title: "dum dum lollipop",
    list_url: "/styles/sketch/dum-dum-lollipop"
  },
  {
    url: "/styles/sketch/enchanted-forest-DTnodmp8jMnvMy4A1onZZf",
    title: "enchanted forest",
    list_url: "/styles/sketch/enchanted-forest"
  },
  {
    url: "/styles/sketch/phoenix-heart-6GbL6dusgQjgDfwyacMe9C",
    title: "phoenix heart",
    list_url: "/styles/sketch/phoenix-heart"
  },
  {
    url: "/styles/sketch/sleeve-with-the-name-of-prachi-U59CFd68EDKHuvM47okkTy",
    title: "sleeve with the name of prachi",
    list_url: "/styles/sketch/sleeve-with-the-name-of-prachi"
  },
  {
    url: "/styles/sketch/teddy-bear-with-bow-around-neck-HkxNCtYKe8Kir4d1EZgYJE",
    title: "teddy bear with bow around neck",
    list_url: "/styles/sketch/teddy-bear-with-bow-around-neck"
  },
  {
    url: "/styles/sketch/zombie-from-the-grave-DtVb4KgaYBbGRXWGfdhu7L",
    title: "zombie from the grave",
    list_url: "/styles/sketch/zombie-from-the-grave"
  },
  {
    url: "/styles/stencil/ace-card-and-jack-card-top-edge-on-fire-24NYZF8XQsmADXLWeXTX5G",
    title: "ace card and jack card top edge on fire",
    list_url: "/styles/stencil/ace-card-and-jack-card-top-edge-on-fire"
  },
  {
    url: "/styles/surrealism/jesus-waiting-at-the-gates-of-heaven-Zc6MquH8BWo85SvjNrZkZ",
    title: "jesus waiting at the gates of heaven",
    list_url: "/styles/surrealism/jesus-waiting-at-the-gates-of-heaven"
  },
  {
    url: "/styles/surrealism/thyroid-cancer-and-breast-cancer-ribbon-2dSDBC8yZ7B8v5ERF9N5Xi",
    title: "thyroid cancer and breast cancer ribbon",
    list_url: "/styles/surrealism/thyroid-cancer-and-breast-cancer-ribbon"
  },
  {
    url: "/styles/traditional/a-wolf-wearing-a-steampunk-top-hat-and-7pVCgpj7f8czuDi3SvVpv",
    title: "a wolf wearing a steampunk top hat and",
    list_url: "/styles/traditional/a-wolf-wearing-a-steampunk-top-hat-and"
  },
  {
    url: "/styles/traditional/atta-deep-bhava-8EyTSC5kyFJG7J5N562gwe",
    title: "atta deep bhava",
    list_url: "/styles/traditional/atta-deep-bhava"
  },
  {
    url: "/styles/traditional/d20-dice-laugh-now-cry-later-7ALSYipVo6R6qgBFLF9kLD",
    title: "d dice laugh now cry later",
    list_url: "/styles/traditional/d20-dice-laugh-now-cry-later"
  },
  {
    url: "/styles/traditional/inquilab-zindabad-PSb6CRS5kCXNVXJm3P5CkC",
    title: "inquilab zindabad",
    list_url: "/styles/traditional/inquilab-zindabad"
  },
  {
    url: "/styles/traditional/maribel-372BAwUtmh89CPcf6qT6bt",
    title: "maribel",
    list_url: "/styles/traditional/maribel"
  },
  {
    url: "/styles/traditional/mountain-with-clouds-VRP9zhLtT1K6JMat7sF9Cy",
    title: "mountain with clouds",
    list_url: "/styles/traditional/mountain-with-clouds"
  },
  {
    url: "/styles/traditional/paul-bunyan-and-babe-the-blue-ox-XZDRYnJhq7mL3DnhQmfQxN",
    title: "paul bunyan and babe the blue ox",
    list_url: "/styles/traditional/paul-bunyan-and-babe-the-blue-ox"
  },
  {
    url: "/styles/traditional/rhea-ripley-wwe-with-horns-licking-skull-KnaVB6yUK4BpeGPPSefF4K",
    title: "rhea ripley wwe with horns licking skull",
    list_url: "/styles/traditional/rhea-ripley-wwe-with-horns-licking-skull"
  },
  {
    url: "/styles/traditional/rooted-in-christ-RD4AB6LjvprfLYLBG2fhc8",
    title: "rooted in christ",
    list_url: "/styles/traditional/rooted-in-christ"
  },
  {
    url: "/styles/traditional/the-letter-c-with-a-crown-reference-UbRz4DJQnrmdPdcagUZp11",
    title: "the letter c with a crown reference",
    list_url: "/styles/traditional/the-letter-c-with-a-crown-reference"
  },
  {
    url: "/styles/traditional/trisomy-21-FjiNmoHs5Dw9NnjhfTWK22",
    title: "trisomy ",
    list_url: "/styles/traditional/trisomy-21"
  },
  {
    url: "/styles/traditional/vladimir-putin-GU5MMSMbMMDFS6mjgSu7bV",
    title: "vladimir putin",
    list_url: "/styles/traditional/vladimir-putin"
  },
  {
    url: "/styles/traditional/white-hawthorn-blossom-with-honey-bee-6TiKzD5V7DpRVanjBgAku",
    title: "white hawthorn blossom with honey bee",
    list_url: "/styles/traditional/white-hawthorn-blossom-with-honey-bee"
  },
  {
    url: "/styles/traditional/woman-with-a-hijab-and-niqab-with-U5AASMidUkGLPdzZ7JpGsG",
    title: "woman with a hijab and niqab with",
    list_url: "/styles/traditional/woman-with-a-hijab-and-niqab-with"
  },
  {
    url: "/styles/trash-polka/the-rebellion-sword-from-devil-may-cry-ABi9Uut9zMoxw2eYrfn2Z6",
    title: "the rebellion sword from devil may cry",
    list_url: "/styles/trash-polka/the-rebellion-sword-from-devil-may-cry"
  },
  {
    url: "/styles/tribal/arise-E3E94z9jho7jevFoeobowY",
    title: "arise",
    list_url: "/styles/tribal/arise"
  },
  {
    url: "/styles/tribal/kinky-tattoo-for-lower-back-EhfaPGa5KbzZgzPg9nt8go",
    title: "kinky tattoo for lower back",
    list_url: "/styles/tribal/kinky-tattoo-for-lower-back"
  },
  {
    url: "/styles/anime/anime-eyes-in-a-japanese-style-rectangle-9U2DDxmnGMb8aZTntW2AtF",
    title: "anime eyes in a japanese style rectangle",
    list_url: "/styles/anime/anime-eyes-in-a-japanese-style-rectangle"
  },
  {
    url: "/styles/anime/hand-and-finger-tattoos-NAJTzxZY43Vbrd7V14u9iq",
    title: "hand and finger tattoos",
    list_url: "/styles/anime/hand-and-finger-tattoos"
  },
  {
    url: "/styles/anime/juuzou-suzuya-7ZEtYtSN9G7qYDeruQJgZs",
    title: "juuzou suzuya",
    list_url: "/styles/anime/juuzou-suzuya"
  },
  {
    url: "/styles/anime/waifu-ahegao-face-Q2d3xVhiCsX92hNwnijxSR",
    title: "waifu ahegao face",
    list_url: "/styles/anime/waifu-ahegao-face"
  },
  {
    url: "/styles/black-grey/1percenter-biker-HyeddQi2hMDZnxLKeeQW6u",
    title: " percenter biker",
    list_url: "/styles/black-grey/1percenter-biker"
  },
  {
    url: "/styles/black-grey/2006-roman-numerals-9EzFAYR8vNCvNxAQTirnHm",
    title: " roman numerals",
    list_url: "/styles/black-grey/2006-roman-numerals"
  },
  {
    url: "/styles/black-grey/a-detailed-portrait-of-king-richard-Vf8zAjJJTt6Pkd5vSbHa4A",
    title: "a detailed portrait of king richard",
    list_url: "/styles/black-grey/a-detailed-portrait-of-king-richard"
  },
  {
    url: "/styles/black-grey/a-dog-chasing-a-rabbit-AvkneYScZ1AvQXQjzyGgCx",
    title: "a dog chasing a rabbit",
    list_url: "/styles/black-grey/a-dog-chasing-a-rabbit"
  },
  {
    url: "/styles/black-grey/a-forearm-tattoo-with-an-angel-praying-UUjQhxf8irj7iDCZDGV94a",
    title: "a forearm tattoo with an angel praying",
    list_url: "/styles/black-grey/a-forearm-tattoo-with-an-angel-praying"
  },
  {
    url: "/styles/black-grey/a-silhouette-of-a-soldier-kneeling-in-W78RhLKMdzdQ76zyCtpb25",
    title: "a silhouette of a soldier kneeling in",
    list_url: "/styles/black-grey/a-silhouette-of-a-soldier-kneeling-in"
  },
  {
    url: "/styles/black-grey/american-flag-we-the-people-written-in-54KVxNWKafcTpQgTkkrkx4",
    title: "american flag we the people written in",
    list_url: "/styles/black-grey/american-flag-we-the-people-written-in"
  },
  {
    url: "/styles/black-grey/angel-numbers-444-888-222-MDB73hpJQdTHivmQdZ26Wz",
    title: "angel numbers ",
    list_url: "/styles/black-grey/angel-numbers-444-888-222"
  },
  {
    url: "/styles/black-grey/angry-male-butterfly-3YZunMR3Q3q79uR8426a14",
    title: "angry male butterfly",
    list_url: "/styles/black-grey/angry-male-butterfly"
  },
  {
    url: "/styles/black-grey/anushka-Pfb7TYsDxFMG37oafs8rmA",
    title: "anushka",
    list_url: "/styles/black-grey/anushka"
  },
  {
    url: "/styles/black-grey/ark-of-the-covenant-3921ngc8brDocx5SCEJ6AE",
    title: "ark of the covenant",
    list_url: "/styles/black-grey/ark-of-the-covenant"
  },
  {
    url: "/styles/black-grey/arsenal-fc-be1iwreAzcYpzZxBDX1mM",
    title: "arsenal fc",
    list_url: "/styles/black-grey/arsenal-fc"
  },
  {
    url: "/styles/black-grey/background-map-of-iran-and-persian-gulf-JZh9yGPMdrHw9ru3edHWvh",
    title: "background map of iran and persian gulf",
    list_url: "/styles/black-grey/background-map-of-iran-and-persian-gulf"
  },
  {
    url: "/styles/black-grey/baltimore-city-skyline-HXDTqJ82tRv6qFHf96eFPC",
    title: "baltimore city skyline",
    list_url: "/styles/black-grey/baltimore-city-skyline"
  },
  {
    url: "/styles/black-grey/bella-name-tatoo-design-UjfK74YciB4yWSWEnYZ7Dd",
    title: "bella name tatoo design",
    list_url: "/styles/black-grey/bella-name-tatoo-design"
  },
  {
    url: "/styles/black-grey/bird-alondra-WpMUvtrG595b7tPLZGEgff",
    title: "bird alondra",
    list_url: "/styles/black-grey/bird-alondra"
  },
  {
    url: "/styles/black-grey/black-and-white-kid-buu-dragon-ball-6cVUTopg6L33eboa82gmvs",
    title: "black and white kid buu dragon ball",
    list_url: "/styles/black-grey/black-and-white-kid-buu-dragon-ball"
  },
  {
    url: "/styles/black-grey/bleeding-heart-XqbvWbjQW4fnCu134YMMys",
    title: "bleeding heart",
    list_url: "/styles/black-grey/bleeding-heart"
  },
  {
    url: "/styles/black-grey/bugs-bunny-gangster-tattoo-design-BhwY3RTnCQSsffBMjshQT4",
    title: "bugs bunny gangster tattoo design",
    list_url: "/styles/black-grey/bugs-bunny-gangster-tattoo-design"
  },
  {
    url: "/styles/black-grey/butterfly-sleeve-WNkNy2UpP8uGG8rS2Ey7zo",
    title: "butterfly sleeve",
    list_url: "/styles/black-grey/butterfly-sleeve"
  },
  {
    url: "/styles/black-grey/calling-death-9Zoywkne3haqkmg1XHN8SE",
    title: "calling death",
    list_url: "/styles/black-grey/calling-death"
  },
  {
    url: "/styles/black-grey/cancer-zodiac-sign-and-chinese-zodiac-MbDSbtAwRtztxMii25oXBg",
    title: "cancer zodiac sign and chinese zodiac",
    list_url: "/styles/black-grey/cancer-zodiac-sign-and-chinese-zodiac"
  },
  {
    url: "/styles/black-grey/chapo-guzman-S6zatayrJdySPbg14p7wMQ",
    title: "chapo guzman",
    list_url: "/styles/black-grey/chapo-guzman"
  },
  {
    url: "/styles/black-grey/chicano-clown-laugh-now-cry-later-KLkfABbvhJLA2MJvW8K4kP",
    title: "chicano clown laugh now cry later",
    list_url: "/styles/black-grey/chicano-clown-laugh-now-cry-later"
  },
  {
    url: "/styles/black-grey/chinese-lantern-3iPuCNrQ9SHgRd1CTkCvci",
    title: "chinese lantern",
    list_url: "/styles/black-grey/chinese-lantern"
  },
  {
    url: "/styles/black-grey/chola-payaso-D3ZZDce8Cy8rkDL29DJYJC",
    title: "chola payaso",
    list_url: "/styles/black-grey/chola-payaso"
  },
  {
    url: "/styles/black-grey/clitoris-KAhMJ5KxA2jhWrf7bLy92R",
    title: "clitoris",
    list_url: "/styles/black-grey/clitoris"
  },
  {
    url: "/styles/black-grey/clouds-with-cross-and-rays-of-sun-E6yoWcEQYn4HHAo3r97b8H",
    title: "clouds with cross and rays of sun",
    list_url: "/styles/black-grey/clouds-with-cross-and-rays-of-sun"
  },
  {
    url: "/styles/black-grey/comparison-is-the-thief-of-joy-VUh9mjothmycPd3Yx7tqpU",
    title: "comparison is the thief of joy",
    list_url: "/styles/black-grey/comparison-is-the-thief-of-joy"
  },
  {
    url: "/styles/black-grey/cross-tattoo-in-thigh-for-men-with-Lcf8z6AkKSXfS4txPkkW1K",
    title: "cross tattoo in thigh for men with",
    list_url: "/styles/black-grey/cross-tattoo-in-thigh-for-men-with"
  },
  {
    url: "/styles/black-grey/cross-with-poison-tree-and-bible-verse-8iBn2DajoECsNvZECcKng8",
    title: "cross with poison tree and bible verse",
    list_url: "/styles/black-grey/cross-with-poison-tree-and-bible-verse"
  },
  {
    url: "/styles/black-grey/cross-with-proverbs-35-6-FcqGV4WkaykrTK3TNTiSEK",
    title: "cross with proverbs ",
    list_url: "/styles/black-grey/cross-with-proverbs-35-6"
  },
  {
    url: "/styles/black-grey/cross-with-rosary-wrapped-around-it-P7w5YLTwD6gJu7fPncZbny",
    title: "cross with rosary wrapped around it",
    list_url: "/styles/black-grey/cross-with-rosary-wrapped-around-it"
  },
  {
    url: "/styles/black-grey/crow-sitting-atop-a-dagger-WBRYCBB3H1Frw5Spzu1cv1",
    title: "crow sitting atop a dagger",
    list_url: "/styles/black-grey/crow-sitting-atop-a-dagger"
  },
  {
    url: "/styles/black-grey/crown-of-thorns-gothic-around-elbow-2eQGaFmJBhE5ajdG83uSfy",
    title: "crown of thorns gothic around elbow",
    list_url: "/styles/black-grey/crown-of-thorns-gothic-around-elbow"
  },
  {
    url: "/styles/black-grey/cupid-boy-with-money-bag-and-fire-Gjw5nK7S9gdhWNtqwFzwBc",
    title: "cupid boy with money bag and fire",
    list_url: "/styles/black-grey/cupid-boy-with-money-bag-and-fire"
  },
  {
    url: "/styles/black-grey/cybersigilism-back-tokyo-ghoul-black-NFFfLjKnUpKe59i49VrriY",
    title: "cybersigilism back tokyo ghoul black",
    list_url: "/styles/black-grey/cybersigilism-back-tokyo-ghoul-black"
  },
  {
    url: "/styles/black-grey/daisy-with-butterfly-UXeG29CrjJoaXNwzqnGdz9",
    title: "daisy with butterfly",
    list_url: "/styles/black-grey/daisy-with-butterfly"
  },
  {
    url: "/styles/black-grey/daniel-and-the-lions-den-6f7fXuth4Rk9fAGGg8TjWM",
    title: "daniel and the lions den",
    list_url: "/styles/black-grey/daniel-and-the-lions-den"
  },
  {
    url: "/styles/black-grey/day-of-the-dead-bride-and-groom-VUsd4xxaiwrSvGmJtSy3Lj",
    title: "day of the dead bride and groom",
    list_url: "/styles/black-grey/day-of-the-dead-bride-and-groom"
  },
  {
    url: "/styles/black-grey/dead-tree-and-crows-3QG4Wk5cMp84WFTgJuGjAE",
    title: "dead tree and crows",
    list_url: "/styles/black-grey/dead-tree-and-crows"
  },
  {
    url: "/styles/black-grey/deception-it-symbolizes-the-act-Jyf7QyBXR3zTNoye7H54gD",
    title: "deception it symbolizes the act",
    list_url: "/styles/black-grey/deception-it-symbolizes-the-act"
  },
  {
    url: "/styles/black-grey/demon-hand-hand-silhouette-G5cUzCgmibZrFUyxQdKzY4",
    title: "demon hand hand silhouette",
    list_url: "/styles/black-grey/demon-hand-hand-silhouette"
  },
  {
    url: "/styles/black-grey/dog-holding-machine-gun-and-money-5CyvBbVAZuqcemN7ZApbSC",
    title: "dog holding machine gun and money",
    list_url: "/styles/black-grey/dog-holding-machine-gun-and-money"
  },
  {
    url: "/styles/black-grey/evil-eye-compass-horizontal-sternum-S5PwQpzw3Sp5Aw3BPqwZVe",
    title: "evil eye compass horizontal sternum",
    list_url: "/styles/black-grey/evil-eye-compass-horizontal-sternum"
  },
  {
    url: "/styles/black-grey/filler-tattoos-king-and-queen-smoke-8nFq1FqYfey77JarfdaDAu",
    title: "filler tattoos king and queen smoke",
    list_url: "/styles/black-grey/filler-tattoos-king-and-queen-smoke"
  },
  {
    url: "/styles/black-grey/finger-over-mouth-silence-whisper-shush-9Cv4q7qMM5Gvz6SgnDMkLB",
    title: "finger over mouth silence whisper shush",
    list_url: "/styles/black-grey/finger-over-mouth-silence-whisper-shush"
  },
  {
    url: "/styles/black-grey/firefighter-ems-tattoos-NrE7HHHVrorzxJweyzLAmr",
    title: "firefighter ems tattoos",
    list_url: "/styles/black-grey/firefighter-ems-tattoos"
  },
  {
    url: "/styles/black-grey/fiza-letter-HYcQTp6Bbkd7cZBpK22CTC",
    title: "fiza letter",
    list_url: "/styles/black-grey/fiza-letter"
  },
  {
    url: "/styles/black-grey/fl-studio-daw-KBaRfwwHku8WHDZRi3f3HC",
    title: "fl studio daw",
    list_url: "/styles/black-grey/fl-studio-daw"
  },
  {
    url: "/styles/black-grey/flowers-of-evil-5VcKJHYf86XfqUHXd6KFg",
    title: "flowers of evil",
    list_url: "/styles/black-grey/flowers-of-evil"
  },
  {
    url: "/styles/black-grey/forest-and-nature-arm-sleeve-QeB4tYpqi181Hxbae9EX4Q",
    title: "forest and nature arm sleeve",
    list_url: "/styles/black-grey/forest-and-nature-arm-sleeve"
  },
  {
    url: "/styles/black-grey/full-sleeve-tattoo-based-on-gambling-67mSPuToZHVwfYjr3bZ2Nr",
    title: "full sleeve tattoo based on gambling",
    list_url: "/styles/black-grey/full-sleeve-tattoo-based-on-gambling"
  },
  {
    url: "/styles/black-grey/gangster-style-money-bag-PQae8VqM1CdetJWAAeedkp",
    title: "gangster style money bag",
    list_url: "/styles/black-grey/gangster-style-money-bag"
  },
  {
    url: "/styles/black-grey/gangster-wile-e-coyote-roadrunner-EzJMZVDF1z43npkdrg5JX2",
    title: "gangster wile e coyote roadrunner",
    list_url: "/styles/black-grey/gangster-wile-e-coyote-roadrunner"
  },
  {
    url: "/styles/black-grey/get-low-asshole-VkJyrbPfs8PgWPb1xrMEnj",
    title: "get low asshole",
    list_url: "/styles/black-grey/get-low-asshole"
  },
  {
    url: "/styles/black-grey/gladiator-shoulder-plate-armor-PXHYpMXp5DNWuVxSSwhWQL",
    title: "gladiator shoulder plate armor",
    list_url: "/styles/black-grey/gladiator-shoulder-plate-armor"
  },
  {
    url: "/styles/black-grey/grey-lionhead-rabbit-with-small-6Ad5nT77WCrbZQHQfvEwSQ",
    title: "grey lionhead rabbit with small",
    list_url: "/styles/black-grey/grey-lionhead-rabbit-with-small"
  },
  {
    url: "/styles/black-grey/grim-reaper-sitting-on-throne-of-skulls-EK6uWQVq8jfyfaZvaKzu8P",
    title: "grim reaper sitting on throne of skulls",
    list_url: "/styles/black-grey/grim-reaper-sitting-on-throne-of-skulls"
  },
  {
    url: "/styles/black-grey/guam-seal-CehgeS1QhtW9suJtR2cS6e",
    title: "guam seal",
    list_url: "/styles/black-grey/guam-seal"
  },
  {
    url: "/styles/black-grey/half-medusa-half-lion-face-morphing-RpB9pX5sj5M7SdmtZK6yHe",
    title: "half medusa half lion face morphing",
    list_url: "/styles/black-grey/half-medusa-half-lion-face-morphing"
  },
  {
    url: "/styles/black-grey/half-woman-face-half-skull-face-tattoo-KoXE1Xioqs9r6VMxwRwrvw",
    title: "half woman face half skull face tattoo",
    list_url: "/styles/black-grey/half-woman-face-half-skull-face-tattoo"
  },
  {
    url: "/styles/black-grey/hanyamas-tattoo-28rgyg2p6f7gN59mJRvckG",
    title: "hanyamas tattoo",
    list_url: "/styles/black-grey/hanyamas-tattoo"
  },
  {
    url: "/styles/black-grey/hummingbird-and-a-catalina-flower-F2Q4DqjaAS9BBHF2XwCzkW",
    title: "hummingbird and a catalina flower",
    list_url: "/styles/black-grey/hummingbird-and-a-catalina-flower"
  },
  {
    url: "/styles/black-grey/i-am-inimitable-i-am-on-original-being-4mjLYNnUu61HsutTwz9oUy",
    title: "i am inimitable i am on original being",
    list_url: "/styles/black-grey/i-am-inimitable-i-am-on-original-being"
  },
  {
    url: "/styles/black-grey/inner-bicep-greek-theme-CnMeF9RJgUCZiXScq74VP3",
    title: "inner bicep greek theme",
    list_url: "/styles/black-grey/inner-bicep-greek-theme"
  },
  {
    url: "/styles/black-grey/jatt-dont-care-written-QpwXsjyGKyH35oVPSn7MVD",
    title: "jatt dont care written",
    list_url: "/styles/black-grey/jatt-dont-care-written"
  },
  {
    url: "/styles/black-grey/jesus-calming-the-storm-on-the-boat-63HqLCNYS99UAkBFZJDzC1",
    title: "jesus calming the storm on the boat",
    list_url: "/styles/black-grey/jesus-calming-the-storm-on-the-boat"
  },
  {
    url: "/styles/black-grey/jesus-side-profile-in-the-clouds-BGFgGjUkeJN7gbnVAavcV6",
    title: "jesus side profile in the clouds",
    list_url: "/styles/black-grey/jesus-side-profile-in-the-clouds"
  },
  {
    url: "/styles/black-grey/jojo-jesus-christ-EE23VcM38whWuoJAwCQSyS",
    title: "jojo jesus christ",
    list_url: "/styles/black-grey/jojo-jesus-christ"
  },
  {
    url: "/styles/black-grey/joker-heath-ledger-62hH2g1JaPgf2BRsfMfXCM",
    title: "joker heath ledger",
    list_url: "/styles/black-grey/joker-heath-ledger"
  },
  {
    url: "/styles/black-grey/koi-fish-tattoos-koi-fish-tattoos-koi-5v5foDosansCtD5igW1GqC",
    title: "koi fish tattoos koi fish tattoos koi",
    list_url: "/styles/black-grey/koi-fish-tattoos-koi-fish-tattoos-koi"
  },
  {
    url: "/styles/black-grey/laughing-buddha-with-money-YK254Tu5be8fUdwtr3DEFm",
    title: "laughing buddha with money",
    list_url: "/styles/black-grey/laughing-buddha-with-money"
  },
  {
    url: "/styles/black-grey/letter-s-letter-e-letter-i-XgtJ8SUFbn8kBzzbUuroGH",
    title: "letter s letter e letter i",
    list_url: "/styles/black-grey/letter-s-letter-e-letter-i"
  },
  {
    url: "/styles/black-grey/letter-v-with-a-heart-KPTBATEDrx5dtRkRFHkUUA",
    title: "letter v with a heart",
    list_url: "/styles/black-grey/letter-v-with-a-heart"
  },
  {
    url: "/styles/black-grey/libera-anima-vestra-5fLR2rorw5NbeXrjhY6d5w",
    title: "libera anima vestra",
    list_url: "/styles/black-grey/libera-anima-vestra"
  },
  {
    url: "/styles/black-grey/lighthouse-with-waves-crashing-qh3QWYW5pybrGDF8hpJju",
    title: "lighthouse with waves crashing",
    list_url: "/styles/black-grey/lighthouse-with-waves-crashing"
  },
  {
    url: "/styles/black-grey/lola-bunny-with-a-bag-of-money-2KyHfRJy3Pcr97wkzWtVAR",
    title: "lola bunny with a bag of money",
    list_url: "/styles/black-grey/lola-bunny-with-a-bag-of-money"
  },
  {
    url: "/styles/black-grey/long-story-short-i-survived-LadmnAoucEwHjeEak7bgE1",
    title: "long story short i survived",
    list_url: "/styles/black-grey/long-story-short-i-survived"
  },
  {
    url: "/styles/black-grey/lord-shiva-and-my-name-mayank-ocaz2XopZgKteGRb44hHC",
    title: "lord shiva and my name mayank",
    list_url: "/styles/black-grey/lord-shiva-and-my-name-mayank"
  },
  {
    url: "/styles/black-grey/luctor-et-emergo-CazX4WkLvwAkopFjj8QoLr",
    title: "luctor et emergo",
    list_url: "/styles/black-grey/luctor-et-emergo"
  },
  {
    url: "/styles/black-grey/luke-2343-bible-verse-with-3-crosses-NfJMUhRW4pQX6ad9HDCRcJ",
    title: "luke bible verse with crosses",
    list_url: "/styles/black-grey/luke-2343-bible-verse-with-3-crosses"
  },
  {
    url: "/styles/black-grey/mark-923-bible-verse-XmMaX5fYA5x9ThiruBar37",
    title: "mark bible verse",
    list_url: "/styles/black-grey/mark-923-bible-verse"
  },
  {
    url: "/styles/black-grey/masonic-anchor-with-cross-top-HXnsy97zggrmrWjwCrhG2U",
    title: "masonic anchor with cross top",
    list_url: "/styles/black-grey/masonic-anchor-with-cross-top"
  },
  {
    url: "/styles/black-grey/may-my-mercy-prevail-my-wrath-with-a-VEJDnnZmN27AsjTdntdvX8",
    title: "may my mercy prevail my wrath with a",
    list_url: "/styles/black-grey/may-my-mercy-prevail-my-wrath-with-a"
  },
  {
    url: "/styles/black-grey/maybach-logo-with-smoke-rising-4syWoX3FpJgp5ALgo2uDyg",
    title: "maybach logo with smoke rising",
    list_url: "/styles/black-grey/maybach-logo-with-smoke-rising"
  },
  {
    url: "/styles/black-grey/medusa-leg-sleeve-snakes-wrapped-JF6SjG1jPBrxi14XBoW9LE",
    title: "medusa leg sleeve snakes wrapped",
    list_url: "/styles/black-grey/medusa-leg-sleeve-snakes-wrapped"
  },
  {
    url: "/styles/black-grey/mona-name-incorporated-MhDM7KKrb9AuTsNHL8j2TB",
    title: "mona name incorporated",
    list_url: "/styles/black-grey/mona-name-incorporated"
  },
  {
    url: "/styles/black-grey/money-over-bitches-TRyo2NN7uin4Cv68eoFWYS",
    title: "money over bitches",
    list_url: "/styles/black-grey/money-over-bitches"
  },
  {
    url: "/styles/black-grey/moon-half-lion-half-woman-eyes-with-FwfZpNGeqkxMzG8V76TwrE",
    title: "moon half lion half woman eyes with",
    list_url: "/styles/black-grey/moon-half-lion-half-woman-eyes-with"
  },
  {
    url: "/styles/black-grey/music-notes-sleeve-TUF4prahiq87Js2whguS6p",
    title: "music notes sleeve",
    list_url: "/styles/black-grey/music-notes-sleeve"
  },
  {
    url: "/styles/black-grey/name-archita-with-rose-growing-GXTY6tekd5z4VyocmTdUqi",
    title: "name archita with rose growing",
    list_url: "/styles/black-grey/name-archita-with-rose-growing"
  },
  {
    url: "/styles/black-grey/name-brittany-in-cursive-writing-with-2daw6YxmoR3sfb57g6xEiY",
    title: "name brittany in cursive writing with",
    list_url: "/styles/black-grey/name-brittany-in-cursive-writing-with"
  },
  {
    url: "/styles/black-grey/name-harshad-VoDbaxLjLaBxUrN4bnp6oP",
    title: "name harshad",
    list_url: "/styles/black-grey/name-harshad"
  },
  {
    url: "/styles/black-grey/name-julia-in-the-form-of-a-key-EUSBrr5BiLhxFGFC13vP56",
    title: "name julia in the form of a key",
    list_url: "/styles/black-grey/name-julia-in-the-form-of-a-key"
  },
  {
    url: "/styles/black-grey/name-tattoo-kj-HqRFXKD1ny1rexUnZGmjXu",
    title: "name tattoo kj",
    list_url: "/styles/black-grey/name-tattoo-kj"
  },
  {
    url: "/styles/black-grey/name-tracy-written-NGEL9dxBmc6Pw8arkDCnFw",
    title: "name tracy written",
    list_url: "/styles/black-grey/name-tracy-written"
  },
  {
    url: "/styles/black-grey/neck-tattoo-rose-with-stem-thorns-add-Z9XrfrBav8MXZBZECVmTS",
    title: "neck tattoo rose with stem thorns add",
    list_url: "/styles/black-grey/neck-tattoo-rose-with-stem-thorns-add"
  },
  {
    url: "/styles/black-grey/new-york-theme-leg-sleeve-realism-7nHf9ULmUtWDQN3LvS8LW7",
    title: "new york theme leg sleeve realism",
    list_url: "/styles/black-grey/new-york-theme-leg-sleeve-realism"
  },
  {
    url: "/styles/black-grey/no-retreat-no-surrender-Q4yVkchNCbTXgni8ELMWbV",
    title: "no retreat no surrender",
    list_url: "/styles/black-grey/no-retreat-no-surrender"
  },
  {
    url: "/styles/black-grey/o-death-where-is-your-sting-o-death-6kw77v2GSR7vuUefBf5JjC",
    title: "o death where is your sting o death",
    list_url: "/styles/black-grey/o-death-where-is-your-sting-o-death"
  },
  {
    url: "/styles/black-grey/obatala-santeria-symbols-V2zWPM26gzssqa7JxxVMSx",
    title: "obatala santeria symbols",
    list_url: "/styles/black-grey/obatala-santeria-symbols"
  },
  {
    url: "/styles/black-grey/oleander-flowers-Ljxh3n1NgZYurGJ8faRnhz",
    title: "oleander flowers",
    list_url: "/styles/black-grey/oleander-flowers"
  },
  {
    url: "/styles/black-grey/on-hand-make-tattoo-name-with-ritika-N2AnB35TNJQQWcAYH8mCaY",
    title: "on hand make tattoo name with ritika",
    list_url: "/styles/black-grey/on-hand-make-tattoo-name-with-ritika"
  },
  {
    url: "/styles/black-grey/one-wing-angel-sephiroth-6mzZAZtDoKPAxRbdkDwmAS",
    title: "one wing angel sephiroth",
    list_url: "/styles/black-grey/one-wing-angel-sephiroth"
  },
  {
    url: "/styles/black-grey/orchid-mantis-Q5QR3a4gUu18ZCbkgcrpMq",
    title: "orchid mantis",
    list_url: "/styles/black-grey/orchid-mantis"
  },
  {
    url: "/styles/black-grey/ornamental-unaloom-fine-line-GyLwWUsni77Ep95wHYmc7w",
    title: "ornamental unaloom fine line",
    list_url: "/styles/black-grey/ornamental-unaloom-fine-line"
  },
  {
    url: "/styles/black-grey/our-faith-can-move-mountains-PZq8XRCyc8Mw9WrdDoBJth",
    title: "our faith can move mountains",
    list_url: "/styles/black-grey/our-faith-can-move-mountains"
  },
  {
    url: "/styles/black-grey/outline-of-state-of-georgia-bulldogs-TggRCjqgjecBtHDsHdfwWP",
    title: "outline of state of georgia bulldogs",
    list_url: "/styles/black-grey/outline-of-state-of-georgia-bulldogs"
  },
  {
    url: "/styles/black-grey/panther-in-a-jungle-VtB6mXsnE4cbBiJcu8MHpe",
    title: "panther in a jungle",
    list_url: "/styles/black-grey/panther-in-a-jungle"
  },
  {
    url: "/styles/black-grey/pennywise-the-clown-with-balloons-KFLqarTeSdmWPywrrfDPLN",
    title: "pennywise the clown with balloons",
    list_url: "/styles/black-grey/pennywise-the-clown-with-balloons"
  },
  {
    url: "/styles/black-grey/poison-tree-and-cross-7pWZnD1tAiYzj6L6EqKAfX",
    title: "poison tree and cross",
    list_url: "/styles/black-grey/poison-tree-and-cross"
  },
  {
    url: "/styles/black-grey/powhatan-american-indian-headdress-and-GGgdHz3ir4CDqCFUHB6S4B",
    title: "powhatan american indian headdress and",
    list_url: "/styles/black-grey/powhatan-american-indian-headdress-and"
  },
  {
    url: "/styles/black-grey/pubic-KMWGb17UeJpcd6vquBRs2V",
    title: "pubic",
    list_url: "/styles/black-grey/pubic"
  },
  {
    url: "/styles/black-grey/punk-skull-with-mohawk-hairstyle-GDZSA3eFWmwimTMxeqaXic",
    title: "punk skull with mohawk hairstyle",
    list_url: "/styles/black-grey/punk-skull-with-mohawk-hairstyle"
  },
  {
    url: "/styles/black-grey/r34-in-rome-J4vRpUT6gv9iovFgUWWAvd",
    title: "r in rome",
    list_url: "/styles/black-grey/r34-in-rome"
  },
  {
    url: "/styles/black-grey/rahul-name-tattoo-on-breast-4yKJC2PcDdQDSV1ndoZNVQ",
    title: "rahul name tattoo on breast",
    list_url: "/styles/black-grey/rahul-name-tattoo-on-breast"
  },
  {
    url: "/styles/black-grey/realistic-phoenix-A64rWTwz9dmieiZNBJbHH1",
    title: "realistic phoenix",
    list_url: "/styles/black-grey/realistic-phoenix"
  },
  {
    url: "/styles/black-grey/rebirth-of-eagle-soaring-Mt6optAwhvx3892omReveN",
    title: "rebirth of eagle soaring",
    list_url: "/styles/black-grey/rebirth-of-eagle-soaring"
  },
  {
    url: "/styles/black-grey/roman-colosseum-Lud34Q1WRVXkxBM3CR8mqX",
    title: "roman colosseum",
    list_url: "/styles/black-grey/roman-colosseum"
  },
  {
    url: "/styles/black-grey/roman-numerals-1994-WWsn8MVbaNsQgMZnzLLKXa",
    title: "roman numerals ",
    list_url: "/styles/black-grey/roman-numerals-1994"
  },
  {
    url: "/styles/black-grey/romans-811-3q3kUVF372ityzkHCq7srP",
    title: "romans ",
    list_url: "/styles/black-grey/romans-811"
  },
  {
    url: "/styles/black-grey/samson-from-the-bible-5vgf5d1nQ5ydrZqo6D7AiE",
    title: "samson from the bible",
    list_url: "/styles/black-grey/samson-from-the-bible"
  },
  {
    url: "/styles/black-grey/shivangi-name-written-Kn5ewb1hKUJepf7AnMoJw1",
    title: "shivangi name written",
    list_url: "/styles/black-grey/shivangi-name-written"
  },
  {
    url: "/styles/black-grey/sisters-by-chance-friends-by-choice-EJ1wgaz4rGb1JBe736MEvU",
    title: "sisters by chance friends by choice",
    list_url: "/styles/black-grey/sisters-by-chance-friends-by-choice"
  },
  {
    url: "/styles/black-grey/skeleton-with-noose-around-his-neck-and-7DBm8qsrjZvwzEXanr2ArT",
    title: "skeleton with noose around his neck and",
    list_url: "/styles/black-grey/skeleton-with-noose-around-his-neck-and"
  },
  {
    url: "/styles/black-grey/snake-wrapped-around-a-skull-5cxr6phEhXX7PRnPcjuuC1",
    title: "snake wrapped around a skull",
    list_url: "/styles/black-grey/snake-wrapped-around-a-skull"
  },
  {
    url: "/styles/black-grey/spiderman-2099-logo-on-back-A11rsb7r9feW6JT77v3XbC",
    title: "spiderman logo on back",
    list_url: "/styles/black-grey/spiderman-2099-logo-on-back"
  },
  {
    url: "/styles/black-grey/st-michael-archangel-slaying-snake-BSy3r1kTEPaJW6a31TLB48",
    title: "st michael archangel slaying snake",
    list_url: "/styles/black-grey/st-michael-archangel-slaying-snake"
  },
  {
    url: "/styles/black-grey/stain-glass-V64W4NDvL2pGzwQQ2J1WDA",
    title: "stain glass",
    list_url: "/styles/black-grey/stain-glass"
  },
  {
    url: "/styles/black-grey/stephanie-letters-Nj16zeUR6Nv2bYAUEY69Nq",
    title: "stephanie letters",
    list_url: "/styles/black-grey/stephanie-letters"
  },
  {
    url: "/styles/black-grey/sun-gothic-FfQ9TtGVhKKx9DvJdpHUxf",
    title: "sun gothic",
    list_url: "/styles/black-grey/sun-gothic"
  },
  {
    url: "/styles/black-grey/sunderland-afc-A18UTdGyJ3FBBpqNkiRFuN",
    title: "sunderland afc",
    list_url: "/styles/black-grey/sunderland-afc"
  },
  {
    url: "/styles/black-grey/sword-behind-the-ear-GNQx1ZTH1D1QiAKAM2RGm3",
    title: "sword behind the ear",
    list_url: "/styles/black-grey/sword-behind-the-ear"
  },
  {
    url: "/styles/black-grey/sydney-sweeney-SBjDedvSoSaZUqogg2Tpdv",
    title: "sydney sweeney",
    list_url: "/styles/black-grey/sydney-sweeney"
  },
  {
    url: "/styles/black-grey/teufel-hunden-surrounded-by-fire-flames-6S3KtLD7wcfLyEXDoyYkGF",
    title: "teufel hunden surrounded by fire flames",
    list_url: "/styles/black-grey/teufel-hunden-surrounded-by-fire-flames"
  },
  {
    url: "/styles/black-grey/the-1st-marine-division-logo-TTrjxmcEsjo8TfDNLrB5p7",
    title: "the st marine division logo",
    list_url: "/styles/black-grey/the-1st-marine-division-logo"
  },
  {
    url: "/styles/black-grey/the-gothic-dagger-B7pF71bdDzkVcZxgf9Fn8V",
    title: "the gothic dagger",
    list_url: "/styles/black-grey/the-gothic-dagger"
  },
  {
    url: "/styles/black-grey/the-name-tommy-gun-QsARC77xVjbdRuq86YPwFN",
    title: "the name tommy gun",
    list_url: "/styles/black-grey/the-name-tommy-gun"
  },
  {
    url: "/styles/black-grey/the-tree-falls-the-way-it-leans-UiR9E8wgpuqZpaZofc1NBo",
    title: "the tree falls the way it leans",
    list_url: "/styles/black-grey/the-tree-falls-the-way-it-leans"
  },
  {
    url: "/styles/black-grey/the-words-outlaw-woman-with-revolvers-6LUmtrkiLPGJ9pXjoAZU4V",
    title: "the words outlaw woman with revolvers",
    list_url: "/styles/black-grey/the-words-outlaw-woman-with-revolvers"
  },
  {
    url: "/styles/black-grey/tiger-lion-bear-leg-sleeve-WmBQcJH8Tkqdayo3UgMi9n",
    title: "tiger lion bear leg sleeve",
    list_url: "/styles/black-grey/tiger-lion-bear-leg-sleeve"
  },
  {
    url: "/styles/black-grey/tree-with-snake-and-long-roots-8qUsM6wx7izpeaGe9ndrHe",
    title: "tree with snake and long roots",
    list_url: "/styles/black-grey/tree-with-snake-and-long-roots"
  },
  {
    url: "/styles/black-grey/two-stone-tablets-with-the-ten-9HfqqYf3MbmWgiZNkic7pq",
    title: "two stone tablets with the ten",
    list_url: "/styles/black-grey/two-stone-tablets-with-the-ten"
  },
  {
    url: "/styles/black-grey/us-military-skeleton-soldier-holding-a-YbyaWUc6cVstHtA7ifRXVf",
    title: "us military skeleton soldier holding a",
    list_url: "/styles/black-grey/us-military-skeleton-soldier-holding-a"
  },
  {
    url: "/styles/black-grey/virgin-mary-with-rose-and-rosary-LNBs9uVvuBFsHnGRc3dy5M",
    title: "virgin mary with rose and rosary",
    list_url: "/styles/black-grey/virgin-mary-with-rose-and-rosary"
  },
  {
    url: "/styles/black-grey/virgo-and-leo-DACygcTfcUV4KjHSKL9KdK",
    title: "virgo and leo",
    list_url: "/styles/black-grey/virgo-and-leo"
  },
  {
    url: "/styles/black-grey/warhammer-40k-chaos-KhhqDBGSRJemHEioRb5b3U",
    title: "warhammer k chaos",
    list_url: "/styles/black-grey/warhammer-40k-chaos"
  },
  {
    url: "/styles/black-grey/wismut-aue-logo-fred-perry-kranz-BppXUHVQf15cj7aesvCf81",
    title: "wismut aue logo fred perry kranz",
    list_url: "/styles/black-grey/wismut-aue-logo-fred-perry-kranz"
  },
  {
    url: "/styles/black-grey/wolf-paw-print-CDudKZTmkPeTm88UdA3q2C",
    title: "wolf paw print",
    list_url: "/styles/black-grey/wolf-paw-print"
  },
  {
    url: "/styles/black-grey/woman-and-flower-hair-tangled-together-JM8Egd9p1p3ExsVCT6KuWw",
    title: "woman and flower hair tangled together",
    list_url: "/styles/black-grey/woman-and-flower-hair-tangled-together"
  },
  {
    url: "/styles/black-grey/year-of-the-dog-EawH8hwQXSdcKUfeJPQxER",
    title: "year of the dog",
    list_url: "/styles/black-grey/year-of-the-dog"
  },
  {
    url: "/styles/black-grey/zulfiqar-sword-shia-islam-with-thorns-CuMaKxQk4ScpK8txEckqqZ",
    title: "zulfiqar sword shia islam with thorns",
    list_url: "/styles/black-grey/zulfiqar-sword-shia-islam-with-thorns"
  },
  {
    url: "/styles/blackwork/1000-7-zxc-tokyo-ghoul-AGGyJFNJvVAFKDVSLf86Xi",
    title: " zxc tokyo ghoul",
    list_url: "/styles/blackwork/1000-7-zxc-tokyo-ghoul"
  },
  {
    url: "/styles/blackwork/a-bow-and-arrow-HRhd4Q1FAJRzbD6dFUeJsu",
    title: "a bow and arrow",
    list_url: "/styles/blackwork/a-bow-and-arrow"
  },
  {
    url: "/styles/blackwork/a-cross-tree-with-roots-add-shading-WpNPTkXvqpskALByynJHNL",
    title: "a cross tree with roots add shading",
    list_url: "/styles/blackwork/a-cross-tree-with-roots-add-shading"
  },
  {
    url: "/styles/blackwork/a-man-with-tattoos-on-his-shoulder-Q1ZmtWcB9q1pizkid42w5x",
    title: "a man with tattoos on his shoulder",
    list_url: "/styles/blackwork/a-man-with-tattoos-on-his-shoulder"
  },
  {
    url: "/styles/blackwork/a-roman-leaf-crown-with-a-cross-in-the-LexdrAvG1wsnbtenP4Wg7V",
    title: "a roman leaf crown with a cross in the",
    list_url: "/styles/blackwork/a-roman-leaf-crown-with-a-cross-in-the"
  },
  {
    url: "/styles/blackwork/a-sleeve-tattoo-of-dice-and-cards-USZeHSfUkv77SfCAdcbC1j",
    title: "a sleeve tattoo of dice and cards",
    list_url: "/styles/blackwork/a-sleeve-tattoo-of-dice-and-cards"
  },
  {
    url: "/styles/blackwork/a-snake-wrapped-around-a-stack-of-money-XS9aUUP8qTLjDWEciJf3m7",
    title: "a snake wrapped around a stack of money",
    list_url: "/styles/blackwork/a-snake-wrapped-around-a-stack-of-money"
  },
  {
    url: "/styles/blackwork/angel-ak-47-gun-in-her-hand-HNjc8S4rrgSi4EA5LM2ubv",
    title: "angel ak gun in her hand",
    list_url: "/styles/blackwork/angel-ak-47-gun-in-her-hand"
  },
  {
    url: "/styles/blackwork/angel-with-ak47-CuyC25EUN692E25WchrDD7",
    title: "angel with ak ",
    list_url: "/styles/blackwork/angel-with-ak47"
  },
  {
    url: "/styles/blackwork/aztec-eagle-armband-tattoo-BtSWpn5vPD2suZ4LQnPKmx",
    title: "aztec eagle armband tattoo",
    list_url: "/styles/blackwork/aztec-eagle-armband-tattoo"
  },
  {
    url: "/styles/blackwork/bat-with-flowers-EunULhbBKGVTuKvfzvck64",
    title: "bat with flowers",
    list_url: "/styles/blackwork/bat-with-flowers"
  },
  {
    url: "/styles/blackwork/bats-on-a-hand-BFhFKWAZNZBeKkY9u3kziD",
    title: "bats on a hand",
    list_url: "/styles/blackwork/bats-on-a-hand"
  },
  {
    url: "/styles/blackwork/bayis-and-isha-name-tatoo-GdEZbKYspiK5jJv3Px8uWS",
    title: "bayis and isha name tatoo",
    list_url: "/styles/blackwork/bayis-and-isha-name-tatoo"
  },
  {
    url: "/styles/blackwork/beautiful-evil-medusa-K59GJ1UvRHUkM2zhA2s1Xb",
    title: "beautiful evil medusa",
    list_url: "/styles/blackwork/beautiful-evil-medusa"
  },
  {
    url: "/styles/blackwork/ben-10-5p4r4pCdzCithxyuRN8vG4",
    title: "ben ",
    list_url: "/styles/blackwork/ben-10"
  },
  {
    url: "/styles/blackwork/berserk-brand-of-sacrifice-9YzdCqw6kLT4DDJ7k6pmwF",
    title: "berserk brand of sacrifice",
    list_url: "/styles/blackwork/berserk-brand-of-sacrifice"
  },
  {
    url: "/styles/blackwork/black-girl-with-lotus-flowers-rib-cage-4SMHJZUh9fmrqTv5qmXobm",
    title: "black girl with lotus flowers rib cage",
    list_url: "/styles/blackwork/black-girl-with-lotus-flowers-rib-cage"
  },
  {
    url: "/styles/blackwork/bloodborne-hunters-mark-SdRsfyLpvu8ZsRaC7fJj3B",
    title: "bloodborne hunters mark",
    list_url: "/styles/blackwork/bloodborne-hunters-mark"
  },
  {
    url: "/styles/blackwork/boho-longhorn-cow-skull-with-feathers-QSX3kx1NWwwXp2c4Ye1jG",
    title: "boho longhorn cow skull with feathers",
    list_url: "/styles/blackwork/boho-longhorn-cow-skull-with-feathers"
  },
  {
    url: "/styles/blackwork/cavapoo-DCjSxYPkCPpPcwBjKoMxu1",
    title: "cavapoo",
    list_url: "/styles/blackwork/cavapoo"
  },
  {
    url: "/styles/blackwork/chinese-writing-on-a-mans-back-28PRKWgNrj22cc3ko72stK",
    title: "chinese writing on a mans back",
    list_url: "/styles/blackwork/chinese-writing-on-a-mans-back"
  },
  {
    url: "/styles/blackwork/combine-nissan-skyline-r34-mustang-BKRCASbXABX8qPNq1LheFe",
    title: "combine nissan skyline r mustang",
    list_url: "/styles/blackwork/combine-nissan-skyline-r34-mustang"
  },
  {
    url: "/styles/blackwork/cover-up-name-chest-tattoo-FgVRXiP7vxs73jMN9asGCq",
    title: "cover up name chest tattoo",
    list_url: "/styles/blackwork/cover-up-name-chest-tattoo"
  },
  {
    url: "/styles/blackwork/crip-JFM4aRATBBaUP2S3FiAErS",
    title: "crip",
    list_url: "/styles/blackwork/crip"
  },
  {
    url: "/styles/blackwork/crip-gang-hand-tatto-TjSMLckGirMnB48s45H8h1",
    title: "crip gang hand tatto",
    list_url: "/styles/blackwork/crip-gang-hand-tatto"
  },
  {
    url: "/styles/blackwork/cross-sunflower-forgiven-luke-637-XxnqMEK7cvWLUxe6wjkqhc",
    title: "cross sunflower forgiven luke ",
    list_url: "/styles/blackwork/cross-sunflower-forgiven-luke-637"
  },
  {
    url: "/styles/blackwork/cupid-with-ski-mask-holding-a-gun-and-D59EkxPTVKxFhXVFpoxNtL",
    title: "cupid with ski mask holding a gun and",
    list_url: "/styles/blackwork/cupid-with-ski-mask-holding-a-gun-and"
  },
  {
    url: "/styles/blackwork/dark-ornamental-tattoo-VtuJVpAtk9MmaygrLqytst",
    title: "dark ornamental tattoo",
    list_url: "/styles/blackwork/dark-ornamental-tattoo"
  },
  {
    url: "/styles/blackwork/dclxvi-roman-numeral-with-roses-on-each-FCHbvDvdeL961LB9NChzqn",
    title: "dclxvi roman numeral with roses on each",
    list_url: "/styles/blackwork/dclxvi-roman-numeral-with-roses-on-each"
  },
  {
    url: "/styles/blackwork/ezekiel-2517-with-jules-winnfield-XiegqfuWZXKKBujvYgHeb8",
    title: "ezekiel with jules winnfield",
    list_url: "/styles/blackwork/ezekiel-2517-with-jules-winnfield"
  },
  {
    url: "/styles/blackwork/fc-schalke-04-1904-gelsenkirchen-N5uFZf3KaWzzPwm3JoK4pz",
    title: "fc schalke gelsenkirchen",
    list_url: "/styles/blackwork/fc-schalke-04-1904-gelsenkirchen"
  },
  {
    url: "/styles/blackwork/fire-flames-all-over-the-forearm-UAMmDS9PxqK9WVFQNQmQbX",
    title: "fire flames all over the forearm",
    list_url: "/styles/blackwork/fire-flames-all-over-the-forearm"
  },
  {
    url: "/styles/blackwork/flute-with-music-harini-name-and-pecock-KUYGP6sHAtARRmtprSPUqF",
    title: "flute with music harini name and pecock",
    list_url: "/styles/blackwork/flute-with-music-harini-name-and-pecock"
  },
  {
    url: "/styles/blackwork/gambling-hustle-money-symbols-7qSzAVumaokGHMFVGkrJMr",
    title: "gambling hustle money symbols",
    list_url: "/styles/blackwork/gambling-hustle-money-symbols"
  },
  {
    url: "/styles/blackwork/gangster-baby-angel-with-kalashnikov-LdWNSX14i5ptqfD1MBXCKi",
    title: "gangster baby angel with kalashnikov",
    list_url: "/styles/blackwork/gangster-baby-angel-with-kalashnikov"
  },
  {
    url: "/styles/blackwork/gato-com-uma-taca-de-vinho-Txy4U4nKDcwZ9KXR4cg6sf",
    title: "gato com uma taca de vinho",
    list_url: "/styles/blackwork/gato-com-uma-taca-de-vinho"
  },
  {
    url: "/styles/blackwork/gladius-YcKKq8CLsi4gtNwiJaWmHR",
    title: "gladius",
    list_url: "/styles/blackwork/gladius"
  },
  {
    url: "/styles/blackwork/gojo-satoru-hollow-purple-M7SyhRW6uWYpAtD6UkF84R",
    title: "gojo satoru hollow purple",
    list_url: "/styles/blackwork/gojo-satoru-hollow-purple"
  },
  {
    url: "/styles/blackwork/gothic-crown-ring-finger-99EyFVXDTNG7gYqgAcrP4B",
    title: "gothic crown ring finger",
    list_url: "/styles/blackwork/gothic-crown-ring-finger"
  },
  {
    url: "/styles/blackwork/gundam-barbatos-CjpSoQShHCCMsqq7QYkPdk",
    title: "gundam barbatos",
    list_url: "/styles/blackwork/gundam-barbatos"
  },
  {
    url: "/styles/blackwork/guy-with-mullet-hair-cut-bald-on-top-SQVHr4fcuQkoWxy8gztJYH",
    title: "guy with mullet hair cut bald on top",
    list_url: "/styles/blackwork/guy-with-mullet-hair-cut-bald-on-top"
  },
  {
    url: "/styles/blackwork/hawk-with-arrow-in-chest-6KTmSoVBMhJ5Ecex8E5q83",
    title: "hawk with arrow in chest",
    list_url: "/styles/blackwork/hawk-with-arrow-in-chest"
  },
  {
    url: "/styles/blackwork/hell-hound-dog-from-call-of-duty-black-8e9hhTdLjHMoHroqMnuwYN",
    title: "hell hound dog from call of duty black",
    list_url: "/styles/blackwork/hell-hound-dog-from-call-of-duty-black"
  },
  {
    url: "/styles/blackwork/hip-and-upper-thigh-tattoo-stencil-TTnsGhCcwRQrPX29p2FrHX",
    title: "hip and upper thigh tattoo stencil",
    list_url: "/styles/blackwork/hip-and-upper-thigh-tattoo-stencil"
  },
  {
    url: "/styles/blackwork/horse-skull-with-flowers-4mo9L7Wm7m5FfZQVP49cQE",
    title: "horse skull with flowers",
    list_url: "/styles/blackwork/horse-skull-with-flowers"
  },
  {
    url: "/styles/blackwork/ilia-topuria-back-tattoo-but-without-KnRZ9LFPwPmuWAw3pMA2V7",
    title: "ilia topuria back tattoo but without",
    list_url: "/styles/blackwork/ilia-topuria-back-tattoo-but-without"
  },
  {
    url: "/styles/blackwork/ix-xvii-mmiii-roman-numerals-2jsXWuNpVquZiBFXqYq78t",
    title: "ix xvii mmiii roman numerals",
    list_url: "/styles/blackwork/ix-xvii-mmiii-roman-numerals"
  },
  {
    url: "/styles/blackwork/kill-the-boy-and-let-the-man-be-born-QUreMk4CtwhYpZB9a7TyYw",
    title: "kill the boy and let the man be born",
    list_url: "/styles/blackwork/kill-the-boy-and-let-the-man-be-born"
  },
  {
    url: "/styles/blackwork/king-and-two-prince-crown-GBJGydmyAZpuk33bMaPR9M",
    title: "king and two prince crown",
    list_url: "/styles/blackwork/king-and-two-prince-crown"
  },
  {
    url: "/styles/blackwork/king-baldwin-H7wvJya6YZ2QY9e7KPmSZz",
    title: "king baldwin",
    list_url: "/styles/blackwork/king-baldwin"
  },
  {
    url: "/styles/blackwork/la-santa-muerte-MnrQaGqmhLqf9omZhuxFzk",
    title: "la santa muerte",
    list_url: "/styles/blackwork/la-santa-muerte"
  },
  {
    url: "/styles/blackwork/lady-gaga-paws-up-YQYM7CpNzChLA3PvRvmwMP",
    title: "lady gaga paws up",
    list_url: "/styles/blackwork/lady-gaga-paws-up"
  },
  {
    url: "/styles/blackwork/lettering-tattoo-slatt-MkXVt44wWTTqvRDQbDcnpL",
    title: "lettering tattoo slatt",
    list_url: "/styles/blackwork/lettering-tattoo-slatt"
  },
  {
    url: "/styles/blackwork/mandalorian-with-mudhorn-MHGcQEYzrx1YcD1rLz6Ybi",
    title: "mandalorian with mudhorn",
    list_url: "/styles/blackwork/mandalorian-with-mudhorn"
  },
  {
    url: "/styles/blackwork/marvel-valkyrie-symbol-mixed-with-norse-SLmNaAszqMVNj3BJQoagWt",
    title: "marvel valkyrie symbol mixed with norse",
    list_url: "/styles/blackwork/marvel-valkyrie-symbol-mixed-with-norse"
  },
  {
    url: "/styles/blackwork/masculine-flower-QtcUiU8eFNMcYKoTt2Lp24",
    title: "masculine flower",
    list_url: "/styles/blackwork/masculine-flower"
  },
  {
    url: "/styles/blackwork/maui-moana-disney-tattoo-with-boy-and-GneTTcaUjsXSvPsGRf7MZ2",
    title: "maui moana disney tattoo with boy and",
    list_url: "/styles/blackwork/maui-moana-disney-tattoo-with-boy-and"
  },
  {
    url: "/styles/blackwork/medicine-man-JUSFfRgVptCypFwt9M9ZiH",
    title: "medicine man",
    list_url: "/styles/blackwork/medicine-man"
  },
  {
    url: "/styles/blackwork/mom-hugging-2-daughters-and-1-son-LqWDjCzY4ZcJWVfTi8qYkc",
    title: "mom hugging daughters and son",
    list_url: "/styles/blackwork/mom-hugging-2-daughters-and-1-son"
  },
  {
    url: "/styles/blackwork/my-moms-name-samantha-and-her-KKFqhzQvxuDPRRo8dLbgZf",
    title: "my moms name samantha and her",
    list_url: "/styles/blackwork/my-moms-name-samantha-and-her"
  },
  {
    url: "/styles/blackwork/name-nikita-in-marathi-language-logo-Hfb4oBqUwd18E48YACfreY",
    title: "name nikita in marathi language logo",
    list_url: "/styles/blackwork/name-nikita-in-marathi-language-logo"
  },
  {
    url: "/styles/blackwork/nike-tn-logo-5gC5NLPXNhdPRrgEXC8b7B",
    title: "nike tn logo",
    list_url: "/styles/blackwork/nike-tn-logo"
  },
  {
    url: "/styles/blackwork/notti-gang-wiith-blood-dripping-JrAiAB7Cx9oSvBaGVY14Jk",
    title: "notti gang wiith blood dripping",
    list_url: "/styles/blackwork/notti-gang-wiith-blood-dripping"
  },
  {
    url: "/styles/blackwork/oni-mask-tattoo-located-on-shoulder-6yv4k38oR2hEZ2h8z3oEAr",
    title: "oni mask tattoo located on shoulder",
    list_url: "/styles/blackwork/oni-mask-tattoo-located-on-shoulder"
  },
  {
    url: "/styles/blackwork/phi-J9kqUKCMJnRYGRshBh4orZ",
    title: "phi",
    list_url: "/styles/blackwork/phi"
  },
  {
    url: "/styles/blackwork/radhika-and-shashi-name-in-one-tattoo-K9VpGzx7UXMD4G3iUrg8J8",
    title: "radhika and shashi name in one tattoo",
    list_url: "/styles/blackwork/radhika-and-shashi-name-in-one-tattoo"
  },
  {
    url: "/styles/blackwork/raymond-reddington-PUwsF5G6NGgQHBZdydFVwE",
    title: "raymond reddington",
    list_url: "/styles/blackwork/raymond-reddington"
  },
  {
    url: "/styles/blackwork/sasuke-uchiha-chidori-D1uE6tt7WnGHgCKhA3QmG7",
    title: "sasuke uchiha chidori",
    list_url: "/styles/blackwork/sasuke-uchiha-chidori"
  },
  {
    url: "/styles/blackwork/scorpion-and-golden-crown-Ni9pxTwpjanJCjSvDJXwQD",
    title: "scorpion and golden crown",
    list_url: "/styles/blackwork/scorpion-and-golden-crown"
  },
  {
    url: "/styles/blackwork/scorpion-with-a-crown-EQZ5rFsfSeqa4zTzyHa7uN",
    title: "scorpion with a crown",
    list_url: "/styles/blackwork/scorpion-with-a-crown"
  },
  {
    url: "/styles/blackwork/seal-of-solomon-VuFbBdT8cPkxGXRFYQa8H3",
    title: "seal of solomon",
    list_url: "/styles/blackwork/seal-of-solomon"
  },
  {
    url: "/styles/blackwork/shadowhunters-JX7D3dW9Eo6HBnpVDosX3G",
    title: "shadowhunters",
    list_url: "/styles/blackwork/shadowhunters"
  },
  {
    url: "/styles/blackwork/shoes-wearing-headphones-XEhfLHwNyB3oL5FuEJFFnm",
    title: "shoes wearing headphones",
    list_url: "/styles/blackwork/shoes-wearing-headphones"
  },
  {
    url: "/styles/blackwork/shroud-of-turin-8qVvcdcwTKsRQ9xmLVuTx6",
    title: "shroud of turin",
    list_url: "/styles/blackwork/shroud-of-turin"
  },
  {
    url: "/styles/blackwork/sobek-egyptian-god-gearing-up-for-war-XL2iH3XTKxT2NJCDtYtTdP",
    title: "sobek egyptian god gearing up for war",
    list_url: "/styles/blackwork/sobek-egyptian-god-gearing-up-for-war"
  },
  {
    url: "/styles/blackwork/soldier-of-death-korps-of-krieg-MjetRQMqHFbfpShuV4kQS4",
    title: "soldier of death korps of krieg",
    list_url: "/styles/blackwork/soldier-of-death-korps-of-krieg"
  },
  {
    url: "/styles/blackwork/spiderweb-with-spider-for-elbow-RDhbV3SWCuLGDYqxuAPfyW",
    title: "spiderweb with spider for elbow",
    list_url: "/styles/blackwork/spiderweb-with-spider-for-elbow"
  },
  {
    url: "/styles/blackwork/stadium-obelisk-KkeMY5v2SUqDUFvwyXg1Vb",
    title: "stadium obelisk",
    list_url: "/styles/blackwork/stadium-obelisk"
  },
  {
    url: "/styles/blackwork/the-devil-and-god-are-raging-inside-of-2NuYtb7j8FiH6Ns14Tg1jp",
    title: "the devil and god are raging inside of",
    list_url: "/styles/blackwork/the-devil-and-god-are-raging-inside-of"
  },
  {
    url: "/styles/blackwork/the-name-alexis-9a5SWh8PKw9ckBKKAf2Ynf",
    title: "the name alexis",
    list_url: "/styles/blackwork/the-name-alexis"
  },
  {
    url: "/styles/blackwork/the-name-laura-with-cursive-letters-in-NWocuT2ssBsttrJWYwCwSk",
    title: "the name laura with cursive letters in",
    list_url: "/styles/blackwork/the-name-laura-with-cursive-letters-in"
  },
  {
    url: "/styles/blackwork/three-little-birds-ajax-TMrZbAKWWjZo713mf172GW",
    title: "three little birds ajax",
    list_url: "/styles/blackwork/three-little-birds-ajax"
  },
  {
    url: "/styles/blackwork/tiger-eye-and-human-eye-XcePF8HrVDqueJFCcdoPx1",
    title: "tiger eye and human eye",
    list_url: "/styles/blackwork/tiger-eye-and-human-eye"
  },
  {
    url: "/styles/blackwork/tom-and-jerry-smoking-cigarettes-HC7hdTEvTvoQMPLtXTHspF",
    title: "tom and jerry smoking cigarettes",
    list_url: "/styles/blackwork/tom-and-jerry-smoking-cigarettes"
  },
  {
    url: "/styles/blackwork/tottenham-hotspur-cockerel-3dm9pTfy2P1zCB25JQW2c2",
    title: "tottenham hotspur cockerel",
    list_url: "/styles/blackwork/tottenham-hotspur-cockerel"
  },
  {
    url: "/styles/blackwork/traditional-japanese-clouds-kV5jz5sUvugyTwtRr3cKM",
    title: "traditional japanese clouds",
    list_url: "/styles/blackwork/traditional-japanese-clouds"
  },
  {
    url: "/styles/blackwork/tribal-with-negative-space-PhQDGyKZFVb3m1CiQC1PQB",
    title: "tribal with negative space",
    list_url: "/styles/blackwork/tribal-with-negative-space"
  },
  {
    url: "/styles/blackwork/two-dragons-flying-44skZRseDVHmDpFCWHm11T",
    title: "two dragons flying",
    list_url: "/styles/blackwork/two-dragons-flying"
  },
  {
    url: "/styles/blackwork/two-sharks-one-black-and-the-other-Qz72Y7vt16ufP4mCMnoZw",
    title: "two sharks one black and the other",
    list_url: "/styles/blackwork/two-sharks-one-black-and-the-other"
  },
  {
    url: "/styles/blackwork/two-skulls-kissing-inside-of-a-heart-B3BFrXLpdnuoEWysW68fnF",
    title: "two skulls kissing inside of a heart",
    list_url: "/styles/blackwork/two-skulls-kissing-inside-of-a-heart"
  },
  {
    url: "/styles/blackwork/vampire-diaries-quote-always-and-forever-CuGFoW7MezyNHfqcshmx3M",
    title: "vampire diaries quote always and forever",
    list_url: "/styles/blackwork/vampire-diaries-quote-always-and-forever"
  },
  {
    url: "/styles/blackwork/vegas-angel-of-the-north-MKyMLHpFjyzjRHSUjcuNut",
    title: "vegas angel of the north",
    list_url: "/styles/blackwork/vegas-angel-of-the-north"
  },
  {
    url: "/styles/blackwork/vietnamese-zodiac-cat-7K5c9Jgf2WuQ8nJs8393Rj",
    title: "vietnamese zodiac cat",
    list_url: "/styles/blackwork/vietnamese-zodiac-cat"
  },
  {
    url: "/styles/blackwork/warhammer-40k-inquisition-symbols-2cuKBW1kvGnbdCz4G5eZpe",
    title: "warhammer k inquisition symbols",
    list_url: "/styles/blackwork/warhammer-40k-inquisition-symbols"
  },
  {
    url: "/styles/blackwork/wolf-moon-trees-birds-flying-5zEaiXrF9PxwUeumvLtgb4",
    title: "wolf moon trees birds flying",
    list_url: "/styles/blackwork/wolf-moon-trees-birds-flying"
  },
  {
    url: "/styles/blackwork/write-the-name-riley-with-a-small-angel-Vvizm8tAhiR4KcLF7CFaqe",
    title: "write the name riley with a small angel",
    list_url: "/styles/blackwork/write-the-name-riley-with-a-small-angel"
  },
  {
    url: "/styles/blackwork/zwei-hande-die-sich-fast-beruhren-KZRJmGq5bKL5xsJ2Jt7pzz",
    title: "zwei hande die sich fast beruhren",
    list_url: "/styles/blackwork/zwei-hande-die-sich-fast-beruhren"
  },
  {
    url: "/styles/chicano/joker-G967vAqSU5ArP6MLVL7AJa",
    title: "joker",
    list_url: "/styles/chicano/joker"
  },
  {
    url: "/styles/color-infused-black-grey/gunsmoke-television-show-marshal-dillon-Weh9sFJRit84RAMFui9U39",
    title: "gunsmoke television show marshal dillon",
    list_url: "/styles/color-infused-black-grey/gunsmoke-television-show-marshal-dillon"
  },
  {
    url: "/styles/color-infused-black-grey/sissy-slut-sissy-submissive-FhdBfYGuVpuiXNiWk71vQN",
    title: "sissy slut sissy submissive",
    list_url: "/styles/color-infused-black-grey/sissy-slut-sissy-submissive"
  },
  {
    url: "/styles/color-infused-black-grey/sissy-slut-sissy-submissive-GLFP6Txvzc81FA8Uou5WDj",
    title: "sissy slut sissy submissive",
    list_url: "/styles/color-infused-black-grey/sissy-slut-sissy-submissive"
  },
  {
    url: "/styles/color-infused-black-grey/sissy-slut-sissy-submissive-HT5eaJdDJnn692G3rpUoRS",
    title: "sissy slut sissy submissive",
    list_url: "/styles/color-infused-black-grey/sissy-slut-sissy-submissive"
  },
  {
    url: "/styles/cyber-sigilism/414-in-bubble-letters-ytD8shuQj45tZo45N2bo8",
    title: " in bubble letters",
    list_url: "/styles/cyber-sigilism/414-in-bubble-letters"
  },
  {
    url: "/styles/cyber-sigilism/cyberpunk-and-christian-style-sword-and-31i1Qvj3rZejJjKfhPzvGe",
    title: "cyberpunk and christian style sword and",
    list_url: "/styles/cyber-sigilism/cyberpunk-and-christian-style-sword-and"
  },
  {
    url: "/styles/cyber-sigilism/laurel-wreath-men-neck-UK8Y3WVjjwvxnpMNDaVgGe",
    title: "laurel wreath men neck",
    list_url: "/styles/cyber-sigilism/laurel-wreath-men-neck"
  },
  {
    url: "/styles/cyber-sigilism/tattoo-sleeve-for-men-in-steampunk-KbtyrwRzKBrfLUHEwRg3G4",
    title: "tattoo sleeve for men in steampunk",
    list_url: "/styles/cyber-sigilism/tattoo-sleeve-for-men-in-steampunk"
  },
  {
    url: "/styles/cyber-sigilism/the-word-blessed-in-japanese-J7U7qguJErLAbMLxjQNtwH",
    title: "the word blessed in japanese",
    list_url: "/styles/cyber-sigilism/the-word-blessed-in-japanese"
  },
  {
    url: "/styles/dotwork/a-kung-fu-symbol-QJoqGCAMkz4rtXEag8h3ku",
    title: "a kung fu symbol",
    list_url: "/styles/dotwork/a-kung-fu-symbol"
  },
  {
    url: "/styles/dotwork/ankita-name-tattoo-with-heart-9wpD6F4GT1svQUV1NBu8tP",
    title: "ankita name tattoo with heart",
    list_url: "/styles/dotwork/ankita-name-tattoo-with-heart"
  },
  {
    url: "/styles/dotwork/carlos-name-4nYkKzZYT35scXyUMJfrb8",
    title: "carlos name",
    list_url: "/styles/dotwork/carlos-name"
  },
  {
    url: "/styles/dotwork/christian-cross-bloody-crown-father-AQSD7KRoVXbVSMuQSp2THG",
    title: "christian cross bloody crown father",
    list_url: "/styles/dotwork/christian-cross-bloody-crown-father"
  },
  {
    url: "/styles/dotwork/cowboy-lever-action-gun-P8V4oxLUGyAHs3nVnyowue",
    title: "cowboy lever action gun",
    list_url: "/styles/dotwork/cowboy-lever-action-gun"
  },
  {
    url: "/styles/dotwork/crescent-moon-with-paw-print-SjEL9Hzzn8FfZWwZrKjvQF",
    title: "crescent moon with paw print",
    list_url: "/styles/dotwork/crescent-moon-with-paw-print"
  },
  {
    url: "/styles/dotwork/donald-duck-smoking-a-cigarette-AWY1xAawiK4RohVqAcevSC",
    title: "donald duck smoking a cigarette",
    list_url: "/styles/dotwork/donald-duck-smoking-a-cigarette"
  },
  {
    url: "/styles/dotwork/dove-memorial-rest-in-peace-G9daJPP8Gf6VZ5RoZsbJNQ",
    title: "dove memorial rest in peace",
    list_url: "/styles/dotwork/dove-memorial-rest-in-peace"
  },
  {
    url: "/styles/dotwork/gible-the-pokemon-stealing-axews-apple-HPsmqCUV7K8es1rEnYBKmc",
    title: "gible the pokemon stealing axews apple",
    list_url: "/styles/dotwork/gible-the-pokemon-stealing-axews-apple"
  },
  {
    url: "/styles/dotwork/infinity-symbol-with-dove-and-peonies-GEnnPrDhRR6Mu7wrGwGvQp",
    title: "infinity symbol with dove and peonies",
    list_url: "/styles/dotwork/infinity-symbol-with-dove-and-peonies"
  },
  {
    url: "/styles/dotwork/laugh-now-cry-later-tattoo-on-a-EKJYcDrXXihBxXUTYZFddC",
    title: "laugh now cry later tattoo on a",
    list_url: "/styles/dotwork/laugh-now-cry-later-tattoo-on-a"
  },
  {
    url: "/styles/dotwork/led-zeppelin-zoso-4UJVuhykMmJEvqGNnEqRA9",
    title: "led zeppelin zoso",
    list_url: "/styles/dotwork/led-zeppelin-zoso"
  },
  {
    url: "/styles/dotwork/leopard-print-heart-ADU8T7BcUcFH6S1jtgsT5f",
    title: "leopard print heart",
    list_url: "/styles/dotwork/leopard-print-heart"
  },
  {
    url: "/styles/dotwork/lightning-mcqueen-cars-film-KtiX8xNQ4sXJ3Ebc8KWkL9",
    title: "lightning mcqueen cars film",
    list_url: "/styles/dotwork/lightning-mcqueen-cars-film"
  },
  {
    url: "/styles/dotwork/logo-of-rolls-royce-but-with-2-letters-XPw8m9FfZJzNBi3DYZxCmY",
    title: "logo of rolls royce but with letters",
    list_url: "/styles/dotwork/logo-of-rolls-royce-but-with-2-letters"
  },
  {
    url: "/styles/dotwork/lokah-samastah-sukhino-bhavantu-tattoo-VvvZJr1sLrvPmaY9bK4kfK",
    title: "lokah samastah sukhino bhavantu tattoo",
    list_url: "/styles/dotwork/lokah-samastah-sukhino-bhavantu-tattoo"
  },
  {
    url: "/styles/dotwork/long-neck-mom-and-2-baby-dinosaur-3UTegUehWHE1LpbrpFPWcY",
    title: "long neck mom and baby dinosaur",
    list_url: "/styles/dotwork/long-neck-mom-and-2-baby-dinosaur"
  },
  {
    url: "/styles/dotwork/my-girlfriends-name-is-bhakti-iwant-her-LkcAQJY4ZWYciEHYYsRCqm",
    title: "my girlfriends name is bhakti iwant her",
    list_url: "/styles/dotwork/my-girlfriends-name-is-bhakti-iwant-her"
  },
  {
    url: "/styles/dotwork/name-ayan-X96o5YXxFCyg78xbXgM9D3",
    title: "name ayan",
    list_url: "/styles/dotwork/name-ayan"
  },
  {
    url: "/styles/dotwork/number-18-with-kartik-name-MwWMJbyLVZsNNvH6fkRrSb",
    title: "number with kartik name",
    list_url: "/styles/dotwork/number-18-with-kartik-name"
  },
  {
    url: "/styles/dotwork/owl-sunflower-KBZsxzTaKtpSP2v1btLXoC",
    title: "owl sunflower",
    list_url: "/styles/dotwork/owl-sunflower"
  },
  {
    url: "/styles/dotwork/paru-APbjrM1rxtE1dT5aiuFwf5",
    title: "paru",
    list_url: "/styles/dotwork/paru"
  },
  {
    url: "/styles/dotwork/rose-angel-wings-for-leaves-thorns-RbwjKrMWNJXoaMBmief8ty",
    title: "rose angel wings for leaves thorns",
    list_url: "/styles/dotwork/rose-angel-wings-for-leaves-thorns"
  },
  {
    url: "/styles/dotwork/salmo-91-P8uPxMCr5QRz79gB45tnrh",
    title: "salmo ",
    list_url: "/styles/dotwork/salmo-91"
  },
  {
    url: "/styles/dotwork/sayali-3MXkdRuf3AWEYfp7284YLp",
    title: "sayali",
    list_url: "/styles/dotwork/sayali"
  },
  {
    url: "/styles/dotwork/snake-with-angel-wings-AjG4huQBgBpPTpJgWNsCyq",
    title: "snake with angel wings",
    list_url: "/styles/dotwork/snake-with-angel-wings"
  },
  {
    url: "/styles/dotwork/spongebob-smoking-weed-2rgEbxXHGQrYHweugqT3AG",
    title: "spongebob smoking weed",
    list_url: "/styles/dotwork/spongebob-smoking-weed"
  },
  {
    url: "/styles/dotwork/standing-on-business-HUb34QaMp6FbzMBk3Ysaiv",
    title: "standing on business",
    list_url: "/styles/dotwork/standing-on-business"
  },
  {
    url: "/styles/dotwork/sun-with-priyanshu-3q7aRgtoWtQTA6g5uPnFqp",
    title: "sun with priyanshu",
    list_url: "/styles/dotwork/sun-with-priyanshu"
  },
  {
    url: "/styles/dotwork/the-number-29-in-roman-numerals-with-a-APGfLLbaHnEHxKkhuu8FdZ",
    title: "the number in roman numerals with a",
    list_url: "/styles/dotwork/the-number-29-in-roman-numerals-with-a"
  },
  {
    url: "/styles/dotwork/the-wolf-with-romulus-and-remus-Tv2CpaHgMJ4RhdH5n814XH",
    title: "the wolf with romulus and remus",
    list_url: "/styles/dotwork/the-wolf-with-romulus-and-remus"
  },
  {
    url: "/styles/dotwork/tottenham-hotspur-YVUePzFKHbLTPkwzdH1C3P",
    title: "tottenham hotspur",
    list_url: "/styles/dotwork/tottenham-hotspur"
  },
  {
    url: "/styles/dotwork/turtle-laying-in-the-clouds-with-a-halo-CDy29aNMBvHD4BVTwaPJYr",
    title: "turtle laying in the clouds with a halo",
    list_url: "/styles/dotwork/turtle-laying-in-the-clouds-with-a-halo"
  },
  {
    url: "/styles/dotwork/virgen-guadalupe-6VGYmVWqw27FTutyP9kyGe",
    title: "virgen guadalupe",
    list_url: "/styles/dotwork/virgen-guadalupe"
  },
  {
    url: "/styles/dotwork/yuri-boyka-TJAYLNbecXfjUyL92wo58D",
    title: "yuri boyka",
    list_url: "/styles/dotwork/yuri-boyka"
  },
  {
    url: "/styles/geometric/beach-palm-tree-forest-mountains-sun-LQ9Xa8CfW9pKuU77WWrQEG",
    title: "beach palm tree forest mountains sun",
    list_url: "/styles/geometric/beach-palm-tree-forest-mountains-sun"
  },
  {
    url: "/styles/geometric/bend-overslim-thick-goth-girlemo-Viyhp3Zxru3uE535d67yrk",
    title: "bend overslim thick goth girlemo",
    list_url: "/styles/geometric/bend-overslim-thick-goth-girlemo"
  },
  {
    url: "/styles/geometric/dotwork-CDZqyN2Ka8CHhgtNRH5Jdr",
    title: "dotwork",
    list_url: "/styles/geometric/dotwork"
  },
  {
    url: "/styles/geometric/gandalf-rune-symbolizing-strength-XSN5qcQRtCZnqdQxuhmBA8",
    title: "gandalf rune symbolizing strength",
    list_url: "/styles/geometric/gandalf-rune-symbolizing-strength"
  },
  {
    url: "/styles/geometric/koi-fish-Ti3GGqGa9FS4UHhGKNW48U",
    title: "koi fish",
    list_url: "/styles/geometric/koi-fish"
  },
  {
    url: "/styles/geometric/pisces-HECySyVDgWer7vywVAQ2L3",
    title: "pisces",
    list_url: "/styles/geometric/pisces"
  },
  {
    url: "/styles/geometric/triangle-tree-TsHJBbLBvYWdEBrvEayaV6",
    title: "triangle tree",
    list_url: "/styles/geometric/triangle-tree"
  },
  {
    url: "/styles/ignorant/acid-house-smiley-face-31XbVqZNbVSrPc2bqFnGmQ",
    title: "acid house smiley face",
    list_url: "/styles/ignorant/acid-house-smiley-face"
  },
  {
    url: "/styles/ignorant/no-weapon-formed-against-me-shall-8kPJtGqkeE3gXR42GWLQ4m",
    title: "no weapon formed against me shall",
    list_url: "/styles/ignorant/no-weapon-formed-against-me-shall"
  },
  {
    url: "/styles/ignorant/scissor-seven-NPXHrs4m7DqGYkuTwDWLE3",
    title: "scissor seven",
    list_url: "/styles/ignorant/scissor-seven"
  },
  {
    url: "/styles/japanese/adolf-hitler-anime-style-NVkJsmXFxGbCup19oqzoym",
    title: "adolf hitler anime style",
    list_url: "/styles/japanese/adolf-hitler-anime-style"
  },
  {
    url: "/styles/japanese/blue-porcelain-dragon-XuHrG1Q9d9bykQ3UBSPM5p",
    title: "blue porcelain dragon",
    list_url: "/styles/japanese/blue-porcelain-dragon"
  },
  {
    url: "/styles/japanese/curse-mark-from-sasuke-XhG16qczQfWA8Ld9W3gRyf",
    title: "curse mark from sasuke",
    list_url: "/styles/japanese/curse-mark-from-sasuke"
  },
  {
    url: "/styles/japanese/delije-sever-WUBpEctsbHE3Wng5MshDbN",
    title: "delije sever",
    list_url: "/styles/japanese/delije-sever"
  },
  {
    url: "/styles/japanese/falcon-CLiBnnFY4CHMdeL53tF84",
    title: "falcon",
    list_url: "/styles/japanese/falcon"
  },
  {
    url: "/styles/japanese/fox-face-with-virgo-zodiac-symbol-in-V7AihXFm9TRpxGxBxK9pki",
    title: "fox face with virgo zodiac symbol in",
    list_url: "/styles/japanese/fox-face-with-virgo-zodiac-symbol-in"
  },
  {
    url: "/styles/japanese/geisha-QMpF4zQudkUVXXKNesdcwk",
    title: "geisha",
    list_url: "/styles/japanese/geisha"
  },
  {
    url: "/styles/japanese/ghost-onryo-YPx1MAgS22Yz8QyaKyQA6L",
    title: "ghost onryo",
    list_url: "/styles/japanese/ghost-onryo"
  },
  {
    url: "/styles/japanese/illuminated-by-god-H312LAdQ2vPdtKGQCj4UAa",
    title: "illuminated by god",
    list_url: "/styles/japanese/illuminated-by-god"
  },
  {
    url: "/styles/japanese/inari-3QXDrnxSEwUqQ6k7UXFAoC",
    title: "inari",
    list_url: "/styles/japanese/inari"
  },
  {
    url: "/styles/japanese/irezumi-tattoo-dragon-white-NA1gK4vtWbR3PKgpVHZmnG",
    title: "irezumi tattoo dragon white",
    list_url: "/styles/japanese/irezumi-tattoo-dragon-white"
  },
  {
    url: "/styles/japanese/japanese-koi-fish-half-forearm-sleeve-Dt9BMvqBBnEtTpg19m3LvN",
    title: "japanese koi fish half forearm sleeve",
    list_url: "/styles/japanese/japanese-koi-fish-half-forearm-sleeve"
  },
  {
    url: "/styles/japanese/kanji-D8etXQB3H3fedRCW5poBTv",
    title: "kanji",
    list_url: "/styles/japanese/kanji"
  },
  {
    url: "/styles/japanese/kanji-de-akai-ito-2JLB9g4vBoEfvUJUbuv1k8",
    title: "kanji de akai ito",
    list_url: "/styles/japanese/kanji-de-akai-ito"
  },
  {
    url: "/styles/japanese/koi-fish-yin-yang-lotus-flower-growing-2UnLzAcmcJqFSA8kA6kgc5",
    title: "koi fish yin yang lotus flower growing",
    list_url: "/styles/japanese/koi-fish-yin-yang-lotus-flower-growing"
  },
  {
    url: "/styles/japanese/korean-dokkaebi-Ht2u8BvMvg62tSVDQgK8PK",
    title: "korean dokkaebi",
    list_url: "/styles/japanese/korean-dokkaebi"
  },
  {
    url: "/styles/japanese/mahakala-4bSWTyayfLZkeRKKPrPuYv",
    title: "mahakala",
    list_url: "/styles/japanese/mahakala"
  },
  {
    url: "/styles/japanese/marked-by-the-uni-8RTUb7WNkxwGLpDa5nrJge",
    title: "marked by the uni",
    list_url: "/styles/japanese/marked-by-the-uni"
  },
  {
    url: "/styles/japanese/moth-3Rrns7pufWVhLuM1AN2xsS",
    title: "moth",
    list_url: "/styles/japanese/moth"
  },
  {
    url: "/styles/japanese/nissan-skyline-r34-XZ4vsp8Zn3oashNML7eqqL",
    title: "nissan skyline r ",
    list_url: "/styles/japanese/nissan-skyline-r34"
  },
  {
    url: "/styles/japanese/omamori-ofuda-talisman-DnyRqopX6TEspSGXw9X22P",
    title: "omamori ofuda talisman",
    list_url: "/styles/japanese/omamori-ofuda-talisman"
  },
  {
    url: "/styles/japanese/purple-diamond-snake-WQHGJU8JLf4CThNjPUm6zH",
    title: "purple diamond snake",
    list_url: "/styles/japanese/purple-diamond-snake"
  },
  {
    url: "/styles/japanese/rose-S4iShvRgjkCL8heExA16sv",
    title: "rose",
    list_url: "/styles/japanese/rose"
  },
  {
    url: "/styles/japanese/samurai-cherry-blossom-tree-2yuYp3rVy1HCrzLQUHb1DB",
    title: "samurai cherry blossom tree",
    list_url: "/styles/japanese/samurai-cherry-blossom-tree"
  },
  {
    url: "/styles/japanese/samurai-jack-NZ3Md5gAH7jQJxwtAEum5D",
    title: "samurai jack",
    list_url: "/styles/japanese/samurai-jack"
  },
  {
    url: "/styles/japanese/samurri-on-knees-with-a-sword-stomach-FUCG74CXeVvcqTZhGxCNyS",
    title: "samurri on knees with a sword stomach",
    list_url: "/styles/japanese/samurri-on-knees-with-a-sword-stomach"
  },
  {
    url: "/styles/japanese/sekiro-death-kanji-6vKWzHTqGrqpiu86Ek9oHc",
    title: "sekiro death kanji",
    list_url: "/styles/japanese/sekiro-death-kanji"
  },
  {
    url: "/styles/japanese/sparrow-Lc55pwju5dpgeM5ZRmLPKk",
    title: "sparrow",
    list_url: "/styles/japanese/sparrow"
  },
  {
    url: "/styles/japanese/wing-chun-kung-fu-ge3GXDvgv8EqHzuTX7EmE",
    title: "wing chun kung fu",
    list_url: "/styles/japanese/wing-chun-kung-fu"
  },
  {
    url: "/styles/japanese/yakuza-girl-with-tattos-P7npRCZXToMWwuyLGAhanZ",
    title: "yakuza girl with tattos",
    list_url: "/styles/japanese/yakuza-girl-with-tattos"
  },
  {
    url: "/styles/minimalist/1400-trippie-redd-themed-RqEzm2HDZ5hbkAfm4SfC8j",
    title: " trippie redd themed",
    list_url: "/styles/minimalist/1400-trippie-redd-themed"
  },
  {
    url: "/styles/minimalist/2008-in-roman-numerals-with-a-5K8xfGymZR8RDV2yRzYvAx",
    title: " in roman numerals with a",
    list_url: "/styles/minimalist/2008-in-roman-numerals-with-a"
  },
  {
    url: "/styles/minimalist/30-seconds-to-mars-logo-BPAmK6hh6c4JMNvzMptcSc",
    title: " seconds to mars logo",
    list_url: "/styles/minimalist/30-seconds-to-mars-logo"
  },
  {
    url: "/styles/minimalist/a-bass-guitar-CbAphWB7zcKa9f2YskxmVh",
    title: "a bass guitar",
    list_url: "/styles/minimalist/a-bass-guitar"
  },
  {
    url: "/styles/minimalist/a-cluster-of-flowers-with-one-daffodil-ETrY28iriHyKhP6cipWANL",
    title: "a cluster of flowers with one daffodil",
    list_url: "/styles/minimalist/a-cluster-of-flowers-with-one-daffodil"
  },
  {
    url: "/styles/minimalist/a-croos-with-the-word-deus-ex-machina-9BE2M4XDmirZ27cTEeRU7w",
    title: "a croos with the word deus ex machina",
    list_url: "/styles/minimalist/a-croos-with-the-word-deus-ex-machina"
  },
  {
    url: "/styles/minimalist/a-fishing-pole-with-the-name-tommy-V91ACuJsppptSKQU4QwBgZ",
    title: "a fishing pole with the name tommy",
    list_url: "/styles/minimalist/a-fishing-pole-with-the-name-tommy"
  },
  {
    url: "/styles/minimalist/a-girl-smoking-a-cigarette-5Y1DGn1DjBj5XDxs1TQXHC",
    title: "a girl smoking a cigarette",
    list_url: "/styles/minimalist/a-girl-smoking-a-cigarette"
  },
  {
    url: "/styles/minimalist/a-hand-with-the-mack-truck-bulldog-KiJbPEGvqQuwjVeadkmrJu",
    title: "a hand with the mack truck bulldog",
    list_url: "/styles/minimalist/a-hand-with-the-mack-truck-bulldog"
  },
  {
    url: "/styles/minimalist/a-minimalist-tattoo-design-of-the-hindu-Hv5v86qZFsU3nqfePL3BFP",
    title: "a minimalist tattoo design of the hindu",
    list_url: "/styles/minimalist/a-minimalist-tattoo-design-of-the-hindu"
  },
  {
    url: "/styles/minimalist/a-minimalist-tattoo-of-hieis-jagan-eye-GYu3dWCGHMiCe9MCFvuCeN",
    title: "a minimalist tattoo of hieis jagan eye",
    list_url: "/styles/minimalist/a-minimalist-tattoo-of-hieis-jagan-eye"
  },
  {
    url: "/styles/minimalist/a-quote-what-happens-on-earth-stays-on-YDvaztvLxLPgVRAbztFsne",
    title: "a quote what happens on earth stays on",
    list_url: "/styles/minimalist/a-quote-what-happens-on-earth-stays-on"
  },
  {
    url: "/styles/minimalist/a-stylized-interpretation-of-the-ifa-4yzyPj2j1b5ToLx3Bq5wjW",
    title: "a stylized interpretation of the ifa",
    list_url: "/styles/minimalist/a-stylized-interpretation-of-the-ifa"
  },
  {
    url: "/styles/minimalist/above-the-knee-floral-with-lily-pad-VRv3h7wGHs68tqqdnL4jn7",
    title: "above the knee floral with lily pad",
    list_url: "/styles/minimalist/above-the-knee-floral-with-lily-pad"
  },
  {
    url: "/styles/minimalist/abstract-motorcycle-ZbSGBiqmjmtdfArkVRmAC",
    title: "abstract motorcycle",
    list_url: "/styles/minimalist/abstract-motorcycle"
  },
  {
    url: "/styles/minimalist/and-the-universe-said-i-love-you-TsUJZRx1ADrYH2XXhC6huz",
    title: "and the universe said i love you",
    list_url: "/styles/minimalist/and-the-universe-said-i-love-you"
  },
  {
    url: "/styles/minimalist/angel-wings-and-initials-j-p-AnwLUJugegBotYzy8BCf7R",
    title: "angel wings and initials j p",
    list_url: "/styles/minimalist/angel-wings-and-initials-j-p"
  },
  {
    url: "/styles/minimalist/aquarius-birth-flower-and-baby-footprints-WyCpDt9Tau95were3VXnRZ",
    title: "aquarius birth flower and baby footprints",
    list_url: "/styles/minimalist/aquarius-birth-flower-and-baby-footprints"
  },
  {
    url: "/styles/minimalist/austin-cursive-writing-3tHDr4QmthcsyGkFjzbkG",
    title: "austin cursive writing",
    list_url: "/styles/minimalist/austin-cursive-writing"
  },
  {
    url: "/styles/minimalist/autism-4p1R441HMxSK8LhcVQ6ppG",
    title: "autism",
    list_url: "/styles/minimalist/autism"
  },
  {
    url: "/styles/minimalist/bart-simpson-C7xSpJV5t1syGaXj4X9tHK",
    title: "bart simpson",
    list_url: "/styles/minimalist/bart-simpson"
  },
  {
    url: "/styles/minimalist/batman-73YReano86w3hx6q6fnY79",
    title: "batman",
    list_url: "/styles/minimalist/batman"
  },
  {
    url: "/styles/minimalist/be-lilith-never-eve-2VuYBjv9vDebW1Qxh9kXpw",
    title: "be lilith never eve",
    list_url: "/styles/minimalist/be-lilith-never-eve"
  },
  {
    url: "/styles/minimalist/bini-PXhCRaCLPgWBJQ4JyK9yq",
    title: "bini",
    list_url: "/styles/minimalist/bini"
  },
  {
    url: "/styles/minimalist/birth-month-flowers-for-january-FZ7b1wTa3dXQ3Sqje8zD4w",
    title: "birth month flowers for january",
    list_url: "/styles/minimalist/birth-month-flowers-for-january"
  },
  {
    url: "/styles/minimalist/brother-bear-eagle-wolf-bear-totem-6b3iE9FnuPkJLPbDkVMTb6",
    title: "brother bear eagle wolf bear totem",
    list_url: "/styles/minimalist/brother-bear-eagle-wolf-bear-totem"
  },
  {
    url: "/styles/minimalist/butterfly-with-name-pavi-JpuzGRshxWZritmY79cSSm",
    title: "butterfly with name pavi",
    list_url: "/styles/minimalist/butterfly-with-name-pavi"
  },
  {
    url: "/styles/minimalist/calisthenics-8FwpXbRJ6KGQ83YCJtGAcN",
    title: "calisthenics",
    list_url: "/styles/minimalist/calisthenics"
  },
  {
    url: "/styles/minimalist/cherokee-rose-flower-TADPCDQ5vJ4Z4NRXWszBCP",
    title: "cherokee rose flower",
    list_url: "/styles/minimalist/cherokee-rose-flower"
  },
  {
    url: "/styles/minimalist/chicano-style-name-samira-7Xvg4xiP8PexVicnq6Xo3g",
    title: "chicano style name samira",
    list_url: "/styles/minimalist/chicano-style-name-samira"
  },
  {
    url: "/styles/minimalist/chris-brown-1111-deluxe-HGDX7SEicyyotTSYtGYY8d",
    title: "chris brown deluxe",
    list_url: "/styles/minimalist/chris-brown-1111-deluxe"
  },
  {
    url: "/styles/minimalist/cigarette-butt-5ARm8Zgs1VbZS4Sx45e9QP",
    title: "cigarette butt",
    list_url: "/styles/minimalist/cigarette-butt"
  },
  {
    url: "/styles/minimalist/comic-silver-surfer-RHEQP5VPm1ZTRUVeS6Hvkv",
    title: "comic silver surfer",
    list_url: "/styles/minimalist/comic-silver-surfer"
  },
  {
    url: "/styles/minimalist/couple-tattoo-design-morse-code-letter-PEZo52yRWCekVCH6jr3yEN",
    title: "couple tattoo design morse code letter",
    list_url: "/styles/minimalist/couple-tattoo-design-morse-code-letter"
  },
  {
    url: "/styles/minimalist/cross-with-flowers-and-the-number-224-9BYr7kfjrSAoj7eTMMiuRb",
    title: "cross with flowers and the number ",
    list_url: "/styles/minimalist/cross-with-flowers-and-the-number-224"
  },
  {
    url: "/styles/minimalist/cute-chicken-nuggets-RgRLjMXU21BRjq2aSMduEE",
    title: "cute chicken nuggets",
    list_url: "/styles/minimalist/cute-chicken-nuggets"
  },
  {
    url: "/styles/minimalist/daffodil-rose-chrysanthemum-2vekavzBaRa9VubBzEXura",
    title: "daffodil rose chrysanthemum",
    list_url: "/styles/minimalist/daffodil-rose-chrysanthemum"
  },
  {
    url: "/styles/minimalist/family-tree-including-the-names-jason-CCM4ucQuyLHMGgWRLWPCMY",
    title: "family tree including the names jason",
    list_url: "/styles/minimalist/family-tree-including-the-names-jason"
  },
  {
    url: "/styles/minimalist/fight-club-6a2ivncTpJ6TM4PhYWATCG",
    title: "fight club",
    list_url: "/styles/minimalist/fight-club"
  },
  {
    url: "/styles/minimalist/gcliff-parallel-lines-HNLEPKv8B7k2byXst6v1qq",
    title: "gcliff parallel lines",
    list_url: "/styles/minimalist/gcliff-parallel-lines"
  },
  {
    url: "/styles/minimalist/grace-in-cursive-writing-JY14eWBYLKZwL8WgCXBpkZ",
    title: "grace in cursive writing",
    list_url: "/styles/minimalist/grace-in-cursive-writing"
  },
  {
    url: "/styles/minimalist/hazel-branch-wrapping-around-the-arm-GRev7ktALVw2DYgyDKJWe5",
    title: "hazel branch wrapping around the arm",
    list_url: "/styles/minimalist/hazel-branch-wrapping-around-the-arm"
  },
  {
    url: "/styles/minimalist/heart-with-forget-me-not-flower-and-paw-WAZ86SVUfZqSwq3rMzvcVn",
    title: "heart with forget me not flower and paw",
    list_url: "/styles/minimalist/heart-with-forget-me-not-flower-and-paw"
  },
  {
    url: "/styles/minimalist/heart-with-letters-hvj-a-hv-NqvsBJz2wYhrM4EMySbMkD",
    title: "heart with letters hvj a hv",
    list_url: "/styles/minimalist/heart-with-letters-hvj-a-hv"
  },
  {
    url: "/styles/minimalist/lust-2bcbP77sb6jVLM37fXvsPg",
    title: "lust",
    list_url: "/styles/minimalist/lust"
  },
  {
    url: "/styles/minimalist/moon-and-hindi-name-manju-3bbAuPYrdahtbKZS4zfwUM",
    title: "moon and hindi name manju",
    list_url: "/styles/minimalist/moon-and-hindi-name-manju"
  },
  {
    url: "/styles/minimalist/muzan-demon-slayer-sword-symbolic-spine-XjbmwzCcXmRG9eRi7ZcknM",
    title: "muzan demon slayer sword symbolic spine",
    list_url: "/styles/minimalist/muzan-demon-slayer-sword-symbolic-spine"
  },
  {
    url: "/styles/minimalist/odysseus-bow-and-arrow-EMiSsXTJopDi5MLRBy9E3E",
    title: "odysseus bow and arrow",
    list_url: "/styles/minimalist/odysseus-bow-and-arrow"
  },
  {
    url: "/styles/minimalist/pokemon-HCqQvrofkpcsWkvpwmJbSr",
    title: "pokemon",
    list_url: "/styles/minimalist/pokemon"
  },
  {
    url: "/styles/minimalist/porch-swing-PhFMjbhRiwaYSvrUWJ8V6C",
    title: "porch swing",
    list_url: "/styles/minimalist/porch-swing"
  },
  {
    url: "/styles/minimalist/star-wars-rebel-alliance-KVWLyvPeQ8hEhBBtJwCSnZ",
    title: "star wars rebel alliance",
    list_url: "/styles/minimalist/star-wars-rebel-alliance"
  },
  {
    url: "/styles/minimalist/the-words-pretty-little-poison-in-4TTswnvHfEaxVchbgRLykW",
    title: "the words pretty little poison in",
    list_url: "/styles/minimalist/the-words-pretty-little-poison-in"
  },
  {
    url: "/styles/minimalist/veena-instrument-5M16WxtrFW1gaiksd7usB8",
    title: "veena instrument",
    list_url: "/styles/minimalist/veena-instrument"
  },
  {
    url: "/styles/minimalist/weezer-2ssBeXuRrJMnGLhcPbgznG",
    title: "weezer",
    list_url: "/styles/minimalist/weezer"
  },
  {
    url: "/styles/minimalist/western-cowboy-skull-smoking-2pRyHFcNT4dQzx9KQj6K5R",
    title: "western cowboy skull smoking",
    list_url: "/styles/minimalist/western-cowboy-skull-smoking"
  },
  {
    url: "/styles/minimalist/yin-yang-with-semicolon-HBA5CCz3UXXMhPT7kZQtB5",
    title: "yin yang with semicolon",
    list_url: "/styles/minimalist/yin-yang-with-semicolon"
  },
  {
    url: "/styles/minimalist/zion-name-7iDfr5cPGyoY9AKDvaiSeg",
    title: "zion name",
    list_url: "/styles/minimalist/zion-name"
  },
  {
    url: "/styles/neotraditional/2-black-and-white-roses-on-the-shoulder-8Qk57jKFQkUMPvD7pDpPdj",
    title: " black and white roses on the shoulder",
    list_url: "/styles/neotraditional/2-black-and-white-roses-on-the-shoulder"
  },
  {
    url: "/styles/neotraditional/a-butterfly-with-sun-Q7VXHPcwg882LGx3PR45g4",
    title: "a butterfly with sun",
    list_url: "/styles/neotraditional/a-butterfly-with-sun"
  },
  {
    url: "/styles/neotraditional/amrita-CnwyxoBCFRWfSYu4he329y",
    title: "amrita",
    list_url: "/styles/neotraditional/amrita"
  },
  {
    url: "/styles/neotraditional/bindu-anand-HUaDDH5TREmXfNjx56M6zk",
    title: "bindu anand",
    list_url: "/styles/neotraditional/bindu-anand"
  },
  {
    url: "/styles/neotraditional/black-female-warrior-face-with-afro-HE2ksrZnVCWmTHJKTV2Viv",
    title: "black female warrior face with afro",
    list_url: "/styles/neotraditional/black-female-warrior-face-with-afro"
  },
  {
    url: "/styles/neotraditional/burning-money-with-brick-wall-being-torn-PYW8r1Lk21WaLPCRpaVNam",
    title: "burning money with brick wall being torn",
    list_url: "/styles/neotraditional/burning-money-with-brick-wall-being-torn"
  },
  {
    url: "/styles/neotraditional/christ-is-my-firm-foundation-the-rock-JTu76mvgUVQXXeNAxYet2n",
    title: "christ is my firm foundation the rock",
    list_url: "/styles/neotraditional/christ-is-my-firm-foundation-the-rock"
  },
  {
    url: "/styles/neotraditional/cole-palmer-UDUdsEhRvuf6d3LQMYk2uu",
    title: "cole palmer",
    list_url: "/styles/neotraditional/cole-palmer"
  },
  {
    url: "/styles/neotraditional/crow-cant-rain-all-the-time-SVgSyHBszxdhe8fKdqJFRL",
    title: "crow cant rain all the time",
    list_url: "/styles/neotraditional/crow-cant-rain-all-the-time"
  },
  {
    url: "/styles/neotraditional/donald-duck-smoking-a-cigar-and-below-Nig8njDDrSAL5dW2MY4XKd",
    title: "donald duck smoking a cigar and below",
    list_url: "/styles/neotraditional/donald-duck-smoking-a-cigar-and-below"
  },
  {
    url: "/styles/neotraditional/doom-beast-mark-on-the-shoulder-run-ZdarcWp6TbuCco8KJpd4C",
    title: "doom beast mark on the shoulder run",
    list_url: "/styles/neotraditional/doom-beast-mark-on-the-shoulder-run"
  },
  {
    url: "/styles/neotraditional/evelyn-name-PAHGhY9LcqHgPV24aawRrh",
    title: "evelyn name",
    list_url: "/styles/neotraditional/evelyn-name"
  },
  {
    url: "/styles/neotraditional/eye-of-cthulhu-terraria-NpH45NbYB1n2WroZcYvyC1",
    title: "eye of cthulhu terraria",
    list_url: "/styles/neotraditional/eye-of-cthulhu-terraria"
  },
  {
    url: "/styles/neotraditional/fiddlehead-fern-Rq2X3vEjYSpSFZyhASCENT",
    title: "fiddlehead fern",
    list_url: "/styles/neotraditional/fiddlehead-fern"
  },
  {
    url: "/styles/neotraditional/gay-cowboy-on-horse-5QFVR5f1Wyfb4Fmg5W52az",
    title: "gay cowboy on horse",
    list_url: "/styles/neotraditional/gay-cowboy-on-horse"
  },
  {
    url: "/styles/neotraditional/general-grievous-GYAaoAHDxFZdzv4q165Ddd",
    title: "general grievous",
    list_url: "/styles/neotraditional/general-grievous"
  },
  {
    url: "/styles/neotraditional/infinity-symbol-ring-finger-tattoo-G9M3r7Ka6mZvTfGx7VGtuP",
    title: "infinity symbol ring finger tattoo",
    list_url: "/styles/neotraditional/infinity-symbol-ring-finger-tattoo"
  },
  {
    url: "/styles/neotraditional/jesus-holding-gun-side-ways-at-you-TNutree3zuukaWnrCnpXKB",
    title: "jesus holding gun side ways at you",
    list_url: "/styles/neotraditional/jesus-holding-gun-side-ways-at-you"
  },
  {
    url: "/styles/neotraditional/katekyo-hitman-reborn-mafia-boss-U4FgntFw2aG9h7Ed5FsHAS",
    title: "katekyo hitman reborn mafia boss",
    list_url: "/styles/neotraditional/katekyo-hitman-reborn-mafia-boss"
  },
  {
    url: "/styles/neotraditional/ktm-LPiDiPodU2ns8rixrtvduQ",
    title: "ktm",
    list_url: "/styles/neotraditional/ktm"
  },
  {
    url: "/styles/neotraditional/lamborghini-logo-with-cars-around-it-9WtJLkEhWzBxCzmbfNPygu",
    title: "lamborghini logo with cars around it",
    list_url: "/styles/neotraditional/lamborghini-logo-with-cars-around-it"
  },
  {
    url: "/styles/neotraditional/lily-of-the-valley-tramp-stamp-Hkjon4gtSbJUssf5XYgzkG",
    title: "lily of the valley tramp stamp",
    list_url: "/styles/neotraditional/lily-of-the-valley-tramp-stamp"
  },
  {
    url: "/styles/neotraditional/lion-roman-soldier-A571Yfj2KshF18NewyXJPu",
    title: "lion roman soldier",
    list_url: "/styles/neotraditional/lion-roman-soldier"
  },
  {
    url: "/styles/neotraditional/lotus-76S1i388vM1DQcDWLgUwpu",
    title: "lotus",
    list_url: "/styles/neotraditional/lotus"
  },
  {
    url: "/styles/neotraditional/meaning-of-the-name-laila-HSRps1MSi8YTPJcGCxh9dC",
    title: "meaning of the name laila",
    list_url: "/styles/neotraditional/meaning-of-the-name-laila"
  },
  {
    url: "/styles/neotraditional/name-kevin-P45QD9K8eB7QQDugVgDZwy",
    title: "name kevin",
    list_url: "/styles/neotraditional/name-kevin"
  },
  {
    url: "/styles/neotraditional/name-tattoo-adam-8TKFLdZqg1sAazvA7UPBHP",
    title: "name tattoo adam",
    list_url: "/styles/neotraditional/name-tattoo-adam"
  },
  {
    url: "/styles/neotraditional/name-tattoo-sushma-and-vinod-WNXmAcM6zASwqNcYxPYw4u",
    title: "name tattoo sushma and vinod",
    list_url: "/styles/neotraditional/name-tattoo-sushma-and-vinod"
  },
  {
    url: "/styles/neotraditional/name-tattoo-violet-flower-Kcvpa5GHaAYwqD4TRWdLEe",
    title: "name tattoo violet flower",
    list_url: "/styles/neotraditional/name-tattoo-violet-flower"
  },
  {
    url: "/styles/neotraditional/no-gods-or-kings-only-man-BxcM8Qtaidig4mkcSyEJao",
    title: "no gods or kings only man",
    list_url: "/styles/neotraditional/no-gods-or-kings-only-man"
  },
  {
    url: "/styles/neotraditional/purple-heart-JHJR7Ad5vwfSTSPxpHwHjm",
    title: "purple heart",
    list_url: "/styles/neotraditional/purple-heart"
  },
  {
    url: "/styles/neotraditional/royal-marines-commando-dagger-and-5owS6YPbSz4Wt9FAPGsfDd",
    title: "royal marines commando dagger and",
    list_url: "/styles/neotraditional/royal-marines-commando-dagger-and"
  },
  {
    url: "/styles/neotraditional/royalty-loyalty-in-my-dna-a7Bs3HerMXxJ4xf7k9rWL",
    title: "royalty loyalty in my dna",
    list_url: "/styles/neotraditional/royalty-loyalty-in-my-dna"
  },
  {
    url: "/styles/neotraditional/sahlo-folina-Sv86t2ME3DQV8Kgp6GbWbH",
    title: "sahlo folina",
    list_url: "/styles/neotraditional/sahlo-folina"
  },
  {
    url: "/styles/neotraditional/santosh-name-DEX8DuTngpwyavpmN114XB",
    title: "santosh name",
    list_url: "/styles/neotraditional/santosh-name"
  },
  {
    url: "/styles/neotraditional/scarlxrd-6iWBS2YLS46a3hAK9eB597",
    title: "scarlxrd",
    list_url: "/styles/neotraditional/scarlxrd"
  },
  {
    url: "/styles/neotraditional/spine-tattoo-with-the-name-andrew-5d65CqrXNuxhkff4zpNYZA",
    title: "spine tattoo with the name andrew",
    list_url: "/styles/neotraditional/spine-tattoo-with-the-name-andrew"
  },
  {
    url: "/styles/neotraditional/three-eyed-raven-4KDS7Dfca7pSYGuvauk1UE",
    title: "three eyed raven",
    list_url: "/styles/neotraditional/three-eyed-raven"
  },
  {
    url: "/styles/neotraditional/tst-7-Pcv8thGdQTzHipywi3Xq2y",
    title: "tst ",
    list_url: "/styles/neotraditional/tst-7"
  },
  {
    url: "/styles/neotraditional/unconditional-love-symbol-6G6MD8SZF7TfJkekrAxELo",
    title: "unconditional love symbol",
    list_url: "/styles/neotraditional/unconditional-love-symbol"
  },
  {
    url: "/styles/neotraditional/viking-ragnar-with-rose-DSwz5JxoA6pHL8Xbkm9JSP",
    title: "viking ragnar with rose",
    list_url: "/styles/neotraditional/viking-ragnar-with-rose"
  },
  {
    url: "/styles/neotraditional/war-pig-Ex7xfthDHFcDjQjitc71uV",
    title: "war pig",
    list_url: "/styles/neotraditional/war-pig"
  },
  {
    url: "/styles/realism/a-gandaberunda-mythical-double-headed-KR8ZN84UmWGsXnx3MsbiCJ",
    title: "a gandaberunda mythical double headed",
    list_url: "/styles/realism/a-gandaberunda-mythical-double-headed"
  },
  {
    url: "/styles/realism/chucky-and-chuckie-me-vs-me-5MmeZ6aPW5MeLYx47RS1PS",
    title: "chucky and chuckie me vs me",
    list_url: "/styles/realism/chucky-and-chuckie-me-vs-me"
  },
  {
    url: "/styles/realism/eve-reaching-for-the-apple-in-the-K5PxcyqMtR34SaZLHGjJCP",
    title: "eve reaching for the apple in the",
    list_url: "/styles/realism/eve-reaching-for-the-apple-in-the"
  },
  {
    url: "/styles/realism/femboy-bottom-RT7ecc9k5zVHDpz1ux2Sot",
    title: "femboy bottom",
    list_url: "/styles/realism/femboy-bottom"
  },
  {
    url: "/styles/realism/honda-civic-HWznLt2FRAhUxuxXnEejTC",
    title: "honda civic",
    list_url: "/styles/realism/honda-civic"
  },
  {
    url: "/styles/realism/knull-marvel-void-RuR7gao1ndMysZWdip1YWz",
    title: "knull marvel void",
    list_url: "/styles/realism/knull-marvel-void"
  },
  {
    url: "/styles/realism/lightning-tattoo-on-shoulder-and-chest-FgdMftiGpEhETfELFHi6Sk",
    title: "lightning tattoo on shoulder and chest",
    list_url: "/styles/realism/lightning-tattoo-on-shoulder-and-chest"
  },
  {
    url: "/styles/realism/lion-with-yellow-and-red-eyes-with-1905-F8vBoQ8BPkZ7WYT38ZrwRV",
    title: "lion with yellow and red eyes with ",
    list_url: "/styles/realism/lion-with-yellow-and-red-eyes-with-1905"
  },
  {
    url: "/styles/realism/pirates-of-the-caribbean-compass-and-PXEVNpT1uHoFp1udT9VK2T",
    title: "pirates of the caribbean compass and",
    list_url: "/styles/realism/pirates-of-the-caribbean-compass-and"
  },
  {
    url: "/styles/realism/pisces-aquarius-ying-yang-CZvh5dgXw8A3fSBy13yPKM",
    title: "pisces aquarius ying yang",
    list_url: "/styles/realism/pisces-aquarius-ying-yang"
  },
  {
    url: "/styles/realism/ritu-5ZxyWKAUkYqAUVzy1i9LeH",
    title: "ritu",
    list_url: "/styles/realism/ritu"
  },
  {
    url: "/styles/realism/rocket-league-octane-VNHxXTY3hkLwiKbxVY3pS9",
    title: "rocket league octane",
    list_url: "/styles/realism/rocket-league-octane"
  },
  {
    url: "/styles/realism/sayed-hassan-portrait-tattoo-5krjVcYaQcid8ZnXjw9Dzs",
    title: "sayed hassan portrait tattoo",
    list_url: "/styles/realism/sayed-hassan-portrait-tattoo"
  },
  {
    url: "/styles/realism/sydney-roosters-LwG8vv35kufeF8TVKiYENR",
    title: "sydney roosters",
    list_url: "/styles/realism/sydney-roosters"
  },
  {
    url: "/styles/realism/the-angel-gabriel-blowing-a-trumpet-6Lvsb9THTy18dmWWidtVpx",
    title: "the angel gabriel blowing a trumpet",
    list_url: "/styles/realism/the-angel-gabriel-blowing-a-trumpet"
  },
  {
    url: "/styles/realism/the-words-tempus-edax-rerum-7CB8wVKpgJvxbgjYKsUB9U",
    title: "the words tempus edax rerum",
    list_url: "/styles/realism/the-words-tempus-edax-rerum"
  },
  {
    url: "/styles/realism/wolf-and-snake-7Ysupk9wgcLNzs7hJNVaCA",
    title: "wolf and snake",
    list_url: "/styles/realism/wolf-and-snake"
  },
  {
    url: "/styles/sketch/diamon-on-a-landmine-Qav2J2AQGHVaWWJ8rnGvZx",
    title: "diamon on a landmine",
    list_url: "/styles/sketch/diamon-on-a-landmine"
  },
  {
    url: "/styles/sketch/hazel-in-cursive-writing-5WsyAzeTrhFZ1P1mVkTy1j",
    title: "hazel in cursive writing",
    list_url: "/styles/sketch/hazel-in-cursive-writing"
  },
  {
    url: "/styles/sketch/heart-scroll-across-name-kaylee-6oiQUaJRAppfTA1eNaa7fB",
    title: "heart scroll across name kaylee",
    list_url: "/styles/sketch/heart-scroll-across-name-kaylee"
  },
  {
    url: "/styles/sketch/lurcher-F8ZbQmEZF11uRhTuqsaFS3",
    title: "lurcher",
    list_url: "/styles/sketch/lurcher"
  },
  {
    url: "/styles/sketch/manta-ray-and-whale-shark-ocean-Pseiu1SXGb5gyQufAQmETn",
    title: "manta ray and whale shark ocean",
    list_url: "/styles/sketch/manta-ray-and-whale-shark-ocean"
  },
  {
    url: "/styles/sketch/prabha-name-with-butterfly-resting-UrNMkGhAuLf2tqbWnwqCgN",
    title: "prabha name with butterfly resting",
    list_url: "/styles/sketch/prabha-name-with-butterfly-resting"
  },
  {
    url: "/styles/sketch/skeleton-hanging-from-noose-A8XfigsWCvYLUgVXqP7Vrh",
    title: "skeleton hanging from noose",
    list_url: "/styles/sketch/skeleton-hanging-from-noose"
  },
  {
    url: "/styles/sketch/sword-through-eye-Ltd6Bj194KyiQAcxEXWk2",
    title: "sword through eye",
    list_url: "/styles/sketch/sword-through-eye"
  },
  {
    url: "/styles/stencil/family-of-browning-deer-heads-on-torso-84c1coTfd3epSwEYRhE8SE",
    title: "family of browning deer heads on torso",
    list_url: "/styles/stencil/family-of-browning-deer-heads-on-torso"
  },
  {
    url: "/styles/stencil/get-rich-or-die-trying-M8AzYsKj17dFqxzTMTdsAJ",
    title: "get rich or die trying",
    list_url: "/styles/stencil/get-rich-or-die-trying"
  },
  {
    url: "/styles/stencil/hebrew-text-jeremiah-333-Y61z46RUtSQVTDbJDwZgSM",
    title: "hebrew text jeremiah ",
    list_url: "/styles/stencil/hebrew-text-jeremiah-333"
  },
  {
    url: "/styles/stencil/lightning-mcqueen-S2H9wSmReQW2x474nQBcEq",
    title: "lightning mcqueen",
    list_url: "/styles/stencil/lightning-mcqueen"
  },
  {
    url: "/styles/stencil/manic-gaara-from-naruto-saying-blood-CUSwZugyEpmUGyN3uNAJV",
    title: "manic gaara from naruto saying blood",
    list_url: "/styles/stencil/manic-gaara-from-naruto-saying-blood"
  },
  {
    url: "/styles/stencil/money-over-everything-3nFkqkv17DhPZgsG5ntWFS",
    title: "money over everything",
    list_url: "/styles/stencil/money-over-everything"
  },
  {
    url: "/styles/stencil/sagittarius-and-virgo-LsHEGX2JFc4i6gWjvniTWe",
    title: "sagittarius and virgo",
    list_url: "/styles/stencil/sagittarius-and-virgo"
  },
  {
    url: "/styles/surrealism/name-of-kayla-Aduwo7HARNHtpyiBJnDDbS",
    title: "name of kayla",
    list_url: "/styles/surrealism/name-of-kayla"
  },
  {
    url: "/styles/traditional/7-of-spades-2-of-diamonds-poker-card-6GwrD6z9Ng1t8Hjyb3knU6",
    title: " of spades of diamonds poker card",
    list_url: "/styles/traditional/7-of-spades-2-of-diamonds-poker-card"
  },
  {
    url: "/styles/traditional/alligator-Hi8rWKCzjky1R3ZQLzDeGe",
    title: "alligator",
    list_url: "/styles/traditional/alligator"
  },
  {
    url: "/styles/traditional/bucking-bull-with-legs-in-the-air-MUrb3VWpjAjKvTk5cusLMj",
    title: "bucking bull with legs in the air",
    list_url: "/styles/traditional/bucking-bull-with-legs-in-the-air"
  },
  {
    url: "/styles/traditional/chubby-pinup-girl-9FdZj8XvLiuuk7ktjxxKAi",
    title: "chubby pinup girl",
    list_url: "/styles/traditional/chubby-pinup-girl"
  },
  {
    url: "/styles/traditional/emerald-6hDQgWw8bka674doN2hisv",
    title: "emerald",
    list_url: "/styles/traditional/emerald"
  },
  {
    url: "/styles/traditional/i-was-his-angel-now-hes-mine-Q454YJ8KuxhJyHQ1szCvqW",
    title: "i was his angel now hes mine",
    list_url: "/styles/traditional/i-was-his-angel-now-hes-mine"
  },
  {
    url: "/styles/traditional/king-neptune-and-poseidon-with-a-turtle-MwFQ34vh6XisoqTmuzG3nt",
    title: "king neptune and poseidon with a turtle",
    list_url: "/styles/traditional/king-neptune-and-poseidon-with-a-turtle"
  },
];
